webpackJsonp([3,1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var jQuery = __webpack_require__(1),
	    $ = jQuery,
	    GalaxyApp = __webpack_require__(52).GalaxyApp,
	    Router = __webpack_require__(55),
	    ToolPanel = __webpack_require__(104),
	    HistoryPanel = __webpack_require__(103),
	    Page = __webpack_require__(53),
	    ToolForm = __webpack_require__(47),
	    FormWrapper = __webpack_require__(62),
	    UserPreferences = __webpack_require__(145),
	    CustomBuilds = __webpack_require__(144),
	    Tours = __webpack_require__(93),
	    GridView = __webpack_require__(12),
	    GridShared = __webpack_require__(128),
	    Workflows = __webpack_require__(149),
	    HistoryList = __webpack_require__(131),
	    ToolFormComposite = __webpack_require__(92),
	    Utils = __webpack_require__(4),
	    Ui = __webpack_require__(5),
	    DatasetError = __webpack_require__(127),
	    DatasetEditAttributes = __webpack_require__(126);
	
	/** define the 'Analyze Data'/analysis/main/home page for Galaxy
	 *  * has a masthead
	 *  * a left tool menu to allow the user to load tools in the center panel
	 *  * a right history menu that shows the user's current data
	 *  * a center panel
	 *  Both panels (generally) persist while the center panel shows any
	 *  UI needed for the current step of an analysis, like:
	 *      * tool forms to set tool parameters,
	 *      * tables showing the contents of datasets
	 *      * etc.
	 */
	window.app = function app(options, bootstrapped) {
	    window.Galaxy = new GalaxyApp(options, bootstrapped);
	    Galaxy.debug('analysis app');
	
	    /** Routes */
	    var AnalysisRouter = Router.extend({
	        routes: {
	            '(/)': 'home',
	            '(/)root*': 'home',
	            '(/)tours(/)(:tour_id)': 'show_tours',
	            '(/)user(/)': 'show_user',
	            '(/)user(/)(:form_id)': 'show_user_form',
	            '(/)workflow(/)': 'show_workflows',
	            '(/)workflow/run(/)': 'show_run',
	            '(/)pages(/)(:action_id)': 'show_pages',
	            '(/)visualizations/(:action_id)': 'show_visualizations',
	            '(/)workflows/list_published(/)': 'show_workflows_published',
	            '(/)histories(/)(:action_id)': 'show_histories',
	            '(/)datasets(/)list(/)': 'show_datasets',
	            '(/)workflow/import_workflow': 'show_import_workflow',
	            '(/)custom_builds': 'show_custom_builds',
	            '(/)datasets/edit': 'show_dataset_edit_attributes',
	            '(/)datasets/error': 'show_dataset_error',
	            '(/)!mode=:mode': 'home'
	        },
	
	        require_login: ['show_user', 'show_user_form', 'show_workflows'],
	
	        authenticate: function (args, name) {
	            return Galaxy.user && Galaxy.user.id || this.require_login.indexOf(name) == -1;
	        },
	
	        show_tours: function (tour_id) {
	            if (tour_id) {
	                Tours.giveTour(tour_id);
	            } else {
	                this.page.display(new Tours.ToursView());
	            }
	        },
	
	        show_user: function () {
	            this.page.display(new UserPreferences.View());
	        },
	
	        show_user_form: function (form_id) {
	            var model = new UserPreferences.Model({ user_id: Galaxy.params.id });
	            this.page.display(new FormWrapper.View(model.get(form_id)));
	        },
	
	        show_visualizations: function (action_id) {
	            this.page.display(new GridShared.View({ action_id: action_id, plural: 'Visualizations', item: 'visualization' }));
	        },
	
	        show_workflows_published: function () {
	            this.page.display(new GridView({ url_base: Galaxy.root + 'workflow/list_published', dict_format: true }));
	        },
	
	        show_histories: function (action_id) {
	            this.page.display(new HistoryList.View({ action_id: action_id }));
	        },
	
	        show_datasets: function () {
	            this.page.display(new GridView({ url_base: Galaxy.root + 'dataset/list', dict_format: true }));
	        },
	
	        show_pages: function (action_id) {
	            this.page.display(new GridShared.View({ action_id: action_id, plural: 'Pages', item: 'page' }));
	        },
	
	        show_workflows: function () {
	            this.page.display(new Workflows.View());
	        },
	
	        show_run: function () {
	            this._loadWorkflow();
	        },
	
	        show_import_workflow: function () {
	            this.page.display(new Workflows.ImportWorkflowView());
	        },
	
	        show_custom_builds: function () {
	            var self = this;
	            var historyPanel = this.page.historyPanel.historyView;
	            if (!historyPanel || !historyPanel.model || !historyPanel.model.id) {
	                window.setTimeout(function () {
	                    self.show_custom_builds();
	                }, 500);
	                return;
	            }
	            this.page.display(new CustomBuilds.View());
	        },
	
	        show_dataset_edit_attributes: function () {
	            this.page.display(new DatasetEditAttributes.View());
	        },
	
	        show_dataset_error: function () {
	            this.page.display(new DatasetError.View());
	        },
	
	        /**  */
	        home: function (params) {
	            // TODO: to router, remove Globals
	            // load a tool by id (tool_id) or rerun a previous tool execution (job_id)
	            if (params.tool_id || params.job_id) {
	                if (params.tool_id === 'upload1') {
	                    this.page.toolPanel.upload.show();
	                    this._loadCenterIframe('welcome');
	                } else {
	                    this._loadToolForm(params);
	                }
	            } else {
	                // show the workflow run form
	                if (params.workflow_id) {
	                    this._loadWorkflow();
	                    // load the center iframe with controller.action: galaxy.org/?m_c=history&m_a=list -> history/list
	                } else if (params.m_c) {
	                    this._loadCenterIframe(params.m_c + '/' + params.m_a);
	                    // show the workflow run form
	                } else {
	                    this._loadCenterIframe('welcome');
	                }
	            }
	        },
	
	        /** load the center panel with a tool form described by the given params obj */
	        _loadToolForm: function (params) {
	            //TODO: load tool form code async
	            params.id = decodeURIComponent(params.tool_id);
	            this.page.display(new ToolForm.View(params));
	        },
	
	        /** load the center panel iframe using the given url */
	        _loadCenterIframe: function (url, root) {
	            root = root || Galaxy.root;
	            url = root + url;
	            if (this.page.$('#galaxy_main').attr('src') !== url) this.page.$('#galaxy_main').prop('src', url);
	        },
	
	        /** load workflow by its url in run mode */
	        _loadWorkflow: function () {
	            var self = this;
	            Utils.get({
	                url: Galaxy.root + 'api/workflows/' + Utils.getQueryString('id') + '/download?style=run',
	                success: function (response) {
	                    self.page.display(new ToolFormComposite.View(response));
	                },
	                error: function (response) {
	                    var error_msg = response.err_msg || 'Error occurred while loading the resource.';
	                    var options = { 'message': error_msg, 'status': 'danger', 'persistent': true };
	                    self.page.display(new Ui.Message(options));
	                }
	            });
	        }
	    });
	
	    // render and start the router
	    $(function () {
	        Galaxy.page = new Page.View(_.extend(options, {
	            Left: ToolPanel,
	            Right: HistoryPanel,
	            Router: AnalysisRouter
	        }));
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/**
	 *  This class contains backbone wrappers for basic ui elements such as Images, Labels, Buttons, Input fields etc.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(15), __webpack_require__(42), __webpack_require__(14), __webpack_require__(37), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Select, Slider, Options, Drilldown, Buttons, Modal) {
	
	    /** Label wrapper */
	    var Label = Backbone.View.extend({
	        tagName: 'label',
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model(options);
	            this.tagName = options.tagName || this.tagName;
	            this.setElement($('<' + this.tagName + '/>'));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	        title: function (new_title) {
	            this.model.set('title', new_title);
	        },
	        value: function () {
	            return this.model.get('title');
	        },
	        render: function () {
	            this.$el.removeClass().addClass('ui-label').addClass(this.model.get('cls')).html(this.model.get('title'));
	            return this;
	        }
	    });
	
	    /** Displays messages used e.g. in the tool form */
	    var Message = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                message: null,
	                status: 'info',
	                cls: '',
	                persistent: false,
	                fade: true
	            }).set(options);
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	        update: function (options) {
	            this.model.set(options);
	        },
	        render: function () {
	            this.$el.removeClass().addClass('ui-message').addClass(this.model.get('cls'));
	            var status = this.model.get('status');
	            if (this.model.get('large')) {
	                this.$el.addClass((status == 'success' && 'done' || status == 'danger' && 'error' || status) + 'messagelarge');
	            } else {
	                this.$el.addClass('alert').addClass('alert-' + status);
	            }
	            if (this.model.get('message')) {
	                this.$el.html(this.messageForDisplay());
	                this.$el[this.model.get('fade') ? 'fadeIn' : 'show']();
	                this.timeout && window.clearTimeout(this.timeout);
	                if (!this.model.get('persistent')) {
	                    var self = this;
	                    this.timeout = window.setTimeout(function () {
	                        self.model.set('message', '');
	                    }, 3000);
	                }
	            } else {
	                this.$el.fadeOut();
	            }
	            return this;
	        },
	        messageForDisplay: function () {
	            return _.escape(this.model.get('message'));
	        }
	    });
	
	    var UnescapedMessage = Message.extend({
	        messageForDisplay: function () {
	            return this.model.get('message');
	        }
	    });
	
	    /** Renders an input element used e.g. in the tool form */
	    var Input = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                type: 'text',
	                placeholder: '',
	                disabled: false,
	                readonly: false,
	                visible: true,
	                cls: '',
	                area: false,
	                color: null,
	                style: null
	            }).set(options);
	            this.tagName = this.model.get('area') ? 'textarea' : 'input';
	            this.setElement($('<' + this.tagName + '/>'));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	        events: {
	            'input': '_onchange'
	        },
	        value: function (new_val) {
	            new_val !== undefined && this.model.set('value', typeof new_val === 'string' ? new_val : '');
	            return this.model.get('value');
	        },
	        render: function () {
	            var self = this;
	            this.$el.removeClass().addClass('ui-' + this.tagName).addClass(this.model.get('cls')).addClass(this.model.get('style')).attr('id', this.model.id).attr('type', this.model.get('type')).attr('placeholder', this.model.get('placeholder')).css('color', this.model.get('color') || '').css('border-color', this.model.get('color') || '');
	            var datalist = this.model.get('datalist');
	            if ($.isArray(datalist) && datalist.length > 0) {
	                this.$el.autocomplete({ source: function (request, response) {
	                        response(self.model.get('datalist'));
	                    },
	                    change: function () {
	                        self._onchange();
	                    } });
	            }
	            if (this.model.get('value') !== this.$el.val()) {
	                this.$el.val(this.model.get('value'));
	            }
	            _.each(['readonly', 'disabled'], function (attr_name) {
	                self.model.get(attr_name) ? self.$el.attr(attr_name, true) : self.$el.removeAttr(attr_name);
	            });
	            this.$el[this.model.get('visible') ? 'show' : 'hide']();
	            return this;
	        },
	        _onchange: function () {
	            this.value(this.$el.val());
	            this.model.get('onchange') && this.model.get('onchange')(this.model.get('value'));
	        }
	    });
	
	    /** Creates a hidden element input field used e.g. in the tool form */
	    var Hidden = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model(options);
	            this.setElement($('<div/>').append(this.$info = $('<div/>')).append(this.$hidden = $('<div/>')));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	        value: function (new_val) {
	            new_val !== undefined && this.model.set('value', new_val);
	            return this.model.get('value');
	        },
	        render: function () {
	            this.$el.attr('id', this.model.id);
	            this.$hidden.val(this.model.get('value'));
	            this.model.get('info') ? this.$info.show().text(this.model.get('info')) : this.$info.hide();
	            return this;
	        }
	    });
	
	    /** Creates a upload element input field */
	    var Upload = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model(options);
	            this.setElement($('<div/>').append(this.$info = $('<div/>')).append(this.$file = $('<input/>').attr('type', 'file').addClass('ui-margin-bottom')).append(this.$text = $('<textarea/>').addClass('ui-textarea').attr('disabled', true)).append(this.$wait = $('<i/>').addClass('fa fa-spinner fa-spin')));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.$file.on('change', function (e) {
	                self._readFile(e);
	            });
	            this.render();
	        },
	        value: function (new_val) {
	            new_val !== undefined && this.model.set('value', new_val);
	            return this.model.get('value');
	        },
	        render: function () {
	            this.$el.attr('id', this.model.id);
	            this.model.get('info') ? this.$info.show().text(this.model.get('info')) : this.$info.hide();
	            this.model.get('value') ? this.$text.text(this.model.get('value')).show() : this.$text.hide();
	            this.model.get('wait') ? this.$wait.show() : this.$wait.hide();
	            return this;
	        },
	        _readFile: function (e) {
	            var self = this;
	            var file = e.target.files && e.target.files[0];
	            if (file) {
	                var reader = new FileReader();
	                reader.onload = function () {
	                    self.model.set({ wait: false, value: this.result });
	                };
	                this.model.set({ wait: true, value: null });
	                reader.readAsText(file);
	            }
	        }
	    });
	
	    return {
	        Button: Buttons.ButtonDefault,
	        ButtonIcon: Buttons.ButtonIcon,
	        ButtonCheck: Buttons.ButtonCheck,
	        ButtonMenu: Buttons.ButtonMenu,
	        ButtonLink: Buttons.ButtonLink,
	        Input: Input,
	        Label: Label,
	        Message: Message,
	        UnescapedMessage: UnescapedMessage,
	        Upload: Upload,
	        Modal: Modal,
	        RadioButton: Options.RadioButton,
	        Checkbox: Options.Checkbox,
	        Radio: Options.Radio,
	        Select: Select,
	        Hidden: Hidden,
	        Slider: Slider,
	        Drilldown: Drilldown
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui) {
	    var View = Backbone.View.extend({
	        visible: false,
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                cls: 'ui-portlet',
	                title: '',
	                icon: '',
	                buttons: null,
	                body: null,
	                scrollable: true,
	                nopadding: false,
	                operations: null,
	                collapsible: false,
	                collapsible_button: false,
	                collapsed: false,
	                onchange_title: null
	            }).set(options);
	            this.setElement(this._template());
	
	            // link all dom elements
	            this.$body = this.$('.portlet-body');
	            this.$title_text = this.$('.portlet-title-text');
	            this.$title_icon = this.$('.portlet-title-icon');
	            this.$header = this.$('.portlet-header');
	            this.$content = this.$('.portlet-content');
	            this.$backdrop = this.$('.portlet-backdrop');
	            this.$buttons = this.$('.portlet-buttons');
	            this.$operations = this.$('.portlet-operations');
	
	            // add body to component list
	            this.model.get('body') && this.append(this.model.get('body'));
	
	            // add icon for collapsible option
	            this.collapsible_button = new Ui.ButtonIcon({
	                icon: 'fa-eye',
	                tooltip: 'Collapse/Expand',
	                cls: 'ui-button-icon-plain',
	                onclick: function () {
	                    self[self.collapsed ? 'expand' : 'collapse']();
	                }
	            });
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.removeClass().addClass(options.cls).attr('id', options.id);
	            this.$header[options.title ? 'show' : 'hide']();
	            this.$title_text.html(options.title);
	            _.each([this.$content, this.$body], function ($el) {
	                $el[options.nopadding ? 'addClass' : 'removeClass']('no-padding');
	            });
	
	            // render title icon
	            if (options.icon) {
	                this.$title_icon.removeClass().addClass('portlet-title-icon fa').addClass(options.icon).show();
	            } else {
	                this.$title_icon.hide();
	            }
	
	            // make portlet collapsible
	            this.$title_text[options.collapsible ? 'addClass' : 'removeClass']('no-highlight collapsible').off();
	            if (options.collapsible) {
	                this.$title_text.on('click', function () {
	                    self[self.collapsed ? 'expand' : 'collapse']();
	                });
	                options.collapsed ? this.collapse() : this.expand();
	            }
	
	            // allow title editing
	            this.$title_text.prop('disabled', !options.onchange_title);
	            options.onchange_title && this.$title_text.make_text_editable({
	                on_finish: function (new_title) {
	                    options.onchange_title(new_title);
	                }
	            });
	
	            // render buttons
	            if (options.buttons) {
	                this.$buttons.empty().show();
	                $.each(this.model.get('buttons'), function (name, item) {
	                    item.$el.prop('id', name);
	                    self.$buttons.append(item.$el);
	                });
	            } else {
	                this.$buttons.hide();
	            }
	
	            // render operations
	            this.$operations.empty;
	            if (options.collapsible_button) {
	                this.$operations.append(this.collapsible_button.$el);
	            }
	            if (options.operations) {
	                $.each(options.operations, function (name, item) {
	                    item.$el.prop('id', name);
	                    self.$operations.append(item.$el);
	                });
	            }
	            return this;
	        },
	
	        /** Append new doms to body */
	        append: function ($el) {
	            this.$body.append($el);
	        },
	
	        /** Remove all content */
	        empty: function () {
	            this.$body.empty();
	        },
	
	        /** Return header element */
	        header: function () {
	            return this.$header;
	        },
	
	        /** Return body element */
	        body: function () {
	            return this.$body;
	        },
	
	        /** Show portlet */
	        show: function () {
	            this.visible = true;
	            this.$el.fadeIn('fast');
	        },
	
	        /** Hide portlet */
	        hide: function () {
	            this.visible = false;
	            this.$el.hide();
	        },
	
	        /** Enable a particular button */
	        enableButton: function (id) {
	            this.$buttons.find('#' + id).prop('disabled', false);
	        },
	
	        /** Disable a particular button */
	        disableButton: function (id) {
	            this.$buttons.find('#' + id).prop('disabled', true);
	        },
	
	        /** Hide a particular operation */
	        hideOperation: function (id) {
	            this.$operations.find('#' + id).hide();
	        },
	
	        /** Show a particular operation */
	        showOperation: function (id) {
	            this.$operations.find('#' + id).show();
	        },
	
	        /** Replaces the event callback of an existing operation */
	        setOperation: function (id, callback) {
	            this.$operations.find('#' + id).off('click').on('click', callback);
	        },
	
	        /** Change title */
	        title: function (new_title) {
	            new_title && this.$title_text.html(new_title);
	            return this.$title_text.html();
	        },
	
	        /** Collapse portlet */
	        collapse: function () {
	            this.collapsed = true;
	            this.$content.height('0%');
	            this.$body.hide();
	            this.collapsible_button.setIcon('fa-eye-slash');
	        },
	
	        /** Expand portlet */
	        expand: function () {
	            this.collapsed = false;
	            this.$content.height('100%');
	            this.$body.fadeIn('fast');
	            this.collapsible_button.setIcon('fa-eye');
	        },
	
	        /** Disable content access */
	        disable: function () {
	            this.$backdrop.show();
	        },
	
	        /** Enable content access */
	        enable: function () {
	            this.$backdrop.hide();
	        },
	
	        _template: function () {
	            return $('<div/>').append($('<div/>').addClass('portlet-header').append($('<div/>').addClass('portlet-operations')).append($('<div/>').addClass('portlet-title').append($('<i/>').addClass('portlet-title-icon')).append($('<span/>').addClass('portlet-title-text')))).append($('<div/>').addClass('portlet-content').append($('<div/>').addClass('portlet-body')).append($('<div/>').addClass('portlet-buttons'))).append($('<div/>').addClass('portlet-backdrop'));
	        }
	    });
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/**
	    This is the main class of the form plugin. It is referenced as 'app' in lower level modules.
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(9), __webpack_require__(5), __webpack_require__(32), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Portlet, Ui, FormSection, FormData) {
	    return Backbone.View.extend({
	        initialize: function (options) {
	            this.model = new Backbone.Model({
	                initial_errors: false,
	                cls: 'ui-portlet-limited',
	                icon: null,
	                always_refresh: true,
	                status: 'warning',
	                onchange: function () {}
	            }).set(options);
	            this.setElement('<div/>');
	            this.render();
	        },
	
	        /** Update available options */
	        update: function (new_model) {
	            var self = this;
	            this.data.matchModel(new_model, function (node, input_id) {
	                var input = self.input_list[input_id];
	                if (input && input.options) {
	                    if (!_.isEqual(input.options, node.options)) {
	                        input.options = node.options;
	                        var field = self.field_list[input_id];
	                        if (field.update) {
	                            var new_options = [];
	                            if (['data', 'data_collection', 'drill_down'].indexOf(input.type) != -1) {
	                                new_options = input.options;
	                            } else {
	                                for (var i in node.options) {
	                                    var opt = node.options[i];
	                                    if (opt.length > 2) {
	                                        new_options.push({ label: opt[0], value: opt[1] });
	                                    }
	                                }
	                            }
	                            field.update(new_options);
	                            field.trigger('change');
	                            Galaxy.emit.debug('form-view::update()', 'Updating options for ' + input_id);
	                        }
	                    }
	                }
	            });
	        },
	
	        /** Set form into wait mode */
	        wait: function (active) {
	            for (var i in this.input_list) {
	                var field = this.field_list[i];
	                var input = this.input_list[i];
	                if (input.is_dynamic && field.wait && field.unwait) {
	                    field[active ? 'wait' : 'unwait']();
	                }
	            }
	        },
	
	        /** Highlight and scroll to input element (currently only used for error notifications) */
	        highlight: function (input_id, message, silent) {
	            var input_element = this.element_list[input_id];
	            if (input_element) {
	                input_element.error(message || 'Please verify this parameter.');
	                this.portlet.expand();
	                this.trigger('expand', input_id);
	                if (!silent) {
	                    var $panel = this.$el.parents().filter(function () {
	                        return ['auto', 'scroll'].indexOf($(this).css('overflow')) != -1;
	                    }).first();
	                    $panel.animate({ scrollTop: $panel.scrollTop() + input_element.$el.offset().top - 120 }, 500);
	                }
	            }
	        },
	
	        /** Highlights errors */
	        errors: function (options) {
	            this.trigger('reset');
	            if (options && options.errors) {
	                var error_messages = this.data.matchResponse(options.errors);
	                for (var input_id in this.element_list) {
	                    var input = this.element_list[input_id];
	                    if (error_messages[input_id]) {
	                        this.highlight(input_id, error_messages[input_id], true);
	                    }
	                }
	            }
	        },
	
	        /** Render tool form */
	        render: function () {
	            var self = this;
	            this.off('change');
	            this.off('reset');
	            // contains the dom field elements as created by the parameter factory i.e. form-parameters
	            this.field_list = {};
	            // contains input definitions/dictionaries as provided by the parameters to_dict() function through the api
	            this.input_list = {};
	            // contains the dom elements of each input element i.e. form-input which wraps the actual input field
	            this.element_list = {};
	            // converts the form into a json data structure
	            this.data = new FormData.Manager(this);
	            this._renderForm();
	            this.data.create();
	            this.model.get('initial_errors') && this.errors(this.model.attributes);
	            // add listener which triggers on checksum change, and reset the form input wrappers
	            var current_check = this.data.checksum();
	            this.on('change', function (input_id) {
	                var input = self.input_list[input_id];
	                if (!input || input.refresh_on_change || self.model.get('always_refresh')) {
	                    var new_check = self.data.checksum();
	                    if (new_check != current_check) {
	                        current_check = new_check;
	                        self.model.get('onchange')();
	                    }
	                }
	            });
	            this.on('reset', function () {
	                _.each(self.element_list, function (input_element) {
	                    input_element.reset();
	                });
	            });
	            return this;
	        },
	
	        /** Renders/appends dom elements of the form */
	        _renderForm: function () {
	            $('.tooltip').remove();
	            var options = this.model.attributes;
	            this.message = new Ui.UnescapedMessage();
	            this.section = new FormSection.View(this, { inputs: options.inputs });
	            this.portlet = new Portlet.View({
	                icon: options.icon,
	                title: options.title,
	                cls: options.cls,
	                operations: options.operations,
	                buttons: options.buttons,
	                collapsible: options.collapsible,
	                collapsed: options.collapsed,
	                onchange_title: options.onchange_title
	            });
	            this.portlet.append(this.message.$el);
	            this.portlet.append(this.section.$el);
	            this.$el.empty();
	            options.inputs && this.$el.append(this.portlet.$el);
	            options.message && this.message.update({ persistent: true, status: options.status, message: options.message });
	            Galaxy.emit.debug('form-view::initialize()', 'Completed');
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** This module contains all button views. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    /** This renders the default button which is used e.g. at the bottom of the upload modal. */
	    var ButtonDefault = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                title: '',
	                icon: '',
	                cls: 'btn btn-default',
	                wait: false,
	                wait_text: 'Sending...',
	                wait_cls: 'btn btn-info',
	                disabled: false,
	                percentage: -1
	            }).set(options);
	            this.setElement($('<button/>').attr('type', 'button').append(this.$icon = $('<i/>')).append(this.$title = $('<span/>')).append(this.$progress = $('<div/>').append(this.$progress_bar = $('<div/>'))));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.removeClass().addClass('ui-button-default').addClass(options.disabled && 'disabled').attr('id', options.id).attr('disabled', options.disabled).off('click').on('click', function () {
	                $('.tooltip').hide();
	                options.onclick && !self.disabled && options.onclick();
	            }).tooltip({ title: options.tooltip, placement: 'bottom' });
	            this.$progress.addClass('progress').css('display', options.percentage !== -1 ? 'block' : 'none');
	            this.$progress_bar.addClass('progress-bar').css({ width: options.percentage + '%' });
	            this.$icon.removeClass().addClass('icon fa');
	            this.$title.removeClass().addClass('title');
	            if (options.wait) {
	                this.$el.addClass(options.wait_cls).prop('disabled', true);
	                this.$icon.addClass('fa-spinner fa-spin ui-margin-right');
	                this.$title.html(options.wait_text);
	            } else {
	                this.$el.addClass(options.cls);
	                this.$icon.addClass(options.icon);
	                this.$title.html(options.title);
	                options.icon && options.title && this.$icon.addClass('ui-margin-right');
	            }
	        },
	
	        /** Show button */
	        show: function () {
	            this.$el.show();
	        },
	
	        /** Hide button */
	        hide: function () {
	            this.$el.hide();
	        },
	
	        /** Disable button */
	        disable: function () {
	            this.model.set('disabled', true);
	        },
	
	        /** Enable button */
	        enable: function () {
	            this.model.set('disabled', false);
	        },
	
	        /** Show spinner to indicate that the button is not ready to be clicked */
	        wait: function () {
	            this.model.set('wait', true);
	        },
	
	        /** Hide spinner to indicate that the button is ready to be clicked */
	        unwait: function () {
	            this.model.set('wait', false);
	        },
	
	        /** Change icon */
	        setIcon: function (icon) {
	            this.model.set('icon', icon);
	        }
	    });
	
	    /** This button allows the right-click/open-in-new-tab feature, its used e.g. for panel buttons. */
	    var ButtonLink = ButtonDefault.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                title: '',
	                icon: '',
	                cls: ''
	            }).set(options);
	            this.setElement($('<a/>').append(this.$icon = $('<span/>')));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	
	        render: function () {
	            var options = this.model.attributes;
	            this.$el.removeClass().addClass(options.cls).attr({ id: options.id,
	                href: options.href || 'javascript:void(0)',
	                title: options.title,
	                target: options.target || '_top',
	                disabled: options.disabled }).tooltip({ placement: 'bottom' }).off('click').on('click', function () {
	                options.onclick && !options.disabled && options.onclick();
	            });
	            this.$icon.removeClass().addClass(options.icon);
	        }
	    });
	
	    /** The check button is used in the tool form and allows to distinguish between multiple states e.g. all, partially and nothing selected. */
	    var ButtonCheck = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                title: 'Select/Unselect all',
	                icons: ['fa-square-o', 'fa-minus-square-o', 'fa-check-square-o'],
	                value: 0,
	                onchange: function () {}
	            }).set(options);
	            this.setElement($('<div/>').append(this.$icon = $('<span/>')).append(this.$title = $('<span/>')));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	
	        render: function (options) {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.addClass('ui-button-check').off('click').on('click', function () {
	                self.model.set('value', self.model.get('value') === 0 && 2 || 0);
	                options.onclick && options.onclick();
	            });
	            this.$title.html(options.title);
	            this.$icon.removeClass().addClass('icon fa ui-margin-right').addClass(options.icons[options.value]);
	        },
	
	        /* Sets a new value and/or returns the value.
	        * @param{Integer}   new_val - Set a new value 0=unchecked, 1=partial and 2=checked.
	        * OR:
	        * @param{Integer}   new_val - Number of selected options.
	        * @param{Integer}   total   - Total number of available options.
	        */
	        value: function (new_val, total) {
	            if (new_val !== undefined) {
	                if (total && new_val !== 0) {
	                    new_val = new_val !== total && 1 || 2;
	                }
	                this.model.set('value', new_val);
	                this.model.get('onchange')(this.model.get('value'));
	            }
	            return this.model.get('value');
	        }
	    });
	
	    /** This renders a differently styled, more compact button version. */
	    var ButtonIcon = ButtonDefault.extend({
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                title: '',
	                icon: '',
	                cls: 'ui-button-icon',
	                disabled: false
	            }).set(options);
	            this.setElement($('<div/>').append(this.$button = $('<div/>').append(this.$icon = $('<i/>')).append(this.$title = $('<span/>'))));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	
	        render: function (options) {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.removeClass().addClass(options.cls).addClass(options.disabled && 'disabled').attr('disabled', options.disabled).attr('id', options.id).off('click').on('click', function () {
	                $('.tooltip').hide();
	                !options.disabled && options.onclick && options.onclick();
	            });
	            this.$button.addClass('button').tooltip({ title: options.tooltip, placement: 'bottom' });
	            this.$icon.removeClass().addClass('icon fa').addClass(options.icon);
	            this.$title.addClass('title').html(options.title);
	            options.icon && options.title && this.$icon.addClass('ui-margin-right');
	        }
	    });
	
	    /** This class creates a button with dropdown menu. */
	    var ButtonMenu = ButtonDefault.extend({
	        $menu: null,
	        initialize: function (options) {
	            this.model = options && options.model || new Backbone.Model({
	                id: '',
	                title: '',
	                pull: 'right',
	                icon: null,
	                onclick: null,
	                cls: 'ui-button-icon ui-button-menu',
	                tooltip: '',
	                target: '',
	                href: '',
	                onunload: null,
	                visible: true,
	                tag: ''
	            }).set(options);
	            this.collection = new Backbone.Collection();
	            this.setElement($('<div/>').append(this.$root = $('<div/>').append(this.$icon = $('<i/>')).append(this.$title = $('<span/>'))));
	            this.listenTo(this.model, 'change', this.render, this);
	            this.listenTo(this.collection, 'change add remove reset', this.render, this);
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.removeClass().addClass('dropdown').addClass(options.cls).attr('id', options.id).css({ display: options.visible && this.collection.where({ visible: true }).length > 0 ? 'block' : 'none' });
	            this.$root.addClass('root button dropdown-toggle').attr('data-toggle', 'dropdown').tooltip({ title: options.tooltip, placement: 'bottom' }).off('click').on('click', function (e) {
	                $('.tooltip').hide();
	                e.preventDefault();
	                options.onclick && options.onclick();
	            });
	            this.$icon.removeClass().addClass('icon fa').addClass(options.icon);
	            this.$title.removeClass().addClass('title').html(options.title);
	            options.icon && options.title && this.$icon.addClass('ui-margin-right');
	            this.$menu && this.$menu.remove();
	            if (this.collection.length > 0) {
	                this.$menu = $('<ul/>').addClass('menu dropdown-menu').addClass('pull-' + self.model.get('pull')).attr('role', 'menu');
	                this.$el.append(this.$menu);
	            }
	            this.collection.each(function (submodel) {
	                var suboptions = submodel.attributes;
	                if (suboptions.visible) {
	                    var $link = $('<a/>').addClass('dropdown-item').attr({ href: suboptions.href, target: suboptions.target }).append($('<i/>').addClass('fa').addClass(suboptions.icon).css('display', suboptions.icon ? 'inline-block' : 'none')).append(suboptions.title).on('click', function (e) {
	                        if (suboptions.onclick) {
	                            e.preventDefault();
	                            suboptions.onclick();
	                        }
	                    });
	                    self.$menu.append($('<li/>').append($link));
	                    suboptions.divider && self.$menu.append($('<li/>').addClass('divider'));
	                }
	            });
	        },
	
	        /** Add a new menu item */
	        addMenu: function (options) {
	            this.collection.add(Utils.merge(options, {
	                title: '',
	                target: '',
	                href: '',
	                onclick: null,
	                divider: false,
	                visible: true,
	                icon: null,
	                cls: 'button-menu btn-group'
	            }));
	        }
	    });
	
	    return {
	        ButtonDefault: ButtonDefault,
	        ButtonLink: ButtonLink,
	        ButtonIcon: ButtonIcon,
	        ButtonCheck: ButtonCheck,
	        ButtonMenu: ButtonMenu
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, Backbone, $, _) {// This is necessary so that, when nested arrays are used in ajax/post/get methods, square brackets ('[]') are
	// not appended to the identifier of a nested array.
	jQuery.ajaxSettings.traditional = true;
	
	// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(33), __webpack_require__(34), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, GridModel, Templates, PopupMenu) {
	
	    // grid view
	    return Backbone.View.extend({
	
	        // model
	        grid: null,
	
	        // Initialize
	        initialize: function (grid_config) {
	            this.grid = new GridModel();
	            this.dict_format = grid_config.dict_format;
	            this.title = grid_config.title;
	            var self = this;
	            window.add_tag_to_grid_filter = function (tag_name, tag_value) {
	                // Put tag name and value together.
	                var tag = tag_name + (tag_value !== undefined && tag_value !== "" ? ":" + tag_value : "");
	                var advanced_search = $('#advanced-search').is(":visible");
	                if (!advanced_search) {
	                    $('#standard-search').slideToggle('fast');
	                    $('#advanced-search').slideToggle('fast');
	                }
	                self.add_filter_condition("tags", tag);
	            };
	
	            // set element
	            if (this.dict_format) {
	                this.setElement('<div/>');
	                if (grid_config.url_base && !grid_config.items) {
	                    var url_data = grid_config.url_data || {};
	                    _.each(grid_config.filters, function (v, k) {
	                        url_data['f-' + k] = v;
	                    });
	                    $.ajax({
	                        url: grid_config.url_base + '?' + $.param(url_data),
	                        success: function (response) {
	                            response.embedded = grid_config.embedded;
	                            response.filters = grid_config.filters || {};
	                            self.init_grid(response);
	                        }
	                    });
	                } else {
	                    this.init_grid(grid_config);
	                }
	            } else {
	                this.setElement('#grid-container');
	                this.init_grid(grid_config);
	            }
	
	            // fix padding
	            if (grid_config.use_panels) {
	                $('#center').css({
	                    padding: '10px',
	                    overflow: 'auto'
	                });
	            }
	        },
	
	        // refresh frames
	        handle_refresh: function (refresh_frames) {
	            if (refresh_frames) {
	                if ($.inArray('history', refresh_frames) > -1) {
	                    if (top.Galaxy && top.Galaxy.currHistoryPanel) {
	                        top.Galaxy.currHistoryPanel.loadCurrentHistory();
	                    }
	                }
	            }
	        },
	
	        // Initialize
	        init_grid: function (grid_config) {
	            this.grid.set(grid_config);
	
	            // get options
	            var options = this.grid.attributes;
	
	            if (this.allow_title_display && options.title) {
	                Utils.setWindowTitle(options.title);
	            }
	            // handle refresh requests
	            this.handle_refresh(options.refresh_frames);
	
	            // strip protocol and domain
	            var url = this.grid.get('url_base');
	            url = url.replace(/^.*\/\/[^\/]+/, '');
	            this.grid.set('url_base', url);
	
	            // append main template
	            this.$el.html(Templates.grid(options));
	
	            // update div contents
	            this.$el.find('#grid-table-header').html(Templates.header(options));
	            this.$el.find('#grid-table-body').html(Templates.body(options));
	            this.$el.find('#grid-table-footer').html(Templates.footer(options));
	
	            // update message
	            if (options.message) {
	                this.$el.find('#grid-message').html(Templates.message(options));
	                var self = this;
	                if (options.use_hide_message) {
	                    setTimeout(function () {
	                        self.$el.find('#grid-message').html('');
	                    }, 5000);
	                }
	            }
	
	            // configure elements
	            this.init_grid_elements();
	            this.init_grid_controls();
	
	            // attach global event handler
	            // TODO: redundant (the onload/standard page handlers do this) - but needed because these are constructed after page ready
	            init_refresh_on_change();
	        },
	
	        // Initialize grid controls
	        init_grid_controls: function () {
	
	            // link
	            var self = this;
	
	            // Initialize grid operation button.
	            this.$el.find('.operation-button').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    self.submit_operation(this);
	                    return false;
	                });
	            });
	
	            // Initialize text filters to select text on click and use normal font when user is typing.
	            this.$el.find('input[type=text]').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    $(this).select();
	                }).keyup(function () {
	                    $(this).css('font-style', 'normal');
	                });
	            });
	
	            // Initialize sort links.
	            this.$el.find('.sort-link').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    self.set_sort_condition($(this).attr('sort_key'));
	                    return false;
	                });
	            });
	
	            // Initialize text filters.
	            this.$el.find('.text-filter-form').each(function () {
	                $(this).off();
	                $(this).submit(function () {
	                    var column_key = $(this).attr('column_key');
	                    var text_input_obj = $('#input-' + column_key + '-filter');
	                    var text_input = text_input_obj.val();
	                    text_input_obj.val('');
	                    self.add_filter_condition(column_key, text_input);
	                    return false;
	                });
	            });
	
	            // Initialize categorical filters.
	            this.$el.find('.text-filter-val > a').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    // Remove visible element.
	                    $(this).parent().remove();
	
	                    // Remove filter condition.
	                    self.remove_filter_condition($(this).attr('filter_key'), $(this).attr('filter_val'));
	
	                    // Return
	                    return false;
	                });
	            });
	
	            // Initialize categorical filters.
	            this.$el.find('.categorical-filter > a').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    self.set_categorical_filter($(this).attr('filter_key'), $(this).attr('filter_val'));
	                    return false;
	                });
	            });
	
	            // Initialize standard, advanced search toggles.
	            this.$el.find('.advanced-search-toggle').each(function () {
	                $(this).off();
	                $(this).click(function () {
	                    self.$el.find('#standard-search').slideToggle('fast');
	                    self.$el.find('#advanced-search').slideToggle('fast');
	                    return false;
	                });
	            });
	
	            // Add event to check all box
	            this.$el.find('#check_all').off();
	            this.$el.find('#check_all').on('click', function () {
	                self.check_all_items();
	            });
	        },
	
	        // Initialize grid elements.
	        init_grid_elements: function () {
	            // Initialize grid selection checkboxes.
	            this.$el.find('.grid').each(function () {
	                var checkboxes = $(this).find("input.grid-row-select-checkbox");
	                var check_count = $(this).find("span.grid-selected-count");
	                var update_checked = function () {
	                    check_count.text($(checkboxes).filter(":checked").length);
	                };
	
	                $(checkboxes).each(function () {
	                    $(this).change(update_checked);
	                });
	                update_checked();
	            });
	
	            // Initialize ratings.
	            if (this.$el.find('.community_rating_star').length !== 0) this.$el.find('.community_rating_star').rating({});
	
	            // get options
	            var options = this.grid.attributes;
	            var self = this;
	
	            //
	            // add page click events
	            //
	            this.$el.find('.page-link > a').each(function () {
	                $(this).click(function () {
	                    self.set_page($(this).attr('page_num'));
	                    return false;
	                });
	            });
	
	            //
	            // add inbound/outbound events
	            //
	            this.$el.find('.use-target').each(function () {
	                $(this).click(function (e) {
	                    self.execute({
	                        href: $(this).attr('href'),
	                        target: $(this).attr('target')
	                    });
	                    return false;
	                });
	            });
	
	            // empty grid?
	            var items_length = options.items.length;
	            if (items_length == 0) {
	                return;
	            }
	
	            // add operation popup menus
	            _.each(options.items, function (item, index) {
	                var button = self.$('#grid-' + index + '-popup').off();
	                var popup = new PopupMenu(button);
	                _.each(options['operations'], function (operation) {
	                    self._add_operation(popup, operation, item);
	                });
	            });
	        },
	
	        /** Add an operation to the items menu */
	        _add_operation: function (popup, operation, item) {
	            var self = this;
	            var settings = item.operation_config[operation.label];
	            if (settings.allowed && operation.allow_popup) {
	                popup.addItem({
	                    html: operation.label,
	                    href: settings.url_args,
	                    target: settings.target,
	                    confirmation_text: operation.confirm,
	                    func: function (e) {
	                        e.preventDefault();
	                        var label = $(e.target).html();
	                        if (operation.onclick) {
	                            operation.onclick(item.encode_id);
	                        } else {
	                            self.execute(this.findItemByHtml(label));
	                        }
	                    }
	                });
	            }
	        },
	
	        // Add a condition to the grid filter; this adds the condition and refreshes the grid.
	        add_filter_condition: function (name, value) {
	            // Do nothing is value is empty.
	            if (value === "") {
	                return false;
	            }
	
	            // Add condition to grid.
	            this.grid.add_filter(name, value, true);
	
	            // Add button that displays filter and provides a button to delete it.
	            var t = $(Templates.filter_element(name, value));
	            var self = this;
	            t.click(function () {
	                // Remove visible element.
	                $(this).remove();
	
	                // Remove filter condition.
	                self.remove_filter_condition(name, value);
	            });
	
	            // append to container
	            var container = this.$el.find('#' + name + '-filtering-criteria');
	            container.append(t);
	
	            // execute
	            this.go_page_one();
	            this.execute();
	        },
	
	        // Remove a condition to the grid filter; this adds the condition and refreshes the grid.
	        remove_filter_condition: function (name, value) {
	            // Remove filter condition.
	            this.grid.remove_filter(name, value);
	
	            // Execute
	            this.go_page_one();
	            this.execute();
	        },
	
	        // Set sort condition for grid.
	        set_sort_condition: function (col_key) {
	            // Set new sort condition. New sort is col_key if sorting new column; if reversing sort on
	            // currently sorted column, sort is reversed.
	            var cur_sort = this.grid.get('sort_key');
	            var new_sort = col_key;
	            if (cur_sort.indexOf(col_key) !== -1) {
	                // Reverse sort.
	                if (cur_sort.substring(0, 1) !== '-') {
	                    new_sort = '-' + col_key;
	                }
	            }
	
	            // Remove sort arrows elements.
	            this.$el.find('.sort-arrow').remove();
	
	            // Add sort arrow element to new sort column.
	            var sort_arrow = new_sort.substring(0, 1) == '-' ? '&uarr;' : '&darr;';
	            var t = $('<span>' + sort_arrow + '</span>').addClass('sort-arrow');
	
	            // Add to header
	            this.$el.find('#' + col_key + '-header').append(t);
	
	            // Update grid.
	            this.grid.set('sort_key', new_sort);
	            this.go_page_one();
	            this.execute();
	        },
	
	        // Set new value for categorical filter.
	        set_categorical_filter: function (name, new_value) {
	            // Update filter hyperlinks to reflect new filter value.
	            var category_filter = this.grid.get('categorical_filters')[name],
	                cur_value = this.grid.get('filters')[name];
	            var self = this;
	            this.$el.find('.' + name + '-filter').each(function () {
	                var text = $.trim($(this).text());
	                var filter = category_filter[text];
	                var filter_value = filter[name];
	                if (filter_value == new_value) {
	                    // Remove filter link since grid will be using this filter. It is assumed that
	                    // this element has a single child, a hyperlink/anchor with text.
	                    $(this).empty();
	                    $(this).addClass('current-filter');
	                    $(this).append(text);
	                } else if (filter_value == cur_value) {
	                    // Add hyperlink for this filter since grid will no longer be using this filter. It is assumed that
	                    // this element has a single child, a hyperlink/anchor.
	                    $(this).empty();
	                    var t = $('<a href="#">' + text + '</a>');
	                    t.click(function () {
	                        self.set_categorical_filter(name, filter_value);
	                    });
	                    $(this).removeClass('current-filter');
	                    $(this).append(t);
	                }
	            });
	
	            // Update grid.
	            this.grid.add_filter(name, new_value);
	            this.go_page_one();
	            this.execute();
	        },
	
	        // Set page to view.
	        set_page: function (new_page) {
	            // Update page hyperlink to reflect new page.
	            var self = this;
	            this.$el.find('.page-link').each(function () {
	                var id = $(this).attr('id'),
	                    page_num = parseInt(id.split('-')[2], 10),
	                    // Id has form 'page-link-<page_num>
	                cur_page = self.grid.get('cur_page'),
	                    text;
	                if (page_num === new_page) {
	                    // Remove link to page since grid will be on this page. It is assumed that
	                    // this element has a single child, a hyperlink/anchor with text.
	                    text = $(this).children().text();
	                    $(this).empty();
	                    $(this).addClass('inactive-link');
	                    $(this).text(text);
	                } else if (page_num === cur_page) {
	                    // Add hyperlink to this page since grid will no longer be on this page. It is assumed that
	                    // this element has a single child, a hyperlink/anchor.
	                    text = $(this).text();
	                    $(this).empty();
	                    $(this).removeClass('inactive-link');
	                    var t = $('<a href="#">' + text + '</a>');
	                    t.click(function () {
	                        self.set_page(page_num);
	                    });
	                    $(this).append(t);
	                }
	            });
	
	            if (new_page === 'all') {
	                this.grid.set('cur_page', new_page);
	            } else {
	                this.grid.set('cur_page', parseInt(new_page, 10));
	            }
	            this.execute();
	        },
	
	        // confirmation/submission of operation request
	        submit_operation: function (operation_button, confirmation_text) {
	            // identify operation
	            var operation_name = $(operation_button).val();
	
	            // verify in any item is selected
	            var number_of_checked_ids = this.$el.find('input[name="id"]:checked').length;
	            if (!number_of_checked_ids > 0) {
	                return false;
	            }
	
	            // Check to see if there's grid confirmation text for this operation
	            var operation = _.findWhere(this.grid.attributes.operations, { label: operation_name });
	            if (operation && !confirmation_text) {
	                confirmation_text = operation.confirm || '';
	            }
	
	            // collect ids
	            var item_ids = [];
	            this.$el.find('input[name=id]:checked').each(function () {
	                item_ids.push($(this).val());
	            });
	
	            // execute operation
	            var options = {
	                operation: operation_name,
	                id: item_ids,
	                confirmation_text: confirmation_text
	            };
	            if (operation.target == 'top') {
	                options = _.extend(options, {
	                    href: operation.href,
	                    target: operation.target
	                });
	            }
	            this.execute(options);
	            return true;
	        },
	
	        check_all_items: function () {
	            var check = this.$('.grid-row-select-checkbox');
	            var state = this.$('#check_all').prop('checked');
	            _.each(check, function (c) {
	                $(c).prop('checked', state);
	            });
	            this.init_grid_elements();
	        },
	
	        // Go back to page one; this is useful when a filter is applied.
	        go_page_one: function () {
	            // Need to go back to page 1 if not showing all.
	            var cur_page = this.grid.get('cur_page');
	            if (cur_page !== null && cur_page !== undefined && cur_page !== 'all') {
	                this.grid.set('cur_page', 1);
	            }
	        },
	
	        //
	        // execute operations and hyperlink requests
	        //
	        execute: function (options) {
	            // get url
	            var id = null;
	            var href = null;
	            var operation = null;
	            var confirmation_text = null;
	            var target = null;
	
	            // check for options
	            if (options) {
	                // get options
	                href = options.href;
	                operation = options.operation;
	                id = options.id;
	                confirmation_text = options.confirmation_text;
	                target = options.target;
	
	                // check if input contains the operation tag
	                if (href !== undefined && href.indexOf('operation=') != -1) {
	                    // Get operation, id in hyperlink's href.
	                    var href_parts = href.split("?");
	                    if (href_parts.length > 1) {
	                        var href_parms_str = href_parts[1];
	                        var href_parms = href_parms_str.split("&");
	                        for (var index = 0; index < href_parms.length; index++) {
	                            if (href_parms[index].indexOf('operation') != -1) {
	                                // Found operation parm; get operation value.
	                                operation = href_parms[index].split('=')[1];
	                                operation = operation.replace(/\+/g, ' ');
	                            } else if (href_parms[index].indexOf('id') != -1) {
	                                // Found id parm; get id value.
	                                id = href_parms[index].split('=')[1];
	                            }
	                        }
	                    }
	                }
	            }
	
	            // check for operation details
	            if (operation && id) {
	                // show confirmation box
	                if (confirmation_text && confirmation_text != '' && confirmation_text != 'None' && confirmation_text != 'null') if (!confirm(confirmation_text)) return false;
	
	                // use small characters for operation?!
	                operation = operation.toLowerCase();
	
	                // Update grid.
	                this.grid.set({
	                    operation: operation,
	                    item_ids: id
	                });
	
	                // Do operation. If operation cannot be performed asynchronously, redirect to location.
	                if (target == 'top') {
	                    window.top.location = href + '?' + $.param(this.grid.get_url_data());
	                } else if (this.grid.can_async_op(operation) || this.dict_format) {
	                    this.update_grid();
	                } else {
	                    this.go_to(target, href);
	                }
	
	                // done
	                return false;
	            }
	
	            // refresh grid
	            if (href) {
	                this.go_to(target, href);
	                return false;
	            }
	
	            // refresh grid
	            if (this.grid.get('async') || this.dict_format) {
	                this.update_grid();
	            } else {
	                this.go_to(target, href);
	            }
	
	            // done
	            return false;
	        },
	
	        // go to url
	        go_to: function (target, href) {
	            // get aysnc status
	            var async = this.grid.get('async');
	            this.grid.set('async', false);
	
	            // get slide status
	            var advanced_search = this.$el.find('#advanced-search').is(':visible');
	            this.grid.set('advanced_search', advanced_search);
	
	            // get default url
	            if (!href) {
	                href = this.grid.get('url_base') + '?' + $.param(this.grid.get_url_data());
	            }
	
	            // clear grid of transient request attributes.
	            this.grid.set({
	                operation: undefined,
	                item_ids: undefined,
	                async: async
	            });
	            switch (target) {
	                case 'inbound':
	                    // this currently assumes that there is only a single grid shown at a time
	                    var $div = $('.grid-header').closest('.inbound');
	                    if ($div.length !== 0) {
	                        $div.load(href);
	                        return;
	                    }
	                    break;
	                case 'top':
	                    window.top.location = href;
	                    break;
	                default:
	                    window.location = href;
	            }
	        },
	
	        // Update grid.
	        update_grid: function () {
	            // If there's an operation, do POST; otherwise, do GET.
	            var method = this.grid.get('operation') ? 'POST' : 'GET';
	
	            // Show overlay to indicate loading and prevent user actions.
	            this.$el.find('.loading-elt-overlay').show();
	            var self = this;
	            $.ajax({
	                type: method,
	                url: self.grid.get('url_base'),
	                data: self.grid.get_url_data(),
	                error: function (response) {
	                    alert('Grid refresh failed');
	                },
	                success: function (response_text) {
	
	                    // backup
	                    var embedded = self.grid.get('embedded');
	                    var insert = self.grid.get('insert');
	                    var advanced_search = self.$el.find('#advanced-search').is(':visible');
	
	                    // request new configuration
	                    var json = self.dict_format ? response_text : $.parseJSON(response_text);
	
	                    // update
	                    json.embedded = embedded;
	                    json.insert = insert;
	                    json.advanced_search = advanced_search;
	
	                    // Initialize new grid config
	                    self.init_grid(json);
	
	                    // Hide loading overlay.
	                    self.$el.find('.loading-elt-overlay').hide();
	                },
	                complete: function () {
	                    // Clear grid of transient request attributes.
	                    self.grid.set({
	                        operation: undefined,
	                        item_ids: undefined
	                    });
	                }
	            });
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(9), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Portlet, Ui) {
	
	    // ui list element
	    var View = Backbone.View.extend({
	        // create portlet to keep track of selected list elements
	        initialize: function (options) {
	            // link this
	            var self = this;
	
	            // initialize options
	            this.options = options;
	            this.name = options.name || 'element';
	            this.multiple = options.multiple || false;
	
	            // create message handler
	            this.message = new Ui.Message();
	
	            // create portlet
	            this.portlet = new Portlet.View({ cls: 'ui-portlet-section' });
	
	            // create select field containing the options which can be inserted into the list
	            this.select = new Ui.Select.View({ optional: options.optional });
	
	            // create insert new list element button
	            this.button = new Ui.ButtonIcon({
	                icon: 'fa fa-sign-in',
	                tooltip: 'Insert new ' + this.name,
	                onclick: function () {
	                    self.add({
	                        id: self.select.value(),
	                        name: self.select.text()
	                    });
	                }
	            });
	
	            // build main element
	            this.setElement(this._template(options));
	            this.$('.ui-list-message').append(this.message.$el);
	            this.$('.ui-list-portlet').append(this.portlet.$el);
	            this.$('.ui-list-button').append(this.button.$el);
	            this.$('.ui-list-select').append(this.select.$el);
	        },
	
	        /** Return/Set currently selected list elements */
	        value: function (val) {
	            // set new value
	            if (val !== undefined) {
	                this.portlet.empty();
	                if ($.isArray(val)) {
	                    for (var i in val) {
	                        var v = val[i];
	                        var v_id = null;
	                        var v_name = null;
	                        if ($.type(v) != 'string') {
	                            v_id = v.id;
	                            v_name = v.name;
	                        } else {
	                            v_id = v_name = v;
	                        }
	                        if (v_id != null) {
	                            this.add({
	                                id: v_id,
	                                name: v_name
	                            });
	                        }
	                    }
	                }
	                this._refresh();
	            }
	            // get current value
	            var lst = [];
	            this.$('.ui-list-id').each(function () {
	                lst.push({
	                    id: $(this).prop('id'),
	                    name: $(this).find('.ui-list-name').html()
	                });
	            });
	            if (lst.length == 0) {
	                return null;
	            }
	            return lst;
	        },
	
	        /** Add row */
	        add: function (options) {
	            var self = this;
	            if (this.$('[id="' + options.id + '"]').length === 0) {
	                if (!Utils.isEmpty(options.id)) {
	                    var $el = $(this._templateRow({
	                        id: options.id,
	                        name: options.name
	                    }));
	                    $el.on('click', function () {
	                        $el.remove();
	                        self._refresh();
	                    });
	                    $el.on('mouseover', function () {
	                        $el.addClass('portlet-highlight');
	                    });
	                    $el.on('mouseout', function () {
	                        $el.removeClass('portlet-highlight');
	                    });
	                    this.portlet.append($el);
	                    this._refresh();
	                } else {
	                    this.message.update({ message: 'Please select a valid ' + this.name + '.', status: 'danger' });
	                }
	            } else {
	                this.message.update({ message: 'This ' + this.name + ' is already in the list.' });
	            }
	        },
	
	        /** Update available options */
	        update: function (options) {
	            this.select.update(options);
	        },
	
	        /** Refresh view */
	        _refresh: function () {
	            if (this.$('.ui-list-id').length > 0) {
	                !this.multiple && this.button.disable();
	                this.$('.ui-list-portlet').show();
	            } else {
	                this.button.enable();
	                this.$('.ui-list-portlet').hide();
	            }
	            this.options.onchange && this.options.onchange();
	        },
	
	        /** Main Template */
	        _template: function (options) {
	            return '<div class="ui-list">' + '<div class="ui-margin-top">' + '<span class="ui-list-button"/>' + '<span class="ui-list-select"/>' + '</div>' + '<div class="ui-list-message"/>' + '<div class="ui-list-portlet"/>' + '</div>';
	        },
	
	        /** Row Template */
	        _templateRow: function (options) {
	            return '<div id="' + options.id + '" class="ui-list-id">' + '<span class="ui-list-delete fa fa-trash"/>' + '<span class="ui-list-name">' + options.name + '</span>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** Base class for options based ui elements **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Buttons) {
	    var Base = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model({
	                visible: true,
	                data: [],
	                id: Utils.uid(),
	                error_text: 'No options available.',
	                wait_text: 'Please wait...',
	                multiple: false,
	                optional: false,
	                onchange: function () {}
	            }).set(options);
	            this.listenTo(this.model, 'change:value', this._changeValue, this);
	            this.listenTo(this.model, 'change:wait', this._changeWait, this);
	            this.listenTo(this.model, 'change:data', this._changeData, this);
	            this.listenTo(this.model, 'change:visible', this._changeVisible, this);
	            this.on('change', function () {
	                self.model.get('onchange')(self.value());
	            });
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            this.$el.empty().removeClass().addClass('ui-options').append(this.$message = $('<div/>')).append(this.$menu = $('<div/>').addClass('ui-options-menu')).append(this.$options = $(this._template()));
	
	            // add select/unselect all button
	            this.all_button = null;
	            if (this.model.get('multiple')) {
	                this.all_button = new Buttons.ButtonCheck({
	                    onclick: function () {
	                        self.$('input').prop('checked', self.all_button.value() !== 0);
	                        self.value(self._getValue());
	                        self.trigger('change');
	                    }
	                });
	                this.$menu.append(this.all_button.$el);
	            }
	
	            // finalize dom
	            this._changeData();
	            this._changeWait();
	            this._changeVisible();
	        },
	
	        /** Update available options */
	        update: function (options) {
	            this.model.set('data', options);
	        },
	
	        _changeData: function () {
	            var self = this;
	            this.$options.empty();
	            if (this._templateOptions) {
	                this.$options.append(this._templateOptions(this.model.get('data')));
	            } else {
	                _.each(this.model.get('data'), function (option) {
	                    self.$options.append($(self._templateOption(option)).addClass('ui-option').tooltip({ title: option.tooltip, placement: 'bottom' }));
	                });
	            }
	            var self = this;
	            this.$('input').on('change', function () {
	                self.value(self._getValue());
	                self.trigger('change');
	            });
	            this._changeValue();
	            this._changeWait();
	        },
	
	        _changeVisible: function () {
	            this.$el[this.model.get('visible') ? 'show' : 'hide']();
	        },
	
	        _changeWait: function () {
	            if (this.model.get('wait')) {
	                if (this.length() === 0) {
	                    this._messageShow(this.model.get('wait_text'), 'info');
	                    this.$options.hide();
	                    this.$menu.hide();
	                }
	            } else {
	                if (this.length() === 0) {
	                    this._messageShow(this.model.get('error_text'), 'danger');
	                    this.$options.hide();
	                    this.$menu.hide();
	                } else {
	                    this.$message.hide();
	                    this.$options.css('display', 'inline-block');
	                    this.$menu.show();
	                }
	            }
	        },
	
	        _changeValue: function () {
	            this._setValue(this.model.get('value'));
	            if (this._getValue() === null && !this.model.get('multiple') && !this.model.get('optional')) {
	                this._setValue(this.first());
	            }
	            this.all_button && this.all_button.value($.isArray(this._getValue()) ? this._getValue().length : 0, this.length());
	        },
	
	        /** Return/Set current selection */
	        value: function (new_value) {
	            new_value !== undefined && this.model.set('value', new_value);
	            return this._getValue();
	        },
	
	        /** Return first available option */
	        first: function () {
	            var options = this.$('input').first();
	            return options.length > 0 ? options.val() : null;
	        },
	
	        /** Show a spinner indicating that the select options are currently loaded */
	        wait: function () {
	            this.model.set('wait', true);
	        },
	
	        /** Hide spinner indicating that the request has been completed */
	        unwait: function () {
	            this.model.set('wait', false);
	        },
	
	        /** Returns the number of options */
	        length: function () {
	            return this.$('.ui-option').length;
	        },
	
	        /** Set value to dom */
	        _setValue: function (new_value) {
	            var self = this;
	            if (new_value !== undefined) {
	                this.$('input').prop('checked', false);
	                if (new_value !== null) {
	                    var values = $.isArray(new_value) ? new_value : [new_value];
	                    _.each(values, function (v) {
	                        self.$('input[value="' + v + '"]').first().prop('checked', true);
	                    });
	                }
	            }
	        },
	
	        /** Return current selection */
	        _getValue: function () {
	            var selected = [];
	            this.$(':checked').each(function () {
	                selected.push($(this).val());
	            });
	            if (Utils.isEmpty(selected)) {
	                return null;
	            }
	            return this.model.get('multiple') ? selected : selected[0];
	        },
	
	        /** Show message instead if options */
	        _messageShow: function (text, status) {
	            this.$message.show().removeClass().addClass('ui-message alert alert-' + status).html(text);
	        },
	
	        /** Main template function */
	        _template: function () {
	            return $('<div/>').addClass('ui-options-list');
	        }
	    });
	
	    /** Iconized **/
	    var BaseIcons = Base.extend({
	        _templateOption: function (pair) {
	            var id = Utils.uid();
	            return $('<div/>').addClass('ui-option').append($('<input/>').attr({
	                id: id,
	                type: this.model.get('type'),
	                name: this.model.id,
	                value: pair.value })).append($('<label/>').addClass('ui-options-label').attr('for', id).html(pair.label));
	        }
	    });
	
	    /** Radio button field **/
	    var Radio = {};
	    Radio.View = BaseIcons.extend({
	        initialize: function (options) {
	            options.type = 'radio';
	            BaseIcons.prototype.initialize.call(this, options);
	        }
	    });
	
	    /** Checkbox options field **/
	    var Checkbox = {};
	    Checkbox.View = BaseIcons.extend({
	        initialize: function (options) {
	            options.type = 'checkbox';
	            options.multiple = true;
	            BaseIcons.prototype.initialize.call(this, options);
	        }
	    });
	
	    /** Radio button options field styled as classic buttons **/
	    var RadioButton = {};
	    RadioButton.View = Base.extend({
	        initialize: function (options) {
	            Base.prototype.initialize.call(this, options);
	        },
	
	        /** Set current value */
	        _setValue: function (new_value) {
	            if (new_value !== undefined) {
	                this.$('input').prop('checked', false);
	                this.$('label').removeClass('active');
	                this.$('[value="' + new_value + '"]').prop('checked', true).closest('label').addClass('active');
	            }
	        },
	
	        /** Template for a single option */
	        _templateOption: function (pair) {
	            var $el = $('<label/>').addClass('btn btn-default');
	            pair.icon && $el.append($('<i/>').addClass('fa').addClass(pair.icon).addClass(!pair.label && 'no-padding'));
	            $el.append($('<input/>').attr({ type: 'radio', name: this.model.id, value: pair.value }));
	            pair.label && $el.append(pair.label);
	            return $el;
	        },
	
	        /** Main template function */
	        _template: function () {
	            return $('<div/>').addClass('btn-group ui-radiobutton').attr('data-toggle', 'buttons');
	        }
	    });
	
	    return {
	        Base: Base,
	        BaseIcons: BaseIcons,
	        Radio: Radio,
	        RadioButton: RadioButton,
	        Checkbox: Checkbox
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/**
	 *  This class creates/wraps a default html select field as backbone class.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Buttons) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.data = [];
	            this.data2 = [];
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                cls: 'ui-select',
	                error_text: 'No options available',
	                empty_text: 'Nothing selected',
	                visible: true,
	                wait: false,
	                multiple: false,
	                searchable: true,
	                optional: false,
	                disabled: false,
	                onchange: function () {},
	                value: null,
	                individual: false,
	                pagesize: 20
	            }).set(options);
	            this.on('change', function () {
	                self.model.get('onchange') && self.model.get('onchange')(self.value());
	            });
	            this.listenTo(this.model, 'change:data', this._changeData, this);
	            this.listenTo(this.model, 'change:disabled', this._changeDisabled, this);
	            this.listenTo(this.model, 'change:wait', this._changeWait, this);
	            this.listenTo(this.model, 'change:visible', this._changeVisible, this);
	            this.listenTo(this.model, 'change:value', this._changeValue, this);
	            this.listenTo(this.model, 'change:multiple change:searchable change:cls change:id', this.render, this);
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            this.model.get('searchable') ? this._renderSearchable() : this._renderClassic();
	            this.$el.addClass(this.model.get('cls')).attr('id', this.model.get('id'));
	            this.$select.empty().addClass('select').attr('id', this.model.get('id') + '_select').prop('multiple', this.model.get('multiple')).on('change', function () {
	                self.value(self._getValue());
	                self.trigger('change');
	            });
	            this._changeData();
	            this._changeWait();
	            this._changeVisible();
	            this._changeDisabled();
	        },
	
	        /** Renders the classic selection field */
	        _renderClassic: function () {
	            var self = this;
	            this.$el.addClass(this.model.get('multiple') ? 'ui-select-multiple' : 'ui-select').append(this.$select = $('<select/>')).append(this.$dropdown = $('<div/>')).append(this.$resize = $('<div/>').append(this.$resize_icon = $('<i/>')));
	            if (this.model.get('multiple')) {
	                this.$dropdown.hide();
	                this.$resize_icon.addClass('fa fa-angle-double-right fa-rotate-45').show();
	                this.$resize.removeClass().addClass('icon-resize').show().off('mousedown').on('mousedown', function (event) {
	                    var currentY = event.pageY;
	                    var currentHeight = self.$select.height();
	                    self.minHeight = self.minHeight || currentHeight;
	                    $('#dd-helper').show().on('mousemove', function (event) {
	                        self.$select.height(Math.max(currentHeight + (event.pageY - currentY), self.minHeight));
	                    }).on('mouseup mouseleave', function () {
	                        $('#dd-helper').hide().off();
	                    });
	                });
	            } else {
	                this.$dropdown.show();
	                this.$resize.hide();
	                this.$resize_icon.hide();
	            }
	        },
	
	        /** Renders the default select2 field */
	        _renderSearchable: function () {
	            var self = this;
	            this.$el.append(this.$select = $('<div/>')).append(this.$dropdown = $('<div/>'));
	            this.$dropdown.hide();
	            if (!this.model.get('multiple')) {
	                this.$dropdown.show().on('click', function () {
	                    self.$select.select2 && self.$select.select2('open');
	                });
	            }
	            this.all_button = null;
	            if (this.model.get('multiple') && !this.model.get('individual')) {
	                this.all_button = new Buttons.ButtonCheck({
	                    onclick: function () {
	                        var new_value = [];
	                        self.all_button.value() !== 0 && _.each(self.model.get('data'), function (option) {
	                            new_value.push(option.value);
	                        });
	                        self.value(new_value);
	                        self.trigger('change');
	                    }
	                });
	                this.$el.prepend(this.all_button.$el);
	            }
	        },
	
	        /** Matches a search term with a given text */
	        _match: function (term, text) {
	            return !term || term == '' || String(text).toUpperCase().indexOf(term.toUpperCase()) >= 0;
	        },
	
	        /** Updates the selection options */
	        _changeData: function () {
	            var self = this;
	            this.data = [];
	            if (!this.model.get('multiple') && this.model.get('optional')) {
	                this.data.push({ value: '__null__', label: self.model.get('empty_text') });
	            }
	            _.each(this.model.get('data'), function (option) {
	                self.data.push(option);
	            });
	            if (this.length() == 0) {
	                this.data.push({ value: '__null__', label: this.model.get('error_text') });
	            }
	            if (this.model.get('searchable')) {
	                this.data2 = [];
	                _.each(this.data, function (option, index) {
	                    self.data2.push({ order: index, id: option.value, text: option.label, tags: option.tags });
	                });
	                this.$select.data('select2') && this.$select.select2('destroy');
	                this.matched_tags = {};
	                this.$select.select2({
	                    data: self.data2,
	                    closeOnSelect: !this.model.get('multiple'),
	                    multiple: this.model.get('multiple'),
	                    query: function (q) {
	                        self.matched_tags = {};
	                        var pagesize = self.model.get('pagesize');
	                        var results = _.filter(self.data2, function (e) {
	                            var found = false;
	                            _.each(e.tags, function (tag) {
	                                if (self._match(q.term, tag)) {
	                                    found = self.matched_tags[tag] = true;
	                                }
	                            });
	                            return found || self._match(q.term, e.text);
	                        });
	                        q.callback({
	                            results: results.slice((q.page - 1) * pagesize, q.page * pagesize),
	                            more: results.length >= q.page * pagesize
	                        });
	                    },
	                    formatResult: function (result) {
	                        return _.escape(result.text) + '<div class="ui-tags">' + _.reduce(result.tags, function (memo, tag) {
	                            if (self.matched_tags[tag]) {
	                                return memo + '&nbsp;' + '<div class="label label-info">' + _.escape(tag) + '</div>';
	                            }
	                            return memo;
	                        }, '') + '</div>';
	                    }
	                });
	                this.$('.select2-container .select2-search input').off('blur');
	            } else {
	                this.$select.find('option').remove();
	                _.each(this.data, function (option) {
	                    self.$select.append($('<option/>').attr('value', option.value).html(_.escape(option.label)));
	                });
	            }
	            this.model.set('disabled', this.length() == 0);
	            this._changeValue();
	        },
	
	        /** Handles field enabling/disabling, usually used when no options are available */
	        _changeDisabled: function () {
	            if (this.model.get('searchable')) {
	                this.$select.select2(this.model.get('disabled') ? 'disable' : 'enable');
	            } else {
	                this.$select.prop('disabled', this.model.get('disabled'));
	            }
	        },
	
	        /** Searchable fields may display a spinner e.g. while waiting for a server response */
	        _changeWait: function () {
	            this.$dropdown.removeClass().addClass('icon-dropdown fa').addClass(this.model.get('wait') ? 'fa-spinner fa-spin' : 'fa-caret-down');
	        },
	
	        /** Handles field visibility */
	        _changeVisible: function () {
	            this.$el[this.model.get('visible') ? 'show' : 'hide']();
	            this.$select[this.model.get('visible') ? 'show' : 'hide']();
	        },
	
	        /** Synchronizes the model value with the actually selected field value */
	        _changeValue: function () {
	            this._setValue(this.model.get('value'));
	            if (this.model.get('multiple')) {
	                if (this.all_button) {
	                    var value = this._getValue();
	                    this.all_button.value($.isArray(value) ? value.length : 0, this.length());
	                }
	            } else if (this._getValue() === null && !this.model.get('optional')) {
	                this._setValue(this.first());
	            }
	        },
	
	        /** Return/Set current selection */
	        value: function (new_value) {
	            new_value !== undefined && this.model.set('value', new_value);
	            return this._getValue();
	        },
	
	        /** Return the first select option */
	        first: function () {
	            return this.data.length > 0 ? this.data[0].value : null;
	        },
	
	        /** Check if a value is an existing option */
	        exists: function (value) {
	            return _.findWhere(this.data, { value: value });
	        },
	
	        /** Return the label/text of the current selection */
	        text: function () {
	            var v = this._getValue();
	            var d = this.exists($.isArray(v) ? v[0] : v);
	            return d ? d.label : '';
	        },
	
	        /** Show the select field */
	        show: function () {
	            this.model.set('visible', true);
	        },
	
	        /** Hide the select field */
	        hide: function () {
	            this.model.set('visible', false);
	        },
	
	        /** Show a spinner indicating that the select options are currently loaded */
	        wait: function () {
	            this.model.set('wait', true);
	        },
	
	        /** Hide spinner indicating that the request has been completed */
	        unwait: function () {
	            this.model.set('wait', false);
	        },
	
	        /** Returns true if the field is disabled */
	        disabled: function () {
	            return this.model.get('disabled');
	        },
	
	        /** Enable the select field */
	        enable: function () {
	            this.model.set('disabled', false);
	        },
	
	        /** Disable the select field */
	        disable: function () {
	            this.model.set('disabled', true);
	        },
	
	        /** Update all available options at once */
	        add: function (options, sorter) {
	            _.each(this.model.get('data'), function (v) {
	                v.keep && !_.findWhere(options, { value: v.value }) && options.push(v);
	            });
	            sorter && options && options.sort(sorter);
	            this.model.set('data', options);
	        },
	
	        /** Update available options */
	        update: function (options) {
	            this.model.set('data', options);
	        },
	
	        /** Set the custom onchange callback function */
	        setOnChange: function (callback) {
	            this.model.set('onchange', callback);
	        },
	
	        /** Number of available options */
	        length: function () {
	            return $.isArray(this.model.get('data')) ? this.model.get('data').length : 0;
	        },
	
	        /** Set value to dom */
	        _setValue: function (new_value) {
	            var self = this;
	            if (new_value === null || new_value === undefined) {
	                new_value = '__null__';
	            }
	            if (this.model.get('multiple')) {
	                new_value = $.isArray(new_value) ? new_value : [new_value];
	            } else if ($.isArray(new_value)) {
	                if (new_value.length > 0) {
	                    new_value = new_value[0];
	                } else {
	                    new_value = '__null__';
	                }
	            }
	            if (this.model.get('searchable')) {
	                if ($.isArray(new_value)) {
	                    var val = [];
	                    _.each(new_value, function (v) {
	                        var d = _.findWhere(self.data2, { id: v });
	                        d && val.push(d);
	                    });
	                    new_value = val;
	                } else {
	                    var d = _.findWhere(this.data2, { id: new_value });
	                    new_value = d;
	                }
	                this.$select.select2('data', new_value);
	            } else {
	                this.$select.val(new_value);
	            }
	        },
	
	        /** Get value from dom */
	        _getValue: function () {
	            var val = null;
	            if (this.model.get('searchable')) {
	                var selected = this.$select.select2('data');
	                if (selected) {
	                    if ($.isArray(selected)) {
	                        val = [];
	                        selected.sort(function (a, b) {
	                            return a.order - b.order;
	                        });
	                        _.each(selected, function (v) {
	                            val.push(v.id);
	                        });
	                    } else {
	                        val = selected.id;
	                    }
	                }
	            } else {
	                val = this.$select.val();
	            }
	            return Utils.isEmpty(val) ? null : val;
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {// Additional dependencies: jQuery, underscore.
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(48), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Modal, Frames, mod_icon_btn) {
	
	    /**
	     * Dataset metedata.
	     */
	    var DatasetMetadata = Backbone.Model.extend({});
	
	    /**
	     * A dataset. In Galaxy, datasets are associated with a history, so
	     * this object is also known as a HistoryDatasetAssociation.
	     */
	    var Dataset = Backbone.Model.extend({
	        defaults: {
	            id: '',
	            type: '',
	            name: '',
	            hda_ldda: 'hda',
	            metadata: null
	        },
	
	        initialize: function () {
	            // Metadata can be passed in as a model or a set of attributes; if it's
	            // already a model, there's no need to set metadata.
	            if (!this.get('metadata')) {
	                this._set_metadata();
	            }
	
	            // Update metadata on change.
	            this.on('change', this._set_metadata, this);
	        },
	
	        _set_metadata: function () {
	            var metadata = new DatasetMetadata();
	
	            // Move metadata from dataset attributes to metadata object.
	            _.each(_.keys(this.attributes), function (k) {
	                if (k.indexOf('metadata_') === 0) {
	                    // Found metadata.
	                    var new_key = k.split('metadata_')[1];
	                    metadata.set(new_key, this.attributes[k]);
	                    delete this.attributes[k];
	                }
	            }, this);
	
	            // Because this is an internal change, silence it.
	            this.set('metadata', metadata, { 'silent': true });
	        },
	
	        /**
	         * Returns dataset metadata for a given attribute.
	         */
	        get_metadata: function (attribute) {
	            return this.attributes.metadata.get(attribute);
	        },
	
	        urlRoot: Galaxy.root + "api/datasets"
	    });
	
	    /**
	     * A tabular dataset. This object extends dataset to provide incremental chunked data.
	     */
	    var TabularDataset = Dataset.extend({
	        defaults: _.extend({}, Dataset.prototype.defaults, {
	            chunk_url: null,
	            first_data_chunk: null,
	            offset: 0,
	            at_eof: false
	        }),
	
	        initialize: function (options) {
	            Dataset.prototype.initialize.call(this);
	
	            // If first data chunk is available, next chunk is 1.
	            if (this.attributes.first_data_chunk) {
	                this.attributes.offset = this.attributes.first_data_chunk.offset;
	            }
	            this.attributes.chunk_url = Galaxy.root + 'dataset/display?dataset_id=' + this.id;
	            this.attributes.url_viz = Galaxy.root + 'visualization';
	        },
	
	        /**
	         * Returns a jQuery Deferred object that resolves to the next data chunk or null if at EOF.
	         */
	        get_next_chunk: function () {
	            // If already at end of file, do nothing.
	            if (this.attributes.at_eof) {
	                return null;
	            }
	
	            // Get next chunk.
	            var self = this,
	                next_chunk = $.Deferred();
	            $.getJSON(this.attributes.chunk_url, {
	                offset: self.attributes.offset
	            }).success(function (chunk) {
	                var rval;
	                if (chunk.ck_data !== '') {
	                    // Found chunk.
	                    rval = chunk;
	                    self.attributes.offset = chunk.offset;
	                } else {
	                    // At EOF.
	                    self.attributes.at_eof = true;
	                    rval = null;
	                }
	                next_chunk.resolve(rval);
	            });
	
	            return next_chunk;
	        }
	    });
	
	    var DatasetCollection = Backbone.Collection.extend({
	        model: Dataset
	    });
	
	    /**
	     * Provides a base for table-based, dynamic view of a tabular dataset.
	     * Do not instantiate directly; use either TopLevelTabularDatasetChunkedView
	     * or EmbeddedTabularDatasetChunkedView.
	     */
	    var TabularDatasetChunkedView = Backbone.View.extend({
	
	        /**
	         * Initialize view and, importantly, set a scroll element.
	         */
	        initialize: function (options) {
	            // Row count for rendering.
	            this.row_count = 0;
	            this.loading_chunk = false;
	
	            // load trackster button
	            new TabularButtonTracksterView({
	                model: options.model,
	                $el: this.$el
	            });
	        },
	
	        expand_to_container: function () {
	            if (this.$el.height() < this.scroll_elt.height()) {
	                this.attempt_to_fetch();
	            }
	        },
	
	        attempt_to_fetch: function (func) {
	            var self = this;
	            if (!this.loading_chunk && this.scrolled_to_bottom()) {
	                this.loading_chunk = true;
	                this.loading_indicator.show();
	                $.when(self.model.get_next_chunk()).then(function (result) {
	                    if (result) {
	                        self._renderChunk(result);
	                        self.loading_chunk = false;
	                    }
	                    self.loading_indicator.hide();
	                    self.expand_to_container();
	                });
	            }
	        },
	
	        render: function () {
	            // Add loading indicator.
	            this.loading_indicator = $('<div/>').attr('id', 'loading_indicator');
	            this.$el.append(this.loading_indicator);
	
	            // Add data table and header.
	            var data_table = $('<table/>').attr({
	                id: 'content_table',
	                cellpadding: 0
	            });
	            this.$el.append(data_table);
	            var column_names = this.model.get_metadata('column_names'),
	                header_container = $('<thead/>').appendTo(data_table),
	                header_row = $('<tr/>').appendTo(header_container);
	            if (column_names) {
	                header_row.append('<th>' + column_names.join('</th><th>') + '</th>');
	            } else {
	                for (var j = 1; j <= this.model.get_metadata('columns'); j++) {
	                    header_row.append('<th>' + j + '</th>');
	                }
	            }
	
	            // Render first chunk.
	            var self = this,
	                first_chunk = this.model.get('first_data_chunk');
	            if (first_chunk) {
	                // First chunk is bootstrapped, so render now.
	                this._renderChunk(first_chunk);
	            } else {
	                // No bootstrapping, so get first chunk and then render.
	                $.when(self.model.get_next_chunk()).then(function (result) {
	                    self._renderChunk(result);
	                });
	            }
	
	            // -- Show new chunks during scrolling. --
	
	            // Set up chunk loading when scrolling using the scrolling element.
	            this.scroll_elt.scroll(function () {
	                self.attempt_to_fetch();
	            });
	        },
	
	        /**
	         * Returns true if user has scrolled to the bottom of the view.
	         */
	        scrolled_to_bottom: function () {
	            return false;
	        },
	
	        // -- Helper functions. --
	
	        _renderCell: function (cell_contents, index, colspan) {
	            var $cell = $('<td>').text(cell_contents);
	            var column_types = this.model.get_metadata('column_types');
	            if (colspan !== undefined) {
	                $cell.attr('colspan', colspan).addClass('stringalign');
	            } else if (column_types) {
	                if (index < column_types.length) {
	                    if (column_types[index] === 'str' || column_types[index] === 'list') {
	                        /* Left align all str columns, right align the rest */
	                        $cell.addClass('stringalign');
	                    }
	                }
	            }
	            return $cell;
	        },
	
	        _renderRow: function (line) {
	            // Check length of cells to ensure this is a complete row.
	            var cells = line.split('\t'),
	                row = $('<tr>'),
	                num_columns = this.model.get_metadata('columns');
	
	            if (this.row_count % 2 !== 0) {
	                row.addClass('dark_row');
	            }
	
	            if (cells.length === num_columns) {
	                _.each(cells, function (cell_contents, index) {
	                    row.append(this._renderCell(cell_contents, index));
	                }, this);
	            } else if (cells.length > num_columns) {
	                // SAM file or like format with optional metadata included.
	                _.each(cells.slice(0, num_columns - 1), function (cell_contents, index) {
	                    row.append(this._renderCell(cell_contents, index));
	                }, this);
	                row.append(this._renderCell(cells.slice(num_columns - 1).join('\t'), num_columns - 1));
	            } else if (cells.length === 1) {
	                // Comment line, just return the one cell.
	                row.append(this._renderCell(line, 0, num_columns));
	            } else {
	                // cells.length is greater than one, but less than num_columns.  Render cells and pad tds.
	                // Possibly a SAM file or like format with optional metadata missing.
	                // Could also be a tabular file with a line with missing columns.
	                _.each(cells, function (cell_contents, index) {
	                    row.append(this._renderCell(cell_contents, index));
	                }, this);
	                _.each(_.range(num_columns - cells.length), function () {
	                    row.append($('<td>'));
	                });
	            }
	
	            this.row_count++;
	            return row;
	        },
	
	        _renderChunk: function (chunk) {
	            var data_table = this.$el.find('table');
	            _.each(chunk.ck_data.split('\n'), function (line, index) {
	                if (line !== '') {
	                    data_table.append(this._renderRow(line));
	                }
	            }, this);
	        }
	    });
	
	    /**
	     * Tabular view that is placed at the top level of page. Scrolling occurs
	     * view top-level elements outside of view.
	     */
	    var TopLevelTabularDatasetChunkedView = TabularDatasetChunkedView.extend({
	
	        initialize: function (options) {
	            TabularDatasetChunkedView.prototype.initialize.call(this, options);
	
	            // Scrolling happens in top-level elements.
	            var scroll_elt = _.find(this.$el.parents(), function (p) {
	                return $(p).css('overflow') === 'auto';
	            });
	
	            // If no scrolling element found, use window.
	            if (!scroll_elt) {
	                scroll_elt = window;
	            }
	
	            // Wrap scrolling element for easy access.
	            this.scroll_elt = $(scroll_elt);
	        },
	
	        /**
	         * Returns true if user has scrolled to the bottom of the view.
	         */
	        scrolled_to_bottom: function () {
	            return this.$el.height() - this.scroll_elt.scrollTop() - this.scroll_elt.height() <= 0;
	        }
	
	    });
	
	    /**
	     * Tabular view tnat is embedded in a page. Scrolling occurs in view's el.
	     */
	    var EmbeddedTabularDatasetChunkedView = TabularDatasetChunkedView.extend({
	
	        initialize: function (options) {
	            TabularDatasetChunkedView.prototype.initialize.call(this, options);
	
	            // Because view is embedded, set up div to do scrolling.
	            this.scroll_elt = this.$el.css({
	                position: 'relative',
	                overflow: 'scroll',
	                height: options.height || '500px'
	            });
	        },
	
	        /**
	         * Returns true if user has scrolled to the bottom of the view.
	         */
	        scrolled_to_bottom: function () {
	            return this.$el.scrollTop() + this.$el.innerHeight() >= this.el.scrollHeight;
	        }
	
	    });
	
	    /** Button for trackster visualization */
	    var TabularButtonTracksterView = Backbone.View.extend({
	
	        // gene region columns
	        col: {
	            chrom: null,
	            start: null,
	            end: null
	        },
	
	        // url for trackster
	        url_viz: null,
	
	        // dataset id
	        dataset_id: null,
	
	        // database key
	        genome_build: null,
	
	        // data type
	        file_ext: null,
	
	        // backbone initialize
	        initialize: function (options) {
	            // check if environment is available
	            var Galaxy = parent.Galaxy;
	
	            // link galaxy modal or create one
	            if (Galaxy && Galaxy.modal) {
	                this.modal = Galaxy.modal;
	            }
	
	            // link galaxy frames
	            if (Galaxy && Galaxy.frame) {
	                this.frame = Galaxy.frame;
	            }
	
	            // check
	            if (!this.modal || !this.frame) {
	                return;
	            }
	
	            // model/metadata
	            var model = options.model;
	            var metadata = model.get('metadata');
	
	            // check for datatype
	            if (!model.get('file_ext')) {
	                return;
	            }
	
	            // get data type
	            this.file_ext = model.get('file_ext');
	
	            // check for bed-file format
	            if (this.file_ext == 'bed') {
	                // verify that metadata exists
	                if (metadata.get('chromCol') && metadata.get('startCol') && metadata.get('endCol')) {
	                    // read in columns
	                    this.col.chrom = metadata.get('chromCol') - 1;
	                    this.col.start = metadata.get('startCol') - 1;
	                    this.col.end = metadata.get('endCol') - 1;
	                } else {
	                    console.log('TabularButtonTrackster : Bed-file metadata incomplete.');
	                    return;
	                }
	            }
	
	            // check for vcf-file format
	            if (this.file_ext == 'vcf') {
	                // search array
	                function search(str, array) {
	                    for (var j = 0; j < array.length; j++) if (array[j].match(str)) return j;
	                    return -1;
	                };
	
	                // load
	                this.col.chrom = search('Chrom', metadata.get('column_names'));
	                this.col.start = search('Pos', metadata.get('column_names'));
	                this.col.end = null;
	
	                // verify that metadata exists
	                if (this.col.chrom == -1 || this.col.start == -1) {
	                    console.log('TabularButtonTrackster : VCF-file metadata incomplete.');
	                    return;
	                }
	            }
	
	            // check
	            if (this.col.chrom === undefined) {
	                return;
	            }
	
	            // get dataset id
	            if (model.id) {
	                this.dataset_id = model.id;
	            } else {
	                console.log('TabularButtonTrackster : Dataset identification is missing.');
	                return;
	            }
	
	            // get url
	            if (model.get('url_viz')) {
	                this.url_viz = model.get('url_viz');
	            } else {
	                console.log('TabularButtonTrackster : Url for visualization controller is missing.');
	                return;
	            }
	
	            // get genome_build / database key
	            if (model.get('genome_build')) {
	                this.genome_build = model.get('genome_build');
	            }
	
	            // create the icon
	            var btn_viz = new mod_icon_btn.IconButtonView({
	                model: new mod_icon_btn.IconButton({
	                    title: 'Visualize',
	                    icon_class: 'chart_curve',
	                    id: 'btn_viz'
	                })
	            });
	
	            // set element
	            this.setElement(options.$el);
	
	            // add to element
	            this.$el.append(btn_viz.render().$el);
	
	            // hide the button
	            this.hide();
	        },
	
	        /** Add event handlers */
	        events: {
	            'mouseover tr': 'show',
	            'mouseleave': 'hide'
	        },
	
	        // show button
	        show: function (e) {
	            var self = this;
	
	            // is numeric
	            function is_numeric(n) {
	                return !isNaN(parseFloat(n)) && isFinite(n);
	            };
	
	            // check
	            if (this.col.chrom === null) return;
	
	            // get selected data line
	            var row = $(e.target).parent();
	
	            // verify that location has been found
	            var chrom = row.children().eq(this.col.chrom).html();
	            var start = row.children().eq(this.col.start).html();
	
	            // end is optional
	            var end = this.col.end ? row.children().eq(this.col.end).html() : start;
	
	            // double check location
	            if (!chrom.match("^#") && chrom !== "" && is_numeric(start)) {
	
	                // get target gene region
	                var btn_viz_pars = {
	                    dataset_id: this.dataset_id,
	                    gene_region: chrom + ":" + start + "-" + end
	                };
	
	                // get button position
	                var offset = row.offset();
	                var left = offset.left - 10;
	                var top = offset.top - $(window).scrollTop() + 3;
	
	                // update css
	                $('#btn_viz').css({ 'position': 'fixed', 'top': top + 'px', 'left': left + 'px' });
	                $('#btn_viz').off('click');
	                $('#btn_viz').click(function () {
	                    self.frame.add({
	                        title: 'Trackster',
	                        url: self.url_viz + '/trackster?' + $.param(btn_viz_pars)
	                    });
	                });
	
	                // show the button
	                $('#btn_viz').show();
	            } else {
	                // hide the button
	                $('#btn_viz').hide();
	            }
	        },
	
	        /** hide button */
	        hide: function () {
	            this.$('#btn_viz').hide();
	        }
	    });
	
	    // -- Utility functions. --
	
	    /**
	     * Create a model, attach it to a view, render view, and attach it to a parent element.
	     */
	    var createModelAndView = function (model, view, model_config, parent_elt) {
	        // Create model, view.
	        var a_view = new view({
	            model: new model(model_config)
	        });
	
	        // Render view and add to parent element.
	        a_view.render();
	        if (parent_elt) {
	            parent_elt.append(a_view.$el);
	        }
	
	        return a_view;
	    };
	
	    /**
	     * Create a tabular dataset chunked view (and requisite tabular dataset model)
	     * and appends to parent_elt.
	     */
	    var createTabularDatasetChunkedView = function (options) {
	        // If no model, create and set model from dataset config.
	        if (!options.model) {
	            options.model = new TabularDataset(options.dataset_config);
	        }
	
	        var parent_elt = options.parent_elt;
	        var embedded = options.embedded;
	
	        // Clean up options so that only needed options are passed to view.
	        delete options.embedded;
	        delete options.parent_elt;
	        delete options.dataset_config;
	
	        // Create and set up view.
	        var view = embedded ? new EmbeddedTabularDatasetChunkedView(options) : new TopLevelTabularDatasetChunkedView(options);
	        view.render();
	
	        if (parent_elt) {
	            parent_elt.append(view.$el);
	            // If we're sticking this in another element, once it's appended check
	            // to make sure we've filled enough space.
	            // Without this, the scroll elements don't work.
	            view.expand_to_container();
	        }
	
	        return view;
	    };
	
	    return {
	        Dataset: Dataset,
	        TabularDataset: TabularDataset,
	        DatasetCollection: DatasetCollection,
	        TabularDatasetChunkedView: TabularDatasetChunkedView,
	        createTabularDatasetChunkedView: createTabularDatasetChunkedView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	    //==============================================================================
	    /** Map of possible HDA/collection/job states to their string equivalents.
	     *      A port of galaxy.model.Dataset.states.
	     */
	
	    var STATES = {
	        // NOT ready states
	        /** is uploading and not ready */
	        UPLOAD: 'upload',
	        /** the job that will produce the dataset queued in the runner */
	        QUEUED: 'queued',
	        /** the job that will produce the dataset is running */
	        RUNNING: 'running',
	        /** metadata for the dataset is being discovered/set */
	        SETTING_METADATA: 'setting_metadata',
	
	        // ready states
	        /** was created without a tool */
	        NEW: 'new',
	        /** has no data */
	        EMPTY: 'empty',
	        /** has successfully completed running */
	        OK: 'ok',
	
	        /** the job that will produce the dataset paused */
	        PAUSED: 'paused',
	        /** metadata discovery/setting failed or errored (but otherwise ok) */
	        FAILED_METADATA: 'failed_metadata',
	        //TODO: not in trans.app.model.Dataset.states - is in database
	        /** not accessible to the current user (i.e. due to permissions) */
	        NOT_VIEWABLE: 'noPermission',
	        /** deleted while uploading */
	        DISCARDED: 'discarded',
	        /** the tool producing this dataset failed */
	        ERROR: 'error'
	    };
	
	    STATES.READY_STATES = [STATES.OK, STATES.EMPTY, STATES.PAUSED, STATES.FAILED_METADATA, STATES.NOT_VIEWABLE, STATES.DISCARDED, STATES.ERROR];
	
	    STATES.NOT_READY_STATES = [STATES.UPLOAD, STATES.QUEUED, STATES.RUNNING, STATES.SETTING_METADATA, STATES.NEW];
	
	    //==============================================================================
	    return STATES;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    //jquery
	    //backbone
	], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    // =============================================================================
	    /**
	     * view for a popup menu
	     */
	    var PopupMenu = Backbone.View.extend({
	        //TODO: maybe better as singleton off the Galaxy obj
	        /** Cache the desired button element and options, set up the button click handler
	         *  NOTE: attaches this view as HTML/jQ data on the button for later use.
	         */
	        initialize: function ($button, options) {
	            // default settings
	            this.$button = $button;
	            if (!this.$button.length) {
	                this.$button = $('<div/>');
	            }
	            this.options = options || [];
	            this.$button.data('popupmenu', this);
	
	            // set up button click -> open menu behavior
	            var menu = this;
	            this.$button.click(function (event) {
	                // if there's already a menu open, remove it
	                $('.popmenu-wrapper').remove();
	                menu._renderAndShow(event);
	                return false;
	            });
	        },
	
	        // render the menu, append to the page body at the click position, and set up the 'click-away' handlers, show
	        _renderAndShow: function (clickEvent) {
	            this.render();
	            this.$el.appendTo('body').css(this._getShownPosition(clickEvent)).show();
	            this._setUpCloseBehavior();
	        },
	
	        // render the menu
	        // this menu doesn't attach itself to the DOM ( see _renderAndShow )
	        render: function () {
	            // render the menu body absolute and hidden, fill with template
	            this.$el.addClass('popmenu-wrapper').hide().css({ position: 'absolute' }).html(this.template(this.$button.attr('id'), this.options));
	
	            // set up behavior on each link/anchor elem
	            if (this.options.length) {
	                var menu = this;
	                //precondition: there should be one option per li
	                this.$el.find('li').each(function (i, li) {
	                    var option = menu.options[i];
	
	                    // if the option has 'func', call that function when the anchor is clicked
	                    if (option.func) {
	                        $(this).children('a.popupmenu-option').click(function (event) {
	                            option.func.call(menu, event, option);
	                            // We must preventDefault otherwise clicking "cancel"
	                            // on a purge or something still navigates and causes
	                            // the action.
	                            event.preventDefault();
	                            // bubble up so that an option click will call the close behavior
	                        });
	                    }
	                });
	            }
	            return this;
	        },
	
	        template: function (id, options) {
	            return ['<ul id="', id, '-menu" class="dropdown-menu">', this._templateOptions(options), '</ul>'].join('');
	        },
	
	        _templateOptions: function (options) {
	            if (!options.length) {
	                return '<li>(no options)</li>';
	            }
	            return _.map(options, function (option) {
	                if (option.divider) {
	                    return '<li class="divider"></li>';
	                } else if (option.header) {
	                    return ['<li class="head"><a href="javascript:void(0);">', option.html, '</a></li>'].join('');
	                }
	                var href = option.href || 'javascript:void(0);',
	                    target = option.target ? ' target="' + option.target + '"' : '',
	                    check = option.checked ? '<span class="fa fa-check"></span>' : '';
	                return ['<li><a class="popupmenu-option" href="', href, '"', target, '>', check, option.html, '</a></li>'].join('');
	            }).join('');
	        },
	
	        // get the absolute position/offset for the menu
	        _getShownPosition: function (clickEvent) {
	
	            // display menu horiz. centered on click...
	            var menuWidth = this.$el.width();
	            var x = clickEvent.pageX - menuWidth / 2;
	
	            // adjust to handle horiz. scroll and window dimensions ( draw entirely on visible screen area )
	            x = Math.min(x, $(document).scrollLeft() + $(window).width() - menuWidth - 5);
	            x = Math.max(x, $(document).scrollLeft() + 5);
	            return {
	                top: clickEvent.pageY,
	                left: x
	            };
	        },
	
	        // bind an event handler to all available frames so that when anything is clicked
	        // the menu is removed from the DOM and the event handler unbinds itself
	        _setUpCloseBehavior: function () {
	            var menu = this;
	            //TODO: alternately: focus hack, blocking overlay, jquery.blockui
	
	            // function to close popup and unbind itself
	            function closePopup(event) {
	                $(document).off('click.close_popup');
	                if (window && window.parent !== window) {
	                    try {
	                        $(window.parent.document).off("click.close_popup");
	                    } catch (err) {}
	                } else {
	                    try {
	                        $('iframe#galaxy_main').contents().off("click.close_popup");
	                    } catch (err) {}
	                }
	                menu.remove();
	            }
	
	            $('html').one("click.close_popup", closePopup);
	            if (window && window.parent !== window) {
	                try {
	                    $(window.parent.document).find('html').one("click.close_popup", closePopup);
	                } catch (err) {}
	            } else {
	                try {
	                    $('iframe#galaxy_main').contents().one("click.close_popup", closePopup);
	                } catch (err) {}
	            }
	        },
	
	        // add a menu option/item at the given index
	        addItem: function (item, index) {
	            // append to end if no index
	            index = index >= 0 ? index : this.options.length;
	            this.options.splice(index, 0, item);
	            return this;
	        },
	
	        // remove a menu option/item at the given index
	        removeItem: function (index) {
	            if (index >= 0) {
	                this.options.splice(index, 1);
	            }
	            return this;
	        },
	
	        // search for a menu option by its html
	        findIndexByHtml: function (html) {
	            for (var i = 0; i < this.options.length; i++) {
	                if (_.has(this.options[i], 'html') && this.options[i].html === html) {
	                    return i;
	                }
	            }
	            return null;
	        },
	
	        // search for a menu option by its html
	        findItemByHtml: function (html) {
	            return this.options[this.findIndexByHtml(html)];
	        },
	
	        // string representation
	        toString: function () {
	            return 'PopupMenu';
	        }
	    });
	    /** shortcut to new for when you don't need to preserve the ref */
	    PopupMenu.create = function _create($button, options) {
	        return new PopupMenu($button, options);
	    };
	
	    // -----------------------------------------------------------------------------
	    // the following class functions are bridges from the original make_popupmenu and make_popup_menus
	    // to the newer backbone.js PopupMenu
	
	    /** Create a PopupMenu from simple map initial_options activated by clicking button_element.
	     *      Converts initial_options to object array used by PopupMenu.
	     *  @param {jQuery|DOMElement} button_element element which, when clicked, activates menu
	     *  @param {Object} initial_options map of key -> values, where
	     *      key is option text, value is fn to call when option is clicked
	     *  @returns {PopupMenu} the PopupMenu created
	     */
	    PopupMenu.make_popupmenu = function (button_element, initial_options) {
	        var convertedOptions = [];
	        _.each(initial_options, function (optionVal, optionKey) {
	            var newOption = { html: optionKey };
	
	            // keys with null values indicate: header
	            if (optionVal === null) {
	                // !optionVal? (null only?)
	                newOption.header = true;
	
	                // keys with function values indicate: a menu option
	            } else if (jQuery.type(optionVal) === 'function') {
	                newOption.func = optionVal;
	            }
	            //TODO:?? any other special optionVals?
	            // there was no divider option originally
	            convertedOptions.push(newOption);
	        });
	        return new PopupMenu($(button_element), convertedOptions);
	    };
	
	    /** Find all anchors in $parent (using selector) and covert anchors into a PopupMenu options map.
	     *  @param {jQuery} $parent the element that contains the links to convert to options
	     *  @param {String} selector jq selector string to find links
	     *  @returns {Object[]} the options array to initialize a PopupMenu
	     */
	    //TODO: lose parent and selector, pass in array of links, use map to return options
	    PopupMenu.convertLinksToOptions = function ($parent, selector) {
	        $parent = $($parent);
	        selector = selector || 'a';
	        var options = [];
	        $parent.find(selector).each(function (elem, i) {
	            var option = {},
	                $link = $(elem);
	
	            // convert link text to the option text (html) and the href into the option func
	            option.html = $link.text();
	            if ($link.attr('href')) {
	                var linkHref = $link.attr('href'),
	                    linkTarget = $link.attr('target'),
	                    confirmText = $link.attr('confirm');
	
	                option.func = function () {
	                    // if there's a "confirm" attribute, throw up a confirmation dialog, and
	                    //  if the user cancels - do nothing
	                    if (confirmText && !confirm(confirmText)) {
	                        return;
	                    }
	
	                    // if there's no confirm attribute, or the user accepted the confirm dialog:
	                    switch (linkTarget) {
	                        // relocate the center panel
	                        case '_parent':
	                            window.parent.location = linkHref;
	                            break;
	
	                        // relocate the entire window
	                        case '_top':
	                            window.top.location = linkHref;
	                            break;
	
	                        // relocate this panel
	                        default:
	                            window.location = linkHref;
	                    }
	                };
	            }
	            options.push(option);
	        });
	        return options;
	    };
	
	    /** Create a single popupmenu from existing DOM button and anchor elements
	     *  @param {jQuery} $buttonElement the element that when clicked will open the menu
	     *  @param {jQuery} $menuElement the element that contains the anchors to convert into a menu
	     *  @param {String} menuElementLinkSelector jq selector string used to find anchors to be made into menu options
	     *  @returns {PopupMenu} the PopupMenu (Backbone View) that can render, control the menu
	     */
	    PopupMenu.fromExistingDom = function ($buttonElement, $menuElement, menuElementLinkSelector) {
	        $buttonElement = $($buttonElement);
	        $menuElement = $($menuElement);
	        var options = PopupMenu.convertLinksToOptions($menuElement, menuElementLinkSelector);
	        // we're done with the menu (having converted it to an options map)
	        $menuElement.remove();
	        return new PopupMenu($buttonElement, options);
	    };
	
	    /** Create all popupmenus within a document or a more specific element
	     *  @param {DOMElement} parent the DOM element in which to search for popupmenus to build (defaults to document)
	     *  @param {String} menuSelector jq selector string to find popupmenu menu elements (defaults to "div[popupmenu]")
	     *  @param {Function} buttonSelectorBuildFn the function to build the jq button selector.
	     *      Will be passed $menuElement, parent.
	     *      (Defaults to return '#' + $menuElement.attr( 'popupmenu' ); )
	     *  @returns {PopupMenu[]} array of popupmenus created
	     */
	    PopupMenu.make_popup_menus = function (parent, menuSelector, buttonSelectorBuildFn) {
	        parent = parent || document;
	        // orig. Glx popupmenu menus have a (non-std) attribute 'popupmenu'
	        //  which contains the id of the button that activates the menu
	        menuSelector = menuSelector || 'div[popupmenu]';
	        // default to (orig. Glx) matching button to menu by using the popupmenu attr of the menu as the id of the button
	        buttonSelectorBuildFn = buttonSelectorBuildFn || function ($menuElement, parent) {
	            return '#' + $menuElement.attr('popupmenu');
	        };
	
	        // aggregate and return all PopupMenus
	        var popupMenusCreated = [];
	        $(parent).find(menuSelector).each(function () {
	            var $menuElement = $(this),
	                $buttonElement = $(parent).find(buttonSelectorBuildFn($menuElement, parent));
	            popupMenusCreated.push(PopupMenu.fromDom($buttonElement, $menuElement));
	            $buttonElement.addClass('popup');
	        });
	        return popupMenusCreated;
	    };
	
	    // =============================================================================
	    return PopupMenu;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/* This class maps the form dom to an api compatible javascript dictionary. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    var Manager = Backbone.Model.extend({
	        initialize: function (app) {
	            this.app = app;
	        },
	
	        /** Creates a checksum. */
	        checksum: function () {
	            var sum = '';
	            var self = this;
	            this.app.section.$el.find('.section-row').each(function () {
	                var id = $(this).attr('id');
	                var field = self.app.field_list[id];
	                if (field) {
	                    sum += id + ':' + JSON.stringify(field.value && field.value()) + ':' + field.collapsed + ';';
	                }
	            });
	            return sum;
	        },
	
	        /** Convert dom into a dictionary of flat id/value pairs used e.g. on job submission. */
	        create: function () {
	            var self = this;
	
	            // get raw dictionary from dom
	            var dict = {};
	            this._iterate(this.app.section.$el, dict);
	
	            // add to result dictionary, label elements
	            var result_dict = {};
	            this.flat_dict = {};
	            function add(flat_id, input_id, input_value) {
	                self.flat_dict[flat_id] = input_id;
	                result_dict[flat_id] = input_value;
	                self.app.element_list[input_id] && self.app.element_list[input_id].$el.attr('tour_id', flat_id);
	            }
	            // converter between raw dictionary and job dictionary
	            function convert(identifier, head) {
	                for (var index in head) {
	                    var node = head[index];
	                    if (node.input) {
	                        var input = node.input;
	                        var flat_id = identifier;
	                        if (identifier != '') {
	                            flat_id += '|';
	                        }
	                        flat_id += input.name;
	                        switch (input.type) {
	                            case 'repeat':
	                                var section_label = 'section-';
	                                var block_indices = [];
	                                var block_prefix = null;
	                                for (var block_label in node) {
	                                    var pos = block_label.indexOf(section_label);
	                                    if (pos != -1) {
	                                        pos += section_label.length;
	                                        block_indices.push(parseInt(block_label.substr(pos)));
	                                        if (!block_prefix) {
	                                            block_prefix = block_label.substr(0, pos);
	                                        }
	                                    }
	                                }
	                                block_indices.sort(function (a, b) {
	                                    return a - b;
	                                });
	                                var index = 0;
	                                for (var i in block_indices) {
	                                    convert(flat_id + '_' + index++, node[block_prefix + block_indices[i]]);
	                                }
	                                break;
	                            case 'conditional':
	                                var value = self.app.field_list[input.id].value();
	                                add(flat_id + '|' + input.test_param.name, input.id, value);
	                                var selectedCase = matchCase(input, value);
	                                if (selectedCase != -1) {
	                                    convert(flat_id, head[input.id + '-section-' + selectedCase]);
	                                }
	                                break;
	                            case 'section':
	                                convert(!input.flat && flat_id || '', node);
	                                break;
	                            default:
	                                var field = self.app.field_list[input.id];
	                                if (field && field.value) {
	                                    var value = field.value();
	                                    if (input.ignore === undefined || input.ignore != value) {
	                                        if (field.collapsed && input.collapsible_value) {
	                                            value = input.collapsible_value;
	                                        }
	                                        add(flat_id, input.id, value);
	                                        if (input.payload) {
	                                            for (var p_id in input.payload) {
	                                                add(p_id, input.id, input.payload[p_id]);
	                                            }
	                                        }
	                                    }
	                                }
	                        }
	                    }
	                }
	            }
	            convert('', dict);
	            return result_dict;
	        },
	
	        /** Matches flat ids to corresponding input element
	         * @param{string} flat_id - Flat input id to be looked up.
	         */
	        match: function (flat_id) {
	            return this.flat_dict && this.flat_dict[flat_id];
	        },
	
	        /** Match conditional values to selected cases
	        */
	        matchCase: function (input, value) {
	            return matchCase(input, value);
	        },
	
	        /** Matches a new tool model to the current input elements e.g. used to update dynamic options
	        */
	        matchModel: function (model, callback) {
	            var self = this;
	            visitInputs(model.inputs, function (input, name) {
	                self.flat_dict[name] && callback(input, self.flat_dict[name]);
	            });
	        },
	
	        /** Matches identifier from api response to input elements e.g. used to display validation errors
	        */
	        matchResponse: function (response) {
	            var result = {};
	            var self = this;
	            function search(id, head) {
	                if (typeof head === 'string') {
	                    var input_id = self.flat_dict[id];
	                    input_id && (result[input_id] = head);
	                } else {
	                    for (var i in head) {
	                        var new_id = i;
	                        if (id !== '') {
	                            var separator = '|';
	                            if (head instanceof Array) {
	                                separator = '_';
	                            }
	                            new_id = id + separator + new_id;
	                        }
	                        search(new_id, head[i]);
	                    }
	                }
	            }
	            search('', response);
	            return result;
	        },
	
	        /** Map dom tree to dictionary tree with input elements.
	        */
	        _iterate: function (parent, dict) {
	            var self = this;
	            var children = $(parent).children();
	            children.each(function () {
	                var child = this;
	                var id = $(child).attr('id');
	                if ($(child).hasClass('section-row')) {
	                    var input = self.app.input_list[id];
	                    dict[id] = input && { input: input } || {};
	                    self._iterate(child, dict[id]);
	                } else {
	                    self._iterate(child, dict);
	                }
	            });
	        }
	    });
	
	    /** Match conditional values to selected cases
	     * @param{dict}   input     - Definition of conditional input parameter
	     * @param{dict}   value     - Current value
	     */
	    var matchCase = function (input, value) {
	        if (input.test_param.type == 'boolean') {
	            if (value == 'true') {
	                value = input.test_param.truevalue || 'true';
	            } else {
	                value = input.test_param.falsevalue || 'false';
	            }
	        }
	        for (var i in input.cases) {
	            if (input.cases[i].value == value) {
	                return i;
	            }
	        }
	        return -1;
	    };
	
	    /** Visits tool inputs
	     * @param{dict}   inputs    - Nested dictionary of input elements
	     * @param{dict}   callback  - Called with the mapped dictionary object and corresponding model node
	     */
	    var visitInputs = function (inputs, callback, prefix, context) {
	        context = $.extend(true, {}, context);
	        _.each(inputs, function (input) {
	            if (input && input.type && input.name) {
	                context[input.name] = input;
	            }
	        });
	        for (var key in inputs) {
	            var node = inputs[key];
	            node.name = node.name || key;
	            var name = prefix ? prefix + '|' + node.name : node.name;
	            switch (node.type) {
	                case 'repeat':
	                    _.each(node.cache, function (cache, j) {
	                        visitInputs(cache, callback, name + '_' + j, context);
	                    });
	                    break;
	                case 'conditional':
	                    if (node.test_param) {
	                        callback(node.test_param, name + '|' + node.test_param.name, context);
	                        var selectedCase = matchCase(node, node.test_param.value);
	                        if (selectedCase != -1) {
	                            visitInputs(node.cases[selectedCase].inputs, callback, name, context);
	                        } else {
	                            Galaxy.emit.debug('form-data::visitInputs() - Invalid case for ' + name + '.');
	                        }
	                    } else {
	                        Galaxy.emit.debug('form-data::visitInputs() - Conditional test parameter missing for ' + name + '.');
	                    }
	                    break;
	                case 'section':
	                    visitInputs(node.inputs, callback, name, context);
	                    break;
	                default:
	                    callback(node, name, context);
	            }
	        }
	    };
	
	    return {
	        Manager: Manager,
	        visitInputs: visitInputs
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    //jquery
	    //backbone
	], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    //=============================================================================
	    /**
	     * backbone model for icon buttons
	     */
	    var IconButton = Backbone.Model.extend({
	        defaults: {
	            title: "",
	            icon_class: "",
	            on_click: null,
	            menu_options: null,
	            is_menu_button: true,
	            id: null,
	            href: null,
	            target: null,
	            enabled: true,
	            visible: true,
	            tooltip_config: {}
	        }
	    });
	
	    /**
	     *  backbone view for icon buttons
	     */
	    var IconButtonView = Backbone.View.extend({
	
	        initialize: function () {
	            // better rendering this way
	            this.model.attributes.tooltip_config = { placement: 'bottom' };
	            this.model.bind('change', this.render, this);
	        },
	
	        render: function () {
	            // hide tooltip
	            this.$el.tooltip('hide');
	
	            var new_elem = this.template(this.model.toJSON());
	            // configure tooltip
	            new_elem.tooltip(this.model.get('tooltip_config'));
	            this.$el.replaceWith(new_elem);
	            this.setElement(new_elem);
	            return this;
	        },
	
	        events: {
	            'click': 'click'
	        },
	
	        click: function (event) {
	            // if on_click pass to that function
	            if (_.isFunction(this.model.get('on_click'))) {
	                this.model.get('on_click')(event);
	                return false;
	            }
	            // otherwise, bubble up ( to href or whatever )
	            return true;
	        },
	
	        // generate html element
	        template: function (options) {
	            var buffer = 'title="' + options.title + '" class="icon-button';
	
	            if (options.is_menu_button) {
	                buffer += ' menu-button';
	            }
	
	            buffer += ' ' + options.icon_class;
	
	            if (!options.enabled) {
	                buffer += '_disabled';
	            }
	
	            // close class tag
	            buffer += '"';
	
	            if (options.id) {
	                buffer += ' id="' + options.id + '"';
	            }
	
	            buffer += ' href="' + options.href + '"';
	            // add target for href
	            if (options.target) {
	                buffer += ' target="' + options.target + '"';
	            }
	            // set visibility
	            if (!options.visible) {
	                buffer += ' style="display: none;"';
	            }
	
	            // enabled/disabled
	            if (options.enabled) {
	                buffer = '<a ' + buffer + '/>';
	            } else {
	                buffer = '<span ' + buffer + '/>';
	            }
	
	            // return element
	            return $(buffer);
	        }
	    });
	
	    // define collection
	    var IconButtonCollection = Backbone.Collection.extend({
	        model: IconButton
	    });
	
	    /**
	     * menu with multiple icon buttons
	     * views are not needed nor used for individual buttons
	     */
	    var IconButtonMenuView = Backbone.View.extend({
	
	        tagName: 'div',
	
	        initialize: function () {
	            this.render();
	        },
	
	        render: function () {
	            // initialize icon buttons
	            var self = this;
	            this.collection.each(function (button) {
	                // create and add icon button to menu
	                var elt = $('<a/>').attr('href', 'javascript:void(0)').attr('title', button.attributes.title).addClass('icon-button menu-button').addClass(button.attributes.icon_class).appendTo(self.$el).click(button.attributes.on_click);
	
	                // configure tooltip
	                if (button.attributes.tooltip_config) {
	                    elt.tooltip(button.attributes.tooltip_config);
	                }
	
	                // add popup menu to icon
	                var menu_options = button.get('options');
	                if (menu_options) {
	                    make_popupmenu(elt, menu_options);
	                }
	            });
	
	            // return
	            return this;
	        }
	    });
	
	    /**
	     * Returns an IconButtonMenuView for the provided configuration.
	     * Configuration is a list of dictionaries where each dictionary
	     * defines an icon button. Each dictionary must have the following
	     * elements: icon_class, title, and on_click.
	     */
	    var create_icon_buttons_menu = function (config, global_config) {
	        // initialize global configuration
	        if (!global_config) global_config = {};
	
	        // create and initialize menu
	        var buttons = new IconButtonCollection(_.map(config, function (button_config) {
	            return new IconButton(_.extend(button_config, global_config));
	        }));
	
	        // return menu
	        return new IconButtonMenuView({ collection: buttons });
	    };
	
	    //=============================================================================
	    return {
	        IconButton: IconButton,
	        IconButtonView: IconButtonView,
	        IconButtonCollection: IconButtonCollection,
	        IconButtonMenuView: IconButtonMenuView,
	        create_icon_buttons_menu: create_icon_buttons_menu
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/**
	 * Popover wrapper
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    var View = Backbone.View.extend({
	        optionsDefault: {
	            with_close: true,
	            title: null,
	            placement: 'top',
	            container: 'body',
	            body: null
	        },
	
	        initialize: function (options) {
	            this.setElement(this._template());
	            this.uid = Utils.uid();
	            this.options = _.defaults(options || {}, this.optionsDefault);
	            this.options.container.parent().append(this.el);
	            this.$title = this.$('.popover-title-label');
	            this.$close = this.$('.popover-close');
	            this.$body = this.$('.popover-content');
	
	            // add initial content
	            this.options.body && this.append(this.options.body);
	
	            // add event to hide if click is outside of popup and not on container
	            var self = this;
	            $('body').on('mousedown.' + this.uid, function (e) {
	                // the 'is' for buttons that trigger popups
	                // the 'has' for icons within a button that triggers a popup
	                self.visible && !$(self.options.container).is(e.target) && !$(self.el).is(e.target) && $(self.el).has(e.target).length === 0 && self.hide();
	            });
	        },
	
	        /**
	         * Render popover
	        */
	        render: function () {
	            this.$title.html(this.options.title);
	            this.$el.removeClass().addClass('ui-popover popover fade in').addClass(this.options.placement);
	            this.$el.css(this._get_placement(this.options.placement));
	
	            // configure close option
	            var self = this;
	            if (this.options.with_close) {
	                this.$close.on('click', function () {
	                    self.hide();
	                }).show();
	            } else {
	                this.$close.off().hide();
	            }
	        },
	
	        /**
	         * Set the popover title
	         * @params{ String }    newTitle    - New popover title
	        */
	        title: function (newTitle) {
	            if (newTitle !== undefined) {
	                this.options.title = newTitle;
	                this.$title.html(newTitle);
	            }
	        },
	
	        /**
	         * Show popover
	        */
	        show: function () {
	            this.render();
	            this.$el.show();
	            this.visible = true;
	        },
	
	        /**
	         * Hide popover
	        */
	        hide: function () {
	            this.$el.hide();
	            this.visible = false;
	        },
	
	        /**
	         * Append new content to the popover
	         * @params{ Object }  $el - Dom element
	        */
	        append: function ($el) {
	            this.$body.append($el);
	        },
	
	        /**
	         * Remove all content
	        */
	        empty: function () {
	            this.$body.empty();
	        },
	
	        /**
	         * Remove popover
	        */
	        remove: function () {
	            $('body').off('mousedown.' + this.uid);
	            this.$el.remove();
	        },
	
	        /**
	         * Improve popover location/placement
	        */
	        _get_placement: function (placement) {
	            // get popover dimensions
	            var width = this._get_width(this.$el);
	            var height = this.$el.height();
	
	            // get container details
	            var $container = this.options.container;
	            var container_width = this._get_width($container);
	            var container_height = this._get_height($container);
	            var container_position = $container.position();
	
	            // get position
	            var top, left;
	            top = left = 0;
	            if (['top', 'bottom'].indexOf(placement) != -1) {
	                left = container_position.left - width + (container_width + width) / 2;
	                switch (placement) {
	                    case 'top':
	                        top = container_position.top - height - 5;
	                        break;
	                    case 'bottom':
	                        top = container_position.top + container_height + 5;
	                        break;
	                }
	            } else {
	                top = container_position.top - height + (container_height + height) / 2;
	                switch (placement) {
	                    case 'right':
	                        left = container_position.left + container_width;
	                        break;
	                }
	            }
	            return { top: top, left: left };
	        },
	
	        /**
	         * Returns padding/margin corrected width
	        */
	        _get_width: function ($el) {
	            return $el.width() + parseInt($el.css('padding-left')) + parseInt($el.css('margin-left')) + parseInt($el.css('padding-right')) + parseInt($el.css('margin-right'));
	        },
	
	        /**
	         * Returns padding corrected height
	        */
	        _get_height: function ($el) {
	            return $el.height() + parseInt($el.css('padding-top')) + parseInt($el.css('padding-bottom'));
	        },
	
	        /**
	         * Return the popover template
	        */
	        _template: function (options) {
	            return '<div class="ui-popover popover fade in">' + '<div class="arrow"/>' + '<div class="popover-title">' + '<div class="popover-title-label"/>' + '<div class="popover-close fa fa-times-circle"/>' + '</div>' + '<div class="popover-content"/>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	
	    /**
	     * A plugin for initializing select2 input items.
	     * Make sure the select2 library itself is loaded beforehand.
	     * Also the element to which select2 will be appended has to 
	     * be created before select2 initialization (and passed as option).
	     */
	    var View = Backbone.View.extend({
	        // options
	        optionsDefault: {
	            css: '',
	            placeholder: 'No data available',
	            data: [],
	            value: null,
	            multiple: false,
	            minimumInputLength: 0,
	            // example format of initial data: "id:name,55:anotherrole@role.com,27:role@role.com"
	            initialData: ''
	        },
	
	        // initialize
	        initialize: function (options) {
	            // configure options
	            this.options = Utils.merge(options, this.optionsDefault);
	
	            // create new element
	            this.setElement(this._template(this.options));
	
	            // check if container exists
	            if (!this.options.container) {
	                console.log('ui-select::initialize() : container not specified.');
	                return;
	            }
	
	            // add to dom
	            this.options.container.append(this.$el);
	
	            // link selection dictionary
	            this.select_data = this.options.data;
	
	            // refresh
	            this._refresh();
	
	            if (!this.options.multiple) {
	                // initial value
	                if (this.options.value) {
	                    this._setValue(this.options.value);
	                }
	
	                // add change event
	                var self = this;
	                if (this.options.onchange) {
	                    this.$el.on('change', function () {
	                        self.options.onchange(self.value());
	                    });
	                }
	            }
	        },
	
	        // value
	        value: function (new_value) {
	            // get current id/value
	            var before = this._getValue();
	
	            // check if new_value is defined
	            if (new_value !== undefined) {
	                this._setValue(new_value);
	            }
	
	            // get current id/value
	            var after = this._getValue();
	
	            // fire onchange
	            if (after != before && this.options.onchange) {
	                this.options.onchange(after);
	            }
	
	            // return current value
	            return after;
	        },
	
	        // label
	        text: function () {
	            return this.$el.select2('data').text;
	        },
	
	        // disabled
	        disabled: function () {
	            return !this.$el.select2('enable');
	        },
	
	        // enable
	        enable: function () {
	            this.$el.select2('enable', true);
	        },
	
	        // disable
	        disable: function () {
	            this.$el.select2('enable', false);
	        },
	
	        // add
	        add: function (options) {
	            // add options
	            this.select_data.push({
	                id: options.id,
	                text: options.text
	            });
	
	            // refresh
	            this._refresh();
	        },
	
	        // remove
	        del: function (id) {
	            // search option
	            var index = this._getIndex(id);
	
	            // check if found
	            if (index != -1) {
	                // remove options
	                this.select_data.splice(index, 1);
	
	                // refresh
	                this._refresh();
	            }
	        },
	
	        // remove
	        remove: function () {
	            this.$el.select2('destroy');
	        },
	
	        // update
	        update: function (options) {
	            // copy options
	            this.select_data = [];
	            for (var key in options.data) {
	                this.select_data.push(options.data[key]);
	            }
	
	            // refresh
	            this._refresh();
	        },
	
	        // refresh
	        _refresh: function () {
	            // add select2 data based on type of input
	            if (!this.options.multiple) {
	                var selected = this._getValue();
	                var select_opt = {
	                    data: this.select_data,
	                    containerCssClass: this.options.css,
	                    placeholder: this.options.placeholder,
	                    dropdownAutoWidth: true
	                };
	                this.$el.select2(select_opt);
	                // select previous value (if exists)
	                this._setValue(selected);
	            } else {
	                var select_opt = {
	                    multiple: this.options.multiple,
	                    containerCssClass: this.options.css,
	                    placeholder: this.options.placeholder,
	                    minimumInputLength: this.options.minimumInputLength,
	                    ajax: this.options.ajax,
	                    dropdownCssClass: this.options.dropdownCssClass,
	                    escapeMarkup: this.options.escapeMarkup,
	                    formatResult: this.options.formatResult,
	                    formatSelection: this.options.formatSelection,
	                    initSelection: this.options.initSelection,
	                    initialData: this.options.initialData
	                };
	                this.$el.select2(select_opt);
	            }
	        },
	
	        // get index
	        _getIndex: function (value) {
	            // returns the index of the searched value
	            _.findIndex(this.select_data, { id: value });
	        },
	
	        // get value
	        _getValue: function () {
	            return this.$el.select2('val');
	        },
	
	        // set value
	        _setValue: function (new_value) {
	            var index = this._getIndex(new_value);
	            if (index == -1) {
	                if (this.select_data.length > 0) {
	                    new_value = this.select_data[0].id;
	                }
	            }
	            this.$el.select2('val', new_value);
	        },
	
	        // element
	        _template: function (options) {
	            return '<input type="hidden" value="' + this.options.initialData + '"/>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** This class creates a ui table element. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            this.options = Utils.merge(options, {
	                content: 'No content available.',
	                onchange: null,
	                ondblclick: null,
	                onconfirm: null,
	                cls: 'ui-table',
	                selectable: true,
	                cls_tr: ''
	            });
	            this.setElement(this._template());
	            this.$thead = this.$('thead');
	            this.$tbody = this.$('tbody');
	            this.$tmessage = this.$('tmessage');
	            this.row = this._row();
	            this.row_count = 0;
	        },
	
	        events: {
	            'click': '_onclick',
	            'dblclick': '_ondblclick'
	        },
	
	        /** Add cell to header row */
	        addHeader: function ($el) {
	            this.row.append($('<th/>').append($el));
	        },
	
	        /** Append header row to table */
	        appendHeader: function () {
	            this.$thead.append(this.row);
	            this.row = $('<tr/>');
	        },
	
	        /** Add cell to row */
	        add: function ($el, width, align) {
	            var wrapper = $('<td/>');
	            if (width) {
	                wrapper.css('width', width);
	            }
	            if (align) {
	                wrapper.css('text-align', align);
	            }
	            this.row.append(wrapper.append($el));
	        },
	
	        /** Append row to table */
	        append: function (id, fade) {
	            this._commit(id, fade, false);
	        },
	
	        /** Prepend row to table */
	        prepend: function (id, fade) {
	            this._commit(id, fade, true);
	        },
	
	        /** Helper to get row element */
	        get: function (id) {
	            return this.$('#' + id);
	        },
	
	        /** Delete row by id */
	        del: function (id) {
	            var item = this.$tbody.find('#' + id);
	            if (item.length > 0) {
	                item.remove();
	                this.row_count--;
	                this._refresh();
	            }
	        },
	
	        /** Delete all rows */
	        delAll: function () {
	            this.$tbody.empty();
	            this.row_count = 0;
	            this._refresh();
	        },
	
	        /** Set a value i.e. selects/highlights a particular row by id */
	        value: function (new_value) {
	            if (this.options.selectable) {
	                this.before = this.$tbody.find('.current').attr('id');
	                if (new_value !== undefined) {
	                    this.$tbody.find('tr').removeClass('current');
	                    if (new_value) {
	                        this.$tbody.find('#' + new_value).addClass('current');
	                    }
	                }
	                var after = this.$tbody.find('.current').attr('id');
	                if (after === undefined) {
	                    return null;
	                } else {
	                    if (after != this.before && this.options.onchange) {
	                        this.options.onchange(new_value);
	                    }
	                    return after;
	                }
	            }
	        },
	
	        /** Return the number of rows */
	        size: function () {
	            return this.$tbody.find('tr').length;
	        },
	
	        /** Helper to append rows */
	        _commit: function (id, fade, prepend) {
	            this.del(id);
	            this.row.attr('id', id);
	            if (prepend) {
	                this.$tbody.prepend(this.row);
	            } else {
	                this.$tbody.append(this.row);
	            }
	            if (fade) {
	                this.row.hide();
	                this.row.fadeIn();
	            }
	            this.row = this._row();
	            this.row_count++;
	            this._refresh();
	        },
	
	        /** Helper to create new row */
	        _row: function () {
	            return $('<tr class="' + this.options.cls_tr + '"></tr>');
	        },
	
	        /** Handles onclick events */
	        _onclick: function (e) {
	            var old_value = this.value();
	            var new_value = $(e.target).closest('tr').attr('id');
	            if (new_value != '') {
	                if (new_value && old_value != new_value) {
	                    if (this.options.onconfirm) {
	                        this.options.onconfirm(new_value);
	                    } else {
	                        this.value(new_value);
	                    }
	                }
	            }
	        },
	
	        /** Handles ondblclick events */
	        _ondblclick: function (e) {
	            var value = this.value();
	            if (value && this.options.ondblclick) {
	                this.options.ondblclick(value);
	            }
	        },
	
	        /** Refresh helper */
	        _refresh: function () {
	            if (this.row_count == 0) {
	                this.$tmessage.show();
	            } else {
	                this.$tmessage.hide();
	            }
	        },
	
	        /** Template */
	        _template: function () {
	            return '<div>' + '<table class="' + this.options.cls + '">' + '<thead/>' + '<tbody/>' + '</table>' + '<tmessage>' + this.options.content + '</tmessage>' + '<div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// from: https://raw.githubusercontent.com/umdjs/umd/master/jqueryPlugin.js
	// Uses AMD or browser globals to create a jQuery plugin.
	(function (factory) {
	    if (true) {
	        //TODO: So...this turns out to be an all or nothing thing. If I load jQuery in the define below, it will
	        //  (of course) wipe the old jquery *and all the plugins loaded into it*. So the define below *is still
	        //  relying on jquery being loaded globally* in order to preserve plugins.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	})(function (jQuery) {
	    'use_strict';
	
	    var $ = jQuery;
	
	    // ============================================================================
	    /**
	     * Make an element with text editable: (a) when user clicks on text, a textbox/area
	     * is provided for editing; (b) when enter key pressed, element's text is set and on_finish
	     * is called.
	     */
	    $.fn.make_text_editable = function (config_dict) {
	        // Get config options.
	        var num_cols = "num_cols" in config_dict ? config_dict.num_cols : 30,
	            num_rows = "num_rows" in config_dict ? config_dict.num_rows : 4,
	            use_textarea = "use_textarea" in config_dict ? config_dict.use_textarea : false,
	            on_finish = "on_finish" in config_dict ? config_dict.on_finish : null,
	            help_text = "help_text" in config_dict ? config_dict.help_text : null;
	
	        // Add element behavior.
	        var container = $(this);
	        container.addClass("editable-text").click(function (e) {
	            // If there's already an input element, editing is active, so do nothing.
	            if ($(this).children(":input").length > 0) {
	                return;
	            }
	
	            container.removeClass("editable-text");
	
	            // Handler for setting element text.
	            var set_text = function (new_text) {
	                container.find(":input").remove();
	
	                if (new_text !== "") {
	                    container.text(new_text);
	                } else {
	                    // No text; need a line so that there is a click target.
	                    container.html("<br>");
	                }
	                container.addClass("editable-text");
	
	                if (on_finish) {
	                    on_finish(new_text);
	                }
	            };
	
	            // Create input element(s) for editing.
	            var cur_text = "cur_text" in config_dict ? config_dict.cur_text : container.text(),
	                input_elt,
	                button_elt;
	
	            if (use_textarea) {
	                input_elt = $("<textarea/>").attr({ rows: num_rows, cols: num_cols }).text($.trim(cur_text)).keyup(function (e) {
	                    if (e.keyCode === 27) {
	                        // Escape key.
	                        set_text(cur_text);
	                    }
	                });
	                button_elt = $("<button/>").text("Done").click(function () {
	                    set_text(input_elt.val());
	                    // Return false so that click does not propogate to container.
	                    return false;
	                });
	            } else {
	                input_elt = $("<input type='text'/>").attr({ value: $.trim(cur_text), size: num_cols }).blur(function () {
	                    set_text(cur_text);
	                }).keyup(function (e) {
	                    if (e.keyCode === 27) {
	                        // Escape key.
	                        $(this).trigger("blur");
	                    } else if (e.keyCode === 13) {
	                        // Enter key.
	                        set_text($(this).val());
	                    }
	
	                    // Do not propogate event to avoid unwanted side effects.
	                    e.stopPropagation();
	                });
	            }
	
	            // Replace text with input object(s) and focus & select.
	            container.text("");
	            container.append(input_elt);
	            if (button_elt) {
	                container.append(button_elt);
	            }
	            input_elt.focus();
	            input_elt.select();
	
	            // Do not propogate to elements below b/c that blurs input and prevents it from being used.
	            e.stopPropagation();
	        });
	
	        // Add help text if there some.
	        if (help_text) {
	            container.attr("title", help_text).tooltip();
	        }
	
	        return container;
	    };
	
	    // ============================================================================
	});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, _) {(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        root.faIconButton = factory();
	    }
	})(this, function () {
	    //============================================================================
	    /** Returns a jQuery object containing a clickable font-awesome button.
	     *      options:
	     *          tooltipConfig   : option map for bootstrap tool tip
	     *          classes         : array of class names (will always be classed as icon-btn)
	     *          disabled        : T/F - add the 'disabled' class?
	     *          title           : tooltip/title string
	     *          target          : optional href target
	     *          href            : optional href
	     *          faIcon          : which font awesome icon to use
	     *          onclick         : function to call when the button is clicked
	     */
	    var faIconButton = function (options) {
	        options = options || {};
	        options.tooltipConfig = options.tooltipConfig || { placement: 'bottom' };
	
	        options.classes = ['icon-btn'].concat(options.classes || []);
	        if (options.disabled) {
	            options.classes.push('disabled');
	        }
	
	        var html = ['<a class="', options.classes.join(' '), '"', options.title ? ' title="' + options.title + '"' : '', !options.disabled && options.target ? ' target="' + options.target + '"' : '', ' href="', !options.disabled && options.href ? options.href : 'javascript:void(0);', '">',
	        // could go with something less specific here - like 'html'
	        '<span class="fa ', options.faIcon, '"></span>', '</a>'].join('');
	        var $button = $(html).tooltip(options.tooltipConfig);
	        if (_.isFunction(options.onclick)) {
	            $button.click(options.onclick);
	        }
	        return $button;
	    };
	
	    //============================================================================
	    return faIconButton;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /**
	     * Stringifies a number adding commas for digit grouping as per North America.
	     */
	    function commatize(number) {
	        number += ''; // Convert to string
	        var rgx = /(\d+)(\d{3})/;
	        while (rgx.test(number)) {
	            number = number.replace(rgx, '$1' + ',' + '$2');
	        }
	        return number;
	    }
	
	    /**
	     * Helper to determine if object is jQuery deferred.
	     */
	    var is_deferred = function (d) {
	        return 'promise' in d;
	    };
	
	    /**
	     * Implementation of a server-state based deferred. Server is repeatedly polled, and when
	     * condition is met, deferred is resolved.
	     */
	    var ServerStateDeferred = Backbone.Model.extend({
	        defaults: {
	            ajax_settings: {},
	            interval: 1000,
	            success_fn: function (result) {
	                return true;
	            }
	        },
	
	        /**
	         * Returns a deferred that resolves when success function returns true.
	         */
	        go: function () {
	            var deferred = $.Deferred(),
	                self = this,
	                ajax_settings = self.get('ajax_settings'),
	                success_fn = self.get('success_fn'),
	                interval = self.get('interval'),
	                _go = function () {
	                $.ajax(ajax_settings).success(function (result) {
	                    if (success_fn(result)) {
	                        // Result is good, so resolve.
	                        deferred.resolve(result);
	                    } else {
	                        // Result not good, try again.
	                        setTimeout(_go, interval);
	                    }
	                });
	            };
	            _go();
	            return deferred;
	        }
	    });
	
	    /**
	     * Returns a random color in hexadecimal format that is sufficiently different from a single color
	     * or set of colors.
	     * @param colors a color or list of colors in the format '#RRGGBB'
	     */
	    var get_random_color = function (colors) {
	        // Default for colors is white.
	        if (!colors) {
	            colors = "#ffffff";
	        }
	
	        // If needed, create list of colors.
	        if (typeof colors === "string") {
	            colors = [colors];
	        }
	
	        // Convert colors to numbers.
	        for (var i = 0; i < colors.length; i++) {
	            colors[i] = parseInt(colors[i].slice(1), 16);
	        }
	
	        // -- Perceived brightness and difference formulas are from
	        // -- http://www.w3.org/WAI/ER/WD-AERT/#color-contrast
	
	        // Compute perceived color brightness (based on RGB-YIQ transformation):
	        var brightness = function (r, g, b) {
	            return (r * 299 + g * 587 + b * 114) / 1000;
	        };
	
	        // Compute color difference:
	        var difference = function (r1, g1, b1, r2, g2, b2) {
	            return Math.max(r1, r2) - Math.min(r1, r2) + (Math.max(g1, g2) - Math.min(g1, g2)) + (Math.max(b1, b2) - Math.min(b1, b2));
	        };
	
	        // Create new random color.
	        var new_color,
	            nr,
	            ng,
	            nb,
	            other_color,
	            or,
	            og,
	            ob,
	            n_brightness,
	            o_brightness,
	            diff,
	            ok = false,
	            num_tries = 0;
	        do {
	            // New color is never white b/c random in [0,1)
	            new_color = Math.round(Math.random() * 0xffffff);
	            nr = (new_color & 0xff0000) >> 16;
	            ng = (new_color & 0x00ff00) >> 8;
	            nb = new_color & 0x0000ff;
	            n_brightness = brightness(nr, ng, nb);
	            ok = true;
	            for (i = 0; i < colors.length; i++) {
	                other_color = colors[i];
	                or = (other_color & 0xff0000) >> 16;
	                og = (other_color & 0x00ff00) >> 8;
	                ob = other_color & 0x0000ff;
	                o_brightness = brightness(or, og, ob);
	                diff = difference(nr, ng, nb, or, og, ob);
	                // These thresholds may need to be adjusted. Brightness difference range is 125;
	                // color difference range is 500.
	                if (Math.abs(n_brightness - o_brightness) < 40 || diff < 200) {
	                    ok = false;
	                    break;
	                }
	            }
	
	            num_tries++;
	        } while (!ok && num_tries <= 10);
	
	        // Add 0x1000000 to left pad number with 0s.
	        return '#' + (0x1000000 + new_color).toString(16).substr(1, 6);
	    };
	
	    return {
	        commatize: commatize,
	        is_deferred: is_deferred,
	        ServerStateDeferred: ServerStateDeferred,
	        get_random_color: get_random_color
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (parseBibtex, baseMVC, _l) {
	    /* global Backbone */
	    // we use amd here to require, but bibtex uses a global or commonjs pattern.
	    // webpack will load via commonjs and plain requirejs will load as global. Check both
	    parseBibtex = parseBibtex || window.BibtexParser;
	
	    var logNamespace = 'citation';
	    //==============================================================================
	    /** @class model for tool citations.
	     *  @name Citation
	     *  @augments Backbone.Model
	     */
	    var Citation = Backbone.Model.extend(baseMVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        defaults: {
	            content: ''
	        },
	
	        initialize: function () {
	            var parsed;
	            try {
	                // TODO: to model.parse/.validate
	                parsed = parseBibtex(this.attributes.content);
	            } catch (err) {
	                return;
	            }
	            // bibtex returns successfully parsed in .entries and any parsing errors in .errors
	            if (parsed.errors.length) {
	                // the gen. form of these errors seems to be [ line, col, char, error message ]
	                var errors = parsed.errors.reduce(function (all, current) {
	                    return all + '; ' + current;
	                });
	                // throw new Error( 'Error parsing bibtex: ' + errors );
	                this.log('Error parsing bibtex: ' + errors);
	            }
	
	            this._fields = {};
	            this.entry = _.first(parsed.entries);
	            if (this.entry) {
	                var rawFields = this.entry.Fields;
	                for (var key in rawFields) {
	                    var value = rawFields[key];
	                    var lowerKey = key.toLowerCase();
	                    this._fields[lowerKey] = value;
	                }
	            }
	        },
	        entryType: function () {
	            return this.entry ? this.entry.EntryType : undefined;
	        },
	        fields: function () {
	            return this._fields;
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone collection of citations.
	     */
	    var BaseCitationCollection = Backbone.Collection.extend(baseMVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        /** root api url */
	        urlRoot: Galaxy.root + 'api',
	        partial: true, // Assume some tools in history/workflow may not be properly annotated yet.
	        model: Citation
	    });
	
	    var HistoryCitationCollection = BaseCitationCollection.extend({
	        /** complete api url */
	        url: function () {
	            return this.urlRoot + '/histories/' + this.history_id + '/citations';
	        }
	    });
	
	    var ToolCitationCollection = BaseCitationCollection.extend({
	        /** complete api url */
	        url: function () {
	            return this.urlRoot + '/tools/' + this.tool_id + '/citations';
	        },
	        partial: false // If a tool has citations, assume they are complete.
	    });
	
	    //==============================================================================
	
	    return {
	        Citation: Citation,
	        HistoryCitationCollection: HistoryCitationCollection,
	        ToolCitationCollection: ToolCitationCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/**
	    This class creates a form input element wrapper
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return Backbone.View.extend({
	        initialize: function (app, options) {
	            this.app = app;
	            this.app_options = app.model ? app.model.attributes : {};
	            this.field = options && options.field || new Backbone.View();
	            this.model = options && options.model || new Backbone.Model({
	                text_enable: this.app_options.text_enable || 'Enable',
	                text_disable: this.app_options.text_disable || 'Disable',
	                cls_enable: this.app_options.cls_enable || 'fa fa-caret-square-o-down',
	                cls_disable: this.app_options.cls_disable || 'fa fa-caret-square-o-up',
	                always_refresh: this.app_options.always_refresh
	            }).set(options);
	
	            // set element and link components
	            this.setElement(this._template());
	            this.$field = this.$('.ui-form-field');
	            this.$info = this.$('.ui-form-info');
	            this.$preview = this.$('.ui-form-preview');
	            this.$collapsible = this.$('.ui-form-collapsible');
	            this.$collapsible_text = this.$('.ui-form-collapsible-text');
	            this.$collapsible_icon = this.$('.ui-form-collapsible-icon');
	            this.$title = this.$('.ui-form-title');
	            this.$title_text = this.$('.ui-form-title-text');
	            this.$error_text = this.$('.ui-form-error-text');
	            this.$error = this.$('.ui-form-error');
	            this.$backdrop = this.$('.ui-form-backdrop');
	
	            // add field element
	            this.$field.prepend(this.field.$el);
	
	            // decide wether to expand or collapse fields
	            var collapsible_value = this.model.get('collapsible_value');
	            this.field.collapsed = collapsible_value !== undefined && JSON.stringify(this.model.get('value')) == JSON.stringify(collapsible_value);
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	
	            // add click handler
	            var self = this;
	            this.$collapsible.on('click', function () {
	                self.field.collapsed = !self.field.collapsed;
	                app.trigger && app.trigger('change');
	                self.render();
	            });
	
	            // hide error on value change
	            if (this.field.model && !this.model.get('always_refresh')) {
	                this.listenTo(this.field.model, 'change:value', function () {
	                    self.reset();
	                });
	            }
	        },
	
	        /** Set backdrop for input element */
	        backdrop: function () {
	            this.model.set('backdrop', true);
	        },
	
	        /** Set error text */
	        error: function (text) {
	            this.model.set('error_text', text);
	        },
	
	        /** Reset this view */
	        reset: function () {
	            !this.model.get('fixed') && this.model.set('error_text', null);
	        },
	
	        render: function () {
	            // render help
	            $('.tooltip').hide();
	            var help_text = this.model.get('help', '');
	            var help_argument = this.model.get('argument');
	            if (help_argument && help_text.indexOf('(' + help_argument + ')') == -1) {
	                help_text += ' (' + help_argument + ')';
	            }
	            this.$info.html(help_text);
	            // render visibility
	            this.$el[this.model.get('hidden') ? 'hide' : 'show']();
	            // render preview view for collapsed fields
	            this.$preview[this.field.collapsed && this.model.get('collapsible_preview') || this.model.get('disabled') ? 'show' : 'hide']().html(_.escape(this.model.get('text_value')));
	            // render error messages
	            var error_text = this.model.get('error_text');
	            this.$error[error_text ? 'show' : 'hide']();
	            this.$el[error_text ? 'addClass' : 'removeClass']('ui-error');
	            this.$error_text.html(error_text);
	            // render backdrop
	            this.$backdrop[this.model.get('backdrop') ? 'show' : 'hide']();
	            // render input field
	            this.field.collapsed || this.model.get('disabled') ? this.$field.hide() : this.$field.show();
	            // render input field color and style
	            this.field.model && this.field.model.set({ 'color': this.model.get('color'), 'style': this.model.get('style') });
	            // render collapsible options
	            if (!this.model.get('disabled') && this.model.get('collapsible_value') !== undefined) {
	                var collapsible_state = this.field.collapsed ? 'enable' : 'disable';
	                this.$title_text.hide();
	                this.$collapsible.show();
	                this.$collapsible_text.text(this.model.get('label'));
	                this.$collapsible_icon.removeClass().addClass('icon').addClass(this.model.get('cls_' + collapsible_state)).attr('data-original-title', this.model.get('text_' + collapsible_state)).tooltip({ placement: 'bottom' });
	            } else {
	                this.$title_text.show().text(this.model.get('label'));
	                this.$collapsible.hide();
	            }
	        },
	
	        _template: function () {
	            return $('<div/>').addClass('ui-form-element').append($('<div/>').addClass('ui-form-error ui-error').append($('<span/>').addClass('fa fa-arrow-down')).append($('<span/>').addClass('ui-form-error-text'))).append($('<div/>').addClass('ui-form-title').append($('<div/>').addClass('ui-form-collapsible').append($('<i/>').addClass('ui-form-collapsible-icon')).append($('<span/>').addClass('ui-form-collapsible-text'))).append($('<span/>').addClass('ui-form-title-text'))).append($('<div/>').addClass('ui-form-field').append($('<span/>').addClass('ui-form-info')).append($('<div/>').addClass('ui-form-backdrop'))).append($('<div/>').addClass('ui-form-preview'));
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/**
	    This class creates input elements. New input parameter types should be added to the types dictionary.
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(38), __webpack_require__(41), __webpack_require__(39), __webpack_require__(40), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, SelectContent, SelectLibrary, SelectFtp, SelectGenomeSpace, ColorPicker) {
	
	    // create form view
	    return Backbone.Model.extend({
	        /** Available parameter types */
	        types: {
	            'text': '_fieldText',
	            'password': '_fieldText',
	            'select': '_fieldSelect',
	            'data_column': '_fieldSelect',
	            'genomebuild': '_fieldSelect',
	            'data': '_fieldData',
	            'data_collection': '_fieldData',
	            'integer': '_fieldSlider',
	            'float': '_fieldSlider',
	            'boolean': '_fieldBoolean',
	            'drill_down': '_fieldDrilldown',
	            'color': '_fieldColor',
	            'hidden': '_fieldHidden',
	            'hidden_data': '_fieldHidden',
	            'baseurl': '_fieldHidden',
	            'library_data': '_fieldLibrary',
	            'ftpfile': '_fieldFtp',
	            'upload': '_fieldUpload',
	            'genomespacefile': '_fieldGenomeSpace'
	        },
	
	        /** Returns an input field for a given field type */
	        create: function (input_def) {
	            var fieldClass = this.types[input_def.type];
	            var field = typeof this[fieldClass] === 'function' ? this[fieldClass].call(this, input_def) : null;
	            if (!field) {
	                field = input_def.options ? this._fieldSelect(input_def) : this._fieldText(input_def);
	                Galaxy.emit.debug('form-parameters::_addRow()', 'Auto matched field type (' + input_def.type + ').');
	            }
	            input_def.value === undefined && (input_def.value = null);
	            field.value(input_def.value);
	            return field;
	        },
	
	        /** Data input field */
	        _fieldData: function (input_def) {
	            return new SelectContent.View({
	                id: 'field-' + input_def.id,
	                extensions: input_def.extensions,
	                optional: input_def.optional,
	                multiple: input_def.multiple,
	                type: input_def.type,
	                flavor: input_def.flavor,
	                data: input_def.options,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Select/Checkbox/Radio options field */
	        _fieldSelect: function (input_def) {
	            // show text field e.g. in workflow editor
	            if (input_def.is_workflow) {
	                return this._fieldText(input_def);
	            }
	
	            // customize properties
	            if (input_def.type == 'data_column') {
	                input_def.error_text = 'Missing columns in referenced dataset.';
	            }
	
	            // identify available options
	            var data = input_def.data;
	            if (!data) {
	                data = [];
	                _.each(input_def.options, function (option) {
	                    data.push({ label: option[0], value: option[1] });
	                });
	            }
	
	            // identify display type
	            var SelectClass = Ui.Select;
	            switch (input_def.display) {
	                case 'checkboxes':
	                    SelectClass = Ui.Checkbox;
	                    break;
	                case 'radio':
	                    SelectClass = Ui.Radio;
	                    break;
	                case 'radiobutton':
	                    SelectClass = Ui.RadioButton;
	                    break;
	            }
	
	            // create select field
	            return new SelectClass.View({
	                id: 'field-' + input_def.id,
	                data: data,
	                error_text: input_def.error_text || 'No options available',
	                multiple: input_def.multiple,
	                optional: input_def.optional,
	                onchange: input_def.onchange,
	                individual: input_def.individual,
	                searchable: input_def.flavor !== 'workflow'
	            });
	        },
	
	        /** Drill down options field */
	        _fieldDrilldown: function (input_def) {
	            // show text field e.g. in workflow editor
	            if (input_def.is_workflow) {
	                return this._fieldText(input_def);
	            }
	
	            // create drill down field
	            return new Ui.Drilldown.View({
	                id: 'field-' + input_def.id,
	                data: input_def.options,
	                display: input_def.display,
	                optional: input_def.optional,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Text input field */
	        _fieldText: function (input_def) {
	            // field replaces e.g. a select field
	            if (input_def.options && input_def.data) {
	                input_def.area = input_def.multiple;
	                if (Utils.isEmpty(input_def.value)) {
	                    input_def.value = null;
	                } else {
	                    if ($.isArray(input_def.value)) {
	                        var str_value = '';
	                        for (var i in input_def.value) {
	                            str_value += String(input_def.value[i]);
	                            if (!input_def.multiple) {
	                                break;
	                            }
	                            str_value += '\n';
	                        }
	                        input_def.value = str_value;
	                    }
	                }
	            }
	            // create input element
	            return new Ui.Input({
	                id: 'field-' + input_def.id,
	                type: input_def.type,
	                area: input_def.area,
	                readonly: input_def.readonly,
	                placeholder: input_def.placeholder,
	                datalist: input_def.datalist,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Slider field */
	        _fieldSlider: function (input_def) {
	            return new Ui.Slider.View({
	                id: 'field-' + input_def.id,
	                precise: input_def.type == 'float',
	                is_workflow: input_def.is_workflow,
	                min: input_def.min,
	                max: input_def.max,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Hidden field */
	        _fieldHidden: function (input_def) {
	            return new Ui.Hidden({
	                id: 'field-' + input_def.id,
	                info: input_def.info
	            });
	        },
	
	        /** Boolean field */
	        _fieldBoolean: function (input_def) {
	            return new Ui.RadioButton.View({
	                id: 'field-' + input_def.id,
	                data: [{ label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }],
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Color picker field */
	        _fieldColor: function (input_def) {
	            return new ColorPicker({
	                id: 'field-' + input_def.id,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** Library dataset field */
	        _fieldLibrary: function (input_def) {
	            return new SelectLibrary.View({
	                id: 'field-' + input_def.id,
	                optional: input_def.optional,
	                multiple: input_def.multiple,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** FTP file field */
	        _fieldFtp: function (input_def) {
	            return new SelectFtp.View({
	                id: 'field-' + input_def.id,
	                optional: input_def.optional,
	                multiple: input_def.multiple,
	                onchange: input_def.onchange
	            });
	        },
	
	        /** GenomeSpace file select field
	         */
	        _fieldGenomeSpace: function (input_def) {
	            var self = this;
	            return new SelectGenomeSpace.View({
	                id: 'field-' + input_def.id,
	                onchange: function () {
	                    self.app.trigger('change');
	                }
	            });
	        },
	
	        /** Upload file field */
	        _fieldUpload: function (input_def) {
	            return new Ui.Upload({
	                id: 'field-' + input_def.id,
	                onchange: input_def.onchange
	            });
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This class creates a ui component which enables the dynamic creation of portlets */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(9), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Portlet, Ui) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            this.list = {};
	            this.options = Utils.merge(options, {
	                title: 'Repeat',
	                empty_text: 'Not available.',
	                max: null,
	                min: null
	            });
	            this.button_new = new Ui.ButtonIcon({
	                icon: 'fa-plus',
	                title: 'Insert ' + this.options.title,
	                tooltip: 'Add new ' + this.options.title + ' block',
	                cls: 'ui-button-icon ui-clear-float form-repeat-add',
	                onclick: function () {
	                    options.onnew && options.onnew();
	                }
	            });
	            this.setElement($('<div/>').append(this.$list = $('<div/>')).append($('<div/>').append(this.button_new.$el)));
	        },
	
	        /** Number of repeat blocks */
	        size: function () {
	            return _.size(this.list);
	        },
	
	        /** Add new repeat block */
	        add: function (options) {
	            if (!options.id || this.list[options.id]) {
	                Galaxy.emit.debug('form-repeat::add()', 'Duplicate or invalid repeat block id.');
	                return;
	            }
	            var button_delete = new Ui.ButtonIcon({
	                icon: 'fa-trash-o',
	                tooltip: 'Delete this repeat block',
	                cls: 'ui-button-icon-plain form-repeat-delete',
	                onclick: function () {
	                    options.ondel && options.ondel();
	                }
	            });
	            var portlet = new Portlet.View({
	                id: options.id,
	                title: 'placeholder',
	                cls: options.cls || 'ui-portlet-repeat',
	                operations: { button_delete: button_delete }
	            });
	            portlet.append(options.$el);
	            portlet.$el.addClass('section-row').hide();
	            this.list[options.id] = portlet;
	            this.$list.append(portlet.$el.fadeIn('fast'));
	            this.options.max > 0 && this.size() >= this.options.max && this.button_new.disable();
	            this._refresh();
	        },
	
	        /** Delete repeat block */
	        del: function (id) {
	            if (!this.list[id]) {
	                Galaxy.emit.debug('form-repeat::del()', 'Invalid repeat block id.');
	                return;
	            }
	            this.$list.find('#' + id).remove();
	            delete this.list[id];
	            this.button_new.enable();
	            this._refresh();
	        },
	
	        /** Remove all */
	        delAll: function () {
	            for (var id in this.list) {
	                this.del(id);
	            }
	        },
	
	        /** Hides add/del options */
	        hideOptions: function () {
	            this.button_new.$el.hide();
	            _.each(this.list, function (portlet) {
	                portlet.hideOperation('button_delete');
	            });
	            _.isEmpty(this.list) && this.$el.append($('<div/>').addClass('ui-form-info').html(this.options.empty_text));
	        },
	
	        /** Refresh view */
	        _refresh: function () {
	            var index = 0;
	            for (var id in this.list) {
	                var portlet = this.list[id];
	                portlet.title(++index + ': ' + this.options.title);
	                portlet[this.size() > this.options.min ? 'showOperation' : 'hideOperation']('button_delete');
	            }
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _, jQuery) {/**
	    This class creates a form section and populates it with input elements. It also handles repeat blocks and conditionals by recursively creating new sub sections.
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(9), __webpack_require__(31), __webpack_require__(29), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Portlet, Repeat, InputElement, Parameters) {
	    var View = Backbone.View.extend({
	        initialize: function (app, options) {
	            this.app = app;
	            this.inputs = options.inputs;
	            this.parameters = new Parameters();
	            this.setElement($('<div/>'));
	            this.render();
	        },
	
	        /** Render section view */
	        render: function () {
	            var self = this;
	            this.$el.empty();
	            _.each(this.inputs, function (input) {
	                self.add(input);
	            });
	        },
	
	        /** Add a new input element */
	        add: function (input) {
	            var input_def = jQuery.extend(true, {}, input);
	            input_def.id = input.id = Utils.uid();
	            this.app.input_list[input_def.id] = input_def;
	            switch (input_def.type) {
	                case 'conditional':
	                    this._addConditional(input_def);
	                    break;
	                case 'repeat':
	                    this._addRepeat(input_def);
	                    break;
	                case 'section':
	                    this._addSection(input_def);
	                    break;
	                default:
	                    this._addRow(input_def);
	            }
	        },
	
	        /** Add a conditional block */
	        _addConditional: function (input_def) {
	            var self = this;
	            input_def.test_param.id = input_def.id;
	            this.app.model.get('sustain_conditionals') && (input_def.test_param.disabled = true);
	            var field = this._addRow(input_def.test_param);
	
	            // set onchange event for test parameter
	            field.model && field.model.set('onchange', function (value) {
	                var selectedCase = self.app.data.matchCase(input_def, value);
	                for (var i in input_def.cases) {
	                    var case_def = input_def.cases[i];
	                    var section_row = self.$('#' + input_def.id + '-section-' + i);
	                    var nonhidden = false;
	                    for (var j in case_def.inputs) {
	                        if (!case_def.inputs[j].hidden) {
	                            nonhidden = true;
	                            break;
	                        }
	                    }
	                    if (i == selectedCase && nonhidden) {
	                        section_row.fadeIn('fast');
	                    } else {
	                        section_row.hide();
	                    }
	                }
	                self.app.trigger('change');
	            });
	
	            // add conditional sub sections
	            for (var i in input_def.cases) {
	                var sub_section = new View(this.app, { inputs: input_def.cases[i].inputs });
	                this._append(sub_section.$el.addClass('ui-form-section'), input_def.id + '-section-' + i);
	            }
	
	            // trigger refresh on conditional input field after all input elements have been created
	            field.trigger('change');
	        },
	
	        /** Add a repeat block */
	        _addRepeat: function (input_def) {
	            var self = this;
	            var block_index = 0;
	
	            // create repeat block element
	            var repeat = new Repeat.View({
	                title: input_def.title || 'Repeat',
	                min: input_def.min,
	                max: input_def.max,
	                onnew: function () {
	                    create(input_def.inputs);self.app.trigger('change');
	                }
	            });
	
	            // helper function to create new repeat blocks
	            function create(inputs) {
	                var sub_section_id = input_def.id + '-section-' + block_index++;
	                var sub_section = new View(self.app, { inputs: inputs });
	                repeat.add({ id: sub_section_id,
	                    $el: sub_section.$el,
	                    ondel: function () {
	                        repeat.del(sub_section_id);self.app.trigger('change');
	                    } });
	            }
	
	            //
	            // add parsed/minimum number of repeat blocks
	            //
	            var n_cache = _.size(input_def.cache);
	            for (var i = 0; i < Math.max(Math.max(n_cache, input_def.min || 0), input_def.default || 0); i++) {
	                create(i < n_cache ? input_def.cache[i] : input_def.inputs);
	            }
	
	            // hide options
	            this.app.model.get('sustain_repeats') && repeat.hideOptions();
	
	            // create input field wrapper
	            var input_element = new InputElement(this.app, {
	                label: input_def.title || input_def.name,
	                help: input_def.help,
	                field: repeat
	            });
	            this._append(input_element.$el, input_def.id);
	        },
	
	        /** Add a customized section */
	        _addSection: function (input_def) {
	            var portlet = new Portlet.View({
	                title: input_def.title || input_def.name,
	                cls: 'ui-portlet-section',
	                collapsible: true,
	                collapsible_button: true,
	                collapsed: !input_def.expanded
	            });
	            portlet.append(new View(this.app, { inputs: input_def.inputs }).$el);
	            portlet.append($('<div/>').addClass('ui-form-info').html(input_def.help));
	            this.app.on('expand', function (input_id) {
	                portlet.$('#' + input_id).length > 0 && portlet.expand();
	            });
	            this._append(portlet.$el, input_def.id);
	        },
	
	        /** Add a single input field element */
	        _addRow: function (input_def) {
	            var self = this;
	            var id = input_def.id;
	            input_def.onchange = input_def.onchange || function () {
	                self.app.trigger('change', id);
	            };
	            var field = this.parameters.create(input_def);
	            this.app.field_list[id] = field;
	            var input_element = new InputElement(this.app, {
	                name: input_def.name,
	                label: input_def.hide_label ? '' : input_def.label || input_def.name,
	                value: input_def.value,
	                text_value: input_def.text_value,
	                collapsible_value: input_def.collapsible_value,
	                collapsible_preview: input_def.collapsible_preview,
	                help: input_def.help,
	                argument: input_def.argument,
	                disabled: input_def.disabled,
	                color: input_def.color,
	                style: input_def.style,
	                backdrop: input_def.backdrop,
	                hidden: input_def.hidden,
	                fixed: input_def.fixed,
	                field: field
	            });
	            this.app.element_list[id] = input_element;
	            this._append(input_element.$el, input_def.id);
	            return field;
	        },
	
	        /** Append a new element to the form i.e. input element, repeat block, conditionals etc. */
	        _append: function ($el, id) {
	            this.$el.append($el.addClass('section-row').attr('id', id));
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    // grid model
	    return Backbone.Model.extend({
	        defaults: {
	            url_base: '',
	            async: false,
	            async_ops: [],
	            categorical_filters: [],
	            filters: {},
	            sort_key: null,
	            show_item_checkboxes: false,
	            advanced_search: false,
	            cur_page: 1,
	            num_pages: 1,
	            operation: undefined,
	            item_ids: undefined
	        },
	
	        /**
	         * Return true if operation can be done asynchronously.
	         */
	        can_async_op: function (op) {
	            return _.indexOf(this.attributes.async_ops, op) !== -1;
	        },
	
	        /**
	         * Add filtering criterion.
	         */
	        add_filter: function (key, value, append) {
	            // Update URL arg with new condition.            
	            if (append) {
	                // Update or append value.
	                var cur_val = this.attributes.filters[key],
	                    new_val;
	                if (cur_val === null || cur_val === undefined) {
	                    new_val = value;
	                } else if (typeof cur_val == 'string') {
	                    if (cur_val == 'All' || cur_val == value) {
	                        new_val = value;
	                    } else {
	                        // Replace string with array.
	                        var values = [];
	                        values[0] = cur_val;
	                        values[1] = value;
	                        new_val = values;
	                    }
	                } else {
	                    // Current value is an array.
	                    new_val = cur_val;
	                    if (new_val.indexOf(value) === -1) {
	                        new_val.push(value);
	                    }
	                }
	                this.attributes.filters[key] = new_val;
	            } else {
	                // Replace value.
	                this.attributes.filters[key] = value;
	            }
	        },
	
	        /**
	         * Remove filtering criterion.
	         */
	        remove_filter: function (key, condition) {
	            var cur_val = this.attributes.filters[key];
	            if (cur_val === null || cur_val === undefined) {
	                return false;
	            }
	
	            if (typeof cur_val === 'string') {
	                // overwrite/remove condition.
	                this.attributes.filters[key] = '';
	            } else {
	                // filter contains an array of conditions.
	                var condition_index = _.indexOf(cur_val, condition);
	                if (condition_index !== -1) {
	                    cur_val[condition_index] = '';
	                }
	            }
	        },
	
	        /**
	         * Returns URL data for obtaining a new grid.
	         */
	        get_url_data: function () {
	            var url_data = {
	                async: this.attributes.async,
	                sort: this.attributes.sort_key,
	                page: this.attributes.cur_page,
	                show_item_checkboxes: this.attributes.show_item_checkboxes,
	                advanced_search: this.attributes.advanced_search
	            };
	
	            // Add operation, item_ids only if they have values.
	            if (this.attributes.operation) {
	                url_data.operation = this.attributes.operation;
	            }
	            if (this.attributes.item_ids) {
	                url_data.id = this.attributes.item_ids;
	            }
	
	            // Add filter arguments to data, placing "f-" in front of all arguments.
	            var self = this;
	            _.each(_.pairs(self.attributes.filters), function (k) {
	                url_data['f-' + k[0]] = k[1];
	            });
	            return url_data;
	        },
	
	        // Return URL for obtaining a new grid
	        get_url: function (args) {
	            return this.get('url_base') + '?' + $.param(this.get_url_data()) + '&' + $.param(args);
	        }
	
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, _) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	
	    // grid view templates
	    return {
	        // template
	        grid: function (options) {
	            var tmpl = '';
	            if (options.embedded) {
	                tmpl = this.grid_header(options) + this.grid_table(options);
	            } else {
	                tmpl = '<div class="loading-elt-overlay"></div>' + '<table>' + '<tr>' + '<td width="75%">' + this.grid_header(options) + '</td>' + '<td></td>' + '<td></td>' + '</tr>' + '<tr>' + '<td width="100%" id="grid-message" valign="top"></td>' + '<td></td>' + '<td></td>' + '</tr>' + '</table>' + this.grid_table(options);
	            }
	
	            // add info text
	            if (options.info_text) {
	                tmpl += '<br><div class="toolParamHelp" style="clear: both;">' + options.info_text + '</div>';
	            }
	
	            // return
	            return tmpl;
	        },
	
	        // template
	        grid_table: function (options) {
	            return '<form method="post" onsubmit="return false;">' + '<table id="grid-table" class="grid">' + '<thead id="grid-table-header"></thead>' + '<tbody id="grid-table-body"></tbody>' + '<tfoot id="grid-table-footer"></tfoot>' + '</table>' + '</form>';
	        },
	
	        // template
	        grid_header: function (options) {
	            var tmpl = '<div class="grid-header">';
	            if (!options.embedded) {
	                tmpl += '<h2>' + options.title + '</h2>';
	            }
	            if (options.global_actions) {
	                tmpl += '<ul class="manage-table-actions">';
	                var show_popup = options.global_actions.length >= 3;
	                if (show_popup) {
	                    tmpl += '<li><a class="action-button" id="popup-global-actions" class="menubutton">Actions</a></li>' + '<div popupmenu="popup-global-actions">';
	                }
	                for (var i in options.global_actions) {
	                    var action = options.global_actions[i];
	                    tmpl += '<li>' + '<a class="action-button use-target" target="' + action.target + '" href="' + action.url_args + '" onclick="return false;" >' + action.label + '</a>' + '</li>';
	                }
	                if (show_popup) {
	                    tmpl += '</div>';
	                }
	                tmpl += '</ul>';
	            }
	            if (options.insert) {
	                tmpl += options.insert;
	            }
	
	            // add grid filters
	            tmpl += this.grid_filters(options);
	            tmpl += '</div>';
	
	            // return template
	            return tmpl;
	        },
	
	        // template
	        header: function (options) {
	
	            // start
	            var tmpl = '<tr>';
	
	            // add checkbox
	            if (options.show_item_checkboxes) {
	                tmpl += '<th>';
	                if (options.items.length > 0) {
	                    tmpl += '<input type="checkbox" id="check_all" name=select_all_checkbox value="true">' + '<input type="hidden" name=select_all_checkbox value="true">';
	                }
	                tmpl += '</th>';
	            }
	
	            // create header elements
	            for (var i in options.columns) {
	                var column = options.columns[i];
	                if (column.visible) {
	                    tmpl += '<th id="' + column.key + '-header">';
	                    if (column.href) {
	                        tmpl += '<a href="' + column.href + '" class="sort-link" sort_key="' + column.key + '">' + column.label + '</a>';
	                    } else {
	                        tmpl += column.label;
	                    }
	                    tmpl += '<span class="sort-arrow">' + column.extra + '</span>' + '</th>';
	                }
	            }
	
	            // finalize
	            tmpl += '</tr>';
	
	            // return template
	            return tmpl;
	        },
	
	        // template
	        body: function (options) {
	            // initialize
	            var tmpl = '';
	            var num_rows_rendered = 0;
	            var items_length = options.items.length;
	
	            // empty grid?
	            if (items_length == 0) {
	                // No results.
	                tmpl += '<tr><td colspan="100"><em>No Items</em></td></tr>';
	                num_rows_rendered = 1;
	            }
	
	            // create rows
	            for (var i in options.items) {
	
	                // encode ids
	                var item = options.items[i];
	                var encoded_id = item.encode_id;
	                var popupmenu_id = 'grid-' + i + '-popup';
	
	                // Tag current
	                tmpl += '<tr ';
	                if (options.current_item_id == item.id) {
	                    tmpl += 'class="current"';
	                }
	                tmpl += '>';
	
	                // Item selection column
	                if (options.show_item_checkboxes) {
	                    tmpl += '<td style="width: 1.5em;">' + '<input type="checkbox" name="id" value="' + encoded_id + '" id="' + encoded_id + '" class="grid-row-select-checkbox" />' + '</td>';
	                }
	
	                // Data columns
	                for (var j in options.columns) {
	                    var column = options.columns[j];
	                    if (column.visible) {
	                        // Nowrap
	                        var nowrap = '';
	                        if (column.nowrap) {
	                            nowrap = 'style="white-space:nowrap;"';
	                        }
	
	                        // get column settings
	                        var column_settings = item.column_config[column.label];
	
	                        // load attributes
	                        var link = column_settings.link;
	                        var value = column_settings.value;
	                        var target = column_settings.target;
	
	                        // unescape value
	                        if (jQuery.type(value) === 'string') {
	                            value = value.replace(/\/\//g, '/');
	                        }
	
	                        // Attach popup menu?
	                        var id = '';
	                        var cls = '';
	                        if (column.attach_popup) {
	                            id = 'grid-' + i + '-popup';
	                            cls = 'menubutton';
	                            if (link != '') {
	                                cls += ' split';
	                            }
	                            cls += ' popup';
	                        }
	
	                        // Check for row wrapping
	                        tmpl += '<td ' + nowrap + '>';
	
	                        // Link
	                        if (link) {
	                            if (options.operations.length != 0) {
	                                tmpl += '<div id="' + id + '" class="' + cls + '" style="float: left;">';
	                            }
	                            tmpl += '<a class="menubutton-label use-target" target="' + target + '" href="' + link + '" onclick="return false;">' + value + '</a>';
	                            if (options.operations.length != 0) {
	                                tmpl += '</div>';
	                            }
	                        } else {
	                            tmpl += '<div id="' + id + '" class="' + cls + '"><label id="' + column.label_id_prefix + encoded_id + '" for="' + encoded_id + '">' + (value || '') + '</label></div>';
	                        }
	                        tmpl += '</td>';
	                    }
	                }
	                tmpl += '</tr>';
	                num_rows_rendered++;
	            }
	            return tmpl;
	        },
	
	        // template
	        footer: function (options) {
	
	            // create template string
	            var tmpl = '';
	
	            // paging
	            if (options.use_paging && options.num_pages > 1) {
	                // get configuration
	                var num_page_links = options.num_page_links;
	                var cur_page_num = options.cur_page_num;
	                var num_pages = options.num_pages;
	
	                // First pass on min page.
	                var page_link_range = num_page_links / 2;
	                var min_page = cur_page_num - page_link_range;
	                var min_offset = 0;
	                if (min_page <= 0) {
	                    // Min page is too low.
	                    min_page = 1;
	                    min_offset = page_link_range - (cur_page_num - min_page);
	                }
	
	                // Set max page.
	                var max_range = page_link_range + min_offset;
	                var max_page = cur_page_num + max_range;
	                var max_offset;
	                if (max_page <= num_pages) {
	                    // Max page is fine.
	                    max_offset = 0;
	                } else {
	                    // Max page is too high.
	                    max_page = num_pages;
	                    // +1 to account for the +1 in the loop below.
	                    max_offset = max_range - (max_page + 1 - cur_page_num);
	                }
	
	                // Second and final pass on min page to add any unused
	                // offset from max to min.
	                if (max_offset != 0) {
	                    min_page -= max_offset;
	                    if (min_page < 1) {
	                        min_page = 1;
	                    }
	                }
	
	                // template header
	                tmpl += '<tr id="page-links-row">';
	                if (options.show_item_checkboxes) {
	                    tmpl += '<td></td>';
	                }
	                tmpl += '<td colspan="100">' + '<span id="page-link-container">' + 'Page:';
	
	                if (min_page > 1) {
	                    tmpl += '<span class="page-link" id="page-link-1"><a href="javascript:void(0);" page_num="1" onclick="return false;">1</a></span> ...';
	                }
	
	                // create page urls
	                for (var page_index = min_page; page_index < max_page + 1; page_index++) {
	
	                    if (page_index == options.cur_page_num) {
	                        tmpl += '<span class="page-link inactive-link" id="page-link-' + page_index + '">' + page_index + '</span>';
	                    } else {
	                        tmpl += '<span class="page-link" id="page-link-' + page_index + '"><a href="javascript:void(0);" onclick="return false;" page_num="' + page_index + '">' + page_index + '</a></span>';
	                    }
	                }
	
	                // show last page
	                if (max_page < num_pages) {
	                    tmpl += '...' + '<span class="page-link" id="page-link-' + num_pages + '"><a href="javascript:void(0);" onclick="return false;" page_num="' + num_pages + '">' + num_pages + '</a></span>';
	                }
	                tmpl += '</span>';
	
	                // Show all link
	                tmpl += '<span class="page-link" id="show-all-link-span"> | <a href="javascript:void(0);" onclick="return false;" page_num="all">Show All</a></span>' + '</td>' + '</tr>';
	            }
	
	            // Grid operations for multiple items.
	            if (options.show_item_checkboxes) {
	                // start template
	                tmpl += '<tr>' + '<input type="hidden" id="operation" name="operation" value="">' + '<td></td>' + '<td colspan="100">' + 'For <span class="grid-selected-count"></span> selected items: ';
	
	                // configure buttons for operations
	                for (var i in options.operations) {
	                    var operation = options.operations[i];
	                    if (operation.allow_multiple) {
	                        tmpl += '<input type="button" value="' + operation.label + '" class="operation-button action-button">&nbsp;';
	                    }
	                }
	
	                // finalize template
	                tmpl += '</td>' + '</tr>';
	            }
	
	            // count global operations
	            var found_global = false;
	            for (i in options.operations) {
	                if (options.operations[i].global_operation) {
	                    found_global = true;
	                    break;
	                }
	            }
	
	            // add global operations
	            if (found_global) {
	                tmpl += '<tr>' + '<td colspan="100">';
	                for (i in options.operations) {
	                    var operation = options.operations[i];
	                    if (operation.global_operation) {
	                        tmpl += '<a class="action-button" href="' + operation.global_operation + '">' + operation.label + '</a>';
	                    }
	                }
	                tmpl += '</td>' + '</tr>';
	            }
	
	            // add legend
	            if (options.legend) {
	                tmpl += '<tr>' + '<td colspan="100">' + options.legend + '</td>' + '</tr>';
	            }
	
	            // return
	            return tmpl;
	        },
	
	        // template
	        message: function (options) {
	            var status = options.status == 'success' ? 'done' : options.status;
	            return '<p>' + '<div class="' + status + 'message transient-message">' + _.escape(options.message) + '</div>' + '<div style="clear: both"></div>' + '</p>';
	        },
	
	        // template
	        grid_filters: function (options) {
	
	            // get filters
	            var default_filter_dict = options.default_filter_dict;
	            var filters = options.filters;
	
	            // show advanced search if flag set or if there are filters for advanced search fields
	            var advanced_search_display = 'none';
	            if (options.advanced_search) {
	                advanced_search_display = 'block';
	            }
	
	            // identify columns with advanced filtering
	            var show_advanced_search_link = false;
	            for (var i in options.columns) {
	                var column = options.columns[i];
	                if (column.filterable == 'advanced') {
	                    var column_key = column.key;
	                    var f_key = filters[column_key];
	                    var d_key = default_filter_dict[column_key];
	                    if (f_key && d_key && f_key != d_key) {
	                        advanced_search_display = 'block';
	                    }
	                    show_advanced_search_link = true;
	                }
	            }
	
	            // hide standard search if advanced is shown
	            var standard_search_display = 'block';
	            if (advanced_search_display == 'block') {
	                standard_search_display = 'none';
	            }
	
	            //
	            // standard search
	            //
	            var tmpl = '<div id="standard-search" style="display: ' + standard_search_display + ';">' + '<table>' + '<tr>' + '<td style="padding: 0;">' + '<table>';
	
	            // add standard filters
	            for (var i in options.columns) {
	                var column = options.columns[i];
	                if (column.filterable == 'standard') {
	                    tmpl += this.grid_column_filter(options, column);
	                }
	            }
	
	            // finalize standard search
	            tmpl += '</table>' + '</td>' + '</tr>' + '<tr>' + '<td>';
	
	            // show advanced search link in standard display
	            if (show_advanced_search_link) {
	                tmpl += '<a href="" class="advanced-search-toggle">Advanced Search</a>';
	            }
	
	            // finalize standard search display
	            tmpl += '</td>' + '</tr>' + '</table>' + '</div>';
	
	            //
	            // advanced search
	            //
	            tmpl += '<div id="advanced-search" style="display: ' + advanced_search_display + '; margin-top: 5px; border: 1px solid #ccc;">' + '<table>' + '<tr>' + '<td style="text-align: left" colspan="100">' + '<a href="" class="advanced-search-toggle">Close Advanced Search</a>' + '</td>' + '</tr>';
	
	            // add advanced filters
	            for (var i in options.columns) {
	                var column = options.columns[i];
	                if (column.filterable == 'advanced') {
	                    tmpl += this.grid_column_filter(options, column);
	                }
	            }
	
	            // finalize advanced search template
	            tmpl += '</table>' + '</div>';
	
	            // return template
	            return tmpl;
	        },
	
	        // template
	        grid_column_filter: function (options, column) {
	
	            // collect parameters
	            var default_filter_dict = options.default_filter_dict;
	            var filters = options.filters;
	            var column_label = column.label;
	            var column_key = column.key;
	            if (column.filterable == 'advanced') {
	                column_label = column_label.toLowerCase();
	            }
	
	            // start
	            var tmpl = '<tr>';
	
	            if (column.filterable == 'advanced') {
	                tmpl += '<td align="left" style="padding-left: 10px">' + column_label + ':</td>';
	            }
	            tmpl += '<td style="padding-bottom: 1px;">';
	            if (column.is_text) {
	                tmpl += '<form class="text-filter-form" column_key="' + column_key + '" action="' + options.url + '" method="get" >';
	                // Carry forward filtering criteria with hidden inputs.
	                for (i in options.columns) {
	                    var temp_column = options.columns[i];
	                    var filter_value = filters[temp_column.key];
	                    if (filter_value) {
	                        if (filter_value != 'All') {
	                            if (temp_column.is_text) {
	                                filter_value = JSON.stringify(filter_value);
	                            }
	                            tmpl += '<input type="hidden" id="' + temp_column.key + '" name="f-' + temp_column.key + '" value="' + filter_value + '"/>';
	                        }
	                    }
	                }
	                // Print current filtering criteria and links to delete.
	                tmpl += '<span id="' + column_key + '-filtering-criteria">';
	
	                // add filters
	                var column_filter = filters[column_key];
	                if (column_filter) {
	                    // identify type
	                    var type = jQuery.type(column_filter);
	
	                    // single filter value
	                    if (type == 'string') {
	                        if (column_filter != 'All') {
	                            // append template
	                            tmpl += this.filter_element(column_key, column_filter);
	                        }
	                    }
	
	                    // multiple filter values
	                    if (type == 'array') {
	                        for (var i in column_filter) {
	                            // get filter
	                            var filter = column_filter[i];
	
	                            // copy filters and remove entry
	                            var params = column_filter;
	                            params = params.slice(i);
	
	                            // append template
	                            tmpl += this.filter_element(column_key, filter);
	                        }
	                    }
	                }
	
	                // close span
	                tmpl += '</span>';
	
	                // Set value, size of search input field. Minimum size is 20 characters.
	                var value = '';
	                if (column.filterable == 'standard') {
	                    value = column.label.toLowerCase();
	                    var size = value.length;
	                    if (size < 20) {
	                        size = 20;
	                    }
	                    // +4 to account for space after placeholder
	                    size = size + 4;
	                }
	
	                // print input field for column
	                tmpl += '<span class="search-box">' + '<input class="search-box-input" id="input-' + column_key + '-filter" name="f-' + column_key + '" type="text" placeholder="' + value + '" size="' + size + '"/>' + '<button type="submit" style="background: transparent; border: none; padding: 4px; margin: 0px;">' + '<i class="fa fa-search"></i>' + '</button>' + '</span>' + '</form>';
	            } else {
	                // filter criteria
	                tmpl += '<span id="' + column_key + '-filtering-criteria">';
	
	                // add category filters
	                var seperator = false;
	                for (var cf_label in options.categorical_filters[column_key]) {
	                    // get category filter
	                    var cf = options.categorical_filters[column_key][cf_label];
	
	                    // each filter will have only a single argument, so get that single argument
	                    var cf_key = '';
	                    var cf_arg = '';
	                    for (var key in cf) {
	                        cf_key = key;
	                        cf_arg = cf[key];
	                    }
	
	                    // add seperator
	                    if (seperator) {
	                        tmpl += ' | ';
	                    }
	                    seperator = true;
	
	                    // add category
	                    var filter = filters[column_key];
	                    if (filter && cf[column_key] && filter == cf_arg) {
	                        tmpl += '<span class="categorical-filter ' + column_key + '-filter current-filter">' + cf_label + '</span>';
	                    } else {
	                        tmpl += '<span class="categorical-filter ' + column_key + '-filter">' + '<a href="javascript:void(0);" filter_key="' + cf_key + '" filter_val="' + cf_arg + '">' + cf_label + '</a>' + '</span>';
	                    }
	                }
	                tmpl += '</span>';
	            }
	            tmpl += '</td>' + '</tr>';
	
	            // return template
	            return tmpl;
	        },
	
	        // template for filter items
	        filter_element: function (filter_key, filter_value) {
	            filter_value = Utils.sanitize(filter_value);
	            return '<span class="text-filter-val">' + filter_value + '<a href="javascript:void(0);" filter_key="' + filter_key + '" filter_val="' + filter_value + '">' + '<i class="fa fa-times" style="padding-left: 5px; padding-bottom: 6px;"/>' + '</a>' + '</span>';
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Provides support for interacting with the GenomeSpace File Browser popup dialogue
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    // tool form templates
	    return {
	        openFileBrowser: function (options) {
	            var GS_UI_URL = window.Galaxy.config.genomespace_ui_url;
	            var GS_UPLOAD_URL = GS_UI_URL + 'upload/loadUrlToGenomespace.html?getLocation=true';
	
	            var newWin = window.open(GS_UPLOAD_URL, "GenomeSpace File Browser", "height=360px,width=600px");
	
	            successCalBack = options['successCallback'];
	            window.addEventListener("message", function (e) {
	                successCalBack(e.data);
	            }, false);
	
	            newWin.focus();
	
	            if (options['errorCallback'] != null) newWin.setCallbackOnGSUploadError = config['errorCallback'];
	        }
	
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** Renders the color picker used e.g. in the tool form **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    return Backbone.View.extend({
	        colors: {
	            standard: ['c00000', 'ff0000', 'ffc000', 'ffff00', '92d050', '00b050', '00b0f0', '0070c0', '002060', '7030a0'],
	            base: ['ffffff', '000000', 'eeece1', '1f497d', '4f81bd', 'c0504d', '9bbb59', '8064a2', '4bacc6', 'f79646'],
	            theme: [['f2f2f2', '7f7f7f', 'ddd9c3', 'c6d9f0', 'dbe5f1', 'f2dcdb', 'ebf1dd', 'e5e0ec', 'dbeef3', 'fdeada'], ['d8d8d8', '595959', 'c4bd97', '8db3e2', 'b8cce4', 'e5b9b7', 'd7e3bc', 'ccc1d9', 'b7dde8', 'fbd5b5'], ['bfbfbf', '3f3f3f', '938953', '548dd4', '95b3d7', 'd99694', 'c3d69b', 'b2a2c7', '92cddc', 'fac08f'], ['a5a5a5', '262626', '494429', '17365d', '366092', '953734', '76923c', '5f497a', '31859b', 'e36c09'], ['7f7f7e', '0c0c0c', '1d1b10', '0f243e', '244061', '632423', '4f6128', '3f3151', '205867', '974806']]
	        },
	
	        initialize: function (options) {
	            this.options = Utils.merge(options, {});
	            this.setElement(this._template());
	            this.$panel = this.$('.ui-color-picker-panel');
	            this.$view = this.$('.ui-color-picker-view');
	            this.$value = this.$('.ui-color-picker-value');
	            this.$header = this.$('.ui-color-picker-header');
	            this._build();
	            this.visible = false;
	            this.value(this.options.value);
	            this.$boxes = this.$('.ui-color-picker-box');
	            var self = this;
	            this.$boxes.on('click', function () {
	                self.value($(this).css('background-color'));
	                self.$header.trigger('click');
	            });
	            this.$header.on('click', function () {
	                self.visible = !self.visible;
	                if (self.visible) {
	                    self.$view.fadeIn('fast');
	                } else {
	                    self.$view.fadeOut('fast');
	                }
	            });
	        },
	
	        /** Get/set value */
	        value: function (new_val) {
	            if (new_val !== undefined && new_val !== null) {
	                this.$value.css('background-color', new_val);
	                this.$('.ui-color-picker-box').empty();
	                this.$(this._getValue()).html(this._templateCheck());
	                this.options.onchange && this.options.onchange(new_val);
	            }
	            return this._getValue();
	        },
	
	        /** Get value from dom */
	        _getValue: function () {
	            var rgb = this.$value.css('background-color');
	            rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
	            if (rgb) {
	                function hex(x) {
	                    return ('0' + parseInt(x).toString(16)).slice(-2);
	                }
	                return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
	            } else {
	                return null;
	            }
	        },
	
	        /** Build color panel */
	        _build: function () {
	            this._content({ colors: this.colors.base });
	            for (var i in this.colors.theme) {
	                var line_def = {};
	                if (i == 0) {
	                    line_def['bottom'] = true;
	                } else if (i != this.colors.theme.length - 1) {
	                    line_def['top'] = true;
	                    line_def['bottom'] = true;
	                } else {
	                    line_def['top'] = true;
	                }
	                line_def['colors'] = this.colors.theme[i];
	                this._content(line_def);
	            }
	            this._content({ colors: this.colors.standard });
	        },
	
	        /** Create content */
	        _content: function (options) {
	            var colors = options.colors;
	            var $content = $(this._templateContent());
	            var $line = $content.find('.line');
	            this.$panel.append($content);
	            for (var i in colors) {
	                var $box = $(this._templateBox(colors[i]));
	                if (options.top) {
	                    $box.css('border-top', 'none');
	                    $box.css('border-top-left-radius', '0px');
	                    $box.css('border-top-right-radius', '0px');
	                }
	                if (options.bottom) {
	                    $box.css('border-bottom', 'none');
	                    $box.css('border-bottom-left-radius', '0px');
	                    $box.css('border-bottom-right-radius', '0px');
	                }
	                $line.append($box);
	            }
	            return $content;
	        },
	
	        /** Check icon */
	        _templateCheck: function () {
	            return '<div class="ui-color-picker-check fa fa-check"/>';
	        },
	
	        /** Content template */
	        _templateContent: function () {
	            return '<div class="ui-color-picker-content">' + '<div class="line"/>' + '</div>';
	        },
	
	        /** Box template */
	        _templateBox: function (color) {
	            return '<div id="' + color + '" class="ui-color-picker-box" style="background-color: #' + color + ';"/>';
	        },
	
	        /** Main template */
	        _template: function () {
	            return '<div class="ui-color-picker">' + '<div class="ui-color-picker-header">' + '<div class="ui-color-picker-value"/>' + '<div class="ui-color-picker-label">Select a color</div>' + '</div>' + '<div class="ui-color-picker-view ui-input">' + '<div class="ui-color-picker-panel"/>' + '</div>';
	            '</div>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, _) {/** This class creates/wraps a drill down element. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Options) {
	
	    var View = Options.BaseIcons.extend({
	        initialize: function (options) {
	            options.type = options.display || 'checkbox';
	            options.multiple = options.type == 'checkbox';
	            Options.BaseIcons.prototype.initialize.call(this, options);
	        },
	
	        /** Set states for selected values */
	        _setValue: function (new_value) {
	            Options.BaseIcons.prototype._setValue.call(this, new_value);
	            if (new_value !== undefined && new_value !== null && this.header_index) {
	                var self = this;
	                var values = $.isArray(new_value) ? new_value : [new_value];
	                _.each(values, function (v) {
	                    var list = self.header_index[v];
	                    _.each(list, function (element) {
	                        self._setState(element, true);
	                    });
	                });
	            }
	        },
	
	        /** Expand/collapse a sub group */
	        _setState: function (header_id, is_expanded) {
	            var $button = this.$('.button-' + header_id);
	            var $subgroup = this.$('.subgroup-' + header_id);
	            $button.data('is_expanded', is_expanded);
	            if (is_expanded) {
	                $subgroup.show();
	                $button.removeClass('fa-plus-square').addClass('fa-minus-square');
	            } else {
	                $subgroup.hide();
	                $button.removeClass('fa-minus-square').addClass('fa-plus-square');
	            }
	        },
	
	        /** Template to create options tree */
	        _templateOptions: function () {
	            var self = this;
	            this.header_index = {};
	
	            // attach event handler
	            function attach($el, header_id) {
	                var $button = $el.find('.button-' + header_id);
	                $button.on('click', function () {
	                    self._setState(header_id, !$button.data('is_expanded'));
	                });
	            }
	
	            // recursive function which iterates through options
	            function iterate($tmpl, options, header) {
	                header = header || [];
	                for (var i in options) {
	                    var level = options[i];
	                    var has_options = level.options && level.options.length > 0;
	                    var new_header = header.slice(0);
	                    self.header_index[level.value] = new_header.slice(0);
	                    var $group = $('<div/>');
	                    if (has_options) {
	                        var header_id = Utils.uid();
	                        var $button = $('<span/>').addClass('button-' + header_id).addClass('ui-drilldown-button fa fa-plus-square');
	                        var $subgroup = $('<div/>').addClass('subgroup-' + header_id).addClass('ui-drilldown-subgroup');
	                        $group.append($('<div/>').append($button).append(self._templateOption({ label: level.name, value: level.value })));
	                        new_header.push(header_id);
	                        iterate($subgroup, level.options, new_header);
	                        $group.append($subgroup);
	                        attach($group, header_id);
	                    } else {
	                        $group.append(self._templateOption({ label: level.name, value: level.value }));
	                    }
	                    $tmpl.append($group);
	                }
	            }
	
	            // iterate through options and create dom
	            var $tmpl = $('<div/>');
	            iterate($tmpl, this.model.get('data'));
	            return $tmpl;
	        },
	
	        /** Template for drill down view */
	        _template: function () {
	            return $('<div/>').addClass('ui-options-list drilldown-container').attr('id', this.model.id);
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Select) {
	
	    /** Batch mode variations */
	    var Batch = { DISABLED: 'disabled', ENABLED: 'enabled', LINKED: 'linked' };
	
	    /** List of available content selectors options */
	    var Configurations = {
	        data: [{ src: 'hda', icon: 'fa-file-o', tooltip: 'Single dataset', multiple: false, batch: Batch.DISABLED }, { src: 'hda', icon: 'fa-files-o', tooltip: 'Multiple datasets', multiple: true, batch: Batch.LINKED }, { src: 'hdca', icon: 'fa-folder-o', tooltip: 'Dataset collection', multiple: false, batch: Batch.LINKED }],
	        data_multiple: [{ src: 'hda', icon: 'fa-files-o', tooltip: 'Multiple datasets', multiple: true, batch: Batch.DISABLED }, { src: 'hdca', icon: 'fa-folder-o', tooltip: 'Dataset collections', multiple: true, batch: Batch.DISABLED }],
	        data_collection: [{ src: 'hdca', icon: 'fa-folder-o', tooltip: 'Dataset collection', multiple: false, batch: Batch.DISABLED }],
	        workflow_data: [{ src: 'hda', icon: 'fa-file-o', tooltip: 'Single dataset', multiple: false, batch: Batch.DISABLED }],
	        workflow_data_multiple: [{ src: 'hda', icon: 'fa-files-o', tooltip: 'Multiple datasets', multiple: true, batch: Batch.DISABLED }],
	        workflow_data_collection: [{ src: 'hdca', icon: 'fa-folder-o', tooltip: 'Dataset collection', multiple: false, batch: Batch.DISABLED }],
	        module_data: [{ src: 'hda', icon: 'fa-file-o', tooltip: 'Single dataset', multiple: false, batch: Batch.DISABLED }, { src: 'hda', icon: 'fa-files-o', tooltip: 'Multiple datasets', multiple: true, batch: Batch.ENABLED }],
	        module_data_collection: [{ src: 'hdca', icon: 'fa-folder-o', tooltip: 'Dataset collection', multiple: false, batch: Batch.DISABLED }, { src: 'hdca', icon: 'fa-folder', tooltip: 'Multiple collections', multiple: true, batch: Batch.ENABLED }]
	    };
	
	    /** View for hda and hdca content selector ui elements */
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model({
	                src_labels: { 'hda': 'dataset', 'hdca': 'dataset collection' },
	                pagelimit: 100,
	                statustimer: 1000
	            }).set(options);
	            this.setElement($('<div/>').addClass('ui-select-content'));
	            this.button_product = new Ui.RadioButton.View({
	                value: 'false',
	                data: [{ icon: 'fa fa-chain', value: 'false',
	                    tooltip: 'Linked inputs will be run in matched order with other datasets e.g. use this for matching forward and reverse reads.' }, { icon: 'fa fa-chain-broken', value: 'true',
	                    tooltip: 'Unlinked dataset inputs will be run against *all* other inputs.' }] });
	            var $batch_div = $('<div/>').addClass('ui-form-info').append($('<i/>').addClass('fa fa-sitemap')).append($('<span/>').html('This is a batch mode input field. Separate jobs will be triggered for each dataset selection.'));
	            this.$batch = {
	                linked: $batch_div.clone(),
	                enabled: $batch_div.clone().append($('<div/>').append($('<div/>').addClass('ui-form-title').html('Batch options:')).append(this.button_product.$el)).append($('<div/>').css('clear', 'both'))
	            };
	
	            // add drag-drop event handlers
	            this.$el.on('dragenter', function (e) {
	                this.lastenter = e.target;self.$el.addClass('ui-dragover');
	            }).on('dragover', function (e) {
	                e.preventDefault();
	            }).on('dragleave', function (e) {
	                this.lastenter === e.target && self.$el.removeClass('ui-dragover');
	            }).on('drop', function (e) {
	                self._handleDrop(e);
	            });
	
	            // track current history elements
	            this.history = {};
	
	            // add listeners
	            this.listenTo(this.model, 'change:data', this._changeData, this);
	            this.listenTo(this.model, 'change:wait', this._changeWait, this);
	            this.listenTo(this.model, 'change:current', this._changeCurrent, this);
	            this.listenTo(this.model, 'change:value', this._changeValue, this);
	            this.listenTo(this.model, 'change:type change:optional change:multiple change:extensions', this._changeType, this);
	            this.render();
	
	            // add change event
	            this.on('change', function () {
	                options.onchange && options.onchange(self.value());
	            });
	        },
	
	        render: function () {
	            this._changeType();
	            this._changeValue();
	            this._changeWait();
	        },
	
	        /** Indicate that select fields are being updated */
	        wait: function () {
	            this.model.set('wait', true);
	        },
	
	        /** Indicate that the options update has been completed */
	        unwait: function () {
	            this.model.set('wait', false);
	        },
	
	        /** Update data representing selectable options */
	        update: function (options) {
	            this.model.set('data', options);
	        },
	
	        /** Return the currently selected dataset values */
	        value: function (new_value) {
	            new_value !== undefined && this.model.set('value', new_value);
	            var current = this.model.get('current');
	            if (this.config[current]) {
	                var id_list = this.fields[current].value();
	                if (id_list !== null) {
	                    id_list = $.isArray(id_list) ? id_list : [id_list];
	                    if (id_list.length > 0) {
	                        var result = this._batch({ values: [] });
	                        for (var i in id_list) {
	                            var details = this.history[id_list[i] + '_' + this.config[current].src];
	                            if (details) {
	                                result.values.push(details);
	                            } else {
	                                Galaxy.emit.debug('ui-select-content::value()', 'Requested details not found for \'' + id_list[i] + '\'.');
	                                return null;
	                            }
	                        }
	                        result.values.sort(function (a, b) {
	                            return a.hid - b.hid;
	                        });
	                        return result;
	                    }
	                }
	            } else {
	                Galaxy.emit.debug('ui-select-content::value()', 'Invalid value/source \'' + new_value + '\'.');
	            }
	            return null;
	        },
	
	        /** Change of current select field */
	        _changeCurrent: function () {
	            var self = this;
	            _.each(this.fields, function (field, i) {
	                if (self.model.get('current') == i) {
	                    field.$el.show();
	                    _.each(self.$batch, function ($batchfield, batchmode) {
	                        $batchfield[self.config[i].batch == batchmode ? 'show' : 'hide']();
	                    });
	                    self.button_type.value(i);
	                } else {
	                    field.$el.hide();
	                }
	            });
	        },
	
	        /** Change of type */
	        _changeType: function () {
	            var self = this;
	
	            // identify selector type identifier i.e. [ flavor ]_[ type ]_[ multiple ]
	            var config_id = (this.model.get('flavor') ? this.model.get('flavor') + '_' : '') + String(this.model.get('type')) + (this.model.get('multiple') ? '_multiple' : '');
	            if (Configurations[config_id]) {
	                this.config = Configurations[config_id];
	            } else {
	                this.config = Configurations['data'];
	                Galaxy.emit.debug('ui-select-content::_changeType()', 'Invalid configuration/type id \'' + config_id + '\'.');
	            }
	
	            // prepare extension component of error message
	            var data = self.model.get('data');
	            var extensions = Utils.textify(this.model.get('extensions'));
	            var src_labels = this.model.get('src_labels');
	
	            // build views
	            this.fields = [];
	            this.button_data = [];
	            _.each(this.config, function (c, i) {
	                self.button_data.push({
	                    value: i,
	                    icon: c.icon,
	                    tooltip: c.tooltip
	                });
	                self.fields.push(new Select.View({
	                    optional: self.model.get('optional'),
	                    multiple: c.multiple,
	                    searchable: !c.multiple || data && data[c.src] && data[c.src].length > self.model.get('pagelimit'),
	                    individual: true,
	                    error_text: 'No ' + (extensions ? extensions + ' ' : '') + (src_labels[c.src] || 'content') + ' available.',
	                    onchange: function () {
	                        self.trigger('change');
	                    }
	                }));
	            });
	            this.button_type = new Ui.RadioButton.View({
	                value: this.model.get('current'),
	                data: this.button_data,
	                onchange: function (value) {
	                    self.model.set('current', value);
	                    self.trigger('change');
	                }
	            });
	
	            // append views
	            this.$el.empty();
	            var button_width = 0;
	            if (this.fields.length > 1) {
	                this.$el.append(this.button_type.$el);
	                button_width = Math.max(0, this.fields.length * 36) + 'px';
	            }
	            _.each(this.fields, function (field) {
	                self.$el.append(field.$el.css({ 'margin-left': button_width }));
	            });
	            _.each(this.$batch, function ($batchfield, batchmode) {
	                self.$el.append($batchfield.css({ 'margin-left': button_width }));
	            });
	            this.model.set('current', 0);
	            this._changeCurrent();
	            this._changeData();
	        },
	
	        /** Change of wait flag */
	        _changeWait: function () {
	            var self = this;
	            _.each(this.fields, function (field) {
	                field[self.model.get('wait') ? 'wait' : 'unwait']();
	            });
	        },
	
	        /** Change of available options */
	        _changeData: function () {
	            var options = this.model.get('data');
	            var self = this;
	            var select_options = {};
	            _.each(options, function (items, src) {
	                select_options[src] = [];
	                _.each(items, function (item) {
	                    select_options[src].push({
	                        hid: item.hid,
	                        keep: item.keep,
	                        label: item.hid + ': ' + item.name,
	                        value: item.id,
	                        tags: item.tags
	                    });
	                    self.history[item.id + '_' + src] = item;
	                });
	            });
	            _.each(this.config, function (c, i) {
	                select_options[c.src] && self.fields[i].add(select_options[c.src], function (a, b) {
	                    return b.hid - a.hid;
	                });
	            });
	        },
	
	        /** Change of incoming value */
	        _changeValue: function () {
	            var new_value = this.model.get('value');
	            if (new_value && new_value.values && new_value.values.length > 0) {
	                // create list with content ids
	                var list = [];
	                _.each(new_value.values, function (value) {
	                    list.push(value.id);
	                });
	                // sniff first suitable field type from config list
	                var src = new_value.values[0].src;
	                var multiple = new_value.values.length > 1;
	                for (var i = 0; i < this.config.length; i++) {
	                    var field = this.fields[i];
	                    var c = this.config[i];
	                    if (c.src == src && [multiple, true].indexOf(c.multiple) !== -1) {
	                        this.model.set('current', i);
	                        field.value(list);
	                        break;
	                    }
	                }
	            } else {
	                _.each(this.fields, function (field) {
	                    field.value(null);
	                });
	            }
	        },
	
	        /** Handles drop events e.g. from history panel */
	        _handleDrop: function (ev) {
	            try {
	                var data = this.model.get('data');
	                var current = this.model.get('current');
	                var config = this.config[current];
	                var field = this.fields[current];
	                var drop_data = JSON.parse(ev.originalEvent.dataTransfer.getData('text'))[0];
	                var new_id = drop_data.id;
	                var new_src = drop_data.history_content_type == 'dataset' ? 'hda' : 'hdca';
	                var new_value = { id: new_id, src: new_src };
	                if (data && _.findWhere(data[new_src], new_value)) {
	                    if (config.src == new_src) {
	                        var current_value = field.value();
	                        if (current_value && config.multiple) {
	                            if (current_value.indexOf(new_id) == -1) {
	                                current_value.push(new_id);
	                            }
	                        } else {
	                            current_value = new_id;
	                        }
	                        field.value(current_value);
	                    } else {
	                        this.model.set('value', { values: [new_value] });
	                        this.model.trigger('change:value');
	                    }
	                    this.trigger('change');
	                    this._handleDropStatus('success');
	                } else {
	                    this._handleDropStatus('danger');
	                }
	            } catch (e) {
	                this._handleDropStatus('danger');
	            }
	            ev.preventDefault();
	        },
	
	        /** Highlight drag result */
	        _handleDropStatus: function (status) {
	            var self = this;
	            this.$el.removeClass('ui-dragover').addClass('ui-dragover-' + status);
	            setTimeout(function () {
	                self.$el.removeClass('ui-dragover-' + status);
	            }, this.model.get('statustimer'));
	        },
	
	        /** Assists in identifying the batch mode */
	        _batch: function (result) {
	            result['batch'] = false;
	            var current = this.model.get('current');
	            var config = this.config[current];
	            if (config.src == 'hdca' && !config.multiple) {
	                var hdca = this.history[this.fields[current].value() + '_hdca'];
	                if (hdca && hdca.map_over_type) {
	                    result['batch'] = true;
	                }
	            }
	            if (config.batch == Batch.LINKED || config.batch == Batch.ENABLED) {
	                result['batch'] = true;
	                if (config.batch == Batch.ENABLED && this.button_product.value() === 'true') {
	                    result['product'] = true;
	                }
	            }
	            return result;
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, List) {
	
	    /**
	     * FTP file selector
	     */
	    var View = Backbone.View.extend({
	        // initialize
	        initialize: function (options) {
	            // link this
	            var self = this;
	
	            // create ui-list view to keep track of selected ftp files
	            this.ftpfile_list = new List.View({
	                name: 'file',
	                optional: options.optional,
	                multiple: options.multiple,
	                onchange: function () {
	                    options.onchange && options.onchange(self.value());
	                }
	            });
	
	            // create elements
	            this.setElement(this.ftpfile_list.$el);
	
	            // initial fetch of ftps
	            Utils.get({
	                url: Galaxy.root + 'api/remote_files',
	                success: function (response) {
	                    var data = [];
	                    for (var i in response) {
	                        data.push({
	                            value: response[i]['path'],
	                            label: response[i]['path']
	                        });
	                    }
	                    self.ftpfile_list.update(data);
	                }
	            });
	        },
	
	        /** Return/Set currently selected ftp datasets */
	        value: function (val) {
	            return this.ftpfile_list.value(val);
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, GenomespaceBrowser) {
	
	    /**
	     * GenomeSpace file selector
	     */
	    var View = Backbone.View.extend({
	        // initialize
	        initialize: function (options) {
	
	            // link this
	            var self = this;
	
	            // create insert new list element button
	            this.browse_button = new Ui.ButtonIcon({
	                title: 'Browse',
	                icon: 'fa fa-sign-in',
	                tooltip: 'Browse GenomeSpace',
	                onclick: function () {
	                    self.browseGenomeSpace();
	                }
	            });
	
	            // create genomespace filepath textbox
	            this.filename_textbox = new Ui.Input();
	
	            // create elements
	            this.setElement(this._template(options));
	            this.$(".ui-gs-browse-button").append(this.browse_button.$el);
	            this.$(".ui-gs-filename-textbox").append(this.filename_textbox.$el);
	        },
	
	        /** Browse GenomeSpace */
	        browseGenomeSpace: function (options) {
	            var self = this;
	            GenomespaceBrowser.openFileBrowser({
	                successCallback: function (data) {
	                    self.value(data.destination);
	                }
	            });
	        },
	
	        /** Main Template */
	        _template: function (options) {
	            return '<div class="ui-gs-select-file">' + '<div class="ui-gs-browse-field">' + '<span class="ui-gs-browse-button" />' + '<span class="ui-gs-filename-textbox" />' + "</div>" + "</div>";
	        },
	
	        /** Return/Set currently selected genomespace filename */
	        value: function (new_value) {
	            // check if new_value is defined
	            if (new_value !== undefined) {
	                this._setValue(new_value);
	            } else {
	                return this._getValue();
	            }
	        },
	
	        // get value
	        _getValue: function () {
	            return this.filename_textbox.value();
	        },
	
	        // set value
	        _setValue: function (new_value) {
	            if (new_value) {
	                this.filename_textbox.value(new_value);
	            }
	        }
	
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {// dependencies
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(24), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Table, List) {
	
	    // collection of libraries
	    var Libraries = Backbone.Collection.extend({
	        url: Galaxy.root + 'api/libraries?deleted=false'
	    });
	
	    // collection of dataset
	    var LibraryDatasets = Backbone.Collection.extend({
	        initialize: function () {
	            var self = this;
	            this.config = new Backbone.Model({ library_id: null });
	            this.config.on('change', function () {
	                self.fetch({ reset: true });
	            });
	        },
	        url: function () {
	            return Galaxy.root + 'api/libraries/' + this.config.get('library_id') + '/contents';
	        }
	    });
	
	    // hda/hdca content selector ui element
	    var View = Backbone.View.extend({
	        // initialize
	        initialize: function (options) {
	            // link this
	            var self = this;
	
	            // collections
	            this.libraries = new Libraries();
	            this.datasets = new LibraryDatasets();
	
	            // link app and options
	            this.options = options;
	
	            // select field for the library
	            // TODO: Remove this once the library API supports searching for library datasets
	            this.library_select = new Ui.Select.View({
	                onchange: function (value) {
	                    self.datasets.config.set('library_id', value);
	                }
	            });
	
	            // create ui-list view to keep track of selected data libraries
	            this.dataset_list = new List.View({
	                name: 'dataset',
	                optional: options.optional,
	                multiple: options.multiple,
	                onchange: function () {
	                    self.trigger('change');
	                }
	            });
	
	            // add reset handler for fetched libraries
	            this.libraries.on('reset', function () {
	                var data = [];
	                self.libraries.each(function (model) {
	                    data.push({
	                        value: model.id,
	                        label: model.get('name')
	                    });
	                });
	                self.library_select.update(data);
	            });
	
	            // add reset handler for fetched library datasets
	            this.datasets.on('reset', function () {
	                var data = [];
	                var library_current = self.library_select.text();
	                if (library_current !== null) {
	                    self.datasets.each(function (model) {
	                        if (model.get('type') === 'file') {
	                            data.push({
	                                value: model.id,
	                                label: model.get('name')
	                            });
	                        }
	                    });
	                }
	                self.dataset_list.update(data);
	            });
	
	            // add change event. fires on trigger
	            this.on('change', function () {
	                options.onchange && options.onchange(self.value());
	            });
	
	            // create elements
	            this.setElement(this._template());
	            this.$('.library-select').append(this.library_select.$el);
	            this.$el.append(this.dataset_list.$el);
	
	            // initial fetch of libraries
	            this.libraries.fetch({
	                reset: true,
	                success: function () {
	                    self.library_select.trigger('change');
	                    if (self.options.value !== undefined) {
	                        self.value(self.options.value);
	                    }
	                }
	            });
	        },
	
	        /** Return/Set currently selected library datasets */
	        value: function (val) {
	            return this.dataset_list.value(val);
	        },
	
	        /** Template */
	        _template: function () {
	            return '<div class="ui-select-library">' + '<div class="library ui-margin-bottom">' + '<span class="library-title">Select Library</span>' + '<span class="library-select"/>' + '</div>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model({
	                id: Utils.uid(),
	                min: null,
	                max: null,
	                step: null,
	                precise: false,
	                split: 10000,
	                value: null,
	                onchange: function () {}
	            }).set(options);
	
	            // create new element
	            this.setElement(this._template());
	            this.$el.attr('id', this.model.id);
	            this.$text = this.$('.ui-form-slider-text');
	            this.$slider = this.$('.ui-form-slider-element');
	
	            // add text field event
	            var pressed = [];
	            this.$text.on('change', function () {
	                self.value($(this).val());
	            }).on('keyup', function (e) {
	                pressed[e.which] = false;
	            }).on('keydown', function (e) {
	                var v = e.which;
	                pressed[v] = true;
	                if (self.model.get('is_workflow') && pressed[16] && v == 52) {
	                    self.value('$');
	                    event.preventDefault();
	                } else if (!(v == 8 || v == 9 || v == 13 || v == 37 || v == 39 || v >= 48 && v <= 57 && !pressed[16] || v >= 96 && v <= 105 || (v == 190 || v == 110) && $(this).val().indexOf('.') == -1 && self.model.get('precise') || (v == 189 || v == 109) && $(this).val().indexOf('-') == -1 || self._isParameter($(this).val()) || pressed[91] || pressed[17])) {
	                    event.preventDefault();
	                }
	            });
	
	            // build slider, cannot be rebuild in render
	            var opts = this.model.attributes;
	            this.has_slider = opts.max !== null && opts.min !== null && opts.max > opts.min;
	            var step = opts.step;
	            if (!step) {
	                if (opts.precise && this.has_slider) {
	                    step = (opts.max - opts.min) / opts.split;
	                } else {
	                    step = 1.0;
	                }
	            }
	            if (this.has_slider) {
	                this.$text.addClass('ui-form-slider-left');
	                this.$slider.slider({ min: opts.min, max: opts.max, step: step }).on('slide', function (event, ui) {
	                    self.value(ui.value);
	                });
	            } else {
	                this.$slider.hide();
	            }
	
	            // add listeners
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	        },
	
	        render: function () {
	            var value = this.model.get('value');
	            this.has_slider && this.$slider.slider('value', value);
	            value !== this.$text.val() && this.$text.val(value);
	        },
	
	        /** Set and return the current value */
	        value: function (new_val) {
	            var options = this.model.attributes;
	            if (new_val !== undefined) {
	                if (new_val !== null && new_val !== '' && !this._isParameter(new_val)) {
	                    isNaN(new_val) && (new_val = 0);
	                    !options.precise && (new_val = Math.round(new_val));
	                    options.max !== null && (new_val = Math.min(new_val, options.max));
	                    options.min !== null && (new_val = Math.max(new_val, options.min));
	                }
	                this.model.set('value', new_val);
	                this.model.trigger('change');
	                options.onchange(new_val);
	            }
	            return this.model.get('value');
	        },
	
	        /** Return true if the field contains a workflow parameter i.e. $('name') */
	        _isParameter: function (value) {
	            return this.model.get('is_workflow') && String(value).substring(0, 1) === '$';
	        },
	
	        /** Slider template */
	        _template: function () {
	            return '<div class="ui-form-slider">' + '<input class="ui-form-slider-text" type="text"/>' + '<div class="ui-form-slider-element"/>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var Model = Backbone.Model.extend({
	        defaults: {
	            extension: 'auto',
	            genome: '?',
	            url_paste: '',
	            status: 'init',
	            info: null,
	            file_name: '',
	            file_mode: '',
	            file_size: 0,
	            file_type: null,
	            file_path: '',
	            file_data: null,
	            percentage: 0,
	            space_to_tab: false,
	            to_posix_lines: true,
	            enabled: true
	        },
	        reset: function (attr) {
	            this.clear().set(this.defaults).set(attr);
	        }
	    });
	    var Collection = Backbone.Collection.extend({ model: Model });
	    return { Model: Model, Collection: Collection };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (baseMVC, _l) {
	    // =============================================================================
	    /** A view on any model that has a 'tags' attribute (a list of tag strings)
	     *      Incorporates the select2 jQuery plugin for tags display/editing:
	     *      http://ivaynberg.github.io/select2/
	     */
	    var TagsEditor = Backbone.View.extend(baseMVC.LoggableMixin).extend(baseMVC.HiddenUntilActivatedViewMixin).extend({
	
	        tagName: 'div',
	        className: 'tags-display',
	        select_width: '100%',
	        events: {},
	
	        /** Set up listeners, parse options */
	        initialize: function (options) {
	            //console.debug( this, options );
	            // only listen to the model only for changes to tags - re-render
	            this.show_editor = false;
	            if (options.usePrompt === false) {
	                this.label = '';
	            } else {
	                this.label = '<label class="prompt">' + _l('Tags') + '</label>';
	            }
	            this.workflow_mode = options.workflow_mode || false;
	            if (this.workflow_mode) {
	                this.events.click = 'showEditor';
	                this.events.keydown = 'keydownHandler';
	            }
	            this.hiddenUntilActivated(options.$activator, options);
	        },
	
	        /** Build the DOM elements, call select to on the created input, and set up behaviors */
	        render: function () {
	            var self = this;
	            if (this.workflow_mode) {
	                this.$el.html(this._workflowTemplate());
	            } else {
	                this.$el.html(this._defaultTemplate());
	            }
	            this.$input().select2({
	                placeholder: 'Add tags',
	                width: this.workflow_mode ? this.width : this.select_width,
	                tags: function () {
	                    // initialize possible tags in the dropdown based on all the tags the user has used so far
	                    return self._getTagsUsed();
	                }
	            });
	
	            this._setUpBehaviors();
	            return this;
	        },
	
	        _hashToName: function (tag) {
	            if (tag.startsWith('#')) {
	                return 'name:' + tag.slice(1);
	            }
	            return tag;
	        },
	
	        _nameToHash: function (tag) {
	            if (tag.startsWith('name:')) {
	                tag = '#' + tag.slice(5);
	            }
	            return tag;
	        },
	
	        /** @returns {String} the html text used to build the view's DOM */
	        _defaultTemplate: function () {
	            return [this.label, this._renderEditor()].join('');
	        },
	
	        _workflowTemplate: function () {
	            // Shows labels by default, event handler controls whether we show tags or editor
	            return [this.show_editor ? this._renderEditor() : this._renderTags()].join(' ');
	        },
	
	        keydownHandler: function (e) {
	            switch (e.which) {
	                // esc
	                case 27:
	                    // hide the tag editor when pressing escape
	                    this.hideEditor();
	                    break;
	            }
	        },
	
	        showEditor: function () {
	            this.show_editor = true;
	            this.render();
	        },
	
	        hideEditor: function () {
	            this.show_editor = false;
	            this.render();
	        },
	
	        _renderEditor: function () {
	            // set up initial tags by adding as CSV to input vals (necc. to init select2)
	            return '<input class="tags-input" value="' + this.tagsToCSV() + '"/>';
	        },
	
	        _renderTags: function () {
	            var tags = this.model.get('tags');
	            var addButton = 'static/images/fugue/tag--plus.png';
	            var renderedArray = [];
	            _.each(tags, function (tag) {
	                tag = tag.indexOf("name:") == 0 ? tag.slice(5) : tag;
	                var renderString = '<span class="label label-info">' + tag + '</span>';
	                renderedArray.push(renderString);
	            });
	            if (renderedArray.length === 0) {
	                // If there are no tags to render we just show the add-tag-button
	                renderedArray.push('<img src=' + addButton + ' class="add-tag-button" title="Add tags"/>');
	            }
	            return renderedArray.join(" ");
	        },
	
	        /** @returns {String} the sorted, comma-separated tags from the model */
	        tagsToCSV: function () {
	            var self = this;
	            var tagsArray = this.model.get('tags');
	            if (!_.isArray(tagsArray) || _.isEmpty(tagsArray)) {
	                return '';
	            }
	            return tagsArray.map(function (tag) {
	                return _.escape(self._nameToHash(tag));
	            }).sort().join(',');
	        },
	
	        /** @returns {jQuery} the input for this view */
	        $input: function () {
	            return this.$el.find('input.tags-input');
	        },
	
	        /** @returns {String[]} all tags used by the current user */
	        _getTagsUsed: function () {
	            //TODO: global
	            var self = this;
	            return _.map(Galaxy.user.get('tags_used'), self._nameToHash);
	        },
	
	        /** set up any event listeners on the view's DOM (mostly handled by select2) */
	        _setUpBehaviors: function () {
	            var self = this;
	            this.$input().on('change', function (event) {
	                // Modify any 'hashtag' 'nametags'
	                event.val = _.map(event.val, self._hashToName);
	                // save the model's tags in either remove or added event
	                self.model.save({ tags: event.val });
	                // if it's new, add the tag to the users tags
	                if (event.added) {
	                    //??: solve weird behavior in FF on test.galaxyproject.org where
	                    //  event.added.text is string object: 'String{ 0="o", 1="n", 2="e" }'
	                    self._addNewTagToTagsUsed(event.added.text + '');
	                }
	            });
	        },
	
	        /** add a new tag (if not already there) to the list of all tags used by the user
	         *  @param {String} newTag  the tag to add to the list of used
	         */
	        _addNewTagToTagsUsed: function (newTag) {
	            //TODO: global
	            var tagsUsed = Galaxy.user.get('tags_used');
	            if (!_.contains(tagsUsed, newTag)) {
	                tagsUsed.push(newTag);
	                tagsUsed.sort();
	                Galaxy.user.set('tags_used', tagsUsed);
	            }
	        },
	
	        /** shut down event listeners and remove this view's DOM */
	        remove: function () {
	            this.$input.off();
	            this.stopListening(this.model);
	            Backbone.View.prototype.remove.call(this);
	        },
	
	        /** string rep */
	        toString: function () {
	            return ['TagsEditor(', this.model + '', ')'].join('');
	        }
	    });
	
	    return {
	        TagsEditor: TagsEditor
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, _) {/**
	    This is the base class of the tool form plugin. This class is e.g. inherited by the regular and the workflow tool form.
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(50), __webpack_require__(5), __webpack_require__(10), __webpack_require__(28), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Deferred, Ui, FormBase, CitationModel, CitationView) {
	    return FormBase.extend({
	        initialize: function (options) {
	            var self = this;
	            this.deferred = new Deferred();
	            FormBase.prototype.initialize.call(this, options);
	
	            // optional model update
	            this._update(this.model.get('initialmodel'));
	
	            // listen to history panel
	            if (this.model.get('listen_to_history') && parent.Galaxy && parent.Galaxy.currHistoryPanel) {
	                this.listenTo(parent.Galaxy.currHistoryPanel.collection, 'change', function () {
	                    self.model.get('onchange')();
	                });
	            }
	            // destroy dom elements
	            this.$el.on('remove', function () {
	                self._destroy();
	            });
	        },
	
	        /** Allows tool form variation to update tool model */
	        _update: function (callback) {
	            var self = this;
	            callback = callback || this.model.get('buildmodel');
	            if (callback) {
	                this.deferred.reset();
	                this.deferred.execute(function (process) {
	                    callback(process, self);
	                    process.then(function () {
	                        self._render();
	                    });
	                });
	            } else {
	                this._render();
	            }
	        },
	
	        /** Wait for deferred build processes before removal */
	        _destroy: function () {
	            var self = this;
	            this.$el.off().hide();
	            this.deferred.execute(function () {
	                FormBase.prototype.remove.call(self);
	                Galaxy.emit.debug('tool-form-base::_destroy()', 'Destroy view.');
	            });
	        },
	
	        /** Build form */
	        _render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.model.set({
	                title: options.fixed_title || '<b>' + options.name + '</b> ' + options.description + ' (Galaxy Version ' + options.version + ')',
	                operations: !options.hide_operations && this._operations(),
	                onchange: function () {
	                    self.deferred.reset();
	                    self.deferred.execute(function (process) {
	                        self.model.get('postchange')(process, self);
	                    });
	                }
	            });
	            this.render();
	            if (!this.model.get('collapsible')) {
	                this.$el.append($('<div/>').addClass('ui-margin-top-large').append(this._footer()));
	            }
	            this.show_message && this.message.update({
	                status: 'success',
	                message: 'Now you are using \'' + options.name + '\' version ' + options.version + ', id \'' + options.id + '\'.',
	                persistent: false
	            });
	            this.show_message = true;
	        },
	
	        /** Create tool operation menu */
	        _operations: function () {
	            var self = this;
	            var options = this.model.attributes;
	
	            // button for version selection
	            var versions_button = new Ui.ButtonMenu({
	                icon: 'fa-cubes',
	                title: !options.narrow && 'Versions' || null,
	                tooltip: 'Select another tool version'
	            });
	            if (!options.sustain_version && options.versions && options.versions.length > 1) {
	                for (var i in options.versions) {
	                    var version = options.versions[i];
	                    if (version != options.version) {
	                        versions_button.addMenu({
	                            title: 'Switch to ' + version,
	                            version: version,
	                            icon: 'fa-cube',
	                            onclick: function () {
	                                // here we update the tool version (some tools encode the version also in the id)
	                                self.model.set('id', options.id.replace(options.version, this.version));
	                                self.model.set('version', this.version);
	                                self._update();
	                            }
	                        });
	                    }
	                }
	            } else {
	                versions_button.$el.hide();
	            }
	
	            // button for options e.g. search, help
	            var menu_button = new Ui.ButtonMenu({
	                icon: 'fa-caret-down',
	                title: !options.narrow && 'Options' || null,
	                tooltip: 'View available options'
	            });
	            if (options.biostar_url) {
	                menu_button.addMenu({
	                    icon: 'fa-question-circle',
	                    title: 'Question?',
	                    onclick: function () {
	                        window.open(options.biostar_url + '/p/new/post/');
	                    }
	                });
	                menu_button.addMenu({
	                    icon: 'fa-search',
	                    title: 'Search',
	                    onclick: function () {
	                        window.open(options.biostar_url + '/local/search/page/?q=' + options.name);
	                    }
	                });
	            };
	            menu_button.addMenu({
	                icon: 'fa-share',
	                title: 'Share',
	                onclick: function () {
	                    prompt('Copy to clipboard: Ctrl+C, Enter', window.location.origin + Galaxy.root + 'root?tool_id=' + options.id);
	                }
	            });
	
	            // add admin operations
	            if (Galaxy.user && Galaxy.user.get('is_admin')) {
	                menu_button.addMenu({
	                    icon: 'fa-download',
	                    title: 'Download',
	                    onclick: function () {
	                        window.location.href = Galaxy.root + 'api/tools/' + options.id + '/download';
	                    }
	                });
	                menu_button.addMenu({
	                    icon: 'fa-refresh',
	                    title: 'Reload XML',
	                    onclick: function () {
	                        Utils.get({
	                            url: Galaxy.root + 'api/tools/' + options.id + '/reload',
	                            success: function (response) {
	                                self.message.update({ persistent: false, message: 'Tool XML has been reloaded.', status: 'success' });
	                            },
	                            error: function (response) {
	                                self.message.update({ persistent: false, message: response.err_msg, status: 'danger' });
	                            }
	                        });
	                    }
	                });
	            }
	
	            // button for version selection
	            if (options.requirements && options.requirements.length > 0) {
	                menu_button.addMenu({
	                    icon: 'fa-info-circle',
	                    title: 'Requirements',
	                    onclick: function () {
	                        if (!this.requirements_visible || self.portlet.collapsed) {
	                            this.requirements_visible = true;
	                            self.portlet.expand();
	                            self.message.update({ persistent: true, message: self._templateRequirements(options), status: 'info' });
	                        } else {
	                            this.requirements_visible = false;
	                            self.message.update({ message: '' });
	                        }
	                    }
	                });
	            }
	
	            // add toolshed url
	            if (options.sharable_url) {
	                menu_button.addMenu({
	                    icon: 'fa-external-link',
	                    title: 'See in Tool Shed',
	                    onclick: function () {
	                        window.open(options.sharable_url);
	                    }
	                });
	            }
	
	            // add tool menu webhooks
	            $.getJSON('/api/webhooks/tool-menu/all', function (webhooks) {
	                _.each(webhooks, function (webhook) {
	                    if (webhook.activate && webhook.config.function) {
	                        menu_button.addMenu({
	                            icon: webhook.config.icon,
	                            title: webhook.config.title,
	                            onclick: function () {
	                                var func = new Function('options', webhook.config.function);
	                                func(options);
	                            }
	                        });
	                    }
	                });
	            });
	
	            return {
	                menu: menu_button,
	                versions: versions_button
	            };
	        },
	
	        /** Create footer */
	        _footer: function () {
	            var options = this.model.attributes;
	            var $el = $('<div/>').append(this._templateHelp(options));
	            if (options.citations) {
	                var $citations = $('<div/>');
	                var citations = new CitationModel.ToolCitationCollection();
	                citations.tool_id = options.id;
	                var citation_list_view = new CitationView.CitationListView({ el: $citations, collection: citations });
	                citation_list_view.render();
	                citations.fetch();
	                $el.append($citations);
	            }
	            return $el;
	        },
	
	        /** Templates */
	        _templateHelp: function (options) {
	            var $tmpl = $('<div/>').addClass('ui-form-help').append(options.help);
	            $tmpl.find('a').attr('target', '_blank');
	            $tmpl.find("img").each(function () {
	                var img_src = $(this).attr("src");
	                if (img_src.indexOf("admin_toolshed") !== -1) {
	                    $(this).attr("src", Galaxy.root + img_src);
	                }
	            });
	            return $tmpl;
	        },
	
	        _templateRequirements: function (options) {
	            var nreq = options.requirements.length;
	            if (nreq > 0) {
	                var requirements_message = 'This tool requires ';
	                _.each(options.requirements, function (req, i) {
	                    requirements_message += req.name + (req.version ? ' (Version ' + req.version + ')' : '') + (i < nreq - 2 ? ', ' : i == nreq - 2 ? ' and ' : '');
	                });
	                var requirements_link = $('<a/>').attr('target', '_blank').attr('href', 'https://galaxyproject.org/tools/requirements/').text('here');
	                return $('<span/>').append(requirements_message + '. Click ').append(requirements_link).append(' for more information.');
	            }
	            return 'No requirements found.';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/* This is the regular tool form */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(8), __webpack_require__(46), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Modal, ToolFormBase, Webhooks) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.modal = parent.Galaxy.modal || new Modal.View();
	            this.form = new ToolFormBase(Utils.merge({
	                listen_to_history: true,
	                always_refresh: false,
	                buildmodel: function (process, form) {
	                    var options = form.model.attributes;
	
	                    // build request url
	                    var build_url = '';
	                    var build_data = {};
	                    var job_id = options.job_id;
	                    if (job_id) {
	                        build_url = Galaxy.root + 'api/jobs/' + job_id + '/build_for_rerun';
	                    } else {
	                        build_url = Galaxy.root + 'api/tools/' + options.id + '/build';
	                        build_data = $.extend({}, Galaxy.params);
	                        build_data['tool_id'] && delete build_data['tool_id'];
	                    }
	                    options.version && (build_data['tool_version'] = options.version);
	
	                    // get initial model
	                    Utils.get({
	                        url: build_url,
	                        data: build_data,
	                        success: function (data) {
	                            if (!data.display) {
	                                window.location = Galaxy.root;
	                                return;
	                            }
	                            if (data.model_class.lastIndexOf('Proto', 0) === 0) {
	                                galaxy_main.location = Galaxy.root + 'tool_runner/rerun?job_id=' + data.job_id;
	                                return;
	                            }
	                            form.model.set(data);
	                            self._customize(form);
	                            Galaxy.emit.debug('tool-form-base::_buildModel()', 'Initial tool model ready.', data);
	                            process.resolve();
	                        },
	                        error: function (response, status) {
	                            var error_message = response && response.err_msg || 'Uncaught error.';
	                            if (status == 401) {
	                                window.location = Galaxy.root + 'user/login?' + $.param({ redirect: Galaxy.root + '?tool_id=' + options.id });
	                            } else if (form.$el.is(':empty')) {
	                                form.$el.prepend(new Ui.Message({
	                                    message: error_message,
	                                    status: 'danger',
	                                    persistent: true,
	                                    large: true
	                                }).$el);
	                            } else {
	                                Galaxy.modal && Galaxy.modal.show({
	                                    title: 'Tool request failed',
	                                    body: error_message,
	                                    buttons: {
	                                        'Close': function () {
	                                            Galaxy.modal.hide();
	                                        }
	                                    }
	                                });
	                            }
	                            Galaxy.emit.debug('tool-form-base::_buildModel()', 'Initial tool model request failed.', response);
	                            process.reject();
	                        }
	                    });
	                },
	                postchange: function (process, form) {
	                    var current_state = {
	                        tool_id: form.model.get('id'),
	                        tool_version: form.model.get('version'),
	                        inputs: $.extend(true, {}, form.data.create())
	                    };
	                    form.wait(true);
	                    Galaxy.emit.debug('tool-form::postchange()', 'Sending current state.', current_state);
	                    Utils.request({
	                        type: 'POST',
	                        url: Galaxy.root + 'api/tools/' + form.model.get('id') + '/build',
	                        data: current_state,
	                        success: function (data) {
	                            form.update(data);
	                            form.wait(false);
	                            Galaxy.emit.debug('tool-form::postchange()', 'Received new model.', data);
	                            process.resolve();
	                        },
	                        error: function (response) {
	                            Galaxy.emit.debug('tool-form::postchange()', 'Refresh request failed.', response);
	                            process.reject();
	                        }
	                    });
	                }
	            }, options));
	            this.deferred = this.form.deferred;
	            this.setElement('<div/>');
	            this.$el.append(this.form.$el);
	        },
	
	        _customize: function (form) {
	            var self = this;
	            var options = form.model.attributes;
	            // build execute button
	            options.buttons = {
	                execute: execute_btn = new Ui.Button({
	                    icon: 'fa-check',
	                    tooltip: 'Execute: ' + options.name + ' (' + options.version + ')',
	                    title: 'Execute',
	                    cls: 'btn btn-primary ui-clear-float',
	                    wait_cls: 'btn btn-info ui-clear-float',
	                    onclick: function () {
	                        execute_btn.wait();
	                        form.portlet.disable();
	                        self.submit(options, function () {
	                            execute_btn.unwait();
	                            form.portlet.enable();
	                        });
	                    }
	                })
	                // remap feature
	            };if (options.job_id && options.job_remap) {
	                options.inputs.push({
	                    label: 'Resume dependencies from this job',
	                    name: 'rerun_remap_job_id',
	                    type: 'select',
	                    display: 'radio',
	                    ignore: '__ignore__',
	                    value: '__ignore__',
	                    options: [['Yes', options.job_id], ['No', '__ignore__']],
	                    help: 'The previous run of this tool failed and other tools were waiting for it to finish successfully. Use this option to resume those tools using the new output(s) of this tool run.'
	                });
	            }
	        },
	
	        /** Submit a regular job.
	         * @param{dict}     options   - Specifies tool id and version
	         * @param{function} callback  - Called when request has completed
	         */
	        submit: function (options, callback) {
	            var self = this;
	            var job_def = {
	                tool_id: options.id,
	                tool_version: options.version,
	                inputs: this.form.data.create()
	            };
	            this.form.trigger('reset');
	            if (!self.validate(job_def)) {
	                Galaxy.emit.debug('tool-form::submit()', 'Submission canceled. Validation failed.');
	                callback && callback();
	                return;
	            }
	            if (options.action !== Galaxy.root + 'tool_runner/index') {
	                var $f = $('<form/>').attr({ action: options.action, method: options.method, enctype: options.enctype });
	                _.each(job_def.inputs, function (value, key) {
	                    $f.append($('<input/>').attr({ 'name': key, 'value': value }));
	                });
	                $f.hide().appendTo('body').submit().remove();
	                callback && callback();
	                return;
	            }
	            Galaxy.emit.debug('tool-form::submit()', 'Validation complete.', job_def);
	            Utils.request({
	                type: 'POST',
	                url: Galaxy.root + 'api/tools',
	                data: job_def,
	                success: function (response) {
	                    callback && callback();
	                    self.$el.children().hide();
	                    self.$el.append(self._templateSuccess(response));
	                    // Show Webhook if job is running
	                    if (response.jobs && response.jobs.length > 0) {
	                        self.$el.append($('<div/>', { id: 'webhook-view' }));
	                        var WebhookApp = new Webhooks.WebhookView({
	                            urlRoot: Galaxy.root + 'api/webhooks/tool',
	                            toolId: job_def.tool_id
	                        });
	                    }
	                    parent.Galaxy && parent.Galaxy.currHistoryPanel && parent.Galaxy.currHistoryPanel.refreshContents();
	                },
	                error: function (response) {
	                    callback && callback();
	                    Galaxy.emit.debug('tool-form::submit', 'Submission failed.', response);
	                    var input_found = false;
	                    if (response && response.err_data) {
	                        var error_messages = self.form.data.matchResponse(response.err_data);
	                        for (var input_id in error_messages) {
	                            self.form.highlight(input_id, error_messages[input_id]);
	                            input_found = true;
	                            break;
	                        }
	                    }
	                    if (!input_found) {
	                        self.modal.show({
	                            title: 'Job submission failed',
	                            body: self._templateError(job_def, response && response.err_msg),
	                            buttons: { 'Close': function () {
	                                    self.modal.hide();
	                                } }
	                        });
	                    }
	                }
	            });
	        },
	
	        /** Validate job dictionary.
	         * @param{dict}     job_def   - Job execution dictionary
	        */
	        validate: function (job_def) {
	            var job_inputs = job_def.inputs;
	            var batch_n = -1;
	            var batch_src = null;
	            for (var job_input_id in job_inputs) {
	                var input_value = job_inputs[job_input_id];
	                var input_id = this.form.data.match(job_input_id);
	                var input_field = this.form.field_list[input_id];
	                var input_def = this.form.input_list[input_id];
	                if (!input_id || !input_def || !input_field) {
	                    Galaxy.emit.debug('tool-form::validate()', 'Retrieving input objects failed.');
	                    continue;
	                }
	                if (!input_def.optional && input_value == null) {
	                    this.form.highlight(input_id);
	                    return false;
	                }
	                if (input_value && input_value.batch) {
	                    var n = input_value.values.length;
	                    var src = n > 0 && input_value.values[0] && input_value.values[0].src;
	                    if (src) {
	                        if (batch_src === null) {
	                            batch_src = src;
	                        } else if (batch_src !== src) {
	                            this.form.highlight(input_id, 'Please select either dataset or dataset list fields for all batch mode fields.');
	                            return false;
	                        }
	                    }
	                    if (batch_n === -1) {
	                        batch_n = n;
	                    } else if (batch_n !== n) {
	                        this.form.highlight(input_id, 'Please make sure that you select the same number of inputs for all batch mode fields. This field contains <b>' + n + '</b> selection(s) while a previous field contains <b>' + batch_n + '</b>.');
	                        return false;
	                    }
	                }
	            }
	            return true;
	        },
	
	        _templateSuccess: function (response) {
	            if (response.jobs && response.jobs.length > 0) {
	                var njobs = response.jobs.length;
	                var njobs_text = njobs == 1 ? '1 job has' : njobs + ' jobs have';
	                var $message = $('<div/>').addClass('donemessagelarge').append($('<p/>').text(njobs_text + ' been successfully added to the queue - resulting in the following datasets:'));
	                _.each(response.outputs, function (output) {
	                    $message.append($('<p/>').addClass('messagerow').append($('<b/>').text(output.hid + ': ' + output.name)));
	                });
	                $message.append($('<p/>').append('<b/>').text('You can check the status of queued jobs and view the resulting data by refreshing the History pane. When the job has been run the status will change from \'running\' to \'finished\' if completed successfully or \'error\' if problems were encountered.'));
	                return $message;
	            } else {
	                return this._templateError(response, 'Invalid success response. No jobs found.');
	            }
	        },
	
	        _templateError: function (response, err_msg) {
	            return $('<div/>').addClass('errormessagelarge').append($('<p/>').text('The server could not complete the request. Please contact the Galaxy Team if this error persists. ' + (err_msg || ''))).append($('<pre/>').text(JSON.stringify(response, null, 4)));
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/**
	 *  Renders tabs e.g. used in the charts editor, behaves similar to repeat and section rendering
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.collection = new Backbone.Collection();
	            this.model = options && options.model || new Backbone.Model({
	                onchange: null,
	                visible: true
	            }).set(options);
	            this.setElement($(this._template()));
	            this.$nav = this.$('.tab-navigation');
	            this.$content = this.$('.tab-content');
	            this.$el.on('click', function () {
	                $('.tooltip').hide();
	            });
	            this.render();
	            this.listenTo(this.model, 'change', this.render, this);
	            this.listenTo(this.collection, 'add', this._add, this);
	            this.listenTo(this.collection, 'remove', this._remove, this);
	            this.listenTo(this.collection, 'change', this._change, this);
	            this.listenTo(this.collection, 'reset', this._reset, this);
	            this.listenTo(this.collection, 'add remove reset', this.render, this);
	        },
	
	        render: function () {
	            var id = this.model.get('current');
	            id = this.$('#' + id).length > 0 ? id : this.first();
	            if (id) {
	                this.$nav.children().removeClass('active');
	                this.$content.children().removeClass('active');
	                this.$('#tab-' + id).addClass('active');
	                this.$('#' + id).addClass('active');
	            }
	            this.$el[this.model.get('visible') ? 'fadeIn' : 'fadeOut']('fast');
	            this.$nav[this.size() > 1 ? 'show' : 'hide']();
	        },
	
	        /** Returns tab id for currently shown tab */
	        current: function () {
	            return this.model.get('current');
	        },
	
	        /** Show tab view and highlight a tab by id */
	        show: function (id) {
	            if (id) {
	                this.model.set({ 'current': id, 'visible': true });
	                this.model.get('onchange') && this.model.get('onchange')(id);
	            }
	        },
	
	        /** Hide tab view */
	        hide: function () {
	            this.model.set('visible', false);
	        },
	
	        /** Returns first tab */
	        first: function () {
	            var model = this.collection.first();
	            return model && model.id;
	        },
	
	        /** Returns current number of tabs */
	        size: function () {
	            return this.collection.length;
	        },
	
	        /** Adds a new tab */
	        add: function (options) {
	            this.collection.add(options);
	        },
	
	        /** Delete tab */
	        del: function (id) {
	            this.collection.remove(id);
	        },
	
	        /** Delete all tabs */
	        delAll: function () {
	            this.collection.reset();
	        },
	
	        /** Show tab */
	        showTab: function (id) {
	            this.collection.get(id).set('hidden', false);
	        },
	
	        /** Hide tab */
	        hideTab: function (id) {
	            this.collection.get(id).set('hidden', true);
	        },
	
	        /** Adds a new tab */
	        _add: function (tab_model) {
	            var self = this;
	            var options = tab_model.attributes;
	            this.$content.append($('<div/>').attr('id', options.id).addClass('tab-pane').append(options.$el));
	            this.$nav.append($(this._template_tab(options)).show().tooltip({ title: options.tooltip, placement: 'bottom', container: self.$el }).on('click', function (e) {
	                e.preventDefault();
	                self.show(options.id);
	            }));
	            if (this.size() == 1) {
	                this.show(options.id);
	            }
	        },
	
	        /** Delete tab */
	        _remove: function (tab_model) {
	            this.$('#tab-' + tab_model.id).remove();
	            this.$('#' + tab_model.id).remove();
	        },
	
	        /** Reset collection */
	        _reset: function () {
	            this.$nav.empty();
	            this.$content.empty();
	        },
	
	        /** Change tab */
	        _change: function (tab_model) {
	            this.$('#tab-' + tab_model.id)[tab_model.get('hidden') ? 'hide' : 'show']();
	        },
	
	        /** Main template */
	        _template: function () {
	            return $('<div/>').addClass('ui-tabs tabbable tabs-left').append($('<ul/>').addClass('tab-navigation nav nav-tabs')).append($('<div/>').addClass('tab-content'));
	        },
	
	        /** Tab template */
	        _template_tab: function (options) {
	            var $tmpl = $('<li/>').addClass('tab-element').attr('id', 'tab-' + options.id).append($('<a/>').attr('id', 'tab-title-link-' + options.id));
	            var $href = $tmpl.find('a');
	            options.icon && $href.append($('<i/>').addClass('tab-icon fa').addClass(options.icon));
	            $href.append($('<span/>').attr('id', 'tab-title-text-' + options.id).addClass('tab-title-text').append(options.title));
	            return $tmpl;
	        }
	    });
	
	    return { View: View };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/**
	 *  This class defines a queue to ensure that multiple deferred callbacks are executed sequentially.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    return Backbone.Model.extend({
	        initialize: function () {
	            this.active = {};
	            this.last = null;
	        },
	
	        /** Adds a callback to the queue. Upon execution a deferred object is parsed to the callback i.e. callback( deferred ).
	         *  If the callback does not take any arguments, the deferred is resolved instantly.
	        */
	        execute: function (callback) {
	            var self = this;
	            var id = Utils.uid();
	            var has_deferred = callback.length > 0;
	
	            // register process
	            this.active[id] = true;
	
	            // deferred process
	            var process = $.Deferred();
	            process.promise().always(function () {
	                delete self.active[id];
	                has_deferred && Galaxy.emit.debug('deferred::execute()', this.state().charAt(0).toUpperCase() + this.state().slice(1) + ' ' + id);
	            });
	
	            // deferred queue
	            $.when(this.last).always(function () {
	                if (self.active[id]) {
	                    has_deferred && Galaxy.emit.debug('deferred::execute()', 'Running ' + id);
	                    callback(process);
	                    !has_deferred && process.resolve();
	                } else {
	                    process.reject();
	                }
	            });
	            this.last = process.promise();
	        },
	
	        /** Resets the promise queue. All currently queued but unexecuted callbacks/promises will be rejected.
	        */
	        reset: function () {
	            Galaxy.emit.debug('deferred::execute()', 'Reset');
	            for (var i in this.active) {
	                this.active[i] = false;
	            }
	        },
	
	        /** Returns true if all processes are done.
	        */
	        ready: function () {
	            return $.isEmptyObject(this.active);
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var jQuery = __webpack_require__(1),
	    $ = jQuery,
	    QUERY_STRING = __webpack_require__(19),
	    Ui = __webpack_require__(5);
	
	var Router = Backbone.Router.extend({
	    // TODO: not many client routes at this point - fill and remove from server.
	    // since we're at root here, this may be the last to be routed entirely on the client.
	    initialize: function (page, options) {
	        this.page = page;
	        this.options = options;
	    },
	
	    /** helper to push a new navigation state */
	    push: function (url, data) {
	        data = data || {};
	        data.__identifer = Math.random().toString(36).substr(2);
	        if (!$.isEmptyObject(data)) {
	            url += url.indexOf('?') == -1 ? '?' : '&';
	            url += $.param(data, true);
	        }
	        Galaxy.params = data;
	        this.navigate(url, { 'trigger': true });
	    },
	
	    /** override to parse query string into obj and send to each route */
	    execute: function (callback, args, name) {
	        Galaxy.debug('router execute:', callback, args, name);
	        var queryObj = QUERY_STRING.parse(args.pop());
	        args.push(queryObj);
	        if (callback) {
	            if (this.authenticate(args, name)) {
	                callback.apply(this, args);
	            } else {
	                this.access_denied();
	            }
	        }
	    },
	
	    authenticate: function (args, name) {
	        return true;
	    },
	
	    access_denied: function () {
	        this.page.display(new Ui.Message({ status: 'danger', message: 'You must be logged in with proper credentials to make this request.', persistent: true }));
	    }
	});
	
	module.exports = Router;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * Parser.js
	 * Copyright 2012-13 Mayank Lahiri
	 * mlahiri@gmail.com
	 * Released under the BSD License.
	 *
	 * A forgiving Bibtex parser that can:
	 * 
	 * (1) operate in streaming or block mode, extracting entries as dictionaries. 
	 * (2) convert Latex special characters to UTF-8.
	 * (3) best-effort parse malformed entries.
	 * (4) run in a CommonJS environment or a browser, without any dependencies.
	 * (5) be advanced-compiled by Google Closure Compiler.
	 * 
	 * Handwritten as a labor of love, not auto-generated from a grammar. 
	 *
	 * Modes of usage:
	 *
	 * (1) Synchronous, string
	 *
	 *   var entries = BibtexParser(text);
	 *   console.log(entries);
	 *
	 * (2) Asynchronous, stream
	 *
	 *   var entryCallback = function(entry) { console.log(entry); }
	 *   var parser = new BibtexParser(entryCallback);
	 *   parser.parse(chunk1);
	 *   parser.parse(chunk2);
	 *   ...
	 * 
	 * @param {text|function(Object)} arg Either a Bibtex string or callback 
	 *                                    function for processing parsed entries.
	 * @constructor
	 */
	function BibtexParser(arg0) {
	  // Determine how this function is to be used
	  if (typeof arg0 == 'string') {
	    // Passed a string, synchronous call without 'new'
	    var tempStorage = {};
	    var entries = [];
	    function accumulator(entry) {
	      entries.push(entry);
	    }
	    var parser = BibtexParser.call(tempStorage, accumulator);
	    parser.parse(arg0);
	    return {
	      'entries': entries,
	      'errors': parser.getErrors()
	    };
	  }
	  if (typeof arg0 != 'function') {
	    throw 'Invalid parser construction.';
	  }
	
	  /** @enum {number} */
	  this.STATES_ = {
	    ENTRY_OR_JUNK: 0,
	    OBJECT_TYPE: 1,
	    ENTRY_KEY: 2,
	    KV_KEY: 3,
	    EQUALS: 4,
	    KV_VALUE: 5
	    /** @private */ };this.DATA_ = {};
	  /** @private */this.CALLBACK_ = arg0;
	  /** @private */this.CHAR_ = 0;
	  /** @private */this.LINE_ = 1;
	  /** @private */this.CHAR_IN_LINE_ = 0;
	  /** @private */this.SKIPWS_ = true;
	  /** @private */this.SKIPCOMMENT_ = true;
	  /** @private */this.PARSETMP_ = {};
	  /** @private */this.SKIPTILLEOL_ = false;
	  /** @private */this.VALBRACES_ = null;
	  /** @private */this.BRACETYPE_ = null;
	  /** @private */this.BRACECOUNT_ = 0;
	  /** @private */this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	  /** @private */this.ERRORS_ = [];
	  /** @private */this.ENTRY_TYPES_ = {
	    'inproceedings': 1,
	    'proceedings': 2,
	    'article': 3,
	    'techreport': 4,
	    'misc': 5,
	    'mastersthesis': 6,
	    'book': 7,
	    'phdthesis': 8,
	    'incollection': 9,
	    'unpublished': 10,
	    'inbook': 11,
	    'manual': 12,
	    'periodical': 13,
	    'booklet': 14,
	    'masterthesis': 15,
	    'conference': 16,
	    'online': 998 // Galaxy MOD: Handle @online entries for preprints.
	    , 'data': 999 // Galaxy MOD: Handle @data citations coming from figshare.
	
	    /** @private */ };this.MACROS_ = {
	    'jan': 'January',
	    'feb': 'February',
	    'mar': 'March',
	    'apr': 'April',
	    'may': 'May',
	    'jun': 'June',
	    'jul': 'July',
	    'aug': 'August',
	    'sep': 'September',
	    'oct': 'October',
	    'nov': 'November',
	    'dec': 'December',
	    'Jan': 'January',
	    'Feb': 'February',
	    'Mar': 'March',
	    'Apr': 'April',
	    'May': 'May',
	    'Jun': 'June',
	    'Jul': 'July',
	    'Aug': 'August',
	    'Sep': 'September',
	    'Oct': 'October',
	    'Nov': 'November',
	    'Dec': 'December'
	
	    /**
	     * Gets an array of all errors encountered during parsing.
	     * Array entries are of the format:
	     *  [ line number, character in line, character in stream, error text ]
	     *
	     * @returns Array<Array>
	     * @public
	     */
	  };this.getErrors = function () {
	    return this.ERRORS_;
	  };
	
	  /**
	   * Processes a chunk of data
	   * @public
	   */
	  this.parse = function (chunk) {
	    for (var i = 0; i < chunk.length; i++) this.processCharacter_(chunk[i]);
	  };
	
	  /**
	   * Logs error at current stream position.
	   *
	   * @private
	   */
	  this.error_ = function (text) {
	    this.ERRORS_.push([this.LINE_, this.CHAR_IN_LINE_, this.CHAR_, text]);
	  };
	
	  /**
	   * Called after an entire entry has been parsed from the stream.
	   * Performs post-processing and invokes the entry callback pointed to by
	   * this.CALLBACK_. Parsed (but unprocessed) entry data is in this.DATA_.
	   */
	  this.processEntry_ = function () {
	    var data = this.DATA_;
	    if (data.Fields) for (var f in data.Fields) {
	      var raw = data.Fields[f];
	
	      // Convert Latex/Bibtex special characters to UTF-8 equivalents
	      for (var i = 0; i < this.CHARCONV_.length; i++) {
	        var re = this.CHARCONV_[i][0];
	        var rep = this.CHARCONV_[i][1];
	        raw = raw.replace(re, rep);
	      }
	
	      // Basic substitutions
	      raw = raw.replace(/[\n\r\t]/g, ' ').replace(/\s\s+/g, ' ').replace(/^\s+|\s+$/g, '');
	
	      // Remove braces and backslashes
	      var len = raw.length;
	      var processed = '';
	      for (var i = 0; i < len; i++) {
	        var c = raw[i];
	        var skip = false;
	        if (c == '\\' && i < len - 1) c = raw[++i];else {
	          if (c == '{' || c == '}') skip = true;
	        }
	        if (!skip) processed += c;
	      }
	      data.Fields[f] = processed;
	    }
	
	    if (data.ObjectType == 'string') {
	      for (var f in data.Fields) {
	        this.MACROS_[f] = data.Fields[f];
	      }
	    } else {
	      // Parsed a new Bibtex entry
	      this.CALLBACK_(data);
	    }
	  };
	
	  /**
	   * Processes next character in the stream, invoking the callback after 
	   * each entry has been found and processed.
	   * 
	   * @private
	   * @param {string} c Next character in input stream
	   */
	  this.processCharacter_ = function (c) {
	    // Housekeeping
	    this.CHAR_++;
	    this.CHAR_IN_LINE_++;
	    if (c == '\n') {
	      this.LINE_++;
	      this.CHAR_IN_LINE_ = 1;
	    }
	
	    // Convenience states for skipping whitespace when needed
	    if (this.SKIPTILLEOL_) {
	      if (c == '\n') this.SKIPTILLEOL_ = false;
	      return;
	    }
	    if (this.SKIPCOMMENT_ && c == '%') {
	      this.SKIPTILLEOL_ = true;
	      return;
	    }
	    if (this.SKIPWS_ && /\s/.test(c)) return;
	    this.SKIPWS_ = false;
	    this.SKIPCOMMENT_ = false;
	    this.SKIPTILLEOL_ = false;
	
	    // Main state machine
	    var AnotherIteration = true;
	    while (AnotherIteration) {
	      //console.log(this.LINE_, this.CHAR_IN_LINE_, this.STATE_, c)
	      AnotherIteration = false;
	      switch (this.STATE_) {
	        // -- Scan for an object marker ('@')
	        // -- Reset temporary data structure in case previous entry was garbled
	        case this.STATES_.ENTRY_OR_JUNK:
	          if (c == '@') {
	            // SUCCESS:     Parsed a valid start-of-object marker.
	            // NEXT_STATE:  OBJECT_TYPE
	            this.STATE_ = this.STATES_.OBJECT_TYPE;
	            this.DATA_ = {
	              ObjectType: ''
	            };
	          }
	          this.BRACETYPE_ = null;
	          this.SKIPWS_ = true;
	          this.SKIPCOMMENT_ = true;
	          break;
	
	        // Start at first non-whitespace character after start-of-object '@'
	        // -- Accept [A-Za-z], break on non-matching character
	        // -- Populate this.DATA_.EntryType and this.DATA_.ObjectType
	        case this.STATES_.OBJECT_TYPE:
	          if (/[A-Za-z]/.test(c)) {
	            this.DATA_.ObjectType += c.toLowerCase();
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	          } else {
	            // Break from state and validate object type
	            var ot = this.DATA_.ObjectType;
	            if (ot == 'comment') {
	              this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	            } else {
	              if (ot == 'string') {
	                this.DATA_.ObjectType = ot;
	                this.DATA_.Fields = {};
	                this.BRACETYPE_ = c;
	                this.BRACECOUNT_ = 1;
	                this.STATE_ = this.STATES_.KV_KEY;
	                this.SKIPWS_ = true;
	                this.SKIPCOMMENT_ = true;
	                this.PARSETMP_ = {
	                  Key: ''
	                };
	              } else {
	                if (ot == 'preamble') {
	                  this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	                } else {
	                  if (ot in this.ENTRY_TYPES_) {
	                    // SUCCESS:     Parsed a valid object type.
	                    // NEXT_STATE:  ENTRY_KEY
	                    this.DATA_.ObjectType = 'entry';
	                    this.DATA_.EntryType = ot;
	                    this.DATA_.EntryKey = '';
	                    this.STATE_ = this.STATES_.ENTRY_KEY;
	                    AnotherIteration = true;
	                  } else {
	                    // ERROR:       Unrecognized object type.
	                    // NEXT_STATE:  ENTRY_OR_JUNK
	                    this.error_('Unrecognized object type: "' + this.DATA_.ObjectType + '"');
	                    this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	                  }
	                }
	              }
	            }
	          }
	          break;
	
	        // Start at first non-alphabetic character after an entry type
	        // -- Populate this.DATA_.EntryKey
	        case this.STATES_.ENTRY_KEY:
	          if ((c === '{' || c === '(') && this.BRACETYPE_ == null) {
	            this.BRACETYPE_ = c;
	            this.BRACECOUNT_ = 1;
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	            break;
	          }
	          if (/[,%\s]/.test(c)) {
	            if (this.DATA_.EntryKey.length < 1) {
	              // Skip comments and whitespace before entry key
	              this.SKIPWS_ = true;
	              this.SKIPCOMMENT_ = true;
	            } else {
	              if (this.BRACETYPE_ == null) {
	                // ERROR:       No opening brace for object
	                // NEXT_STATE:  ENTRY_OR_JUNK
	                this.error_('No opening brace for object.');
	                this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	              } else {
	                // SUCCESS:     Parsed an entry key
	                // NEXT_STATE:  KV_KEY
	                this.SKIPWS_ = true;
	                this.SKIPCOMMENT_ = true;
	                AnotherIteration = true;
	                this.STATE_ = this.STATES_.KV_KEY;
	                this.PARSETMP_.Key = '';
	                this.DATA_.Fields = {};
	              }
	            }
	          } else {
	            this.DATA_.EntryKey += c;
	            this.SKIPWS_ = false;
	            this.SKIPCOMMENT_ = false;
	          }
	          break;
	
	        // Start at first non-whitespace/comment character after entry key.
	        // -- Populate this.PARSETMP_.Key
	        case this.STATES_.KV_KEY:
	          // Test for end of entry
	          if (c == '}' && this.BRACETYPE_ == '{' || c == ')' && this.BRACETYPE_ == '(') {
	            // SUCCESS:       Parsed an entry, possible incomplete
	            // NEXT_STATE:    ENTRY_OR_JUNK
	            this.processEntry_();
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	            this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	            break;
	          }
	          if (/[\-A-Za-z:]/.test(c)) {
	            // Add to key
	            this.PARSETMP_.Key += c;
	            this.SKIPWS_ = false;
	            this.SKIPCOMMENT_ = false;
	          } else {
	            // Either end of key or we haven't encountered start of key
	            if (this.PARSETMP_.Key.length < 1) {
	              // Keep going till we see a key
	              this.SKIPWS_ = true;
	              this.SKIPCOMMENT_ = true;
	            } else {
	              // SUCCESS:       Found full key in K/V pair
	              // NEXT_STATE:    EQUALS
	              this.SKIPWS_ = true;
	              this.SKIPCOMMENT_ = true;
	              this.STATE_ = this.STATES_.EQUALS;
	              AnotherIteration = true;
	            }
	          }
	          break;
	
	        // Start at first non-alphabetic character after K/V pair key.
	        case this.STATES_.EQUALS:
	          if (c == '}' && this.BRACETYPE_ == '{' || c == ')' && this.BRACETYPE_ == '(') {
	            // ERROR:         K/V pair with key but no value
	            // NEXT_STATE:    ENTRY_OR_JUNK
	            this.error_('Key-value pair has key "' + this.PARSETMP_.Key + '", but no value.');
	            this.processEntry_();
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	            this.STATE_ = this.STATES_.ENTRY_OR_JUNK;
	            break;
	          }
	          if (c == '=') {
	            // SUCCESS:       found an equal signs separating key and value
	            // NEXT_STATE:    KV_VALUE
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	            this.STATE_ = this.STATES_.KV_VALUE;
	            this.PARSETMP_.Value = '';
	            this.VALBRACES_ = { '"': [], '{': [] };
	          }
	          break;
	
	        // Start at first non-whitespace/comment character after '=' 
	        // -- Populate this.PARSETMP_.Value
	        case this.STATES_.KV_VALUE:
	          var delim = this.VALBRACES_;
	          var val = this.PARSETMP_.Value;
	          var doneParsingValue = false;
	
	          // Test for special characters
	          if (c == '"' || c == '{' || c == '}' || c == ',') {
	            if (c == ',') {
	              // This comma can mean:
	              // (1) just another comma literal
	              // (2) end of a macro reference
	              if (0 === delim['"'].length + delim['{'].length) {
	                // end of a macro reference
	                var macro = this.PARSETMP_.Value.trim();
	                if (macro in this.MACROS_) {
	                  // Successful macro reference
	                  this.PARSETMP_.Value = this.MACROS_[macro];
	                } else {
	                  // Reference to an undefined macro
	                  this.error_('Reference to an undefined macro: ' + macro);
	                }
	                doneParsingValue = true;
	              }
	            }
	            if (c == '"') {
	              // This quote can mean:
	              // (1) opening delimiter
	              // (2) closing delimiter
	              // (3) literal, if we have a '{' on the stack
	              if (0 === delim['"'].length + delim['{'].length) {
	                // opening delimiter
	                delim['"'].push(this.CHAR_);
	                this.SKIPWS_ = false;
	                this.SKIPCOMMENT_ = false;
	                break;
	              }
	              if (delim['"'].length == 1 && delim['{'].length == 0 && (val.length == 0 || val[val.length - 1] != '\\')) {
	                // closing delimiter
	                doneParsingValue = true;
	              } else {
	                // literal, add to value
	              }
	            }
	            if (c == '{') {
	              // This brace can mean:
	              // (1) opening delimiter
	              // (2) stacked verbatim delimiter
	              if (val.length == 0 || val[val.length - 1] != '\\') {
	                delim['{'].push(this.CHAR_);
	                this.SKIPWS_ = false;
	                this.SKIPCOMMENT_ = false;
	              } else {
	                // literal, add to value
	              }
	            }
	            if (c == '}') {
	              // This brace can mean:
	              // (1) closing delimiter
	              // (2) closing stacked verbatim delimiter
	              // (3) end of object definition if value was a macro
	              if (0 === delim['"'].length + delim['{'].length) {
	                // end of object definition, after macro
	                var macro = this.PARSETMP_.Value.trim();
	                if (macro in this.MACROS_) {
	                  // Successful macro reference
	                  this.PARSETMP_.Value = this.MACROS_[macro];
	                } else {
	                  // Reference to an undefined macro
	                  this.error_('Reference to an undefined macro: ' + macro);
	                }
	                AnotherIteration = true;
	                doneParsingValue = true;
	              } else {
	                if (val.length == 0 || val[val.length - 1] != '\\') {
	                  if (delim['{'].length > 0) {
	                    // pop stack for stacked verbatim delimiter
	                    delim['{'].splice(delim['{'].length - 1, 1);
	                    if (0 == delim['{'].length + delim['"'].length) {
	                      // closing delimiter
	                      doneParsingValue = true;
	                    } else {
	                      // end verbatim block
	                    }
	                  }
	                } else {
	                    // literal, add to value
	                  }
	              }
	            }
	          }
	
	          // If here, then we are either done parsing the value or 
	          // have a literal that should be added to the value.
	          if (doneParsingValue) {
	            // SUCCESS:     value parsed
	            // NEXT_STATE:  KV_KEY
	            this.SKIPWS_ = true;
	            this.SKIPCOMMENT_ = true;
	            this.STATE_ = this.STATES_.KV_KEY;
	            this.DATA_.Fields[this.PARSETMP_.Key] = this.PARSETMP_.Value;
	            this.PARSETMP_ = { Key: '' };
	            this.VALBRACES_ = null;
	          } else {
	            this.PARSETMP_.Value += c;
	          }
	          break;
	      } // end switch (this.STATE_)
	    } // end while(AnotherIteration)
	  }; // end function processCharacter 
	
	  /** @private */this.CHARCONV_ = [[/\\space /g, '\u0020'], [/\\textdollar /g, '\u0024'], [/\\textquotesingle /g, '\u0027'], [/\\ast /g, '\u002A'], [/\\textbackslash /g, '\u005C'], [/\\\^\{\}/g, '\u005E'], [/\\textasciigrave /g, '\u0060'], [/\\lbrace /g, '\u007B'], [/\\vert /g, '\u007C'], [/\\rbrace /g, '\u007D'], [/\\textasciitilde /g, '\u007E'], [/\\textexclamdown /g, '\u00A1'], [/\\textcent /g, '\u00A2'], [/\\textsterling /g, '\u00A3'], [/\\textcurrency /g, '\u00A4'], [/\\textyen /g, '\u00A5'], [/\\textbrokenbar /g, '\u00A6'], [/\\textsection /g, '\u00A7'], [/\\textasciidieresis /g, '\u00A8'], [/\\textcopyright /g, '\u00A9'], [/\\textordfeminine /g, '\u00AA'], [/\\guillemotleft /g, '\u00AB'], [/\\lnot /g, '\u00AC'], [/\\textregistered /g, '\u00AE'], [/\\textasciimacron /g, '\u00AF'], [/\\textdegree /g, '\u00B0'], [/\\pm /g, '\u00B1'], [/\\textasciiacute /g, '\u00B4'], [/\\mathrm\{\\mu\}/g, '\u00B5'], [/\\textparagraph /g, '\u00B6'], [/\\cdot /g, '\u00B7'], [/\\c\{\}/g, '\u00B8'], [/\\textordmasculine /g, '\u00BA'], [/\\guillemotright /g, '\u00BB'], [/\\textonequarter /g, '\u00BC'], [/\\textonehalf /g, '\u00BD'], [/\\textthreequarters /g, '\u00BE'], [/\\textquestiondown /g, '\u00BF'], [/\\`\{A\}/g, '\u00C0'], [/\\'\{A\}/g, '\u00C1'], [/\\\^\{A\}/g, '\u00C2'], [/\\~\{A\}/g, '\u00C3'], [/\\"\{A\}/g, '\u00C4'], [/\\AA /g, '\u00C5'], [/\\AE /g, '\u00C6'], [/\\c\{C\}/g, '\u00C7'], [/\\`\{E\}/g, '\u00C8'], [/\\'\{E\}/g, '\u00C9'], [/\\\^\{E\}/g, '\u00CA'], [/\\"\{E\}/g, '\u00CB'], [/\\`\{I\}/g, '\u00CC'], [/\\'\{I\}/g, '\u00CD'], [/\\\^\{I\}/g, '\u00CE'], [/\\"\{I\}/g, '\u00CF'], [/\\DH /g, '\u00D0'], [/\\~\{N\}/g, '\u00D1'], [/\\`\{O\}/g, '\u00D2'], [/\\'\{O\}/g, '\u00D3'], [/\\\^\{O\}/g, '\u00D4'], [/\\~\{O\}/g, '\u00D5'], [/\\"\{O\}/g, '\u00D6'], [/\\texttimes /g, '\u00D7'], [/\\O /g, '\u00D8'], [/\\`\{U\}/g, '\u00D9'], [/\\'\{U\}/g, '\u00DA'], [/\\\^\{U\}/g, '\u00DB'], [/\\"\{U\}/g, '\u00DC'], [/\\'\{Y\}/g, '\u00DD'], [/\\TH /g, '\u00DE'], [/\\ss /g, '\u00DF'], [/\\`\{a\}/g, '\u00E0'], [/\\'\{a\}/g, '\u00E1'], [/\\\^\{a\}/g, '\u00E2'], [/\\~\{a\}/g, '\u00E3'], [/\\"\{a\}/g, '\u00E4'], [/\\aa /g, '\u00E5'], [/\\ae /g, '\u00E6'], [/\\c\{c\}/g, '\u00E7'], [/\\`\{e\}/g, '\u00E8'], [/\\'\{e\}/g, '\u00E9'], [/\\\^\{e\}/g, '\u00EA'], [/\\"\{e\}/g, '\u00EB'], [/\\`\{\\i\}/g, '\u00EC'], [/\\'\{\\i\}/g, '\u00ED'], [/\\\^\{\\i\}/g, '\u00EE'], [/\\"\{\\i\}/g, '\u00EF'], [/\\dh /g, '\u00F0'], [/\\~\{n\}/g, '\u00F1'], [/\\`\{o\}/g, '\u00F2'], [/\\'\{o\}/g, '\u00F3'], [/\\\^\{o\}/g, '\u00F4'], [/\\~\{o\}/g, '\u00F5'], [/\\"\{o\}/g, '\u00F6'], [/\\div /g, '\u00F7'], [/\\o /g, '\u00F8'], [/\\`\{u\}/g, '\u00F9'], [/\\'\{u\}/g, '\u00FA'], [/\\\^\{u\}/g, '\u00FB'], [/\\"\{u\}/g, '\u00FC'], [/\\'\{y\}/g, '\u00FD'], [/\\th /g, '\u00FE'], [/\\"\{y\}/g, '\u00FF'], [/\\=\{A\}/g, '\u0100'], [/\\=\{a\}/g, '\u0101'], [/\\u\{A\}/g, '\u0102'], [/\\u\{a\}/g, '\u0103'], [/\\k\{A\}/g, '\u0104'], [/\\k\{a\}/g, '\u0105'], [/\\'\{C\}/g, '\u0106'], [/\\'\{c\}/g, '\u0107'], [/\\\^\{C\}/g, '\u0108'], [/\\\^\{c\}/g, '\u0109'], [/\\.\{C\}/g, '\u010A'], [/\\.\{c\}/g, '\u010B'], [/\\v\{C\}/g, '\u010C'], [/\\v\{c\}/g, '\u010D'], [/\\v\{D\}/g, '\u010E'], [/\\v\{d\}/g, '\u010F'], [/\\DJ /g, '\u0110'], [/\\dj /g, '\u0111'], [/\\=\{E\}/g, '\u0112'], [/\\=\{e\}/g, '\u0113'], [/\\u\{E\}/g, '\u0114'], [/\\u\{e\}/g, '\u0115'], [/\\.\{E\}/g, '\u0116'], [/\\.\{e\}/g, '\u0117'], [/\\k\{E\}/g, '\u0118'], [/\\k\{e\}/g, '\u0119'], [/\\v\{E\}/g, '\u011A'], [/\\v\{e\}/g, '\u011B'], [/\\\^\{G\}/g, '\u011C'], [/\\\^\{g\}/g, '\u011D'], [/\\u\{G\}/g, '\u011E'], [/\\u\{g\}/g, '\u011F'], [/\\.\{G\}/g, '\u0120'], [/\\.\{g\}/g, '\u0121'], [/\\c\{G\}/g, '\u0122'], [/\\c\{g\}/g, '\u0123'], [/\\\^\{H\}/g, '\u0124'], [/\\\^\{h\}/g, '\u0125'], [/\\Elzxh /g, '\u0127'], [/\\~\{I\}/g, '\u0128'], [/\\~\{\\i\}/g, '\u0129'], [/\\=\{I\}/g, '\u012A'], [/\\=\{\\i\}/g, '\u012B'], [/\\u\{I\}/g, '\u012C'], [/\\u\{\\i\}/g, '\u012D'], [/\\k\{I\}/g, '\u012E'], [/\\k\{i\}/g, '\u012F'], [/\\.\{I\}/g, '\u0130'], [/\\i /g, '\u0131'], [/\\\^\{J\}/g, '\u0134'], [/\\\^\{\\j\}/g, '\u0135'], [/\\c\{K\}/g, '\u0136'], [/\\c\{k\}/g, '\u0137'], [/\\'\{L\}/g, '\u0139'], [/\\'\{l\}/g, '\u013A'], [/\\c\{L\}/g, '\u013B'], [/\\c\{l\}/g, '\u013C'], [/\\v\{L\}/g, '\u013D'], [/\\v\{l\}/g, '\u013E'], [/\\L /g, '\u0141'], [/\\l /g, '\u0142'], [/\\'\{N\}/g, '\u0143'], [/\\'\{n\}/g, '\u0144'], [/\\c\{N\}/g, '\u0145'], [/\\c\{n\}/g, '\u0146'], [/\\v\{N\}/g, '\u0147'], [/\\v\{n\}/g, '\u0148'], [/\\NG /g, '\u014A'], [/\\ng /g, '\u014B'], [/\\=\{O\}/g, '\u014C'], [/\\=\{o\}/g, '\u014D'], [/\\u\{O\}/g, '\u014E'], [/\\u\{o\}/g, '\u014F'], [/\\H\{O\}/g, '\u0150'], [/\\H\{o\}/g, '\u0151'], [/\\OE /g, '\u0152'], [/\\oe /g, '\u0153'], [/\\'\{R\}/g, '\u0154'], [/\\'\{r\}/g, '\u0155'], [/\\c\{R\}/g, '\u0156'], [/\\c\{r\}/g, '\u0157'], [/\\v\{R\}/g, '\u0158'], [/\\v\{r\}/g, '\u0159'], [/\\'\{S\}/g, '\u015A'], [/\\'\{s\}/g, '\u015B'], [/\\\^\{S\}/g, '\u015C'], [/\\\^\{s\}/g, '\u015D'], [/\\c\{S\}/g, '\u015E'], [/\\c\{s\}/g, '\u015F'], [/\\v\{S\}/g, '\u0160'], [/\\v\{s\}/g, '\u0161'], [/\\c\{T\}/g, '\u0162'], [/\\c\{t\}/g, '\u0163'], [/\\v\{T\}/g, '\u0164'], [/\\v\{t\}/g, '\u0165'], [/\\~\{U\}/g, '\u0168'], [/\\~\{u\}/g, '\u0169'], [/\\=\{U\}/g, '\u016A'], [/\\=\{u\}/g, '\u016B'], [/\\u\{U\}/g, '\u016C'], [/\\u\{u\}/g, '\u016D'], [/\\r\{U\}/g, '\u016E'], [/\\r\{u\}/g, '\u016F'], [/\\H\{U\}/g, '\u0170'], [/\\H\{u\}/g, '\u0171'], [/\\k\{U\}/g, '\u0172'], [/\\k\{u\}/g, '\u0173'], [/\\\^\{W\}/g, '\u0174'], [/\\\^\{w\}/g, '\u0175'], [/\\\^\{Y\}/g, '\u0176'], [/\\\^\{y\}/g, '\u0177'], [/\\"\{Y\}/g, '\u0178'], [/\\'\{Z\}/g, '\u0179'], [/\\'\{z\}/g, '\u017A'], [/\\.\{Z\}/g, '\u017B'], [/\\.\{z\}/g, '\u017C'], [/\\v\{Z\}/g, '\u017D'], [/\\v\{z\}/g, '\u017E'], [/\\texthvlig /g, '\u0195'], [/\\textnrleg /g, '\u019E'], [/\\eth /g, '\u01AA'], [/\\textdoublepipe /g, '\u01C2'], [/\\'\{g\}/g, '\u01F5'], [/\\Elztrna /g, '\u0250'], [/\\Elztrnsa /g, '\u0252'], [/\\Elzopeno /g, '\u0254'], [/\\Elzrtld /g, '\u0256'], [/\\Elzschwa /g, '\u0259'], [/\\varepsilon /g, '\u025B'], [/\\Elzpgamma /g, '\u0263'], [/\\Elzpbgam /g, '\u0264'], [/\\Elztrnh /g, '\u0265'], [/\\Elzbtdl /g, '\u026C'], [/\\Elzrtll /g, '\u026D'], [/\\Elztrnm /g, '\u026F'], [/\\Elztrnmlr /g, '\u0270'], [/\\Elzltlmr /g, '\u0271'], [/\\Elzltln /g, '\u0272'], [/\\Elzrtln /g, '\u0273'], [/\\Elzclomeg /g, '\u0277'], [/\\textphi /g, '\u0278'], [/\\Elztrnr /g, '\u0279'], [/\\Elztrnrl /g, '\u027A'], [/\\Elzrttrnr /g, '\u027B'], [/\\Elzrl /g, '\u027C'], [/\\Elzrtlr /g, '\u027D'], [/\\Elzfhr /g, '\u027E'], [/\\Elzrtls /g, '\u0282'], [/\\Elzesh /g, '\u0283'], [/\\Elztrnt /g, '\u0287'], [/\\Elzrtlt /g, '\u0288'], [/\\Elzpupsil /g, '\u028A'], [/\\Elzpscrv /g, '\u028B'], [/\\Elzinvv /g, '\u028C'], [/\\Elzinvw /g, '\u028D'], [/\\Elztrny /g, '\u028E'], [/\\Elzrtlz /g, '\u0290'], [/\\Elzyogh /g, '\u0292'], [/\\Elzglst /g, '\u0294'], [/\\Elzreglst /g, '\u0295'], [/\\Elzinglst /g, '\u0296'], [/\\textturnk /g, '\u029E'], [/\\Elzdyogh /g, '\u02A4'], [/\\Elztesh /g, '\u02A7'], [/\\textasciicaron /g, '\u02C7'], [/\\Elzverts /g, '\u02C8'], [/\\Elzverti /g, '\u02CC'], [/\\Elzlmrk /g, '\u02D0'], [/\\Elzhlmrk /g, '\u02D1'], [/\\Elzsbrhr /g, '\u02D2'], [/\\Elzsblhr /g, '\u02D3'], [/\\Elzrais /g, '\u02D4'], [/\\Elzlow /g, '\u02D5'], [/\\textasciibreve /g, '\u02D8'], [/\\textperiodcentered /g, '\u02D9'], [/\\r\{\}/g, '\u02DA'], [/\\k\{\}/g, '\u02DB'], [/\\texttildelow /g, '\u02DC'], [/\\H\{\}/g, '\u02DD'], [/\\tone\{55\}/g, '\u02E5'], [/\\tone\{44\}/g, '\u02E6'], [/\\tone\{33\}/g, '\u02E7'], [/\\tone\{22\}/g, '\u02E8'], [/\\tone\{11\}/g, '\u02E9'], [/\\cyrchar\\C/g, '\u030F'], [/\\Elzpalh /g, '\u0321'], [/\\Elzrh /g, '\u0322'], [/\\Elzsbbrg /g, '\u032A'], [/\\Elzxl /g, '\u0335'], [/\\Elzbar /g, '\u0336'], [/\\'\{A\}/g, '\u0386'], [/\\'\{E\}/g, '\u0388'], [/\\'\{H\}/g, '\u0389'], [/\\'\{\}\{I\}/g, '\u038A'], [/\\'\{\}O/g, '\u038C'], [/\\mathrm\{'Y\}/g, '\u038E'], [/\\mathrm\{'\\Omega\}/g, '\u038F'], [/\\acute\{\\ddot\{\\iota\}\}/g, '\u0390'], [/\\Alpha /g, '\u0391'], [/\\Beta /g, '\u0392'], [/\\Gamma /g, '\u0393'], [/\\Delta /g, '\u0394'], [/\\Epsilon /g, '\u0395'], [/\\Zeta /g, '\u0396'], [/\\Eta /g, '\u0397'], [/\\Theta /g, '\u0398'], [/\\Iota /g, '\u0399'], [/\\Kappa /g, '\u039A'], [/\\Lambda /g, '\u039B'], [/\\Xi /g, '\u039E'], [/\\Pi /g, '\u03A0'], [/\\Rho /g, '\u03A1'], [/\\Sigma /g, '\u03A3'], [/\\Tau /g, '\u03A4'], [/\\Upsilon /g, '\u03A5'], [/\\Phi /g, '\u03A6'], [/\\Chi /g, '\u03A7'], [/\\Psi /g, '\u03A8'], [/\\Omega /g, '\u03A9'], [/\\mathrm\{\\ddot\{I\}\}/g, '\u03AA'], [/\\mathrm\{\\ddot\{Y\}\}/g, '\u03AB'], [/\\'\{\$\\alpha\$\}/g, '\u03AC'], [/\\acute\{\\epsilon\}/g, '\u03AD'], [/\\acute\{\\eta\}/g, '\u03AE'], [/\\acute\{\\iota\}/g, '\u03AF'], [/\\acute\{\\ddot\{\\upsilon\}\}/g, '\u03B0'], [/\\alpha /g, '\u03B1'], [/\\beta /g, '\u03B2'], [/\\gamma /g, '\u03B3'], [/\\delta /g, '\u03B4'], [/\\epsilon /g, '\u03B5'], [/\\zeta /g, '\u03B6'], [/\\eta /g, '\u03B7'], [/\\texttheta /g, '\u03B8'], [/\\iota /g, '\u03B9'], [/\\kappa /g, '\u03BA'], [/\\lambda /g, '\u03BB'], [/\\mu /g, '\u03BC'], [/\\nu /g, '\u03BD'], [/\\xi /g, '\u03BE'], [/\\pi /g, '\u03C0'], [/\\rho /g, '\u03C1'], [/\\varsigma /g, '\u03C2'], [/\\sigma /g, '\u03C3'], [/\\tau /g, '\u03C4'], [/\\upsilon /g, '\u03C5'], [/\\varphi /g, '\u03C6'], [/\\chi /g, '\u03C7'], [/\\psi /g, '\u03C8'], [/\\omega /g, '\u03C9'], [/\\ddot\{\\iota\}/g, '\u03CA'], [/\\ddot\{\\upsilon\}/g, '\u03CB'], [/\\'\{o\}/g, '\u03CC'], [/\\acute\{\\upsilon\}/g, '\u03CD'], [/\\acute\{\\omega\}/g, '\u03CE'], [/\\Pisymbol\{ppi022\}\{87\}/g, '\u03D0'], [/\\textvartheta /g, '\u03D1'], [/\\Upsilon /g, '\u03D2'], [/\\phi /g, '\u03D5'], [/\\varpi /g, '\u03D6'], [/\\Stigma /g, '\u03DA'], [/\\Digamma /g, '\u03DC'], [/\\digamma /g, '\u03DD'], [/\\Koppa /g, '\u03DE'], [/\\Sampi /g, '\u03E0'], [/\\varkappa /g, '\u03F0'], [/\\varrho /g, '\u03F1'], [/\\textTheta /g, '\u03F4'], [/\\backepsilon /g, '\u03F6'], [/\\cyrchar\\CYRYO /g, '\u0401'], [/\\cyrchar\\CYRDJE /g, '\u0402'], [/\\cyrchar\{\\'\\CYRG\}/g, '\u0403'], [/\\cyrchar\\CYRIE /g, '\u0404'], [/\\cyrchar\\CYRDZE /g, '\u0405'], [/\\cyrchar\\CYRII /g, '\u0406'], [/\\cyrchar\\CYRYI /g, '\u0407'], [/\\cyrchar\\CYRJE /g, '\u0408'], [/\\cyrchar\\CYRLJE /g, '\u0409'], [/\\cyrchar\\CYRNJE /g, '\u040A'], [/\\cyrchar\\CYRTSHE /g, '\u040B'], [/\\cyrchar\{\\'\\CYRK\}/g, '\u040C'], [/\\cyrchar\\CYRUSHRT /g, '\u040E'], [/\\cyrchar\\CYRDZHE /g, '\u040F'], [/\\cyrchar\\CYRA /g, '\u0410'], [/\\cyrchar\\CYRB /g, '\u0411'], [/\\cyrchar\\CYRV /g, '\u0412'], [/\\cyrchar\\CYRG /g, '\u0413'], [/\\cyrchar\\CYRD /g, '\u0414'], [/\\cyrchar\\CYRE /g, '\u0415'], [/\\cyrchar\\CYRZH /g, '\u0416'], [/\\cyrchar\\CYRZ /g, '\u0417'], [/\\cyrchar\\CYRI /g, '\u0418'], [/\\cyrchar\\CYRISHRT /g, '\u0419'], [/\\cyrchar\\CYRK /g, '\u041A'], [/\\cyrchar\\CYRL /g, '\u041B'], [/\\cyrchar\\CYRM /g, '\u041C'], [/\\cyrchar\\CYRN /g, '\u041D'], [/\\cyrchar\\CYRO /g, '\u041E'], [/\\cyrchar\\CYRP /g, '\u041F'], [/\\cyrchar\\CYRR /g, '\u0420'], [/\\cyrchar\\CYRS /g, '\u0421'], [/\\cyrchar\\CYRT /g, '\u0422'], [/\\cyrchar\\CYRU /g, '\u0423'], [/\\cyrchar\\CYRF /g, '\u0424'], [/\\cyrchar\\CYRH /g, '\u0425'], [/\\cyrchar\\CYRC /g, '\u0426'], [/\\cyrchar\\CYRCH /g, '\u0427'], [/\\cyrchar\\CYRSH /g, '\u0428'], [/\\cyrchar\\CYRSHCH /g, '\u0429'], [/\\cyrchar\\CYRHRDSN /g, '\u042A'], [/\\cyrchar\\CYRERY /g, '\u042B'], [/\\cyrchar\\CYRSFTSN /g, '\u042C'], [/\\cyrchar\\CYREREV /g, '\u042D'], [/\\cyrchar\\CYRYU /g, '\u042E'], [/\\cyrchar\\CYRYA /g, '\u042F'], [/\\cyrchar\\cyra /g, '\u0430'], [/\\cyrchar\\cyrb /g, '\u0431'], [/\\cyrchar\\cyrv /g, '\u0432'], [/\\cyrchar\\cyrg /g, '\u0433'], [/\\cyrchar\\cyrd /g, '\u0434'], [/\\cyrchar\\cyre /g, '\u0435'], [/\\cyrchar\\cyrzh /g, '\u0436'], [/\\cyrchar\\cyrz /g, '\u0437'], [/\\cyrchar\\cyri /g, '\u0438'], [/\\cyrchar\\cyrishrt /g, '\u0439'], [/\\cyrchar\\cyrk /g, '\u043A'], [/\\cyrchar\\cyrl /g, '\u043B'], [/\\cyrchar\\cyrm /g, '\u043C'], [/\\cyrchar\\cyrn /g, '\u043D'], [/\\cyrchar\\cyro /g, '\u043E'], [/\\cyrchar\\cyrp /g, '\u043F'], [/\\cyrchar\\cyrr /g, '\u0440'], [/\\cyrchar\\cyrs /g, '\u0441'], [/\\cyrchar\\cyrt /g, '\u0442'], [/\\cyrchar\\cyru /g, '\u0443'], [/\\cyrchar\\cyrf /g, '\u0444'], [/\\cyrchar\\cyrh /g, '\u0445'], [/\\cyrchar\\cyrc /g, '\u0446'], [/\\cyrchar\\cyrch /g, '\u0447'], [/\\cyrchar\\cyrsh /g, '\u0448'], [/\\cyrchar\\cyrshch /g, '\u0449'], [/\\cyrchar\\cyrhrdsn /g, '\u044A'], [/\\cyrchar\\cyrery /g, '\u044B'], [/\\cyrchar\\cyrsftsn /g, '\u044C'], [/\\cyrchar\\cyrerev /g, '\u044D'], [/\\cyrchar\\cyryu /g, '\u044E'], [/\\cyrchar\\cyrya /g, '\u044F'], [/\\cyrchar\\cyryo /g, '\u0451'], [/\\cyrchar\\cyrdje /g, '\u0452'], [/\\cyrchar\{\\'\\cyrg\}/g, '\u0453'], [/\\cyrchar\\cyrie /g, '\u0454'], [/\\cyrchar\\cyrdze /g, '\u0455'], [/\\cyrchar\\cyrii /g, '\u0456'], [/\\cyrchar\\cyryi /g, '\u0457'], [/\\cyrchar\\cyrje /g, '\u0458'], [/\\cyrchar\\cyrlje /g, '\u0459'], [/\\cyrchar\\cyrnje /g, '\u045A'], [/\\cyrchar\\cyrtshe /g, '\u045B'], [/\\cyrchar\{\\'\\cyrk\}/g, '\u045C'], [/\\cyrchar\\cyrushrt /g, '\u045E'], [/\\cyrchar\\cyrdzhe /g, '\u045F'], [/\\cyrchar\\CYROMEGA /g, '\u0460'], [/\\cyrchar\\cyromega /g, '\u0461'], [/\\cyrchar\\CYRYAT /g, '\u0462'], [/\\cyrchar\\CYRIOTE /g, '\u0464'], [/\\cyrchar\\cyriote /g, '\u0465'], [/\\cyrchar\\CYRLYUS /g, '\u0466'], [/\\cyrchar\\cyrlyus /g, '\u0467'], [/\\cyrchar\\CYRIOTLYUS /g, '\u0468'], [/\\cyrchar\\cyriotlyus /g, '\u0469'], [/\\cyrchar\\CYRBYUS /g, '\u046A'], [/\\cyrchar\\CYRIOTBYUS /g, '\u046C'], [/\\cyrchar\\cyriotbyus /g, '\u046D'], [/\\cyrchar\\CYRKSI /g, '\u046E'], [/\\cyrchar\\cyrksi /g, '\u046F'], [/\\cyrchar\\CYRPSI /g, '\u0470'], [/\\cyrchar\\cyrpsi /g, '\u0471'], [/\\cyrchar\\CYRFITA /g, '\u0472'], [/\\cyrchar\\CYRIZH /g, '\u0474'], [/\\cyrchar\\CYRUK /g, '\u0478'], [/\\cyrchar\\cyruk /g, '\u0479'], [/\\cyrchar\\CYROMEGARND /g, '\u047A'], [/\\cyrchar\\cyromegarnd /g, '\u047B'], [/\\cyrchar\\CYROMEGATITLO /g, '\u047C'], [/\\cyrchar\\cyromegatitlo /g, '\u047D'], [/\\cyrchar\\CYROT /g, '\u047E'], [/\\cyrchar\\cyrot /g, '\u047F'], [/\\cyrchar\\CYRKOPPA /g, '\u0480'], [/\\cyrchar\\cyrkoppa /g, '\u0481'], [/\\cyrchar\\cyrthousands /g, '\u0482'], [/\\cyrchar\\cyrhundredthousands /g, '\u0488'], [/\\cyrchar\\cyrmillions /g, '\u0489'], [/\\cyrchar\\CYRSEMISFTSN /g, '\u048C'], [/\\cyrchar\\cyrsemisftsn /g, '\u048D'], [/\\cyrchar\\CYRRTICK /g, '\u048E'], [/\\cyrchar\\cyrrtick /g, '\u048F'], [/\\cyrchar\\CYRGUP /g, '\u0490'], [/\\cyrchar\\cyrgup /g, '\u0491'], [/\\cyrchar\\CYRGHCRS /g, '\u0492'], [/\\cyrchar\\cyrghcrs /g, '\u0493'], [/\\cyrchar\\CYRGHK /g, '\u0494'], [/\\cyrchar\\cyrghk /g, '\u0495'], [/\\cyrchar\\CYRZHDSC /g, '\u0496'], [/\\cyrchar\\cyrzhdsc /g, '\u0497'], [/\\cyrchar\\CYRZDSC /g, '\u0498'], [/\\cyrchar\\cyrzdsc /g, '\u0499'], [/\\cyrchar\\CYRKDSC /g, '\u049A'], [/\\cyrchar\\cyrkdsc /g, '\u049B'], [/\\cyrchar\\CYRKVCRS /g, '\u049C'], [/\\cyrchar\\cyrkvcrs /g, '\u049D'], [/\\cyrchar\\CYRKHCRS /g, '\u049E'], [/\\cyrchar\\cyrkhcrs /g, '\u049F'], [/\\cyrchar\\CYRKBEAK /g, '\u04A0'], [/\\cyrchar\\cyrkbeak /g, '\u04A1'], [/\\cyrchar\\CYRNDSC /g, '\u04A2'], [/\\cyrchar\\cyrndsc /g, '\u04A3'], [/\\cyrchar\\CYRNG /g, '\u04A4'], [/\\cyrchar\\cyrng /g, '\u04A5'], [/\\cyrchar\\CYRPHK /g, '\u04A6'], [/\\cyrchar\\cyrphk /g, '\u04A7'], [/\\cyrchar\\CYRABHHA /g, '\u04A8'], [/\\cyrchar\\cyrabhha /g, '\u04A9'], [/\\cyrchar\\CYRSDSC /g, '\u04AA'], [/\\cyrchar\\cyrsdsc /g, '\u04AB'], [/\\cyrchar\\CYRTDSC /g, '\u04AC'], [/\\cyrchar\\cyrtdsc /g, '\u04AD'], [/\\cyrchar\\CYRY /g, '\u04AE'], [/\\cyrchar\\cyry /g, '\u04AF'], [/\\cyrchar\\CYRYHCRS /g, '\u04B0'], [/\\cyrchar\\cyryhcrs /g, '\u04B1'], [/\\cyrchar\\CYRHDSC /g, '\u04B2'], [/\\cyrchar\\cyrhdsc /g, '\u04B3'], [/\\cyrchar\\CYRTETSE /g, '\u04B4'], [/\\cyrchar\\cyrtetse /g, '\u04B5'], [/\\cyrchar\\CYRCHRDSC /g, '\u04B6'], [/\\cyrchar\\cyrchrdsc /g, '\u04B7'], [/\\cyrchar\\CYRCHVCRS /g, '\u04B8'], [/\\cyrchar\\cyrchvcrs /g, '\u04B9'], [/\\cyrchar\\CYRSHHA /g, '\u04BA'], [/\\cyrchar\\cyrshha /g, '\u04BB'], [/\\cyrchar\\CYRABHCH /g, '\u04BC'], [/\\cyrchar\\cyrabhch /g, '\u04BD'], [/\\cyrchar\\CYRABHCHDSC /g, '\u04BE'], [/\\cyrchar\\cyrabhchdsc /g, '\u04BF'], [/\\cyrchar\\CYRpalochka /g, '\u04C0'], [/\\cyrchar\\CYRKHK /g, '\u04C3'], [/\\cyrchar\\cyrkhk /g, '\u04C4'], [/\\cyrchar\\CYRNHK /g, '\u04C7'], [/\\cyrchar\\cyrnhk /g, '\u04C8'], [/\\cyrchar\\CYRCHLDSC /g, '\u04CB'], [/\\cyrchar\\cyrchldsc /g, '\u04CC'], [/\\cyrchar\\CYRAE /g, '\u04D4'], [/\\cyrchar\\cyrae /g, '\u04D5'], [/\\cyrchar\\CYRSCHWA /g, '\u04D8'], [/\\cyrchar\\cyrschwa /g, '\u04D9'], [/\\cyrchar\\CYRABHDZE /g, '\u04E0'], [/\\cyrchar\\cyrabhdze /g, '\u04E1'], [/\\cyrchar\\CYROTLD /g, '\u04E8'], [/\\cyrchar\\cyrotld /g, '\u04E9'], [/\\hspace\{0.6em\}/g, '\u2002'], [/\\hspace\{1em\}/g, '\u2003'], [/\\hspace\{0.33em\}/g, '\u2004'], [/\\hspace\{0.25em\}/g, '\u2005'], [/\\hspace\{0.166em\}/g, '\u2006'], [/\\hphantom\{0\}/g, '\u2007'], [/\\hphantom\{,\}/g, '\u2008'], [/\\hspace\{0.167em\}/g, '\u2009'], [/\\mkern1mu /g, '\u200A'], [/\\textendash /g, '\u2013'], [/\\textemdash /g, '\u2014'], [/\\rule\{1em\}\{1pt\}/g, '\u2015'], [/\\Vert /g, '\u2016'], [/\\Elzreapos /g, '\u201B'], [/\\textquotedblleft /g, '\u201C'], [/\\textquotedblright /g, '\u201D'], [/\\textdagger /g, '\u2020'], [/\\textdaggerdbl /g, '\u2021'], [/\\textbullet /g, '\u2022'], [/\\ldots /g, '\u2026'], [/\\textperthousand /g, '\u2030'], [/\\textpertenthousand /g, '\u2031'], [/\\backprime /g, '\u2035'], [/\\guilsinglleft /g, '\u2039'], [/\\guilsinglright /g, '\u203A'], [/\\mkern4mu /g, '\u205F'], [/\\nolinebreak /g, '\u2060'], [/\\ensuremath\{\\Elzpes\}/g, '\u20A7'], [/\\mbox\{\\texteuro\} /g, '\u20AC'], [/\\dddot /g, '\u20DB'], [/\\ddddot /g, '\u20DC'], [/\\mathbb\{C\}/g, '\u2102'], [/\\mathscr\{g\}/g, '\u210A'], [/\\mathscr\{H\}/g, '\u210B'], [/\\mathfrak\{H\}/g, '\u210C'], [/\\mathbb\{H\}/g, '\u210D'], [/\\hslash /g, '\u210F'], [/\\mathscr\{I\}/g, '\u2110'], [/\\mathfrak\{I\}/g, '\u2111'], [/\\mathscr\{L\}/g, '\u2112'], [/\\mathscr\{l\}/g, '\u2113'], [/\\mathbb\{N\}/g, '\u2115'], [/\\cyrchar\\textnumero /g, '\u2116'], [/\\wp /g, '\u2118'], [/\\mathbb\{P\}/g, '\u2119'], [/\\mathbb\{Q\}/g, '\u211A'], [/\\mathscr\{R\}/g, '\u211B'], [/\\mathfrak\{R\}/g, '\u211C'], [/\\mathbb\{R\}/g, '\u211D'], [/\\Elzxrat /g, '\u211E'], [/\\texttrademark /g, '\u2122'], [/\\mathbb\{Z\}/g, '\u2124'], [/\\Omega /g, '\u2126'], [/\\mho /g, '\u2127'], [/\\mathfrak\{Z\}/g, '\u2128'], [/\\ElsevierGlyph\{2129\}/g, '\u2129'], [/\\AA /g, '\u212B'], [/\\mathscr\{B\}/g, '\u212C'], [/\\mathfrak\{C\}/g, '\u212D'], [/\\mathscr\{e\}/g, '\u212F'], [/\\mathscr\{E\}/g, '\u2130'], [/\\mathscr\{F\}/g, '\u2131'], [/\\mathscr\{M\}/g, '\u2133'], [/\\mathscr\{o\}/g, '\u2134'], [/\\aleph /g, '\u2135'], [/\\beth /g, '\u2136'], [/\\gimel /g, '\u2137'], [/\\daleth /g, '\u2138'], [/\\textfrac\{1\}\{3\}/g, '\u2153'], [/\\textfrac\{2\}\{3\}/g, '\u2154'], [/\\textfrac\{1\}\{5\}/g, '\u2155'], [/\\textfrac\{2\}\{5\}/g, '\u2156'], [/\\textfrac\{3\}\{5\}/g, '\u2157'], [/\\textfrac\{4\}\{5\}/g, '\u2158'], [/\\textfrac\{1\}\{6\}/g, '\u2159'], [/\\textfrac\{5\}\{6\}/g, '\u215A'], [/\\textfrac\{1\}\{8\}/g, '\u215B'], [/\\textfrac\{3\}\{8\}/g, '\u215C'], [/\\textfrac\{5\}\{8\}/g, '\u215D'], [/\\textfrac\{7\}\{8\}/g, '\u215E'], [/\\leftarrow /g, '\u2190'], [/\\uparrow /g, '\u2191'], [/\\rightarrow /g, '\u2192'], [/\\downarrow /g, '\u2193'], [/\\leftrightarrow /g, '\u2194'], [/\\updownarrow /g, '\u2195'], [/\\nwarrow /g, '\u2196'], [/\\nearrow /g, '\u2197'], [/\\searrow /g, '\u2198'], [/\\swarrow /g, '\u2199'], [/\\nleftarrow /g, '\u219A'], [/\\nrightarrow /g, '\u219B'], [/\\arrowwaveright /g, '\u219C'], [/\\arrowwaveright /g, '\u219D'], [/\\twoheadleftarrow /g, '\u219E'], [/\\twoheadrightarrow /g, '\u21A0'], [/\\leftarrowtail /g, '\u21A2'], [/\\rightarrowtail /g, '\u21A3'], [/\\mapsto /g, '\u21A6'], [/\\hookleftarrow /g, '\u21A9'], [/\\hookrightarrow /g, '\u21AA'], [/\\looparrowleft /g, '\u21AB'], [/\\looparrowright /g, '\u21AC'], [/\\leftrightsquigarrow /g, '\u21AD'], [/\\nleftrightarrow /g, '\u21AE'], [/\\Lsh /g, '\u21B0'], [/\\Rsh /g, '\u21B1'], [/\\ElsevierGlyph\{21B3\}/g, '\u21B3'], [/\\curvearrowleft /g, '\u21B6'], [/\\curvearrowright /g, '\u21B7'], [/\\circlearrowleft /g, '\u21BA'], [/\\circlearrowright /g, '\u21BB'], [/\\leftharpoonup /g, '\u21BC'], [/\\leftharpoondown /g, '\u21BD'], [/\\upharpoonright /g, '\u21BE'], [/\\upharpoonleft /g, '\u21BF'], [/\\rightharpoonup /g, '\u21C0'], [/\\rightharpoondown /g, '\u21C1'], [/\\downharpoonright /g, '\u21C2'], [/\\downharpoonleft /g, '\u21C3'], [/\\rightleftarrows /g, '\u21C4'], [/\\dblarrowupdown /g, '\u21C5'], [/\\leftrightarrows /g, '\u21C6'], [/\\leftleftarrows /g, '\u21C7'], [/\\upuparrows /g, '\u21C8'], [/\\rightrightarrows /g, '\u21C9'], [/\\downdownarrows /g, '\u21CA'], [/\\leftrightharpoons /g, '\u21CB'], [/\\rightleftharpoons /g, '\u21CC'], [/\\nLeftarrow /g, '\u21CD'], [/\\nLeftrightarrow /g, '\u21CE'], [/\\nRightarrow /g, '\u21CF'], [/\\Leftarrow /g, '\u21D0'], [/\\Uparrow /g, '\u21D1'], [/\\Rightarrow /g, '\u21D2'], [/\\Downarrow /g, '\u21D3'], [/\\Leftrightarrow /g, '\u21D4'], [/\\Updownarrow /g, '\u21D5'], [/\\Lleftarrow /g, '\u21DA'], [/\\Rrightarrow /g, '\u21DB'], [/\\rightsquigarrow /g, '\u21DD'], [/\\DownArrowUpArrow /g, '\u21F5'], [/\\forall /g, '\u2200'], [/\\complement /g, '\u2201'], [/\\partial /g, '\u2202'], [/\\exists /g, '\u2203'], [/\\nexists /g, '\u2204'], [/\\varnothing /g, '\u2205'], [/\\nabla /g, '\u2207'], [/\\in /g, '\u2208'], [/\\not\\in /g, '\u2209'], [/\\ni /g, '\u220B'], [/\\not\\ni /g, '\u220C'], [/\\prod /g, '\u220F'], [/\\coprod /g, '\u2210'], [/\\sum /g, '\u2211'], [/\\mp /g, '\u2213'], [/\\dotplus /g, '\u2214'], [/\\setminus /g, '\u2216'], [/\\circ /g, '\u2218'], [/\\bullet /g, '\u2219'], [/\\surd /g, '\u221A'], [/\\propto /g, '\u221D'], [/\\infty /g, '\u221E'], [/\\rightangle /g, '\u221F'], [/\\angle /g, '\u2220'], [/\\measuredangle /g, '\u2221'], [/\\sphericalangle /g, '\u2222'], [/\\mid /g, '\u2223'], [/\\nmid /g, '\u2224'], [/\\parallel /g, '\u2225'], [/\\nparallel /g, '\u2226'], [/\\wedge /g, '\u2227'], [/\\vee /g, '\u2228'], [/\\cap /g, '\u2229'], [/\\cup /g, '\u222A'], [/\\int /g, '\u222B'], [/\\int\\!\\int /g, '\u222C'], [/\\int\\!\\int\\!\\int /g, '\u222D'], [/\\oint /g, '\u222E'], [/\\surfintegral /g, '\u222F'], [/\\volintegral /g, '\u2230'], [/\\clwintegral /g, '\u2231'], [/\\ElsevierGlyph\{2232\}/g, '\u2232'], [/\\ElsevierGlyph\{2233\}/g, '\u2233'], [/\\therefore /g, '\u2234'], [/\\because /g, '\u2235'], [/\\Colon /g, '\u2237'], [/\\ElsevierGlyph\{2238\}/g, '\u2238'], [/\\mathbin\{\{:\}\\!\\!\{\-\}\\!\\!\{:\}\}/g, '\u223A'], [/\\homothetic /g, '\u223B'], [/\\sim /g, '\u223C'], [/\\backsim /g, '\u223D'], [/\\lazysinv /g, '\u223E'], [/\\wr /g, '\u2240'], [/\\not\\sim /g, '\u2241'], [/\\ElsevierGlyph\{2242\}/g, '\u2242'], [/\\NotEqualTilde /g, '\u2242-00338'], [/\\simeq /g, '\u2243'], [/\\not\\simeq /g, '\u2244'], [/\\cong /g, '\u2245'], [/\\approxnotequal /g, '\u2246'], [/\\not\\cong /g, '\u2247'], [/\\approx /g, '\u2248'], [/\\not\\approx /g, '\u2249'], [/\\approxeq /g, '\u224A'], [/\\tildetrpl /g, '\u224B'], [/\\not\\apid /g, '\u224B-00338'], [/\\allequal /g, '\u224C'], [/\\asymp /g, '\u224D'], [/\\Bumpeq /g, '\u224E'], [/\\NotHumpDownHump /g, '\u224E-00338'], [/\\bumpeq /g, '\u224F'], [/\\NotHumpEqual /g, '\u224F-00338'], [/\\doteq /g, '\u2250'], [/\\not\\doteq/g, '\u2250-00338'], [/\\doteqdot /g, '\u2251'], [/\\fallingdotseq /g, '\u2252'], [/\\risingdotseq /g, '\u2253'], [/\\eqcirc /g, '\u2256'], [/\\circeq /g, '\u2257'], [/\\estimates /g, '\u2259'], [/\\ElsevierGlyph\{225A\}/g, '\u225A'], [/\\starequal /g, '\u225B'], [/\\triangleq /g, '\u225C'], [/\\ElsevierGlyph\{225F\}/g, '\u225F'], [/\\not =/g, '\u2260'], [/\\equiv /g, '\u2261'], [/\\not\\equiv /g, '\u2262'], [/\\leq /g, '\u2264'], [/\\geq /g, '\u2265'], [/\\leqq /g, '\u2266'], [/\\geqq /g, '\u2267'], [/\\lneqq /g, '\u2268'], [/\\lvertneqq /g, '\u2268-0FE00'], [/\\gneqq /g, '\u2269'], [/\\gvertneqq /g, '\u2269-0FE00'], [/\\ll /g, '\u226A'], [/\\NotLessLess /g, '\u226A-00338'], [/\\gg /g, '\u226B'], [/\\NotGreaterGreater /g, '\u226B-00338'], [/\\between /g, '\u226C'], [/\\not\\kern\-0.3em\\times /g, '\u226D'], [/\\not</g, '\u226E'], [/\\not>/g, '\u226F'], [/\\not\\leq /g, '\u2270'], [/\\not\\geq /g, '\u2271'], [/\\lessequivlnt /g, '\u2272'], [/\\greaterequivlnt /g, '\u2273'], [/\\ElsevierGlyph\{2274\}/g, '\u2274'], [/\\ElsevierGlyph\{2275\}/g, '\u2275'], [/\\lessgtr /g, '\u2276'], [/\\gtrless /g, '\u2277'], [/\\notlessgreater /g, '\u2278'], [/\\notgreaterless /g, '\u2279'], [/\\prec /g, '\u227A'], [/\\succ /g, '\u227B'], [/\\preccurlyeq /g, '\u227C'], [/\\succcurlyeq /g, '\u227D'], [/\\precapprox /g, '\u227E'], [/\\NotPrecedesTilde /g, '\u227E-00338'], [/\\succapprox /g, '\u227F'], [/\\NotSucceedsTilde /g, '\u227F-00338'], [/\\not\\prec /g, '\u2280'], [/\\not\\succ /g, '\u2281'], [/\\subset /g, '\u2282'], [/\\supset /g, '\u2283'], [/\\not\\subset /g, '\u2284'], [/\\not\\supset /g, '\u2285'], [/\\subseteq /g, '\u2286'], [/\\supseteq /g, '\u2287'], [/\\not\\subseteq /g, '\u2288'], [/\\not\\supseteq /g, '\u2289'], [/\\subsetneq /g, '\u228A'], [/\\varsubsetneqq /g, '\u228A-0FE00'], [/\\supsetneq /g, '\u228B'], [/\\varsupsetneq /g, '\u228B-0FE00'], [/\\uplus /g, '\u228E'], [/\\sqsubset /g, '\u228F'], [/\\NotSquareSubset /g, '\u228F-00338'], [/\\sqsupset /g, '\u2290'], [/\\NotSquareSuperset /g, '\u2290-00338'], [/\\sqsubseteq /g, '\u2291'], [/\\sqsupseteq /g, '\u2292'], [/\\sqcap /g, '\u2293'], [/\\sqcup /g, '\u2294'], [/\\oplus /g, '\u2295'], [/\\ominus /g, '\u2296'], [/\\otimes /g, '\u2297'], [/\\oslash /g, '\u2298'], [/\\odot /g, '\u2299'], [/\\circledcirc /g, '\u229A'], [/\\circledast /g, '\u229B'], [/\\circleddash /g, '\u229D'], [/\\boxplus /g, '\u229E'], [/\\boxminus /g, '\u229F'], [/\\boxtimes /g, '\u22A0'], [/\\boxdot /g, '\u22A1'], [/\\vdash /g, '\u22A2'], [/\\dashv /g, '\u22A3'], [/\\top /g, '\u22A4'], [/\\perp /g, '\u22A5'], [/\\truestate /g, '\u22A7'], [/\\forcesextra /g, '\u22A8'], [/\\Vdash /g, '\u22A9'], [/\\Vvdash /g, '\u22AA'], [/\\VDash /g, '\u22AB'], [/\\nvdash /g, '\u22AC'], [/\\nvDash /g, '\u22AD'], [/\\nVdash /g, '\u22AE'], [/\\nVDash /g, '\u22AF'], [/\\vartriangleleft /g, '\u22B2'], [/\\vartriangleright /g, '\u22B3'], [/\\trianglelefteq /g, '\u22B4'], [/\\trianglerighteq /g, '\u22B5'], [/\\original /g, '\u22B6'], [/\\image /g, '\u22B7'], [/\\multimap /g, '\u22B8'], [/\\hermitconjmatrix /g, '\u22B9'], [/\\intercal /g, '\u22BA'], [/\\veebar /g, '\u22BB'], [/\\rightanglearc /g, '\u22BE'], [/\\ElsevierGlyph\{22C0\}/g, '\u22C0'], [/\\ElsevierGlyph\{22C1\}/g, '\u22C1'], [/\\bigcap /g, '\u22C2'], [/\\bigcup /g, '\u22C3'], [/\\diamond /g, '\u22C4'], [/\\cdot /g, '\u22C5'], [/\\star /g, '\u22C6'], [/\\divideontimes /g, '\u22C7'], [/\\bowtie /g, '\u22C8'], [/\\ltimes /g, '\u22C9'], [/\\rtimes /g, '\u22CA'], [/\\leftthreetimes /g, '\u22CB'], [/\\rightthreetimes /g, '\u22CC'], [/\\backsimeq /g, '\u22CD'], [/\\curlyvee /g, '\u22CE'], [/\\curlywedge /g, '\u22CF'], [/\\Subset /g, '\u22D0'], [/\\Supset /g, '\u22D1'], [/\\Cap /g, '\u22D2'], [/\\Cup /g, '\u22D3'], [/\\pitchfork /g, '\u22D4'], [/\\lessdot /g, '\u22D6'], [/\\gtrdot /g, '\u22D7'], [/\\verymuchless /g, '\u22D8'], [/\\verymuchgreater /g, '\u22D9'], [/\\lesseqgtr /g, '\u22DA'], [/\\gtreqless /g, '\u22DB'], [/\\curlyeqprec /g, '\u22DE'], [/\\curlyeqsucc /g, '\u22DF'], [/\\not\\sqsubseteq /g, '\u22E2'], [/\\not\\sqsupseteq /g, '\u22E3'], [/\\Elzsqspne /g, '\u22E5'], [/\\lnsim /g, '\u22E6'], [/\\gnsim /g, '\u22E7'], [/\\precedesnotsimilar /g, '\u22E8'], [/\\succnsim /g, '\u22E9'], [/\\ntriangleleft /g, '\u22EA'], [/\\ntriangleright /g, '\u22EB'], [/\\ntrianglelefteq /g, '\u22EC'], [/\\ntrianglerighteq /g, '\u22ED'], [/\\vdots /g, '\u22EE'], [/\\cdots /g, '\u22EF'], [/\\upslopeellipsis /g, '\u22F0'], [/\\downslopeellipsis /g, '\u22F1'], [/\\barwedge /g, '\u2305'], [/\\perspcorrespond /g, '\u2306'], [/\\lceil /g, '\u2308'], [/\\rceil /g, '\u2309'], [/\\lfloor /g, '\u230A'], [/\\rfloor /g, '\u230B'], [/\\recorder /g, '\u2315'], [/\\mathchar"2208/g, '\u2316'], [/\\ulcorner /g, '\u231C'], [/\\urcorner /g, '\u231D'], [/\\llcorner /g, '\u231E'], [/\\lrcorner /g, '\u231F'], [/\\frown /g, '\u2322'], [/\\smile /g, '\u2323'], [/\\langle /g, '\u2329'], [/\\rangle /g, '\u232A'], [/\\ElsevierGlyph\{E838\}/g, '\u233D'], [/\\Elzdlcorn /g, '\u23A3'], [/\\lmoustache /g, '\u23B0'], [/\\rmoustache /g, '\u23B1'], [/\\textvisiblespace /g, '\u2423'], [/\\ding\{172\}/g, '\u2460'], [/\\ding\{173\}/g, '\u2461'], [/\\ding\{174\}/g, '\u2462'], [/\\ding\{175\}/g, '\u2463'], [/\\ding\{176\}/g, '\u2464'], [/\\ding\{177\}/g, '\u2465'], [/\\ding\{178\}/g, '\u2466'], [/\\ding\{179\}/g, '\u2467'], [/\\ding\{180\}/g, '\u2468'], [/\\ding\{181\}/g, '\u2469'], [/\\circledS /g, '\u24C8'], [/\\Elzdshfnc /g, '\u2506'], [/\\Elzsqfnw /g, '\u2519'], [/\\diagup /g, '\u2571'], [/\\ding\{110\}/g, '\u25A0'], [/\\square /g, '\u25A1'], [/\\blacksquare /g, '\u25AA'], [/\\fbox\{~~\}/g, '\u25AD'], [/\\Elzvrecto /g, '\u25AF'], [/\\ElsevierGlyph\{E381\}/g, '\u25B1'], [/\\ding\{115\}/g, '\u25B2'], [/\\bigtriangleup /g, '\u25B3'], [/\\blacktriangle /g, '\u25B4'], [/\\vartriangle /g, '\u25B5'], [/\\blacktriangleright /g, '\u25B8'], [/\\triangleright /g, '\u25B9'], [/\\ding\{116\}/g, '\u25BC'], [/\\bigtriangledown /g, '\u25BD'], [/\\blacktriangledown /g, '\u25BE'], [/\\triangledown /g, '\u25BF'], [/\\blacktriangleleft /g, '\u25C2'], [/\\triangleleft /g, '\u25C3'], [/\\ding\{117\}/g, '\u25C6'], [/\\lozenge /g, '\u25CA'], [/\\bigcirc /g, '\u25CB'], [/\\ding\{108\}/g, '\u25CF'], [/\\Elzcirfl /g, '\u25D0'], [/\\Elzcirfr /g, '\u25D1'], [/\\Elzcirfb /g, '\u25D2'], [/\\ding\{119\}/g, '\u25D7'], [/\\Elzrvbull /g, '\u25D8'], [/\\Elzsqfl /g, '\u25E7'], [/\\Elzsqfr /g, '\u25E8'], [/\\Elzsqfse /g, '\u25EA'], [/\\bigcirc /g, '\u25EF'], [/\\ding\{72\}/g, '\u2605'], [/\\ding\{73\}/g, '\u2606'], [/\\ding\{37\}/g, '\u260E'], [/\\ding\{42\}/g, '\u261B'], [/\\ding\{43\}/g, '\u261E'], [/\\rightmoon /g, '\u263E'], [/\\mercury /g, '\u263F'], [/\\venus /g, '\u2640'], [/\\male /g, '\u2642'], [/\\jupiter /g, '\u2643'], [/\\saturn /g, '\u2644'], [/\\uranus /g, '\u2645'], [/\\neptune /g, '\u2646'], [/\\pluto /g, '\u2647'], [/\\aries /g, '\u2648'], [/\\taurus /g, '\u2649'], [/\\gemini /g, '\u264A'], [/\\cancer /g, '\u264B'], [/\\leo /g, '\u264C'], [/\\virgo /g, '\u264D'], [/\\libra /g, '\u264E'], [/\\scorpio /g, '\u264F'], [/\\sagittarius /g, '\u2650'], [/\\capricornus /g, '\u2651'], [/\\aquarius /g, '\u2652'], [/\\pisces /g, '\u2653'], [/\\ding\{171\}/g, '\u2660'], [/\\diamond /g, '\u2662'], [/\\ding\{168\}/g, '\u2663'], [/\\ding\{170\}/g, '\u2665'], [/\\ding\{169\}/g, '\u2666'], [/\\quarternote /g, '\u2669'], [/\\eighthnote /g, '\u266A'], [/\\flat /g, '\u266D'], [/\\natural /g, '\u266E'], [/\\sharp /g, '\u266F'], [/\\ding\{33\}/g, '\u2701'], [/\\ding\{34\}/g, '\u2702'], [/\\ding\{35\}/g, '\u2703'], [/\\ding\{36\}/g, '\u2704'], [/\\ding\{38\}/g, '\u2706'], [/\\ding\{39\}/g, '\u2707'], [/\\ding\{40\}/g, '\u2708'], [/\\ding\{41\}/g, '\u2709'], [/\\ding\{44\}/g, '\u270C'], [/\\ding\{45\}/g, '\u270D'], [/\\ding\{46\}/g, '\u270E'], [/\\ding\{47\}/g, '\u270F'], [/\\ding\{48\}/g, '\u2710'], [/\\ding\{49\}/g, '\u2711'], [/\\ding\{50\}/g, '\u2712'], [/\\ding\{51\}/g, '\u2713'], [/\\ding\{52\}/g, '\u2714'], [/\\ding\{53\}/g, '\u2715'], [/\\ding\{54\}/g, '\u2716'], [/\\ding\{55\}/g, '\u2717'], [/\\ding\{56\}/g, '\u2718'], [/\\ding\{57\}/g, '\u2719'], [/\\ding\{58\}/g, '\u271A'], [/\\ding\{59\}/g, '\u271B'], [/\\ding\{60\}/g, '\u271C'], [/\\ding\{61\}/g, '\u271D'], [/\\ding\{62\}/g, '\u271E'], [/\\ding\{63\}/g, '\u271F'], [/\\ding\{64\}/g, '\u2720'], [/\\ding\{65\}/g, '\u2721'], [/\\ding\{66\}/g, '\u2722'], [/\\ding\{67\}/g, '\u2723'], [/\\ding\{68\}/g, '\u2724'], [/\\ding\{69\}/g, '\u2725'], [/\\ding\{70\}/g, '\u2726'], [/\\ding\{71\}/g, '\u2727'], [/\\ding\{73\}/g, '\u2729'], [/\\ding\{74\}/g, '\u272A'], [/\\ding\{75\}/g, '\u272B'], [/\\ding\{76\}/g, '\u272C'], [/\\ding\{77\}/g, '\u272D'], [/\\ding\{78\}/g, '\u272E'], [/\\ding\{79\}/g, '\u272F'], [/\\ding\{80\}/g, '\u2730'], [/\\ding\{81\}/g, '\u2731'], [/\\ding\{82\}/g, '\u2732'], [/\\ding\{83\}/g, '\u2733'], [/\\ding\{84\}/g, '\u2734'], [/\\ding\{85\}/g, '\u2735'], [/\\ding\{86\}/g, '\u2736'], [/\\ding\{87\}/g, '\u2737'], [/\\ding\{88\}/g, '\u2738'], [/\\ding\{89\}/g, '\u2739'], [/\\ding\{90\}/g, '\u273A'], [/\\ding\{91\}/g, '\u273B'], [/\\ding\{92\}/g, '\u273C'], [/\\ding\{93\}/g, '\u273D'], [/\\ding\{94\}/g, '\u273E'], [/\\ding\{95\}/g, '\u273F'], [/\\ding\{96\}/g, '\u2740'], [/\\ding\{97\}/g, '\u2741'], [/\\ding\{98\}/g, '\u2742'], [/\\ding\{99\}/g, '\u2743'], [/\\ding\{100\}/g, '\u2744'], [/\\ding\{101\}/g, '\u2745'], [/\\ding\{102\}/g, '\u2746'], [/\\ding\{103\}/g, '\u2747'], [/\\ding\{104\}/g, '\u2748'], [/\\ding\{105\}/g, '\u2749'], [/\\ding\{106\}/g, '\u274A'], [/\\ding\{107\}/g, '\u274B'], [/\\ding\{109\}/g, '\u274D'], [/\\ding\{111\}/g, '\u274F'], [/\\ding\{112\}/g, '\u2750'], [/\\ding\{113\}/g, '\u2751'], [/\\ding\{114\}/g, '\u2752'], [/\\ding\{118\}/g, '\u2756'], [/\\ding\{120\}/g, '\u2758'], [/\\ding\{121\}/g, '\u2759'], [/\\ding\{122\}/g, '\u275A'], [/\\ding\{123\}/g, '\u275B'], [/\\ding\{124\}/g, '\u275C'], [/\\ding\{125\}/g, '\u275D'], [/\\ding\{126\}/g, '\u275E'], [/\\ding\{161\}/g, '\u2761'], [/\\ding\{162\}/g, '\u2762'], [/\\ding\{163\}/g, '\u2763'], [/\\ding\{164\}/g, '\u2764'], [/\\ding\{165\}/g, '\u2765'], [/\\ding\{166\}/g, '\u2766'], [/\\ding\{167\}/g, '\u2767'], [/\\ding\{182\}/g, '\u2776'], [/\\ding\{183\}/g, '\u2777'], [/\\ding\{184\}/g, '\u2778'], [/\\ding\{185\}/g, '\u2779'], [/\\ding\{186\}/g, '\u277A'], [/\\ding\{187\}/g, '\u277B'], [/\\ding\{188\}/g, '\u277C'], [/\\ding\{189\}/g, '\u277D'], [/\\ding\{190\}/g, '\u277E'], [/\\ding\{191\}/g, '\u277F'], [/\\ding\{192\}/g, '\u2780'], [/\\ding\{193\}/g, '\u2781'], [/\\ding\{194\}/g, '\u2782'], [/\\ding\{195\}/g, '\u2783'], [/\\ding\{196\}/g, '\u2784'], [/\\ding\{197\}/g, '\u2785'], [/\\ding\{198\}/g, '\u2786'], [/\\ding\{199\}/g, '\u2787'], [/\\ding\{200\}/g, '\u2788'], [/\\ding\{201\}/g, '\u2789'], [/\\ding\{202\}/g, '\u278A'], [/\\ding\{203\}/g, '\u278B'], [/\\ding\{204\}/g, '\u278C'], [/\\ding\{205\}/g, '\u278D'], [/\\ding\{206\}/g, '\u278E'], [/\\ding\{207\}/g, '\u278F'], [/\\ding\{208\}/g, '\u2790'], [/\\ding\{209\}/g, '\u2791'], [/\\ding\{210\}/g, '\u2792'], [/\\ding\{211\}/g, '\u2793'], [/\\ding\{212\}/g, '\u2794'], [/\\ding\{216\}/g, '\u2798'], [/\\ding\{217\}/g, '\u2799'], [/\\ding\{218\}/g, '\u279A'], [/\\ding\{219\}/g, '\u279B'], [/\\ding\{220\}/g, '\u279C'], [/\\ding\{221\}/g, '\u279D'], [/\\ding\{222\}/g, '\u279E'], [/\\ding\{223\}/g, '\u279F'], [/\\ding\{224\}/g, '\u27A0'], [/\\ding\{225\}/g, '\u27A1'], [/\\ding\{226\}/g, '\u27A2'], [/\\ding\{227\}/g, '\u27A3'], [/\\ding\{228\}/g, '\u27A4'], [/\\ding\{229\}/g, '\u27A5'], [/\\ding\{230\}/g, '\u27A6'], [/\\ding\{231\}/g, '\u27A7'], [/\\ding\{232\}/g, '\u27A8'], [/\\ding\{233\}/g, '\u27A9'], [/\\ding\{234\}/g, '\u27AA'], [/\\ding\{235\}/g, '\u27AB'], [/\\ding\{236\}/g, '\u27AC'], [/\\ding\{237\}/g, '\u27AD'], [/\\ding\{238\}/g, '\u27AE'], [/\\ding\{239\}/g, '\u27AF'], [/\\ding\{241\}/g, '\u27B1'], [/\\ding\{242\}/g, '\u27B2'], [/\\ding\{243\}/g, '\u27B3'], [/\\ding\{244\}/g, '\u27B4'], [/\\ding\{245\}/g, '\u27B5'], [/\\ding\{246\}/g, '\u27B6'], [/\\ding\{247\}/g, '\u27B7'], [/\\ding\{248\}/g, '\u27B8'], [/\\ding\{249\}/g, '\u27B9'], [/\\ding\{250\}/g, '\u27BA'], [/\\ding\{251\}/g, '\u27BB'], [/\\ding\{252\}/g, '\u27BC'], [/\\ding\{253\}/g, '\u27BD'], [/\\ding\{254\}/g, '\u27BE'], [/\\longleftarrow /g, '\u27F5'], [/\\longrightarrow /g, '\u27F6'], [/\\longleftrightarrow /g, '\u27F7'], [/\\Longleftarrow /g, '\u27F8'], [/\\Longrightarrow /g, '\u27F9'], [/\\Longleftrightarrow /g, '\u27FA'], [/\\longmapsto /g, '\u27FC'], [/\\sim\\joinrel\\leadsto/g, '\u27FF'], [/\\ElsevierGlyph\{E212\}/g, '\u2905'], [/\\UpArrowBar /g, '\u2912'], [/\\DownArrowBar /g, '\u2913'], [/\\ElsevierGlyph\{E20C\}/g, '\u2923'], [/\\ElsevierGlyph\{E20D\}/g, '\u2924'], [/\\ElsevierGlyph\{E20B\}/g, '\u2925'], [/\\ElsevierGlyph\{E20A\}/g, '\u2926'], [/\\ElsevierGlyph\{E211\}/g, '\u2927'], [/\\ElsevierGlyph\{E20E\}/g, '\u2928'], [/\\ElsevierGlyph\{E20F\}/g, '\u2929'], [/\\ElsevierGlyph\{E210\}/g, '\u292A'], [/\\ElsevierGlyph\{E21C\}/g, '\u2933'], [/\\ElsevierGlyph\{E21D\}/g, '\u2933-00338'], [/\\ElsevierGlyph\{E21A\}/g, '\u2936'], [/\\ElsevierGlyph\{E219\}/g, '\u2937'], [/\\Elolarr /g, '\u2940'], [/\\Elorarr /g, '\u2941'], [/\\ElzRlarr /g, '\u2942'], [/\\ElzrLarr /g, '\u2944'], [/\\Elzrarrx /g, '\u2947'], [/\\LeftRightVector /g, '\u294E'], [/\\RightUpDownVector /g, '\u294F'], [/\\DownLeftRightVector /g, '\u2950'], [/\\LeftUpDownVector /g, '\u2951'], [/\\LeftVectorBar /g, '\u2952'], [/\\RightVectorBar /g, '\u2953'], [/\\RightUpVectorBar /g, '\u2954'], [/\\RightDownVectorBar /g, '\u2955'], [/\\DownLeftVectorBar /g, '\u2956'], [/\\DownRightVectorBar /g, '\u2957'], [/\\LeftUpVectorBar /g, '\u2958'], [/\\LeftDownVectorBar /g, '\u2959'], [/\\LeftTeeVector /g, '\u295A'], [/\\RightTeeVector /g, '\u295B'], [/\\RightUpTeeVector /g, '\u295C'], [/\\RightDownTeeVector /g, '\u295D'], [/\\DownLeftTeeVector /g, '\u295E'], [/\\DownRightTeeVector /g, '\u295F'], [/\\LeftUpTeeVector /g, '\u2960'], [/\\LeftDownTeeVector /g, '\u2961'], [/\\UpEquilibrium /g, '\u296E'], [/\\ReverseUpEquilibrium /g, '\u296F'], [/\\RoundImplies /g, '\u2970'], [/\\ElsevierGlyph\{E214\}/g, '\u297C'], [/\\ElsevierGlyph\{E215\}/g, '\u297D'], [/\\Elztfnc /g, '\u2980'], [/\\ElsevierGlyph\{3018\}/g, '\u2985'], [/\\Elroang /g, '\u2986'], [/\\ElsevierGlyph\{E291\}/g, '\u2994'], [/\\Elzddfnc /g, '\u2999'], [/\\Angle /g, '\u299C'], [/\\Elzlpargt /g, '\u29A0'], [/\\ElsevierGlyph\{E260\}/g, '\u29B5'], [/\\ElsevierGlyph\{E61B\}/g, '\u29B6'], [/\\ElzLap /g, '\u29CA'], [/\\Elzdefas /g, '\u29CB'], [/\\LeftTriangleBar /g, '\u29CF'], [/\\NotLeftTriangleBar /g, '\u29CF-00338'], [/\\RightTriangleBar /g, '\u29D0'], [/\\NotRightTriangleBar /g, '\u29D0-00338'], [/\\ElsevierGlyph\{E372\}/g, '\u29DC'], [/\\blacklozenge /g, '\u29EB'], [/\\RuleDelayed /g, '\u29F4'], [/\\Elxuplus /g, '\u2A04'], [/\\ElzThr /g, '\u2A05'], [/\\Elxsqcup /g, '\u2A06'], [/\\ElzInf /g, '\u2A07'], [/\\ElzSup /g, '\u2A08'], [/\\ElzCint /g, '\u2A0D'], [/\\clockoint /g, '\u2A0F'], [/\\ElsevierGlyph\{E395\}/g, '\u2A10'], [/\\sqrint /g, '\u2A16'], [/\\ElsevierGlyph\{E25A\}/g, '\u2A25'], [/\\ElsevierGlyph\{E25B\}/g, '\u2A2A'], [/\\ElsevierGlyph\{E25C\}/g, '\u2A2D'], [/\\ElsevierGlyph\{E25D\}/g, '\u2A2E'], [/\\ElzTimes /g, '\u2A2F'], [/\\ElsevierGlyph\{E25E\}/g, '\u2A34'], [/\\ElsevierGlyph\{E25E\}/g, '\u2A35'], [/\\ElsevierGlyph\{E259\}/g, '\u2A3C'], [/\\amalg /g, '\u2A3F'], [/\\ElzAnd /g, '\u2A53'], [/\\ElzOr /g, '\u2A54'], [/\\ElsevierGlyph\{E36E\}/g, '\u2A55'], [/\\ElOr /g, '\u2A56'], [/\\perspcorrespond /g, '\u2A5E'], [/\\Elzminhat /g, '\u2A5F'], [/\\ElsevierGlyph\{225A\}/g, '\u2A63'], [/\\stackrel\{*\}\{=\}/g, '\u2A6E'], [/\\Equal /g, '\u2A75'], [/\\leqslant /g, '\u2A7D'], [/\\nleqslant /g, '\u2A7D-00338'], [/\\geqslant /g, '\u2A7E'], [/\\ngeqslant /g, '\u2A7E-00338'], [/\\lessapprox /g, '\u2A85'], [/\\gtrapprox /g, '\u2A86'], [/\\lneq /g, '\u2A87'], [/\\gneq /g, '\u2A88'], [/\\lnapprox /g, '\u2A89'], [/\\gnapprox /g, '\u2A8A'], [/\\lesseqqgtr /g, '\u2A8B'], [/\\gtreqqless /g, '\u2A8C'], [/\\eqslantless /g, '\u2A95'], [/\\eqslantgtr /g, '\u2A96'], [/\\Pisymbol\{ppi020\}\{117\}/g, '\u2A9D'], [/\\Pisymbol\{ppi020\}\{105\}/g, '\u2A9E'], [/\\NestedLessLess /g, '\u2AA1'], [/\\NotNestedLessLess /g, '\u2AA1-00338'], [/\\NestedGreaterGreater /g, '\u2AA2'], [/\\NotNestedGreaterGreater /g, '\u2AA2-00338'], [/\\preceq /g, '\u2AAF'], [/\\not\\preceq /g, '\u2AAF-00338'], [/\\succeq /g, '\u2AB0'], [/\\not\\succeq /g, '\u2AB0-00338'], [/\\precneqq /g, '\u2AB5'], [/\\succneqq /g, '\u2AB6'], [/\\precapprox /g, '\u2AB7'], [/\\succapprox /g, '\u2AB8'], [/\\precnapprox /g, '\u2AB9'], [/\\succnapprox /g, '\u2ABA'], [/\\subseteqq /g, '\u2AC5'], [/\\nsubseteqq /g, '\u2AC5-00338'], [/\\supseteqq /g, '\u2AC6'], [/\\nsupseteqq/g, '\u2AC6-00338'], [/\\subsetneqq /g, '\u2ACB'], [/\\supsetneqq /g, '\u2ACC'], [/\\ElsevierGlyph\{E30D\}/g, '\u2AEB'], [/\\Elztdcol /g, '\u2AF6'], [/\\ElsevierGlyph\{300A\}/g, '\u300A'], [/\\ElsevierGlyph\{300B\}/g, '\u300B'], [/\\ElsevierGlyph\{3018\}/g, '\u3018'], [/\\ElsevierGlyph\{3019\}/g, '\u3019'], [/\\openbracketleft /g, '\u301A'], [/\\openbracketright /g, '\u301B']];
	
	  return this;
	} // end function BibtexParser
	
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = BibtexParser;
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(28), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (baseMVC, citationModel, _l) {
	
	    var CitationView = Backbone.View.extend({
	        tagName: 'div',
	        className: 'citations',
	        render: function () {
	            this.$el.append("<p>" + this.formattedReference() + "</p>");
	            return this;
	        },
	        formattedReference: function () {
	            var model = this.model;
	            var entryType = model.entryType();
	            var fields = model.fields();
	
	            var ref = "";
	            // Code inspired by...
	            // https://github.com/vkaravir/bib-publication-list/blob/master/src/bib-publication-list.js
	            var authorsAndYear = this._asSentence((fields.author ? fields.author : "") + (fields.year ? " (" + fields.year + ")" : "")) + " ";
	            var title = fields.title || "";
	            var pages = fields.pages ? "pp. " + fields.pages : "";
	            var address = fields.address;
	            if (entryType == "article") {
	                var volume = (fields.volume ? fields.volume : "") + (fields.number ? " (" + fields.number + ")" : "") + (pages ? ", " + pages : "");
	                ref = authorsAndYear + this._asSentence(title) + (fields.journal ? "In <em>" + fields.journal + ", " : "") + this._asSentence(volume) + this._asSentence(fields.address) + "<\/em>";
	            } else if (entryType == "inproceedings" || entryType == "proceedings") {
	                ref = authorsAndYear + this._asSentence(title) + (fields.booktitle ? "In <em>" + fields.booktitle + ", " : "") + (pages ? pages : "") + (address ? ", " + address : "") + ".<\/em>";
	            } else if (entryType == "mastersthesis" || entryType == "phdthesis") {
	                ref = authorsAndYear + this._asSentence(title) + (fields.howpublished ? fields.howpublished + ". " : "") + (fields.note ? fields.note + "." : "");
	            } else if (entryType == "techreport") {
	                ref = authorsAndYear + this._asSentence(title) + this._asSentence(fields.institution) + this._asSentence(fields.number) + this._asSentence(fields.type);
	            } else if (entryType == "book" || entryType == "inbook" || entryType == "incollection") {
	                ref = authorsAndYear + " " + this._formatBookInfo(fields);
	            } else {
	                ref = authorsAndYear + " " + this._asSentence(title) + this._asSentence(fields.howpublished) + this._asSentence(fields.note);
	            }
	            var doiUrl = "";
	            if (fields.doi) {
	                doiUrl = 'http://dx.doi.org/' + fields.doi;
	                ref += '[<a href="' + doiUrl + '" target="_blank">doi:' + fields.doi + "</a>]";
	            }
	            var url = fields.url || doiUrl;
	            if (url) {
	                ref += '[<a href="' + url + '" target="_blank">Link</a>]';
	            }
	            return ref;
	        },
	        _formatBookInfo: function (fields) {
	            var info = "";
	            if (fields.chapter) {
	                info += fields.chapter + " in ";
	            }
	            if (fields.title) {
	                info += "<em>" + fields.title + "<\/em>";
	            }
	            if (fields.editor) {
	                info += ", Edited by " + fields.editor + ", ";
	            }
	            if (fields.publisher) {
	                info += ", " + fields.publisher;
	            }
	            if (fields.pages) {
	                info += ", pp. " + fields.pages + "";
	            }
	            if (fields.series) {
	                info += ", <em>" + fields.series + "<\/em>";
	            }
	            if (fields.volume) {
	                info += ", Vol." + fields.volume;
	            }
	            if (fields.issn) {
	                info += ", ISBN: " + fields.issn;
	            }
	            return info + ".";
	        },
	        _asSentence: function (str) {
	            return str && str.trim() ? str + ". " : "";
	        }
	    });
	
	    var CitationListView = Backbone.View.extend({
	        el: '#citations',
	        /**
	         * Set up view.
	         */
	        initialize: function () {
	            this.listenTo(this.collection, 'add', this.renderCitation);
	        },
	
	        events: {
	            'click .citations-to-bibtex': 'showBibtex',
	            'click .citations-to-formatted': 'showFormatted'
	        },
	
	        renderCitation: function (citation) {
	            var citationView = new CitationView({ model: citation });
	            this.$(".citations-formatted").append(citationView.render().el);
	            var rawTextarea = this.$(".citations-bibtex-text");
	            rawTextarea.val(rawTextarea.val() + "\n\r" + citation.attributes.content);
	        },
	
	        render: function () {
	            this.$el.html(this.citationsElement());
	            this.collection.each(function (item) {
	                this.renderCitation(item);
	            }, this);
	            this.showFormatted();
	        },
	
	        showBibtex: function () {
	            this.$(".citations-to-formatted").show();
	            this.$(".citations-to-bibtex").hide();
	            this.$(".citations-bibtex").show();
	            this.$(".citations-formatted").hide();
	            this.$(".citations-bibtex-text").select();
	        },
	
	        showFormatted: function () {
	            this.$(".citations-to-formatted").hide();
	            this.$(".citations-to-bibtex").show();
	            this.$(".citations-bibtex").hide();
	            this.$(".citations-formatted").show();
	        },
	
	        partialWarningElement: function () {
	            if (this.collection.partial) {
	                return ['<div style="padding:5px 10px">', '<b>Warning: This is a experimental feature.</b> Most Galaxy tools will not annotate', ' citations explicitly at this time. When writing up your analysis, please manually', ' review your histories and find all references', ' that should be cited in order to completely describe your work. Also, please remember to', ' <a href="https://galaxyproject.org/citing-galaxy">cite Galaxy</a>.', '</div>'].join('');
	            } else {
	                return '';
	            }
	        },
	
	        citationsElement: function () {
	            return ['<div class="toolForm">', '<div class="toolFormTitle">', _l("Citations"), ' <button type="button" class="btn btn-xs citations-to-bibtex" title="Show all in BibTeX format."><i class="fa fa-pencil-square-o"></i> Show BibTeX</button>', ' <button type="button" class="btn btn-xs citations-to-formatted" title="Return to formatted citation list."><i class="fa fa-times"></i> Hide BibTeX</button>', '</div>', '<div class="toolFormBody" style="padding:5px 10px">', this.partialWarningElement(), '<span class="citations-formatted" style="word-wrap: break-word;"></span>', '</div>', '<div class="citations-bibtex toolFormBody" style="padding:5px 10px">', '<textarea style="width: 100%; height: 500px;" class="citations-bibtex-text"></textarea>', '</div>', '</div>'].join('');
	        }
	    });
	
	    //==============================================================================
	    return {
	        CitationView: CitationView,
	        CitationListView: CitationListView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(67), __webpack_require__(61), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_ITEM, DATASET_LI, BASE_MVC, _l) {
	
	    'use strict';
	    //==============================================================================
	
	    var FoldoutListItemView = LIST_ITEM.FoldoutListItemView,
	        ListItemView = LIST_ITEM.ListItemView;
	    /** @class Read only view for DatasetCollection.
	     */
	    var DCListItemView = FoldoutListItemView.extend(
	    /** @lends DCListItemView.prototype */{
	
	        className: FoldoutListItemView.prototype.className + " dataset-collection",
	        id: function () {
	            return ['dataset_collection', this.model.get('id')].join('-');
	        },
	
	        /** override to add linkTarget */
	        initialize: function (attributes) {
	            this.linkTarget = attributes.linkTarget || '_blank';
	            this.hasUser = attributes.hasUser;
	            FoldoutListItemView.prototype.initialize.call(this, attributes);
	        },
	
	        /** event listeners */
	        _setUpListeners: function () {
	            FoldoutListItemView.prototype._setUpListeners.call(this);
	            this.listenTo(this.model, 'change', function (model, options) {
	                // if the model has changed deletion status render it entirely
	                if (_.has(model.changed, 'deleted')) {
	                    this.render();
	
	                    // if the model has been decorated after the fact with the element count,
	                    // render the subtitle where the count is displayed
	                } else if (_.has(model.changed, 'element_count')) {
	                    this.$('> .title-bar .subtitle').replaceWith(this._renderSubtitle());
	                }
	            });
	        },
	
	        // ......................................................................... rendering
	        /** render a subtitle to show the user what sort of collection this is */
	        _renderSubtitle: function () {
	            return $(this.templates.subtitle(this.model.toJSON(), this));
	        },
	
	        // ......................................................................... foldout
	        /** override to add linktarget to sub-panel */
	        _getFoldoutPanelOptions: function () {
	            var options = FoldoutListItemView.prototype._getFoldoutPanelOptions.call(this);
	            return _.extend(options, {
	                linkTarget: this.linkTarget,
	                hasUser: this.hasUser
	            });
	        },
	
	        /** override to not catch sub-panel selectors */
	        $selector: function () {
	            return this.$('> .selector');
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DCListItemView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DCListItemView.prototype.templates = function () {
	
	        var warnings = _.extend({}, FoldoutListItemView.prototype.templates.warnings, {
	            error: BASE_MVC.wrapTemplate([
	            // error during index fetch - show error on dataset
	            '<% if( model.error ){ %>', '<div class="errormessagesmall">', _l('There was an error getting the data for this collection'), ': <%- model.error %>', '</div>', '<% } %>']),
	            purged: BASE_MVC.wrapTemplate(['<% if( model.purged ){ %>', '<div class="purged-msg warningmessagesmall">', _l('This collection has been deleted and removed from disk'), '</div>', '<% } %>']),
	            deleted: BASE_MVC.wrapTemplate([
	            // deleted not purged
	            '<% if( model.deleted && !model.purged ){ %>', '<div class="deleted-msg warningmessagesmall">', _l('This collection has been deleted'), '</div>', '<% } %>'])
	        });
	
	        // use element identifier
	        var titleBarTemplate = BASE_MVC.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<div class="title">', '<span class="name"><%- collection.element_identifier || collection.name %></span>', '</div>', '<div class="subtitle"></div>', '</div>'], 'collection');
	
	        // use element identifier
	        var subtitleTemplate = BASE_MVC.wrapTemplate(['<div class="subtitle">', '<% var countText = collection.element_count? ( collection.element_count + " " ) : ""; %>', '<%        if( collection.collection_type === "list" ){ %>', _l('a list of <%- countText %>datasets'), '<% } else if( collection.collection_type === "paired" ){ %>', _l('a pair of datasets'), '<% } else if( collection.collection_type === "list:paired" ){ %>', _l('a list of <%- countText %>dataset pairs'), '<% } else if( collection.collection_type === "list:list" ){ %>', _l('a list of <%- countText %>dataset lists'), '<% } %>', '</div>'], 'collection');
	
	        return _.extend({}, FoldoutListItemView.prototype.templates, {
	            warnings: warnings,
	            titleBar: titleBarTemplate,
	            subtitle: subtitleTemplate
	        });
	    }();
	
	    //==============================================================================
	    /** @class Read only view for DatasetCollectionElement.
	     */
	    var DCEListItemView = ListItemView.extend(
	    /** @lends DCEListItemView.prototype */{
	
	        /** add the DCE class to the list item */
	        className: ListItemView.prototype.className + " dataset-collection-element",
	
	        /** set up */
	        initialize: function (attributes) {
	            if (attributes.logger) {
	                this.logger = this.model.logger = attributes.logger;
	            }
	            this.log('DCEListItemView.initialize:', attributes);
	            ListItemView.prototype.initialize.call(this, attributes);
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DCEListItemView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DCEListItemView.prototype.templates = function () {
	
	        // use the element identifier here - since that will persist and the user will need it
	        var titleBarTemplate = BASE_MVC.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<div class="title">', '<span class="name"><%- element.element_identifier %></span>', '</div>', '<div class="subtitle"></div>', '</div>'], 'element');
	
	        return _.extend({}, ListItemView.prototype.templates, {
	            titleBar: titleBarTemplate
	        });
	    }();
	
	    //==============================================================================
	    /** @class Read only view for a DatasetCollectionElement that is also an DatasetAssociation
	     *      (a dataset contained in a dataset collection).
	     */
	    var DatasetDCEListItemView = DATASET_LI.DatasetListItemView.extend(
	    /** @lends DatasetDCEListItemView.prototype */{
	
	        className: DATASET_LI.DatasetListItemView.prototype.className + " dataset-collection-element",
	
	        /** set up */
	        initialize: function (attributes) {
	            if (attributes.logger) {
	                this.logger = this.model.logger = attributes.logger;
	            }
	            this.log('DatasetDCEListItemView.initialize:', attributes);
	            DATASET_LI.DatasetListItemView.prototype.initialize.call(this, attributes);
	        },
	
	        /** In this override, only get details if in the ready state.
	         *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
	         */
	        _fetchModelDetails: function () {
	            var view = this;
	            if (view.model.inReadyState() && !view.model.hasDetails()) {
	                return view.model.fetch({ silent: true });
	            }
	            return jQuery.when();
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DatasetDCEListItemView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DatasetDCEListItemView.prototype.templates = function () {
	
	        // use the element identifier here and not the dataset name
	        //TODO:?? can we steal the DCE titlebar?
	        var titleBarTemplate = BASE_MVC.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<span class="state-icon"></span>', '<div class="title">', '<span class="name"><%- element.element_identifier %></span>', '</div>', '</div>'], 'element');
	
	        return _.extend({}, DATASET_LI.DatasetListItemView.prototype.templates, {
	            titleBar: titleBarTemplate
	        });
	    }();
	
	    //==============================================================================
	    /** @class Read only view for a DatasetCollectionElement that is also a DatasetCollection
	     *      (a nested DC).
	     */
	    var NestedDCDCEListItemView = DCListItemView.extend(
	    /** @lends NestedDCDCEListItemView.prototype */{
	
	        className: DCListItemView.prototype.className + " dataset-collection-element",
	
	        /** In this override, add the state as a class for use with state-based CSS */
	        _swapNewRender: function ($newRender) {
	            DCListItemView.prototype._swapNewRender.call(this, $newRender);
	            var state = this.model.get('state') || 'ok';
	            this.$el.addClass('state-' + state);
	            return this.$el;
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'NestedDCDCEListItemView(' + modelString + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        DCListItemView: DCListItemView,
	        DCEListItemView: DCEListItemView,
	        DatasetDCEListItemView: DatasetDCEListItemView,
	        NestedDCDCEListItemView: NestedDCDCEListItemView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, Backbone, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(85), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DATASET_MODEL, BASE_MVC, _l) {
	    'use strict';
	
	    //==============================================================================
	    /*
	    Notes:
	    
	    Terminology:
	        DatasetCollection/DC : a container of datasets or nested DatasetCollections
	        Element/DatasetCollectionElement/DCE : an item contained in a DatasetCollection
	        HistoryDatasetCollectionAssociation/HDCA: a DatasetCollection contained in a history
	    
	    
	    This all seems too complex unfortunately:
	    
	    - Terminology collision between DatasetCollections (DCs) and Backbone Collections.
	    - In the DatasetCollections API JSON, DC Elements use a 'Has A' stucture to *contain*
	        either a dataset or a nested DC. This would make the hierarchy much taller. I've
	        decided to merge the contained JSON with the DC element json - making the 'has a'
	        relation into an 'is a' relation. This seems simpler to me and allowed a lot of
	        DRY in both models and views, but may make tracking or tracing within these models
	        more difficult (since DatasetCollectionElements are now *also* DatasetAssociations
	        or DatasetCollections (nested)). This also violates the rule of thumb about
	        favoring aggregation over inheritance.
	    - Currently, there are three DatasetCollection subclasses: List, Pair, and ListPaired.
	        These each should a) be usable on their own, b) be usable in the context of
	        nesting within a collection model (at least in the case of ListPaired), and
	        c) be usable within the context of other container models (like History or
	        LibraryFolder, etc.). I've tried to separate/extract classes in order to
	        handle those three situations, but it's proven difficult to do in a simple,
	        readable manner.
	    - Ideally, histories and libraries would inherit from the same server models as
	        dataset collections do since they are (in essence) dataset collections themselves -
	        making the whole nested structure simpler. This would be a large, error-prone
	        refactoring and migration.
	    
	    Many of the classes and heirarchy are meant as extension points so, while the
	    relations and flow may be difficult to understand initially, they'll allow us to
	    handle the growth or flux dataset collection in the future (w/o actually implementing
	    any YAGNI).
	    
	    */
	    //_________________________________________________________________________________________________ ELEMENTS
	    /** @class mixin for Dataset collection elements.
	     *      When collection elements are passed from the API, the underlying element is
	     *          in a sub-object 'object' (IOW, a DCE representing an HDA will have HDA json in element.object).
	     *      This mixin uses the constructor and parse methods to merge that JSON with the DCE attribtues
	     *          effectively changing a DCE from a container to a subclass (has a --> is a).
	     */
	
	    var DatasetCollectionElementMixin = {
	
	        /** default attributes used by elements in a dataset collection */
	        defaults: {
	            model_class: 'DatasetCollectionElement',
	            element_identifier: null,
	            element_index: null,
	            element_type: null
	        },
	
	        /** merge the attributes of the sub-object 'object' into this model */
	        _mergeObject: function (attributes) {
	            // if we don't preserve and correct ids here, the element id becomes the object id
	            // and collision in backbone's _byId will occur and only
	            _.extend(attributes, attributes.object, { element_id: attributes.id });
	            delete attributes.object;
	            return attributes;
	        },
	
	        /** override to merge this.object into this */
	        constructor: function (attributes, options) {
	            // console.debug( '\t DatasetCollectionElement.constructor:', attributes, options );
	            attributes = this._mergeObject(attributes);
	            this.idAttribute = 'element_id';
	            Backbone.Model.apply(this, arguments);
	        },
	
	        /** when the model is fetched, merge this.object into this */
	        parse: function (response, options) {
	            var attributes = response;
	            attributes = this._mergeObject(attributes);
	            return attributes;
	        }
	    };
	
	    /** @class Concrete class of Generic DatasetCollectionElement */
	    var DatasetCollectionElement = Backbone.Model.extend(BASE_MVC.LoggableMixin).extend(DatasetCollectionElementMixin).extend({ _logNamespace: 'collections' });
	
	    //==============================================================================
	    /** @class Base/Abstract Backbone collection for Generic DCEs. */
	    var DCECollection = Backbone.Collection.extend(BASE_MVC.LoggableMixin).extend(
	    /** @lends DCECollection.prototype */{
	        _logNamespace: 'collections',
	
	        model: DatasetCollectionElement,
	
	        /** String representation. */
	        toString: function () {
	            return ['DatasetCollectionElementCollection(', this.length, ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for a dataset collection element that is a dataset (HDA).
	     */
	    var DatasetDCE = DATASET_MODEL.DatasetAssociation.extend(BASE_MVC.mixin(DatasetCollectionElementMixin,
	    /** @lends DatasetDCE.prototype */{
	
	        /** url fn */
	        url: function () {
	            // won't always be an hda
	            if (!this.has('history_id')) {
	                console.warn('no endpoint for non-hdas within a collection yet');
	                // (a little silly since this api endpoint *also* points at hdas)
	                return Galaxy.root + 'api/datasets';
	            }
	            return Galaxy.root + 'api/histories/' + this.get('history_id') + '/contents/' + this.get('id');
	        },
	
	        defaults: _.extend({}, DATASET_MODEL.DatasetAssociation.prototype.defaults, DatasetCollectionElementMixin.defaults),
	
	        _downloadQueryParameters: function () {
	            return '?to_ext=' + this.get('file_ext') + '&hdca_id=' + this.get('parent_hdca_id') + '&element_identifier=' + this.get('element_identifier');
	        },
	
	        // because all objects have constructors (as this hashmap would even if this next line wasn't present)
	        //  the constructor in hcontentMixin won't be attached by BASE_MVC.mixin to this model
	        //  - re-apply manually for now
	        /** call the mixin constructor */
	        constructor: function (attributes, options) {
	            this.debug('\t DatasetDCE.constructor:', attributes, options);
	            //DATASET_MODEL.DatasetAssociation.prototype.constructor.call( this, attributes, options );
	            DatasetCollectionElementMixin.constructor.call(this, attributes, options);
	        },
	
	        /** Does this model already contain detailed data (as opposed to just summary level data)? */
	        hasDetails: function () {
	            return this.elements && this.elements.length;
	        },
	
	        /** String representation. */
	        toString: function () {
	            var objStr = this.get('element_identifier');
	            return ['DatasetDCE(', objStr, ')'].join('');
	        }
	    }));
	
	    //==============================================================================
	    /** @class DCECollection of DatasetDCE's (a list of datasets, a pair of datasets).
	     */
	    var DatasetDCECollection = DCECollection.extend(
	    /** @lends DatasetDCECollection.prototype */{
	        model: DatasetDCE,
	
	        /** String representation. */
	        toString: function () {
	            return ['DatasetDCECollection(', this.length, ')'].join('');
	        }
	    });
	
	    //_________________________________________________________________________________________________ COLLECTIONS
	    /** @class Backbone model for Dataset Collections.
	     *      The DC API returns an array of JSON objects under the attribute elements.
	     *      This model:
	     *          - removes that array/attribute ('elements') from the model,
	     *          - creates a bbone collection (of the class defined in the 'collectionClass' attribute),
	     *          - passes that json onto the bbone collection
	     *          - caches the bbone collection in this.elements
	     */
	    var DatasetCollection = Backbone.Model.extend(BASE_MVC.LoggableMixin).extend(BASE_MVC.SearchableModelMixin).extend( /** @lends DatasetCollection.prototype */{
	        _logNamespace: 'collections',
	
	        /** default attributes for a model */
	        defaults: {
	            /* 'list', 'paired', or 'list:paired' */
	            collection_type: null,
	            //??
	            deleted: false
	        },
	
	        /** Which class to use for elements */
	        collectionClass: DCECollection,
	
	        /** set up: create elements instance var and (on changes to elements) update them  */
	        initialize: function (model, options) {
	            this.debug(this + '(DatasetCollection).initialize:', model, options, this);
	            this.elements = this._createElementsModel();
	            this.on('change:elements', function () {
	                this.log('change:elements');
	                //TODO: prob. better to update the collection instead of re-creating it
	                this.elements = this._createElementsModel();
	            });
	        },
	
	        /** move elements model attribute to full collection */
	        _createElementsModel: function () {
	            this.debug(this + '._createElementsModel', this.collectionClass, this.get('elements'), this.elements);
	            //TODO: same patterns as DatasetCollectionElement _createObjectModel - refactor to BASE_MVC.hasSubModel?
	            var elements = this.get('elements') || [];
	            this.unset('elements', { silent: true });
	            var self = this;
	            _.each(elements, function (element, index) {
	                _.extend(element, { "parent_hdca_id": self.get("id") });
	            });
	            this.elements = new this.collectionClass(elements);
	            //this.debug( 'collectionClass:', this.collectionClass + '', this.elements );
	            return this.elements;
	        },
	
	        // ........................................................................ common queries
	        /** pass the elements back within the model json when this is serialized */
	        toJSON: function () {
	            var json = Backbone.Model.prototype.toJSON.call(this);
	            if (this.elements) {
	                json.elements = this.elements.toJSON();
	            }
	            return json;
	        },
	
	        /** Is this collection in a 'ready' state no processing (for the collection) is left
	         *  to do on the server.
	         */
	        inReadyState: function () {
	            var populated = this.get('populated');
	            return this.isDeletedOrPurged() || populated;
	        },
	
	        //TODO:?? the following are the same interface as DatasetAssociation - can we combine?
	        /** Does the DC contain any elements yet? Is a fetch() required? */
	        hasDetails: function () {
	            return this.elements.length !== 0;
	        },
	
	        /** Given the filters, what models in this.elements would be returned? */
	        getVisibleContents: function (filters) {
	            // filters unused for now
	            return this.elements;
	        },
	
	        // ........................................................................ ajax
	        /** override to use actual Dates objects for create/update times */
	        parse: function (response, options) {
	            var parsed = Backbone.Model.prototype.parse.call(this, response, options);
	            if (parsed.create_time) {
	                parsed.create_time = new Date(parsed.create_time);
	            }
	            if (parsed.update_time) {
	                parsed.update_time = new Date(parsed.update_time);
	            }
	            return parsed;
	        },
	
	        /** save this dataset, _Mark_ing it as deleted (just a flag) */
	        'delete': function (options) {
	            if (this.get('deleted')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: true }, options);
	        },
	        /** save this dataset, _Mark_ing it as undeleted */
	        undelete: function (options) {
	            if (!this.get('deleted') || this.get('purged')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: false }, options);
	        },
	
	        /** Is this collection deleted or purged? */
	        isDeletedOrPurged: function () {
	            return this.get('deleted') || this.get('purged');
	        },
	
	        // ........................................................................ searchable
	        /** searchable attributes for collections */
	        searchAttributes: ['name', 'tags'],
	
	        // ........................................................................ misc
	        /** String representation */
	        toString: function () {
	            var idAndName = [this.get('id'), this.get('name') || this.get('element_identifier')];
	            return 'DatasetCollection(' + idAndName.join(',') + ')';
	        }
	    });
	
	    //==============================================================================
	    /** Model for a DatasetCollection containing datasets (non-nested).
	     */
	    var ListDatasetCollection = DatasetCollection.extend(
	    /** @lends ListDatasetCollection.prototype */{
	
	        /** override since we know the collection will only contain datasets */
	        collectionClass: DatasetDCECollection,
	
	        /** String representation. */
	        toString: function () {
	            return 'List' + DatasetCollection.prototype.toString.call(this);
	        }
	    });
	
	    //==============================================================================
	    /** Model for a DatasetCollection containing fwd/rev datasets (a list of 2).
	     */
	    var PairDatasetCollection = ListDatasetCollection.extend(
	    /** @lends PairDatasetCollection.prototype */{
	
	        /** String representation. */
	        toString: function () {
	            return 'Pair' + DatasetCollection.prototype.toString.call(this);
	        }
	    });
	
	    //_________________________________________________________________________________________________ NESTED COLLECTIONS
	    // this is where things get weird, man. Weird.
	    //TODO: it might be possible to compact all the following...I think.
	    //==============================================================================
	    /** @class Backbone model for a Generic DatasetCollectionElement that is also a DatasetCollection
	     *      (a nested collection). Currently only list:paired.
	     */
	    var NestedDCDCE = DatasetCollection.extend(BASE_MVC.mixin(DatasetCollectionElementMixin,
	    /** @lends NestedDCDCE.prototype */{
	
	        // because all objects have constructors (as this hashmap would even if this next line wasn't present)
	        //  the constructor in hcontentMixin won't be attached by BASE_MVC.mixin to this model
	        //  - re-apply manually it now
	        /** call the mixin constructor */
	        constructor: function (attributes, options) {
	            this.debug('\t NestedDCDCE.constructor:', attributes, options);
	            DatasetCollectionElementMixin.constructor.call(this, attributes, options);
	        },
	
	        /** String representation. */
	        toString: function () {
	            var objStr = this.object ? '' + this.object : this.get('element_identifier');
	            return ['NestedDCDCE(', objStr, ')'].join('');
	        }
	    }));
	
	    //==============================================================================
	    /** @class Backbone collection containing Generic NestedDCDCE's (nested dataset collections).
	     */
	    var NestedDCDCECollection = DCECollection.extend(
	    /** @lends NestedDCDCECollection.prototype */{
	
	        /** This is a collection of nested collections */
	        model: NestedDCDCE,
	
	        /** String representation. */
	        toString: function () {
	            return ['NestedDCDCECollection(', this.length, ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for a paired dataset collection within a list:paired dataset collection.
	     */
	    var NestedPairDCDCE = PairDatasetCollection.extend(BASE_MVC.mixin(DatasetCollectionElementMixin,
	    /** @lends NestedPairDCDCE.prototype */{
	        //TODO:?? possibly rename to NestedDatasetCollection?
	
	        // because all objects have constructors (as this hashmap would even if this next line wasn't present)
	        //  the constructor in hcontentMixin won't be attached by BASE_MVC.mixin to this model
	        //  - re-apply manually it now
	        /** This is both a collection and a collection element - call the constructor */
	        constructor: function (attributes, options) {
	            this.debug('\t NestedPairDCDCE.constructor:', attributes, options);
	            //DatasetCollection.constructor.call( this, attributes, options );
	            DatasetCollectionElementMixin.constructor.call(this, attributes, options);
	        },
	
	        /** String representation. */
	        toString: function () {
	            var objStr = this.object ? '' + this.object : this.get('element_identifier');
	            return ['NestedPairDCDCE(', objStr, ')'].join('');
	        }
	    }));
	
	    //==============================================================================
	    /** @class Backbone collection for a backbone collection containing paired dataset collections.
	     */
	    var NestedPairDCDCECollection = NestedDCDCECollection.extend(
	    /** @lends PairDCDCECollection.prototype */{
	
	        /** We know this collection is composed of only nested pair collections */
	        model: NestedPairDCDCE,
	
	        /** String representation. */
	        toString: function () {
	            return ['NestedPairDCDCECollection(', this.length, ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone Model for a DatasetCollection (list) that contains DatasetCollections (pairs).
	     */
	    var ListPairedDatasetCollection = DatasetCollection.extend(
	    /** @lends ListPairedDatasetCollection.prototype */{
	
	        /** list:paired is the only collection that itself contains collections */
	        collectionClass: NestedPairDCDCECollection,
	
	        /** String representation. */
	        toString: function () {
	            return ['ListPairedDatasetCollection(', this.get('name'), ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for a list dataset collection within a list:list dataset collection. */
	    var NestedListDCDCE = ListDatasetCollection.extend(BASE_MVC.mixin(DatasetCollectionElementMixin,
	    /** @lends NestedListDCDCE.prototype */{
	
	        /** This is both a collection and a collection element - call the constructor */
	        constructor: function (attributes, options) {
	            this.debug('\t NestedListDCDCE.constructor:', attributes, options);
	            DatasetCollectionElementMixin.constructor.call(this, attributes, options);
	        },
	
	        /** String representation. */
	        toString: function () {
	            var objStr = this.object ? '' + this.object : this.get('element_identifier');
	            return ['NestedListDCDCE(', objStr, ')'].join('');
	        }
	    }));
	
	    //==============================================================================
	    /** @class Backbone collection containing list dataset collections. */
	    var NestedListDCDCECollection = NestedDCDCECollection.extend({
	
	        /** We know this collection is composed of only nested pair collections */
	        model: NestedListDCDCE,
	
	        /** String representation. */
	        toString: function () {
	            return ['NestedListDCDCECollection(', this.length, ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone Model for a DatasetCollection (list) that contains other lists. */
	    var ListOfListsDatasetCollection = DatasetCollection.extend({
	
	        /** list:paired is the only collection that itself contains collections */
	        collectionClass: NestedListDCDCECollection,
	
	        /** String representation. */
	        toString: function () {
	            return ['ListOfListsDatasetCollection(', this.get('name'), ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    return {
	        ListDatasetCollection: ListDatasetCollection,
	        PairDatasetCollection: PairDatasetCollection,
	        ListPairedDatasetCollection: ListPairedDatasetCollection,
	        ListOfListsDatasetCollection: ListOfListsDatasetCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $, jQuery) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(63), __webpack_require__(17), __webpack_require__(7), __webpack_require__(82), __webpack_require__(8), __webpack_require__(100), __webpack_require__(6), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HDCA, STATES, BASE_MVC, baseCreator, UI_MODAL, naturalSort, _l) {
	
	    'use strict';
	
	    var logNamespace = 'collections';
	
	    /*==============================================================================
	    TODO:
	        use proper Element model and not just json
	        straighten out createFn, collection.createHDCA
	        possibly stop using modals for this
	        It would be neat to do a drag and drop
	    
	    ==============================================================================*/
	    /** A view for both DatasetDCEs and NestedDCDCEs
	     *  (things that implement collection-model:DatasetCollectionElementMixin)
	     */
	    var DatasetCollectionElementView = Backbone.View.extend(BASE_MVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        //TODO: use proper class (DatasetDCE or NestedDCDCE (or the union of both))
	        tagName: 'li',
	        className: 'collection-element',
	
	        initialize: function (attributes) {
	            this.element = attributes.element || {};
	            this.selected = attributes.selected || false;
	        },
	
	        render: function () {
	            this.$el.attr('data-element-id', this.element.id).attr('draggable', true).html(this.template({ element: this.element }));
	            if (this.selected) {
	                this.$el.addClass('selected');
	            }
	            return this;
	        },
	
	        //TODO: lots of unused space in the element - possibly load details and display them horiz.
	        template: _.template(['<a class="name" title="', _l('Click to rename'), '" href="javascript:void(0)">', '<%- element.name %>', '</a>', '<button class="discard btn btn-sm" title="', _l('Remove this dataset from the list'), '">', _l('Discard'), '</button>'].join('')),
	
	        /** select this element and pub */
	        select: function (toggle) {
	            this.$el.toggleClass('selected', toggle);
	            this.trigger('select', {
	                source: this,
	                selected: this.$el.hasClass('selected')
	            });
	        },
	
	        /** animate the removal of this element and pub */
	        discard: function () {
	            var view = this,
	                parentWidth = this.$el.parent().width();
	            this.$el.animate({ 'margin-right': parentWidth }, 'fast', function () {
	                view.trigger('discard', {
	                    source: view
	                });
	                view.destroy();
	            });
	        },
	
	        /** remove the DOM and any listeners */
	        destroy: function () {
	            this.off();
	            this.$el.remove();
	        },
	
	        events: {
	            'click': '_click',
	            'click .name': '_clickName',
	            'click .discard': '_clickDiscard',
	
	            'dragstart': '_dragstart',
	            'dragend': '_dragend',
	            'dragover': '_sendToParent',
	            'drop': '_sendToParent'
	        },
	
	        /** select when the li is clicked */
	        _click: function (ev) {
	            ev.stopPropagation();
	            this.select(ev);
	        },
	
	        /** rename a pair when the name is clicked */
	        _clickName: function (ev) {
	            ev.stopPropagation();
	            ev.preventDefault();
	            var promptString = [_l('Enter a new name for the element'), ':\n(', _l('Note that changing the name here will not rename the dataset'), ')'].join(''),
	                response = prompt(_l('Enter a new name for the element') + ':', this.element.name);
	            if (response) {
	                this.element.name = response;
	                this.render();
	            }
	            //TODO: cancelling with ESC leads to closure of the creator...
	        },
	
	        /** discard when the discard button is clicked */
	        _clickDiscard: function (ev) {
	            ev.stopPropagation();
	            this.discard();
	        },
	
	        /** dragging pairs for re-ordering */
	        _dragstart: function (ev) {
	            if (ev.originalEvent) {
	                ev = ev.originalEvent;
	            }
	            ev.dataTransfer.effectAllowed = 'move';
	            ev.dataTransfer.setData('text/plain', JSON.stringify(this.element));
	
	            this.$el.addClass('dragging');
	            this.$el.parent().trigger('collection-element.dragstart', [this]);
	        },
	
	        /** dragging for re-ordering */
	        _dragend: function (ev) {
	            this.$el.removeClass('dragging');
	            this.$el.parent().trigger('collection-element.dragend', [this]);
	        },
	
	        /** manually bubble up an event to the parent/container */
	        _sendToParent: function (ev) {
	            this.$el.parent().trigger(ev);
	        },
	
	        /** string rep */
	        toString: function () {
	            return 'DatasetCollectionElementView()';
	        }
	    });
	
	    // ============================================================================
	    /** An interface for building collections.
	     */
	    var ListCollectionCreator = Backbone.View.extend(BASE_MVC.LoggableMixin).extend(baseCreator.CollectionCreatorMixin).extend({
	        _logNamespace: logNamespace,
	
	        /** the class used to display individual elements */
	        elementViewClass: DatasetCollectionElementView,
	        /** the class this creator will create and save */
	        collectionClass: HDCA.HistoryListDatasetCollection,
	        className: 'list-collection-creator collection-creator flex-row-container',
	
	        /** minimum number of valid elements to start with in order to build a collection of this type */
	        minElements: 1,
	
	        defaultAttributes: {
	            //TODO: remove - use new collectionClass().save()
	            /** takes elements and creates the proper collection - returns a promise */
	            creationFn: function () {
	                throw new TypeError('no creation fn for creator');
	            },
	            /** fn to call when the collection is created (scoped to this) */
	            oncreate: function () {},
	            /** fn to call when the cancel button is clicked (scoped to this) - if falsy, no btn is displayed */
	            oncancel: function () {},
	            /** distance from list edge to begin autoscrolling list */
	            autoscrollDist: 24,
	            /** Color passed to hoverhighlight */
	            highlightClr: 'rgba( 64, 255, 255, 1.0 )'
	        },
	
	        footerSettings: {
	            '.hide-originals': 'hideOriginals'
	        },
	
	        /** set up initial options, instance vars, behaviors */
	        initialize: function (attributes) {
	            this.metric('ListCollectionCreator.initialize', attributes);
	            var creator = this;
	            _.each(this.defaultAttributes, function (value, key) {
	                value = attributes[key] || value;
	                creator[key] = value;
	            });
	
	            /** unordered, original list - cache to allow reversal */
	            creator.initialElements = attributes.elements || [];
	
	            this._setUpCommonSettings(attributes);
	            this._instanceSetUp();
	            this._elementsSetUp();
	            this._setUpBehaviors();
	        },
	
	        /** set up instance vars */
	        _instanceSetUp: function () {
	            /** Ids of elements that have been selected by the user - to preserve over renders */
	            this.selectedIds = {};
	            /** DOM elements currently being dragged */
	            this.$dragging = null;
	            /** Used for blocking UI events during ajax/operations (don't post twice) */
	            this.blocking = false;
	        },
	
	        // ------------------------------------------------------------------------ process raw list
	        /** set up main data */
	        _elementsSetUp: function () {
	            //this.debug( '-- _dataSetUp' );
	            /** a list of invalid elements and the reasons they aren't valid */
	            this.invalidElements = [];
	            //TODO: handle fundamental problem of syncing DOM, views, and list here
	            /** data for list in progress */
	            this.workingElements = [];
	            /** views for workingElements */
	            this.elementViews = [];
	
	            // copy initial list, sort, add ids if needed
	            this.workingElements = this.initialElements.slice(0);
	            this._ensureElementIds();
	            this._validateElements();
	            this._mangleDuplicateNames();
	            this._sortElements();
	        },
	
	        /** add ids to dataset objs in initial list if none */
	        _ensureElementIds: function () {
	            this.workingElements.forEach(function (element) {
	                if (!element.hasOwnProperty('id')) {
	                    element.id = _.uniqueId();
	                }
	            });
	            return this.workingElements;
	        },
	
	        /** separate working list into valid and invalid elements for this collection */
	        _validateElements: function () {
	            var creator = this,
	                existingNames = {};
	            creator.invalidElements = [];
	
	            this.workingElements = this.workingElements.filter(function (element) {
	                var problem = creator._isElementInvalid(element);
	                if (problem) {
	                    creator.invalidElements.push({
	                        element: element,
	                        text: problem
	                    });
	                }
	                return !problem;
	            });
	            return this.workingElements;
	        },
	
	        /** describe what is wrong with a particular element if anything */
	        _isElementInvalid: function (element) {
	            if (element.history_content_type !== 'dataset') {
	                return _l("is not a dataset");
	            }
	            var validState = element.state === STATES.OK || _.contains(STATES.NOT_READY_STATES, element.state);
	            if (!validState) {
	                return _l("has errored, is paused, or is not accessible");
	            }
	            if (element.deleted || element.purged) {
	                return _l("has been deleted or purged");
	            }
	            return null;
	        },
	
	        /** mangle duplicate names using a mac-like '(counter)' addition to any duplicates */
	        _mangleDuplicateNames: function () {
	            var SAFETY = 900,
	                counter = 1,
	                existingNames = {};
	            this.workingElements.forEach(function (element) {
	                var currName = element.name;
	                while (existingNames.hasOwnProperty(currName)) {
	                    currName = element.name + ' (' + counter + ')';
	                    counter += 1;
	                    if (counter >= SAFETY) {
	                        throw new Error('Safety hit in while loop - thats impressive');
	                    }
	                }
	                element.name = currName;
	                existingNames[element.name] = true;
	            });
	        },
	
	        /** sort a list of elements */
	        _sortElements: function (list) {
	            // // currently only natural sort by name
	            // this.workingElements.sort( function( a, b ){ return naturalSort( a.name, b.name ); });
	            // return this.workingElements;
	        },
	
	        // ------------------------------------------------------------------------ rendering
	        // templates : ListCollectionCreator.templates,
	        /** render the entire interface */
	        render: function (speed, callback) {
	            //this.debug( '-- _render' );
	            if (this.workingElements.length < this.minElements) {
	                return this._renderInvalid(speed, callback);
	            }
	
	            this.$el.empty().html(this.templates.main());
	            this._renderHeader(speed);
	            this._renderMiddle(speed);
	            this._renderFooter(speed);
	            this._addPluginComponents();
	            this.$('.collection-name').focus();
	            this.trigger('rendered', this);
	            return this;
	        },
	
	        /** render a simplified interface aimed at telling the user why they can't move forward */
	        _renderInvalid: function (speed, callback) {
	            //this.debug( '-- _render' );
	            this.$el.empty().html(this.templates.invalidInitial({
	                problems: this.invalidElements,
	                elements: this.workingElements
	            }));
	            if (typeof this.oncancel === 'function') {
	                this.$('.cancel-create.btn').show();
	            }
	            this.trigger('rendered', this);
	            return this;
	        },
	
	        /** render the header section */
	        _renderHeader: function (speed, callback) {
	            var $header = this.$('.header').empty().html(this.templates.header()).find('.help-content').prepend($(this.templates.helpContent()));
	            //TODO: should only show once despite calling _renderHeader again
	            if (this.invalidElements.length) {
	                this._invalidElementsAlert();
	            }
	            return $header;
	        },
	
	        /** render the middle including the elements */
	        _renderMiddle: function (speed, callback) {
	            var $middle = this.$('.middle').empty().html(this.templates.middle());
	            this._renderList(speed);
	            return $middle;
	        },
	
	        /** add any jQuery/bootstrap/custom plugins to elements rendered */
	        _addPluginComponents: function () {
	            this.$('.help-content i').hoverhighlight('.collection-creator', this.highlightClr);
	        },
	
	        /** build and show an alert describing any elements that could not be included due to problems */
	        _invalidElementsAlert: function () {
	            this._showAlert(this.templates.invalidElements({ problems: this.invalidElements }), 'alert-warning');
	        },
	
	        _disableNameAndCreate: function (disable) {
	            disable = !_.isUndefined(disable) ? disable : true;
	            if (disable) {
	                this.$('.collection-name').prop('disabled', true);
	                this.$('.create-collection').toggleClass('disabled', true);
	                // } else {
	                //     this.$( '.collection-name' ).prop( 'disabled', false );
	                //     this.$( '.create-collection' ).removeClass( 'disable' );
	            }
	        },
	
	        // ------------------------------------------------------------------------ rendering elements
	        /** conv. to the main list display DOM */
	        $list: function () {
	            return this.$('.collection-elements');
	        },
	
	        /** show or hide the clear selected control based on the num of selected elements */
	        _renderClearSelected: function () {
	            if (_.size(this.selectedIds)) {
	                this.$('.collection-elements-controls > .clear-selected').show();
	            } else {
	                this.$('.collection-elements-controls > .clear-selected').hide();
	            }
	        },
	
	        /** render the elements in order (or a warning if no elements found) */
	        _renderList: function (speed, callback) {
	            //this.debug( '-- _renderList' );
	            var creator = this,
	                $tmp = jQuery('<div/>'),
	                $list = creator.$list();
	
	            _.each(this.elementViews, function (view) {
	                view.destroy();
	                creator.removeElementView(view);
	            });
	
	            // if( !this.workingElements.length ){
	            //     this._renderNoValidElements();
	            //     return;
	            // }
	
	            creator.workingElements.forEach(function (element) {
	                var elementView = creator._createElementView(element);
	                $tmp.append(elementView.$el);
	            });
	
	            creator._renderClearSelected();
	            $list.empty().append($tmp.children());
	            _.invoke(creator.elementViews, 'render');
	
	            if ($list.height() > $list.css('max-height')) {
	                $list.css('border-width', '1px 0px 1px 0px');
	            } else {
	                $list.css('border-width', '0px');
	            }
	        },
	
	        /** create an element view, cache in elementViews, set up listeners, and return */
	        _createElementView: function (element) {
	            var elementView = new this.elementViewClass({
	                //TODO: use non-generic class or not all
	                // model : COLLECTION.DatasetDCE( element )
	                element: element,
	                selected: _.has(this.selectedIds, element.id)
	            });
	            this.elementViews.push(elementView);
	            this._listenToElementView(elementView);
	            return elementView;
	        },
	
	        /** listen to any element events */
	        _listenToElementView: function (view) {
	            var creator = this;
	            creator.listenTo(view, {
	                select: function (data) {
	                    var element = data.source.element;
	                    if (data.selected) {
	                        creator.selectedIds[element.id] = true;
	                    } else {
	                        delete creator.selectedIds[element.id];
	                    }
	                    creator.trigger('elements:select', data);
	                },
	                discard: function (data) {
	                    creator.trigger('elements:discard', data);
	                }
	            });
	        },
	
	        /** add a new element view based on the json in element */
	        addElementView: function (element) {
	            //TODO: workingElements is sorted, add element in appropo index
	            // add element, sort elements, find element index
	            // var view = this._createElementView( element );
	            // return view;
	        },
	
	        /** stop listening to view and remove from caches */
	        removeElementView: function (view) {
	            delete this.selectedIds[view.element.id];
	            this._renderClearSelected();
	
	            this.elementViews = _.without(this.elementViews, view);
	            this.stopListening(view);
	        },
	
	        /** render a message in the list that no elements remain to create a collection */
	        _renderNoElementsLeft: function () {
	            this._disableNameAndCreate(true);
	            this.$('.collection-elements').append(this.templates.noElementsLeft());
	        },
	
	        // /** render a message in the list that no valid elements were found to create a collection */
	        // _renderNoValidElements : function(){
	        //     this._disableNameAndCreate( true );
	        //     this.$( '.collection-elements' ).append( this.templates.noValidElements() );
	        // },
	
	        // ------------------------------------------------------------------------ API
	        /** convert element into JSON compatible with the collections API */
	        _elementToJSON: function (element) {
	            // return element.toJSON();
	            return element;
	        },
	
	        /** create the collection via the API
	         *  @returns {jQuery.xhr Object} the jquery ajax request
	         */
	        createList: function (name) {
	            if (!this.workingElements.length) {
	                var message = _l('No valid elements for final list') + '. ';
	                message += '<a class="cancel-create" href="javascript:void(0);">' + _l('Cancel') + '</a> ';
	                message += _l('or');
	                message += ' <a class="reset" href="javascript:void(0);">' + _l('start over') + '</a>.';
	                this._showAlert(message);
	                return;
	            }
	
	            var creator = this,
	                elements = this.workingElements.map(function (element) {
	                return creator._elementToJSON(element);
	            });
	
	            creator.blocking = true;
	            return creator.creationFn(elements, name, creator.hideOriginals).always(function () {
	                creator.blocking = false;
	            }).fail(function (xhr, status, message) {
	                creator.trigger('error', {
	                    xhr: xhr,
	                    status: status,
	                    message: _l('An error occurred while creating this collection')
	                });
	            }).done(function (response, message, xhr) {
	                creator.trigger('collection:created', response, message, xhr);
	                creator.metric('collection:created', response);
	                if (typeof creator.oncreate === 'function') {
	                    creator.oncreate.call(this, response, message, xhr);
	                }
	            });
	        },
	
	        // ------------------------------------------------------------------------ events
	        /** set up event handlers on self */
	        _setUpBehaviors: function () {
	            this.on('error', this._errorHandler);
	
	            this.once('rendered', function () {
	                this.trigger('rendered:initial', this);
	            });
	
	            this.on('elements:select', function (data) {
	                this._renderClearSelected();
	            });
	
	            this.on('elements:discard', function (data) {
	                var element = data.source.element;
	                this.removeElementView(data.source);
	
	                this.workingElements = _.without(this.workingElements, element);
	                if (!this.workingElements.length) {
	                    this._renderNoElementsLeft();
	                }
	            });
	
	            //this.on( 'all', function(){
	            //    this.info( arguments );
	            //});
	            return this;
	        },
	
	        /** handle errors with feedback and details to the user (if available) */
	        _errorHandler: function (data) {
	            this.error(data);
	
	            var creator = this,
	                content = data.message || _l('An error occurred');
	            if (data.xhr) {
	                var xhr = data.xhr,
	                    message = data.message;
	                if (xhr.readyState === 0 && xhr.status === 0) {
	                    content += ': ' + _l('Galaxy could not be reached and may be updating.') + _l(' Try again in a few minutes.');
	                } else if (xhr.responseJSON) {
	                    content += ':<br /><pre>' + JSON.stringify(xhr.responseJSON) + '</pre>';
	                } else {
	                    content += ': ' + message;
	                }
	            }
	            creator._showAlert(content, 'alert-danger');
	        },
	
	        events: {
	            // header
	            'click .more-help': '_clickMoreHelp',
	            'click .less-help': '_clickLessHelp',
	            'click .main-help': '_toggleHelp',
	            'click .header .alert button': '_hideAlert',
	
	            'click .reset': 'reset',
	            'click .clear-selected': 'clearSelectedElements',
	
	            // elements - selection
	            'click .collection-elements': 'clearSelectedElements',
	
	            // elements - drop target
	            // 'dragenter .collection-elements': '_dragenterElements',
	            // 'dragleave .collection-elements': '_dragleaveElements',
	            'dragover .collection-elements': '_dragoverElements',
	            'drop .collection-elements': '_dropElements',
	
	            // these bubble up from the elements as custom events
	            'collection-element.dragstart .collection-elements': '_elementDragstart',
	            'collection-element.dragend   .collection-elements': '_elementDragend',
	
	            // footer
	            'change .collection-name': '_changeName',
	            'keydown .collection-name': '_nameCheckForEnter',
	            'change .hide-originals': '_changeHideOriginals',
	            'click .cancel-create': '_cancelCreate',
	            'click .create-collection': '_clickCreate' //,
	        },
	
	        // ........................................................................ elements
	        /** reset all data to the initial state */
	        reset: function () {
	            this._instanceSetUp();
	            this._elementsSetUp();
	            this.render();
	        },
	
	        /** deselect all elements */
	        clearSelectedElements: function (ev) {
	            this.$('.collection-elements .collection-element').removeClass('selected');
	            this.$('.collection-elements-controls > .clear-selected').hide();
	        },
	
	        //_dragenterElements : function( ev ){
	        //    //this.debug( '_dragenterElements:', ev );
	        //},
	        //TODO: if selected are dragged out of the list area - remove the placeholder - cuz it won't work anyway
	        // _dragleaveElements : function( ev ){
	        //    //this.debug( '_dragleaveElements:', ev );
	        // },
	
	        /** track the mouse drag over the list adding a placeholder to show where the drop would occur */
	        _dragoverElements: function (ev) {
	            //this.debug( '_dragoverElements:', ev );
	            ev.preventDefault();
	
	            var $list = this.$list();
	            this._checkForAutoscroll($list, ev.originalEvent.clientY);
	            var $nearest = this._getNearestElement(ev.originalEvent.clientY);
	
	            //TODO: no need to re-create - move instead
	            this.$('.element-drop-placeholder').remove();
	            var $placeholder = $('<div class="element-drop-placeholder"></div>');
	            if (!$nearest.length) {
	                $list.append($placeholder);
	            } else {
	                $nearest.before($placeholder);
	            }
	        },
	
	        /** If the mouse is near enough to the list's top or bottom, scroll the list */
	        _checkForAutoscroll: function ($element, y) {
	            var AUTOSCROLL_SPEED = 2,
	                offset = $element.offset(),
	                scrollTop = $element.scrollTop(),
	                upperDist = y - offset.top,
	                lowerDist = offset.top + $element.outerHeight() - y;
	            if (upperDist >= 0 && upperDist < this.autoscrollDist) {
	                $element.scrollTop(scrollTop - AUTOSCROLL_SPEED);
	            } else if (lowerDist >= 0 && lowerDist < this.autoscrollDist) {
	                $element.scrollTop(scrollTop + AUTOSCROLL_SPEED);
	            }
	        },
	
	        /** get the nearest element based on the mouse's Y coordinate.
	         *  If the y is at the end of the list, return an empty jQuery object.
	         */
	        _getNearestElement: function (y) {
	            var WIGGLE = 4,
	                lis = this.$('.collection-elements li.collection-element').toArray();
	            for (var i = 0; i < lis.length; i++) {
	                var $li = $(lis[i]),
	                    top = $li.offset().top,
	                    halfHeight = Math.floor($li.outerHeight() / 2) + WIGGLE;
	                if (top + halfHeight > y && top - halfHeight < y) {
	                    return $li;
	                }
	            }
	            return $();
	        },
	
	        /** drop (dragged/selected elements) onto the list, re-ordering the internal list */
	        _dropElements: function (ev) {
	            if (ev.originalEvent) {
	                ev = ev.originalEvent;
	            }
	            // both required for firefox
	            ev.preventDefault();
	            ev.dataTransfer.dropEffect = 'move';
	
	            // insert before the nearest element or after the last.
	            var $nearest = this._getNearestElement(ev.clientY);
	            if ($nearest.length) {
	                this.$dragging.insertBefore($nearest);
	            } else {
	                // no nearest before - insert after last element
	                this.$dragging.insertAfter(this.$('.collection-elements .collection-element').last());
	            }
	            // resync the creator's list based on the new DOM order
	            this._syncOrderToDom();
	            return false;
	        },
	
	        /** resync the creator's list of elements based on the DOM order */
	        _syncOrderToDom: function () {
	            var creator = this,
	                newElements = [];
	            //TODO: doesn't seem wise to use the dom to store these - can't we sync another way?
	            this.$('.collection-elements .collection-element').each(function () {
	                var id = $(this).attr('data-element-id'),
	                    element = _.findWhere(creator.workingElements, { id: id });
	                if (element) {
	                    newElements.push(element);
	                } else {
	                    console.error('missing element: ', id);
	                }
	            });
	            this.workingElements = newElements;
	            this._renderList();
	        },
	
	        /** drag communication with element sub-views: dragstart */
	        _elementDragstart: function (ev, element) {
	            // auto select the element causing the event and move all selected
	            element.select(true);
	            this.$dragging = this.$('.collection-elements .collection-element.selected');
	        },
	
	        /** drag communication with element sub-views: dragend - remove the placeholder */
	        _elementDragend: function (ev, element) {
	            $('.element-drop-placeholder').remove();
	            this.$dragging = null;
	        },
	
	        // ------------------------------------------------------------------------ templates
	        //TODO: move to require text plugin and load these as text
	        //TODO: underscore currently unnecc. bc no vars are used
	        //TODO: better way of localizing text-nodes in long strings
	        /** underscore template fns attached to class */
	        templates: _.extend({}, baseCreator.CollectionCreatorMixin._creatorTemplates, {
	
	            /** the header (not including help text) */
	            header: _.template(['<div class="main-help well clear">', '<a class="more-help" href="javascript:void(0);">', _l('More help'), '</a>', '<div class="help-content">', '<a class="less-help" href="javascript:void(0);">', _l('Less'), '</a>', '</div>', '</div>', '<div class="alert alert-dismissable">', '<button type="button" class="close" data-dismiss="alert" ', 'title="', _l('Close and show more help'), '" aria-hidden="true">&times;</button>', '<span class="alert-message"></span>', '</div>'].join('')),
	
	            /** the middle: element list */
	            middle: _.template(['<div class="collection-elements-controls">', '<a class="reset" href="javascript:void(0);" ', 'title="', _l('Undo all reordering and discards'), '">', _l('Start over'), '</a>', '<a class="clear-selected" href="javascript:void(0);" ', 'title="', _l('De-select all selected datasets'), '">', _l('Clear selected'), '</a>', '</div>', '<div class="collection-elements scroll-container flex-row">', '</div>'].join('')),
	
	            /** creation and cancel controls */
	            footer: _.template(['<div class="attributes clear">', '<div class="clear">', '<label class="setting-prompt pull-right">', _l('Hide original elements'), '?', '<input class="hide-originals pull-right" type="checkbox" />', '</label>', '</div>', '<div class="clear">', '<input class="collection-name form-control pull-right" ', 'placeholder="', _l('Enter a name for your new collection'), '" />', '<div class="collection-name-prompt pull-right">', _l('Name'), ':</div>', '</div>', '</div>', '<div class="actions clear vertically-spaced">', '<div class="other-options pull-left">', '<button class="cancel-create btn" tabindex="-1">', _l('Cancel'), '</button>', '<div class="create-other btn-group dropup">', '<button class="btn btn-default dropdown-toggle" data-toggle="dropdown">', _l('Create a different kind of collection'), ' <span class="caret"></span>', '</button>', '<ul class="dropdown-menu" role="menu">', '<li><a href="#">', _l('Create a <i>single</i> pair'), '</a></li>', '<li><a href="#">', _l('Create a list of <i>unpaired</i> datasets'), '</a></li>', '</ul>', '</div>', '</div>', '<div class="main-options pull-right">', '<button class="create-collection btn btn-primary">', _l('Create list'), '</button>', '</div>', '</div>'].join('')),
	
	            /** help content */
	            helpContent: _.template(['<p>', _l(['Collections of datasets are permanent, ordered lists of datasets that can be passed to tools and ', 'workflows in order to have analyses done on each member of the entire group. This interface allows ', 'you to create a collection and re-order the final collection.'].join('')), '</p>', '<ul>', '<li>', _l(['Rename elements in the list by clicking on ', '<i data-target=".collection-element .name">the existing name</i>.'].join('')), '</li>', '<li>', _l(['Discard elements from the final created list by clicking on the ', '<i data-target=".collection-element .discard">"Discard"</i> button.'].join('')), '</li>', '<li>', _l(['Reorder the list by clicking and dragging elements. Select multiple elements by clicking on ', '<i data-target=".collection-element">them</i> and you can then move those selected by dragging the ', 'entire group. Deselect them by clicking them again or by clicking the ', 'the <i data-target=".clear-selected">"Clear selected"</i> link.'].join('')), '</li>', '<li>', _l(['Click the <i data-target=".reset">"Start over"</i> link to begin again as if you had just opened ', 'the interface.'].join('')), '</li>', '<li>', _l(['Click the <i data-target=".cancel-create">"Cancel"</i> button to exit the interface.'].join('')), '</li>', '</ul><br />', '<p>', _l(['Once your collection is complete, enter a <i data-target=".collection-name">name</i> and ', 'click <i data-target=".create-collection">"Create list"</i>.'].join('')), '</p>'].join('')),
	
	            /** shown in list when all elements are discarded */
	            invalidElements: _.template([_l('The following selections could not be included due to problems:'), '<ul><% _.each( problems, function( problem ){ %>', '<li><b><%- problem.element.name %></b>: <%- problem.text %></li>', '<% }); %></ul>'].join('')),
	
	            /** shown in list when all elements are discarded */
	            noElementsLeft: _.template(['<li class="no-elements-left-message">', _l('No elements left! '), _l('Would you like to '), '<a class="reset" href="javascript:void(0)">', _l('start over'), '</a>?', '</li>'].join('')),
	
	            /** a simplified page communicating what went wrong and why the user needs to reselect something else */
	            invalidInitial: _.template(['<div class="header flex-row no-flex">', '<div class="alert alert-warning" style="display: block">', '<span class="alert-message">', '<% if( _.size( problems ) ){ %>', _l('The following selections could not be included due to problems'), ':', '<ul><% _.each( problems, function( problem ){ %>', '<li><b><%- problem.element.name %></b>: <%- problem.text %></li>', '<% }); %></ul>', '<% } else if( _.size( elements ) < 1 ){ %>', _l('No datasets were selected'), '.', '<% } %>', '<br />', _l('At least one element is needed for the collection'), '. ', _l('You may need to '), '<a class="cancel-create" href="javascript:void(0)">', _l('cancel'), '</a> ', _l('and reselect new elements'), '.', '</span>', '</div>', '</div>', '<div class="footer flex-row no-flex">', '<div class="actions clear vertically-spaced">', '<div class="other-options pull-left">', '<button class="cancel-create btn" tabindex="-1">', _l('Cancel'), '</button>',
	            // _l( 'Create a different kind of collection' ),
	            '</div>', '</div>', '</div>'].join(''))
	        }),
	
	        // ------------------------------------------------------------------------ misc
	        /** string rep */
	        toString: function () {
	            return 'ListCollectionCreator';
	        }
	    });
	
	    //=============================================================================
	    /** Create a modal and load its body with the given CreatorClass creator type
	     *  @returns {Deferred} resolved when creator has built a collection.
	     */
	    var collectionCreatorModal = function _collectionCreatorModal(elements, options, CreatorClass) {
	
	        var deferred = jQuery.Deferred(),
	            modal = Galaxy.modal || new UI_MODAL.View(),
	            creator;
	
	        options = _.defaults(options || {}, {
	            elements: elements,
	            oncancel: function () {
	                modal.hide();
	                deferred.reject('cancelled');
	            },
	            oncreate: function (creator, response) {
	                modal.hide();
	                deferred.resolve(response);
	            }
	        });
	
	        creator = new CreatorClass(options);
	        modal.show({
	            title: options.title || _l('Create a collection'),
	            body: creator.$el,
	            width: '80%',
	            height: '100%',
	            closing_events: true
	        });
	        creator.render();
	        window._collectionCreator = creator;
	
	        //TODO: remove modal header
	        return deferred;
	    };
	
	    /** List collection flavor of collectionCreatorModal. */
	    var listCollectionCreatorModal = function _listCollectionCreatorModal(elements, options) {
	        options = options || {};
	        options.title = _l('Create a collection from a list of datasets');
	        return collectionCreatorModal(elements, options, ListCollectionCreator);
	    };
	
	    //==============================================================================
	    /** Use a modal to create a list collection, then add it to the given history contents.
	     *  @returns {Deferred} resolved when the collection is added to the history.
	     */
	    function createListCollection(contents, defaultHideSourceItems) {
	        var elements = contents.toJSON(),
	            promise = listCollectionCreatorModal(elements, {
	            defaultHideSourceItems: defaultHideSourceItems,
	            creationFn: function (elements, name, hideSourceItems) {
	                elements = elements.map(function (element) {
	                    return {
	                        id: element.id,
	                        name: element.name,
	                        //TODO: this allows for list:list even if the filter above does not - reconcile
	                        src: element.history_content_type === 'dataset' ? 'hda' : 'hdca'
	                    };
	                });
	                return contents.createHDCA(elements, 'list', name, hideSourceItems);
	            }
	        });
	        return promise;
	    }
	
	    //==============================================================================
	    return {
	        DatasetCollectionElementView: DatasetCollectionElementView,
	        ListCollectionCreator: ListCollectionCreator,
	
	        collectionCreatorModal: collectionCreatorModal,
	        listCollectionCreatorModal: listCollectionCreatorModal,
	        createListCollection: createListCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, jQuery, Backbone, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(67), __webpack_require__(17), __webpack_require__(26), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_ITEM, STATES, faIconButton, BASE_MVC, _l) {
	    'use strict';
	
	    var logNamespace = 'dataset';
	    /*==============================================================================
	    TODO:
	        straighten out state rendering and templates used
	        inaccessible/STATES.NOT_VIEWABLE is a special case
	        simplify button rendering
	    
	    ==============================================================================*/
	    var _super = LIST_ITEM.ListItemView;
	    /** @class Read only list view for either LDDAs, HDAs, or HDADCEs.
	     *      Roughly, any DatasetInstance (and not a raw Dataset).
	     */
	    var DatasetListItemView = _super.extend(
	    /** @lends DatasetListItemView.prototype */{
	        _logNamespace: logNamespace,
	
	        className: _super.prototype.className + " dataset",
	        //TODO:?? doesn't exactly match an hda's type_id
	        id: function () {
	            return ['dataset', this.model.get('id')].join('-');
	        },
	
	        /** Set up: instance vars, options, and event handlers */
	        initialize: function (attributes) {
	            if (attributes.logger) {
	                this.logger = this.model.logger = attributes.logger;
	            }
	            this.log(this + '.initialize:', attributes);
	            _super.prototype.initialize.call(this, attributes);
	
	            /** where should pages from links be displayed? (default to new tab/window) */
	            this.linkTarget = attributes.linkTarget || '_blank';
	        },
	
	        /** event listeners */
	        _setUpListeners: function () {
	            _super.prototype._setUpListeners.call(this);
	            var self = this;
	
	            // re-rendering on any model changes
	            return self.listenTo(self.model, {
	                'change': function (model) {
	                    // if the model moved into the ready state and is expanded without details, fetch those details now
	                    if (self.model.changedAttributes().state && self.model.inReadyState() && self.expanded && !self.model.hasDetails()) {
	                        // normally, will render automatically (due to fetch -> change),
	                        // but! setting_metadata sometimes doesn't cause any other changes besides state
	                        // so, not rendering causes it to seem frozen in setting_metadata state
	                        self.model.fetch({ silent: true }).done(function () {
	                            self.render();
	                        });
	                    } else {
	                        if (_.has(model.changed, 'tags') && _.keys(model.changed).length === 1) {
	                            // If only the tags have changed, rerender specifically
	                            // the titlebar region.  Otherwise default to the full
	                            // render.
	                            self.$('.nametags').html(self._renderNametags());
	                        } else {
	                            self.render();
	                        }
	                    }
	                }
	            });
	        },
	
	        // ......................................................................... expandable
	        /** In this override, only get details if in the ready state, get rerunnable if in other states.
	         *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
	         */
	        _fetchModelDetails: function () {
	            var view = this;
	            if (view.model.inReadyState() && !view.model.hasDetails()) {
	                return view.model.fetch({ silent: true });
	            }
	            return jQuery.when();
	        },
	
	        // ......................................................................... removal
	        /** Remove this view's html from the DOM and remove all event listeners.
	         *  @param {Number or String} speed jq effect speed
	         *  @param {Function} callback      an optional function called when removal is done (scoped to this view)
	         */
	        remove: function (speed, callback) {
	            var view = this;
	            speed = speed || this.fxSpeed;
	            this.$el.fadeOut(speed, function () {
	                Backbone.View.prototype.remove.call(view);
	                if (callback) {
	                    callback.call(view);
	                }
	            });
	        },
	
	        // ......................................................................... rendering
	        /* TODO:
	            dataset states are the issue primarily making dataset rendering complex
	                each state should have it's own way of displaying/set of details
	                often with different actions that can be applied
	            throw in deleted/purged/visible and things get complicated easily
	            I've considered (a couple of times) - creating a view for each state
	                - but recreating the view during an update...seems wrong
	        */
	        /** In this override, add the dataset state as a class for use with state-based CSS */
	        _swapNewRender: function ($newRender) {
	            _super.prototype._swapNewRender.call(this, $newRender);
	            if (this.model.has('state')) {
	                this.$el.addClass('state-' + this.model.get('state'));
	            }
	            return this.$el;
	        },
	
	        // ................................................................................ titlebar
	        /** In this override, add the dataset display button. */
	        _renderPrimaryActions: function () {
	            // render just the display for read-only
	            return [this._renderDisplayButton()];
	        },
	
	        /** Render icon-button to display dataset data */
	        _renderDisplayButton: function () {
	            // don't show display if not viewable or not accessible
	            var state = this.model.get('state');
	            if (state === STATES.NOT_VIEWABLE || state === STATES.DISCARDED || !this.model.get('accessible')) {
	                return null;
	            }
	
	            var displayBtnData = {
	                target: this.linkTarget,
	                classes: 'display-btn'
	            };
	
	            // show a disabled display if the data's been purged
	            if (this.model.get('purged')) {
	                displayBtnData.disabled = true;
	                displayBtnData.title = _l('Cannot display datasets removed from disk');
	
	                // disable if still uploading
	            } else if (state === STATES.UPLOAD) {
	                displayBtnData.disabled = true;
	                displayBtnData.title = _l('This dataset must finish uploading before it can be viewed');
	
	                // disable if still new
	            } else if (state === STATES.NEW) {
	                displayBtnData.disabled = true;
	                displayBtnData.title = _l('This dataset is not yet viewable');
	            } else {
	                displayBtnData.title = _l('View data');
	
	                // default link for dataset
	                displayBtnData.href = this.model.urls.display;
	
	                // add frame manager option onclick event
	                var self = this;
	                displayBtnData.onclick = function (ev) {
	                    if (Galaxy.frame && Galaxy.frame.active) {
	                        // Add dataset to frames.
	                        Galaxy.frame.addDataset(self.model.get('id'));
	                        ev.preventDefault();
	                    }
	                };
	            }
	            displayBtnData.faIcon = 'fa-eye';
	            return faIconButton(displayBtnData);
	        },
	
	        // ......................................................................... rendering details
	        /** Render the enclosing div of the hda body and, if expanded, the html in the body
	         *  @returns {jQuery} rendered DOM
	         */
	        _renderDetails: function () {
	            //TODO: generalize to be allow different details for each state
	
	            // no access - render nothing but a message
	            if (this.model.get('state') === STATES.NOT_VIEWABLE) {
	                return $(this.templates.noAccess(this.model.toJSON(), this));
	            }
	
	            var $details = _super.prototype._renderDetails.call(this);
	            $details.find('.actions .left').empty().append(this._renderSecondaryActions());
	            $details.find('.summary').html(this._renderSummary()).prepend(this._renderDetailMessages());
	            $details.find('.display-applications').html(this._renderDisplayApplications());
	
	            this._setUpBehaviors($details);
	            return $details;
	        },
	
	        /** Defer to the appropo summary rendering fn based on state */
	        _renderSummary: function () {
	            var json = this.model.toJSON(),
	                summaryRenderFn = this.templates.summaries[json.state];
	            summaryRenderFn = summaryRenderFn || this.templates.summaries.unknown;
	            return summaryRenderFn(json, this);
	        },
	
	        /** Render messages to be displayed only when the details are shown */
	        _renderDetailMessages: function () {
	            var view = this,
	                $warnings = $('<div class="detail-messages"></div>'),
	                json = view.model.toJSON();
	            //TODO:! unordered (map)
	            _.each(view.templates.detailMessages, function (templateFn) {
	                $warnings.append($(templateFn(json, view)));
	            });
	            return $warnings;
	        },
	
	        /** Render the external display application links */
	        _renderDisplayApplications: function () {
	            if (this.model.isDeletedOrPurged()) {
	                return '';
	            }
	            // render both old and new display apps using the same template
	            return [this.templates.displayApplications(this.model.get('display_apps'), this), this.templates.displayApplications(this.model.get('display_types'), this)].join('');
	        },
	
	        // ......................................................................... secondary/details actions
	        /** A series of links/buttons for less commonly used actions: re-run, info, etc. */
	        _renderSecondaryActions: function () {
	            this.debug('_renderSecondaryActions');
	            switch (this.model.get('state')) {
	                case STATES.NOT_VIEWABLE:
	                    return [];
	                case STATES.OK:
	                case STATES.FAILED_METADATA:
	                case STATES.ERROR:
	                    return [this._renderDownloadButton(), this._renderShowParamsButton()];
	            }
	            return [this._renderShowParamsButton()];
	        },
	
	        /** Render icon-button to show the input and output (stdout/err) for the job that created this.
	         *  @returns {jQuery} rendered DOM
	         */
	        _renderShowParamsButton: function () {
	            // gen. safe to show in all cases
	            return faIconButton({
	                title: _l('View details'),
	                classes: 'params-btn',
	                href: this.model.urls.show_params,
	                target: this.linkTarget,
	                faIcon: 'fa-info-circle',
	                onclick: function (ev) {
	                    if (Galaxy.frame && Galaxy.frame.active) {
	                        Galaxy.frame.add({ title: 'Dataset details', url: this.href });
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                    }
	                }
	            });
	        },
	
	        /** Render icon-button/popupmenu to download the data (and/or the associated meta files (bai, etc.)) for this.
	         *  @returns {jQuery} rendered DOM
	         */
	        _renderDownloadButton: function () {
	            // don't show anything if the data's been purged
	            if (this.model.get('purged') || !this.model.hasData()) {
	                return null;
	            }
	
	            // return either: a popupmenu with links to download assoc. meta files (if there are meta files)
	            //  or a single download icon-button (if there are no meta files)
	            if (!_.isEmpty(this.model.get('meta_files'))) {
	                return this._renderMetaFileDownloadButton();
	            }
	
	            return $(['<a class="download-btn icon-btn" ', 'href="', this.model.urls.download, '" title="' + _l('Download') + '" download>', '<span class="fa fa-floppy-o"></span>', '</a>'].join(''));
	        },
	
	        /** Render the download button which opens a dropdown with links to download assoc. meta files (indeces, etc.) */
	        _renderMetaFileDownloadButton: function () {
	            var urls = this.model.urls;
	            return $(['<div class="metafile-dropdown dropdown">', '<a class="download-btn icon-btn" href="javascript:void(0)" data-toggle="dropdown"', ' title="' + _l('Download') + '">', '<span class="fa fa-floppy-o"></span>', '</a>', '<ul class="dropdown-menu" role="menu" aria-labelledby="dLabel">', '<li><a href="' + urls.download + '" download>', _l('Download dataset'), '</a></li>', _.map(this.model.get('meta_files'), function (meta_file) {
	                return ['<li><a href="', urls.meta_download + meta_file.file_type, '">', _l('Download'), ' ', meta_file.file_type, '</a></li>'].join('');
	            }).join('\n'), '</ul>', '</div>'].join('\n'));
	        },
	
	        _renderNametags: function () {
	            var tpl = _.template(['<% _.each(_.sortBy(_.uniq(tags), function(x) { return x }), function(tag){ %>', '<% if (tag.indexOf("name:") == 0){ %>', '<span class="label label-info"><%- tag.slice(5) %></span>', '<% } %>', '<% }); %>'].join(''));
	            return tpl({ tags: this.model.get('tags') });
	        },
	
	        // ......................................................................... misc
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .display-btn': function (ev) {
	                this.trigger('display', this, ev);
	            },
	            'click .params-btn': function (ev) {
	                this.trigger('params', this, ev);
	            },
	            'click .download-btn': function (ev) {
	                this.trigger('download', this, ev);
	            }
	        }),
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DatasetListItemView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DatasetListItemView.prototype.templates = function () {
	        //TODO: move to require text! plugin
	
	        var warnings = _.extend({}, _super.prototype.templates.warnings, {
	            failed_metadata: BASE_MVC.wrapTemplate([
	            // failed metadata is rendered as a warning on an otherwise ok dataset view
	            '<% if( model.state === "failed_metadata" ){ %>', '<div class="warningmessagesmall">', _l('An error occurred setting the metadata for this dataset'), '</div>', '<% } %>']),
	            error: BASE_MVC.wrapTemplate([
	            // error during index fetch - show error on dataset
	            '<% if( model.error ){ %>', '<div class="errormessagesmall">', _l('There was an error getting the data for this dataset'), ': <%- model.error %>', '</div>', '<% } %>']),
	            purged: BASE_MVC.wrapTemplate(['<% if( model.purged ){ %>', '<div class="purged-msg warningmessagesmall">', _l('This dataset has been deleted and removed from disk'), '</div>', '<% } %>']),
	            deleted: BASE_MVC.wrapTemplate([
	            // deleted not purged
	            '<% if( model.deleted && !model.purged ){ %>', '<div class="deleted-msg warningmessagesmall">', _l('This dataset has been deleted'), '</div>', '<% } %>'])
	
	            //NOTE: hidden warning is only needed for HDAs
	        });
	
	        var detailsTemplate = BASE_MVC.wrapTemplate(['<div class="details">', '<div class="summary"></div>', '<div class="actions clear">', '<div class="left"></div>', '<div class="right"></div>', '</div>',
	
	        // do not display tags, annotation, display apps, or peek when deleted
	        '<% if( !dataset.deleted && !dataset.purged ){ %>', '<div class="tags-display"></div>', '<div class="annotation-display"></div>', '<div class="display-applications"></div>', '<% if( dataset.peek ){ %>', '<pre class="dataset-peek"><%= dataset.peek %></pre>', '<% } %>', '<% } %>', '</div>'], 'dataset');
	
	        var noAccessTemplate = BASE_MVC.wrapTemplate(['<div class="details">', '<div class="summary">', _l('You do not have permission to view this dataset'), '</div>', '</div>'], 'dataset');
	
	        //TODO: still toooooooooooooo complex - rework
	        var summaryTemplates = {};
	        summaryTemplates[STATES.OK] = summaryTemplates[STATES.FAILED_METADATA] = BASE_MVC.wrapTemplate(['<% if( dataset.misc_blurb ){ %>', '<div class="blurb">', '<span class="value"><%- dataset.misc_blurb %></span>', '</div>', '<% } %>', '<% if( dataset.file_ext ){ %>', '<div class="datatype">', '<label class="prompt">', _l('format'), '</label>', '<span class="value"><%- dataset.file_ext %></span>', '</div>', '<% } %>', '<% if( dataset.metadata_dbkey ){ %>', '<div class="dbkey">', '<label class="prompt">', _l('database'), '</label>', '<span class="value">', '<%- dataset.metadata_dbkey %>', '</span>', '</div>', '<% } %>', '<% if( dataset.misc_info ){ %>', '<div class="info">', '<span class="value"><%- dataset.misc_info %></span>', '</div>', '<% } %>'], 'dataset');
	        summaryTemplates[STATES.NEW] = BASE_MVC.wrapTemplate(['<div>', _l('This is a new dataset and not all of its data are available yet'), '</div>'], 'dataset');
	        summaryTemplates[STATES.NOT_VIEWABLE] = BASE_MVC.wrapTemplate(['<div>', _l('You do not have permission to view this dataset'), '</div>'], 'dataset');
	        summaryTemplates[STATES.DISCARDED] = BASE_MVC.wrapTemplate(['<div>', _l('The job creating this dataset was cancelled before completion'), '</div>'], 'dataset');
	        summaryTemplates[STATES.QUEUED] = BASE_MVC.wrapTemplate(['<div>', _l('This job is waiting to run'), '</div>'], 'dataset');
	        summaryTemplates[STATES.RUNNING] = BASE_MVC.wrapTemplate(['<div>', _l('This job is currently running'), '</div>'], 'dataset');
	        summaryTemplates[STATES.UPLOAD] = BASE_MVC.wrapTemplate(['<div>', _l('This dataset is currently uploading'), '</div>'], 'dataset');
	        summaryTemplates[STATES.SETTING_METADATA] = BASE_MVC.wrapTemplate(['<div>', _l('Metadata is being auto-detected'), '</div>'], 'dataset');
	        summaryTemplates[STATES.PAUSED] = BASE_MVC.wrapTemplate(['<div>', _l('This job is paused. Use the "Resume Paused Jobs" in the history menu to resume'), '</div>'], 'dataset');
	        summaryTemplates[STATES.ERROR] = BASE_MVC.wrapTemplate(['<% if( !dataset.purged ){ %>', '<div><%- dataset.misc_blurb %></div>', '<% } %>', '<span class="help-text">', _l('An error occurred with this dataset'), ':</span>', '<div class="job-error-text"><%- dataset.misc_info %></div>'], 'dataset');
	        summaryTemplates[STATES.EMPTY] = BASE_MVC.wrapTemplate(['<div>', _l('No data'), ': <i><%- dataset.misc_blurb %></i></div>'], 'dataset');
	        summaryTemplates.unknown = BASE_MVC.wrapTemplate(['<div>Error: unknown dataset state: "<%- dataset.state %>"</div>'], 'dataset');
	
	        // messages to be displayed only within the details section ('below the fold')
	        var detailMessageTemplates = {
	            resubmitted: BASE_MVC.wrapTemplate([
	            // deleted not purged
	            '<% if( model.resubmitted ){ %>', '<div class="resubmitted-msg infomessagesmall">', _l('The job creating this dataset has been resubmitted'), '</div>', '<% } %>'])
	        };
	
	        // this is applied to both old and new style display apps
	        var displayApplicationsTemplate = BASE_MVC.wrapTemplate(['<% _.each( apps, function( app ){ %>', '<div class="display-application">', '<span class="display-application-location"><%- app.label %></span> ', '<span class="display-application-links">', '<% _.each( app.links, function( link ){ %>', '<a target="<%- link.target %>" href="<%- link.href %>">', '<% print( _l( link.text ) ); %>', '</a> ', '<% }); %>', '</span>', '</div>', '<% }); %>'], 'apps');
	
	        return _.extend({}, _super.prototype.templates, {
	            warnings: warnings,
	            details: detailsTemplate,
	            noAccess: noAccessTemplate,
	            summaries: summaryTemplates,
	            detailMessages: detailMessageTemplates,
	            displayApplications: displayApplicationsTemplate
	        });
	    }();
	
	    // ============================================================================
	    return {
	        DatasetListItemView: DatasetListItemView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** Generic form view */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Form, Ui) {
	
	    var View = Backbone.View.extend({
	
	        initialize: function (options) {
	            this.model = new Backbone.Model(options);
	            this.url = this.model.get('url');
	            this.redirect = this.model.get('redirect');
	            this.setElement('<div/>');
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            $.ajax({
	                url: Galaxy.root + this.url,
	                type: 'GET'
	            }).done(function (response) {
	                var options = $.extend({}, self.model.attributes, response);
	                var form = new Form({
	                    title: options.title,
	                    message: options.message,
	                    status: options.status || 'warning',
	                    icon: options.icon,
	                    inputs: options.inputs,
	                    buttons: {
	                        'submit': new Ui.Button({
	                            tooltip: options.submit_tooltip,
	                            title: options.submit_title || 'Save',
	                            icon: options.submit_icon || 'fa-save',
	                            cls: 'btn btn-primary ui-clear-float',
	                            onclick: function () {
	                                self._submit(form);
	                            }
	                        })
	                    }
	                });
	                self.$el.empty().append(form.$el);
	            }).fail(function (response) {
	                self.$el.empty().append(new Ui.Message({
	                    message: 'Failed to load resource ' + self.url + '.',
	                    status: 'danger',
	                    persistent: true
	                }).$el);
	            });
	        },
	
	        _submit: function (form) {
	            var self = this;
	            $.ajax({
	                url: Galaxy.root + self.url,
	                data: JSON.stringify(form.data.create()),
	                type: 'PUT',
	                contentType: 'application/json'
	            }).done(function (response) {
	                var success_message = { message: response.message, status: 'success', persistent: false };
	                if (self.redirect) {
	                    window.location = Galaxy.root + self.redirect + '?' + $.param(success_message);
	                } else {
	                    form.data.matchModel(response, function (input, input_id) {
	                        form.field_list[input_id].value(input.value);
	                    });
	                    self._showMessage(form, success_message);
	                }
	            }).fail(function (response) {
	                self._showMessage(form, { message: response.responseJSON.err_msg, status: 'danger', persistent: false });
	            });
	        },
	
	        _showMessage: function (form, options) {
	            var $panel = form.$el.parents().filter(function () {
	                return ['auto', 'scroll'].indexOf($(this).css('overflow')) != -1;
	            }).first();
	            $panel.animate({ scrollTop: 0 }, 500);
	            form.message.update(options);
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(59), __webpack_require__(90), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DC_MODEL, HISTORY_CONTENT, _l) {
	
	    'use strict';
	
	    /*==============================================================================
	    
	    Models for DatasetCollections contained within a history.
	    
	    TODO:
	        these might be compactable to one class if some duplication with
	        collection-model is used.
	    
	    ==============================================================================*/
	
	    var hcontentMixin = HISTORY_CONTENT.HistoryContentMixin,
	        ListDC = DC_MODEL.ListDatasetCollection,
	        PairDC = DC_MODEL.PairDatasetCollection,
	        ListPairedDC = DC_MODEL.ListPairedDatasetCollection,
	        ListOfListsDC = DC_MODEL.ListOfListsDatasetCollection;
	
	    //==============================================================================
	    /** Override to post to contents route w/o id. */
	    function buildHDCASave(_super) {
	        return function _save(attributes, options) {
	            if (this.isNew()) {
	                options = options || {};
	                options.url = this.urlRoot + this.get('history_id') + '/contents';
	                attributes = attributes || {};
	                attributes.type = 'dataset_collection';
	            }
	            return _super.call(this, attributes, options);
	        };
	    }
	
	    //==============================================================================
	    /** @class Backbone model for List Dataset Collection within a History.
	     */
	    var HistoryListDatasetCollection = ListDC.extend(hcontentMixin).extend(
	    /** @lends HistoryListDatasetCollection.prototype */{
	
	        defaults: _.extend(_.clone(ListDC.prototype.defaults), {
	            history_content_type: 'dataset_collection',
	            collection_type: 'list',
	            model_class: 'HistoryDatasetCollectionAssociation'
	        }),
	
	        /** Override to post to contents route w/o id. */
	        save: buildHDCASave(ListDC.prototype.save),
	
	        /** String representation. */
	        toString: function () {
	            return 'History' + ListDC.prototype.toString.call(this);
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for Pair Dataset Collection within a History.
	     *  @constructs
	     */
	    var HistoryPairDatasetCollection = PairDC.extend(hcontentMixin).extend(
	    /** @lends HistoryPairDatasetCollection.prototype */{
	
	        defaults: _.extend(_.clone(PairDC.prototype.defaults), {
	            history_content_type: 'dataset_collection',
	            collection_type: 'paired',
	            model_class: 'HistoryDatasetCollectionAssociation'
	        }),
	
	        /** Override to post to contents route w/o id. */
	        save: buildHDCASave(PairDC.prototype.save),
	
	        /** String representation. */
	        toString: function () {
	            return 'History' + PairDC.prototype.toString.call(this);
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for List of Pairs Dataset Collection within a History. */
	    var HistoryListPairedDatasetCollection = ListPairedDC.extend(hcontentMixin).extend({
	
	        defaults: _.extend(_.clone(ListPairedDC.prototype.defaults), {
	            history_content_type: 'dataset_collection',
	            collection_type: 'list:paired',
	            model_class: 'HistoryDatasetCollectionAssociation'
	        }),
	
	        /** Override to post to contents route w/o id. */
	        save: buildHDCASave(ListPairedDC.prototype.save),
	
	        /** String representation. */
	        toString: function () {
	            return 'History' + ListPairedDC.prototype.toString.call(this);
	        }
	    });
	
	    //==============================================================================
	    /** @class Backbone model for List of Lists Dataset Collection within a History. */
	    var HistoryListOfListsDatasetCollection = ListOfListsDC.extend(hcontentMixin).extend({
	
	        defaults: _.extend(_.clone(ListOfListsDC.prototype.defaults), {
	            history_content_type: 'dataset_collection',
	            collection_type: 'list:list',
	            model_class: 'HistoryDatasetCollectionAssociation'
	        }),
	
	        /** Override to post to contents route w/o id. */
	        save: buildHDCASave(ListOfListsDC.prototype.save),
	
	        /** String representation. */
	        toString: function () {
	            return ['HistoryListOfListsDatasetCollection(', this.get('name'), ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    return {
	        HistoryListDatasetCollection: HistoryListDatasetCollection,
	        HistoryPairDatasetCollection: HistoryPairDatasetCollection,
	        HistoryListPairedDatasetCollection: HistoryListPairedDatasetCollection,
	        HistoryListOfListsDatasetCollection: HistoryListOfListsDatasetCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, jQuery, Backbone) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(81), __webpack_require__(88), __webpack_require__(63), __webpack_require__(66), __webpack_require__(7), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CONTROLLED_FETCH_COLLECTION, HDA_MODEL, HDCA_MODEL, HISTORY_PREFS, BASE_MVC, AJAX_QUEUE) {
	    'use strict';
	
	    //==============================================================================
	
	    var _super = CONTROLLED_FETCH_COLLECTION.PaginatedCollection;
	    /** @class Backbone collection for history content.
	     *      NOTE: history content seems like a dataset collection, but differs in that it is mixed:
	     *          each element can be either an HDA (dataset) or a DatasetCollection and co-exist on
	     *          the same level.
	     *      Dataset collections on the other hand are not mixed and (so far) can only contain either
	     *          HDAs or child dataset collections on one level.
	     *      This is why this does not inherit from any of the DatasetCollections (currently).
	     */
	    var HistoryContents = _super.extend(BASE_MVC.LoggableMixin).extend({
	        _logNamespace: 'history',
	
	        // ........................................................................ composite collection
	        /** since history content is a mix, override model fn into a factory, creating based on history_content_type */
	        model: function (attrs, options) {
	            if (attrs.history_content_type === "dataset") {
	                return new HDA_MODEL.HistoryDatasetAssociation(attrs, options);
	            } else if (attrs.history_content_type === "dataset_collection") {
	                switch (attrs.collection_type) {
	                    case 'list':
	                        return new HDCA_MODEL.HistoryListDatasetCollection(attrs, options);
	                    case 'paired':
	                        return new HDCA_MODEL.HistoryPairDatasetCollection(attrs, options);
	                    case 'list:paired':
	                        return new HDCA_MODEL.HistoryListPairedDatasetCollection(attrs, options);
	                    case 'list:list':
	                        return new HDCA_MODEL.HistoryListOfListsDatasetCollection(attrs, options);
	                }
	                // This is a hack inside a hack:
	                // Raise a plain object with validationError to fake a model.validationError
	                // (since we don't have a model to use validate with)
	                // (the outer hack being the mixed content/model function in this collection)
	                var msg = 'Unknown collection_type: ' + attrs.collection_type;
	                console.warn(msg, attrs);
	                return { validationError: msg };
	            }
	            return { validationError: 'Unknown history_content_type: ' + attrs.history_content_type };
	        },
	
	        // ........................................................................ set up
	        limitPerPage: 500,
	
	        /** @type {Integer} how many contents per call to fetch when using progressivelyFetchDetails */
	        limitPerProgressiveFetch: 500,
	
	        /** @type {String} order used here and when fetching from server */
	        order: 'hid',
	
	        /** root api url */
	        urlRoot: Galaxy.root + 'api/histories',
	
	        /** complete api url */
	        url: function () {
	            return this.urlRoot + '/' + this.historyId + '/contents';
	        },
	
	        /** Set up */
	        initialize: function (models, options) {
	            options = options || {};
	            _super.prototype.initialize.call(this, models, options);
	
	            this.history = options.history || null;
	            this.setHistoryId(options.historyId || null);
	            /** @type {Boolean} does this collection contain and fetch deleted elements */
	            this.includeDeleted = options.includeDeleted || this.includeDeleted;
	            /** @type {Boolean} does this collection contain and fetch non-visible elements */
	            this.includeHidden = options.includeHidden || this.includeHidden;
	
	            // backbonejs uses collection.model.prototype.idAttribute to determine if a model is *already* in a collection
	            //  and either merged or replaced. In this case, our 'model' is a function so we need to add idAttribute
	            //  manually here - if we don't, contents will not merge but be replaced/swapped.
	            this.model.prototype.idAttribute = 'type_id';
	        },
	
	        setHistoryId: function (newId) {
	            this.historyId = newId;
	            this._setUpWebStorage();
	        },
	
	        /** Set up client side storage. Currently PersistanStorage keyed under 'history:<id>' */
	        _setUpWebStorage: function (initialSettings) {
	            // TODO: use initialSettings
	            if (!this.historyId) {
	                return;
	            }
	            this.storage = new HISTORY_PREFS.HistoryPrefs({
	                id: HISTORY_PREFS.HistoryPrefs.historyStorageKey(this.historyId)
	            });
	            this.trigger('new-storage', this.storage, this);
	
	            this.on({
	                'include-deleted': function (newVal) {
	                    this.storage.includeDeleted(newVal);
	                },
	                'include-hidden': function (newVal) {
	                    this.storage.includeHidden(newVal);
	                }
	            });
	
	            this.includeDeleted = this.storage.includeDeleted() || false;
	            this.includeHidden = this.storage.includeHidden() || false;
	            return this;
	        },
	
	        // ........................................................................ common queries
	        /** @type {Object} map of collection available sorting orders containing comparator fns */
	        comparators: _.extend(_.clone(_super.prototype.comparators), {
	            'name': BASE_MVC.buildComparator('name', { ascending: true }),
	            'name-dsc': BASE_MVC.buildComparator('name', { ascending: false }),
	            'hid': BASE_MVC.buildComparator('hid', { ascending: false }),
	            'hid-asc': BASE_MVC.buildComparator('hid', { ascending: true })
	        }),
	
	        /** Get every model in this collection not in a 'ready' state (running). */
	        running: function () {
	            return this.filter(function (c) {
	                return !c.inReadyState();
	            });
	        },
	
	        /** return contents that are not ready and not deleted/hidden */
	        runningAndActive: function () {
	            return this.filter(function (c) {
	                return !c.inReadyState() && c.get('visible')
	                // TODO: deletedOrPurged?
	                && !c.get('deleted');
	            });
	        },
	
	        /** Get the model with the given hid
	         *  @param {Int} hid the hid to search for
	         *  @returns {HistoryDatasetAssociation} the model with the given hid or undefined if not found
	         */
	        getByHid: function (hid) {
	            // note: there *can* be more than one content with a given hid, this finds the first based on order
	            return this.findWhere({ hid: hid });
	        },
	
	        /** return true if all contents have details */
	        haveDetails: function () {
	            return this.all(function (c) {
	                return c.hasDetails();
	            });
	        },
	
	        // ........................................................................ hidden / deleted
	        /** return a new contents collection of only hidden items */
	        hidden: function () {
	            return this.filter(function (c) {
	                return c.hidden();
	            });
	        },
	
	        /** return a new contents collection of only hidden items */
	        deleted: function () {
	            return this.filter(function (c) {
	                return c.get('deleted');
	            });
	        },
	
	        /** return a new contents collection of only hidden items */
	        visibleAndUndeleted: function () {
	            return this.filter(function (c) {
	                return c.get('visible') &&
	                // TODO: deletedOrPurged?
	                !c.get('deleted');
	            });
	        },
	
	        /** create a setter in order to publish the change */
	        setIncludeDeleted: function (setting, options) {
	            if (_.isBoolean(setting) && setting !== this.includeDeleted) {
	                this.includeDeleted = setting;
	                if (_.result(options, 'silent')) {
	                    return;
	                }
	                this.trigger('include-deleted', setting, this);
	            }
	        },
	
	        /** create a setter in order to publish the change */
	        setIncludeHidden: function (setting, options) {
	            if (_.isBoolean(setting) && setting !== this.includeHidden) {
	                this.includeHidden = setting;
	                options = options || {};
	                if (_.result(options, 'silent')) {
	                    return;
	                }
	                this.trigger('include-hidden', setting, this);
	            }
	        },
	
	        // ........................................................................ ajax
	        // ............ controlled fetch collection
	        /** override to get expanded ids from sessionStorage and pass to API as details */
	        fetch: function (options) {
	            options = options || {};
	            if (this.historyId && !options.details) {
	                var prefs = HISTORY_PREFS.HistoryPrefs.get(this.historyId).toJSON();
	                if (!_.isEmpty(prefs.expandedIds)) {
	                    options.details = _.values(prefs.expandedIds).join(',');
	                }
	            }
	            return _super.prototype.fetch.call(this, options);
	        },
	
	        // ............. ControlledFetch stuff
	        /** override to include the API versioning flag */
	        _buildFetchData: function (options) {
	            return _.extend(_super.prototype._buildFetchData.call(this, options), {
	                v: 'dev'
	            });
	        },
	
	        /** Extend to include details and version */
	        _fetchParams: _super.prototype._fetchParams.concat([
	        // TODO: remove (the need for) both
	        /** version */
	        'v',
	        /** dataset ids to get full details of */
	        'details']),
	
	        /** override to add deleted/hidden filters */
	        _buildFetchFilters: function (options) {
	            var superFilters = _super.prototype._buildFetchFilters.call(this, options) || {};
	            var filters = {};
	            if (!this.includeDeleted) {
	                filters.deleted = false;
	                filters.purged = false;
	            }
	            if (!this.includeHidden) {
	                filters.visible = true;
	            }
	            return _.defaults(superFilters, filters);
	        },
	
	        // ............ paginated collection
	        getTotalItemCount: function () {
	            return this.history.contentsShown();
	        },
	
	        // ............ history contents specific ajax
	        /** override to filter requested contents to those updated after the Date 'since' */
	        fetchUpdated: function (since, options) {
	            if (since) {
	                options = options || { filters: {} };
	                options.remove = false;
	                options.filters = {
	                    'update_time-ge': since.toISOString(),
	                    // workflows will produce hidden datasets (non-output datasets) that still
	                    // need to be updated in the collection or they'll update forever
	                    // we can remove the default visible filter by using an 'empty' value
	                    visible: ''
	                };
	            }
	            return this.fetch(options);
	        },
	
	        /** fetch all the deleted==true contents of this collection */
	        fetchDeleted: function (options) {
	            options = options || {};
	            var self = this;
	            options.filters = _.extend(options.filters, {
	                // all deleted, purged or not
	                deleted: true,
	                purged: undefined
	            });
	            options.remove = false;
	
	            self.trigger('fetching-deleted', self);
	            return self.fetch(options).always(function () {
	                self.trigger('fetching-deleted-done', self);
	            });
	        },
	
	        /** fetch all the visible==false contents of this collection */
	        fetchHidden: function (options) {
	            options = options || {};
	            var self = this;
	            options.filters = _.extend(options.filters, {
	                visible: false
	            });
	            options.remove = false;
	
	            self.trigger('fetching-hidden', self);
	            return self.fetch(options).always(function () {
	                self.trigger('fetching-hidden-done', self);
	            });
	        },
	
	        /** fetch detailed model data for all contents in this collection */
	        fetchAllDetails: function (options) {
	            options = options || {};
	            var detailsFlag = { details: 'all' };
	            options.data = _.extend(options.data || {}, detailsFlag);
	            return this.fetch(options);
	        },
	
	        /** specialty fetch method for retrieving the element_counts of all hdcas in the history */
	        fetchCollectionCounts: function (options) {
	            options = options || {};
	            options.keys = ['type_id', 'element_count'].join(',');
	            options.filters = _.extend(options.filters || {}, {
	                history_content_type: 'dataset_collection'
	            });
	            options.remove = false;
	            return this.fetch(options);
	        },
	
	        // ............. quasi-batch ops
	        // TODO: to batch
	        /** helper that fetches using filterParams then calls save on each fetched using updateWhat as the save params */
	        _filterAndUpdate: function (filterParams, updateWhat) {
	            var self = this;
	            var idAttribute = self.model.prototype.idAttribute;
	            var updateArgs = [updateWhat];
	
	            return self.fetch({ filters: filterParams, remove: false }).then(function (fetched) {
	                // convert filtered json array to model array
	                fetched = fetched.reduce(function (modelArray, currJson, i) {
	                    var model = self.get(currJson[idAttribute]);
	                    return model ? modelArray.concat(model) : modelArray;
	                }, []);
	                return self.ajaxQueue('save', updateArgs, fetched);
	            });
	        },
	
	        /** using a queue, perform ajaxFn on each of the models in this collection */
	        ajaxQueue: function (ajaxFn, args, collection) {
	            collection = collection || this.models;
	            return new AJAX_QUEUE.AjaxQueue(collection.slice().reverse().map(function (content, i) {
	                var fn = _.isString(ajaxFn) ? content[ajaxFn] : ajaxFn;
	                return function () {
	                    return fn.apply(content, args);
	                };
	            })).deferred;
	        },
	
	        /** fetch contents' details in batches of limitPerCall - note: only get searchable details here */
	        progressivelyFetchDetails: function (options) {
	            options = options || {};
	            var deferred = jQuery.Deferred();
	            var self = this;
	            var limit = options.limitPerCall || self.limitPerProgressiveFetch;
	            // TODO: only fetch tags and annotations if specifically requested
	            var searchAttributes = HDA_MODEL.HistoryDatasetAssociation.prototype.searchAttributes;
	            var detailKeys = searchAttributes.join(',');
	
	            function _recursivelyFetch(offset) {
	                offset = offset || 0;
	                var _options = _.extend(_.clone(options), {
	                    view: 'summary',
	                    keys: detailKeys,
	                    limit: limit,
	                    offset: offset,
	                    reset: offset === 0,
	                    remove: false
	                });
	
	                _.defer(function () {
	                    self.fetch.call(self, _options).fail(deferred.reject).done(function (response) {
	                        deferred.notify(response, limit, offset);
	                        if (response.length !== limit) {
	                            self.allFetched = true;
	                            deferred.resolve(response, limit, offset);
	                        } else {
	                            _recursivelyFetch(offset + limit);
	                        }
	                    });
	                });
	            }
	            _recursivelyFetch();
	            return deferred;
	        },
	
	        /** does some bit of JSON represent something that can be copied into this contents collection */
	        isCopyable: function (contentsJSON) {
	            var copyableModelClasses = ['HistoryDatasetAssociation', 'HistoryDatasetCollectionAssociation'];
	            return _.isObject(contentsJSON) && contentsJSON.id && _.contains(copyableModelClasses, contentsJSON.model_class);
	        },
	
	        /** copy an existing, accessible hda into this collection */
	        copy: function (json) {
	            // TODO: somehow showhorn all this into 'save'
	            var id, type, contentType;
	            if (_.isString(json)) {
	                id = json;
	                contentType = 'hda';
	                type = 'dataset';
	            } else {
	                id = json.id;
	                contentType = {
	                    'HistoryDatasetAssociation': 'hda',
	                    'LibraryDatasetDatasetAssociation': 'ldda',
	                    'HistoryDatasetCollectionAssociation': 'hdca'
	                }[json.model_class] || 'hda';
	                type = contentType === 'hdca' ? 'dataset_collection' : 'dataset';
	            }
	            var collection = this,
	                xhr = jQuery.ajax(this.url(), {
	                method: 'POST',
	                contentType: 'application/json',
	                data: JSON.stringify({
	                    content: id,
	                    source: contentType,
	                    type: type
	                })
	            }).done(function (response) {
	                collection.add([response], { parse: true });
	            }).fail(function (error, status, message) {
	                collection.trigger('error', collection, xhr, {}, 'Error copying contents', { type: type, id: id, source: contentType });
	            });
	            return xhr;
	        },
	
	        /** create a new HDCA in this collection */
	        createHDCA: function (elementIdentifiers, collectionType, name, hideSourceItems, options) {
	            // normally collection.create returns the new model, but we need the promise from the ajax, so we fake create
	            //precondition: elementIdentifiers is an array of plain js objects
	            //  in the proper form to create the collectionType
	            var hdca = this.model({
	                history_content_type: 'dataset_collection',
	                collection_type: collectionType,
	                history_id: this.historyId,
	                name: name,
	                hide_source_items: hideSourceItems || false,
	                // should probably be able to just send in a bunch of json here and restruct per class
	                // note: element_identifiers is now (incorrectly) an attribute
	                element_identifiers: elementIdentifiers
	                // do not create the model on the client until the ajax returns
	            });
	            return hdca.save(options);
	        },
	
	        // ........................................................................ searching
	        /** return true if all contents have the searchable attributes */
	        haveSearchDetails: function () {
	            return this.allFetched && this.all(function (content) {
	                // null (which is a valid returned annotation value)
	                // will return false when using content.has( 'annotation' )
	                //TODO: a bit hacky - formalize
	                return _.has(content.attributes, 'annotation');
	            });
	        },
	
	        /** return a new collection of contents whose attributes contain the substring matchesWhat */
	        matches: function (matchesWhat) {
	            return this.filter(function (content) {
	                return content.matches(matchesWhat);
	            });
	        },
	
	        // ........................................................................ misc
	        /** In this override, copy the historyId to the clone */
	        clone: function () {
	            var clone = Backbone.Collection.prototype.clone.call(this);
	            clone.historyId = this.historyId;
	            return clone;
	        },
	
	        /** String representation. */
	        toString: function () {
	            return ['HistoryContents(', [this.historyId, this.length].join(), ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    return {
	        HistoryContents: HistoryContents
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, jQuery, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(64), __webpack_require__(66), __webpack_require__(81), __webpack_require__(4), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HISTORY_CONTENTS, HISTORY_PREFS, CONTROLLED_FETCH_COLLECTION, UTILS, BASE_MVC, _l) {
	    'use strict';
	
	    //==============================================================================
	    /** @class Model for a Galaxy history resource - both a record of user
	     *      tool use and a collection of the datasets those tools produced.
	     *  @name History
	     *  @augments Backbone.Model
	     */
	
	    var History = Backbone.Model.extend(BASE_MVC.LoggableMixin).extend(BASE_MVC.mixin(BASE_MVC.SearchableModelMixin, /** @lends History.prototype */{
	        _logNamespace: 'history',
	
	        /** ms between fetches when checking running jobs/datasets for updates */
	        UPDATE_DELAY: 4000,
	
	        // values from api (may need more)
	        defaults: {
	            model_class: 'History',
	            id: null,
	            name: 'Unnamed History',
	            state: 'new',
	
	            deleted: false,
	            contents_active: {},
	            contents_states: {}
	        },
	
	        urlRoot: Galaxy.root + 'api/histories',
	
	        contentsClass: HISTORY_CONTENTS.HistoryContents,
	
	        /** What model fields to search with */
	        searchAttributes: ['name', 'annotation', 'tags'],
	
	        /** Adding title and singular tag */
	        searchAliases: {
	            title: 'name',
	            tag: 'tags'
	        },
	
	        // ........................................................................ set up/tear down
	        /** Set up the model
	         *  @param {Object} historyJSON model data for this History
	         *  @param {Object} options     any extra settings including logger
	         */
	        initialize: function (historyJSON, options) {
	            options = options || {};
	            this.logger = options.logger || null;
	            this.log(this + ".initialize:", historyJSON, options);
	
	            /** HistoryContents collection of the HDAs contained in this history. */
	            this.contents = new this.contentsClass([], {
	                history: this,
	                historyId: this.get('id'),
	                order: options.order
	            });
	
	            this._setUpListeners();
	            this._setUpCollectionListeners();
	
	            /** cached timeout id for the dataset updater */
	            this.updateTimeoutId = null;
	        },
	
	        /** set up any event listeners for this history including those to the contained HDAs
	         *  events: error:contents  if an error occurred with the contents collection
	         */
	        _setUpListeners: function () {
	            // if the model's id changes ('current' or null -> an actual id), update the contents history_id
	            return this.on({
	                'error': function (model, xhr, options, msg, details) {
	                    this.clearUpdateTimeout();
	                },
	                'change:id': function (model, newId) {
	                    if (this.contents) {
	                        this.contents.historyId = newId;
	                    }
	                }
	            });
	        },
	
	        /** event handlers for the contents submodels */
	        _setUpCollectionListeners: function () {
	            if (!this.contents) {
	                return this;
	            }
	            // bubble up errors
	            return this.listenTo(this.contents, {
	                'error': function () {
	                    this.trigger.apply(this, jQuery.makeArray(arguments));
	                }
	            });
	        },
	
	        // ........................................................................ derived attributes
	        /**  */
	        contentsShown: function () {
	            var contentsActive = this.get('contents_active');
	            var shown = contentsActive.active || 0;
	            shown += this.contents.includeDeleted ? contentsActive.deleted : 0;
	            shown += this.contents.includeHidden ? contentsActive.hidden : 0;
	            return shown;
	        },
	
	        /** convert size in bytes to a more human readable version */
	        nice_size: function () {
	            var size = this.get('size');
	            return size ? UTILS.bytesToString(size, true, 2) : _l('(empty)');
	        },
	
	        /** override to add nice_size */
	        toJSON: function () {
	            return _.extend(Backbone.Model.prototype.toJSON.call(this), {
	                nice_size: this.nice_size()
	            });
	        },
	
	        /** override to allow getting nice_size */
	        get: function (key) {
	            if (key === 'nice_size') {
	                return this.nice_size();
	            }
	            return Backbone.Model.prototype.get.apply(this, arguments);
	        },
	
	        // ........................................................................ common queries
	        /** T/F is this history owned by the current user (Galaxy.user)
	         *      Note: that this will return false for an anon user even if the history is theirs.
	         */
	        ownedByCurrUser: function () {
	            // no currUser
	            if (!Galaxy || !Galaxy.user) {
	                return false;
	            }
	            // user is anon or history isn't owned
	            if (Galaxy.user.isAnonymous() || Galaxy.user.id !== this.get('user_id')) {
	                return false;
	            }
	            return true;
	        },
	
	        /** Return the number of running jobs assoc with this history (note: unknown === 0) */
	        numOfUnfinishedJobs: function () {
	            var unfinishedJobIds = this.get('non_ready_jobs');
	            return unfinishedJobIds ? unfinishedJobIds.length : 0;
	        },
	
	        /** Return the number of running hda/hdcas in this history (note: unknown === 0) */
	        numOfUnfinishedShownContents: function () {
	            return this.contents.runningAndActive().length || 0;
	        },
	
	        // ........................................................................ updates
	        _fetchContentRelatedAttributes: function () {
	            var contentRelatedAttrs = ['size', 'non_ready_jobs', 'contents_active', 'hid_counter'];
	            return this.fetch({ data: $.param({ keys: contentRelatedAttrs.join(',') }) });
	        },
	
	        /** check for any changes since the last time we updated (or fetch all if ) */
	        refresh: function (options) {
	            // console.log( this + '.refresh' );
	            options = options || {};
	            var self = this;
	
	            // note if there was no previous update time, all summary contents will be fetched
	            var lastUpdateTime = self.lastUpdateTime;
	            // if we don't flip this, then a fully-fetched list will not be re-checked via fetch
	            this.contents.allFetched = false;
	            var fetchFn = self.contents.currentPage !== 0 ? function () {
	                return self.contents.fetchPage(self.contents.currentPage);
	            } : function () {
	                return self.contents.fetchUpdated(lastUpdateTime);
	            };
	            // note: if there was no previous update time, all summary contents will be fetched
	            return fetchFn().done(function (response, status, xhr) {
	                var serverResponseDatetime;
	                try {
	                    serverResponseDatetime = new Date(xhr.getResponseHeader('Date'));
	                } catch (err) {}
	                self.lastUpdateTime = serverResponseDatetime || new Date();
	                self.checkForUpdates(options);
	            });
	        },
	
	        /** continuously fetch updated contents every UPDATE_DELAY ms if this history's datasets or jobs are unfinished */
	        checkForUpdates: function (options) {
	            // console.log( this + '.checkForUpdates' );
	            options = options || {};
	            var delay = this.UPDATE_DELAY;
	            var self = this;
	            if (!self.id) {
	                return;
	            }
	
	            function _delayThenUpdate() {
	                // prevent buildup of updater timeouts by clearing previous if any, then set new and cache id
	                self.clearUpdateTimeout();
	                self.updateTimeoutId = setTimeout(function () {
	                    self.refresh(options);
	                }, delay);
	            }
	
	            // if there are still datasets in the non-ready state, recurse into this function with the new time
	            var nonReadyContentCount = this.numOfUnfinishedShownContents();
	            // console.log( 'nonReadyContentCount:', nonReadyContentCount );
	            if (nonReadyContentCount > 0) {
	                _delayThenUpdate();
	            } else {
	                // no datasets are running, but currently runnning jobs may still produce new datasets
	                // see if the history has any running jobs and continue to update if so
	                // (also update the size for the user in either case)
	                self._fetchContentRelatedAttributes().done(function (historyData) {
	                    // console.log( 'non_ready_jobs:', historyData.non_ready_jobs );
	                    if (self.numOfUnfinishedJobs() > 0) {
	                        _delayThenUpdate();
	                    } else {
	                        // otherwise, let listeners know that all updates have stopped
	                        self.trigger('ready');
	                    }
	                });
	            }
	        },
	
	        /** clear the timeout and the cached timeout id */
	        clearUpdateTimeout: function () {
	            if (this.updateTimeoutId) {
	                clearTimeout(this.updateTimeoutId);
	                this.updateTimeoutId = null;
	            }
	        },
	
	        // ........................................................................ ajax
	        /** override to use actual Dates objects for create/update times */
	        parse: function (response, options) {
	            var parsed = Backbone.Model.prototype.parse.call(this, response, options);
	            if (parsed.create_time) {
	                parsed.create_time = new Date(parsed.create_time);
	            }
	            if (parsed.update_time) {
	                parsed.update_time = new Date(parsed.update_time);
	            }
	            return parsed;
	        },
	
	        /** fetch this histories data (using options) then it's contents (using contentsOptions) */
	        fetchWithContents: function (options, contentsOptions) {
	            options = options || {};
	            var self = this;
	
	            // console.log( this + '.fetchWithContents' );
	            // TODO: push down to a base class
	            options.view = 'dev-detailed';
	
	            // fetch history then use history data to fetch (paginated) contents
	            return this.fetch(options).then(function getContents(history) {
	                self.contents.history = self;
	                self.contents.setHistoryId(history.id);
	                return self.fetchContents(contentsOptions);
	            });
	        },
	
	        /** fetch this histories contents, adjusting options based on the stored history preferences */
	        fetchContents: function (options) {
	            options = options || {};
	            var self = this;
	
	            // we're updating, reset the update time
	            self.lastUpdateTime = new Date();
	            return self.contents.fetchCurrentPage(options);
	        },
	
	        /** save this history, _Mark_ing it as deleted (just a flag) */
	        _delete: function (options) {
	            if (this.get('deleted')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: true }, options);
	        },
	        /** purge this history, _Mark_ing it as purged and removing all dataset data from the server */
	        purge: function (options) {
	            if (this.get('purged')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: true, purged: true }, options);
	        },
	        /** save this history, _Mark_ing it as undeleted */
	        undelete: function (options) {
	            if (!this.get('deleted')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: false }, options);
	        },
	
	        /** Make a copy of this history on the server
	         *  @param {Boolean} current    if true, set the copy as the new current history (default: true)
	         *  @param {String} name        name of new history (default: none - server sets to: Copy of <current name>)
	         *  @fires copied               passed this history and the response JSON from the copy
	         *  @returns {xhr}
	         */
	        copy: function (current, name, allDatasets) {
	            current = current !== undefined ? current : true;
	            if (!this.id) {
	                throw new Error('You must set the history ID before copying it.');
	            }
	
	            var postData = { history_id: this.id };
	            if (current) {
	                postData.current = true;
	            }
	            if (name) {
	                postData.name = name;
	            }
	            if (!allDatasets) {
	                postData.all_datasets = false;
	            }
	            postData.view = 'dev-detailed';
	
	            var history = this;
	            var copy = jQuery.post(this.urlRoot, postData);
	            // if current - queue to setAsCurrent before firing 'copied'
	            if (current) {
	                return copy.then(function (response) {
	                    var newHistory = new History(response);
	                    return newHistory.setAsCurrent().done(function () {
	                        history.trigger('copied', history, response);
	                    });
	                });
	            }
	            return copy.done(function (response) {
	                history.trigger('copied', history, response);
	            });
	        },
	
	        setAsCurrent: function () {
	            var history = this,
	                xhr = jQuery.getJSON(Galaxy.root + 'history/set_as_current?id=' + this.id);
	
	            xhr.done(function () {
	                history.trigger('set-as-current', history);
	            });
	            return xhr;
	        },
	
	        // ........................................................................ misc
	        toString: function () {
	            return 'History(' + this.get('id') + ',' + this.get('name') + ')';
	        }
	    }));
	
	    //==============================================================================
	    var _collectionSuper = CONTROLLED_FETCH_COLLECTION.InfinitelyScrollingCollection;
	    /** @class A collection of histories (per user)
	     *      that maintains the current history as the first in the collection.
	     *  New or copied histories become the current history.
	     */
	    var HistoryCollection = _collectionSuper.extend(BASE_MVC.LoggableMixin).extend({
	        _logNamespace: 'history',
	
	        model: History,
	        /** @type {String} initial order used by collection */
	        order: 'update_time',
	        /** @type {Number} limit used for the first fetch (or a reset) */
	        limitOnFirstFetch: 10,
	        /** @type {Number} limit used for each subsequent fetch */
	        limitPerFetch: 10,
	
	        initialize: function (models, options) {
	            options = options || {};
	            this.log('HistoryCollection.initialize', models, options);
	            _collectionSuper.prototype.initialize.call(this, models, options);
	
	            /** @type {boolean} should deleted histories be included */
	            this.includeDeleted = options.includeDeleted || false;
	
	            /** @type {String} encoded id of the history that's current */
	            this.currentHistoryId = options.currentHistoryId;
	
	            this.setUpListeners();
	            // note: models are sent to reset *after* this fn ends; up to this point
	            // the collection *is empty*
	        },
	
	        urlRoot: Galaxy.root + 'api/histories',
	        url: function () {
	            return this.urlRoot;
	        },
	
	        /** set up reflexive event handlers */
	        setUpListeners: function setUpListeners() {
	            return this.on({
	                // when a history is deleted, remove it from the collection (if optionally set to do so)
	                'change:deleted': function (history) {
	                    // TODO: this becomes complicated when more filters are used
	                    this.debug('change:deleted', this.includeDeleted, history.get('deleted'));
	                    if (!this.includeDeleted && history.get('deleted')) {
	                        this.remove(history);
	                    }
	                },
	                // listen for a history copy, setting it to current
	                'copied': function (original, newData) {
	                    this.setCurrent(new History(newData, []));
	                },
	                // when a history is made current, track the id in the collection
	                'set-as-current': function (history) {
	                    var oldCurrentId = this.currentHistoryId;
	                    this.trigger('no-longer-current', oldCurrentId);
	                    this.currentHistoryId = history.id;
	                }
	            });
	        },
	
	        /** override to change view */
	        _buildFetchData: function (options) {
	            return _.extend(_collectionSuper.prototype._buildFetchData.call(this, options), {
	                view: 'dev-detailed'
	            });
	        },
	
	        /** override to filter out deleted and purged */
	        _buildFetchFilters: function (options) {
	            var superFilters = _collectionSuper.prototype._buildFetchFilters.call(this, options) || {};
	            var filters = {};
	            if (!this.includeDeleted) {
	                filters.deleted = false;
	                filters.purged = false;
	            } else {
	                // force API to return both deleted and non
	                //TODO: when the API is updated, remove this
	                filters.deleted = null;
	            }
	            return _.defaults(superFilters, filters);
	        },
	
	        /** override to fetch current as well (as it may be outside the first 10, etc.) */
	        fetchFirst: function (options) {
	            var self = this;
	            // TODO: batch?
	            var xhr = $.when();
	            if (this.currentHistoryId) {
	                xhr = _collectionSuper.prototype.fetchFirst.call(self, {
	                    silent: true,
	                    limit: 1,
	                    filters: {
	                        // without these a deleted current history will return [] here and block the other xhr
	                        'purged': '',
	                        'deleted': '',
	                        'encoded_id-in': this.currentHistoryId
	                    }
	                });
	            }
	            return xhr.then(function () {
	                options = options || {};
	                options.offset = 0;
	                return self.fetchMore(options);
	            });
	        },
	
	        /** @type {Object} map of collection available sorting orders containing comparator fns */
	        comparators: _.extend(_.clone(_collectionSuper.prototype.comparators), {
	            'name': BASE_MVC.buildComparator('name', { ascending: true }),
	            'name-dsc': BASE_MVC.buildComparator('name', { ascending: false }),
	            'size': BASE_MVC.buildComparator('size', { ascending: false }),
	            'size-asc': BASE_MVC.buildComparator('size', { ascending: true })
	        }),
	
	        /** override to always have the current history first */
	        sort: function (options) {
	            options = options || {};
	            var silent = options.silent;
	            var currentHistory = this.remove(this.get(this.currentHistoryId));
	            _collectionSuper.prototype.sort.call(this, _.defaults({ silent: true }, options));
	            this.unshift(currentHistory, { silent: true });
	            if (!silent) {
	                this.trigger('sort', this, options);
	            }
	            return this;
	        },
	
	        /** create a new history and by default set it to be the current history */
	        create: function create(data, hdas, historyOptions, xhrOptions) {
	            //TODO: .create is actually a collection function that's overridden here
	            var collection = this,
	                xhr = jQuery.getJSON(Galaxy.root + 'history/create_new_current');
	            return xhr.done(function (newData) {
	                collection.setCurrent(new History(newData, [], historyOptions || {}));
	            });
	        },
	
	        /** set the current history to the given history, placing it first in the collection.
	         *  Pass standard bbone options for use in unshift.
	         *  @triggers new-current passed history and this collection
	         */
	        setCurrent: function (history, options) {
	            options = options || {};
	            // new histories go in the front
	            this.unshift(history, options);
	            this.currentHistoryId = history.get('id');
	            if (!options.silent) {
	                this.trigger('new-current', history, this);
	            }
	            return this;
	        },
	
	        toString: function toString() {
	            return 'HistoryCollection(' + this.length + ',current:' + this.currentHistoryId + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        History: History,
	        HistoryCollection: HistoryCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BASE_MVC) {
	
	    'use strict';
	
	    var logNamespace = 'history';
	
	    // ============================================================================
	    /** session storage for individual history preferences */
	    var HistoryPrefs = BASE_MVC.SessionStorageModel.extend(
	    /** @lends HistoryPrefs.prototype */{
	        //TODO:?? move to user prefs?
	        defaults: {
	            //TODO:?? expandedIds to array?
	            expandedIds: {},
	            show_deleted: false,
	            show_hidden: false
	        },
	
	        /** add an hda id to the hash of expanded hdas */
	        addExpanded: function (model) {
	            //TODO: use type_id and not model
	            var current = this.get('expandedIds');
	            current[model.id] = model.get('id');
	            this.save('expandedIds', current);
	        },
	
	        /** remove an hda id from the hash of expanded hdas */
	        removeExpanded: function (model) {
	            var current = this.get('expandedIds');
	            delete current[model.id];
	            this.save('expandedIds', current);
	        },
	
	        isExpanded: function (contentId) {
	            return _.result(this.get('expandedIds'), contentId, false);
	        },
	
	        allExpanded: function () {
	            return _.values(this.get('expandedIds'));
	        },
	
	        clearExpanded: function () {
	            this.set('expandedIds', {});
	        },
	
	        includeDeleted: function (val) {
	            // moving the invocation here so other components don't need to know the key
	            // TODO: change this key later
	            if (!_.isUndefined(val)) {
	                this.set('show_deleted', val);
	            }
	            return this.get('show_deleted');
	        },
	
	        includeHidden: function (val) {
	            // TODO: change this key later
	            if (!_.isUndefined(val)) {
	                this.set('show_hidden', val);
	            }
	            return this.get('show_hidden');
	        },
	
	        toString: function () {
	            return 'HistoryPrefs(' + this.id + ')';
	        }
	
	    }, {
	        // ........................................................................ class vars
	        // class lvl for access w/o instantiation
	        storageKeyPrefix: 'history:',
	
	        /** key string to store each histories settings under */
	        historyStorageKey: function historyStorageKey(historyId) {
	            if (!historyId) {
	                throw new Error('HistoryPrefs.historyStorageKey needs valid id: ' + historyId);
	            }
	            // single point of change
	            return HistoryPrefs.storageKeyPrefix + historyId;
	        },
	
	        /** return the existing storage for the history with the given id (or create one if it doesn't exist) */
	        get: function get(historyId) {
	            return new HistoryPrefs({ id: HistoryPrefs.historyStorageKey(historyId) });
	        },
	
	        /** clear all history related items in sessionStorage */
	        clearAll: function clearAll(historyId) {
	            for (var key in sessionStorage) {
	                if (key.indexOf(HistoryPrefs.storageKeyPrefix) === 0) {
	                    sessionStorage.removeItem(key);
	                }
	            }
	        }
	    });
	
	    //==============================================================================
	    return {
	        HistoryPrefs: HistoryPrefs
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BASE_MVC, _l) {
	
	    'use strict';
	
	    var logNamespace = 'list';
	    //==============================================================================
	    /** A view which, when first rendered, shows only summary data/attributes, but
	     *      can be expanded to show further details (and optionally fetch those
	     *      details from the server).
	     */
	    var ExpandableView = Backbone.View.extend(BASE_MVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        //TODO: Although the reasoning behind them is different, this shares a lot with HiddenUntilActivated above: combine them
	        //PRECONDITION: model must have method hasDetails
	        //PRECONDITION: subclasses must have templates.el and templates.details
	
	        initialize: function (attributes) {
	            /** are the details of this view expanded/shown or not? */
	            this.expanded = attributes.expanded || false;
	            this.log('\t expanded:', this.expanded);
	            this.fxSpeed = attributes.fxSpeed !== undefined ? attributes.fxSpeed : this.fxSpeed;
	        },
	
	        // ........................................................................ render main
	        /** jq fx speed */
	        fxSpeed: 'fast',
	
	        /** Render this content, set up ui.
	         *  @param {Number or String} speed   the speed of the render
	         */
	        render: function (speed) {
	            var $newRender = this._buildNewRender();
	            this._setUpBehaviors($newRender);
	            this._queueNewRender($newRender, speed);
	            return this;
	        },
	
	        /** Build a temp div containing the new children for the view's $el.
	         *      If the view is already expanded, build the details as well.
	         */
	        _buildNewRender: function () {
	            // create a new render using a skeleton template, render title buttons, render body, and set up events, etc.
	            var $newRender = $(this.templates.el(this.model.toJSON(), this));
	            if (this.expanded) {
	                this.$details($newRender).replaceWith(this._renderDetails().show());
	            }
	            return $newRender;
	        },
	
	        /** Fade out the old el, swap in the new contents, then fade in.
	         *  @param {Number or String} speed   jq speed to use for rendering effects
	         *  @fires rendered when rendered
	         */
	        _queueNewRender: function ($newRender, speed) {
	            speed = speed === undefined ? this.fxSpeed : speed;
	            var view = this;
	
	            if (speed === 0) {
	                view._swapNewRender($newRender);
	                view.trigger('rendered', view);
	            } else {
	                $(view).queue('fx', [function (next) {
	                    view.$el.fadeOut(speed, next);
	                }, function (next) {
	                    view._swapNewRender($newRender);
	                    next();
	                }, function (next) {
	                    view.$el.fadeIn(speed, next);
	                }, function (next) {
	                    view.trigger('rendered', view);
	                    next();
	                }]);
	            }
	        },
	
	        /** empty out the current el, move the $newRender's children in */
	        _swapNewRender: function ($newRender) {
	            return this.$el.empty().attr('class', _.isFunction(this.className) ? this.className() : this.className).append($newRender.children());
	        },
	
	        /** set up js behaviors, event handlers for elements within the given container
	         *  @param {jQuery} $container jq object that contains the elements to process (defaults to this.$el)
	         */
	        _setUpBehaviors: function ($where) {
	            $where = $where || this.$el;
	            // set up canned behavior on children (bootstrap, popupmenus, editable_text, etc.)
	            //make_popup_menus( $where );
	            $where.find('[title]').tooltip({ placement: 'bottom' });
	        },
	
	        // ......................................................................... details
	        /** shortcut to details DOM (as jQ) */
	        $details: function ($where) {
	            $where = $where || this.$el;
	            return $where.find('> .details');
	        },
	
	        /** build the DOM for the details and set up behaviors on it */
	        _renderDetails: function () {
	            var $newDetails = $(this.templates.details(this.model.toJSON(), this));
	            this._setUpBehaviors($newDetails);
	            return $newDetails;
	        },
	
	        // ......................................................................... expansion/details
	        /** Show or hide the details
	         *  @param {Boolean} expand if true, expand; if false, collapse
	         */
	        toggleExpanded: function (expand) {
	            expand = expand === undefined ? !this.expanded : expand;
	            if (expand) {
	                this.expand();
	            } else {
	                this.collapse();
	            }
	            return this;
	        },
	
	        /** Render and show the full, detailed body of this view including extra data and controls.
	         *      note: if the model does not have detailed data, fetch that data before showing the body
	         *  @fires expanded when a body has been expanded
	         */
	        expand: function () {
	            var view = this;
	            return view._fetchModelDetails().always(function () {
	                view._expand();
	            });
	        },
	
	        /** Check for model details and, if none, fetch them.
	         *  @returns {jQuery.promise} the model.fetch.xhr if details are being fetched, an empty promise if not
	         */
	        _fetchModelDetails: function () {
	            if (!this.model.hasDetails()) {
	                return this.model.fetch();
	            }
	            return jQuery.when();
	        },
	
	        /** Inner fn called when expand (public) has fetched the details */
	        _expand: function () {
	            var view = this,
	                $newDetails = view._renderDetails();
	            view.$details().replaceWith($newDetails);
	            // needs to be set after the above or the slide will not show
	            view.expanded = true;
	            view.$details().slideDown(view.fxSpeed, function () {
	                view.trigger('expanded', view);
	            });
	        },
	
	        /** Hide the body/details of an HDA.
	         *  @fires collapsed when a body has been collapsed
	         */
	        collapse: function () {
	            this.debug(this + '(ExpandableView).collapse');
	            var view = this;
	            view.expanded = false;
	            this.$details().slideUp(view.fxSpeed, function () {
	                view.trigger('collapsed', view);
	            });
	        }
	
	    });
	
	    //==============================================================================
	    /** A view that is displayed in some larger list/grid/collection.
	     *      Inherits from Expandable, Selectable, Draggable.
	     *  The DOM contains warnings, a title bar, and a series of primary action controls.
	     *      Primary actions are meant to be easily accessible item functions (such as delete)
	     *      that are rendered in the title bar.
	     *
	     *  Details are rendered when the user clicks the title bar or presses enter/space when
	     *      the title bar is in focus.
	     *
	     *  Designed as a base class for history panel contents - but usable elsewhere (I hope).
	     */
	    var ListItemView = ExpandableView.extend(BASE_MVC.mixin(BASE_MVC.SelectableViewMixin, BASE_MVC.DraggableViewMixin, {
	
	        tagName: 'div',
	        className: 'list-item',
	
	        /** Set up the base class and all mixins */
	        initialize: function (attributes) {
	            ExpandableView.prototype.initialize.call(this, attributes);
	            BASE_MVC.SelectableViewMixin.initialize.call(this, attributes);
	            BASE_MVC.DraggableViewMixin.initialize.call(this, attributes);
	            this._setUpListeners();
	        },
	
	        /** event listeners */
	        _setUpListeners: function () {
	            // hide the primary actions in the title bar when selectable and narrow
	            this.on('selectable', function (isSelectable) {
	                if (isSelectable) {
	                    this.$('.primary-actions').hide();
	                } else {
	                    this.$('.primary-actions').show();
	                }
	            }, this);
	            return this;
	        },
	
	        // ........................................................................ rendering
	        /** In this override, call methods to build warnings, titlebar and primary actions */
	        _buildNewRender: function () {
	            var $newRender = ExpandableView.prototype._buildNewRender.call(this);
	            $newRender.children('.warnings').replaceWith(this._renderWarnings());
	            $newRender.children('.title-bar').replaceWith(this._renderTitleBar());
	            $newRender.children('.primary-actions').append(this._renderPrimaryActions());
	            $newRender.find('> .title-bar .subtitle').replaceWith(this._renderSubtitle());
	            return $newRender;
	        },
	
	        /** In this override, render the selector controls and set up dragging before the swap */
	        _swapNewRender: function ($newRender) {
	            ExpandableView.prototype._swapNewRender.call(this, $newRender);
	            if (this.selectable) {
	                this.showSelector(0);
	            }
	            if (this.draggable) {
	                this.draggableOn();
	            }
	            return this.$el;
	        },
	
	        /** Render any warnings the item may need to show (e.g. "I'm deleted") */
	        _renderWarnings: function () {
	            var view = this,
	                $warnings = $('<div class="warnings"></div>'),
	                json = view.model.toJSON();
	            //TODO:! unordered (map)
	            _.each(view.templates.warnings, function (templateFn) {
	                $warnings.append($(templateFn(json, view)));
	            });
	            return $warnings;
	        },
	
	        /** Render the title bar (the main/exposed SUMMARY dom element) */
	        _renderTitleBar: function () {
	            return $(this.templates.titleBar(this.model.toJSON(), this));
	        },
	
	        /** Return an array of jQ objects containing common/easily-accessible item controls */
	        _renderPrimaryActions: function () {
	            // override this
	            return [];
	        },
	
	        /** Render the title bar (the main/exposed SUMMARY dom element) */
	        _renderSubtitle: function () {
	            return $(this.templates.subtitle(this.model.toJSON(), this));
	        },
	
	        // ......................................................................... events
	        /** event map */
	        events: {
	            // expand the body when the title is clicked or when in focus and space or enter is pressed
	            'click .title-bar': '_clickTitleBar',
	            'keydown .title-bar': '_keyDownTitleBar',
	            'click .selector': 'toggleSelect'
	        },
	
	        /** expand when the title bar is clicked */
	        _clickTitleBar: function (event) {
	            event.stopPropagation();
	            if (event.altKey) {
	                this.toggleSelect(event);
	                if (!this.selectable) {
	                    this.showSelector();
	                }
	            } else {
	                this.toggleExpanded();
	            }
	        },
	
	        /** expand when the title bar is in focus and enter or space is pressed */
	        _keyDownTitleBar: function (event) {
	            // bail (with propagation) if keydown and not space or enter
	            var KEYCODE_SPACE = 32,
	                KEYCODE_RETURN = 13;
	            if (event && event.type === 'keydown' && (event.keyCode === KEYCODE_SPACE || event.keyCode === KEYCODE_RETURN)) {
	                this.toggleExpanded();
	                event.stopPropagation();
	                return false;
	            }
	            return true;
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'ListItemView(' + modelString + ')';
	        }
	    }));
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    ListItemView.prototype.templates = function () {
	
	        var elTemplato = BASE_MVC.wrapTemplate(['<div class="list-element">',
	        // errors, messages, etc.
	        '<div class="warnings"></div>',
	
	        // multi-select checkbox
	        '<div class="selector">', '<span class="fa fa-2x fa-square-o"></span>', '</div>',
	        // space for title bar buttons - gen. floated to the right
	        '<div class="primary-actions"></div>', '<div class="title-bar"></div>',
	
	        // expandable area for more details
	        '<div class="details"></div>', '</div>']);
	
	        var warnings = {};
	
	        var titleBarTemplate = BASE_MVC.wrapTemplate([
	        // adding a tabindex here allows focusing the title bar and the use of keydown to expand the dataset display
	        '<div class="title-bar clear" tabindex="0">',
	        //TODO: prob. belongs in dataset-list-item
	        '<span class="state-icon"></span>', '<div class="title">', '<span class="name"><%- element.name %></span>', '</div>', '<div class="subtitle"></div>', '</div>'], 'element');
	
	        var subtitleTemplate = BASE_MVC.wrapTemplate([
	        // override this
	        '<div class="subtitle"></div>']);
	
	        var detailsTemplate = BASE_MVC.wrapTemplate([
	        // override this
	        '<div class="details"></div>']);
	
	        return {
	            el: elTemplato,
	            warnings: warnings,
	            titleBar: titleBarTemplate,
	            subtitle: subtitleTemplate,
	            details: detailsTemplate
	        };
	    }();
	
	    //==============================================================================
	    /** A view that is displayed in some larger list/grid/collection.
	     *  *AND* can display some sub-list of it's own when expanded (e.g. dataset collections).
	     *  This list will 'foldout' when the item is expanded depending on this.foldoutStyle:
	     *      If 'foldout': will expand vertically to show the nested list
	     *      If 'drilldown': will overlay the parent list
	     *
	     *  Inherits from ListItemView.
	     *
	     *  _renderDetails does the work of creating this.details: a sub-view that shows the nested list
	     */
	    var FoldoutListItemView = ListItemView.extend({
	
	        /** If 'foldout': show the sub-panel inside the expanded item
	         *  If 'drilldown': only fire events and handle by pub-sub
	         *      (allow the panel containing this item to attach it, hide itself, etc.)
	         */
	        foldoutStyle: 'foldout',
	        /** Panel view class to instantiate for the sub-panel */
	        foldoutPanelClass: null,
	
	        /** override to:
	         *      add attributes foldoutStyle and foldoutPanelClass for config poly
	         *      disrespect attributes.expanded if drilldown
	         */
	        initialize: function (attributes) {
	            if (this.foldoutStyle === 'drilldown') {
	                this.expanded = false;
	            }
	            this.foldoutStyle = attributes.foldoutStyle || this.foldoutStyle;
	            this.foldoutPanelClass = attributes.foldoutPanelClass || this.foldoutPanelClass;
	
	            ListItemView.prototype.initialize.call(this, attributes);
	            this.foldout = this._createFoldoutPanel();
	        },
	
	        /** in this override, attach the foldout panel when rendering details */
	        _renderDetails: function () {
	            if (this.foldoutStyle === 'drilldown') {
	                return $();
	            }
	            var $newDetails = ListItemView.prototype._renderDetails.call(this);
	            return this._attachFoldout(this.foldout, $newDetails);
	        },
	
	        /** In this override, handle collection expansion. */
	        _createFoldoutPanel: function () {
	            var model = this.model;
	            var FoldoutClass = this._getFoldoutPanelClass(model),
	                options = this._getFoldoutPanelOptions(model),
	                foldout = new FoldoutClass(_.extend(options, {
	                model: model
	            }));
	            return foldout;
	        },
	
	        /** Stub to return proper foldout panel class */
	        _getFoldoutPanelClass: function () {
	            // override
	            return this.foldoutPanelClass;
	        },
	
	        /** Stub to return proper foldout panel options */
	        _getFoldoutPanelOptions: function () {
	            return {
	                // propagate foldout style down
	                foldoutStyle: this.foldoutStyle,
	                fxSpeed: this.fxSpeed
	            };
	        },
	
	        /** Render the foldout panel inside the view, hiding controls */
	        _attachFoldout: function (foldout, $whereTo) {
	            $whereTo = $whereTo || this.$('> .details');
	            this.foldout = foldout.render(0);
	            foldout.$('> .controls').hide();
	            return $whereTo.append(foldout.$el);
	        },
	
	        /** In this override, branch on foldoutStyle to show expanded */
	        expand: function () {
	            var view = this;
	            return view._fetchModelDetails().always(function () {
	                if (view.foldoutStyle === 'foldout') {
	                    view._expand();
	                } else if (view.foldoutStyle === 'drilldown') {
	                    view._expandByDrilldown();
	                }
	            });
	        },
	
	        /** For drilldown, set up close handler and fire expanded:drilldown
	         *      containing views can listen to this and handle other things
	         *      (like hiding themselves) by listening for expanded/collapsed:drilldown
	         */
	        _expandByDrilldown: function () {
	            var view = this;
	            // attachment and rendering done by listener
	            view.listenTo(view.foldout, 'close', function () {
	                view.trigger('collapsed:drilldown', view, view.foldout);
	            });
	            view.trigger('expanded:drilldown', view, view.foldout);
	        }
	
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    FoldoutListItemView.prototype.templates = function () {
	
	        var detailsTemplate = BASE_MVC.wrapTemplate(['<div class="details">',
	        // override with more info (that goes above the panel)
	        '</div>'], 'collection');
	
	        return _.extend({}, ListItemView.prototype.templates, {
	            details: detailsTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        ExpandableView: ExpandableView,
	        ListItemView: ListItemView,
	        FoldoutListItemView: FoldoutListItemView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/**
	 * Model, view, and controller objects for Galaxy tools and tool panel.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(27), __webpack_require__(16), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util, data, ToolForm) {
	    'use strict';
	
	    /**
	     * Mixin for tracking model visibility.
	     */
	
	    var VisibilityMixin = {
	        hidden: false,
	
	        show: function () {
	            this.set("hidden", false);
	        },
	
	        hide: function () {
	            this.set("hidden", true);
	        },
	
	        toggle: function () {
	            this.set("hidden", !this.get("hidden"));
	        },
	
	        is_visible: function () {
	            return !this.attributes.hidden;
	        }
	
	    };
	
	    /**
	     * A tool parameter.
	     */
	    var ToolParameter = Backbone.Model.extend({
	        defaults: {
	            name: null,
	            label: null,
	            type: null,
	            value: null,
	            html: null,
	            num_samples: 5
	        },
	
	        initialize: function (options) {
	            this.attributes.html = unescape(this.attributes.html);
	        },
	
	        copy: function () {
	            return new ToolParameter(this.toJSON());
	        },
	
	        set_value: function (value) {
	            this.set('value', value || '');
	        }
	    });
	
	    var ToolParameterCollection = Backbone.Collection.extend({
	        model: ToolParameter
	    });
	
	    /**
	     * A data tool parameter.
	     */
	    var DataToolParameter = ToolParameter.extend({});
	
	    /**
	     * An integer tool parameter.
	     */
	    var IntegerToolParameter = ToolParameter.extend({
	        set_value: function (value) {
	            this.set('value', parseInt(value, 10));
	        },
	
	        /**
	         * Returns samples from a tool input.
	         */
	        get_samples: function () {
	            return d3.scale.linear().domain([this.get('min'), this.get('max')]).ticks(this.get('num_samples'));
	        }
	    });
	
	    var FloatToolParameter = IntegerToolParameter.extend({
	        set_value: function (value) {
	            this.set('value', parseFloat(value));
	        }
	    });
	
	    /**
	     * A select tool parameter.
	     */
	    var SelectToolParameter = ToolParameter.extend({
	        /**
	         * Returns tool options.
	         */
	        get_samples: function () {
	            return _.map(this.get('options'), function (option) {
	                return option[0];
	            });
	        }
	    });
	
	    // Set up dictionary of parameter types.
	    ToolParameter.subModelTypes = {
	        'integer': IntegerToolParameter,
	        'float': FloatToolParameter,
	        'data': DataToolParameter,
	        'select': SelectToolParameter
	    };
	
	    /**
	     * A Galaxy tool.
	     */
	    var Tool = Backbone.Model.extend({
	        // Default attributes.
	        defaults: {
	            id: null,
	            name: null,
	            description: null,
	            target: null,
	            inputs: [],
	            outputs: []
	        },
	
	        urlRoot: Galaxy.root + 'api/tools',
	
	        initialize: function (options) {
	
	            // Set parameters.
	            this.set('inputs', new ToolParameterCollection(_.map(options.inputs, function (p) {
	                var p_class = ToolParameter.subModelTypes[p.type] || ToolParameter;
	                return new p_class(p);
	            })));
	        },
	
	        /**
	         *
	         */
	        toJSON: function () {
	            var rval = Backbone.Model.prototype.toJSON.call(this);
	
	            // Convert inputs to JSON manually.
	            rval.inputs = this.get('inputs').map(function (i) {
	                return i.toJSON();
	            });
	            return rval;
	        },
	
	        /**
	         * Removes inputs of a particular type; this is useful because not all inputs can be handled by
	         * client and server yet.
	         */
	        remove_inputs: function (types) {
	            var tool = this,
	                incompatible_inputs = tool.get('inputs').filter(function (input) {
	                return types.indexOf(input.get('type')) !== -1;
	            });
	            tool.get('inputs').remove(incompatible_inputs);
	        },
	
	        /**
	         * Returns object copy, optionally including only inputs that can be sampled.
	         */
	        copy: function (only_samplable_inputs) {
	            var copy = new Tool(this.toJSON());
	
	            // Return only samplable inputs if flag is set.
	            if (only_samplable_inputs) {
	                var valid_inputs = new Backbone.Collection();
	                copy.get('inputs').each(function (input) {
	                    if (input.get_samples()) {
	                        valid_inputs.push(input);
	                    }
	                });
	                copy.set('inputs', valid_inputs);
	            }
	
	            return copy;
	        },
	
	        apply_search_results: function (results) {
	            _.indexOf(results, this.attributes.id) !== -1 ? this.show() : this.hide();
	            return this.is_visible();
	        },
	
	        /**
	         * Set a tool input's value.
	         */
	        set_input_value: function (name, value) {
	            this.get('inputs').find(function (input) {
	                return input.get('name') === name;
	            }).set('value', value);
	        },
	
	        /**
	         * Set many input values at once.
	         */
	        set_input_values: function (inputs_dict) {
	            var self = this;
	            _.each(_.keys(inputs_dict), function (input_name) {
	                self.set_input_value(input_name, inputs_dict[input_name]);
	            });
	        },
	
	        /**
	         * Run tool; returns a Deferred that resolves to the tool's output(s).
	         */
	        run: function () {
	            return this._run();
	        },
	
	        /**
	         * Rerun tool using regions and a target dataset.
	         */
	        rerun: function (target_dataset, regions) {
	            return this._run({
	                action: 'rerun',
	                target_dataset_id: target_dataset.id,
	                regions: regions
	            });
	        },
	
	        /**
	         * Returns input dict for tool's inputs.
	         */
	        get_inputs_dict: function () {
	            var input_dict = {};
	            this.get('inputs').each(function (input) {
	                input_dict[input.get('name')] = input.get('value');
	            });
	            return input_dict;
	        },
	
	        /**
	         * Run tool; returns a Deferred that resolves to the tool's output(s).
	         * NOTE: this method is a helper method and should not be called directly.
	         */
	        _run: function (additional_params) {
	            // Create payload.
	            var payload = _.extend({
	                tool_id: this.id,
	                inputs: this.get_inputs_dict()
	            }, additional_params);
	
	            // Because job may require indexing datasets, use server-side
	            // deferred to ensure that job is run. Also use deferred that
	            // resolves to outputs from tool.
	            var run_deferred = $.Deferred(),
	                ss_deferred = new util.ServerStateDeferred({
	                ajax_settings: {
	                    url: this.urlRoot,
	                    data: JSON.stringify(payload),
	                    dataType: "json",
	                    contentType: 'application/json',
	                    type: "POST"
	                },
	                interval: 2000,
	                success_fn: function (response) {
	                    return response !== "pending";
	                }
	            });
	
	            // Run job and resolve run_deferred to tool outputs.
	            $.when(ss_deferred.go()).then(function (result) {
	                run_deferred.resolve(new data.DatasetCollection(result));
	            });
	            return run_deferred;
	        }
	    });
	    _.extend(Tool.prototype, VisibilityMixin);
	
	    /**
	     * Tool view.
	     */
	    var ToolView = Backbone.View.extend({});
	
	    /**
	     * Wrap collection of tools for fast access/manipulation.
	     */
	    var ToolCollection = Backbone.Collection.extend({
	        model: Tool
	    });
	
	    /**
	     * Label or section header in tool panel.
	     */
	    var ToolSectionLabel = Backbone.Model.extend(VisibilityMixin);
	
	    /**
	     * Section of tool panel with elements (labels and tools).
	     */
	    var ToolSection = Backbone.Model.extend({
	        defaults: {
	            elems: [],
	            open: false
	        },
	
	        clear_search_results: function () {
	            _.each(this.attributes.elems, function (elt) {
	                elt.show();
	            });
	
	            this.show();
	            this.set("open", false);
	        },
	
	        apply_search_results: function (results) {
	            var all_hidden = true,
	                cur_label;
	            _.each(this.attributes.elems, function (elt) {
	                if (elt instanceof ToolSectionLabel) {
	                    cur_label = elt;
	                    cur_label.hide();
	                } else if (elt instanceof Tool) {
	                    if (elt.apply_search_results(results)) {
	                        all_hidden = false;
	                        if (cur_label) {
	                            cur_label.show();
	                        }
	                    }
	                }
	            });
	
	            if (all_hidden) {
	                this.hide();
	            } else {
	                this.show();
	                this.set("open", true);
	            }
	        }
	    });
	    _.extend(ToolSection.prototype, VisibilityMixin);
	
	    /**
	     * Tool search that updates results when query is changed. Result value of null
	     * indicates that query was not run; if not null, results are from search using
	     * query.
	     */
	    var ToolSearch = Backbone.Model.extend({
	        defaults: {
	            search_hint_string: "search tools",
	            min_chars_for_search: 3,
	            clear_btn_url: "",
	            visible: true,
	            query: "",
	            results: null,
	            // ESC (27) will clear the input field and tool search filters
	            clear_key: 27
	        },
	
	        urlRoot: Galaxy.root + 'api/tools',
	
	        initialize: function () {
	            this.on("change:query", this.do_search);
	        },
	
	        /**
	         * Do the search and update the results.
	         */
	        do_search: function () {
	            var query = this.attributes.query;
	
	            // If query is too short, do not search.
	            if (query.length < this.attributes.min_chars_for_search) {
	                this.set("results", null);
	                return;
	            }
	
	            // Do search via AJAX.
	            var q = query;
	            // Stop previous ajax-request
	            if (this.timer) {
	                clearTimeout(this.timer);
	            }
	            // Start a new ajax-request in X ms
	            $("#search-clear-btn").hide();
	            $("#search-spinner").show();
	            var self = this;
	            this.timer = setTimeout(function () {
	                // log the search to analytics if present
	                if (typeof ga !== 'undefined') {
	                    ga('send', 'pageview', Galaxy.root + '?q=' + q);
	                }
	                $.get(self.urlRoot, { q: q }, function (data) {
	                    self.set("results", data);
	                    $("#search-spinner").hide();
	                    $("#search-clear-btn").show();
	                }, "json");
	            }, 400);
	        },
	
	        clear_search: function () {
	            this.set("query", "");
	            this.set("results", null);
	        }
	
	    });
	    _.extend(ToolSearch.prototype, VisibilityMixin);
	
	    /**
	     * Tool Panel.
	     */
	    var ToolPanel = Backbone.Model.extend({
	
	        initialize: function (options) {
	            this.attributes.tool_search = options.tool_search;
	            this.attributes.tool_search.on("change:results", this.apply_search_results, this);
	            this.attributes.tools = options.tools;
	            this.attributes.layout = new Backbone.Collection(this.parse(options.layout));
	        },
	
	        /**
	         * Parse tool panel dictionary and return collection of tool panel elements.
	         */
	        parse: function (response) {
	            // Recursive function to parse tool panel elements.
	            var self = this,
	
	            // Helper to recursively parse tool panel.
	            parse_elt = function (elt_dict) {
	                var type = elt_dict.model_class;
	                // There are many types of tools; for now, anything that ends in 'Tool'
	                // is treated as a generic tool.
	                if (type.indexOf('Tool') === type.length - 4) {
	                    return self.attributes.tools.get(elt_dict.id);
	                } else if (type === 'ToolSection') {
	                    // Parse elements.
	                    var elems = _.map(elt_dict.elems, parse_elt);
	                    elt_dict.elems = elems;
	                    return new ToolSection(elt_dict);
	                } else if (type === 'ToolSectionLabel') {
	                    return new ToolSectionLabel(elt_dict);
	                }
	            };
	
	            return _.map(response, parse_elt);
	        },
	
	        clear_search_results: function () {
	            this.get('layout').each(function (panel_elt) {
	                if (panel_elt instanceof ToolSection) {
	                    panel_elt.clear_search_results();
	                } else {
	                    // Label or tool, so just show.
	                    panel_elt.show();
	                }
	            });
	        },
	
	        apply_search_results: function () {
	            var results = this.get('tool_search').get('results');
	            if (results === null) {
	                this.clear_search_results();
	                return;
	            }
	
	            var cur_label = null;
	            this.get('layout').each(function (panel_elt) {
	                if (panel_elt instanceof ToolSectionLabel) {
	                    cur_label = panel_elt;
	                    cur_label.hide();
	                } else if (panel_elt instanceof Tool) {
	                    if (panel_elt.apply_search_results(results)) {
	                        if (cur_label) {
	                            cur_label.show();
	                        }
	                    }
	                } else {
	                    // Starting new section, so clear current label.
	                    cur_label = null;
	                    panel_elt.apply_search_results(results);
	                }
	            });
	        }
	    });
	
	    /**
	     * View classes for Galaxy tools and tool panel.
	     *
	     * Views use the templates defined below for rendering. Views update as needed
	     * based on (a) model/collection events and (b) user interactions; in this sense,
	     * they are controllers are well and the HTML is the real view in the MVC architecture.
	     */
	
	    /**
	     * Base view that handles visibility based on model's hidden attribute.
	     */
	    var BaseView = Backbone.View.extend({
	        initialize: function () {
	            this.model.on("change:hidden", this.update_visible, this);
	            this.update_visible();
	        },
	        update_visible: function () {
	            this.model.attributes.hidden ? this.$el.hide() : this.$el.show();
	        }
	    });
	
	    /**
	     * Link to a tool.
	     */
	    var ToolLinkView = BaseView.extend({
	        tagName: 'div',
	
	        render: function () {
	            // create element
	            var $link = $('<div/>');
	            $link.append(templates.tool_link(this.model.toJSON()));
	
	            var formStyle = this.model.get('form_style', null);
	            // open upload dialog for upload tool
	            if (this.model.id === 'upload1') {
	                $link.find('a').on('click', function (e) {
	                    e.preventDefault();
	                    Galaxy.upload.show();
	                });
	            } else if (formStyle === 'regular') {
	                // regular tools
	                var self = this;
	                $link.find('a').on('click', function (e) {
	                    e.preventDefault();
	                    Galaxy.router.push('/', { tool_id: self.model.id, version: self.model.get('version') });
	                });
	            }
	
	            // add element
	            this.$el.append($link);
	            return this;
	        }
	    });
	
	    /**
	     * Panel label/section header.
	     */
	    var ToolSectionLabelView = BaseView.extend({
	        tagName: 'div',
	        className: 'toolPanelLabel',
	
	        render: function () {
	            this.$el.append($("<span/>").text(this.model.attributes.text));
	            return this;
	        }
	    });
	
	    /**
	     * Panel section.
	     */
	    var ToolSectionView = BaseView.extend({
	        tagName: 'div',
	        className: 'toolSectionWrapper',
	
	        initialize: function () {
	            BaseView.prototype.initialize.call(this);
	            this.model.on("change:open", this.update_open, this);
	        },
	
	        render: function () {
	            // Build using template.
	            this.$el.append(templates.panel_section(this.model.toJSON()));
	
	            // Add tools to section.
	            var section_body = this.$el.find(".toolSectionBody");
	            _.each(this.model.attributes.elems, function (elt) {
	                if (elt instanceof Tool) {
	                    var tool_view = new ToolLinkView({ model: elt, className: "toolTitle" });
	                    tool_view.render();
	                    section_body.append(tool_view.$el);
	                } else if (elt instanceof ToolSectionLabel) {
	                    var label_view = new ToolSectionLabelView({ model: elt });
	                    label_view.render();
	                    section_body.append(label_view.$el);
	                } else {
	                    // TODO: handle nested section bodies?
	                }
	            });
	            return this;
	        },
	
	        events: {
	            'click .toolSectionTitle > a': 'toggle'
	        },
	
	        /**
	         * Toggle visibility of tool section.
	         */
	        toggle: function () {
	            this.model.set("open", !this.model.attributes.open);
	        },
	
	        /**
	         * Update whether section is open or close.
	         */
	        update_open: function () {
	            this.model.attributes.open ? this.$el.children(".toolSectionBody").slideDown("fast") : this.$el.children(".toolSectionBody").slideUp("fast");
	        }
	    });
	
	    var ToolSearchView = Backbone.View.extend({
	        tagName: 'div',
	        id: 'tool-search',
	        className: 'bar',
	
	        events: {
	            'click': 'focus_and_select',
	            'keyup :input': 'query_changed',
	            'change :input': 'query_changed',
	            'click #search-clear-btn': 'clear'
	        },
	
	        render: function () {
	            this.$el.append(templates.tool_search(this.model.toJSON()));
	            if (!this.model.is_visible()) {
	                this.$el.hide();
	            }
	
	            // Adjust top for issue 2907 depending on whether the messagebox is visible.
	            if ($("#messagebox").is(":visible")) {
	                this.$el.css("top", "95px");
	            }
	
	            this.$el.find('[title]').tooltip();
	            return this;
	        },
	
	        focus_and_select: function () {
	            this.$el.find(":input").focus().select();
	        },
	
	        clear: function () {
	            this.model.clear_search();
	            this.$el.find(":input").val('');
	            this.focus_and_select();
	            return false;
	        },
	
	        query_changed: function (evData) {
	            // check for the 'clear key' (ESC) first
	            if (this.model.attributes.clear_key && this.model.attributes.clear_key === evData.which) {
	                this.clear();
	                return false;
	            }
	            this.model.set("query", this.$el.find(":input").val());
	        }
	    });
	
	    /**
	     * Tool panel view. Events triggered include:
	     * tool_link_click(click event, tool_model)
	     */
	    var ToolPanelView = Backbone.View.extend({
	        tagName: 'div',
	        className: 'toolMenu',
	
	        /**
	         * Set up view.
	         */
	        initialize: function () {
	            this.model.get('tool_search').on("change:results", this.handle_search_results, this);
	        },
	
	        render: function () {
	            var self = this;
	
	            // Render search.
	            var search_view = new ToolSearchView({ model: this.model.get('tool_search') });
	            search_view.render();
	            self.$el.append(search_view.$el);
	
	            // Render panel.
	            this.model.get('layout').each(function (panel_elt) {
	                if (panel_elt instanceof ToolSection) {
	                    var section_title_view = new ToolSectionView({ model: panel_elt });
	                    section_title_view.render();
	                    self.$el.append(section_title_view.$el);
	                } else if (panel_elt instanceof Tool) {
	                    var tool_view = new ToolLinkView({ model: panel_elt, className: "toolTitleNoSection" });
	                    tool_view.render();
	                    self.$el.append(tool_view.$el);
	                } else if (panel_elt instanceof ToolSectionLabel) {
	                    var label_view = new ToolSectionLabelView({ model: panel_elt });
	                    label_view.render();
	                    self.$el.append(label_view.$el);
	                }
	            });
	
	            // Setup tool link click eventing.
	            self.$el.find("a.tool-link").click(function (e) {
	                // Tool id is always the first class.
	                var tool_id = $(this).attr('class').split(/\s+/)[0],
	                    tool = self.model.get('tools').get(tool_id);
	
	                self.trigger("tool_link_click", e, tool);
	            });
	
	            return this;
	        },
	
	        handle_search_results: function () {
	            var results = this.model.get('tool_search').get('results');
	            if (results && results.length === 0) {
	                $("#search-no-results").show();
	            } else {
	                $("#search-no-results").hide();
	            }
	        }
	    });
	
	    /**
	     * View for working with a tool: setting parameters and inputs and executing the tool.
	     */
	    var ToolFormView = Backbone.View.extend({
	        className: 'toolForm',
	
	        render: function () {
	            this.$el.children().remove();
	            this.$el.append(templates.tool_form(this.model.toJSON()));
	        }
	    });
	
	    /**
	     * Integrated tool menu + tool execution.
	     */
	    var IntegratedToolMenuAndView = Backbone.View.extend({
	        className: 'toolMenuAndView',
	
	        initialize: function () {
	            this.tool_panel_view = new ToolPanelView({ collection: this.collection });
	            this.tool_form_view = new ToolFormView();
	        },
	
	        render: function () {
	            // Render and append tool panel.
	            this.tool_panel_view.render();
	            this.tool_panel_view.$el.css("float", "left");
	            this.$el.append(this.tool_panel_view.$el);
	
	            // Append tool form view.
	            this.tool_form_view.$el.hide();
	            this.$el.append(this.tool_form_view.$el);
	
	            // On tool link click, show tool.
	            var self = this;
	            this.tool_panel_view.on("tool_link_click", function (e, tool) {
	                // Prevents click from activating link:
	                e.preventDefault();
	                // Show tool that was clicked on:
	                self.show_tool(tool);
	            });
	        },
	
	        /**
	         * Fetch and display tool.
	         */
	        show_tool: function (tool) {
	            var self = this;
	            tool.fetch().done(function () {
	                self.tool_form_view.model = tool;
	                self.tool_form_view.render();
	                self.tool_form_view.$el.show();
	                $('#left').width("650px");
	            });
	        }
	    });
	
	    // TODO: move into relevant views
	    var templates = {
	        // the search bar at the top of the tool panel
	        tool_search: _.template(['<input id="tool-search-query" class="search-query parent-width" name="query" ', 'placeholder="<%- search_hint_string %>" autocomplete="off" type="text" />', '<a id="search-clear-btn" title="clear search (esc)"> </a>',
	        //TODO: replace with icon
	        '<span id="search-spinner" class="search-spinner fa fa-spinner fa-spin"></span>'].join('')),
	
	        // the category level container in the tool panel (e.g. 'Get Data', 'Text Manipulation')
	        panel_section: _.template(['<div class="toolSectionTitle" id="title_<%- id %>">', '<a href="javascript:void(0)"><span><%- name %></span></a>', '</div>', '<div id="<%- id %>" class="toolSectionBody" style="display: none;">', '<div class="toolSectionBg"></div>', '<div>'].join('')),
	
	        // a single tool's link in the tool panel; will load the tool form in the center panel
	        tool_link: _.template(['<a class="<%- id %> tool-link" href="<%= link %>" target="<%- target %>" minsizehint="<%- min_width %>">', '<span class="labels">', '<% _.each( labels, function( label ){ %>', '<span class="label label-default label-<%- label %>">', '<%- label %>', '</span>', '<% }); %>', '</span>', '<span class="tool-old-link">', '<%- name %>', '</span>', ' <%- description %>', '</a>'].join('')),
	
	        // the tool form for entering tool parameters, viewing help and executing the tool
	        // loaded when a tool link is clicked in the tool panel
	        tool_form: _.template(['<div class="toolFormTitle"><%- tool.name %> (version <%- tool.version %>)</div>', '<div class="toolFormBody">', '<% _.each( tool.inputs, function( input ){ %>', '<div class="form-row">', '<label for="<%- input.name %>"><%- input.label %>:</label>', '<div class="form-row-input">', '<%= input.html %>', '</div>', '<div class="toolParamHelp" style="clear: both;">', '<%- input.help %>', '</div>', '<div style="clear: both;"></div>', '</div>', '<% }); %>', '</div>', '<div class="form-row form-actions">', '<input type="submit" class="btn btn-primary" name="runtool_btn" value="Execute" />', '</div>', '<div class="toolHelp">', '<div class="toolHelpBody"><% tool.help %></div>', '</div>'].join(''), { variable: 'tool' })
	    };
	
	    // Exports
	    return {
	        ToolParameter: ToolParameter,
	        IntegerToolParameter: IntegerToolParameter,
	        SelectToolParameter: SelectToolParameter,
	        Tool: Tool,
	        ToolCollection: ToolCollection,
	        ToolSearch: ToolSearch,
	        ToolPanel: ToolPanel,
	        ToolPanelView: ToolPanelView,
	        ToolFormView: ToolFormView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This renders the content of the ftp popup **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    return Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.options = Utils.merge(options, {
	                class_add: 'upload-icon-button fa fa-square-o',
	                class_remove: 'upload-icon-button fa fa-check-square-o',
	                class_partial: 'upload-icon-button fa fa-minus-square-o',
	                collection: null,
	                onchange: function () {},
	                onadd: function () {},
	                onremove: function () {}
	            });
	            this.collection = this.options.collection;
	            this.setElement(this._template());
	            this.rows = [];
	            Utils.get({
	                url: Galaxy.root + 'api/remote_files',
	                success: function (ftp_files) {
	                    self._fill(ftp_files);
	                },
	                error: function () {
	                    self._fill();
	                }
	            });
	        },
	
	        /** Fill table with ftp entries */
	        _fill: function (ftp_files) {
	            if (ftp_files && ftp_files.length > 0) {
	                this.$('.upload-ftp-content').html($(this._templateTable()));
	                var size = 0;
	                for (var index in ftp_files) {
	                    this.rows.push(this._add(ftp_files[index]));
	                    size += ftp_files[index].size;
	                }
	                this.$('.upload-ftp-number').html(ftp_files.length + ' files');
	                this.$('.upload-ftp-disk').html(Utils.bytesToString(size, true));
	                if (this.collection) {
	                    var self = this;
	                    this.$('._has_collection').show();
	                    this.$select_all = this.$('.upload-selectall').addClass(this.options.class_add);
	                    this.$select_all.on('click', function () {
	                        var add = self.$select_all.hasClass(self.options.class_add);
	                        for (var index in ftp_files) {
	                            var ftp_file = ftp_files[index];
	                            var model_index = self._find(ftp_file);
	                            if (!model_index && add || model_index && !add) {
	                                self.rows[index].trigger('click');
	                            }
	                        }
	                    });
	                    this._refresh();
	                }
	            } else {
	                this.$('.upload-ftp-content').html($(this._templateInfo()));
	            }
	            this.$('.upload-ftp-wait').hide();
	        },
	
	        /** Add file to table */
	        _add: function (ftp_file) {
	            var self = this;
	            var $it = $(this._templateRow(ftp_file));
	            var $icon = $it.find('.icon');
	            this.$('tbody').append($it);
	            if (this.collection) {
	                $icon.addClass(this._find(ftp_file) ? this.options.class_remove : this.options.class_add);
	                $it.on('click', function () {
	                    var model_index = self._find(ftp_file);
	                    $icon.removeClass();
	                    if (!model_index) {
	                        self.options.onadd(ftp_file);
	                        $icon.addClass(self.options.class_remove);
	                    } else {
	                        self.options.onremove(model_index);
	                        $icon.addClass(self.options.class_add);
	                    }
	                    self._refresh();
	                });
	            } else {
	                $it.on('click', function () {
	                    self.options.onchange(ftp_file);
	                });
	            }
	            return $it;
	        },
	
	        /** Refresh select all button state */
	        _refresh: function () {
	            var filtered = this.collection.where({ file_mode: 'ftp', enabled: true });
	            this.$select_all.removeClass();
	            if (filtered.length == 0) {
	                this.$select_all.addClass(this.options.class_add);
	            } else {
	                this.$select_all.addClass(filtered.length == this.rows.length ? this.options.class_remove : this.options.class_partial);
	            }
	        },
	
	        /** Get model index */
	        _find: function (ftp_file) {
	            var item = this.collection.findWhere({
	                file_path: ftp_file.path,
	                file_mode: 'ftp',
	                enabled: true
	            });
	            return item && item.get('id');
	        },
	
	        /** Template of row */
	        _templateRow: function (options) {
	            return '<tr class="upload-ftp-row">' + '<td class="_has_collection" style="display: none;"><div class="icon"/></td>' + '<td class="ftp-name">' + _.escape(options.path) + '</td>' + '<td class="ftp-size">' + Utils.bytesToString(options.size) + '</td>' + '<td class="ftp-time">' + options.ctime + '</td>' + '</tr>';
	        },
	
	        /** Template of table */
	        _templateTable: function () {
	            return '<span style="whitespace: nowrap; float: left;">Available files: </span>' + '<span style="whitespace: nowrap; float: right;">' + '<span class="upload-icon fa fa-file-text-o"/>' + '<span class="upload-ftp-number"/>&nbsp;&nbsp;' + '<span class="upload-icon fa fa-hdd-o"/>' + '<span class="upload-ftp-disk"/>' + '</span>' + '<table class="grid" style="float: left;">' + '<thead>' + '<tr>' + '<th class="_has_collection" style="display: none;"><div class="upload-selectall"></th>' + '<th>Name</th>' + '<th>Size</th>' + '<th>Created</th>' + '</tr>' + '</thead>' + '<tbody/>' + '</table>';
	        },
	
	        /** Template of info message */
	        _templateInfo: function () {
	            return '<div class="upload-ftp-warning warningmessage">' + 'Your FTP directory does not contain any files.' + '</div>';
	        },
	
	        /** Template of main view */
	        _template: function () {
	            return '<div class="upload-ftp">' + '<div class="upload-ftp-wait fa fa-spinner fa-spin"/>' + '<div class="upload-ftp-help">This Galaxy server allows you to upload files via FTP. To upload some files, log in to the FTP server at <strong>' + this.options.ftp_upload_site + '</strong> using your Galaxy credentials (email address and password).</div>' + '<div class="upload-ftp-content"/>' + '<div>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This renders the content of the settings popup, allowing users to specify flags i.e. for space-to-tab conversion **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
	    return Backbone.View.extend({
	        options: {
	            class_check: 'fa-check-square-o',
	            class_uncheck: 'fa-square-o',
	            parameters: [{
	                id: 'space_to_tab',
	                title: 'Convert spaces to tabs'
	            }, {
	                id: 'to_posix_lines',
	                title: 'Use POSIX standard'
	            }]
	        },
	
	        initialize: function (options) {
	            var self = this;
	            this.model = options.model;
	            this.setElement($('<div/>').addClass('upload-settings'));
	            this.$el.append($('<div/>').addClass('upload-settings-cover'));
	            this.$el.append($('<table/>').addClass('upload-settings-table ui-table-striped').append('<tbody/>'));
	            this.$cover = this.$('.upload-settings-cover');
	            this.$table = this.$('.upload-settings-table > tbody');
	            this.listenTo(this.model, 'change', this.render, this);
	            this.model.trigger('change');
	        },
	
	        render: function () {
	            var self = this;
	            this.$table.empty();
	            _.each(this.options.parameters, function (parameter) {
	                var $checkbox = $('<div/>').addClass('upload-' + parameter.id + ' upload-icon-button fa').addClass(self.model.get(parameter.id) && self.options.class_check || self.options.class_uncheck).on('click', function () {
	                    self.model.get('enabled') && self.model.set(parameter.id, !self.model.get(parameter.id));
	                });
	                self.$table.append($('<tr/>').append($('<td/>').append($checkbox)).append($('<td/>').append(parameter.title)));
	            });
	            this.$cover[this.model.get('enabled') && 'hide' || 'show']();
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, _) {/*
	    galaxy upload plugins - requires FormData and XMLHttpRequest
	*/
	;(function ($) {
	    // add event properties
	    jQuery.event.props.push("dataTransfer");
	
	    /**
	        Posts file data to the API
	    */
	    $.uploadpost = function (config) {
	        // parse options
	        var cnf = $.extend({}, {
	            data: {},
	            success: function () {},
	            error: function () {},
	            progress: function () {},
	            url: null,
	            maxfilesize: 2048,
	            error_filesize: 'File exceeds 2GB. Please use a FTP client.',
	            error_default: 'Please make sure the file is available.',
	            error_server: 'Upload request failed.',
	            error_login: 'Uploads require you to log in.'
	        }, config);
	
	        // link data
	        var data = cnf.data;
	
	        // check errors
	        if (data.error_message) {
	            cnf.error(data.error_message);
	            return;
	        }
	
	        // construct form data
	        var form = new FormData();
	        for (var key in data.payload) {
	            form.append(key, data.payload[key]);
	        }
	
	        // add files to submission
	        var sizes = 0;
	        for (var key in data.files) {
	            var d = data.files[key];
	            form.append(d.name, d.file, d.file.name);
	            sizes += d.file.size;
	        }
	
	        // check file size, unless it's an ftp file
	        if (sizes > 1048576 * cnf.maxfilesize) {
	            cnf.error(cnf.error_filesize);
	            return;
	        }
	
	        // prepare request
	        var xhr = new XMLHttpRequest();
	        xhr.open('POST', cnf.url, true);
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.setRequestHeader('Cache-Control', 'no-cache');
	        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
	        // captures state changes
	        xhr.onreadystatechange = function () {
	            // check for request completed, server connection closed
	            if (xhr.readyState == xhr.DONE) {
	                // parse response
	                var response = null;
	                var extra_info = "";
	                if (xhr.responseText) {
	                    try {
	                        response = jQuery.parseJSON(xhr.responseText);
	                        extra_info = response.err_msg;
	                    } catch (e) {
	                        response = xhr.responseText;
	                        extra_info = response;
	                    }
	                }
	                // pass any error to the error option
	                if (xhr.status < 200 || xhr.status > 299) {
	                    var text = xhr.statusText;
	                    if (xhr.status == 403) {
	                        text = cnf.error_login;
	                    } else if (xhr.status == 0) {
	                        text = cnf.error_server;
	                    } else if (!text) {
	                        text = cnf.error_default;
	                    }
	                    cnf.error(text + ' (' + xhr.status + '). ' + extra_info);
	                } else {
	                    cnf.success(response);
	                }
	            }
	        };
	
	        // prepare upload progress
	        xhr.upload.addEventListener('progress', function (e) {
	            if (e.lengthComputable) {
	                cnf.progress(Math.round(e.loaded * 100 / e.total));
	            }
	        }, false);
	
	        // send request
	        Galaxy.emit.debug('uploadbox::uploadpost()', 'Posting following data.', cnf);
	        xhr.send(form);
	    };
	
	    /**
	        Handles the upload events drag/drop etc.
	    */
	    $.fn.uploadinput = function (options) {
	        // initialize
	        var el = this;
	        var opts = $.extend({}, {
	            ondragover: function () {},
	            ondragleave: function () {},
	            onchange: function () {},
	            multiple: false
	        }, options);
	
	        // append hidden upload field
	        var $input = $('<input type="file" style="display: none" ' + (opts.multiple && 'multiple' || '') + '/>');
	        el.append($input.change(function (e) {
	            opts.onchange(e.target.files);
	            $(this).val('');
	        }));
	
	        // drag/drop events
	        el.on('drop', function (e) {
	            opts.ondragleave(e);
	            if (e.dataTransfer) {
	                opts.onchange(e.dataTransfer.files);
	                e.preventDefault();
	            }
	        });
	        el.on('dragover', function (e) {
	            e.preventDefault();
	            opts.ondragover(e);
	        });
	        el.on('dragleave', function (e) {
	            e.stopPropagation();
	            opts.ondragleave(e);
	        });
	
	        // exports
	        return {
	            dialog: function () {
	                $input.trigger('click');
	            }
	        };
	    };
	
	    /**
	        Handles the upload queue and events such as drag/drop etc.
	    */
	    $.fn.uploadbox = function (options) {
	        // parse options
	        var opts = $.extend({}, {
	            dragover: function () {},
	            dragleave: function () {},
	            announce: function (d) {},
	            initialize: function (d) {},
	            progress: function (d, m) {},
	            success: function (d, m) {},
	            error: function (d, m) {
	                alert(m);
	            },
	            complete: function () {}
	        }, options);
	
	        // file queue
	        var queue = {};
	
	        // queue index/length counter
	        var queue_index = 0;
	        var queue_length = 0;
	
	        // indicates if queue is currently running
	        var queue_running = false;
	        var queue_stop = false;
	
	        // element
	        var uploadinput = $(this).uploadinput({
	            multiple: true,
	            onchange: function (files) {
	                add(files);
	            },
	            ondragover: options.ondragover,
	            ondragleave: options.ondragleave
	        });
	
	        // add new files to upload queue
	        function add(files) {
	            if (files && files.length && !queue_running) {
	                var current_index = queue_index;
	                _.each(files, function (file, key) {
	                    if (file.mode !== 'new' && _.filter(queue, function (f) {
	                        return f.name === file.name && f.size === file.size;
	                    }).length) {
	                        file.duplicate = true;
	                    }
	                });
	                _.each(files, function (file) {
	                    if (!file.duplicate) {
	                        var index = String(queue_index++);
	                        queue[index] = file;
	                        opts.announce(index, queue[index]);
	                        queue_length++;
	                    }
	                });
	                return current_index;
	            }
	        }
	
	        // remove file from queue
	        function remove(index) {
	            if (queue[index]) {
	                delete queue[index];
	                queue_length--;
	            }
	        }
	
	        // process an upload, recursive
	        function process() {
	            // validate
	            if (queue_length == 0 || queue_stop) {
	                queue_stop = false;
	                queue_running = false;
	                opts.complete();
	                return;
	            } else {
	                queue_running = true;
	            }
	
	            // get an identifier from the queue
	            var index = -1;
	            for (var key in queue) {
	                index = key;
	                break;
	            }
	
	            // get current file from queue
	            var file = queue[index];
	
	            // remove from queue
	            remove(index);
	
	            // create and submit data
	            $.uploadpost({
	                url: opts.url,
	                data: opts.initialize(index),
	                success: function (message) {
	                    opts.success(index, message);process();
	                },
	                error: function (message) {
	                    opts.error(index, message);process();
	                },
	                progress: function (percentage) {
	                    opts.progress(index, percentage);
	                }
	            });
	        }
	
	        /*
	            public interface
	        */
	
	        // open file browser for selection
	        function select() {
	            uploadinput.dialog();
	        }
	
	        // remove all entries from queue
	        function reset(index) {
	            for (index in queue) {
	                remove(index);
	            }
	        }
	
	        // initiate upload process
	        function start() {
	            if (!queue_running) {
	                queue_running = true;
	                process();
	            }
	        }
	
	        // stop upload process
	        function stop() {
	            queue_stop = true;
	        }
	
	        // set options
	        function configure(options) {
	            opts = $.extend({}, opts, options);
	            return opts;
	        }
	
	        // verify browser compatibility
	        function compatible() {
	            return window.File && window.FormData && window.XMLHttpRequest && window.FileList;
	        }
	
	        // export functions
	        return {
	            'select': select,
	            'add': add,
	            'remove': remove,
	            'start': start,
	            'stop': stop,
	            'reset': reset,
	            'configure': configure,
	            'compatible': compatible
	        };
	    };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(6), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function (baseMVC, _l) {
	    // =============================================================================
	    /** A view on any model that has a 'annotation' attribute
	     */
	    var AnnotationEditor = Backbone.View.extend(baseMVC.LoggableMixin).extend(baseMVC.HiddenUntilActivatedViewMixin).extend({
	
	        tagName: 'div',
	        className: 'annotation-display',
	
	        /** Set up listeners, parse options */
	        initialize: function (options) {
	            options = options || {};
	            this.tooltipConfig = options.tooltipConfig || { placement: 'bottom' };
	            //console.debug( this, options );
	            // only listen to the model only for changes to annotations
	            this.listenTo(this.model, 'change:annotation', function () {
	                this.render();
	            });
	            this.hiddenUntilActivated(options.$activator, options);
	        },
	
	        /** Build the DOM elements, call select to on the created input, and set up behaviors */
	        render: function () {
	            var view = this;
	            this.$el.html(this._template());
	
	            //TODO: handle empties better
	            this.$annotation().make_text_editable({
	                use_textarea: true,
	                on_finish: function (newAnnotation) {
	                    view.$annotation().text(newAnnotation);
	                    view.model.save({ annotation: newAnnotation }, { silent: true }).fail(function () {
	                        view.$annotation().text(view.model.previous('annotation'));
	                    });
	                }
	            });
	            return this;
	        },
	
	        /** @returns {String} the html text used to build the view's DOM */
	        _template: function () {
	            var annotation = this.model.get('annotation');
	            return [
	            //TODO: make prompt optional
	            '<label class="prompt">', _l('Annotation'), '</label>',
	            // set up initial tags by adding as CSV to input vals (necc. to init select2)
	            '<div class="annotation">', _.escape(annotation), '</div>'].join('');
	        },
	
	        /** @returns {jQuery} the main element for this view */
	        $annotation: function () {
	            return this.$el.find('.annotation');
	        },
	
	        /** shut down event listeners and remove this view's DOM */
	        remove: function () {
	            this.$annotation.off();
	            this.stopListening(this.model);
	            Backbone.View.prototype.remove.call(this);
	        },
	
	        /** string rep */
	        toString: function () {
	            return ['AnnotationEditor(', this.model + '', ')'].join('');
	        }
	    });
	    // =============================================================================
	    return {
	        AnnotationEditor: AnnotationEditor
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(2), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BASE_MVC) {
	    'use strict';
	
	    //=============================================================================
	    /**
	     * A Collection that can be limited/offset/re-ordered/filtered.
	     * @type {Backbone.Collection}
	     */
	
	    var ControlledFetchCollection = Backbone.Collection.extend({
	
	        /** call setOrder on initialization to build the comparator based on options */
	        initialize: function (models, options) {
	            Backbone.Collection.prototype.initialize.call(this, models, options);
	            this.setOrder(options.order || this.order, { silent: true });
	        },
	
	        /** set up to track order changes and re-sort when changed */
	        _setUpListeners: function () {
	            return this.on({
	                'changed-order': this.sort
	            });
	        },
	
	        /** override to provide order and offsets based on instance vars, set limit if passed,
	         *  and set allFetched/fire 'all-fetched' when xhr returns
	         */
	        fetch: function (options) {
	            options = this._buildFetchOptions(options);
	            Galaxy.debug('fetch options:', options);
	            return Backbone.Collection.prototype.fetch.call(this, options);
	        },
	
	        /** build ajax data/parameters from options */
	        _buildFetchOptions: function (options) {
	            // note: we normally want options passed in to override the defaults built here
	            // so most of these fns will generate defaults
	            options = _.clone(options) || {};
	            var self = this;
	
	            // jquery ajax option; allows multiple q/qv for filters (instead of 'q[]')
	            options.traditional = true;
	
	            // options.data
	            // we keep limit, offset, etc. in options *as well as move it into data* because:
	            // - it makes fetch calling convenient to add it to a single options map (instead of as mult. args)
	            // - it allows the std. event handlers (for fetch, etc.) to have access
	            //   to the pagination options too
	            //      (i.e. this.on( 'sync', function( options ){ if( options.limit ){ ... } }))
	            // however, when we send to xhr/jquery we copy them to data also so that they become API query params
	            options.data = options.data || self._buildFetchData(options);
	            Galaxy.debug('data:', options.data);
	
	            // options.data.filters --> options.data.q, options.data.qv
	            var filters = this._buildFetchFilters(options);
	            Galaxy.debug('filters:', filters);
	            if (!_.isEmpty(filters)) {
	                _.extend(options.data, this._fetchFiltersToAjaxData(filters));
	            }
	            Galaxy.debug('data:', options.data);
	            return options;
	        },
	
	        /** Build the dictionary to send to fetch's XHR as data */
	        _buildFetchData: function (options) {
	            var defaults = {};
	            if (this.order) {
	                defaults.order = this.order;
	            }
	            return _.defaults(_.pick(options, this._fetchParams), defaults);
	        },
	
	        /** These attribute keys are valid params to fetch/API-index */
	        _fetchParams: [
	        /** model dependent string to control the order of models returned */
	        'order',
	        /** limit the number of models returned from a fetch */
	        'limit',
	        /** skip this number of models when fetching */
	        'offset',
	        /** what series of attributes to return (model dependent) */
	        'view',
	        /** individual keys to return for the models (see api/histories.index) */
	        'keys'],
	
	        /** add any needed filters here based on collection state */
	        _buildFetchFilters: function (options) {
	            // override
	            return _.clone(options.filters || {});
	        },
	
	        /** Convert dictionary filters to qqv style arrays */
	        _fetchFiltersToAjaxData: function (filters) {
	            // return as a map so ajax.data can extend from it
	            var filterMap = {
	                q: [],
	                qv: []
	            };
	            _.each(filters, function (v, k) {
	                // don't send if filter value is empty
	                if (v === undefined || v === '') {
	                    return;
	                }
	                // json to python
	                if (v === true) {
	                    v = 'True';
	                }
	                if (v === false) {
	                    v = 'False';
	                }
	                if (v === null) {
	                    v = 'None';
	                }
	                // map to k/v arrays (q/qv)
	                filterMap.q.push(k);
	                filterMap.qv.push(v);
	            });
	            return filterMap;
	        },
	
	        /** override to reset allFetched flag to false */
	        reset: function (models, options) {
	            this.allFetched = false;
	            return Backbone.Collection.prototype.reset.call(this, models, options);
	        },
	
	        // ........................................................................ order
	        order: null,
	
	        /** @type {Object} map of collection available sorting orders containing comparator fns */
	        comparators: {
	            'update_time': BASE_MVC.buildComparator('update_time', { ascending: false }),
	            'update_time-asc': BASE_MVC.buildComparator('update_time', { ascending: true }),
	            'create_time': BASE_MVC.buildComparator('create_time', { ascending: false }),
	            'create_time-asc': BASE_MVC.buildComparator('create_time', { ascending: true })
	        },
	
	        /** set the order and comparator for this collection then sort with the new order
	         *  @event 'changed-order' passed the new order and the collection
	         */
	        setOrder: function (order, options) {
	            options = options || {};
	            var collection = this;
	            var comparator = collection.comparators[order];
	            if (_.isUndefined(comparator)) {
	                throw new Error('unknown order: ' + order);
	            }
	            // if( _.isUndefined( comparator ) ){ return; }
	            if (comparator === collection.comparator) {
	                return;
	            }
	
	            collection.order = order;
	            collection.comparator = comparator;
	
	            if (!options.silent) {
	                collection.trigger('changed-order', options);
	            }
	            return collection;
	        }
	
	    });
	
	    //=============================================================================
	    /**
	     *
	     */
	    var PaginatedCollection = ControlledFetchCollection.extend({
	
	        /** @type {Number} limit used for each page's fetch */
	        limitPerPage: 500,
	
	        initialize: function (models, options) {
	            ControlledFetchCollection.prototype.initialize.call(this, models, options);
	            this.currentPage = options.currentPage || 0;
	        },
	
	        getTotalItemCount: function () {
	            return this.length;
	        },
	
	        shouldPaginate: function () {
	            return this.getTotalItemCount() >= this.limitPerPage;
	        },
	
	        getLastPage: function () {
	            return Math.floor(this.getTotalItemCount() / this.limitPerPage);
	        },
	
	        getPageCount: function () {
	            return this.getLastPage() + 1;
	        },
	
	        getPageLimitOffset: function (pageNum) {
	            pageNum = this.constrainPageNum(pageNum);
	            return {
	                limit: this.limitPerPage,
	                offset: pageNum * this.limitPerPage
	            };
	        },
	
	        constrainPageNum: function (pageNum) {
	            return Math.max(0, Math.min(pageNum, this.getLastPage()));
	        },
	
	        /** fetch the next page of data */
	        fetchPage: function (pageNum, options) {
	            var self = this;
	            pageNum = self.constrainPageNum(pageNum);
	            self.currentPage = pageNum;
	            options = _.defaults(options || {}, self.getPageLimitOffset(pageNum));
	
	            self.trigger('fetching-more');
	            return self.fetch(options).always(function () {
	                self.trigger('fetching-more-done');
	            });
	        },
	
	        fetchCurrentPage: function (options) {
	            return this.fetchPage(this.currentPage, options);
	        },
	
	        fetchPrevPage: function (options) {
	            return this.fetchPage(this.currentPage - 1, options);
	        },
	
	        fetchNextPage: function (options) {
	            return this.fetchPage(this.currentPage + 1, options);
	        }
	    });
	
	    //=============================================================================
	    /**
	     * A Collection that will load more elements without reseting.
	     */
	    var InfinitelyScrollingCollection = ControlledFetchCollection.extend({
	
	        /** @type {Number} limit used for the first fetch (or a reset) */
	        limitOnFirstFetch: null,
	        /** @type {Number} limit used for each subsequent fetch */
	        limitPerFetch: 100,
	
	        initialize: function (models, options) {
	            ControlledFetchCollection.prototype.initialize.call(this, models, options);
	            /** @type {Integer} number of contents to return from the first fetch */
	            this.limitOnFirstFetch = options.limitOnFirstFetch || this.limitOnFirstFetch;
	            /** @type {Integer} limit for every fetch after the first */
	            this.limitPerFetch = options.limitPerFetch || this.limitPerFetch;
	            /** @type {Boolean} are all contents fetched? */
	            this.allFetched = false;
	            /** @type {Integer} what was the offset of the last content returned */
	            this.lastFetched = options.lastFetched || 0;
	        },
	
	        /** build ajax data/parameters from options */
	        _buildFetchOptions: function (options) {
	            // options (options for backbone.fetch and jquery.ajax generally)
	            // backbone option; false here to make fetching an addititive process
	            options.remove = options.remove || false;
	            return ControlledFetchCollection.prototype._buildFetchOptions.call(this, options);
	        },
	
	        /** fetch the first 'page' of data */
	        fetchFirst: function (options) {
	            Galaxy.debug('ControlledFetchCollection.fetchFirst:', options);
	            options = options ? _.clone(options) : {};
	            this.allFetched = false;
	            this.lastFetched = 0;
	            return this.fetchMore(_.defaults(options, {
	                reset: true,
	                limit: this.limitOnFirstFetch
	            }));
	        },
	
	        /** fetch the next page of data */
	        fetchMore: function (options) {
	            Galaxy.debug('ControlledFetchCollection.fetchMore:', options);
	            options = _.clone(options || {});
	            var collection = this;
	
	            Galaxy.debug('fetchMore, options.reset:', options.reset);
	            if (!options.reset && collection.allFetched) {
	                return jQuery.when();
	            }
	
	            // TODO: this fails in the edge case where
	            //  the first fetch offset === limit (limit 4, offset 4, collection.length 4)
	            if (options.reset) {
	                options.offset = 0;
	            } else if (options.offset === undefined) {
	                options.offset = collection.lastFetched;
	            }
	            var limit = options.limit = options.limit || collection.limitPerFetch || null;
	            Galaxy.debug('fetchMore, limit:', limit, 'offset:', options.offset);
	
	            collection.trigger('fetching-more');
	            return collection.fetch(options).always(function () {
	                collection.trigger('fetching-more-done');
	            })
	            // maintain allFetched flag and trigger if all were fetched this time
	            .done(function _postFetchMore(fetchedData) {
	                var numFetched = _.isArray(fetchedData) ? fetchedData.length : 0;
	                collection.lastFetched += numFetched;
	                Galaxy.debug('fetchMore, lastFetched:', collection.lastFetched);
	                // anything less than a full page means we got all there is to get
	                if (!limit || numFetched < limit) {
	                    collection.allFetched = true;
	                    collection.trigger('all-fetched', this);
	                }
	            });
	        },
	
	        /** fetch all the collection */
	        fetchAll: function (options) {
	            // whitelist options to prevent allowing limit/offset/filters
	            // (use vanilla fetch instead)
	            options = options || {};
	            var self = this;
	            options = _.pick(options, 'silent');
	            options.filters = {};
	            return self.fetch(options).done(function () {
	                self.allFetched = true;
	                self.trigger('all-fetched', self);
	            });
	        }
	    });
	
	    //==============================================================================
	    return {
	        ControlledFetchCollection: ControlledFetchCollection,
	        PaginatedCollection: PaginatedCollection,
	        InfinitelyScrollingCollection: InfinitelyScrollingCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /* For presentation-related functionality shared across collection creators.
	       Particularily overlapping functionality related to name processing and help.
	    */
	    var CollectionCreatorMixin = {
	
	        /** add (or clear if clear is truthy) a validation warning to the DOM element described in what */
	        _validationWarning: function (what, clear) {
	            var VALIDATION_CLASS = 'validation-warning';
	            if (what === 'name') {
	                what = this.$('.collection-name').add(this.$('.collection-name-prompt'));
	                this.$('.collection-name').focus().select();
	            }
	            if (clear) {
	                what = what || this.$('.' + VALIDATION_CLASS);
	                what.removeClass(VALIDATION_CLASS);
	            } else {
	                what.addClass(VALIDATION_CLASS);
	            }
	        },
	
	        _changeHideOriginals: function (ev) {
	            this.hideOriginals = this.$('.hide-originals').prop("checked");
	        },
	
	        // ........................................................................ footer
	        /** handle a collection name change */
	        _changeName: function (ev) {
	            this._validationWarning('name', !!this._getName());
	        },
	
	        /** check for enter key press when in the collection name and submit */
	        _nameCheckForEnter: function (ev) {
	            if (ev.keyCode === 13 && !this.blocking) {
	                this._clickCreate();
	            }
	        },
	
	        /** get the current collection name */
	        _getName: function () {
	            return _.escape(this.$('.collection-name').val());
	        },
	
	        // ........................................................................ header
	        /** expand help */
	        _clickMoreHelp: function (ev) {
	            ev.stopPropagation();
	            this.$('.main-help').addClass('expanded');
	            this.$('.more-help').hide();
	        },
	        /** collapse help */
	        _clickLessHelp: function (ev) {
	            ev.stopPropagation();
	            this.$('.main-help').removeClass('expanded');
	            this.$('.more-help').show();
	        },
	        /** toggle help */
	        _toggleHelp: function (ev) {
	            ev.stopPropagation();
	            this.$('.main-help').toggleClass('expanded');
	            this.$('.more-help').toggle();
	        },
	
	        /** show an alert on the top of the interface containing message (alertClass is bootstrap's alert-*) */
	        _showAlert: function (message, alertClass) {
	            alertClass = alertClass || 'alert-danger';
	            this.$('.main-help').hide();
	            this.$('.header .alert').attr('class', 'alert alert-dismissable').addClass(alertClass).show().find('.alert-message').html(message);
	        },
	        /** hide the alerts at the top */
	        _hideAlert: function (message) {
	            this.$('.main-help').show();
	            this.$('.header .alert').hide();
	        },
	
	        _cancelCreate: function (ev) {
	            if (typeof this.oncancel === 'function') {
	                this.oncancel.call(this);
	            }
	        },
	
	        /** attempt to create the current collection */
	        _clickCreate: function (ev) {
	            var name = this._getName();
	            if (!name) {
	                this._validationWarning('name');
	            } else if (!this.blocking) {
	                this.createList(name);
	            }
	        },
	
	        _setUpCommonSettings: function (attributes) {
	            this.hideOriginals = attributes.defaultHideSourceItems || false;
	        },
	
	        /** render the footer, completion controls, and cancel controls */
	        _renderFooter: function (speed, callback) {
	            var instance = this;
	            var $footer = this.$('.footer').empty().html(this.templates.footer());
	            _.each(this.footerSettings, function (property, selector) {
	                this.$(selector).prop('checked', instance[property]);
	            });
	            if (typeof this.oncancel === 'function') {
	                this.$('.cancel-create.btn').show();
	            }
	            return $footer;
	        },
	
	        _creatorTemplates: {
	            main: _.template(['<div class="header flex-row no-flex"></div>', '<div class="middle flex-row flex-row-container"></div>', '<div class="footer flex-row no-flex"></div>'].join(''))
	        }
	
	        //==============================================================================
	    };return {
	        CollectionCreatorMixin: CollectionCreatorMixin
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(91), __webpack_require__(59), __webpack_require__(58), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_VIEW, DC_MODEL, DC_LI, BASE_MVC, _l) {
	
	    'use strict';
	
	    var logNamespace = 'collections';
	    /* =============================================================================
	    TODO:
	    
	    ============================================================================= */
	    /** @class non-editable, read-only View/Controller for a dataset collection.
	     */
	    var _super = LIST_VIEW.ModelListPanel;
	    var CollectionView = _super.extend(
	    /** @lends CollectionView.prototype */{
	        //MODEL is either a DatasetCollection (or subclass) or a DatasetCollectionElement (list of pairs)
	        _logNamespace: logNamespace,
	
	        className: _super.prototype.className + ' dataset-collection-panel',
	
	        /** sub view class used for datasets */
	        DatasetDCEViewClass: DC_LI.DatasetDCEListItemView,
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_LI.NestedDCDCEListItemView,
	        /** key of attribute in model to assign to this.collection */
	        modelCollectionKey: 'elements',
	
	        // ......................................................................... SET UP
	        /** Set up the view, set up storage, bind listeners to HistoryContents events
	         *  @param {Object} attributes optional settings for the panel
	         */
	        initialize: function (attributes) {
	            _super.prototype.initialize.call(this, attributes);
	            this.linkTarget = attributes.linkTarget || '_blank';
	
	            this.hasUser = attributes.hasUser;
	            /** A stack of panels that currently cover or hide this panel */
	            this.panelStack = [];
	            /** The text of the link to go back to the panel containing this one */
	            this.parentName = attributes.parentName;
	            /** foldout or drilldown */
	            this.foldoutStyle = attributes.foldoutStyle || 'foldout';
	            this.downloadUrl = this.model.attributes.url + '/download';
	        },
	
	        _queueNewRender: function ($newRender, speed) {
	            speed = speed === undefined ? this.fxSpeed : speed;
	            var panel = this;
	            panel.log('_queueNewRender:', $newRender, speed);
	
	            // TODO: jquery@1.12 doesn't change display when the elem has display: flex
	            // this causes display: block for those elems after the use of show/hide animations
	            // animations are removed from this view for now until fixed
	            panel._swapNewRender($newRender);
	            panel.trigger('rendered', panel);
	        },
	
	        // ------------------------------------------------------------------------ sub-views
	        /** In this override, use model.getVisibleContents */
	        _filterCollection: function () {
	            //TODO: should *not* be model.getVisibleContents - visibility is not model related
	            return this.model.getVisibleContents();
	        },
	
	        /** override to return proper view class based on element_type */
	        _getItemViewClass: function (model) {
	            //this.debug( this + '._getItemViewClass:', model );
	            //TODO: subclasses use DCEViewClass - but are currently unused - decide
	            switch (model.get('element_type')) {
	                case 'hda':
	                    return this.DatasetDCEViewClass;
	                case 'dataset_collection':
	                    return this.NestedDCDCEViewClass;
	            }
	            throw new TypeError('Unknown element type:', model.get('element_type'));
	        },
	
	        /** override to add link target and anon */
	        _getItemViewOptions: function (model) {
	            var options = _super.prototype._getItemViewOptions.call(this, model);
	            return _.extend(options, {
	                linkTarget: this.linkTarget,
	                hasUser: this.hasUser,
	                //TODO: could move to only nested: list:paired
	                foldoutStyle: this.foldoutStyle
	            });
	        },
	
	        // ------------------------------------------------------------------------ collection sub-views
	        /** In this override, add/remove expanded/collapsed model ids to/from web storage */
	        _setUpItemViewListeners: function (view) {
	            var panel = this;
	            _super.prototype._setUpItemViewListeners.call(panel, view);
	
	            // use pub-sub to: handle drilldown expansion and collapse
	            panel.listenTo(view, {
	                'expanded:drilldown': function (v, drilldown) {
	                    this._expandDrilldownPanel(drilldown);
	                },
	                'collapsed:drilldown': function (v, drilldown) {
	                    this._collapseDrilldownPanel(drilldown);
	                }
	            });
	            return this;
	        },
	
	        /** Handle drill down by hiding this panels list and controls and showing the sub-panel */
	        _expandDrilldownPanel: function (drilldown) {
	            this.panelStack.push(drilldown);
	            // hide this panel's controls and list, set the name for back navigation, and attach to the $el
	            this.$('> .controls').add(this.$list()).hide();
	            drilldown.parentName = this.model.get('name');
	            this.$el.append(drilldown.render().$el);
	        },
	
	        /** Handle drilldown close by freeing the panel and re-rendering this panel */
	        _collapseDrilldownPanel: function (drilldown) {
	            this.panelStack.pop();
	            this.render();
	        },
	
	        // ------------------------------------------------------------------------ panel events
	        /** event map */
	        events: {
	            'click .navigation .back': 'close'
	        },
	
	        /** close/remove this collection panel */
	        close: function (event) {
	            this.remove();
	            this.trigger('close');
	        },
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'CollectionView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //------------------------------------------------------------------------------ TEMPLATES
	    CollectionView.prototype.templates = function () {
	
	        var controlsTemplate = BASE_MVC.wrapTemplate(['<div class="controls">', '<div class="navigation">', '<a class="back" href="javascript:void(0)">', '<span class="fa fa-icon fa-angle-left"></span>', _l('Back to '), '<%- view.parentName %>', '</a>', '</div>', '<div class="title">', '<div class="name"><%- collection.name || collection.element_identifier %></div>', '<div class="subtitle">', '<% if( collection.collection_type === "list" ){ %>', _l('a list of datasets'), '<% } else if( collection.collection_type === "paired" ){ %>', _l('a pair of datasets'), '<% } else if( collection.collection_type === "list:paired" ){ %>', _l('a list of paired datasets'), '<% } else if( collection.collection_type === "list:list" ){ %>', _l('a list of dataset lists'), '<% } %>', '</div>', '</div>', '<div class="tags-display"></div>', '<div class="actions">', '<a class="download-btn icon-btn" ', 'href="<%- view.downloadUrl %>', '" title="" download="" data-original-title="Download Collection">', '<span class="fa fa-floppy-o"></span>', '</a>', '</div>', '</div>'], 'collection');
	
	        return _.extend(_.clone(_super.prototype.templates), {
	            controls: controlsTemplate
	        });
	    }();
	
	    // =============================================================================
	    /** @class non-editable, read-only View/Controller for a dataset collection. */
	    var ListCollectionView = CollectionView.extend(
	    /** @lends ListCollectionView.prototype */{
	
	        //TODO: not strictly needed - due to switch in CollectionView._getContentClass
	        /** sub view class used for datasets */
	        DatasetDCEViewClass: DC_LI.DatasetDCEListItemView,
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'ListCollectionView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class non-editable, read-only View/Controller for a dataset collection. */
	    var PairCollectionView = ListCollectionView.extend(
	    /** @lends PairCollectionView.prototype */{
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'PairCollectionView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class non-editable, read-only View/Controller for a dataset collection. */
	    var ListOfPairsCollectionView = CollectionView.extend(
	    /** @lends ListOfPairsCollectionView.prototype */{
	
	        //TODO: not strictly needed - due to switch in CollectionView._getContentClass
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_LI.NestedDCDCEListItemView.extend({
	            foldoutPanelClass: PairCollectionView
	        }),
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'ListOfPairsCollectionView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class non-editable, read-only View/Controller for a list of lists dataset collection. */
	    var ListOfListsCollectionView = CollectionView.extend({
	
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_LI.NestedDCDCEListItemView.extend({
	            foldoutPanelClass: PairCollectionView
	        }),
	
	        /** string rep */
	        toString: function () {
	            return 'ListOfListsCollectionView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        CollectionView: CollectionView,
	        ListCollectionView: ListCollectionView,
	        PairCollectionView: PairCollectionView,
	        ListOfPairsCollectionView: ListOfPairsCollectionView,
	        ListOfListsCollectionView: ListOfListsCollectionView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(61), __webpack_require__(45), __webpack_require__(80), __webpack_require__(26), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (STATES, DATASET_LI, TAGS, ANNOTATIONS, faIconButton, BASE_MVC, _l) {
	
	    'use strict';
	    //==============================================================================
	
	    var _super = DATASET_LI.DatasetListItemView;
	    /** @class Editing view for DatasetAssociation.
	     */
	    var DatasetListItemEdit = _super.extend(
	    /** @lends DatasetListItemEdit.prototype */{
	
	        /** set up: options */
	        initialize: function (attributes) {
	            _super.prototype.initialize.call(this, attributes);
	            this.hasUser = attributes.hasUser;
	
	            /** allow user purge of dataset files? */
	            this.purgeAllowed = attributes.purgeAllowed || false;
	
	            //TODO: move to HiddenUntilActivatedViewMixin
	            /** should the tags editor be shown or hidden initially? */
	            this.tagsEditorShown = attributes.tagsEditorShown || false;
	            /** should the tags editor be shown or hidden initially? */
	            this.annotationEditorShown = attributes.annotationEditorShown || false;
	        },
	
	        // ......................................................................... titlebar actions
	        /** In this override, add the other two primary actions: edit and delete */
	        _renderPrimaryActions: function () {
	            var actions = _super.prototype._renderPrimaryActions.call(this);
	            if (this.model.get('state') === STATES.NOT_VIEWABLE) {
	                return actions;
	            }
	            // render the display, edit attr and delete icon-buttons
	            return _super.prototype._renderPrimaryActions.call(this).concat([this._renderEditButton(), this._renderDeleteButton()]);
	        },
	
	        //TODO: move titleButtons into state renderers, remove state checks in the buttons
	
	        /** Render icon-button to edit the attributes (format, permissions, etc.) this dataset. */
	        _renderEditButton: function () {
	            var self = this;
	            // don't show edit while uploading, in-accessible
	            // DO show if in error (ala previous history panel)
	            if (this.model.get('state') === STATES.DISCARDED || !this.model.get('accessible')) {
	                return null;
	            }
	            var purged = this.model.get('purged'),
	                deleted = this.model.get('deleted'),
	                editBtnData = {
	                title: _l('Edit attributes'),
	                href: Galaxy.root + 'datasets/edit?dataset_id=' + this.model.attributes.id,
	                faIcon: 'fa-pencil',
	                classes: 'edit-btn',
	                onclick: function (ev) {
	                    if (Galaxy.router) {
	                        ev.preventDefault();
	                        Galaxy.router.push('datasets/edit', { dataset_id: self.model.attributes.id });
	                    }
	                }
	            };
	            // disable if purged or deleted and explain why in the tooltip
	            if (deleted || purged) {
	                editBtnData.disabled = true;
	                if (purged) {
	                    editBtnData.title = _l('Cannot edit attributes of datasets removed from disk');
	                } else if (deleted) {
	                    editBtnData.title = _l('Undelete dataset to edit attributes');
	                }
	
	                // disable if still uploading or new
	            } else if (_.contains([STATES.UPLOAD, STATES.NEW], this.model.get('state'))) {
	                editBtnData.disabled = true;
	                editBtnData.title = _l('This dataset is not yet editable');
	            }
	            return faIconButton(editBtnData);
	        },
	
	        /** Render icon-button to delete this hda. */
	        _renderDeleteButton: function () {
	            // don't show delete if...
	            if (!this.model.get('accessible')) {
	                return null;
	            }
	
	            var self = this,
	                deletedAlready = this.model.isDeletedOrPurged();
	            return faIconButton({
	                title: !deletedAlready ? _l('Delete') : _l('Dataset is already deleted'),
	                disabled: deletedAlready,
	                faIcon: 'fa-times',
	                classes: 'delete-btn',
	                onclick: function () {
	                    // ...bler... tooltips being left behind in DOM (hover out never called on deletion)
	                    self.$el.find('.icon-btn.delete-btn').trigger('mouseout');
	                    self.model['delete']();
	                }
	            });
	        },
	
	        // ......................................................................... details
	        /** In this override, add tags and annotations controls, make the ? dbkey a link to editing page */
	        _renderDetails: function () {
	            //TODO: generalize to be allow different details for each state
	            var $details = _super.prototype._renderDetails.call(this),
	                state = this.model.get('state');
	
	            if (!this.model.isDeletedOrPurged() && _.contains([STATES.OK, STATES.FAILED_METADATA], state)) {
	                this._renderTags($details);
	                this._renderAnnotation($details);
	                this._makeDbkeyEditLink($details);
	            }
	
	            this._setUpBehaviors($details);
	            return $details;
	        },
	
	        /**************************************************************************
	         * Render help button to show tool help text without rerunning the tool.
	         * Issue #2100
	         */
	        _renderToolHelpButton: function () {
	            var datasetID = this.model.attributes.dataset_id;
	            var jobID = this.model.attributes.creating_job;
	            var self = this;
	
	            var parseToolBuild = function (data) {
	                var helpString = '<div id="thdiv-' + datasetID + '" class="toolhelp">';
	                if (data.name && data.help) {
	                    helpString += '<strong>Tool help for ' + data.name + '</strong><hr/>';
	                    helpString += data.help;
	                } else {
	                    helpString += '<strong>Tool help is unavailable for this dataset.</strong><hr/>';
	                }
	                helpString += '</div>';
	                self.$el.find('.details').append($.parseHTML(helpString));
	            };
	            var parseToolID = function (data) {
	                $.ajax({
	                    url: Galaxy.root + 'api/tools/' + data.tool_id + '/build'
	                }).done(function (data) {
	                    parseToolBuild(data);
	                }).fail(function () {
	                    parseToolBuild({});
	                });
	            };
	            if (Galaxy.user.id === null) {
	                return null;
	            }
	            return faIconButton({
	                title: _l('Tool Help'),
	                classes: 'icon-btn',
	                href: '#',
	                faIcon: 'fa-question',
	                onclick: function () {
	                    var divString = 'thdiv-' + datasetID;
	                    if (self.$el.find(".toolhelp").length > 0) {
	                        self.$el.find(".toolhelp").toggle();
	                    } else {
	                        $.ajax({
	                            url: Galaxy.root + 'api/jobs/' + jobID
	                        }).done(function (data) {
	                            parseToolID(data);
	                        }).fail(function () {
	                            console.log('Failed at recovering job information from the  Galaxy API for job id "' + jobID + '".');
	                        });
	                    }
	                }
	            });
	        },
	        //*************************************************************************
	
	        /** Add less commonly used actions in the details section based on state */
	        _renderSecondaryActions: function () {
	            var actions = _super.prototype._renderSecondaryActions.call(this);
	            switch (this.model.get('state')) {
	                case STATES.UPLOAD:
	                case STATES.NOT_VIEWABLE:
	                    return actions;
	                case STATES.ERROR:
	                    // error button comes first
	                    actions.unshift(this._renderErrButton());
	                    return actions.concat([this._renderRerunButton(), this._renderToolHelpButton()]);
	                case STATES.OK:
	                case STATES.FAILED_METADATA:
	                    return actions.concat([this._renderRerunButton(), this._renderVisualizationsButton(), this._renderToolHelpButton()]);
	            }
	            return actions.concat([this._renderRerunButton(), this._renderToolHelpButton()]);
	        },
	
	        /** Render icon-button to report an error on this dataset to the galaxy admin. */
	        _renderErrButton: function () {
	            var self = this;
	            return faIconButton({
	                title: _l('View or report this error'),
	                href: Galaxy.root + 'datasets/error?dataset_id=' + this.model.attributes.id,
	                classes: 'report-error-btn',
	                faIcon: 'fa-bug',
	                onclick: function (ev) {
	                    if (Galaxy.router) {
	                        ev.preventDefault();
	                        Galaxy.router.push('datasets/error', { dataset_id: self.model.attributes.id });
	                    }
	                }
	            });
	        },
	
	        /** Render icon-button to re-run the job that created this dataset. */
	        _renderRerunButton: function () {
	            var creating_job = this.model.get('creating_job');
	            var rerun_url = this.model.urls.rerun;
	            if (this.model.get('rerunnable')) {
	                return faIconButton({
	                    title: _l('Run this job again'),
	                    href: this.model.urls.rerun,
	                    classes: 'rerun-btn',
	                    target: this.linkTarget,
	                    faIcon: 'fa-refresh',
	                    onclick: function (ev) {
	                        if (Galaxy.router) {
	                            ev.preventDefault();
	                            Galaxy.router.push('/', { job_id: creating_job });
	                        }
	                    }
	                });
	            }
	        },
	
	        /** Render an icon-button or popupmenu of links based on the applicable visualizations */
	        _renderVisualizationsButton: function () {
	            //TODO: someday - lazyload visualizations
	            var visualizations = this.model.get('visualizations');
	            if (this.model.isDeletedOrPurged() || !this.hasUser || !this.model.hasData() || _.isEmpty(visualizations)) {
	                return null;
	            }
	            if (!_.isObject(visualizations[0])) {
	                this.warn('Visualizations have been switched off');
	                return null;
	            }
	
	            var $visualizations = $(this.templates.visualizations(visualizations, this));
	            //HACK: need to re-write those directed at galaxy_main with linkTarget
	            $visualizations.find('[target="galaxy_main"]').attr('target', this.linkTarget);
	            // use addBack here to include the root $visualizations elem (for the case of 1 visualization)
	            this._addScratchBookFn($visualizations.find('.visualization-link').addBack('.visualization-link'));
	            return $visualizations;
	        },
	
	        /** add scratchbook functionality to visualization links */
	        _addScratchBookFn: function ($links) {
	            var li = this;
	            $links.click(function (ev) {
	                if (Galaxy.frame && Galaxy.frame.active) {
	                    Galaxy.frame.add({
	                        title: 'Visualization',
	                        url: $(this).attr('href')
	                    });
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            });
	        },
	
	        //TODO: if possible move these to readonly view - but display the owner's tags/annotation (no edit)
	        /** Render the tags list/control */
	        _renderTags: function ($where) {
	            if (!this.hasUser) {
	                return;
	            }
	            var view = this;
	            this.tagsEditor = new TAGS.TagsEditor({
	                model: this.model,
	                el: $where.find('.tags-display'),
	                onshowFirstTime: function () {
	                    this.render();
	                },
	                // persist state on the hda view (and not the editor) since these are currently re-created each time
	                onshow: function () {
	                    view.tagsEditorShown = true;
	                },
	                onhide: function () {
	                    view.tagsEditorShown = false;
	                },
	                $activator: faIconButton({
	                    title: _l('Edit dataset tags'),
	                    classes: 'tag-btn',
	                    faIcon: 'fa-tags'
	                }).appendTo($where.find('.actions .right'))
	            });
	            if (this.tagsEditorShown) {
	                this.tagsEditor.toggle(true);
	            }
	        },
	
	        /** Render the annotation display/control */
	        _renderAnnotation: function ($where) {
	            if (!this.hasUser) {
	                return;
	            }
	            var view = this;
	            this.annotationEditor = new ANNOTATIONS.AnnotationEditor({
	                model: this.model,
	                el: $where.find('.annotation-display'),
	                onshowFirstTime: function () {
	                    this.render();
	                },
	                // persist state on the hda view (and not the editor) since these are currently re-created each time
	                onshow: function () {
	                    view.annotationEditorShown = true;
	                },
	                onhide: function () {
	                    view.annotationEditorShown = false;
	                },
	                $activator: faIconButton({
	                    title: _l('Edit dataset annotation'),
	                    classes: 'annotate-btn',
	                    faIcon: 'fa-comment'
	                }).appendTo($where.find('.actions .right'))
	            });
	            if (this.annotationEditorShown) {
	                this.annotationEditor.toggle(true);
	            }
	        },
	
	        /** If the format/dbkey/genome_build isn't set, make the display a link to the edit page */
	        _makeDbkeyEditLink: function ($details) {
	            // make the dbkey a link to editing
	            if (this.model.get('metadata_dbkey') === '?' && !this.model.isDeletedOrPurged()) {
	                var editableDbkey = $('<a class="value">?</a>').attr('href', this.model.urls.edit).attr('target', this.linkTarget);
	                $details.find('.dbkey .value').replaceWith(editableDbkey);
	            }
	        },
	
	        // ......................................................................... events
	        /** event map */
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .undelete-link': '_clickUndeleteLink',
	            'click .purge-link': '_clickPurgeLink',
	
	            'click .edit-btn': function (ev) {
	                this.trigger('edit', this, ev);
	            },
	            'click .delete-btn': function (ev) {
	                this.trigger('delete', this, ev);
	            },
	            'click .rerun-btn': function (ev) {
	                this.trigger('rerun', this, ev);
	            },
	            'click .report-err-btn': function (ev) {
	                this.trigger('report-err', this, ev);
	            },
	            'click .visualization-btn': function (ev) {
	                this.trigger('visualize', this, ev);
	            },
	            'click .dbkey a': function (ev) {
	                this.trigger('edit', this, ev);
	            }
	        }),
	
	        /** listener for item undelete (in the messages section) */
	        _clickUndeleteLink: function (ev) {
	            this.model.undelete();
	            return false;
	        },
	
	        /** listener for item purge (in the messages section) */
	        _clickPurgeLink: function (ev) {
	            if (confirm(_l('This will permanently remove the data in your dataset. Are you sure?'))) {
	                this.model.purge();
	            }
	            return false;
	        },
	
	        // ......................................................................... misc
	        /** string rep */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'HDAEditView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DatasetListItemEdit.prototype.templates = function () {
	
	        var warnings = _.extend({}, _super.prototype.templates.warnings, {
	            failed_metadata: BASE_MVC.wrapTemplate([
	            // in this override, provide a link to the edit page
	            '<% if( dataset.state === "failed_metadata" ){ %>', '<div class="failed_metadata-warning warningmessagesmall">', _l('An error occurred setting the metadata for this dataset'), '<br /><a href="<%- dataset.urls.edit %>" target="<%- view.linkTarget %>">', _l('Set it manually or retry auto-detection'), '</a>', '</div>', '<% } %>'], 'dataset'),
	
	            deleted: BASE_MVC.wrapTemplate([
	            // in this override, provide links to undelete or purge the dataset
	            '<% if( dataset.deleted && !dataset.purged ){ %>',
	            // deleted not purged
	            '<div class="deleted-msg warningmessagesmall">', _l('This dataset has been deleted'), '<br /><a class="undelete-link" href="javascript:void(0);">', _l('Undelete it'), '</a>', '<% if( view.purgeAllowed ){ %>', '<br /><a class="purge-link" href="javascript:void(0);">', _l('Permanently remove it from disk'), '</a>', '<% } %>', '</div>', '<% } %>'], 'dataset')
	        });
	
	        var visualizationsTemplate = BASE_MVC.wrapTemplate(['<% if( visualizations.length === 1 ){ %>', '<a class="visualization-link icon-btn" href="<%- visualizations[0].href %>"', ' target="<%- visualizations[0].target %>" title="', _l('Visualize in'), ' <%- visualizations[0].html %>">', '<span class="fa fa-bar-chart-o"></span>', '</a>', '<% } else { %>', '<div class="visualizations-dropdown dropdown icon-btn">', '<a data-toggle="dropdown" title="', _l('Visualize'), '">', '<span class="fa fa-bar-chart-o"></span>', '</a>', '<ul class="dropdown-menu" role="menu">', '<% _.each( visualizations, function( visualization ){ %>', '<li><a class="visualization-link" href="<%- visualization.href %>"', ' target="<%- visualization.target %>">', '<%- visualization.html %>', '</a></li>', '<% }); %>', '</ul>', '</div>', '<% } %>'], 'visualizations');
	
	        return _.extend({}, _super.prototype.templates, {
	            warnings: warnings,
	            visualizations: visualizationsTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        DatasetListItemEdit: DatasetListItemEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (STATES, BASE_MVC, _l) {
	    'use strict';
	
	    var logNamespace = 'dataset';
	    //==============================================================================
	    var searchableMixin = BASE_MVC.SearchableModelMixin;
	    /** @class base model for any DatasetAssociation (HDAs, LDDAs, DatasetCollectionDAs).
	     *      No knowledge of what type (HDA/LDDA/DCDA) should be needed here.
	     *  The DA's are made searchable (by attribute) by mixing in SearchableModelMixin.
	     */
	    var DatasetAssociation = Backbone.Model.extend(BASE_MVC.LoggableMixin).extend(BASE_MVC.mixin(searchableMixin, /** @lends DatasetAssociation.prototype */{
	        _logNamespace: logNamespace,
	
	        /** default attributes for a model */
	        defaults: {
	            state: STATES.NEW,
	            deleted: false,
	            purged: false,
	            name: '(unnamed dataset)',
	            accessible: true,
	            // sniffed datatype (sam, tabular, bed, etc.)
	            data_type: '',
	            file_ext: '',
	            file_size: 0,
	
	            // array of associated file types (eg. [ 'bam_index', ... ])
	            meta_files: [],
	
	            misc_blurb: '',
	            misc_info: '',
	
	            tags: []
	            // do NOT default on annotation, as this default is valid and will be passed on 'save'
	            //  which is incorrect behavior when the model is only partially fetched (annos are not passed in summary data)
	            //annotation          : ''
	        },
	
	        /** instance vars and listeners */
	        initialize: function (attributes, options) {
	            this.debug(this + '(Dataset).initialize', attributes, options);
	
	            //!! this state is not in trans.app.model.Dataset.states - set it here -
	            if (!this.get('accessible')) {
	                this.set('state', STATES.NOT_VIEWABLE);
	            }
	
	            /** Datasets rely/use some web controllers - have the model generate those URLs on startup */
	            this.urls = this._generateUrls();
	
	            this._setUpListeners();
	        },
	
	        /** returns misc. web urls for rendering things like re-run, display, etc. */
	        _generateUrls: function () {
	            var id = this.get('id');
	            if (!id) {
	                return {};
	            }
	            var urls = {
	                'purge': 'datasets/' + id + '/purge_async',
	                'display': 'datasets/' + id + '/display/?preview=True',
	                'edit': 'datasets/edit?dataset_id=' + id,
	                'download': 'datasets/' + id + '/display' + this._downloadQueryParameters(),
	                'report_error': 'dataset/errors?id=' + id,
	                'rerun': 'tool_runner/rerun?id=' + id,
	                'show_params': 'datasets/' + id + '/show_params',
	                'visualization': 'visualization',
	                'meta_download': 'dataset/get_metadata_file?hda_id=' + id + '&metadata_name='
	            };
	            _.each(urls, function (value, key) {
	                urls[key] = Galaxy.root + value;
	            });
	            this.urls = urls;
	            return urls;
	        },
	
	        _downloadQueryParameters: function () {
	            return '?to_ext=' + this.get('file_ext');
	        },
	
	        /** set up any event listeners
	         *  event: state:ready  fired when this DA moves into/is already in a ready state
	         */
	        _setUpListeners: function () {
	            // if the state has changed and the new state is a ready state, fire an event
	            this.on('change:state', function (currModel, newState) {
	                this.log(this + ' has changed state:', currModel, newState);
	                if (this.inReadyState()) {
	                    this.trigger('state:ready', currModel, newState, this.previous('state'));
	                }
	            });
	            // the download url (currently) relies on having a correct file extension
	            this.on('change:id change:file_ext', function (currModel) {
	                this._generateUrls();
	            });
	        },
	
	        // ........................................................................ common queries
	        /** override to add urls */
	        toJSON: function () {
	            var json = Backbone.Model.prototype.toJSON.call(this);
	            //console.warn( 'returning json?' );
	            //return json;
	            return _.extend(json, {
	                urls: this.urls
	            });
	        },
	
	        /** Is this dataset deleted or purged? */
	        isDeletedOrPurged: function () {
	            return this.get('deleted') || this.get('purged');
	        },
	
	        /** Is this dataset in a 'ready' state; where 'Ready' states are states where no
	         *      processing (for the ds) is left to do on the server.
	         */
	        inReadyState: function () {
	            var ready = _.contains(STATES.READY_STATES, this.get('state'));
	            return this.isDeletedOrPurged() || ready;
	        },
	
	        /** Does this model already contain detailed data (as opposed to just summary level data)? */
	        hasDetails: function () {
	            // if it's inaccessible assume it has everything it needs
	            if (!this.get('accessible')) {
	                return true;
	            }
	            return this.has('annotation');
	        },
	
	        /** Convenience function to match dataset.has_data. */
	        hasData: function () {
	            return this.get('file_size') > 0;
	        },
	
	        // ........................................................................ ajax
	        fetch: function (options) {
	            var dataset = this;
	            return Backbone.Model.prototype.fetch.call(this, options).always(function () {
	                dataset._generateUrls();
	            });
	        },
	
	        /** override to use actual Dates objects for create/update times */
	        parse: function (response, options) {
	            var parsed = Backbone.Model.prototype.parse.call(this, response, options);
	            if (parsed.create_time) {
	                parsed.create_time = new Date(parsed.create_time);
	            }
	            if (parsed.update_time) {
	                parsed.update_time = new Date(parsed.update_time);
	            }
	            return parsed;
	        },
	
	        /** override to wait by default */
	        save: function (attrs, options) {
	            options = options || {};
	            options.wait = _.isUndefined(options.wait) ? true : options.wait;
	            return Backbone.Model.prototype.save.call(this, attrs, options);
	        },
	
	        //NOTE: subclasses of DA's will need to implement url and urlRoot in order to have these work properly
	        /** save this dataset, _Mark_ing it as deleted (just a flag) */
	        'delete': function (options) {
	            if (this.get('deleted')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: true }, options);
	        },
	        /** save this dataset, _Mark_ing it as undeleted */
	        undelete: function (options) {
	            if (!this.get('deleted') || this.get('purged')) {
	                return jQuery.when();
	            }
	            return this.save({ deleted: false }, options);
	        },
	
	        /** remove the file behind this dataset from the filesystem (if permitted) */
	        purge: function _purge(options) {
	            //TODO: use, override model.destroy, HDA.delete({ purge: true })
	            if (this.get('purged')) {
	                return jQuery.when();
	            }
	            options = options || {};
	            options.url = this.urls.purge;
	
	            //TODO: ideally this would be a DELETE call to the api
	            //  using purge async for now
	            var hda = this,
	                xhr = jQuery.ajax(options);
	            xhr.done(function (message, status, responseObj) {
	                hda.set({ deleted: true, purged: true });
	            });
	            xhr.fail(function (xhr, status, message) {
	                // Exception messages are hidden within error page including:  '...not allowed in this Galaxy instance.'
	                // unbury and re-add to xhr
	                var error = _l("Unable to purge dataset");
	                var messageBuriedInUnfortunatelyFormattedError = 'Removal of datasets by users ' + 'is not allowed in this Galaxy instance';
	                if (xhr.responseJSON && xhr.responseJSON.error) {
	                    error = xhr.responseJSON.error;
	                } else if (xhr.responseText.indexOf(messageBuriedInUnfortunatelyFormattedError) !== -1) {
	                    error = messageBuriedInUnfortunatelyFormattedError;
	                }
	                xhr.responseText = error;
	                hda.trigger('error', hda, xhr, options, _l(error), { error: error });
	            });
	            return xhr;
	        },
	
	        // ........................................................................ searching
	        /** what attributes of an HDA will be used in a text search */
	        searchAttributes: ['name', 'file_ext', 'genome_build', 'misc_blurb', 'misc_info', 'annotation', 'tags'],
	
	        /** our attr keys don't often match the labels we display to the user - so, when using
	         *      attribute specifiers ('name="bler"') in a term, allow passing in aliases for the
	         *      following attr keys.
	         */
	        searchAliases: {
	            title: 'name',
	            format: 'file_ext',
	            database: 'genome_build',
	            blurb: 'misc_blurb',
	            description: 'misc_blurb',
	            info: 'misc_info',
	            tag: 'tags'
	        },
	
	        // ........................................................................ misc
	        /** String representation */
	        toString: function () {
	            var nameAndId = this.get('id') || '';
	            if (this.get('name')) {
	                nameAndId = '"' + this.get('name') + '",' + nameAndId;
	            }
	            return 'Dataset(' + nameAndId + ')';
	        }
	    }));
	
	    //==============================================================================
	    /** @class Backbone collection for dataset associations.
	     */
	    var DatasetAssociationCollection = Backbone.Collection.extend(BASE_MVC.LoggableMixin).extend(
	    /** @lends HistoryContents.prototype */{
	        _logNamespace: logNamespace,
	
	        model: DatasetAssociation,
	
	        /** root api url */
	        urlRoot: Galaxy.root + 'api/datasets',
	
	        /** url fn */
	        url: function () {
	            return this.urlRoot;
	        },
	
	        // ........................................................................ common queries
	        /** Get the ids of every item in this collection
	         *  @returns array of encoded ids
	         */
	        ids: function () {
	            return this.map(function (item) {
	                return item.get('id');
	            });
	        },
	
	        /** Get contents that are not ready
	         *  @returns array of content models
	         */
	        notReady: function () {
	            return this.filter(function (content) {
	                return !content.inReadyState();
	            });
	        },
	
	        /** return true if any datasets don't have details */
	        haveDetails: function () {
	            return this.all(function (dataset) {
	                return dataset.hasDetails();
	            });
	        },
	
	        // ........................................................................ ajax
	        /** using a queue, perform ajaxFn on each of the models in this collection */
	        ajaxQueue: function (ajaxFn, options) {
	            var deferred = jQuery.Deferred(),
	                startingLength = this.length,
	                responses = [];
	
	            if (!startingLength) {
	                deferred.resolve([]);
	                return deferred;
	            }
	
	            // use reverse order (stylistic choice)
	            var ajaxFns = this.chain().reverse().map(function (dataset, i) {
	                return function () {
	                    var xhr = ajaxFn.call(dataset, options);
	                    // if successful, notify using the deferred to allow tracking progress
	                    xhr.done(function (response) {
	                        deferred.notify({ curr: i, total: startingLength, response: response, model: dataset });
	                    });
	                    // (regardless of previous error or success) if not last ajax call, shift and call the next
	                    //  if last fn, resolve deferred
	                    xhr.always(function (response) {
	                        responses.push(response);
	                        if (ajaxFns.length) {
	                            ajaxFns.shift()();
	                        } else {
	                            deferred.resolve(responses);
	                        }
	                    });
	                };
	            }).value();
	            // start the queue
	            ajaxFns.shift()();
	
	            return deferred;
	        },
	
	        // ........................................................................ sorting/filtering
	        /** return a new collection of datasets whose attributes contain the substring matchesWhat */
	        matches: function (matchesWhat) {
	            return this.filter(function (dataset) {
	                return dataset.matches(matchesWhat);
	            });
	        },
	
	        /** String representation. */
	        toString: function () {
	            return ['DatasetAssociationCollection(', this.length, ')'].join('');
	        }
	    });
	
	    //==============================================================================
	    return {
	        DatasetAssociation: DatasetAssociation,
	        DatasetAssociationCollection: DatasetAssociationCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, jQuery, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(94), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (MODAL, ERROR_MODAL, _l) {
	
	    'use strict';
	
	    //==============================================================================
	    /**
	     * A dialog/modal that allows copying a user history or 'importing' from user
	     * another. Generally called via historyCopyDialog below.
	     * @type {Object}
	     */
	
	    var CopyDialog = {
	
	        // language related strings/fns
	        defaultName: _.template("Copy of '<%- name %>'"),
	        title: _.template(_l('Copying history') + ' "<%- name %>"'),
	        submitLabel: _l('Copy'),
	        errorMessage: _l('History could not be copied.'),
	        progressive: _l('Copying history'),
	        activeLabel: _l('Copy only the active, non-deleted datasets'),
	        allLabel: _l('Copy all datasets including deleted ones'),
	        anonWarning: _l('As an anonymous user, unless you login or register, you will lose your current history ') + _l('after copying this history. '),
	
	        // template for modal body
	        _template: _.template([
	        //TODO: remove inline styles
	        // show a warning message for losing current to anon users
	        '<% if( isAnon ){ %>', '<div class="warningmessage">', '<%- anonWarning %>', _l('You can'), ' <a href="/user/login">', _l('login here'), '</a> ', _l('or'), ' ', ' <a href="/user/create">', _l('register here'), '</a>.', '</div>', '<% } %>', '<form>', '<label for="copy-modal-title">', _l('Enter a title for the new history'), ':', '</label><br />',
	        // TODO: could use required here and the form validators
	        // NOTE: use unescaped here if escaped in the modal function below
	        '<input id="copy-modal-title" class="form-control" style="width: 100%" value="<%= name %>" />', '<p class="invalid-title bg-danger" style="color: red; margin: 8px 0px 8px 0px; display: none">', _l('Please enter a valid history title'), '</p>',
	        // if allowAll, add the option to copy deleted datasets, too
	        '<% if( allowAll ){ %>', '<br />', '<p>', _l('Choose which datasets from the original history to include:'), '</p>',
	        // copy non-deleted is the default
	        '<input name="copy-what" type="radio" id="copy-non-deleted" value="copy-non-deleted" ', '<% if( copyWhat === "copy-non-deleted" ){ print( "checked" ); } %>/>', '<label for="copy-non-deleted"> <%- activeLabel %></label>', '<br />', '<input name="copy-what" type="radio" id="copy-all" value="copy-all" ', '<% if( copyWhat === "copy-all" ){ print( "checked" ); } %>/>', '<label for="copy-all"> <%- allLabel %></label>', '<% } %>', '</form>'].join('')),
	
	        // empty modal body and let the user know the copy is happening
	        _showAjaxIndicator: function _showAjaxIndicator() {
	            var indicator = '<p><span class="fa fa-spinner fa-spin"></span> ' + this.progressive + '...</p>';
	            this.modal.$('.modal-body').empty().append(indicator).css({ 'margin-top': '8px' });
	        },
	
	        // (sorta) public interface - display the modal, render the form, and potentially copy the history
	        // returns a jQuery.Deferred done->history copied, fail->user cancelled
	        dialog: function _dialog(modal, history, options) {
	            options = options || {};
	
	            var dialog = this,
	                deferred = jQuery.Deferred(),
	
	            // TODO: getting a little byzantine here
	            defaultCopyNameFn = options.nameFn || this.defaultName,
	                defaultCopyName = defaultCopyNameFn({ name: history.get('name') }),
	
	            // TODO: these two might be simpler as one 3 state option (all,active,no-choice)
	            defaultCopyWhat = options.allDatasets ? 'copy-all' : 'copy-non-deleted',
	                allowAll = !_.isUndefined(options.allowAll) ? options.allowAll : true,
	                autoClose = !_.isUndefined(options.autoClose) ? options.autoClose : true;
	
	            this.modal = modal;
	
	            // validate the name and copy if good
	            function checkNameAndCopy() {
	                var name = modal.$('#copy-modal-title').val();
	                if (!name) {
	                    modal.$('.invalid-title').show();
	                    return;
	                }
	                // get further settings, shut down and indicate the ajax call, then hide and resolve/reject
	                var copyAllDatasets = modal.$('input[name="copy-what"]:checked').val() === 'copy-all';
	                modal.$('button').prop('disabled', true);
	                dialog._showAjaxIndicator();
	                history.copy(true, name, copyAllDatasets).done(function (response) {
	                    deferred.resolve(response);
	                }).fail(function (xhr, status, message) {
	                    var options = { name: name, copyAllDatasets: copyAllDatasets };
	                    ERROR_MODAL.ajaxErrorModal(history, xhr, options, dialog.errorMessage);
	                    deferred.rejectWith(deferred, arguments);
	                }).done(function () {
	                    if (autoClose) {
	                        modal.hide();
	                    }
	                });
	            }
	
	            var originalClosingCallback = options.closing_callback;
	            modal.show(_.extend(options, {
	                title: this.title({ name: history.get('name') }),
	                body: $(dialog._template({
	                    name: defaultCopyName,
	                    isAnon: Galaxy.user.isAnonymous(),
	                    allowAll: allowAll,
	                    copyWhat: defaultCopyWhat,
	                    activeLabel: this.activeLabel,
	                    allLabel: this.allLabel,
	                    anonWarning: this.anonWarning
	                })),
	                buttons: _.object([[_l('Cancel'), function () {
	                    modal.hide();
	                }], [this.submitLabel, checkNameAndCopy]]),
	                height: 'auto',
	                closing_events: true,
	                closing_callback: function _historyCopyClose(cancelled) {
	                    if (cancelled) {
	                        deferred.reject({ cancelled: true });
	                    }
	                    if (originalClosingCallback) {
	                        originalClosingCallback(cancelled);
	                    }
	                }
	            }));
	
	            // set the default dataset copy, autofocus the title, and set up for a simple return
	            modal.$('#copy-modal-title').focus().select();
	            modal.$('#copy-modal-title').on('keydown', function (ev) {
	                if (ev.keyCode === 13) {
	                    ev.preventDefault();
	                    checkNameAndCopy();
	                }
	            });
	
	            return deferred;
	        }
	    };
	
	    //==============================================================================
	    // maintain the (slight) distinction between copy and import
	    /**
	     * Subclass CopyDialog to use the import language.
	     */
	    var ImportDialog = _.extend({}, CopyDialog, {
	        defaultName: _.template("imported: <%- name %>"),
	        title: _.template(_l('Importing history') + ' "<%- name %>"'),
	        submitLabel: _l('Import'),
	        errorMessage: _l('History could not be imported.'),
	        progressive: _l('Importing history'),
	        activeLabel: _l('Import only the active, non-deleted datasets'),
	        allLabel: _l('Import all datasets including deleted ones'),
	        anonWarning: _l('As an anonymous user, unless you login or register, you will lose your current history ') + _l('after importing this history. ')
	
	    });
	
	    //==============================================================================
	    /**
	     * Main interface for both history import and history copy dialogs.
	     * @param  {Backbone.Model} history     the history to copy
	     * @param  {Object}         options     a hash
	     * @return {jQuery.Deferred}            promise that fails on close and succeeds on copy
	     *
	     * options:
	     *     (this object is also passed to the modal used to display the dialog and accepts modal options)
	     *     {Function} nameFn    if defined, use this to build the default name shown to the user
	     *                          (the fn is passed: {name: <original history's name>})
	     *     {bool} useImport     if true, use the 'import' language (instead of Copy)
	     *     {bool} allowAll      if true, allow the user to choose between copying all datasets and
	     *                          only non-deleted datasets
	     *     {String} allDatasets default initial checked radio button: 'copy-all' or 'copy-non-deleted',
	     */
	    var historyCopyDialog = function (history, options) {
	        options = options || {};
	        // create our own modal if Galaxy doesn't have one (mako tab without use_panels)
	        var modal = window.parent.Galaxy.modal || new MODAL.View({});
	        return options.useImport ? ImportDialog.dialog(modal, history, options) : CopyDialog.dialog(modal, history, options);
	    };
	
	    //==============================================================================
	    return historyCopyDialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(61), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DATASET_LI, BASE_MVC, _l) {
	
	    'use strict';
	
	    //==============================================================================
	
	    var _super = DATASET_LI.DatasetListItemView;
	    /** @class Read only view for HistoryDatasetAssociation.
	     *      Since there are no controls on the HDAView to hide the dataset,
	     *      the primary thing this class does (currently) is override templates
	     *      to render the HID.
	     */
	    var HDAListItemView = _super.extend(
	    /** @lends HDAListItemView.prototype */{
	
	        className: _super.prototype.className + " history-content",
	
	        initialize: function (attributes, options) {
	            _super.prototype.initialize.call(this, attributes, options);
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'HDAListItemView(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    HDAListItemView.prototype.templates = function () {
	
	        var titleBarTemplate = BASE_MVC.wrapTemplate([
	        // adding the hid display to the title
	        '<div class="title-bar clear" tabindex="0">', '<span class="state-icon"></span>', '<div class="title">',
	        //TODO: remove whitespace and use margin-right
	        '<span class="hid"><%- dataset.hid %></span> ', '<span class="name"><%- dataset.name %></span>', '</div>', '</br>', '<span class="nametags">', '<% _.each(_.sortBy(_.uniq(dataset.tags), function(x) { return x }), function(tag){ %>', '<% if (tag.indexOf("name:") == 0){ %>', '<span class="label label-info"><%- tag.slice(5) %></span>', '<% } %>', '<% }); %>', '</span>', '</div>'], 'dataset');
	
	        var warnings = _.extend({}, _super.prototype.templates.warnings, {
	            hidden: BASE_MVC.wrapTemplate([
	            // add a warning when hidden
	            '<% if( !dataset.visible ){ %>', '<div class="hidden-msg warningmessagesmall">', _l('This dataset has been hidden'), '</div>', '<% } %>'], 'dataset')
	        });
	
	        return _.extend({}, _super.prototype.templates, {
	            titleBar: titleBarTemplate,
	            warnings: warnings
	        });
	    }();
	
	    //==============================================================================
	    return {
	        HDAListItemView: HDAListItemView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(85), __webpack_require__(90), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DATASET, HISTORY_CONTENT, BASE_MVC, _l) {
	    'use strict';
	
	    //==============================================================================
	
	    var _super = DATASET.DatasetAssociation,
	        hcontentMixin = HISTORY_CONTENT.HistoryContentMixin;
	    /** @class (HDA) model for a Galaxy dataset contained in and related to a history.
	     */
	    var HistoryDatasetAssociation = _super.extend(BASE_MVC.mixin(hcontentMixin,
	    /** @lends HistoryDatasetAssociation.prototype */{
	
	        /** default attributes for a model */
	        defaults: _.extend({}, _super.prototype.defaults, hcontentMixin.defaults, {
	            history_content_type: 'dataset',
	            model_class: 'HistoryDatasetAssociation'
	        })
	    }));
	
	    //==============================================================================
	    return {
	        HistoryDatasetAssociation: HistoryDatasetAssociation
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(58), __webpack_require__(83), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (STATES, DC_LI, DC_VIEW, BASE_MVC, _l) {
	
	    'use strict';
	
	    //==============================================================================
	
	    var _super = DC_LI.DCListItemView;
	    /** @class Read only view for HistoryDatasetCollectionAssociation (a dataset collection inside a history).
	     */
	    var HDCAListItemView = _super.extend(
	    /** @lends HDCAListItemView.prototype */{
	
	        className: _super.prototype.className + " history-content",
	
	        /** event listeners */
	        _setUpListeners: function () {
	            _super.prototype._setUpListeners.call(this);
	            this.listenTo(this.model, {
	                'change:tags change:populated change:visible': function (model, options) {
	                    this.render();
	                }
	            });
	        },
	
	        /** Override to provide the proper collections panels as the foldout */
	        _getFoldoutPanelClass: function () {
	            switch (this.model.get('collection_type')) {
	                case 'list':
	                    return DC_VIEW.ListCollectionView;
	                case 'paired':
	                    return DC_VIEW.PairCollectionView;
	                case 'list:paired':
	                    return DC_VIEW.ListOfPairsCollectionView;
	                case 'list:list':
	                    return DC_VIEW.ListOfListsCollectionView;
	            }
	            throw new TypeError('Uknown collection_type: ' + this.model.get('collection_type'));
	        },
	
	        /** In this override, add the state as a class for use with state-based CSS */
	        _swapNewRender: function ($newRender) {
	            _super.prototype._swapNewRender.call(this, $newRender);
	            //TODO: model currently has no state
	            var state = !this.model.get('populated') ? STATES.RUNNING : STATES.OK;
	            //if( this.model.has( 'state' ) ){
	            this.$el.addClass('state-' + state);
	            //}
	            return this.$el;
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'HDCAListItemView(' + modelString + ')';
	        }
	    });
	
	    /** underscore templates */
	    HDCAListItemView.prototype.templates = function () {
	
	        var warnings = _.extend({}, _super.prototype.templates.warnings, {
	            hidden: BASE_MVC.wrapTemplate([
	            // add a warning when hidden
	            '<% if( !collection.visible ){ %>', '<div class="hidden-msg warningmessagesmall">', _l('This collection has been hidden'), '</div>', '<% } %>'], 'collection')
	        });
	
	        // could steal this from hda-base (or use mixed content)
	        var titleBarTemplate = BASE_MVC.wrapTemplate([
	        // adding the hid display to the title
	        '<div class="title-bar clear" tabindex="0">', '<span class="state-icon"></span>', '<div class="title">',
	        //TODO: remove whitespace and use margin-right
	        '<span class="hid"><%- collection.hid %></span> ', '<span class="name"><%- collection.name %></span>', '</div>', '<div class="subtitle"></div>', '<span class="nametags">', '<% _.each(_.sortBy(_.uniq(collection.tags), function(x) { return x }), function(tag){ %>', '<% if (tag.indexOf("name:") == 0){ %>', '<span class="label label-info"><%- tag.slice(5) %></span>', '<% } %>', '<% }); %>', '</span>', '</div>'], 'collection');
	
	        return _.extend({}, _super.prototype.templates, {
	            warnings: warnings,
	            titleBar: titleBarTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        HDCAListItemView: HDCAListItemView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (STATES, BASE_MVC, _l) {
	    'use strict';
	
	    //==============================================================================
	    /** @class Mixin for HistoryContents content (HDAs, HDCAs).
	     */
	
	    var HistoryContentMixin = {
	
	        /** default attributes for a model */
	        defaults: {
	            /** parent (containing) history */
	            history_id: null,
	            /** some content_type (HistoryContents can contain mixed model classes) */
	            history_content_type: null,
	            /** indicating when/what order the content was generated in the context of the history */
	            hid: null,
	            /** whether the user wants the content shown (visible) */
	            visible: true
	        },
	
	        // ........................................................................ mixed content element
	        // In order to be part of a MIXED bbone collection, we can't rely on the id
	        //  (which may collide btwn models of different classes)
	        // Instead, use type_id which prefixes the history_content_type so the bbone collection can differentiate
	        idAttribute: 'type_id',
	
	        // ........................................................................ common queries
	        /** the more common alias of visible */
	        hidden: function () {
	            return !this.get('visible');
	        },
	
	        //TODO: remove
	        /** based on includeDeleted, includeHidden (gen. from the container control),
	         *      would this ds show in the list of ds's?
	         *  @param {Boolean} includeDeleted are we showing deleted hdas?
	         *  @param {Boolean} includeHidden are we showing hidden hdas?
	         */
	        isVisible: function (includeDeleted, includeHidden) {
	            var isVisible = true;
	            if (!includeDeleted && (this.get('deleted') || this.get('purged'))) {
	                isVisible = false;
	            }
	            if (!includeHidden && !this.get('visible')) {
	                isVisible = false;
	            }
	            return isVisible;
	        },
	
	        // ........................................................................ ajax
	        //TODO?: these are probably better done on the leaf classes
	        /** history content goes through the 'api/histories' API */
	        urlRoot: Galaxy.root + 'api/histories/',
	
	        /** full url spec. for this content */
	        url: function () {
	            var url = this.urlRoot + this.get('history_id') + '/contents/' + this.get('history_content_type') + 's/' + this.get('id');
	            return url;
	        },
	
	        /** save this content as not visible */
	        hide: function (options) {
	            if (!this.get('visible')) {
	                return jQuery.when();
	            }
	            return this.save({ visible: false }, options);
	        },
	        /** save this content as visible */
	        unhide: function (options) {
	            if (this.get('visible')) {
	                return jQuery.when();
	            }
	            return this.save({ visible: true }, options);
	        },
	
	        // ........................................................................ misc
	        toString: function () {
	            return [this.get('type_id'), this.get('hid'), this.get('name')].join(':');
	        }
	    };
	
	    //==============================================================================
	    return {
	        HistoryContentMixin: HistoryContentMixin
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(67), __webpack_require__(152), __webpack_require__(7), __webpack_require__(6), __webpack_require__(98)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_ITEM, LoadingIndicator, BASE_MVC, _l) {
	
	    'use strict';
	
	    var logNamespace = 'list';
	    /* ============================================================================
	    TODO:
	    
	    ============================================================================ */
	    /** @class View for a list/collection of models and the sub-views of those models.
	     *      Sub-views must (at least have the interface if not) inherit from ListItemView.
	     *      (For a list panel that also includes some 'container' model (History->HistoryContents)
	     *      use ModelWithListPanel)
	     *
	     *  Allows for:
	     *      searching collection/sub-views
	     *      selecting/multi-selecting sub-views
	     *
	     *  Currently used:
	     *      for dataset/dataset-choice
	     *      as superclass of ModelListPanel
	     */
	    var ListPanel = Backbone.View.extend(BASE_MVC.LoggableMixin).extend( /** @lends ListPanel.prototype */{
	        _logNamespace: logNamespace,
	
	        /** class to use for constructing the sub-views */
	        viewClass: LIST_ITEM.ListItemView,
	        /** class to used for constructing collection of sub-view models */
	        collectionClass: Backbone.Collection,
	
	        tagName: 'div',
	        className: 'list-panel',
	
	        /** (in ms) that jquery effects will use */
	        fxSpeed: 'fast',
	
	        /** string to display when the collection has no contents */
	        emptyMsg: _l('This list is empty'),
	        /** displayed when no items match the search terms */
	        noneFoundMsg: _l('No matching items found'),
	        /** string used for search placeholder */
	        searchPlaceholder: _l('search'),
	
	        // ......................................................................... SET UP
	        /** Set up the view, set up storage, bind listeners to HistoryContents events
	         *  @param {Object} attributes optional settings for the list
	         */
	        initialize: function (attributes, options) {
	            attributes = attributes || {};
	            // set the logger if requested
	            if (attributes.logger) {
	                this.logger = attributes.logger;
	            }
	            this.log(this + '.initialize:', attributes);
	
	            // ---- instance vars
	            /** how quickly should jquery fx run? */
	            this.fxSpeed = _.has(attributes, 'fxSpeed') ? attributes.fxSpeed : this.fxSpeed;
	
	            /** filters for displaying subviews */
	            this.filters = [];
	            /** current search terms */
	            this.searchFor = attributes.searchFor || '';
	
	            /** loading indicator */
	            // this.indicator = new LoadingIndicator( this.$el );
	
	            /** currently showing selectors on items? */
	            this.selecting = attributes.selecting !== undefined ? attributes.selecting : true;
	            //this.selecting = false;
	
	            /** cached selected item.model.ids to persist btwn renders */
	            this.selected = attributes.selected || [];
	            /** the last selected item.model.id */
	            this.lastSelected = null;
	
	            /** are sub-views draggable */
	            this.dragItems = attributes.dragItems || false;
	
	            /** list item view class (when passed models) */
	            this.viewClass = attributes.viewClass || this.viewClass;
	
	            /** list item views */
	            this.views = [];
	            /** list item models */
	            this.collection = attributes.collection || this._createDefaultCollection();
	
	            /** filter fns run over collection items to see if they should show in the list */
	            this.filters = attributes.filters || [];
	
	            /** override $scrollContainer fn via attributes - fn should return jq for elem to call scrollTo on */
	            this.$scrollContainer = attributes.$scrollContainer || this.$scrollContainer;
	
	            /** @type {String} generic title */
	            this.title = attributes.title || '';
	            /** @type {String} generic subtitle */
	            this.subtitle = attributes.subtitle || '';
	
	            this._setUpListeners();
	        },
	
	        // ------------------------------------------------------------------------ listeners
	        /** create any event listeners for the list */
	        _setUpListeners: function () {
	            this.off();
	
	            //TODO: move errorHandler down into list-view from history-view or
	            //  pass to global error handler (Galaxy)
	            this.on({
	                error: function (model, xhr, options, msg, details) {
	                    //this.errorHandler( model, xhr, options, msg, details );
	                    console.error(model, xhr, options, msg, details);
	                },
	                // show hide the loading indicator
	                loading: function () {
	                    this._showLoadingIndicator('loading...', 40);
	                },
	                'loading-done': function () {
	                    this._hideLoadingIndicator(40);
	                }
	            });
	
	            // throw the first render up as a diff namespace using once (for outside consumption)
	            this.once('rendered', function () {
	                this.trigger('rendered:initial', this);
	            });
	
	            this._setUpCollectionListeners();
	            this._setUpViewListeners();
	            return this;
	        },
	
	        /** create and return a collection for when none is initially passed */
	        _createDefaultCollection: function () {
	            // override
	            return new this.collectionClass([]);
	        },
	
	        /** listening for collection events */
	        _setUpCollectionListeners: function () {
	            this.log(this + '._setUpCollectionListeners', this.collection);
	            this.stopListening(this.collection);
	
	            // bubble up error events
	            this.listenTo(this.collection, {
	                error: function (model, xhr, options, msg, details) {
	                    this.trigger('error', model, xhr, options, msg, details);
	                },
	                update: function (collection, options) {
	                    var changes = options.changes;
	                    // console.info( collection + ', update:', changes, '\noptions:', options );
	                    // more than one: render everything
	                    if (options.renderAll || changes.added.length + changes.removed.length > 1) {
	                        return this.renderItems();
	                    }
	                    // otherwise, let the single add/remove handlers do it
	                    if (changes.added.length === 1) {
	                        return this.addItemView(_.first(changes.added), collection, options);
	                    }
	                    if (changes.removed.length === 1) {
	                        return this.removeItemView(_.first(changes.removed), collection, options);
	                    }
	                }
	            });
	            return this;
	        },
	
	        /** listening for sub-view events that bubble up with the 'view:' prefix */
	        _setUpViewListeners: function () {
	            this.log(this + '._setUpViewListeners');
	
	            // shift to select a range
	            this.on({
	                'view:selected': function (view, ev) {
	                    if (ev && ev.shiftKey && this.lastSelected) {
	                        var lastSelectedView = this.viewFromModelId(this.lastSelected);
	                        if (lastSelectedView) {
	                            this.selectRange(view, lastSelectedView);
	                        }
	                    } else if (ev && ev.altKey && !this.selecting) {
	                        this.showSelectors();
	                    }
	                    this.selected.push(view.model.id);
	                    this.lastSelected = view.model.id;
	                },
	
	                'view:de-selected': function (view, ev) {
	                    this.selected = _.without(this.selected, view.model.id);
	                }
	            });
	        },
	
	        // ------------------------------------------------------------------------ rendering
	        /** Render this content, set up ui.
	         *  @param {Number or String} speed   the speed of the render
	         */
	        render: function (speed) {
	            this.log(this + '.render', speed);
	            var $newRender = this._buildNewRender();
	            this._setUpBehaviors($newRender);
	            this._queueNewRender($newRender, speed);
	            return this;
	        },
	
	        /** Build a temp div containing the new children for the view's $el. */
	        _buildNewRender: function () {
	            this.debug(this + '(ListPanel)._buildNewRender');
	            var $newRender = $(this.templates.el({}, this));
	            this._renderControls($newRender);
	            this._renderTitle($newRender);
	            this._renderSubtitle($newRender);
	            this._renderSearch($newRender);
	            this.renderItems($newRender);
	            return $newRender;
	        },
	
	        /** Build a temp div containing the new children for the view's $el. */
	        _renderControls: function ($newRender) {
	            this.debug(this + '(ListPanel)._renderControls');
	            var $controls = $(this.templates.controls({}, this));
	            $newRender.find('.controls').replaceWith($controls);
	            return $controls;
	        },
	
	        /** return a jQuery object containing the title DOM */
	        _renderTitle: function ($where) {
	            //$where = $where || this.$el;
	            //$where.find( '.title' ).replaceWith( ... )
	        },
	
	        /** return a jQuery object containing the subtitle DOM (if any) */
	        _renderSubtitle: function ($where) {
	            //$where = $where || this.$el;
	            //$where.find( '.title' ).replaceWith( ... )
	        },
	
	        /** Fade out the old el, swap in the new contents, then fade in.
	         *  @param {Number or String} speed   jq speed to use for rendering effects
	         *  @fires rendered when rendered
	         */
	        _queueNewRender: function ($newRender, speed) {
	            speed = speed === undefined ? this.fxSpeed : speed;
	            var panel = this;
	            panel.log('_queueNewRender:', $newRender, speed);
	
	            $(panel).queue('fx', [function (next) {
	                panel.$el.fadeOut(speed, next);
	            }, function (next) {
	                panel._swapNewRender($newRender);
	                next();
	            }, function (next) {
	                panel.$el.fadeIn(speed, next);
	            }, function (next) {
	                panel.trigger('rendered', panel);
	                next();
	            }]);
	        },
	
	        /** empty out the current el, move the $newRender's children in */
	        _swapNewRender: function ($newRender) {
	            this.$el.empty().attr('class', this.className).append($newRender.children());
	            if (this.selecting) {
	                this.showSelectors(0);
	            }
	            return this;
	        },
	
	        /** Set up any behaviors, handlers (ep. plugins) that need to be called when the entire view has been built but
	         *  not attached to the page yet.
	         */
	        _setUpBehaviors: function ($where) {
	            $where = $where || this.$el;
	            this.$controls($where).find('[title]').tooltip();
	            // set up the pupup for actions available when multi selecting
	            this._renderMultiselectActionMenu($where);
	            return this;
	        },
	
	        /** render a menu containing the actions available to sets of selected items */
	        _renderMultiselectActionMenu: function ($where) {
	            $where = $where || this.$el;
	            var $menu = $where.find('.list-action-menu'),
	                actions = this.multiselectActions();
	            if (!actions.length) {
	                return $menu.empty();
	            }
	
	            var $newMenu = $(['<div class="list-action-menu btn-group">', '<button class="list-action-menu-btn btn btn-default dropdown-toggle" data-toggle="dropdown">', _l('For all selected'), '...', '</button>', '<ul class="dropdown-menu pull-right" role="menu">', '</ul>', '</div>'].join(''));
	            var $actions = actions.map(function (action) {
	                var html = ['<li><a href="javascript:void(0);">', action.html, '</a></li>'].join('');
	                return $(html).click(function (ev) {
	                    ev.preventDefault();
	                    return action.func(ev);
	                });
	            });
	            $newMenu.find('ul').append($actions);
	            $menu.replaceWith($newMenu);
	            return $newMenu;
	        },
	
	        /** return a list of plain objects used to render multiselect actions menu. Each object should have:
	         *      html: an html string used as the anchor contents
	         *      func: a function called when the anchor is clicked (passed the click event)
	         */
	        multiselectActions: function () {
	            return [];
	        },
	
	        // ------------------------------------------------------------------------ sub-$element shortcuts
	        /** the scroll container for this panel - can be $el, $el.parent(), or grandparent depending on context */
	        $scrollContainer: function ($where) {
	            // override or set via attributes.$scrollContainer
	            return ($where || this.$el).parent().parent();
	        },
	        /** convenience selector for the section that displays the list controls */
	        $controls: function ($where) {
	            return ($where || this.$el).find('> .controls');
	        },
	        /** list-items: where the subviews are contained in the view's dom */
	        $list: function ($where) {
	            return ($where || this.$el).find('> .list-items');
	        },
	        /** container where list messages are attached */
	        $messages: function ($where) {
	            //TODO: controls isn't really correct here (only for ModelListPanel)
	            return ($where || this.$el).find('> .controls .messages');
	        },
	        /** the message displayed when no views can be shown (no views, none matching search) */
	        $emptyMessage: function ($where) {
	            return ($where || this.$el).find('> .empty-message');
	        },
	
	        // ------------------------------------------------------------------------ hda sub-views
	        /** render the subviews for the list's collection */
	        renderItems: function ($whereTo) {
	            $whereTo = $whereTo || this.$el;
	            var panel = this;
	            panel.log(this + '.renderItems', $whereTo);
	
	            var $list = panel.$list($whereTo);
	            panel.freeViews();
	            // console.log( 'views freed' );
	            //TODO:? cache and re-use views?
	            var shownModels = panel._filterCollection();
	            // console.log( 'models filtered:', shownModels );
	
	            panel.views = shownModels.map(function (itemModel) {
	                var view = panel._createItemView(itemModel);
	                return view;
	            });
	
	            $list.empty();
	            // console.log( 'list emptied' );
	            if (panel.views.length) {
	                panel._attachItems($whereTo);
	                // console.log( 'items attached' );
	            }
	            panel._renderEmptyMessage($whereTo).toggle(!panel.views.length);
	            panel.trigger('views:ready', panel.views);
	
	            // console.log( '------------------------------------------- rendering items' );
	            return panel.views;
	        },
	
	        /** Filter the collection to only those models that should be currently viewed */
	        _filterCollection: function () {
	            // override this
	            var panel = this;
	            return panel.collection.filter(_.bind(panel._filterItem, panel));
	        },
	
	        /** Should the model be viewable in the current state?
	         *     Checks against this.filters and this.searchFor
	         */
	        _filterItem: function (model) {
	            // override this
	            var panel = this;
	            return _.every(panel.filters.map(function (fn) {
	                return fn.call(model);
	            })) && (!panel.searchFor || model.matchesAll(panel.searchFor));
	        },
	
	        /** Create a view for a model and set up it's listeners */
	        _createItemView: function (model) {
	            var ViewClass = this._getItemViewClass(model);
	            var options = _.extend(this._getItemViewOptions(model), {
	                model: model
	            });
	            var view = new ViewClass(options);
	            this._setUpItemViewListeners(view);
	            return view;
	        },
	
	        /** Free a view for a model. Note: does not remove it from the DOM */
	        _destroyItemView: function (view) {
	            this.stopListening(view);
	            this.views = _.without(this.views, view);
	        },
	
	        _destroyItemViews: function (view) {
	            var self = this;
	            self.views.forEach(function (v) {
	                self.stopListening(v);
	            });
	            self.views = [];
	            return self;
	        },
	
	        /** free any sub-views the list has */
	        freeViews: function () {
	            return this._destroyItemViews();
	        },
	
	        /** Get the bbone view class based on the model */
	        _getItemViewClass: function (model) {
	            // override this
	            return this.viewClass;
	        },
	
	        /** Get the options passed to the new view based on the model */
	        _getItemViewOptions: function (model) {
	            // override this
	            return {
	                //logger      : this.logger,
	                fxSpeed: this.fxSpeed,
	                expanded: false,
	                selectable: this.selecting,
	                selected: _.contains(this.selected, model.id),
	                draggable: this.dragItems
	            };
	        },
	
	        /** Set up listeners for new models */
	        _setUpItemViewListeners: function (view) {
	            var panel = this;
	            // send all events to the panel, re-namspaceing them with the view prefix
	            this.listenTo(view, 'all', function () {
	                var args = Array.prototype.slice.call(arguments, 0);
	                args[0] = 'view:' + args[0];
	                panel.trigger.apply(panel, args);
	            });
	
	            // drag multiple - hijack ev.setData to add all selected items
	            this.listenTo(view, 'draggable:dragstart', function (ev, v) {
	                //TODO: set multiple drag data here
	                var json = {},
	                    selected = this.getSelectedModels();
	                if (selected.length) {
	                    json = selected.toJSON();
	                } else {
	                    json = [v.model.toJSON()];
	                }
	                ev.dataTransfer.setData('text', JSON.stringify(json));
	                //ev.dataTransfer.setDragImage( v.el, 60, 60 );
	            }, this);
	
	            return panel;
	        },
	
	        /** Attach views in this.views to the model based on $whereTo */
	        _attachItems: function ($whereTo) {
	            var self = this;
	            // console.log( '_attachItems:', $whereTo, this.$list( $whereTo ) );
	            //ASSUMES: $list has been emptied
	            this.$list($whereTo).append(this.views.map(function (view) {
	                return self._renderItemView$el(view);
	            }));
	            return this;
	        },
	
	        /** get a given subview's $el (or whatever may wrap it) and return it */
	        _renderItemView$el: function (view) {
	            // useful to wrap and override
	            return view.render(0).$el;
	        },
	
	        /** render the empty/none-found message */
	        _renderEmptyMessage: function ($whereTo) {
	            this.debug('_renderEmptyMessage', $whereTo, this.searchFor);
	            var text = this.searchFor ? this.noneFoundMsg : this.emptyMsg;
	            return this.$emptyMessage($whereTo).text(text);
	        },
	
	        /** expand all item views */
	        expandAll: function () {
	            _.each(this.views, function (view) {
	                view.expand();
	            });
	        },
	
	        /** collapse all item views */
	        collapseAll: function () {
	            _.each(this.views, function (view) {
	                view.collapse();
	            });
	        },
	
	        // ------------------------------------------------------------------------ collection/views syncing
	        /** Add a view (if the model should be viewable) to the panel */
	        addItemView: function (model, collection, options) {
	            // console.log( this + '.addItemView:', model );
	            var panel = this;
	            // get the index of the model in the list of filtered models shown by this list
	            // in order to insert the view in the proper place
	            //TODO:? potentially expensive
	            var modelIndex = panel._filterCollection().indexOf(model);
	            if (modelIndex === -1) {
	                return undefined;
	            }
	            var view = panel._createItemView(model);
	            // console.log( 'adding and rendering:', modelIndex, view.toString() );
	
	            $(view).queue('fx', [function (next) {
	                // hide the empty message first if only view
	                if (panel.$emptyMessage().is(':visible')) {
	                    panel.$emptyMessage().fadeOut(panel.fxSpeed, next);
	                } else {
	                    next();
	                }
	            }, function (next) {
	                panel._attachView(view, modelIndex);
	                next();
	            }]);
	            return view;
	        },
	
	        /** internal fn to add view (to both panel.views and panel.$list) */
	        _attachView: function (view, modelIndex, useFx) {
	            // console.log( this + '._attachView:', view, modelIndex, useFx );
	            useFx = _.isUndefined(useFx) ? true : useFx;
	            modelIndex = modelIndex || 0;
	            var panel = this;
	
	            // use the modelIndex to splice into views and insert at the proper index in the DOM
	            panel.views.splice(modelIndex, 0, view);
	            panel._insertIntoListAt(modelIndex, panel._renderItemView$el(view).hide());
	
	            panel.trigger('view:attached', view);
	            if (useFx) {
	                view.$el.slideDown(panel.fxSpeed, function () {
	                    panel.trigger('view:attached:rendered');
	                });
	            } else {
	                view.$el.show();
	                panel.trigger('view:attached:rendered');
	            }
	            return view;
	        },
	
	        /** insert a jq object as a child of list-items at the specified *DOM index* */
	        _insertIntoListAt: function (index, $what) {
	            // console.log( this + '._insertIntoListAt:', index, $what );
	            var $list = this.$list();
	            if (index === 0) {
	                $list.prepend($what);
	            } else {
	                $list.children().eq(index - 1).after($what);
	            }
	            return $what;
	        },
	
	        /** Remove a view from the panel (if found) */
	        removeItemView: function (model, collection, options) {
	            var panel = this;
	            var view = _.find(panel.views, function (v) {
	                return v.model === model;
	            });
	            if (!view) {
	                return undefined;
	            }
	            panel.views = _.without(panel.views, view);
	            panel.trigger('view:removed', view);
	
	            // potentially show the empty message if no views left
	            // use anonymous queue here - since remove can happen multiple times
	            $({}).queue('fx', [function (next) {
	                view.$el.fadeOut(panel.fxSpeed, next);
	            }, function (next) {
	                view.remove();
	                panel.trigger('view:removed:rendered');
	                if (!panel.views.length) {
	                    panel._renderEmptyMessage().fadeIn(panel.fxSpeed, next);
	                } else {
	                    next();
	                }
	            }]);
	            return view;
	        },
	
	        /** get views based on model.id */
	        viewFromModelId: function (id) {
	            return _.find(this.views, function (v) {
	                return v.model.id === id;
	            });
	        },
	
	        /** get views based on model */
	        viewFromModel: function (model) {
	            return model ? this.viewFromModelId(model.id) : undefined;
	        },
	
	        /** get views based on model properties */
	        viewsWhereModel: function (properties) {
	            return this.views.filter(function (view) {
	                return _.isMatch(view.model.attributes, properties);
	            });
	        },
	
	        /** A range of views between (and including) viewA and viewB */
	        viewRange: function (viewA, viewB) {
	            if (viewA === viewB) {
	                return viewA ? [viewA] : [];
	            }
	
	            var indexA = this.views.indexOf(viewA),
	                indexB = this.views.indexOf(viewB);
	
	            // handle not found
	            if (indexA === -1 || indexB === -1) {
	                if (indexA === indexB) {
	                    return [];
	                }
	                return indexA === -1 ? [viewB] : [viewA];
	            }
	            // reverse if indeces are
	            //note: end inclusive
	            return indexA < indexB ? this.views.slice(indexA, indexB + 1) : this.views.slice(indexB, indexA + 1);
	        },
	
	        // ------------------------------------------------------------------------ searching
	        /** render a search input for filtering datasets shown
	         *      (see SearchableMixin in base-mvc for implementation of the actual searching)
	         *      return will start the search
	         *      esc will clear the search
	         *      clicking the clear button will clear the search
	         *      uses searchInput in ui.js
	         */
	        _renderSearch: function ($where) {
	            $where.find('.controls .search-input').searchInput({
	                placeholder: this.searchPlaceholder,
	                initialVal: this.searchFor,
	                onfirstsearch: _.bind(this._firstSearch, this),
	                onsearch: _.bind(this.searchItems, this),
	                onclear: _.bind(this.clearSearch, this)
	            });
	            return $where;
	        },
	
	        /** What to do on the first search entered */
	        _firstSearch: function (searchFor) {
	            // override to load model details if necc.
	            this.log('onFirstSearch', searchFor);
	            return this.searchItems(searchFor);
	        },
	
	        /** filter view list to those that contain the searchFor terms */
	        searchItems: function (searchFor, force) {
	            this.log('searchItems', searchFor, this.searchFor, force);
	            if (!force && this.searchFor === searchFor) {
	                return this;
	            }
	            this.searchFor = searchFor;
	            this.renderItems();
	            this.trigger('search:searching', searchFor, this);
	            var $search = this.$('> .controls .search-query');
	            if ($search.val() !== searchFor) {
	                $search.val(searchFor);
	            }
	            return this;
	        },
	
	        /** clear the search filters and show all views that are normally shown */
	        clearSearch: function (searchFor) {
	            //this.log( 'onSearchClear', this );
	            this.searchFor = '';
	            this.trigger('search:clear', this);
	            this.$('> .controls .search-query').val('');
	            this.renderItems();
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ selection
	        /** @type Integer when the number of list item views is >= to this, don't animate selectors */
	        THROTTLE_SELECTOR_FX_AT: 20,
	
	        /** show selectors on all visible itemViews and associated controls */
	        showSelectors: function (speed) {
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            this.selecting = true;
	            this.$('.list-actions').slideDown(speed);
	            speed = this.views.length >= this.THROTTLE_SELECTOR_FX_AT ? 0 : speed;
	            _.each(this.views, function (view) {
	                view.showSelector(speed);
	            });
	            //this.selected = [];
	            //this.lastSelected = null;
	        },
	
	        /** hide selectors on all visible itemViews and associated controls */
	        hideSelectors: function (speed) {
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            this.selecting = false;
	            this.$('.list-actions').slideUp(speed);
	            speed = this.views.length >= this.THROTTLE_SELECTOR_FX_AT ? 0 : speed;
	            _.each(this.views, function (view) {
	                view.hideSelector(speed);
	            });
	            this.selected = [];
	            this.lastSelected = null;
	        },
	
	        /** show or hide selectors on all visible itemViews and associated controls */
	        toggleSelectors: function () {
	            if (!this.selecting) {
	                this.showSelectors();
	            } else {
	                this.hideSelectors();
	            }
	        },
	
	        /** select all visible items */
	        selectAll: function (event) {
	            _.each(this.views, function (view) {
	                view.select(event);
	            });
	        },
	
	        /** deselect all visible items */
	        deselectAll: function (event) {
	            this.lastSelected = null;
	            _.each(this.views, function (view) {
	                view.deselect(event);
	            });
	        },
	
	        /** select a range of datasets between A and B */
	        selectRange: function (viewA, viewB) {
	            var range = this.viewRange(viewA, viewB);
	            _.each(range, function (view) {
	                view.select();
	            });
	            return range;
	        },
	
	        /** return an array of all currently selected itemViews */
	        getSelectedViews: function () {
	            return _.filter(this.views, function (v) {
	                return v.selected;
	            });
	        },
	
	        /** return a collection of the models of all currenly selected items */
	        getSelectedModels: function () {
	            // console.log( '(getSelectedModels)' );
	            return new this.collection.constructor(_.map(this.getSelectedViews(), function (view) {
	                return view.model;
	            }));
	        },
	
	        // ------------------------------------------------------------------------ loading indicator
	        /** hide the $el and display a loading indicator (in the $el's parent) when loading new data */
	        _showLoadingIndicator: function (msg, speed, callback) {
	            this.debug('_showLoadingIndicator', this.indicator, msg, speed, callback);
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            if (!this.indicator) {
	                this.indicator = new LoadingIndicator(this.$el);
	                this.debug('\t created', this.indicator);
	            }
	            if (!this.$el.is(':visible')) {
	                this.indicator.show(0, callback);
	            } else {
	                this.$el.fadeOut(speed);
	                this.indicator.show(msg, speed, callback);
	            }
	        },
	
	        /** hide the loading indicator */
	        _hideLoadingIndicator: function (speed, callback) {
	            this.debug('_hideLoadingIndicator', this.indicator, speed, callback);
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            if (this.indicator) {
	                this.indicator.hide(speed, callback);
	            }
	        },
	
	        // ------------------------------------------------------------------------ scrolling
	        /** get the current scroll position of the panel in its parent */
	        scrollPosition: function () {
	            return this.$scrollContainer().scrollTop();
	        },
	
	        /** set the current scroll position of the panel in its parent */
	        scrollTo: function (pos, speed) {
	            speed = speed || 0;
	            this.$scrollContainer().animate({ scrollTop: pos }, speed);
	            return this;
	        },
	
	        /** Scrolls the panel to the top. */
	        scrollToTop: function (speed) {
	            return this.scrollTo(0, speed);
	        },
	
	        /** scroll to the given view in list-items */
	        scrollToItem: function (view, speed) {
	            if (!view) {
	                return this;
	            }
	            return this;
	        },
	
	        /** Scrolls the panel to show the content with the given id. */
	        scrollToId: function (id, speed) {
	            return this.scrollToItem(this.viewFromModelId(id), speed);
	        },
	
	        // ------------------------------------------------------------------------ panel events
	        /** event map */
	        events: {
	            'click .select-all': 'selectAll',
	            'click .deselect-all': 'deselectAll'
	        },
	
	        // ------------------------------------------------------------------------ misc
	        /** Return a string rep of the panel */
	        toString: function () {
	            return 'ListPanel(' + this.collection + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    ListPanel.prototype.templates = function () {
	
	        var elTemplate = BASE_MVC.wrapTemplate([
	        // temp container
	        '<div>', '<div class="controls"></div>', '<div class="list-items"></div>', '<div class="empty-message infomessagesmall"></div>', '</div>']);
	
	        var controlsTemplate = BASE_MVC.wrapTemplate(['<div class="controls">', '<div class="title">', '<div class="name"><%- view.title %></div>', '</div>', '<div class="subtitle"><%- view.subtitle %></div>',
	        // buttons, controls go here
	        '<div class="actions"></div>',
	        // deleted msg, etc.
	        '<div class="messages"></div>', '<div class="search">', '<div class="search-input"></div>', '</div>',
	
	        // show when selectors are shown
	        '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-default"', 'data-mode="select">', _l('All'), '</button>', '<button class="deselect-all btn btn-default"', 'data-mode="select">', _l('None'), '</button>', '</div>', '<div class="list-action-menu btn-group">', '</div>', '</div>', '</div>']);
	
	        return {
	            el: elTemplate,
	            controls: controlsTemplate
	        };
	    }();
	
	    //=============================================================================
	    /** View for a model that has a sub-collection (e.g. History, DatasetCollection)
	     *  Allows:
	     *      the model to be reset
	     *      auto assign panel.collection to panel.model[ panel.modelCollectionKey ]
	     *
	     */
	    var ModelListPanel = ListPanel.extend({
	
	        /** key of attribute in model to assign to this.collection */
	        modelCollectionKey: 'contents',
	
	        initialize: function (attributes) {
	            ListPanel.prototype.initialize.call(this, attributes);
	            this.selecting = attributes.selecting !== undefined ? attributes.selecting : false;
	
	            this.setModel(this.model, attributes);
	        },
	
	        /** release/free/shutdown old models and set up panel for new models
	         *  @fires new-model with the panel as parameter
	         */
	        setModel: function (model, attributes) {
	            attributes = attributes || {};
	            this.debug(this + '.setModel:', model, attributes);
	
	            this.freeModel();
	            this.freeViews();
	
	            if (model) {
	                var oldModelId = this.model ? this.model.get('id') : null;
	
	                // set up the new model with user, logger, storage, events
	                this.model = model;
	                if (this.logger) {
	                    this.model.logger = this.logger;
	                }
	                this._setUpModelListeners();
	
	                //TODO: relation btwn model, collection becoming tangled here
	                // free the collection, and assign the new collection to either
	                //  the model[ modelCollectionKey ], attributes.collection, or an empty vanilla collection
	                this.stopListening(this.collection);
	                this.collection = this.model[this.modelCollectionKey] || attributes.collection || this._createDefaultCollection();
	                this._setUpCollectionListeners();
	
	                if (oldModelId && model.get('id') !== oldModelId) {
	                    this.trigger('new-model', this);
	                }
	            }
	            return this;
	        },
	
	        /** free the current model and all listeners for it, free any views for the model */
	        freeModel: function () {
	            // stop/release the previous model, and clear cache to sub-views
	            if (this.model) {
	                this.stopListening(this.model);
	                //TODO: see base-mvc
	                //this.model.free();
	                //this.model = null;
	            }
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ listening
	        /** listening for model events */
	        _setUpModelListeners: function () {
	            // override
	            this.log(this + '._setUpModelListeners', this.model);
	            // bounce model errors up to the panel
	            this.listenTo(this.model, 'error', function () {
	                var args = Array.prototype.slice.call(arguments, 0);
	                //args.unshift( 'model:error' );
	                args.unshift('error');
	                this.trigger.apply(this, args);
	            }, this);
	
	            // debugging
	            if (this.logger) {
	                this.listenTo(this.model, 'all', function (event) {
	                    this.info(this + '(model)', event, arguments);
	                });
	            }
	            return this;
	        },
	
	        /** Build a temp div containing the new children for the view's $el.
	         */
	        _renderControls: function ($newRender) {
	            this.debug(this + '(ModelListPanel)._renderControls');
	            var json = this.model ? this.model.toJSON() : {},
	                $controls = $(this.templates.controls(json, this));
	            $newRender.find('.controls').replaceWith($controls);
	            return $controls;
	        },
	
	        // ------------------------------------------------------------------------ misc
	        /** Return a string rep of the panel */
	        toString: function () {
	            return 'ModelListPanel(' + this.model + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    ModelListPanel.prototype.templates = function () {
	
	        var controlsTemplate = BASE_MVC.wrapTemplate(['<div class="controls">', '<div class="title">',
	        //TODO: this is really the only difference - consider factoring titlebar out
	        '<div class="name"><%- model.name %></div>', '</div>', '<div class="subtitle"><%- view.subtitle %></div>', '<div class="actions"></div>', '<div class="messages"></div>', '<div class="search">', '<div class="search-input"></div>', '</div>', '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-default"', 'data-mode="select">', _l('All'), '</button>', '<button class="deselect-all btn btn-default"', 'data-mode="select">', _l('None'), '</button>', '</div>', '<div class="list-action-menu btn-group">', '</div>', '</div>', '</div>']);
	
	        return _.extend(_.clone(ListPanel.prototype.templates), {
	            controls: controlsTemplate
	        });
	    }();
	
	    //=============================================================================
	    return {
	        ListPanel: ListPanel,
	        ModelListPanel: ModelListPanel
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This is the run workflow tool form view. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(50), __webpack_require__(5), __webpack_require__(10), __webpack_require__(20), __webpack_require__(46), __webpack_require__(8), __webpack_require__(44), __webpack_require__(147)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Deferred, Ui, Form, FormData, ToolFormBase, Modal, Webhooks, WorkflowIcons) {
	
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.modal = parent.Galaxy.modal || new Modal.View();
	            this.model = options && options.model || new Backbone.Model(options);
	            this.deferred = new Deferred();
	            this.setElement($('<div/>').addClass('ui-form-composite').append(this.$message = $('<div/>')).append(this.$header = $('<div/>')).append(this.$steps = $('<div/>')));
	            $('body').append(this.$el);
	            this._configure();
	            this.render();
	            $(window).resize(function () {
	                self._refresh();
	            });
	        },
	
	        /** Refresh height of scrollable div below header, handle scrolling by lazy loading steps */
	        _refresh: function (step_index) {
	            var margin = _.reduce(this.$el.children(), function (memo, child) {
	                return memo + $(child).outerHeight();
	            }, 0) - this.$steps.height() + 90;
	            this.$steps.css('height', $(window).height() - margin);
	        },
	
	        /** Configures form/step options for each workflow step */
	        _configure: function () {
	            var self = this;
	            this.forms = [];
	            this.steps = [];
	            this.links = [];
	            this.parms = [];
	            _.each(this.model.get('steps'), function (step, i) {
	                Galaxy.emit.debug('tool-form-composite::initialize()', i + ' : Preparing workflow step.');
	                var icon = WorkflowIcons[step.step_type];
	                var title = parseInt(i + 1) + ': ' + (step.step_label || step.step_name);
	                if (step.annotation) {
	                    title += ' - ' + step.annotation;
	                }
	                if (step.step_version) {
	                    title += ' (Galaxy Version ' + step.step_version + ')';
	                }
	                step = Utils.merge({
	                    index: i,
	                    fixed_title: _.escape(title),
	                    icon: icon || '',
	                    help: null,
	                    citations: null,
	                    collapsible: true,
	                    collapsed: i > 0 && !self._isDataStep(step),
	                    sustain_version: true,
	                    sustain_repeats: true,
	                    sustain_conditionals: true,
	                    narrow: true,
	                    text_enable: 'Edit',
	                    text_disable: 'Undo',
	                    cls_enable: 'fa fa-edit',
	                    cls_disable: 'fa fa-undo',
	                    errors: step.messages,
	                    initial_errors: true,
	                    cls: 'ui-portlet-narrow',
	                    hide_operations: true,
	                    needs_refresh: false,
	                    always_refresh: step.step_type != 'tool'
	                }, step);
	                self.steps[i] = step;
	                self.links[i] = [];
	                self.parms[i] = {};
	            });
	
	            // build linear index of step input pairs
	            _.each(this.steps, function (step, i) {
	                FormData.visitInputs(step.inputs, function (input, name) {
	                    self.parms[i][name] = input;
	                });
	            });
	
	            // iterate through data input modules and collect linked sub steps
	            _.each(this.steps, function (step, i) {
	                _.each(step.output_connections, function (output_connection) {
	                    _.each(self.steps, function (sub_step, j) {
	                        sub_step.step_index === output_connection.input_step_index && self.links[i].push(sub_step);
	                    });
	                });
	            });
	
	            // convert all connected data inputs to hidden fields with proper labels,
	            // and track the linked source step
	            _.each(this.steps, function (step, i) {
	                _.each(self.steps, function (sub_step, j) {
	                    var connections_by_name = {};
	                    _.each(step.output_connections, function (connection) {
	                        sub_step.step_index === connection.input_step_index && (connections_by_name[connection.input_name] = connection);
	                    });
	                    _.each(self.parms[j], function (input, name) {
	                        var connection = connections_by_name[name];
	                        if (connection) {
	                            input.type = 'hidden';
	                            input.help = input.step_linked ? input.help + ', ' : '';
	                            input.help += 'Output dataset \'' + connection.output_name + '\' from step ' + (parseInt(i) + 1);
	                            input.step_linked = input.step_linked || [];
	                            input.step_linked.push({ index: step.index, step_type: step.step_type });
	                        }
	                    });
	                });
	            });
	
	            // identify and configure workflow parameters
	            var wp_count = 0;
	            this.wp_inputs = {};
	            function _handleWorkflowParameter(value, callback) {
	                var re = /\$\{(.+?)\}/g,
	                    match;
	                while (match = re.exec(String(value))) {
	                    var wp_name = match[1];
	                    callback(self.wp_inputs[wp_name] = self.wp_inputs[wp_name] || {
	                        label: wp_name,
	                        name: wp_name,
	                        type: 'text',
	                        color: 'hsl( ' + ++wp_count * 100 + ', 70%, 30% )',
	                        style: 'ui-form-wp-source',
	                        links: []
	                    });
	                }
	            }
	            _.each(this.steps, function (step, i) {
	                _.each(self.parms[i], function (input, name) {
	                    _handleWorkflowParameter(input.value, function (wp_input) {
	                        wp_input.links.push(step);
	                        input.wp_linked = true;
	                        input.type = 'text';
	                        input.backdrop = true;
	                        input.style = 'ui-form-wp-target';
	                    });
	                });
	                _.each(step.post_job_actions, function (pja) {
	                    _.each(pja.action_arguments, function (arg) {
	                        _handleWorkflowParameter(arg, function () {});
	                    });
	                });
	            });
	
	            // select fields are shown for dynamic fields if all putative data inputs are available,
	            // or if an explicit reference is specified as data_ref and available
	            _.each(this.steps, function (step, i) {
	                if (step.step_type == 'tool') {
	                    var data_resolved = true;
	                    FormData.visitInputs(step.inputs, function (input, name, context) {
	                        var is_runtime_value = input.value && input.value.__class__ == 'RuntimeValue';
	                        var is_data_input = ['data', 'data_collection'].indexOf(input.type) != -1;
	                        var data_ref = context[input.data_ref];
	                        input.step_linked && !self._isDataStep(input.step_linked) && (data_resolved = false);
	                        input.options && (input.options.length == 0 && !data_resolved || input.wp_linked) && (input.is_workflow = true);
	                        data_ref && (input.is_workflow = data_ref.step_linked && !self._isDataStep(data_ref.step_linked) || input.wp_linked);
	                        (is_data_input || input.value && input.value.__class__ == 'RuntimeValue' && !input.step_linked) && (step.collapsed = false);
	                        is_runtime_value && (input.value = input.default_value);
	                        input.flavor = 'workflow';
	                        if (!is_runtime_value && !is_data_input && input.type !== 'hidden' && !input.wp_linked) {
	                            if (input.optional || !Utils.isEmpty(input.value) && input.value !== '') {
	                                input.collapsible_value = input.value;
	                                input.collapsible_preview = true;
	                            }
	                        }
	                    });
	                }
	            });
	        },
	
	        render: function () {
	            var self = this;
	            this.deferred.reset();
	            this._renderHeader();
	            this._renderMessage();
	            this._renderParameters();
	            this._renderHistory();
	            _.each(this.steps, function (step) {
	                self._renderStep(step);
	            });
	        },
	
	        /** Render header */
	        _renderHeader: function () {
	            var self = this;
	            this.execute_btn = new Ui.Button({
	                icon: 'fa-check',
	                title: 'Run workflow',
	                cls: 'btn btn-primary',
	                onclick: function () {
	                    self._execute();
	                }
	            });
	            this.$header.addClass('ui-form-header').empty().append(new Ui.Label({ title: 'Workflow: ' + this.model.get('name') }).$el).append(this.execute_btn.$el);
	        },
	
	        /** Render message */
	        _renderMessage: function () {
	            this.$message.empty();
	            if (this.model.get('has_upgrade_messages')) {
	                this.$message.append(new Ui.Message({
	                    message: 'Some tools in this workflow may have changed since it was last saved or some errors were found. The workflow may still run, but any new options will have default values. Please review the messages below to make a decision about whether the changes will affect your analysis.',
	                    status: 'warning',
	                    persistent: true,
	                    fade: false
	                }).$el);
	            }
	            var step_version_changes = this.model.get('step_version_changes');
	            if (step_version_changes && step_version_changes.length > 0) {
	                this.$message.append(new Ui.Message({
	                    message: 'Some tools are being executed with different versions compared to those available when this workflow was last saved because the other versions are not or no longer available on this Galaxy instance. To upgrade your workflow and dismiss this message simply edit the workflow and re-save it.',
	                    status: 'warning',
	                    persistent: true,
	                    fade: false
	                }).$el);
	            }
	        },
	
	        /** Render workflow parameters */
	        _renderParameters: function () {
	            var self = this;
	            this.wp_form = null;
	            if (!_.isEmpty(this.wp_inputs)) {
	                this.wp_form = new Form({ title: '<b>Workflow Parameters</b>', inputs: this.wp_inputs, cls: 'ui-portlet-narrow', onchange: function () {
	                        _.each(self.wp_form.input_list, function (input_def, i) {
	                            _.each(input_def.links, function (step) {
	                                self._refreshStep(step);
	                            });
	                        });
	                    }
	                });
	                this._append(this.$steps.empty(), this.wp_form.$el);
	            }
	        },
	
	        /** Render workflow parameters */
	        _renderHistory: function () {
	            this.history_form = new Form({
	                cls: 'ui-portlet-narrow',
	                title: '<b>History Options</b>',
	                inputs: [{
	                    type: 'conditional',
	                    name: 'new_history',
	                    test_param: {
	                        name: 'check',
	                        label: 'Send results to a new history',
	                        type: 'boolean',
	                        value: 'false',
	                        help: ''
	                    },
	                    cases: [{
	                        value: 'true',
	                        inputs: [{
	                            name: 'name',
	                            label: 'History name',
	                            type: 'text',
	                            value: this.model.get('name')
	                        }]
	                    }]
	                }]
	            });
	            this._append(this.$steps, this.history_form.$el);
	        },
	
	        /** Render step */
	        _renderStep: function (step) {
	            var self = this;
	            var form = null;
	            this.deferred.execute(function (promise) {
	                self.$steps.addClass('ui-steps');
	                if (step.step_type == 'tool') {
	                    step.postchange = function (process, form) {
	                        var self = this;
	                        var current_state = {
	                            tool_id: step.id,
	                            tool_version: step.version,
	                            inputs: $.extend(true, {}, form.data.create())
	                        };
	                        form.wait(true);
	                        Galaxy.emit.debug('tool-form-composite::postchange()', 'Sending current state.', current_state);
	                        Utils.request({
	                            type: 'POST',
	                            url: Galaxy.root + 'api/tools/' + step.id + '/build',
	                            data: current_state,
	                            success: function (data) {
	                                form.update(data);
	                                form.wait(false);
	                                Galaxy.emit.debug('tool-form-composite::postchange()', 'Received new model.', data);
	                                process.resolve();
	                            },
	                            error: function (response) {
	                                Galaxy.emit.debug('tool-form-composite::postchange()', 'Refresh request failed.', response);
	                                process.reject();
	                            }
	                        });
	                    };
	                    form = new ToolFormBase(step);
	                    if (step.post_job_actions && step.post_job_actions.length) {
	                        form.portlet.append($('<div/>').addClass('ui-form-element-disabled').append($('<div/>').addClass('ui-form-title').html('<b>Job Post Actions</b>')).append($('<div/>').addClass('ui-form-preview').html(_.reduce(step.post_job_actions, function (memo, value) {
	                            return memo + ' ' + value.short_str;
	                        }, ''))));
	                    }
	                } else {
	                    var is_simple_input = ['data_input', 'data_collection_input'].indexOf(step.step_type) != -1;
	                    _.each(step.inputs, function (input) {
	                        input.flavor = 'module';input.hide_label = is_simple_input;
	                    });
	                    form = new Form(Utils.merge({
	                        title: step.fixed_title,
	                        onchange: function () {
	                            _.each(self.links[step.index], function (link) {
	                                self._refreshStep(link);
	                            });
	                        },
	                        inputs: step.inputs && step.inputs.length > 0 ? step.inputs : [{ type: 'hidden', name: 'No options available.', ignore: null }]
	                    }, step));
	                }
	                self.forms[step.index] = form;
	                self._append(self.$steps, form.$el);
	                self._refresh();
	                step.needs_refresh && self._refreshStep(step);
	                form.portlet[!self.show_progress ? 'enable' : 'disable']();
	                self.show_progress && self.execute_btn.model.set({ wait: true,
	                    wait_text: 'Preparing...',
	                    percentage: (step.index + 1) * 100.0 / self.steps.length });
	                Galaxy.emit.debug('tool-form-composite::initialize()', step.index + ' : Workflow step state ready.', step);
	                setTimeout(function () {
	                    promise.resolve();
	                }, 0);
	            });
	        },
	
	        /** Refreshes step values from source step values */
	        _refreshStep: function (step) {
	            var self = this;
	            var form = this.forms[step.index];
	            if (form) {
	                _.each(self.parms[step.index], function (input, name) {
	                    if (input.step_linked || input.wp_linked) {
	                        var field = form.field_list[form.data.match(name)];
	                        if (field) {
	                            var new_value = undefined;
	                            if (input.step_linked) {
	                                new_value = { values: [] };
	                                _.each(input.step_linked, function (source_step) {
	                                    if (self._isDataStep(source_step)) {
	                                        var value = self.forms[source_step.index].data.create().input;
	                                        value && _.each(value.values, function (v) {
	                                            new_value.values.push(v);
	                                        });
	                                    }
	                                });
	                                if (!input.multiple && new_value.values.length > 0) {
	                                    new_value = { values: [new_value.values[0]] };
	                                }
	                            } else if (input.wp_linked) {
	                                new_value = input.value;
	                                var re = /\$\{(.+?)\}/g,
	                                    match;
	                                while (match = re.exec(input.value)) {
	                                    var wp_field = self.wp_form.field_list[self.wp_form.data.match(match[1])];
	                                    var wp_value = wp_field && wp_field.value();
	                                    if (wp_value) {
	                                        new_value = new_value.split(match[0]).join(wp_value);
	                                    }
	                                }
	                            }
	                            if (new_value !== undefined) {
	                                field.value(new_value);
	                            }
	                        }
	                    }
	                });
	                form.trigger('change');
	            } else {
	                step.needs_refresh = true;
	            }
	        },
	
	        /** Refresh the history after job submission while form is shown */
	        _refreshHistory: function () {
	            var self = this;
	            var history = parent.Galaxy && parent.Galaxy.currHistoryPanel && parent.Galaxy.currHistoryPanel.model;
	            this._refresh_history && clearTimeout(this._refresh_history);
	            if (history) {
	                history.refresh().success(function () {
	                    if (history.numOfUnfinishedShownContents() === 0) {
	                        self._refresh_history = setTimeout(function () {
	                            self._refreshHistory();
	                        }, history.UPDATE_DELAY);
	                    }
	                });
	            }
	        },
	
	        /** Build remaining steps */
	        _execute: function () {
	            var self = this;
	            this.show_progress = true;
	            this._enabled(false);
	            this.deferred.execute(function (promise) {
	                setTimeout(function () {
	                    promise.resolve();self._submit();
	                }, 0);
	            });
	        },
	
	        /** Validate and submit workflow */
	        _submit: function () {
	            var self = this;
	            var history_form_data = this.history_form.data.create();
	            var job_def = {
	                new_history_name: history_form_data['new_history|name'] ? history_form_data['new_history|name'] : null,
	                history_id: !history_form_data['new_history|name'] ? this.model.get('history_id') : null,
	                replacement_params: this.wp_form ? this.wp_form.data.create() : {},
	                parameters: {},
	                // Tool form will submit flat maps for each parameter
	                // (e.g. "repeat_0|cond|param": "foo" instead of nested
	                // data structures).
	                parameters_normalized: true,
	                // Tool form always wants a list of invocations back
	                // so that inputs can be batched.
	                batch: true
	            };
	            var validated = true;
	            for (var i in this.forms) {
	                var form = this.forms[i];
	                var job_inputs = form.data.create();
	                var step = self.steps[i];
	                var step_index = step.step_index;
	                form.trigger('reset');
	                for (var job_input_id in job_inputs) {
	                    var input_value = job_inputs[job_input_id];
	                    var input_id = form.data.match(job_input_id);
	                    var input_field = form.field_list[input_id];
	                    var input_def = form.input_list[input_id];
	                    if (!input_def.step_linked) {
	                        if (this._isDataStep(step)) {
	                            validated = input_value && input_value.values && input_value.values.length > 0;
	                        } else {
	                            validated = input_def.optional || input_def.is_workflow && input_value !== '' || !input_def.is_workflow && input_value !== null;
	                        }
	                        if (!validated) {
	                            form.highlight(input_id);
	                            break;
	                        }
	                        job_def.parameters[step_index] = job_def.parameters[step_index] || {};
	                        job_def.parameters[step_index][job_input_id] = job_inputs[job_input_id];
	                    }
	                }
	                if (!validated) {
	                    break;
	                }
	            }
	            if (!validated) {
	                self._enabled(true);
	                Galaxy.emit.debug('tool-form-composite::submit()', 'Validation failed.', job_def);
	            } else {
	                Galaxy.emit.debug('tool-form-composite::submit()', 'Validation complete.', job_def);
	                Utils.request({
	                    type: 'POST',
	                    url: Galaxy.root + 'api/workflows/' + this.model.id + '/invocations',
	                    data: job_def,
	                    success: function (response) {
	                        Galaxy.emit.debug('tool-form-composite::submit', 'Submission successful.', response);
	                        self.$el.children().hide();
	                        self.$el.append(self._templateSuccess(response));
	
	                        // Show Webhook if job is running
	                        if ($.isArray(response) && response.length > 0) {
	                            self.$el.append($('<div/>', { id: 'webhook-view' }));
	                            var WebhookApp = new Webhooks.WebhookView({
	                                urlRoot: Galaxy.root + 'api/webhooks/workflow',
	                                toolId: job_def.tool_id,
	                                toolVersion: job_def.tool_version
	                            });
	                        }
	
	                        self._refreshHistory();
	                    },
	                    error: function (response) {
	                        Galaxy.emit.debug('tool-form-composite::submit', 'Submission failed.', response);
	                        var input_found = false;
	                        if (response && response.err_data) {
	                            for (var i in self.forms) {
	                                var form = self.forms[i];
	                                var step_related_errors = response.err_data[form.model.get('step_index')];
	                                if (step_related_errors) {
	                                    var error_messages = form.data.matchResponse(step_related_errors);
	                                    for (var input_id in error_messages) {
	                                        form.highlight(input_id, error_messages[input_id]);
	                                        input_found = true;
	                                        break;
	                                    }
	                                }
	                            }
	                        }
	                        if (!input_found) {
	                            self.modal.show({
	                                title: 'Workflow submission failed',
	                                body: self._templateError(job_def, response && response.err_msg),
	                                buttons: {
	                                    'Close': function () {
	                                        self.modal.hide();
	                                    }
	                                }
	                            });
	                        }
	                    },
	                    complete: function () {
	                        self._enabled(true);
	                    }
	                });
	            }
	        },
	
	        /** Append new dom to body */
	        _append: function ($container, $el) {
	            $container.append('<p/>').append($el);
	        },
	
	        /** Set enabled/disabled state */
	        _enabled: function (enabled) {
	            this.execute_btn.model.set({ wait: !enabled, wait_text: 'Sending...', percentage: -1 });
	            this.wp_form && this.wp_form.portlet[enabled ? 'enable' : 'disable']();
	            this.history_form && this.history_form.portlet[enabled ? 'enable' : 'disable']();
	            _.each(this.forms, function (form) {
	                form && form.portlet[enabled ? 'enable' : 'disable']();
	            });
	        },
	
	        /** Is data input module/step */
	        _isDataStep: function (steps) {
	            var lst = $.isArray(steps) ? steps : [steps];
	            for (var i = 0; i < lst.length; i++) {
	                var step = lst[i];
	                if (!step || !step.step_type || !step.step_type.startsWith('data')) {
	                    return false;
	                }
	            }
	            return true;
	        },
	
	        /** Templates */
	        _templateSuccess: function (response) {
	            if ($.isArray(response) && response.length > 0) {
	                return $('<div/>').addClass('donemessagelarge').append($('<p/>').html('Successfully invoked workflow <b>' + Utils.sanitize(this.model.get('name')) + '</b>' + (response.length > 1 ? ' <b>' + response.length + ' times</b>' : '') + '.')).append($('<p/>').append('<b/>').text('You can check the status of queued jobs and view the resulting data by refreshing the History pane. When the job has been run the status will change from \'running\' to \'finished\' if completed successfully or \'error\' if problems were encountered.'));
	            } else {
	                return this._templateError(response, 'Invalid success response. No invocations found.');
	            }
	        },
	
	        _templateError: function (response, err_msg) {
	            return $('<div/>').addClass('errormessagelarge').append($('<p/>').text('The server could not complete the request. Please contact the Galaxy Team if this error persists. ' + (JSON.stringify(err_msg) || ''))).append($('<pre/>').text(JSON.stringify(response, null, 4)));
	        }
	    });
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_l) {
	    'use strict';
	
	    //TODO: toastr is another possibility - I didn't see where I might add details, tho
	
	    /* ============================================================================
	    Error modals meant to replace the o-so-easy alerts.
	    
	    These are currently styled as errormessages but use the Galaxy.modal
	    infrastructure to be shown/closed. They're capable of showing details in a
	    togglable dropdown and the details are formatted in a pre.
	    
	    Example:
	        errorModal( 'Heres a message', 'A Title', { some_details: 'here' });
	        errorModal( 'Heres a message' ); // no details, title is 'Error'
	    
	    There are three specialized forms:
	        offlineErrorModal       a canned response for when there's no connection
	        badGatewayErrorModal    canned response for when Galaxy is restarting
	        ajaxErrorModal          plugable into any Backbone class as an
	            error event handler by accepting the error args: model, xhr, options
	    
	    Examples:
	        if( navigator.offLine ){ offlineErrorModal(); }
	        if( xhr.status === 502 ){ badGatewayErrorModal(); }
	        this.listenTo( this.model, 'error', ajaxErrorModal );
	    
	    ============================================================================ */
	
	    var CONTACT_MSG = _l('Please contact a Galaxy administrator if the problem persists.');
	    var DEFAULT_AJAX_ERR_MSG = _l('An error occurred while updating information with the server.');
	    var DETAILS_MSG = _l('The following information can assist the developers in finding the source of the error:');
	
	    /** private helper that builds the modal and handles adding details */
	    function _errorModal(message, title, details) {
	        // create and return the modal, adding details button only if needed
	        Galaxy.modal.show({
	            title: title,
	            body: message,
	            closing_events: true,
	            buttons: { Ok: function () {
	                    Galaxy.modal.hide();
	                } }
	        });
	        Galaxy.modal.$el.addClass('error-modal');
	
	        if (details) {
	            Galaxy.modal.$('.error-details').add(Galaxy.modal.$('button:contains("Details")')).remove();
	            $('<div/>').addClass('error-details').hide().appendTo(Galaxy.modal.$('.modal-content')).append([$('<p/>').text(DETAILS_MSG), $('<pre/>').text(JSON.stringify(details, null, '  '))]);
	
	            $('<button id="button-1" class="pull-left">' + _l('Details') + '</button>').appendTo(Galaxy.modal.$('.buttons')).click(function () {
	                Galaxy.modal.$('.error-details').toggle();
	            });
	        }
	        return Galaxy.modal;
	    }
	
	    /** Display a modal showing an error message but fallback to alert if there's no modal */
	    function errorModal(message, title, details) {
	        if (!message) {
	            return;
	        }
	
	        message = _l(message);
	        title = _l(title) || _l('Error:');
	        if (window.Galaxy && Galaxy.modal) {
	            return _errorModal(message, title, details);
	        }
	
	        alert(title + '\n\n' + message);
	        console.log('error details:', JSON.stringify(details));
	    }
	
	    // ----------------------------------------------------------------------------
	    /** display a modal when the user may be offline */
	    function offlineErrorModal() {
	        return errorModal(_l('You appear to be offline. Please check your connection and try again.'), _l('Offline?'));
	    }
	
	    // ----------------------------------------------------------------------------
	    /** 502 messages that should be displayed when galaxy is restarting */
	    function badGatewayErrorModal() {
	        return errorModal(_l('Galaxy is currently unreachable. Please try again in a few minutes.') + ' ' + CONTACT_MSG, _l('Cannot connect to Galaxy'));
	    }
	
	    // ----------------------------------------------------------------------------
	    /** display a modal (with details) about a failed Backbone ajax operation */
	    function ajaxErrorModal(model, xhr, options, message, title) {
	        message = message || DEFAULT_AJAX_ERR_MSG;
	        message += ' ' + CONTACT_MSG;
	        title = title || _l('An error occurred');
	        var details = _ajaxDetails(model, xhr, options);
	        return errorModal(message, title, details);
	    }
	
	    /** build details which may help debugging the ajax call */
	    function _ajaxDetails(model, xhr, options) {
	        return {
	            //TODO: still can't manage Raven id
	            raven: _.result(window.Raven, 'lastEventId'),
	            userAgent: navigator.userAgent,
	            onLine: navigator.onLine,
	            version: _.result(Galaxy.config, 'version_major'),
	            xhr: _.omit(xhr, _.functions(xhr)),
	            options: _.omit(options, 'xhr'),
	            // add ajax data from Galaxy object cache
	            url: _.result(Galaxy.lastAjax, 'url'),
	            data: _.result(Galaxy.lastAjax, 'data'),
	            // backbone stuff (auto-redacting email for user)
	            model: _.result(model, 'toJSON', model + ''),
	            user: _.omit(_.result(Galaxy.user, 'toJSON'), 'email')
	        };
	    }
	
	    //=============================================================================
	    return {
	        errorModal: errorModal,
	        offlineErrorModal: offlineErrorModal,
	        badGatewayErrorModal: badGatewayErrorModal,
	        ajaxErrorModal: ajaxErrorModal
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, $) {(function (factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	})(function () {
	    //=============================================================================
	
	    jQuery.fn.extend({
	        hoverhighlight: function $hoverhighlight(scope, color) {
	            scope = scope || 'body';
	            if (!this.length) {
	                return this;
	            }
	
	            $(this).each(function () {
	                var $this = $(this),
	                    targetSelector = $this.data('target');
	
	                if (targetSelector) {
	                    $this.mouseover(function (ev) {
	                        $(targetSelector, scope).css({
	                            background: color
	                        });
	                    }).mouseout(function (ev) {
	                        $(targetSelector).css({
	                            background: ''
	                        });
	                    });
	                }
	            });
	            return this;
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, jQuery) {// from: https://raw.githubusercontent.com/umdjs/umd/master/jqueryPlugin.js
	// Uses AMD or browser globals to create a jQuery plugin.
	(function (factory) {
	    if (true) {
	        //TODO: So...this turns out to be an all or nothing thing. If I load jQuery in the define below, it will
	        //  (of course) wipe the old jquery *and all the plugins loaded into it*. So the define below *is still
	        //  relying on jquery being loaded globally* in order to preserve plugins.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	})(function () {
	    var _l = window._l || function (s) {
	        return s;
	    };
	
	    //TODO: consolidate with tool menu functionality, use there
	
	    /** searchInput: (jQuery plugin)
	     *      Creates a search input, a clear button, and loading indicator
	     *      within the selected node.
	     *
	     *      When the user either presses return or enters some minimal number
	     *      of characters, a callback is called. Pressing ESC when the input
	     *      is focused will clear the input and call a separate callback.
	     */
	    function searchInput(parentNode, options) {
	        var KEYCODE_ESC = 27,
	            KEYCODE_RETURN = 13,
	            $parentNode = $(parentNode),
	            firstSearch = true,
	            defaults = {
	            initialVal: '',
	            name: 'search',
	            placeholder: 'search',
	            classes: '',
	            onclear: function () {},
	            onfirstsearch: null,
	            onsearch: function (inputVal) {},
	            minSearchLen: 0,
	            escWillClear: true,
	            oninit: function () {}
	        };
	
	        // .................................................................... input rendering and events
	        // visually clear the search, trigger an event, and call the callback
	        function clearSearchInput(event) {
	            var $input = $(this).parent().children('input');
	            $input.val('').trigger('searchInput.clear').blur();
	            options.onclear();
	        }
	
	        // search for searchTerms, trigger an event, call the appropo callback (based on whether this is the first)
	        function search(event, searchTerms) {
	            if (!searchTerms) {
	                return clearSearchInput();
	            }
	            $(this).trigger('search.search', searchTerms);
	            if (typeof options.onfirstsearch === 'function' && firstSearch) {
	                firstSearch = false;
	                options.onfirstsearch(searchTerms);
	            } else {
	                options.onsearch(searchTerms);
	            }
	        }
	
	        // .................................................................... input rendering and events
	        function inputTemplate() {
	            // class search-query is bootstrap 2.3 style that now lives in base.less
	            return ['<input type="text" name="', options.name, '" placeholder="', options.placeholder, '" ', 'class="search-query ', options.classes, '" ', '/>'].join('');
	        }
	
	        // the search input that responds to keyboard events and displays the search value
	        function $input() {
	            return $(inputTemplate())
	            // select all text on a focus
	            .focus(function (event) {
	                $(this).select();
	            })
	            // attach behaviors to esc, return if desired, search on some min len string
	            .keyup(function (event) {
	                event.preventDefault();
	                event.stopPropagation();
	
	                // esc key will clear if desired
	                if (event.which === KEYCODE_ESC && options.escWillClear) {
	                    clearSearchInput.call(this, event);
	                } else {
	                    var searchTerms = $(this).val();
	                    // return key or the search string len > minSearchLen (if not 0) triggers search
	                    if (event.which === KEYCODE_RETURN || options.minSearchLen && searchTerms.length >= options.minSearchLen) {
	                        search.call(this, event, searchTerms);
	                    }
	                }
	            }).val(options.initialVal);
	        }
	
	        // .................................................................... clear button rendering and events
	        // a button for clearing the search bar, placed on the right hand side
	        function $clearBtn() {
	            return $(['<span class="search-clear fa fa-times-circle" ', 'title="', _l('clear search (esc)'), '"></span>'].join('')).tooltip({ placement: 'bottom' }).click(function (event) {
	                clearSearchInput.call(this, event);
	            });
	        }
	
	        // .................................................................... loadingIndicator rendering
	        // a button for clearing the search bar, placed on the right hand side
	        function $loadingIndicator() {
	            return $(['<span class="search-loading fa fa-spinner fa-spin" ', 'title="', _l('loading...'), '"></span>'].join('')).hide().tooltip({ placement: 'bottom' });
	        }
	
	        // .................................................................... commands
	        // visually swap the load, clear buttons
	        function toggleLoadingIndicator() {
	            $parentNode.find('.search-loading').toggle();
	            $parentNode.find('.search-clear').toggle();
	        }
	
	        // .................................................................... init
	        // string command (not constructor)
	        if (jQuery.type(options) === 'string') {
	            if (options === 'toggle-loading') {
	                toggleLoadingIndicator();
	            }
	            return $parentNode;
	        }
	
	        // initial render
	        if (jQuery.type(options) === 'object') {
	            options = jQuery.extend(true, {}, defaults, options);
	        }
	        //NOTE: prepended
	        return $parentNode.addClass('search-input').prepend([$input(), $clearBtn(), $loadingIndicator()]);
	    }
	
	    // as jq plugin
	    jQuery.fn.extend({
	        searchInput: function $searchInput(options) {
	            return this.each(function () {
	                return searchInput(this, options);
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    // Alphanumeric/natural sort fn
	    function naturalSort(a, b) {
	        // setup temp-scope variables for comparison evauluation
	        var re = /(-?[0-9\.]+)/g,
	            x = a.toString().toLowerCase() || '',
	            y = b.toString().toLowerCase() || '',
	            nC = String.fromCharCode(0),
	            xN = x.replace(re, nC + '$1' + nC).split(nC),
	            yN = y.replace(re, nC + '$1' + nC).split(nC),
	            xD = new Date(x).getTime(),
	            yD = xD ? new Date(y).getTime() : null;
	        // natural sorting of dates
	        if (yD) {
	            if (xD < yD) {
	                return -1;
	            } else if (xD > yD) {
	                return 1;
	            }
	        }
	        // natural sorting through split numeric strings and default strings
	        var oFxNcL, oFyNcL;
	        for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
	            oFxNcL = parseFloat(xN[cLoc]) || xN[cLoc];
	            oFyNcL = parseFloat(yN[cLoc]) || yN[cLoc];
	            if (oFxNcL < oFyNcL) {
	                return -1;
	            } else if (oFxNcL > oFyNcL) {
	                return 1;
	            }
	        }
	        return 0;
	    }
	
	    return naturalSort;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var Ui = __webpack_require__(5),
	    historyOptionsMenu = __webpack_require__(135);
	CurrentHistoryView = __webpack_require__(132).CurrentHistoryView, _l = __webpack_require__(6);
	
	/** the right hand panel in the analysis page that shows the current history */
	var HistoryPanel = Backbone.View.extend({
	
	    initialize: function (page, options) {
	        var self = this;
	        this.userIsAnonymous = Galaxy.user.isAnonymous();
	        this.allow_user_dataset_purge = options.config.allow_user_dataset_purge;
	        this.root = options.root;
	
	        // view of the current history
	        this.historyView = new CurrentHistoryView({
	            className: CurrentHistoryView.prototype.className + ' middle',
	            purgeAllowed: this.allow_user_dataset_purge,
	            linkTarget: 'galaxy_main'
	        });
	
	        // add history panel to Galaxy object
	        Galaxy.currHistoryPanel = this.historyView;
	        Galaxy.currHistoryPanel.listenToGalaxy(Galaxy);
	
	        // build buttons
	        this.buttonRefresh = new Ui.ButtonLink({
	            id: 'history-refresh-button',
	            title: 'Refresh history',
	            cls: 'panel-header-button',
	            icon: 'fa fa-refresh',
	            onclick: function () {
	                self.historyView.loadCurrentHistory();
	            }
	        });
	        this.buttonOptions = new Ui.ButtonLink({
	            id: 'history-options-button',
	            title: 'History options',
	            cls: 'panel-header-button',
	            target: 'galaxy_main',
	            icon: 'fa fa-cog',
	            href: this.root + 'root/history_options'
	        });
	        this.buttonViewMulti = new Ui.ButtonLink({
	            id: 'history-view-multi-button',
	            title: 'View all histories',
	            cls: 'panel-header-button',
	            icon: 'fa fa-columns',
	            href: this.root + 'history/view_multiple'
	        });
	
	        // define components
	        this.model = new Backbone.Model({
	            cls: 'history-right-panel',
	            title: _l('History'),
	            buttons: [this.buttonRefresh, this.buttonOptions, this.buttonViewMulti]
	        });
	
	        // build body template and connect history view
	        this.setElement(this._template());
	        this.historyView.setElement(this.$el);
	        this.historyView.connectToQuotaMeter(Galaxy.quotaMeter);
	        this.historyView.loadCurrentHistory();
	
	        // fetch to update the quota meter adding 'current' for any anon-user's id
	        Galaxy.listenTo(this.historyView, 'history-size-change', function () {
	            Galaxy.user.fetch({ url: Galaxy.user.urlRoot() + '/' + (Galaxy.user.id || 'current') });
	        });
	    },
	
	    render: function () {
	        this.optionsMenu = historyOptionsMenu(this.buttonOptions.$el, {
	            anonymous: this.userIsAnonymous,
	            purgeAllowed: this.allow_user_dataset_purge,
	            root: this.root
	        });
	        this.buttonViewMulti.$el[!this.userIsAnonymous ? 'show' : 'hide']();
	    },
	
	    /** add history view div */
	    _template: function (data) {
	        return ['<div id="current-history-panel" class="history-panel middle"/>'].join('');
	    },
	
	    toString: function () {
	        return 'historyPanel';
	    }
	});
	
	module.exports = HistoryPanel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {var Tools = __webpack_require__(68),
	    Upload = __webpack_require__(143),
	    _l = __webpack_require__(6),
	    ToolForm = __webpack_require__(92);
	
	var ToolPanel = Backbone.View.extend({
	    initialize: function (page, options) {
	        // access configuration options
	        var config = options.config;
	        this.root = options.root;
	
	        /** @type {Object[]} descriptions of user's workflows to be shown in the tool menu */
	        this.stored_workflow_menu_entries = config.stored_workflow_menu_entries || [];
	
	        // create tool search, tool panel, and tool panel view.
	        var tool_search = new Tools.ToolSearch({
	            hidden: false
	        });
	        var tools = new Tools.ToolCollection(config.toolbox);
	        this.tool_panel = new Tools.ToolPanel({
	            tool_search: tool_search,
	            tools: tools,
	            layout: config.toolbox_in_panel
	        });
	        this.tool_panel_view = new Tools.ToolPanelView({ model: this.tool_panel });
	
	        // add upload modal
	        this.upload_button = new Upload({
	            nginx_upload_path: config.nginx_upload_path,
	            ftp_upload_site: config.ftp_upload_site,
	            default_genome: config.default_genome,
	            default_extension: config.default_extension
	        });
	
	        // add uploader button to Galaxy object
	        Galaxy.upload = this.upload_button;
	
	        // components for panel definition
	        this.model = new Backbone.Model({
	            title: _l('Tools'),
	            buttons: [this.upload_button]
	        });
	
	        // build body template
	        this.setElement(this._template());
	    },
	
	    render: function () {
	        // if there are tools, render panel and display everything
	        var self = this;
	        if (this.tool_panel.get('layout').size() > 0) {
	            this.$el.prepend(this.tool_panel_view.$el);
	            this.tool_panel_view.render();
	        }
	        // build the dom for the workflow portion of the tool menu
	        // add internal workflow list
	        self.$('#internal-workflows').append(self._templateAllWorkflow({
	            title: _l('All workflows'),
	            href: 'workflow'
	        }));
	        _.each(this.stored_workflow_menu_entries, function (menu_entry) {
	            self.$('#internal-workflows').append(self._templateWorkflowLink({
	                title: menu_entry.stored_workflow.name,
	                href: 'workflow/run?id=' + menu_entry.encoded_stored_workflow_id
	            }));
	        });
	    },
	
	    /** build a link to one tool */
	    _templateTool: function (tool) {
	        return ['<div class="toolTitle">', '<a href="', this.root, tool.href, '" target="galaxy_main">', tool.title, '</a>', '</div>'].join('');
	    },
	
	    /** build a link to 'All Workflows' */
	    _templateAllWorkflow: function (tool) {
	        return ['<div class="toolTitle">',
	        // global
	        '<a href="', Galaxy.root, tool.href, '">', tool.title, '</a>', '</div>'].join('');
	    },
	
	    /** build links to workflows in toolpanel */
	    _templateWorkflowLink: function (wf) {
	        return ['<div class="toolTitle">', '<a class="' + wf.cls + ' " href="', Galaxy.root, wf.href, '">', wf.title, '</a>', '</div>'].join('');
	    },
	
	    /** override to include inital menu dom and workflow section */
	    _template: function () {
	        return ['<div class="toolMenuContainer">', '<div class="toolMenu" style="display: none">', '<div id="search-no-results" style="display: none; padding-top: 5px">', '<em><strong>', _l('Search did not match any tools.'), '</strong></em>', '</div>', '</div>', '<div class="toolSectionPad"/>', '<div class="toolSectionPad"/>', '<div class="toolSectionTitle" id="title_XXinternalXXworkflow">', '<span>', _l('Workflows'), '</span>', '</div>', '<div id="internal-workflows" class="toolSectionBody">', '<div class="toolSectionBg"/>', '</div>', '</div>'].join('');
	    },
	
	    toString: function () {
	        return 'toolPanel';
	    }
	});
	
	module.exports = ToolPanel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	 * Toastr
	 * Version 2.0.1
	 * Copyright 2012 John Papa and Hans Fjällemark.  
	 * All Rights Reserved.  
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and 
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * Author: John Papa and Hans Fjällemark
	 * Project: https://github.com/CodeSeven/toastr
	 */
	;(function (define) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			var $ = jQuery;
			return function () {
				var version = '2.0.1';
				var $container;
				var listener;
				var toastId = 0;
				var toastType = {
					error: 'error',
					info: 'info',
					success: 'success',
					warning: 'warning'
				};
	
				var toastr = {
					clear: clear,
					error: error,
					getContainer: getContainer,
					info: info,
					options: {},
					subscribe: subscribe,
					success: success,
					version: version,
					warning: warning
				};
	
				return toastr;
	
				//#region Accessible Methods
				function error(message, title, optionsOverride) {
					return notify({
						type: toastType.error,
						iconClass: getOptions().iconClasses.error,
						message: message,
						optionsOverride: optionsOverride,
						title: title
					});
				}
	
				function info(message, title, optionsOverride) {
					return notify({
						type: toastType.info,
						iconClass: getOptions().iconClasses.info,
						message: message,
						optionsOverride: optionsOverride,
						title: title
					});
				}
	
				function subscribe(callback) {
					listener = callback;
				}
	
				function success(message, title, optionsOverride) {
					return notify({
						type: toastType.success,
						iconClass: getOptions().iconClasses.success,
						message: message,
						optionsOverride: optionsOverride,
						title: title
					});
				}
	
				function warning(message, title, optionsOverride) {
					return notify({
						type: toastType.warning,
						iconClass: getOptions().iconClasses.warning,
						message: message,
						optionsOverride: optionsOverride,
						title: title
					});
				}
	
				function clear($toastElement) {
					var options = getOptions();
					if (!$container) {
						getContainer(options);
					}
					if ($toastElement && $(':focus', $toastElement).length === 0) {
						$toastElement[options.hideMethod]({
							duration: options.hideDuration,
							easing: options.hideEasing,
							complete: function () {
								removeToast($toastElement);
							}
						});
						return;
					}
					if ($container.children().length) {
						$container[options.hideMethod]({
							duration: options.hideDuration,
							easing: options.hideEasing,
							complete: function () {
								$container.remove();
							}
						});
					}
				}
				//#endregion
	
				//#region Internal Methods
	
				function getDefaults() {
					return {
						tapToDismiss: true,
						toastClass: 'toast',
						containerId: 'toast-container',
						debug: false,
	
						showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
						showDuration: 300,
						showEasing: 'swing', //swing and linear are built into jQuery
						onShown: undefined,
						hideMethod: 'fadeOut',
						hideDuration: 1000,
						hideEasing: 'swing',
						onHidden: undefined,
	
						extendedTimeOut: 1000,
						iconClasses: {
							error: 'toast-error',
							info: 'toast-info',
							success: 'toast-success',
							warning: 'toast-warning'
						},
						iconClass: 'toast-info',
						positionClass: 'toast-top-right',
						timeOut: 5000, // Set timeOut and extendedTimeout to 0 to make it sticky
						titleClass: 'toast-title',
						messageClass: 'toast-message',
						target: 'body',
						closeHtml: '<button>&times;</button>',
						newestOnTop: true
					};
				}
	
				function publish(args) {
					if (!listener) {
						return;
					}
					listener(args);
				}
	
				function notify(map) {
					var options = getOptions(),
					    iconClass = map.iconClass || options.iconClass;
	
					if (typeof map.optionsOverride !== 'undefined') {
						options = $.extend(options, map.optionsOverride);
						iconClass = map.optionsOverride.iconClass || iconClass;
					}
	
					toastId++;
	
					$container = getContainer(options);
					var intervalId = null,
					    $toastElement = $('<div/>'),
					    $titleElement = $('<div/>'),
					    $messageElement = $('<div/>'),
					    $closeElement = $(options.closeHtml),
					    response = {
						toastId: toastId,
						state: 'visible',
						startTime: new Date(),
						options: options,
						map: map
					};
	
					if (map.iconClass) {
						$toastElement.addClass(options.toastClass).addClass(iconClass);
					}
	
					if (map.title) {
						$titleElement.append(map.title).addClass(options.titleClass);
						$toastElement.append($titleElement);
					}
	
					if (map.message) {
						$messageElement.append(map.message).addClass(options.messageClass);
						$toastElement.append($messageElement);
					}
	
					if (options.closeButton) {
						$closeElement.addClass('toast-close-button');
						$toastElement.prepend($closeElement);
					}
	
					$toastElement.hide();
					if (options.newestOnTop) {
						$container.prepend($toastElement);
					} else {
						$container.append($toastElement);
					}
	
					$toastElement[options.showMethod]({ duration: options.showDuration, easing: options.showEasing, complete: options.onShown });
					if (options.timeOut > 0) {
						intervalId = setTimeout(hideToast, options.timeOut);
					}
	
					$toastElement.hover(stickAround, delayedhideToast);
					if (!options.onclick && options.tapToDismiss) {
						$toastElement.click(hideToast);
					}
					if (options.closeButton && $closeElement) {
						$closeElement.click(function (event) {
							event.stopPropagation();
							hideToast(true);
						});
					}
	
					if (options.onclick) {
						$toastElement.click(function () {
							options.onclick();
							hideToast();
						});
					}
	
					publish(response);
	
					if (options.debug && console) {
						console.log(response);
					}
	
					return $toastElement;
	
					function hideToast(override) {
						if ($(':focus', $toastElement).length && !override) {
							return;
						}
						return $toastElement[options.hideMethod]({
							duration: options.hideDuration,
							easing: options.hideEasing,
							complete: function () {
								removeToast($toastElement);
								if (options.onHidden) {
									options.onHidden();
								}
								response.state = 'hidden';
								response.endTime = new Date(), publish(response);
							}
						});
					}
	
					function delayedhideToast() {
						if (options.timeOut > 0 || options.extendedTimeOut > 0) {
							intervalId = setTimeout(hideToast, options.extendedTimeOut);
						}
					}
	
					function stickAround() {
						clearTimeout(intervalId);
						$toastElement.stop(true, true)[options.showMethod]({ duration: options.showDuration, easing: options.showEasing });
					}
				}
				function getContainer(options) {
					if (!options) {
						options = getOptions();
					}
					$container = $('#' + options.containerId);
					if ($container.length) {
						return $container;
					}
					$container = $('<div/>').attr('id', options.containerId).addClass(options.positionClass);
					$container.appendTo($(options.target));
					return $container;
				}
	
				function getOptions() {
					return $.extend({}, getDefaults(), toastr.options);
				}
	
				function removeToast($toastElement) {
					if (!$container) {
						$container = getContainer();
					}
					if ($toastElement.is(':visible')) {
						return;
					}
					$toastElement.remove();
					$toastElement = null;
					if ($container.children().length === 0) {
						$container.remove();
					}
				}
				//#endregion
			}();
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(__webpack_require__(165));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58), __webpack_require__(84), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DC_LI, DATASET_LI_EDIT, BASE_MVC, _l) {
	
	    'use strict';
	    //==============================================================================
	
	    var DCListItemView = DC_LI.DCListItemView;
	    /** @class Edit view for DatasetCollection.
	     */
	    var DCListItemEdit = DCListItemView.extend(
	    /** @lends DCListItemEdit.prototype */{
	
	        /** override to add linkTarget */
	        initialize: function (attributes) {
	            DCListItemView.prototype.initialize.call(this, attributes);
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DCListItemEdit(' + modelString + ')';
	        }
	    });
	
	    //==============================================================================
	    var DCEListItemView = DC_LI.DCEListItemView;
	    /** @class Read only view for DatasetCollectionElement.
	     */
	    var DCEListItemEdit = DCEListItemView.extend(
	    /** @lends DCEListItemEdit.prototype */{
	        //TODO: this might be expendable - compacted with HDAListItemView
	
	        /** set up */
	        initialize: function (attributes) {
	            DCEListItemView.prototype.initialize.call(this, attributes);
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DCEListItemEdit(' + modelString + ')';
	        }
	    });
	
	    //==============================================================================
	    // NOTE: this does not inherit from DatasetDCEListItemView as you would expect
	    //TODO: but should - if we can find something simpler than using diamond
	    /** @class Editable view for a DatasetCollectionElement that is also an DatasetAssociation
	     *      (a dataset contained in a dataset collection).
	     */
	    var DatasetDCEListItemEdit = DATASET_LI_EDIT.DatasetListItemEdit.extend(
	    /** @lends DatasetDCEListItemEdit.prototype */{
	
	        /** set up */
	        initialize: function (attributes) {
	            DATASET_LI_EDIT.DatasetListItemEdit.prototype.initialize.call(this, attributes);
	        },
	
	        // NOTE: this does not inherit from DatasetDCEListItemView - so we duplicate this here
	        //TODO: fix
	        /** In this override, only get details if in the ready state.
	         *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
	         */
	        _fetchModelDetails: function () {
	            var view = this;
	            if (view.model.inReadyState() && !view.model.hasDetails()) {
	                return view.model.fetch({ silent: true });
	            }
	            return jQuery.when();
	        },
	
	        /** Override to remove delete button */
	        _renderDeleteButton: function () {
	            return null;
	        },
	
	        // ......................................................................... misc
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'DatasetDCEListItemEdit(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    DatasetDCEListItemEdit.prototype.templates = function () {
	
	        return _.extend({}, DATASET_LI_EDIT.DatasetListItemEdit.prototype.templates, {
	            titleBar: DC_LI.DatasetDCEListItemView.prototype.templates.titleBar
	        });
	    }();
	
	    //==============================================================================
	    /** @class Read only view for a DatasetCollectionElement that is also a DatasetCollection
	     *      (a nested DC).
	     */
	    var NestedDCDCEListItemEdit = DC_LI.NestedDCDCEListItemView.extend(
	    /** @lends NestedDCDCEListItemEdit.prototype */{
	
	        /** String representation */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'NestedDCDCEListItemEdit(' + modelString + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        DCListItemEdit: DCListItemEdit,
	        DCEListItemEdit: DCEListItemEdit,
	        DatasetDCEListItemEdit: DatasetDCEListItemEdit,
	        NestedDCDCEListItemEdit: NestedDCDCEListItemEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(59), __webpack_require__(122), __webpack_require__(7), __webpack_require__(45), __webpack_require__(26), __webpack_require__(6), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DC_VIEW, DC_MODEL, DC_EDIT, BASE_MVC, TAGS, faIconButton, _l) {
	
	    'use strict';
	    /* =============================================================================
	    TODO:
	    
	    ============================================================================= */
	    /** @class editable View/Controller for a dataset collection.
	     */
	
	    var _super = DC_VIEW.CollectionView;
	    var CollectionViewEdit = _super.extend(
	    /** @lends CollectionView.prototype */{
	        //MODEL is either a DatasetCollection (or subclass) or a DatasetCollectionElement (list of pairs)
	
	        /** logger used to record this.log messages, commonly set to console */
	        //logger              : console,
	
	        /** sub view class used for datasets */
	        DatasetDCEViewClass: DC_EDIT.DatasetDCEListItemEdit,
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_EDIT.NestedDCDCEListItemEdit,
	
	        // ......................................................................... SET UP
	        /** Set up the view, set up storage, bind listeners to HistoryContents events
	         *  @param {Object} attributes optional settings for the panel
	         */
	        initialize: function (attributes) {
	            _super.prototype.initialize.call(this, attributes);
	        },
	
	        /** In this override, make the collection name editable
	         */
	        _setUpBehaviors: function ($where) {
	            $where = $where || this.$el;
	            _super.prototype._setUpBehaviors.call(this, $where);
	            if (!this.model) {
	                return;
	            }
	
	            // anon users shouldn't have access to any of the following
	            if (!Galaxy.user || Galaxy.user.isAnonymous()) {
	                return;
	            }
	
	            this.tagsEditorShown = true;
	
	            //TODO: extract
	            var panel = this,
	                nameSelector = '> .controls .name';
	            $where.find(nameSelector).attr('title', _l('Click to rename collection')).tooltip({ placement: 'bottom' }).make_text_editable({
	                on_finish: function (newName) {
	                    var previousName = panel.model.get('name');
	                    if (newName && newName !== previousName) {
	                        panel.$el.find(nameSelector).text(newName);
	                        panel.model.save({ name: newName }).fail(function () {
	                            panel.$el.find(nameSelector).text(panel.model.previous('name'));
	                        });
	                    } else {
	                        panel.$el.find(nameSelector).text(previousName);
	                    }
	                }
	            });
	            this.tagsEditor = new TAGS.TagsEditor({
	                model: this.model,
	                el: $where.find('.tags-display'),
	                onshowFirstTime: function () {
	                    this.render();
	                },
	                usePrompt: false
	            });
	            this.tagsEditor.toggle(true);
	        },
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'CollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class non-editable, read-only View/Controller for a dataset collection. */
	    var ListCollectionViewEdit = CollectionViewEdit.extend(
	    /** @lends ListCollectionView.prototype */{
	
	        //TODO: not strictly needed - due to switch in CollectionView._getContentClass
	        /** sub view class used for datasets */
	        DatasetDCEViewClass: DC_EDIT.DatasetDCEListItemEdit,
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'ListCollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class Editable, read-only View/Controller for a dataset collection. */
	    var PairCollectionViewEdit = ListCollectionViewEdit.extend(
	    /** @lends PairCollectionViewEdit.prototype */{
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'PairCollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class Editable (roughly since these collections are immutable),
	     *  View/Controller for a dataset collection.
	     */
	    var NestedPairCollectionViewEdit = PairCollectionViewEdit.extend(
	    /** @lends NestedPairCollectionViewEdit.prototype */{
	
	        /** Override to remove the editable text from the name/identifier - these collections are considered immutable */
	        _setUpBehaviors: function ($where) {
	            _super.prototype._setUpBehaviors.call(this, $where);
	        },
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'NestedPairCollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class editable, View/Controller for a list of pairs dataset collection. */
	    var ListOfPairsCollectionViewEdit = CollectionViewEdit.extend(
	    /** @lends ListOfPairsCollectionView.prototype */{
	
	        //TODO: not strictly needed - due to switch in CollectionView._getContentClass
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_EDIT.NestedDCDCEListItemEdit.extend({
	            foldoutPanelClass: NestedPairCollectionViewEdit
	        }),
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'ListOfPairsCollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    // =============================================================================
	    /** @class View/Controller for a list of lists dataset collection. */
	    var ListOfListsCollectionViewEdit = CollectionViewEdit.extend(
	    /** @lends ListOfListsCollectionView.prototype */{
	
	        //TODO: not strictly needed - due to switch in CollectionView._getContentClass
	        /** sub view class used for nested collections */
	        NestedDCDCEViewClass: DC_EDIT.NestedDCDCEListItemEdit.extend({
	            foldoutPanelClass: NestedPairCollectionViewEdit
	        }),
	
	        // ........................................................................ misc
	        /** string rep */
	        toString: function () {
	            return 'ListOfListsCollectionViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        CollectionViewEdit: CollectionViewEdit,
	        ListCollectionViewEdit: ListCollectionViewEdit,
	        PairCollectionViewEdit: PairCollectionViewEdit,
	        ListOfPairsCollectionViewEdit: ListOfPairsCollectionViewEdit,
	        ListOfListsCollectionViewEdit: ListOfListsCollectionViewEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, jQuery, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(156), __webpack_require__(100), __webpack_require__(82), __webpack_require__(7), __webpack_require__(6), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_RESULT__ = function (levenshteinDistance, naturalSort, baseCreator, baseMVC, _l) {
	
	    'use strict';
	
	    var logNamespace = 'collections';
	    /* ============================================================================
	    TODO:
	    
	    
	    PROGRAMMATICALLY:
	    currPanel.once( 'rendered', function(){
	        currPanel.showSelectors();
	        currPanel.selectAll();
	        _.last( currPanel.actionsPopup.options ).func();
	    });
	    
	    ============================================================================ */
	    /** A view for paired datasets in the collections creator.
	     */
	    var PairView = Backbone.View.extend(baseMVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        tagName: 'li',
	        className: 'dataset paired',
	
	        initialize: function (attributes) {
	            this.pair = attributes.pair || {};
	        },
	
	        template: _.template(['<span class="forward-dataset-name flex-column"><%- pair.forward.name %></span>', '<span class="pair-name-column flex-column">', '<span class="pair-name"><%- pair.name %></span>', '</span>', '<span class="reverse-dataset-name flex-column"><%- pair.reverse.name %></span>'].join('')),
	
	        render: function () {
	            this.$el.attr('draggable', true).data('pair', this.pair).html(this.template({ pair: this.pair })).addClass('flex-column-container');
	            return this;
	        },
	
	        events: {
	            'dragstart': '_dragstart',
	            'dragend': '_dragend',
	            'dragover': '_sendToParent',
	            'drop': '_sendToParent'
	        },
	
	        /** dragging pairs for re-ordering */
	        _dragstart: function (ev) {
	            ev.currentTarget.style.opacity = '0.4';
	            if (ev.originalEvent) {
	                ev = ev.originalEvent;
	            }
	
	            ev.dataTransfer.effectAllowed = 'move';
	            ev.dataTransfer.setData('text/plain', JSON.stringify(this.pair));
	
	            this.$el.parent().trigger('pair.dragstart', [this]);
	        },
	
	        /** dragging pairs for re-ordering */
	        _dragend: function (ev) {
	            ev.currentTarget.style.opacity = '1.0';
	            this.$el.parent().trigger('pair.dragend', [this]);
	        },
	
	        /** manually bubble up an event to the parent/container */
	        _sendToParent: function (ev) {
	            this.$el.parent().trigger(ev);
	        },
	
	        /** string rep */
	        toString: function () {
	            return 'PairView(' + this.pair.name + ')';
	        }
	    });
	
	    // ============================================================================
	    /** returns an autopair function that uses the provided options.match function */
	    function autoPairFnBuilder(options) {
	        options = options || {};
	        options.createPair = options.createPair || function _defaultCreatePair(params) {
	            params = params || {};
	            var a = params.listA.splice(params.indexA, 1)[0],
	                b = params.listB.splice(params.indexB, 1)[0],
	                aInBIndex = params.listB.indexOf(a),
	                bInAIndex = params.listA.indexOf(b);
	            if (aInBIndex !== -1) {
	                params.listB.splice(aInBIndex, 1);
	            }
	            if (bInAIndex !== -1) {
	                params.listA.splice(bInAIndex, 1);
	            }
	            return this._pair(a, b, { silent: true });
	        };
	        // compile these here outside of the loop
	        var _regexps = [];
	        function getRegExps() {
	            if (!_regexps.length) {
	                _regexps = [new RegExp(this.filters[0]), new RegExp(this.filters[1])];
	            }
	            return _regexps;
	        }
	        // mangle params as needed
	        options.preprocessMatch = options.preprocessMatch || function _defaultPreprocessMatch(params) {
	            var regexps = getRegExps.call(this);
	            return _.extend(params, {
	                matchTo: params.matchTo.name.replace(regexps[0], ''),
	                possible: params.possible.name.replace(regexps[1], '')
	            });
	        };
	
	        return function _strategy(params) {
	            this.debug('autopair _strategy ---------------------------');
	            params = params || {};
	            var listA = params.listA,
	                listB = params.listB,
	                indexA = 0,
	                indexB,
	                bestMatch = {
	                score: 0.0,
	                index: null
	            },
	                paired = [];
	            //console.debug( 'params:', JSON.stringify( params, null, '  ' ) );
	            this.debug('starting list lens:', listA.length, listB.length);
	            this.debug('bestMatch (starting):', JSON.stringify(bestMatch, null, '  '));
	
	            while (indexA < listA.length) {
	                var matchTo = listA[indexA];
	                bestMatch.score = 0.0;
	
	                for (indexB = 0; indexB < listB.length; indexB++) {
	                    var possible = listB[indexB];
	                    this.debug(indexA + ':' + matchTo.name);
	                    this.debug(indexB + ':' + possible.name);
	
	                    // no matching with self
	                    if (listA[indexA] !== listB[indexB]) {
	                        bestMatch = options.match.call(this, options.preprocessMatch.call(this, {
	                            matchTo: matchTo,
	                            possible: possible,
	                            index: indexB,
	                            bestMatch: bestMatch
	                        }));
	                        this.debug('bestMatch:', JSON.stringify(bestMatch, null, '  '));
	                        if (bestMatch.score === 1.0) {
	                            this.debug('breaking early due to perfect match');
	                            break;
	                        }
	                    }
	                }
	                var scoreThreshold = options.scoreThreshold.call(this);
	                this.debug('scoreThreshold:', scoreThreshold);
	                this.debug('bestMatch.score:', bestMatch.score);
	
	                if (bestMatch.score >= scoreThreshold) {
	                    //console.debug( 'autoPairFnBuilder.strategy', listA[ indexA ].name, listB[ bestMatch.index ].name );
	                    paired.push(options.createPair.call(this, {
	                        listA: listA,
	                        indexA: indexA,
	                        listB: listB,
	                        indexB: bestMatch.index
	                    }));
	                    //console.debug( 'list lens now:', listA.length, listB.length );
	                } else {
	                    indexA += 1;
	                }
	                if (!listA.length || !listB.length) {
	                    return paired;
	                }
	            }
	            this.debug('paired:', JSON.stringify(paired, null, '  '));
	            this.debug('autopair _strategy ---------------------------');
	            return paired;
	        };
	    }
	
	    // ============================================================================
	    /** An interface for building collections of paired datasets.
	     */
	    var PairedCollectionCreator = Backbone.View.extend(baseMVC.LoggableMixin).extend(baseCreator.CollectionCreatorMixin).extend({
	        _logNamespace: logNamespace,
	
	        className: 'list-of-pairs-collection-creator collection-creator flex-row-container',
	
	        /** set up initial options, instance vars, behaviors, and autopair (if set to do so) */
	        initialize: function (attributes) {
	            this.metric('PairedCollectionCreator.initialize', attributes);
	            //this.debug( '-- PairedCollectionCreator:', attributes );
	
	            attributes = _.defaults(attributes, {
	                datasets: [],
	                filters: this.DEFAULT_FILTERS,
	                automaticallyPair: true,
	                strategy: 'lcs',
	                matchPercentage: 0.9,
	                twoPassAutopairing: true
	            });
	
	            /** unordered, original list */
	            this.initialList = attributes.datasets;
	
	            /** is this from a history? if so, what's its id? */
	            this.historyId = attributes.historyId;
	
	            /** which filters should be used initially? (String[2] or name in commonFilters) */
	            this.filters = this.commonFilters[attributes.filters] || this.commonFilters[this.DEFAULT_FILTERS];
	            if (_.isArray(attributes.filters)) {
	                this.filters = attributes.filters;
	            }
	
	            /** try to auto pair the unpaired datasets on load? */
	            this.automaticallyPair = attributes.automaticallyPair;
	
	            /** what method to use for auto pairing (will be passed aggression level) */
	            this.strategy = this.strategies[attributes.strategy] || this.strategies[this.DEFAULT_STRATEGY];
	            if (_.isFunction(attributes.strategy)) {
	                this.strategy = attributes.strategy;
	            }
	
	            /** distance/mismatch level allowed for autopairing */
	            this.matchPercentage = attributes.matchPercentage;
	
	            /** try to autopair using simple first, then this.strategy on the remainder */
	            this.twoPassAutopairing = attributes.twoPassAutopairing;
	
	            /** remove file extensions (\.*) from created pair names? */
	            this.removeExtensions = true;
	            //this.removeExtensions = false;
	
	            /** fn to call when the cancel button is clicked (scoped to this) - if falsy, no btn is displayed */
	            this.oncancel = attributes.oncancel;
	            /** fn to call when the collection is created (scoped to this) */
	            this.oncreate = attributes.oncreate;
	
	            /** fn to call when the cancel button is clicked (scoped to this) - if falsy, no btn is displayed */
	            this.autoscrollDist = attributes.autoscrollDist || 24;
	
	            /** is the unpaired panel shown? */
	            this.unpairedPanelHidden = false;
	            /** is the paired panel shown? */
	            this.pairedPanelHidden = false;
	
	            /** DOM elements currently being dragged */
	            this.$dragging = null;
	
	            /** Used for blocking UI events during ajax/operations (don't post twice) */
	            this.blocking = false;
	
	            this._setUpCommonSettings(attributes);
	            this._setUpBehaviors();
	            this._dataSetUp();
	        },
	
	        /** map of common filter pairs by name */
	        commonFilters: {
	            illumina: ['_1', '_2'],
	            Rs: ['_R1', '_R2']
	        },
	        /** which commonFilter to use by default */
	        DEFAULT_FILTERS: 'illumina',
	
	        /** map of name->fn for autopairing */
	        strategies: {
	            'simple': 'autopairSimple',
	            'lcs': 'autopairLCS',
	            'levenshtein': 'autopairLevenshtein'
	        },
	        /** default autopair strategy name */
	        DEFAULT_STRATEGY: 'lcs',
	
	        // ------------------------------------------------------------------------ process raw list
	        /** set up main data: cache initialList, sort, and autopair */
	        _dataSetUp: function () {
	            //this.debug( '-- _dataSetUp' );
	
	            this.paired = [];
	            this.unpaired = [];
	
	            this.selectedIds = [];
	
	            // sort initial list, add ids if needed, and save new working copy to unpaired
	            this._sortInitialList();
	            this._ensureIds();
	            this.unpaired = this.initialList.slice(0);
	
	            if (this.automaticallyPair) {
	                this.autoPair();
	                this.once('rendered:initial', function () {
	                    this.trigger('autopair');
	                });
	            }
	        },
	
	        /** sort initial list */
	        _sortInitialList: function () {
	            //this.debug( '-- _sortInitialList' );
	            this._sortDatasetList(this.initialList);
	        },
	
	        /** sort a list of datasets */
	        _sortDatasetList: function (list) {
	            // currently only natural sort by name
	            list.sort(function (a, b) {
	                return naturalSort(a.name, b.name);
	            });
	            return list;
	        },
	
	        /** add ids to dataset objs in initial list if none */
	        _ensureIds: function () {
	            this.initialList.forEach(function (dataset) {
	                if (!dataset.hasOwnProperty('id')) {
	                    dataset.id = _.uniqueId();
	                }
	            });
	            return this.initialList;
	        },
	
	        /** split initial list into two lists, those that pass forward filters & those passing reverse */
	        _splitByFilters: function () {
	            var regexFilters = this.filters.map(function (stringFilter) {
	                return new RegExp(stringFilter);
	            }),
	                split = [[], []];
	
	            function _filter(unpaired, filter) {
	                return filter.test(unpaired.name);
	                //return dataset.name.indexOf( filter ) >= 0;
	            }
	            this.unpaired.forEach(function _filterEach(unpaired) {
	                // 90% of the time this seems to work, but:
	                //TODO: this treats *all* strings as regex which may confuse people - possibly check for // surrounding?
	                //  would need explanation in help as well
	                regexFilters.forEach(function (filter, i) {
	                    if (_filter(unpaired, filter)) {
	                        split[i].push(unpaired);
	                    }
	                });
	            });
	            return split;
	        },
	
	        /** add a dataset to the unpaired list in it's proper order */
	        _addToUnpaired: function (dataset) {
	            // currently, unpaired is natural sorted by name, use binary search to find insertion point
	            var binSearchSortedIndex = function (low, hi) {
	                if (low === hi) {
	                    return low;
	                }
	
	                var mid = Math.floor((hi - low) / 2) + low,
	                    compared = naturalSort(dataset.name, this.unpaired[mid].name);
	
	                if (compared < 0) {
	                    return binSearchSortedIndex(low, mid);
	                } else if (compared > 0) {
	                    return binSearchSortedIndex(mid + 1, hi);
	                }
	                // walk the equal to find the last
	                while (this.unpaired[mid] && this.unpaired[mid].name === dataset.name) {
	                    mid++;
	                }
	                return mid;
	            }.bind(this);
	
	            this.unpaired.splice(binSearchSortedIndex(0, this.unpaired.length), 0, dataset);
	        },
	
	        // ------------------------------------------------------------------------ auto pairing
	        /** two passes to automatically create pairs:
	         *  use both simpleAutoPair, then the fn mentioned in strategy
	         */
	        autoPair: function (strategy) {
	            // split first using exact matching
	            var split = this._splitByFilters(),
	                paired = [];
	            if (this.twoPassAutopairing) {
	                paired = this.autopairSimple({
	                    listA: split[0],
	                    listB: split[1]
	                });
	                split = this._splitByFilters();
	            }
	
	            // uncomment to see printlns while running tests
	            //this.debug = function(){ console.log.apply( console, arguments ); };
	
	            // then try the remainder with something less strict
	            strategy = strategy || this.strategy;
	            split = this._splitByFilters();
	            paired = paired.concat(this[strategy].call(this, {
	                listA: split[0],
	                listB: split[1]
	            }));
	            return paired;
	        },
	
	        /** autopair by exact match */
	        autopairSimple: autoPairFnBuilder({
	            scoreThreshold: function () {
	                return 0.6;
	            },
	            match: function _match(params) {
	                params = params || {};
	                if (params.matchTo === params.possible) {
	                    return {
	                        index: params.index,
	                        score: 1.0
	                    };
	                }
	                return params.bestMatch;
	            }
	        }),
	
	        /** autopair by levenshtein edit distance scoring */
	        autopairLevenshtein: autoPairFnBuilder({
	            scoreThreshold: function () {
	                return this.matchPercentage;
	            },
	            match: function _matches(params) {
	                params = params || {};
	                var distance = levenshteinDistance(params.matchTo, params.possible),
	                    score = 1.0 - distance / Math.max(params.matchTo.length, params.possible.length);
	                if (score > params.bestMatch.score) {
	                    return {
	                        index: params.index,
	                        score: score
	                    };
	                }
	                return params.bestMatch;
	            }
	        }),
	
	        /** autopair by longest common substrings scoring */
	        autopairLCS: autoPairFnBuilder({
	            scoreThreshold: function () {
	                return this.matchPercentage;
	            },
	            match: function _matches(params) {
	                params = params || {};
	                var match = this._naiveStartingAndEndingLCS(params.matchTo, params.possible).length,
	                    score = match / Math.max(params.matchTo.length, params.possible.length);
	                if (score > params.bestMatch.score) {
	                    return {
	                        index: params.index,
	                        score: score
	                    };
	                }
	                return params.bestMatch;
	            }
	        }),
	
	        /** return the concat'd longest common prefix and suffix from two strings */
	        _naiveStartingAndEndingLCS: function (s1, s2) {
	            var fwdLCS = '',
	                revLCS = '',
	                i = 0,
	                j = 0;
	            while (i < s1.length && i < s2.length) {
	                if (s1[i] !== s2[i]) {
	                    break;
	                }
	                fwdLCS += s1[i];
	                i += 1;
	            }
	            if (i === s1.length) {
	                return s1;
	            }
	            if (i === s2.length) {
	                return s2;
	            }
	
	            i = s1.length - 1;
	            j = s2.length - 1;
	            while (i >= 0 && j >= 0) {
	                if (s1[i] !== s2[j]) {
	                    break;
	                }
	                revLCS = [s1[i], revLCS].join('');
	                i -= 1;
	                j -= 1;
	            }
	            return fwdLCS + revLCS;
	        },
	
	        // ------------------------------------------------------------------------ pairing / unpairing
	        /** create a pair from fwd and rev, removing them from unpaired, and placing the new pair in paired */
	        _pair: function (fwd, rev, options) {
	            options = options || {};
	            this.debug('_pair:', fwd, rev);
	            var pair = this._createPair(fwd, rev, options.name);
	            this.paired.push(pair);
	            this.unpaired = _.without(this.unpaired, fwd, rev);
	            if (!options.silent) {
	                this.trigger('pair:new', pair);
	            }
	            return pair;
	        },
	
	        /** create a pair Object from fwd and rev, adding the name attribute (will guess if not given) */
	        _createPair: function (fwd, rev, name) {
	            // ensure existance and don't pair something with itself
	            if (!(fwd && rev) || fwd === rev) {
	                throw new Error('Bad pairing: ' + [JSON.stringify(fwd), JSON.stringify(rev)]);
	            }
	            name = name || this._guessNameForPair(fwd, rev);
	            return { forward: fwd, name: name, reverse: rev };
	        },
	
	        /** try to find a good pair name for the given fwd and rev datasets */
	        _guessNameForPair: function (fwd, rev, removeExtensions) {
	            removeExtensions = removeExtensions !== undefined ? removeExtensions : this.removeExtensions;
	            var fwdName = fwd.name,
	                revName = rev.name,
	                lcs = this._naiveStartingAndEndingLCS(fwdName.replace(new RegExp(this.filters[0]), ''), revName.replace(new RegExp(this.filters[1]), ''));
	            if (removeExtensions) {
	                var lastDotIndex = lcs.lastIndexOf('.');
	                if (lastDotIndex > 0) {
	                    var extension = lcs.slice(lastDotIndex, lcs.length);
	                    lcs = lcs.replace(extension, '');
	                    fwdName = fwdName.replace(extension, '');
	                    revName = revName.replace(extension, '');
	                }
	            }
	            return lcs || fwdName + ' & ' + revName;
	        },
	
	        /** unpair a pair, removing it from paired, and adding the fwd,rev datasets back into unpaired */
	        _unpair: function (pair, options) {
	            options = options || {};
	            if (!pair) {
	                throw new Error('Bad pair: ' + JSON.stringify(pair));
	            }
	            this.paired = _.without(this.paired, pair);
	            this._addToUnpaired(pair.forward);
	            this._addToUnpaired(pair.reverse);
	
	            if (!options.silent) {
	                this.trigger('pair:unpair', [pair]);
	            }
	            return pair;
	        },
	
	        /** unpair all paired datasets */
	        unpairAll: function () {
	            var pairs = [];
	            while (this.paired.length) {
	                pairs.push(this._unpair(this.paired[0], { silent: true }));
	            }
	            this.trigger('pair:unpair', pairs);
	        },
	
	        // ------------------------------------------------------------------------ API
	        /** convert a pair into JSON compatible with the collections API */
	        _pairToJSON: function (pair, src) {
	            src = src || 'hda';
	            //TODO: consider making this the pair structure when created instead
	            return {
	                collection_type: 'paired',
	                src: 'new_collection',
	                name: pair.name,
	                element_identifiers: [{
	                    name: 'forward',
	                    id: pair.forward.id,
	                    src: src
	                }, {
	                    name: 'reverse',
	                    id: pair.reverse.id,
	                    src: src
	                }]
	            };
	        },
	
	        /** create the collection via the API
	         *  @returns {jQuery.xhr Object}    the jquery ajax request
	         */
	        createList: function (name) {
	            var creator = this,
	                url = Galaxy.root + 'api/histories/' + this.historyId + '/contents/dataset_collections';
	
	            //TODO: use ListPairedCollection.create()
	            var ajaxData = {
	                type: 'dataset_collection',
	                collection_type: 'list:paired',
	                hide_source_items: creator.hideOriginals || false,
	                name: _.escape(name || creator.$('.collection-name').val()),
	                element_identifiers: creator.paired.map(function (pair) {
	                    return creator._pairToJSON(pair);
	                })
	
	            };
	            //this.debug( JSON.stringify( ajaxData ) );
	            creator.blocking = true;
	            return jQuery.ajax(url, {
	                type: 'POST',
	                contentType: 'application/json',
	                dataType: 'json',
	                data: JSON.stringify(ajaxData)
	            }).always(function () {
	                creator.blocking = false;
	            }).fail(function (xhr, status, message) {
	                creator._ajaxErrHandler(xhr, status, message);
	            }).done(function (response, message, xhr) {
	                //this.info( 'ok', response, message, xhr );
	                creator.trigger('collection:created', response, message, xhr);
	                creator.metric('collection:created', response);
	                if (typeof creator.oncreate === 'function') {
	                    creator.oncreate.call(this, response, message, xhr);
	                }
	            });
	        },
	
	        /** handle ajax errors with feedback and details to the user (if available) */
	        _ajaxErrHandler: function (xhr, status, message) {
	            this.error(xhr, status, message);
	            var content = _l('An error occurred while creating this collection');
	            if (xhr) {
	                if (xhr.readyState === 0 && xhr.status === 0) {
	                    content += ': ' + _l('Galaxy could not be reached and may be updating.') + _l(' Try again in a few minutes.');
	                } else if (xhr.responseJSON) {
	                    content += '<br /><pre>' + JSON.stringify(xhr.responseJSON) + '</pre>';
	                } else {
	                    content += ': ' + message;
	                }
	            }
	            creator._showAlert(content, 'alert-danger');
	        },
	
	        // ------------------------------------------------------------------------ rendering
	        /** render the entire interface */
	        render: function (speed, callback) {
	            //this.debug( '-- _render' );
	            //this.$el.empty().html( this.templates.main() );
	            this.$el.empty().html(this.templates.main());
	            this._renderHeader(speed);
	            this._renderMiddle(speed);
	            this._renderFooter(speed);
	            this._addPluginComponents();
	            this.trigger('rendered', this);
	            return this;
	        },
	
	        /** render the header section */
	        _renderHeader: function (speed, callback) {
	            //this.debug( '-- _renderHeader' );
	            var $header = this.$('.header').empty().html(this.templates.header()).find('.help-content').prepend($(this.templates.helpContent()));
	
	            this._renderFilters();
	            return $header;
	        },
	        /** fill the filter inputs with the filter values */
	        _renderFilters: function () {
	            return this.$('.forward-column .column-header input').val(this.filters[0]).add(this.$('.reverse-column .column-header input').val(this.filters[1]));
	        },
	
	        /** render the middle including unpaired and paired sections (which may be hidden) */
	        _renderMiddle: function (speed, callback) {
	            var $middle = this.$('.middle').empty().html(this.templates.middle());
	
	            // (re-) hide the un/paired panels based on instance vars
	            if (this.unpairedPanelHidden) {
	                this.$('.unpaired-columns').hide();
	            } else if (this.pairedPanelHidden) {
	                this.$('.paired-columns').hide();
	            }
	
	            this._renderUnpaired();
	            this._renderPaired();
	            return $middle;
	        },
	        /** render the unpaired section, showing datasets accrd. to filters, update the unpaired counts */
	        _renderUnpaired: function (speed, callback) {
	            //this.debug( '-- _renderUnpaired' );
	            var creator = this,
	                $fwd,
	                $rev,
	                $prd = [],
	                split = this._splitByFilters();
	            // update unpaired counts
	            this.$('.forward-column .title').text([split[0].length, _l('unpaired forward')].join(' '));
	            this.$('.forward-column .unpaired-info').text(this._renderUnpairedDisplayStr(this.unpaired.length - split[0].length));
	            this.$('.reverse-column .title').text([split[1].length, _l('unpaired reverse')].join(' '));
	            this.$('.reverse-column .unpaired-info').text(this._renderUnpairedDisplayStr(this.unpaired.length - split[1].length));
	
	            this.$('.unpaired-columns .column-datasets').empty();
	
	            // show/hide the auto pair button if any unpaired are left
	            this.$('.autopair-link').toggle(this.unpaired.length !== 0);
	            if (this.unpaired.length === 0) {
	                this._renderUnpairedEmpty();
	                return;
	            }
	
	            // create the dataset dom arrays
	            $rev = split[1].map(function (dataset, i) {
	                // if there'll be a fwd dataset across the way, add a button to pair the row
	                if (split[0][i] !== undefined && split[0][i] !== dataset) {
	                    $prd.push(creator._renderPairButton());
	                }
	                return creator._renderUnpairedDataset(dataset);
	            });
	            $fwd = split[0].map(function (dataset) {
	                return creator._renderUnpairedDataset(dataset);
	            });
	
	            if (!$fwd.length && !$rev.length) {
	                this._renderUnpairedNotShown();
	                return;
	            }
	            // add to appropo cols
	            //TODO: not the best way to render - consider rendering the entire unpaired-columns section in a fragment
	            //  and swapping out that
	            this.$('.unpaired-columns .forward-column .column-datasets').append($fwd).add(this.$('.unpaired-columns .paired-column .column-datasets').append($prd)).add(this.$('.unpaired-columns .reverse-column .column-datasets').append($rev));
	            this._adjUnpairedOnScrollbar();
	        },
	        /** return a string to display the count of filtered out datasets */
	        _renderUnpairedDisplayStr: function (numFiltered) {
	            return ['(', numFiltered, ' ', _l('filtered out'), ')'].join('');
	        },
	        /** return an unattached jQuery DOM element to represent an unpaired dataset */
	        _renderUnpairedDataset: function (dataset) {
	            //TODO: to underscore template
	            return $('<li/>').attr('id', 'dataset-' + dataset.id).addClass('dataset unpaired').attr('draggable', true).addClass(dataset.selected ? 'selected' : '').append($('<span/>').addClass('dataset-name').text(dataset.name))
	            //??
	            .data('dataset', dataset);
	        },
	        /** render the button that may go between unpaired datasets, allowing the user to pair a row */
	        _renderPairButton: function () {
	            //TODO: *not* a dataset - don't pretend like it is
	            return $('<li/>').addClass('dataset unpaired').append($('<span/>').addClass('dataset-name').text(_l('Pair these datasets')));
	        },
	        /** a message to display when no unpaired left */
	        _renderUnpairedEmpty: function () {
	            //this.debug( '-- renderUnpairedEmpty' );
	            var $msg = $('<div class="empty-message"></div>').text('(' + _l('no remaining unpaired datasets') + ')');
	            this.$('.unpaired-columns .paired-column .column-datasets').empty().prepend($msg);
	            return $msg;
	        },
	        /** a message to display when no unpaired can be shown with the current filters */
	        _renderUnpairedNotShown: function () {
	            //this.debug( '-- renderUnpairedEmpty' );
	            var $msg = $('<div class="empty-message"></div>').text('(' + _l('no datasets were found matching the current filters') + ')');
	            this.$('.unpaired-columns .paired-column .column-datasets').empty().prepend($msg);
	            return $msg;
	        },
	        /** try to detect if the unpaired section has a scrollbar and adjust left column for better centering of all */
	        _adjUnpairedOnScrollbar: function () {
	            var $unpairedColumns = this.$('.unpaired-columns').last(),
	                $firstDataset = this.$('.unpaired-columns .reverse-column .dataset').first();
	            if (!$firstDataset.length) {
	                return;
	            }
	            var ucRight = $unpairedColumns.offset().left + $unpairedColumns.outerWidth(),
	                dsRight = $firstDataset.offset().left + $firstDataset.outerWidth(),
	                rightDiff = Math.floor(ucRight) - Math.floor(dsRight);
	            //this.debug( 'rightDiff:', ucRight, '-', dsRight, '=', rightDiff );
	            this.$('.unpaired-columns .forward-column').css('margin-left', rightDiff > 0 ? rightDiff : 0);
	        },
	
	        /** render the paired section and update counts of paired datasets */
	        _renderPaired: function (speed, callback) {
	            //this.debug( '-- _renderPaired' );
	            this.$('.paired-column-title .title').text([this.paired.length, _l('paired')].join(' '));
	            // show/hide the unpair all link
	            this.$('.unpair-all-link').toggle(this.paired.length !== 0);
	            if (this.paired.length === 0) {
	                this._renderPairedEmpty();
	                return;
	                //TODO: would be best to return here (the $columns)
	            } else {
	                // show/hide 'remove extensions link' when any paired and they seem to have extensions
	                this.$('.remove-extensions-link').show();
	            }
	
	            this.$('.paired-columns .column-datasets').empty();
	            var creator = this;
	            this.paired.forEach(function (pair, i) {
	                //TODO: cache these?
	                var pairView = new PairView({ pair: pair });
	                creator.$('.paired-columns .column-datasets').append(pairView.render().$el).append(['<button class="unpair-btn">', '<span class="fa fa-unlink" title="', _l('Unpair'), '"></span>', '</button>'].join(''));
	            });
	        },
	        /** a message to display when none paired */
	        _renderPairedEmpty: function () {
	            var $msg = $('<div class="empty-message"></div>').text('(' + _l('no paired datasets yet') + ')');
	            this.$('.paired-columns .column-datasets').empty().prepend($msg);
	            return $msg;
	        },
	
	        footerSettings: {
	            '.hide-originals': 'hideOriginals',
	            '.remove-extensions': 'removeExtensions'
	        },
	
	        /** add any jQuery/bootstrap/custom plugins to elements rendered */
	        _addPluginComponents: function () {
	            this._chooseFiltersPopover('.choose-filters-link');
	            this.$('.help-content i').hoverhighlight('.collection-creator', 'rgba( 64, 255, 255, 1.0 )');
	        },
	
	        /** build a filter selection popover allowing selection of common filter pairs */
	        _chooseFiltersPopover: function (selector) {
	            function filterChoice(val1, val2) {
	                return ['<button class="filter-choice btn" ', 'data-forward="', val1, '" data-reverse="', val2, '">', _l('Forward'), ': ', val1, ', ', _l('Reverse'), ': ', val2, '</button>'].join('');
	            }
	            var $popoverContent = $(_.template(['<div class="choose-filters">', '<div class="help">', _l('Choose from the following filters to change which unpaired reads are shown in the display'), ':</div>', _.values(this.commonFilters).map(function (filterSet) {
	                return filterChoice(filterSet[0], filterSet[1]);
	            }).join(''), '</div>'].join(''))({}));
	
	            return this.$(selector).popover({
	                container: '.collection-creator',
	                placement: 'bottom',
	                html: true,
	                //animation   : false,
	                content: $popoverContent
	            });
	        },
	
	        /** add (or clear if clear is truthy) a validation warning to what */
	        _validationWarning: function (what, clear) {
	            var VALIDATION_CLASS = 'validation-warning';
	            if (what === 'name') {
	                what = this.$('.collection-name').add(this.$('.collection-name-prompt'));
	                this.$('.collection-name').focus().select();
	            }
	            if (clear) {
	                what = what || this.$('.' + VALIDATION_CLASS);
	                what.removeClass(VALIDATION_CLASS);
	            } else {
	                what.addClass(VALIDATION_CLASS);
	            }
	        },
	
	        // ------------------------------------------------------------------------ events
	        /** set up event handlers on self */
	        _setUpBehaviors: function () {
	            this.once('rendered', function () {
	                this.trigger('rendered:initial', this);
	            });
	
	            this.on('pair:new', function () {
	                //TODO: ideally only re-render the columns (or even elements) involved
	                this._renderUnpaired();
	                this._renderPaired();
	
	                // scroll to bottom where new pairs are added
	                //TODO: this doesn't seem to work - innerHeight sticks at 133...
	                //  may have to do with improper flex columns
	                //var $pairedView = this.$( '.paired-columns' );
	                //$pairedView.scrollTop( $pairedView.innerHeight() );
	                //this.debug( $pairedView.height() )
	                this.$('.paired-columns').scrollTop(8000000);
	            });
	            this.on('pair:unpair', function (pairs) {
	                //TODO: ideally only re-render the columns (or even elements) involved
	                this._renderUnpaired();
	                this._renderPaired();
	                this.splitView();
	            });
	
	            this.on('filter-change', function () {
	                this.filters = [this.$('.forward-unpaired-filter input').val(), this.$('.reverse-unpaired-filter input').val()];
	                this.metric('filter-change', this.filters);
	                this._renderFilters();
	                this._renderUnpaired();
	            });
	
	            this.on('autopair', function () {
	                this._renderUnpaired();
	                this._renderPaired();
	
	                var message,
	                    msgClass = null;
	                if (this.paired.length) {
	                    msgClass = 'alert-success';
	                    message = this.paired.length + ' ' + _l('pairs created');
	                    if (!this.unpaired.length) {
	                        message += ': ' + _l('all datasets have been successfully paired');
	                        this.hideUnpaired();
	                        this.$('.collection-name').focus();
	                    }
	                } else {
	                    message = _l(['Could not automatically create any pairs from the given dataset names.', 'You may want to choose or enter different filters and try auto-pairing again.', 'Close this message using the X on the right to view more help.'].join(' '));
	                }
	                this._showAlert(message, msgClass);
	            });
	
	            //this.on( 'all', function(){
	            //    this.info( arguments );
	            //});
	            return this;
	        },
	
	        events: {
	            // header
	            'click .more-help': '_clickMoreHelp',
	            'click .less-help': '_clickLessHelp',
	            'click .main-help': '_toggleHelp',
	            'click .header .alert button': '_hideAlert',
	            'click .forward-column .column-title': '_clickShowOnlyUnpaired',
	            'click .reverse-column .column-title': '_clickShowOnlyUnpaired',
	            'click .unpair-all-link': '_clickUnpairAll',
	            //TODO: this seems kinda backasswards - re-sending jq event as a backbone event, can we listen directly?
	            'change .forward-unpaired-filter input': function (ev) {
	                this.trigger('filter-change');
	            },
	            'focus .forward-unpaired-filter input': function (ev) {
	                $(ev.currentTarget).select();
	            },
	            'click .autopair-link': '_clickAutopair',
	            'click .choose-filters .filter-choice': '_clickFilterChoice',
	            'click .clear-filters-link': '_clearFilters',
	            'change .reverse-unpaired-filter input': function (ev) {
	                this.trigger('filter-change');
	            },
	            'focus .reverse-unpaired-filter input': function (ev) {
	                $(ev.currentTarget).select();
	            },
	            // unpaired
	            'click .forward-column .dataset.unpaired': '_clickUnpairedDataset',
	            'click .reverse-column .dataset.unpaired': '_clickUnpairedDataset',
	            'click .paired-column .dataset.unpaired': '_clickPairRow',
	            'click .unpaired-columns': 'clearSelectedUnpaired',
	            'mousedown .unpaired-columns .dataset': '_mousedownUnpaired',
	            // divider
	            'click .paired-column-title': '_clickShowOnlyPaired',
	            'mousedown .flexible-partition-drag': '_startPartitionDrag',
	            // paired
	            'click .paired-columns .dataset.paired': 'selectPair',
	            'click .paired-columns': 'clearSelectedPaired',
	            'click .paired-columns .pair-name': '_clickPairName',
	            'click .unpair-btn': '_clickUnpair',
	            // paired - drop target
	            //'dragenter .paired-columns'                 : '_dragenterPairedColumns',
	            //'dragleave .paired-columns .column-datasets': '_dragleavePairedColumns',
	            'dragover .paired-columns .column-datasets': '_dragoverPairedColumns',
	            'drop .paired-columns .column-datasets': '_dropPairedColumns',
	
	            'pair.dragstart .paired-columns .column-datasets': '_pairDragstart',
	            'pair.dragend   .paired-columns .column-datasets': '_pairDragend',
	
	            // footer
	            'change .remove-extensions': function (ev) {
	                this.toggleExtensions();
	            },
	            'change .collection-name': '_changeName',
	            'keydown .collection-name': '_nameCheckForEnter',
	            'change .hide-originals': '_changeHideOriginals',
	            'click .cancel-create': '_cancelCreate',
	            'click .create-collection': '_clickCreate' //,
	        },
	
	        /** toggle between showing only unpaired and split view */
	        _clickShowOnlyUnpaired: function (ev) {
	            //this.debug( 'click unpaired', ev.currentTarget );
	            if (this.$('.paired-columns').is(':visible')) {
	                this.hidePaired();
	            } else {
	                this.splitView();
	            }
	        },
	        /** toggle between showing only paired and split view */
	        _clickShowOnlyPaired: function (ev) {
	            //this.debug( 'click paired' );
	            if (this.$('.unpaired-columns').is(':visible')) {
	                this.hideUnpaired();
	            } else {
	                this.splitView();
	            }
	        },
	
	        /** hide unpaired, show paired */
	        hideUnpaired: function (speed, callback) {
	            this.unpairedPanelHidden = true;
	            this.pairedPanelHidden = false;
	            this._renderMiddle(speed, callback);
	        },
	        /** hide paired, show unpaired */
	        hidePaired: function (speed, callback) {
	            this.unpairedPanelHidden = false;
	            this.pairedPanelHidden = true;
	            this._renderMiddle(speed, callback);
	        },
	        /** show both paired and unpaired (splitting evenly) */
	        splitView: function (speed, callback) {
	            this.unpairedPanelHidden = this.pairedPanelHidden = false;
	            this._renderMiddle(speed, callback);
	            return this;
	        },
	
	        /** unpair all paired and do other super neat stuff which I'm not really sure about yet... */
	        _clickUnpairAll: function (ev) {
	            this.metric('unpairAll');
	            this.unpairAll();
	        },
	
	        /** attempt to autopair */
	        _clickAutopair: function (ev) {
	            var paired = this.autoPair();
	            this.metric('autopair', paired.length, this.unpaired.length);
	            this.trigger('autopair');
	        },
	
	        /** set the filters based on the data attributes of the button click target */
	        _clickFilterChoice: function (ev) {
	            var $selected = $(ev.currentTarget);
	            this.$('.forward-unpaired-filter input').val($selected.data('forward'));
	            this.$('.reverse-unpaired-filter input').val($selected.data('reverse'));
	            this._hideChooseFilters();
	            this.trigger('filter-change');
	        },
	
	        /** hide the choose filters popover */
	        _hideChooseFilters: function () {
	            //TODO: update bootstrap and remove the following hack
	            //  see also: https://github.com/twbs/bootstrap/issues/10260
	            this.$('.choose-filters-link').popover('hide');
	            this.$('.popover').css('display', 'none');
	        },
	
	        /** clear both filters */
	        _clearFilters: function (ev) {
	            this.$('.forward-unpaired-filter input').val('');
	            this.$('.reverse-unpaired-filter input').val('');
	            this.trigger('filter-change');
	        },
	
	        // ........................................................................ unpaired
	        /** select an unpaired dataset */
	        _clickUnpairedDataset: function (ev) {
	            ev.stopPropagation();
	            return this.toggleSelectUnpaired($(ev.currentTarget));
	        },
	
	        /** Toggle the selection of an unpaired dataset representation.
	         *  @param [jQuery] $dataset        the unpaired dataset dom rep to select
	         *  @param [Boolean] options.force  if defined, force selection based on T/F; otherwise, toggle
	         */
	        toggleSelectUnpaired: function ($dataset, options) {
	            options = options || {};
	            var dataset = $dataset.data('dataset'),
	                select = options.force !== undefined ? options.force : !$dataset.hasClass('selected');
	            //this.debug( id, options.force, $dataset, dataset );
	            if (!$dataset.length || dataset === undefined) {
	                return $dataset;
	            }
	
	            if (select) {
	                $dataset.addClass('selected');
	                if (!options.waitToPair) {
	                    this.pairAllSelected();
	                }
	            } else {
	                $dataset.removeClass('selected');
	                //delete dataset.selected;
	            }
	            return $dataset;
	        },
	
	        /** pair all the currently selected unpaired datasets */
	        pairAllSelected: function (options) {
	            options = options || {};
	            var creator = this,
	                fwds = [],
	                revs = [],
	                pairs = [];
	            creator.$('.unpaired-columns .forward-column .dataset.selected').each(function () {
	                fwds.push($(this).data('dataset'));
	            });
	            creator.$('.unpaired-columns .reverse-column .dataset.selected').each(function () {
	                revs.push($(this).data('dataset'));
	            });
	            fwds.length = revs.length = Math.min(fwds.length, revs.length);
	            //this.debug( fwds );
	            //this.debug( revs );
	            fwds.forEach(function (fwd, i) {
	                try {
	                    pairs.push(creator._pair(fwd, revs[i], { silent: true }));
	                } catch (err) {
	                    //TODO: preserve selected state of those that couldn't be paired
	                    //TODO: warn that some could not be paired
	                    creator.error(err);
	                }
	            });
	            if (pairs.length && !options.silent) {
	                this.trigger('pair:new', pairs);
	            }
	            return pairs;
	        },
	
	        /** clear the selection on all unpaired datasets */
	        clearSelectedUnpaired: function () {
	            this.$('.unpaired-columns .dataset.selected').removeClass('selected');
	        },
	
	        /** when holding down the shift key on a click, 'paint' the moused over datasets as selected */
	        _mousedownUnpaired: function (ev) {
	            if (ev.shiftKey) {
	                var creator = this,
	                    $startTarget = $(ev.target).addClass('selected'),
	                    moveListener = function (ev) {
	                    creator.$(ev.target).filter('.dataset').addClass('selected');
	                };
	                $startTarget.parent().on('mousemove', moveListener);
	
	                // on any mouseup, stop listening to the move and try to pair any selected
	                $(document).one('mouseup', function (ev) {
	                    $startTarget.parent().off('mousemove', moveListener);
	                    creator.pairAllSelected();
	                });
	            }
	        },
	
	        /** attempt to pair two datasets directly across from one another */
	        _clickPairRow: function (ev) {
	            //if( !ev.currentTarget ){ return true; }
	            var rowIndex = $(ev.currentTarget).index(),
	                fwd = $('.unpaired-columns .forward-column .dataset').eq(rowIndex).data('dataset'),
	                rev = $('.unpaired-columns .reverse-column .dataset').eq(rowIndex).data('dataset');
	            //this.debug( 'row:', rowIndex, fwd, rev );
	            this._pair(fwd, rev);
	        },
	
	        // ........................................................................ divider/partition
	        /** start dragging the visible divider/partition between unpaired and paired panes */
	        _startPartitionDrag: function (ev) {
	            var creator = this,
	                startingY = ev.pageY;
	            //this.debug( 'partition drag START:', ev );
	            $('body').css('cursor', 'ns-resize');
	            creator.$('.flexible-partition-drag').css('color', 'black');
	
	            function endDrag(ev) {
	                //creator.debug( 'partition drag STOP:', ev );
	                // doing this by an added class didn't really work well - kept flashing still
	                creator.$('.flexible-partition-drag').css('color', '');
	                $('body').css('cursor', '').unbind('mousemove', trackMouse);
	            }
	            function trackMouse(ev) {
	                var offset = ev.pageY - startingY;
	                //creator.debug( 'partition:', startingY, offset );
	                if (!creator.adjPartition(offset)) {
	                    //creator.debug( 'mouseup triggered' );
	                    $('body').trigger('mouseup');
	                }
	                creator._adjUnpairedOnScrollbar();
	                startingY += offset;
	            }
	            $('body').mousemove(trackMouse);
	            $('body').one('mouseup', endDrag);
	        },
	
	        /** adjust the parition up/down +/-adj pixels */
	        adjPartition: function (adj) {
	            var $unpaired = this.$('.unpaired-columns'),
	                $paired = this.$('.paired-columns'),
	                unpairedHi = parseInt($unpaired.css('height'), 10),
	                pairedHi = parseInt($paired.css('height'), 10);
	            //this.debug( adj, 'hi\'s:', unpairedHi, pairedHi, unpairedHi + adj, pairedHi - adj );
	
	            unpairedHi = Math.max(10, unpairedHi + adj);
	            pairedHi = pairedHi - adj;
	
	            var movingUpwards = adj < 0;
	            // when the divider gets close to the top - lock into hiding the unpaired section
	            if (movingUpwards) {
	                if (this.unpairedPanelHidden) {
	                    return false;
	                } else if (unpairedHi <= 10) {
	                    this.hideUnpaired();
	                    return false;
	                }
	            } else {
	                if (this.unpairedPanelHidden) {
	                    $unpaired.show();
	                    this.unpairedPanelHidden = false;
	                }
	            }
	
	            // when the divider gets close to the bottom - lock into hiding the paired section
	            if (!movingUpwards) {
	                if (this.pairedPanelHidden) {
	                    return false;
	                } else if (pairedHi <= 15) {
	                    this.hidePaired();
	                    return false;
	                }
	            } else {
	                if (this.pairedPanelHidden) {
	                    $paired.show();
	                    this.pairedPanelHidden = false;
	                }
	            }
	
	            $unpaired.css({
	                height: unpairedHi + 'px',
	                flex: '0 0 auto'
	            });
	            return true;
	        },
	
	        // ........................................................................ paired
	        /** select a pair when clicked */
	        selectPair: function (ev) {
	            ev.stopPropagation();
	            $(ev.currentTarget).toggleClass('selected');
	        },
	
	        /** deselect all pairs */
	        clearSelectedPaired: function (ev) {
	            this.$('.paired-columns .dataset.selected').removeClass('selected');
	        },
	
	        /** rename a pair when the pair name is clicked */
	        _clickPairName: function (ev) {
	            ev.stopPropagation();
	            var $name = $(ev.currentTarget),
	                $pair = $name.parent().parent(),
	                index = $pair.index('.dataset.paired'),
	                pair = this.paired[index],
	                response = prompt('Enter a new name for the pair:', pair.name);
	            if (response) {
	                pair.name = response;
	                // set a flag (which won't be passed in json creation) for manual naming so we don't overwrite these
	                //  when adding/removing extensions
	                //hackish
	                pair.customizedName = true;
	                $name.text(pair.name);
	            }
	        },
	
	        /** unpair this pair */
	        _clickUnpair: function (ev) {
	            //if( !ev.currentTarget ){ return true; }
	            var pairIndex = Math.floor($(ev.currentTarget).index('.unpair-btn'));
	            //this.debug( 'pair:', pairIndex );
	            this._unpair(this.paired[pairIndex]);
	        },
	
	        // ........................................................................ paired - drag and drop re-ordering
	        //_dragenterPairedColumns : function( ev ){
	        //    this.debug( '_dragenterPairedColumns:', ev );
	        //},
	        //_dragleavePairedColumns : function( ev ){
	        //    //this.debug( '_dragleavePairedColumns:', ev );
	        //},
	        /** track the mouse drag over the paired list adding a placeholder to show where the drop would occur */
	        _dragoverPairedColumns: function (ev) {
	            //this.debug( '_dragoverPairedColumns:', ev );
	            ev.preventDefault();
	
	            var $list = this.$('.paired-columns .column-datasets');
	            this._checkForAutoscroll($list, ev.originalEvent.clientY);
	            //this.debug( ev.originalEvent.clientX, ev.originalEvent.clientY );
	            var $nearest = this._getNearestPairedDatasetLi(ev.originalEvent.clientY);
	
	            $('.element-drop-placeholder').remove();
	            var $placeholder = $('<div class="element-drop-placeholder"></div>');
	            if (!$nearest.length) {
	                $list.append($placeholder);
	            } else {
	                $nearest.before($placeholder);
	            }
	        },
	
	        /** If the mouse is near enough to the list's top or bottom, scroll the list */
	        _checkForAutoscroll: function ($element, y) {
	            var AUTOSCROLL_SPEED = 2;
	            var offset = $element.offset(),
	                scrollTop = $element.scrollTop(),
	                upperDist = y - offset.top,
	                lowerDist = offset.top + $element.outerHeight() - y;
	            //this.debug( '_checkForAutoscroll:', scrollTop, upperDist, lowerDist );
	            if (upperDist >= 0 && upperDist < this.autoscrollDist) {
	                $element.scrollTop(scrollTop - AUTOSCROLL_SPEED);
	            } else if (lowerDist >= 0 && lowerDist < this.autoscrollDist) {
	                $element.scrollTop(scrollTop + AUTOSCROLL_SPEED);
	            }
	        },
	
	        /** get the nearest *previous* paired dataset PairView based on the mouse's Y coordinate.
	         *      If the y is at the end of the list, return an empty jQuery object.
	         */
	        _getNearestPairedDatasetLi: function (y) {
	            var WIGGLE = 4,
	                lis = this.$('.paired-columns .column-datasets li').toArray();
	            for (var i = 0; i < lis.length; i++) {
	                var $li = $(lis[i]),
	                    top = $li.offset().top,
	                    halfHeight = Math.floor($li.outerHeight() / 2) + WIGGLE;
	                if (top + halfHeight > y && top - halfHeight < y) {
	                    //this.debug( y, top + halfHeight, top - halfHeight )
	                    return $li;
	                }
	            }
	            return $();
	        },
	        /** drop (dragged/selected PairViews) onto the list, re-ordering both the DOM and the internal array of pairs */
	        _dropPairedColumns: function (ev) {
	            // both required for firefox
	            ev.preventDefault();
	            ev.dataTransfer.dropEffect = 'move';
	
	            var $nearest = this._getNearestPairedDatasetLi(ev.originalEvent.clientY);
	            if ($nearest.length) {
	                this.$dragging.insertBefore($nearest);
	            } else {
	                // no nearest before - insert after last element (unpair button)
	                this.$dragging.insertAfter(this.$('.paired-columns .unpair-btn').last());
	            }
	            // resync the creator's list of paired based on the new DOM order
	            this._syncPairsToDom();
	            return false;
	        },
	        /** resync the creator's list of paired based on the DOM order of pairs */
	        _syncPairsToDom: function () {
	            var newPaired = [];
	            //TODO: doesn't seem wise to use the dom to store these - can't we sync another way?
	            this.$('.paired-columns .dataset.paired').each(function () {
	                newPaired.push($(this).data('pair'));
	            });
	            //this.debug( newPaired );
	            this.paired = newPaired;
	            this._renderPaired();
	        },
	        /** drag communication with pair sub-views: dragstart */
	        _pairDragstart: function (ev, pair) {
	            //this.debug( '_pairDragstart', ev, pair )
	            // auto select the pair causing the event and move all selected
	            pair.$el.addClass('selected');
	            var $selected = this.$('.paired-columns .dataset.selected');
	            this.$dragging = $selected;
	        },
	        /** drag communication with pair sub-views: dragend - remove the placeholder */
	        _pairDragend: function (ev, pair) {
	            //this.debug( '_pairDragend', ev, pair )
	            $('.element-drop-placeholder').remove();
	            this.$dragging = null;
	        },
	
	        // ........................................................................ footer
	        toggleExtensions: function (force) {
	            var creator = this;
	            creator.removeExtensions = force !== undefined ? force : !creator.removeExtensions;
	
	            _.each(creator.paired, function (pair) {
	                // don't overwrite custom names
	                if (pair.customizedName) {
	                    return;
	                }
	                pair.name = creator._guessNameForPair(pair.forward, pair.reverse);
	            });
	
	            creator._renderPaired();
	            creator._renderFooter();
	        },
	
	        // ------------------------------------------------------------------------ misc
	        /** debug a dataset list */
	        _printList: function (list) {
	            var creator = this;
	            _.each(list, function (e) {
	                if (list === creator.paired) {
	                    creator._printPair(e);
	                } else {
	                    //creator.debug( e );
	                }
	            });
	        },
	
	        /** print a pair Object */
	        _printPair: function (pair) {
	            this.debug(pair.forward.name, pair.reverse.name, ': ->', pair.name);
	        },
	
	        /** string rep */
	        toString: function () {
	            return 'PairedCollectionCreator';
	        },
	
	        templates: _.extend({}, baseCreator.CollectionCreatorMixin._creatorTemplates, {
	
	            /** the header (not including help text) */
	            header: _.template(['<div class="main-help well clear">', '<a class="more-help" href="javascript:void(0);">', _l('More help'), '</a>', '<div class="help-content">', '<a class="less-help" href="javascript:void(0);">', _l('Less'), '</a>', '</div>', '</div>', '<div class="alert alert-dismissable">', '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>', '<span class="alert-message"></span>', '</div>', '<div class="column-headers vertically-spaced flex-column-container">', '<div class="forward-column flex-column column">', '<div class="column-header">', '<div class="column-title">', '<span class="title">', _l('Unpaired forward'), '</span>', '<span class="title-info unpaired-info"></span>', '</div>', '<div class="unpaired-filter forward-unpaired-filter pull-left">', '<input class="search-query" placeholder="', _l('Filter this list'), '" />', '</div>', '</div>', '</div>', '<div class="paired-column flex-column no-flex column">', '<div class="column-header">', '<a class="choose-filters-link" href="javascript:void(0)">', _l('Choose filters'), '</a>', '<a class="clear-filters-link" href="javascript:void(0);">', _l('Clear filters'), '</a><br />', '<a class="autopair-link" href="javascript:void(0);">', _l('Auto-pair'), '</a>', '</div>', '</div>', '<div class="reverse-column flex-column column">', '<div class="column-header">', '<div class="column-title">', '<span class="title">', _l('Unpaired reverse'), '</span>', '<span class="title-info unpaired-info"></span>', '</div>', '<div class="unpaired-filter reverse-unpaired-filter pull-left">', '<input class="search-query" placeholder="', _l('Filter this list'), '" />', '</div>', '</div>', '</div>', '</div>'].join('')),
	
	            /** the middle: unpaired, divider, and paired */
	            middle: _.template([
	            // contains two flex rows (rows that fill available space) and a divider btwn
	            '<div class="unpaired-columns flex-column-container scroll-container flex-row">', '<div class="forward-column flex-column column">', '<ol class="column-datasets"></ol>', '</div>', '<div class="paired-column flex-column no-flex column">', '<ol class="column-datasets"></ol>', '</div>', '<div class="reverse-column flex-column column">', '<ol class="column-datasets"></ol>', '</div>', '</div>', '<div class="flexible-partition">', '<div class="flexible-partition-drag" title="', _l('Drag to change'), '"></div>', '<div class="column-header">', '<div class="column-title paired-column-title">', '<span class="title"></span>', '</div>', '<a class="unpair-all-link" href="javascript:void(0);">', _l('Unpair all'), '</a>', '</div>', '</div>', '<div class="paired-columns flex-column-container scroll-container flex-row">', '<ol class="column-datasets"></ol>', '</div>'].join('')),
	
	            /** creation and cancel controls */
	            footer: _.template(['<div class="attributes clear">', '<div class="clear">', '<label class="setting-prompt pull-right">', _l('Hide original elements'), '?', '<input class="hide-originals pull-right" type="checkbox" />', '</label>', '<label class="setting-prompt pull-right">', _l('Remove file extensions from pair names'), '?', '<input class="remove-extensions pull-right" type="checkbox" />', '</label>', '</div>', '<div class="clear">', '<input class="collection-name form-control pull-right" ', 'placeholder="', _l('Enter a name for your new list'), '" />', '<div class="collection-name-prompt pull-right">', _l('Name'), ':</div>', '</div>', '</div>', '<div class="actions clear vertically-spaced">', '<div class="other-options pull-left">', '<button class="cancel-create btn" tabindex="-1">', _l('Cancel'), '</button>', '<div class="create-other btn-group dropup">', '<button class="btn btn-default dropdown-toggle" data-toggle="dropdown">', _l('Create a different kind of collection'), ' <span class="caret"></span>', '</button>', '<ul class="dropdown-menu" role="menu">', '<li><a href="#">', _l('Create a <i>single</i> pair'), '</a></li>', '<li><a href="#">', _l('Create a list of <i>unpaired</i> datasets'), '</a></li>', '</ul>', '</div>', '</div>', '<div class="main-options pull-right">', '<button class="create-collection btn btn-primary">', _l('Create list'), '</button>', '</div>', '</div>'].join('')),
	
	            /** help content */
	            helpContent: _.template(['<p>', _l(['Collections of paired datasets are ordered lists of dataset pairs (often forward and reverse reads). ', 'These collections can be passed to tools and workflows in order to have analyses done on each member of ', 'the entire group. This interface allows you to create a collection, choose which datasets are paired, ', 'and re-order the final collection.'].join('')), '</p>', '<p>', _l(['Unpaired datasets are shown in the <i data-target=".unpaired-columns">unpaired section</i> ', '(hover over the underlined words to highlight below). ', 'Paired datasets are shown in the <i data-target=".paired-columns">paired section</i>.', '<ul>To pair datasets, you can:', '<li>Click a dataset in the ', '<i data-target=".unpaired-columns .forward-column .column-datasets,', '.unpaired-columns .forward-column">forward column</i> ', 'to select it then click a dataset in the ', '<i data-target=".unpaired-columns .reverse-column .column-datasets,', '.unpaired-columns .reverse-column">reverse column</i>.', '</li>', '<li>Click one of the "Pair these datasets" buttons in the ', '<i data-target=".unpaired-columns .paired-column .column-datasets,', '.unpaired-columns .paired-column">middle column</i> ', 'to pair the datasets in a particular row.', '</li>', '<li>Click <i data-target=".autopair-link">"Auto-pair"</i> ', 'to have your datasets automatically paired based on name.', '</li>', '</ul>'].join('')), '</p>', '<p>', _l(['<ul>You can filter what is shown in the unpaired sections by:', '<li>Entering partial dataset names in either the ', '<i data-target=".forward-unpaired-filter input">forward filter</i> or ', '<i data-target=".reverse-unpaired-filter input">reverse filter</i>.', '</li>', '<li>Choosing from a list of preset filters by clicking the ', '<i data-target=".choose-filters-link">"Choose filters" link</i>.', '</li>', '<li>Entering regular expressions to match dataset names. See: ', '<a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions"', ' target="_blank">MDN\'s JavaScript Regular Expression Tutorial</a>. ', 'Note: forward slashes (\\) are not needed.', '</li>', '<li>Clearing the filters by clicking the ', '<i data-target=".clear-filters-link">"Clear filters" link</i>.', '</li>', '</ul>'].join('')), '</p>', '<p>', _l(['To unpair individual dataset pairs, click the ', '<i data-target=".unpair-btn">unpair buttons ( <span class="fa fa-unlink"></span> )</i>. ', 'Click the <i data-target=".unpair-all-link">"Unpair all" link</i> to unpair all pairs.'].join('')), '</p>', '<p>', _l(['You can include or remove the file extensions (e.g. ".fastq") from your pair names by toggling the ', '<i data-target=".remove-extensions-prompt">"Remove file extensions from pair names?"</i> control.'].join('')), '</p>', '<p>', _l(['Once your collection is complete, enter a <i data-target=".collection-name">name</i> and ', 'click <i data-target=".create-collection">"Create list"</i>. ', '(Note: you do not have to pair all unpaired datasets to finish.)'].join('')), '</p>'].join(''))
	        })
	    });
	
	    //=============================================================================
	    /** a modal version of the paired collection creator */
	    var pairedCollectionCreatorModal = function _pairedCollectionCreatorModal(datasets, options) {
	
	        var deferred = jQuery.Deferred(),
	            creator;
	
	        options = _.defaults(options || {}, {
	            datasets: datasets,
	            oncancel: function () {
	                Galaxy.modal.hide();
	                deferred.reject('cancelled');
	            },
	            oncreate: function (creator, response) {
	                Galaxy.modal.hide();
	                deferred.resolve(response);
	            }
	        });
	
	        if (!window.Galaxy || !Galaxy.modal) {
	            throw new Error('Galaxy or Galaxy.modal not found');
	        }
	
	        creator = new PairedCollectionCreator(options);
	        Galaxy.modal.show({
	            title: 'Create a collection of paired datasets',
	            body: creator.$el,
	            width: '80%',
	            height: '800px',
	            closing_events: true
	        });
	        creator.render();
	        window.creator = creator;
	
	        //TODO: remove modal header
	        return deferred;
	    };
	
	    //=============================================================================
	    function createListOfPairsCollection(collection, defaultHideSourceItems) {
	        var elements = collection.toJSON();
	        //TODO: validate elements
	        return pairedCollectionCreatorModal(elements, {
	            historyId: collection.historyId,
	            defaultHideSourceItems: defaultHideSourceItems
	        });
	    }
	
	    //=============================================================================
	    return {
	        PairedCollectionCreator: PairedCollectionCreator,
	        pairedCollectionCreatorModal: pairedCollectionCreatorModal,
	        createListOfPairsCollection: createListOfPairsCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(60), __webpack_require__(63), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_CREATOR, HDCA, BASE_MVC, _l) {
	
	    'use strict';
	
	    var logNamespace = 'collections';
	    /*==============================================================================
	    TODO:
	        the paired creator doesn't really mesh with the list creator as parent
	            it may be better to make an abstract super class for both
	        composites may inherit from this (or vis-versa)
	        PairedDatasetCollectionElementView doesn't make a lot of sense
	    
	    ==============================================================================*/
	    /**  */
	    var PairedDatasetCollectionElementView = Backbone.View.extend(BASE_MVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        //TODO: use proper class (DatasetDCE or NestedDCDCE (or the union of both))
	        tagName: 'li',
	        className: 'collection-element',
	
	        initialize: function (attributes) {
	            this.element = attributes.element || {};
	            this.identifier = attributes.identifier;
	        },
	
	        render: function () {
	            this.$el.attr('data-element-id', this.element.id).html(this.template({ identifier: this.identifier, element: this.element }));
	            return this;
	        },
	
	        //TODO: lots of unused space in the element - possibly load details and display them horiz.
	        template: _.template(['<span class="identifier"><%- identifier %></span>', '<span class="name"><%- element.name %></span>'].join('')),
	
	        /** remove the DOM and any listeners */
	        destroy: function () {
	            this.off();
	            this.$el.remove();
	        },
	
	        /** string rep */
	        toString: function () {
	            return 'DatasetCollectionElementView()';
	        }
	    });
	
	    // ============================================================================
	    var _super = LIST_CREATOR.ListCollectionCreator;
	
	    /** An interface for building collections.
	     */
	    var PairCollectionCreator = _super.extend({
	
	        /** the class used to display individual elements */
	        elementViewClass: PairedDatasetCollectionElementView,
	        /** the class this creator will create and save */
	        collectionClass: HDCA.HistoryPairDatasetCollection,
	        className: 'pair-collection-creator collection-creator flex-row-container',
	
	        /** override to no-op */
	        _mangleDuplicateNames: function () {},
	
	        // TODO: this whole pattern sucks. There needs to be two classes of problem area:
	        //      bad inital choices and
	        //      when the user has painted his/her self into a corner during creation/use-of-the-creator
	        /** render the entire interface */
	        render: function (speed, callback) {
	            if (this.workingElements.length === 2) {
	                return _super.prototype.render.call(this, speed, callback);
	            }
	            return this._renderInvalid(speed, callback);
	        },
	
	        // ------------------------------------------------------------------------ rendering elements
	        /** render forward/reverse */
	        _renderList: function (speed, callback) {
	            //this.debug( '-- _renderList' );
	            //precondition: there are two valid elements in workingElements
	            var creator = this,
	                $tmp = jQuery('<div/>'),
	                $list = creator.$list();
	
	            // lose the original views, create the new, append all at once, then call their renders
	            _.each(this.elementViews, function (view) {
	                view.destroy();
	                creator.removeElementView(view);
	            });
	            $tmp.append(creator._createForwardElementView().$el);
	            $tmp.append(creator._createReverseElementView().$el);
	            $list.empty().append($tmp.children());
	            _.invoke(creator.elementViews, 'render');
	        },
	
	        /** create the forward element view */
	        _createForwardElementView: function () {
	            return this._createElementView(this.workingElements[0], { identifier: 'forward' });
	        },
	
	        /** create the forward element view */
	        _createReverseElementView: function () {
	            return this._createElementView(this.workingElements[1], { identifier: 'reverse' });
	        },
	
	        /** create an element view, cache in elementViews, and return */
	        _createElementView: function (element, options) {
	            var elementView = new this.elementViewClass(_.extend(options, {
	                element: element
	            }));
	            this.elementViews.push(elementView);
	            return elementView;
	        },
	
	        /** swap the forward, reverse elements and re-render */
	        swap: function () {
	            this.workingElements = [this.workingElements[1], this.workingElements[0]];
	            this._renderList();
	        },
	
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .swap': 'swap'
	        }),
	
	        // ------------------------------------------------------------------------ templates
	        //TODO: move to require text plugin and load these as text
	        //TODO: underscore currently unnecc. bc no vars are used
	        //TODO: better way of localizing text-nodes in long strings
	        /** underscore template fns attached to class */
	        templates: _.extend(_.clone(_super.prototype.templates), {
	            /** the middle: element list */
	            middle: _.template(['<div class="collection-elements-controls">', '<a class="swap" href="javascript:void(0);" title="', _l('Swap forward and reverse datasets'), '">', _l('Swap'), '</a>', '</div>', '<div class="collection-elements scroll-container flex-row">', '</div>'].join('')),
	
	            /** help content */
	            helpContent: _.template(['<p>', _l(['Pair collections are permanent collections containing two datasets: one forward and one reverse. ', 'Often these are forward and reverse reads. The pair collections can be passed to tools and ', 'workflows in order to have analyses done on both datasets. This interface allows ', 'you to create a pair, name it, and swap which is forward and which reverse.'].join('')), '</p>', '<ul>', '<li>', _l(['Click the <i data-target=".swap">"Swap"</i> link to make your forward dataset the reverse ', 'and the reverse dataset forward.'].join('')), '</li>', '<li>', _l(['Click the <i data-target=".cancel-create">"Cancel"</i> button to exit the interface.'].join('')), '</li>', '</ul><br />', '<p>', _l(['Once your collection is complete, enter a <i data-target=".collection-name">name</i> and ', 'click <i data-target=".create-collection">"Create list"</i>.'].join('')), '</p>'].join('')),
	
	            /** a simplified page communicating what went wrong and why the user needs to reselect something else */
	            invalidInitial: _.template(['<div class="header flex-row no-flex">', '<div class="alert alert-warning" style="display: block">', '<span class="alert-message">', '<% if( _.size( problems ) ){ %>', _l('The following selections could not be included due to problems'), '<ul><% _.each( problems, function( problem ){ %>', '<li><b><%- problem.element.name %></b>: <%- problem.text %></li>', '<% }); %></ul>', '<% } else if( _.size( elements ) === 0 ){ %>', _l('No datasets were selected'), '.', '<% } else if( _.size( elements ) === 1 ){ %>', _l('Only one dataset was selected'), ': <%- elements[0].name %>', '<% } else if( _.size( elements ) > 2 ){ %>', _l('Too many datasets were selected'), ': <%- _.pluck( elements, "name" ).join( ", ") %>', '<% } %>', '<br />', _l('Two (and only two) elements are needed for the pair'), '. ', _l('You may need to '), '<a class="cancel-create" href="javascript:void(0)">', _l('cancel'), '</a> ', _l('and reselect new elements'), '.', '</span>', '</div>', '</div>', '<div class="footer flex-row no-flex">', '<div class="actions clear vertically-spaced">', '<div class="other-options pull-left">', '<button class="cancel-create btn" tabindex="-1">', _l('Cancel'), '</button>',
	            // _l( 'Create a different kind of collection' ),
	            '</div>', '</div>', '</div>'].join(''))
	        }),
	
	        // ------------------------------------------------------------------------ misc
	        /** string rep */
	        toString: function () {
	            return 'PairCollectionCreator';
	        }
	    });
	
	    //==============================================================================
	    /** List collection flavor of collectionCreatorModal. */
	    var pairCollectionCreatorModal = function _pairCollectionCreatorModal(elements, options) {
	        options = options || {};
	        options.title = _l('Create a collection from a pair of datasets');
	        return LIST_CREATOR.collectionCreatorModal(elements, options, PairCollectionCreator);
	    };
	
	    //==============================================================================
	    /** Use a modal to create a pair collection, then add it to the given history contents.
	     *  @returns {Deferred} resolved when the collection is added to the history.
	     */
	    function createPairCollection(contents, defaultHideSourceItems) {
	        var elements = contents.toJSON(),
	            promise = pairCollectionCreatorModal(elements, {
	            defaultHideSourceItems: defaultHideSourceItems,
	            creationFn: function (elements, name, hideSourceItems) {
	                elements = [{ name: "forward", src: "hda", id: elements[0].id }, { name: "reverse", src: "hda", id: elements[1].id }];
	                return contents.createHDCA(elements, 'paired', name, hideSourceItems);
	            }
	        });
	        return promise;
	    }
	
	    //==============================================================================
	    return {
	        PairCollectionCreator: PairCollectionCreator,
	        pairCollectionCreatorModal: pairCollectionCreatorModal,
	        createPairCollection: createPairCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(49), __webpack_require__(5), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Tabs, Ui, Form) {
	
	    /** Dataset edit attributes view */
	    var View = Backbone.View.extend({
	        initialize: function () {
	            this.setElement('<div/>');
	            this.model = new Backbone.Model({ 'dataset_id': Galaxy.params.dataset_id });
	            this.render();
	        },
	
	        // Fetch data for the selected dataset and 
	        // build tabs for editing its attributes
	        render: function () {
	            var url = Galaxy.root + 'dataset/edit',
	                self = this;
	            Utils.get({
	                url: url,
	                data: { 'dataset_id': self.model.get('dataset_id') },
	                success: function (response) {
	                    self.render_attribute_page(self, response);
	                },
	                error: function (response) {
	                    var error_response = {
	                        'status': 'error',
	                        'message': 'Error occured while loading the dataset.',
	                        'persistent': true,
	                        'cls': 'errormessage'
	                    };
	                    self.display_message(error_response, self.$('.response-message'));
	                }
	            });
	        },
	
	        /** Render all the tabs view */
	        render_attribute_page: function (self, response) {
	            var message = {
	                'message': response.message,
	                'status': response.status,
	                'persistent': true,
	                'cls': response.status + 'message'
	            };
	            self.$el.empty().append(self._templateHeader());
	            self.display_message(message, self.$('.response-message'));
	            // Create all tabs
	            self.create_tabs(response, self.$('.edit-attr'));
	        },
	
	        /** Perform AJAX post call */
	        call_ajax: function (self, data, tab_name) {
	            var post_url = Galaxy.root + 'dataset/edit';
	            $.ajax({
	                type: "PUT",
	                url: post_url,
	                data: data,
	                success: function (response) {
	                    self.render_attribute_page(self, response);
	                    self.reload_history();
	                },
	                error: function (response) {
	                    var error_response = {
	                        'status': 'error',
	                        'message': 'Error occured while saving. Please fill all the required fields and try again.',
	                        'persistent': true,
	                        'cls': 'errormessage'
	                    };
	                    self.display_message(error_response, self.$('.response-message'));
	                }
	            });
	        },
	
	        /** Display actions messages */
	        display_message: function (response, $el) {
	            $el.empty().html(new Ui.Message(response).$el);
	        },
	
	        /** Create tabs for different attributes of dataset*/
	        create_tabs: function (response, $el_edit_attr) {
	            var self = this;
	            self.tabs = new Tabs.View();
	            self.tabs.add({
	                id: 'attributes',
	                title: 'Attributes',
	                icon: 'fa fa-bars',
	                tooltip: 'Edit dataset attributes',
	                $el: self._getAttributesFormTemplate(response)
	            });
	
	            self.tabs.add({
	                id: 'convert',
	                title: 'Convert',
	                icon: 'fa-gear',
	                tooltip: 'Convert to new format',
	                $el: self._getConvertFormTemplate(response)
	            });
	
	            self.tabs.add({
	                id: 'datatype',
	                title: 'Datatypes',
	                icon: 'fa-database',
	                tooltip: 'Change data type',
	                $el: self._getChangeDataTypeFormTemplate(response)
	            });
	
	            self.tabs.add({
	                id: 'permissions',
	                title: 'Permissions',
	                icon: 'fa-user',
	                tooltip: 'Permissions',
	                $el: self._getPermissionsFormTemplate(response)
	            });
	            $el_edit_attr.append(self.tabs.$el);
	            self.tabs.showTab('attributes');
	        },
	
	        /** Main template */
	        _templateHeader: function () {
	            return '<div class="page-container edit-attr">' + '<div class="response-message"></div>' + '<h3>Edit Dataset Attributes</h3>' + '</div>';
	        },
	
	        /** Attributes tab template */
	        _getAttributesFormTemplate: function (response) {
	            var self = this;
	            var form = new Form({
	                title: 'Edit attributes',
	                inputs: response.edit_attributes_inputs,
	                operations: {
	                    'submit_editattr': new Ui.ButtonIcon({
	                        tooltip: 'Save attributes of the dataset.',
	                        icon: 'fa-floppy-o ',
	                        title: 'Save attributes',
	                        onclick: function () {
	                            self._submit(self, form, response, "edit_attributes");
	                        }
	                    }),
	                    'submit_autocorrect': new Ui.ButtonIcon({
	                        tooltip: 'This will inspect the dataset and attempt to correct the values of fields if they are not accurate.',
	                        icon: 'fa-undo ',
	                        title: 'Auto-detect',
	                        onclick: function () {
	                            self._submit(self, form, response, "auto-detect");
	                        }
	                    })
	                }
	            });
	            return form.$el;
	        },
	
	        /** Convert tab template */
	        _getConvertFormTemplate: function (response) {
	            var self = this;
	            var form = new Form({
	                title: 'Convert to new format',
	                inputs: response.convert_inputs,
	                operations: {
	                    'submit': new Ui.ButtonIcon({
	                        tooltip: 'Convert the datatype to a new format.',
	                        title: 'Convert datatype',
	                        icon: 'fa-exchange ',
	                        onclick: function () {
	                            self._submit(self, form, response, "convert");
	                        }
	                    })
	                }
	            });
	            return form.$el;
	        },
	
	        /** Change datatype template */
	        _getChangeDataTypeFormTemplate: function (response) {
	            var self = this;
	            var form = new Form({
	                title: 'Change datatype',
	                inputs: response.convert_datatype_inputs,
	                operations: {
	                    'submit': new Ui.ButtonIcon({
	                        tooltip: 'Change the datatype to a new type.',
	                        title: 'Change datatype',
	                        icon: 'fa-exchange ',
	                        onclick: function () {
	                            self._submit(self, form, response, "change");
	                        }
	                    })
	                }
	            });
	            return form.$el;
	        },
	
	        /** Permissions template */
	        _getPermissionsFormTemplate: function (response) {
	            var template = "",
	                self = this;
	            if (response.can_manage_dataset) {
	                var form = new Form({
	                    title: 'Manage dataset permissions on ' + response.display_name,
	                    inputs: response.permission_inputs,
	                    operations: {
	                        'submit': new Ui.ButtonIcon({
	                            tooltip: 'Save permissions.',
	                            title: 'Save permissions',
	                            icon: 'fa-floppy-o ',
	                            onclick: function () {
	                                self._submit(self, form, response, "permissions");
	                            }
	                        })
	                    }
	                });
	                return form.$el;
	            } else {
	                var form = new Form({
	                    title: 'View permissions',
	                    inputs: response.permission_inputs
	                });
	                return form.$el;
	            }
	        },
	
	        /** Submit action */
	        _submit: function (self, form, response, type) {
	            var form_data = form.data.create();
	            form_data.dataset_id = response.dataset_id;
	            switch (type) {
	                case "edit_attributes":
	                    form_data.save = 'Save';
	                    break;
	
	                case "auto-detect":
	                    form_data.detect = 'Auto-detect';
	                    break;
	
	                case "convert":
	                    if (form_data.target_type !== null && form_data.target_type) {
	                        form_data.dataset_id = response.dataset_id;
	                        form_data.convert_data = 'Convert';
	                    }
	                    break;
	
	                case "change":
	                    form_data.change = 'Save';
	                    break;
	
	                case "permissions":
	                    var post_data = {};
	                    post_data.permissions = JSON.stringify(form_data);
	                    post_data.update_roles_button = "Save";
	                    post_data.dataset_id = response.dataset_id;
	                    form_data = post_data;
	                    break;
	            }
	            self.call_ajax(self, form_data);
	        },
	
	        /** Reload Galaxy's history after updating dataset's attributes */
	        reload_history: function () {
	            if (window.Galaxy) {
	                window.Galaxy.currHistoryPanel.loadCurrentHistory();
	            }
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Form) {
	
	    /** Dataset edit attributes view */
	    var View = Backbone.View.extend({
	        initialize: function () {
	            this.setElement('<div/>');
	            this.model = new Backbone.Model({ 'dataset_id': Galaxy.params.dataset_id });
	            this.render();
	        },
	
	        // Fetch data for the selected dataset and
	        render: function () {
	            var data_url = Galaxy.root + 'api/datasets/' + this.model.get('dataset_id'),
	                self = this;
	
	            Utils.get({
	                url: data_url,
	                success: function (dataset) {
	                    var job_url = Galaxy.root + 'api/jobs/' + dataset.creating_job + '?full=True';
	                    Utils.get({
	                        url: job_url,
	                        success: function (job) {
	                            var job_url = Galaxy.root + 'api/jobs/' + dataset.creating_job + '?full=True';
	                            self.render_error_page(self, dataset, job);
	                        },
	                        error: function (response) {
	                            var error_response = {
	                                'status': 'error',
	                                'message': 'Error occured while loading the job.',
	                                'persistent': true,
	                                'cls': 'errormessage'
	                            };
	                            self.display_message(error_response, self.$('.response-message'));
	                        }
	                    });
	                },
	                error: function (response) {
	                    var error_response = {
	                        'status': 'error',
	                        'message': 'Error occured while loading the dataset.',
	                        'persistent': true,
	                        'cls': 'errormessage'
	                    };
	                    self.display_message(error_response, self.$('.response-message'));
	                }
	            });
	        },
	
	        /** Render the view */
	        render_error_page: function (self, dataset, job) {
	            self.$el.empty().append(self._templateHeader());
	            self.$el.append('<h2>Dataset Error</h2>');
	            self.$el.append('<p>An error occured while running the tool <b>' + job.tool_id + '</b>.</p>');
	            self.$el.append('<p>Tool execution generated the following messages:</p>');
	            self.$el.append('<pre class="code">' + job.stderr + '</pre>');
	            self.$el.append('<h2>Report This Error</pre>');
	            self.$el.append('<p>Usually the local Galaxy administrators regularly review errors that occur on the server. However, if you would like to provide additional information (such as what you were trying to do when the error occurred) and a contact e-mail address, we will be better able to investigate your problem and get back to you.</p>');
	            self.$el.append(self._getBugFormTemplate(dataset, job));
	        },
	
	        /** Display actions messages */
	        display_message: function (response, $el, doNotClear, safe) {
	            if (!safe) {
	                if (doNotClear) {
	                    $el.append(new Ui.Message(response).$el);
	                } else {
	                    $el.empty().html(new Ui.Message(response).$el);
	                }
	            } else {
	                if (doNotClear) {
	                    $el.append(new Ui.UnescapedMessage(response).$el);
	                } else {
	                    $el.empty().html(new Ui.UnescapedMessage(response).$el);
	                }
	            }
	        },
	
	        /** Main template */
	        _templateHeader: function () {
	            return '<div class="page-container edit-attr">' + '<div class="response-message"></div>' + '</div>';
	        },
	
	        /** Convert tab template */
	        _getBugFormTemplate: function (dataset, job) {
	            var self = this;
	            var inputs = [{
	                "help": "Your email address",
	                "options": [],
	                "type": "text",
	                "name": "email",
	                "label": "Your email",
	                "value": Galaxy.user.get('email')
	            }, {
	                "help": "Any additional comments you can provide regarding what you were doing at the time of the bug.",
	                "options": [],
	                "type": "text",
	                "area": true,
	                "name": "message",
	                "label": "Message"
	            }];
	
	            // TODO
	            if (false) {
	                inputs.push({
	                    "name": "public_consent",
	                    "label": "Public Disclosure Consent",
	                    "help": "This Galaxy is configured to report to one or more error reporting backends that public to the world. By selecting 'yes', you acknowledge that this bug report will be made public.",
	                    "value": String(Boolean(false)),
	                    "options": [],
	                    "type": "boolean"
	                });
	            }
	
	            var form = new Form({
	                title: 'Error Report',
	                inputs: inputs,
	                buttons: {
	                    save: new Ui.Button({
	                        icon: 'fa-bug',
	                        title: 'Report',
	                        cls: 'ui-button btn btn-primary',
	                        floating: 'clear',
	                        onclick: function () {
	                            var form_data = form.data.create();
	                            var url = Galaxy.root + 'api/jobs/' + job.id + '/error';
	                            form_data.dataset_id = dataset.id;
	                            self.submit(form_data, url);
	                        }
	                    })
	                }
	            });
	            return form.$el;
	        },
	
	        /** Make ajax request */
	        submit: function (form_data, url) {
	            var self = this;
	            // Some required metadata
	            $.ajax({
	                type: "POST",
	                url: url,
	                data: form_data,
	                success: function (response) {
	                    // Clear out the div
	                    self.$el.empty().append(self._templateHeader());
	                    // And display the messages.
	                    response.messages.forEach(function (message) {
	                        self.display_message({
	                            'status': message[1],
	                            'message': message[0],
	                            'persistent': true
	                        }, self.$('.response-message'), true, true);
	                    });
	                },
	                error: function (response) {
	                    var error_response = {
	                        'status': 'error',
	                        'message': 'Error occured while saving. Please fill all the required fields and try again.',
	                        'persistent': true,
	                        'cls': 'errormessage'
	                    };
	                    self.display_message(error_response, self.$('.response-message'));
	                }
	            });
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This class renders the grid list with shared section. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GridView) {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.setElement($('<div/>'));
	            this.model = new Backbone.Model(options);
	            this.item = this.model.get('item');
	            this.title = this.model.get('plural');
	            $.ajax({
	                url: Galaxy.root + this.item + '/' + this.model.get('action_id'),
	                success: function (response) {
	                    response['dict_format'] = true;
	                    self.model.set(response);
	                    self.render();
	                }
	            });
	        },
	
	        render: function () {
	            var grid = new GridView(this.model.attributes);
	            this.$el.empty().append(grid.$el);
	            this.$el.append(this._templateShared());
	        },
	
	        _templateShared: function () {
	            var self = this;
	            var $tmpl = $('<div>' + '<h2>' + this.model.get('plural') + ' shared with you by others</h2>' + '</div>');
	            var options = this.model.attributes;
	            if (options.shared_by_others && options.shared_by_others.length > 0) {
	                var $table = $('<table class="colored" border="0" cellspacing="0" cellpadding="0" width="100%">' + '<tr class="header">' + '<th>Title</th>' + '<th>Owner</th>' + '</tr>' + '</table>');
	                _.each(options.shared_by_others, function (it, index) {
	                    var display_url = Galaxy.root + self.item + '/display_by_username_and_slug?username=' + it.username + '&slug=' + it.slug;
	                    $table.append('<tr>' + '<td>' + '<a href="' + display_url + '">' + _.escape(it.title) + '</a>' + '</td>' + '<td>' + _.escape(it.username) + '</td>' + '</tr>');
	                });
	                $tmpl.append($table);
	            } else {
	                $tmpl.append('No ' + this.model.get('plural').toLowerCase() + ' have been shared with you.');
	            }
	            return $tmpl;
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(84), __webpack_require__(87), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DATASET_LI_EDIT, HDA_LI, BASE_MVC, _l) {
	
	    'use strict';
	
	    //==============================================================================
	
	    var _super = DATASET_LI_EDIT.DatasetListItemEdit;
	    /** @class Editing view for HistoryDatasetAssociation.
	     */
	    var HDAListItemEdit = _super.extend(
	    /** @lends HDAListItemEdit.prototype */{
	
	        className: _super.prototype.className + " history-content",
	
	        /** In this override, only get details if in the ready state, get rerunnable if in other states.
	         *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
	         */
	        _fetchModelDetails: function () {
	            var view = this;
	            if (view.model.inReadyState() && !view.model.hasDetails()) {
	                return view.model.fetch({ silent: true });
	
	                // special case the need for the rerunnable and creating_job attributes
	                // needed for rendering re-run button on queued, running datasets
	            } else if (!view.model.has('rerunnable')) {
	                return view.model.fetch({ silent: true, data: {
	                        // only fetch rerunnable and creating_job to keep overhead down
	                        keys: ['rerunnable', 'creating_job'].join(',')
	                    } });
	            }
	            return jQuery.when();
	        },
	
	        /** event map */
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .unhide-link': function (ev) {
	                this.model.unhide();return false;
	            }
	        }),
	
	        /** string rep */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'HDAListItemEdit(' + modelString + ')';
	        }
	    });
	
	    // ............................................................................ TEMPLATES
	    /** underscore templates */
	    HDAListItemEdit.prototype.templates = function () {
	
	        var warnings = _.extend({}, _super.prototype.templates.warnings, {
	            hidden: BASE_MVC.wrapTemplate(['<% if( !dataset.visible ){ %>',
	            // add a link to unhide a dataset
	            '<div class="hidden-msg warningmessagesmall">', _l('This dataset has been hidden'), '<br /><a class="unhide-link" a href="javascript:void(0);">', _l('Unhide it'), '</a>', '</div>', '<% } %>'], 'dataset')
	        });
	
	        return _.extend({}, _super.prototype.templates, {
	            //NOTE: *steal* the HDAListItemView titleBar
	            titleBar: HDA_LI.HDAListItemView.prototype.templates.titleBar,
	            warnings: warnings
	        });
	    }();
	
	    //==============================================================================
	    return {
	        HDAListItemEdit: HDAListItemEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(89), __webpack_require__(123), __webpack_require__(26), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HDCA_LI, DC_VIEW_EDIT, faIconButton, _l) {
	
	    'use strict';
	
	    //==============================================================================
	
	    var _super = HDCA_LI.HDCAListItemView;
	    /** @class Editing view for HistoryDatasetCollectionAssociation.
	     */
	    var HDCAListItemEdit = _super.extend(
	    /** @lends HDCAListItemEdit.prototype */{
	
	        /** logger used to record this.log messages, commonly set to console */
	        //logger              : console,
	
	        /** Override to return editable versions of the collection panels */
	        _getFoldoutPanelClass: function () {
	            switch (this.model.get('collection_type')) {
	                case 'list':
	                    return DC_VIEW_EDIT.ListCollectionViewEdit;
	                case 'paired':
	                    return DC_VIEW_EDIT.PairCollectionViewEdit;
	                case 'list:paired':
	                    return DC_VIEW_EDIT.ListOfPairsCollectionViewEdit;
	                case 'list:list':
	                    return DC_VIEW_EDIT.ListOfListsCollectionViewEdit;
	            }
	            throw new TypeError('Uknown collection_type: ' + this.model.get('collection_type'));
	        },
	
	        // ......................................................................... delete
	        /** In this override, add the delete button. */
	        _renderPrimaryActions: function () {
	            this.log(this + '._renderPrimaryActions');
	            // render the display, edit attr and delete icon-buttons
	            return _super.prototype._renderPrimaryActions.call(this).concat([this._renderDeleteButton()]);
	        },
	
	        /** Render icon-button to delete this collection. */
	        _renderDeleteButton: function () {
	            var self = this,
	                deleted = this.model.get('deleted');
	            return faIconButton({
	                title: deleted ? _l('Dataset collection is already deleted') : _l('Delete'),
	                classes: 'delete-btn',
	                faIcon: 'fa-times',
	                disabled: deleted,
	                onclick: function () {
	                    // ...bler... tooltips being left behind in DOM (hover out never called on deletion)
	                    self.$el.find('.icon-btn.delete-btn').trigger('mouseout');
	                    self.model['delete']();
	                }
	            });
	        },
	
	        // ......................................................................... misc
	        /** string rep */
	        toString: function () {
	            var modelString = this.model ? this.model + '' : '(no model)';
	            return 'HDCAListItemEdit(' + modelString + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        HDCAListItemEdit: HDCAListItemEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** This class renders the grid list. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(12), __webpack_require__(65), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, GridView, HistoryModel, historyCopyDialog) {
	
	    var View = Backbone.View.extend({
	        title: "Histories",
	        initialize: function (options) {
	            var self = this;
	            this.setElement($('<div/>'));
	            this.model = new Backbone.Model();
	            Utils.get({
	                url: Galaxy.root + 'history/' + options.action_id,
	                success: function (response) {
	                    response['dict_format'] = true;
	                    _.each(response['operations'], function (operation) {
	                        if (operation.label == 'Copy') {
	                            operation.onclick = function (id) {
	                                self._showCopyDialog(id);
	                            };
	                        }
	                    });
	                    self.model.set(response);
	                    self.render();
	                }
	            });
	        },
	
	        render: function () {
	            var grid = new GridView(this.model.attributes);
	            this.$el.empty().append(grid.$el);
	        },
	
	        _showCopyDialog: function (id) {
	            var history = new HistoryModel.History({ id: id });
	            history.fetch().fail(function () {
	                alert('History could not be fetched. Please contact an administrator');
	            }).done(function () {
	                historyCopyDialog(history, {}).done(function () {
	                    if (window.parent && window.parent.Galaxy && window.parent.Galaxy.currHistoryPanel) {
	                        window.parent.Galaxy.currHistoryPanel.loadCurrentHistory();
	                    }
	                    window.location.reload(true);
	                });
	            });
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $, jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(65), __webpack_require__(133), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HISTORY_MODEL, HISTORY_VIEW_EDIT, BASE_MVC, _l) {
	
	    'use strict';
	
	    // ============================================================================
	    /** session storage for history panel preferences (and to maintain state)
	     */
	
	    var HistoryViewPrefs = BASE_MVC.SessionStorageModel.extend(
	    /** @lends HistoryViewPrefs.prototype */{
	        defaults: {
	            /** should the tags editor be shown or hidden initially? */
	            tagsEditorShown: false,
	            /** should the annotation editor be shown or hidden initially? */
	            annotationEditorShown: false,
	            ///** what is the currently focused content (dataset or collection) in the current history?
	            // *      (the history panel will highlight and scroll to the focused content view)
	            // */
	            //focusedContentId : null
	            /** Current scroll position */
	            scrollPosition: 0
	        },
	        toString: function () {
	            return 'HistoryViewPrefs(' + JSON.stringify(this.toJSON()) + ')';
	        }
	    });
	
	    /** key string to store panel prefs (made accessible on class so you can access sessionStorage directly) */
	    HistoryViewPrefs.storageKey = function storageKey() {
	        return 'history-panel';
	    };
	
	    /* =============================================================================
	    TODO:
	    
	    ============================================================================= */
	    var _super = HISTORY_VIEW_EDIT.HistoryViewEdit;
	    // used in root/index.mako
	    /** @class View/Controller for the user's current history model as used in the history
	     *      panel (current right hand panel) of the analysis page.
	     *
	     *  The only history panel that:
	     *      will poll for updates.
	     *      displays datasets in reverse hid order.
	     */
	    var CurrentHistoryView = _super.extend( /** @lends CurrentHistoryView.prototype */{
	
	        className: _super.prototype.className + ' current-history-panel',
	
	        /** override to use drilldown (and not foldout) for how collections are displayed */
	        HDCAViewClass: _super.prototype.HDCAViewClass.extend({
	            foldoutStyle: 'drilldown'
	        }),
	
	        emptyMsg: [_l('This history is empty'), '. ', _l('You can '), '<a class="uploader-link" href="javascript:void(0)">', _l('load your own data'), '</a>', _l(' or '), '<a class="get-data-link" href="javascript:void(0)">', _l('get data from an external source'), '</a>'].join(''),
	
	        // ......................................................................... SET UP
	        /** Set up the view, set up storage, bind listeners to HistoryContents events */
	        initialize: function (attributes) {
	            attributes = attributes || {};
	
	            // ---- persistent preferences
	            /** maintain state / preferences over page loads */
	            this.preferences = new HistoryViewPrefs(_.extend({
	                id: HistoryViewPrefs.storageKey()
	            }, _.pick(attributes, _.keys(HistoryViewPrefs.prototype.defaults))));
	
	            _super.prototype.initialize.call(this, attributes);
	
	            /** sub-views that will overlay this panel (collections) */
	            this.panelStack = [];
	
	            /** id of currently focused content */
	            this.currentContentId = attributes.currentContentId || null;
	            //NOTE: purposely not sent to localstorage since panel recreation roughly lines up with a reset of this value
	        },
	
	        /** Override to cache the current scroll position with a listener */
	        _setUpListeners: function () {
	            _super.prototype._setUpListeners.call(this);
	
	            var panel = this;
	            // reset scroll position when there's a new history
	            this.on('new-model', function () {
	                panel.preferences.set('scrollPosition', 0);
	            });
	        },
	
	        // ------------------------------------------------------------------------ loading history/item models
	        // TODO: next three more appropriate moved to the app level
	        /** (re-)loads the user's current history & contents w/ details */
	        loadCurrentHistory: function () {
	            return this.loadHistory(null, { url: Galaxy.root + 'history/current_history_json' });
	        },
	
	        /** loads a history & contents w/ details and makes them the current history */
	        switchToHistory: function (historyId, attributes) {
	            if (Galaxy.user.isAnonymous()) {
	                this.trigger('error', _l('You must be logged in to switch histories'), _l('Anonymous user'));
	                return $.when();
	            }
	            return this.loadHistory(historyId, { url: Galaxy.root + 'history/set_as_current?id=' + historyId });
	        },
	
	        /** creates a new history on the server and sets it as the user's current history */
	        createNewHistory: function (attributes) {
	            if (Galaxy.user.isAnonymous()) {
	                this.trigger('error', _l('You must be logged in to create histories'), _l('Anonymous user'));
	                return $.when();
	            }
	            return this.loadHistory(null, { url: Galaxy.root + 'history/create_new_current' });
	        },
	
	        /** release/free/shutdown old models and set up panel for new models */
	        setModel: function (model, attributes, render) {
	            _super.prototype.setModel.call(this, model, attributes, render);
	            if (this.model && this.model.id) {
	                this.log('checking for updates');
	                this.model.checkForUpdates();
	            }
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ history/content event listening
	        /** listening for history events */
	        _setUpModelListeners: function () {
	            _super.prototype._setUpModelListeners.call(this);
	            // re-broadcast any model change events so that listeners don't have to re-bind to each history
	            return this.listenTo(this.model, {
	                'change:nice_size change:size': function () {
	                    this.trigger('history-size-change', this, this.model, arguments);
	                },
	                'change:id': function () {
	                    this.once('loading-done', function () {
	                        this.model.checkForUpdates();
	                    });
	                }
	            });
	        },
	
	        /** listening for collection events */
	        _setUpCollectionListeners: function () {
	            _super.prototype._setUpCollectionListeners.call(this);
	            // if a hidden item is created (gen. by a workflow), moves thru the updater to the ready state,
	            //  then: remove it from the collection if the panel is set to NOT show hidden datasets
	            this.listenTo(this.collection, 'state:ready', function (model, newState, oldState) {
	                if (!model.get('visible') && !this.collection.storage.includeHidden()) {
	                    this.removeItemView(model);
	                }
	            });
	        },
	
	        // ------------------------------------------------------------------------ panel rendering
	        /** override to add a handler to capture the scroll position when the parent scrolls */
	        _setUpBehaviors: function ($where) {
	            $where = $where || this.$el;
	            // console.log( '_setUpBehaviors', this.$scrollContainer( $where ).get(0), this.$list( $where ) );
	            // we need to call this in _setUpBehaviors which is called after render since the $el
	            // may not be attached to $el.parent and $scrollContainer() may not work
	            var panel = this;
	            _super.prototype._setUpBehaviors.call(panel, $where);
	
	            // cache the handler to remove and re-add so we don't pile up the handlers
	            if (!this._debouncedScrollCaptureHandler) {
	                this._debouncedScrollCaptureHandler = _.debounce(function scrollCapture() {
	                    // cache the scroll position (only if visible)
	                    if (panel.$el.is(':visible')) {
	                        panel.preferences.set('scrollPosition', $(this).scrollTop());
	                    }
	                }, 40);
	            }
	
	            panel.$scrollContainer($where).off('scroll', this._debouncedScrollCaptureHandler).on('scroll', this._debouncedScrollCaptureHandler);
	            return panel;
	        },
	
	        /** In this override, handle null models and move the search input to the top */
	        _buildNewRender: function () {
	            if (!this.model) {
	                return $();
	            }
	            var $newRender = _super.prototype._buildNewRender.call(this);
	            $newRender.find('.search').prependTo($newRender.find('> .controls'));
	            this._renderQuotaMessage($newRender);
	            return $newRender;
	        },
	
	        /** render the message displayed when a user is over quota and can't run jobs */
	        _renderQuotaMessage: function ($whereTo) {
	            $whereTo = $whereTo || this.$el;
	            return $(this.templates.quotaMsg({}, this)).prependTo($whereTo.find('.messages'));
	        },
	
	        /** In this override, get and set current panel preferences when editor is used */
	        _renderTags: function ($where) {
	            var panel = this;
	            // render tags and show/hide based on preferences
	            _super.prototype._renderTags.call(panel, $where);
	            if (panel.preferences.get('tagsEditorShown')) {
	                panel.tagsEditor.toggle(true);
	            }
	            // store preference when shown or hidden
	            panel.listenTo(panel.tagsEditor, 'hiddenUntilActivated:shown hiddenUntilActivated:hidden', function (tagsEditor) {
	                panel.preferences.set('tagsEditorShown', tagsEditor.hidden);
	            });
	        },
	
	        /** In this override, get and set current panel preferences when editor is used */
	        _renderAnnotation: function ($where) {
	            var panel = this;
	            // render annotation and show/hide based on preferences
	            _super.prototype._renderAnnotation.call(panel, $where);
	            if (panel.preferences.get('annotationEditorShown')) {
	                panel.annotationEditor.toggle(true);
	            }
	            // store preference when shown or hidden
	            panel.listenTo(panel.annotationEditor, 'hiddenUntilActivated:shown hiddenUntilActivated:hidden', function (annotationEditor) {
	                panel.preferences.set('annotationEditorShown', annotationEditor.hidden);
	            });
	        },
	
	        /** Override to scroll to cached position (in prefs) after swapping */
	        _swapNewRender: function ($newRender) {
	            _super.prototype._swapNewRender.call(this, $newRender);
	            var panel = this;
	            _.delay(function () {
	                var pos = panel.preferences.get('scrollPosition');
	                if (pos) {
	                    panel.scrollTo(pos, 0);
	                }
	            }, 10);
	            //TODO: is this enough of a delay on larger histories?
	
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ sub-views
	        /** Override to add the current-content highlight class to currentContentId's view */
	        _attachItems: function ($whereTo) {
	            _super.prototype._attachItems.call(this, $whereTo);
	            var panel = this;
	            if (panel.currentContentId) {
	                panel._setCurrentContentById(panel.currentContentId);
	            }
	            return this;
	        },
	
	        /** Override to remove any drill down panels */
	        addItemView: function (model, collection, options) {
	            var view = _super.prototype.addItemView.call(this, model, collection, options);
	            if (!view) {
	                return view;
	            }
	            if (this.panelStack.length) {
	                return this._collapseDrilldownPanel();
	            }
	            return view;
	        },
	
	        // ------------------------------------------------------------------------ collection sub-views
	        /** In this override, add/remove expanded/collapsed model ids to/from web storage */
	        _setUpItemViewListeners: function (view) {
	            var panel = this;
	            _super.prototype._setUpItemViewListeners.call(panel, view);
	            // use pub-sub to: handle drilldown expansion and collapse
	            return panel.listenTo(view, {
	                'expanded:drilldown': function (v, drilldown) {
	                    this._expandDrilldownPanel(drilldown);
	                },
	                'collapsed:drilldown': function (v, drilldown) {
	                    this._collapseDrilldownPanel(drilldown);
	                }
	            });
	        },
	
	        /** display 'current content': add a visible highlight and store the id of a content item */
	        setCurrentContent: function (view) {
	            this.$('.history-content.current-content').removeClass('current-content');
	            if (view) {
	                view.$el.addClass('current-content');
	                this.currentContentId = view.model.id;
	            } else {
	                this.currentContentId = null;
	            }
	        },
	
	        /** find the view with the id and then call setCurrentContent on it */
	        _setCurrentContentById: function (id) {
	            var view = this.viewFromModelId(id) || null;
	            this.setCurrentContent(view);
	        },
	
	        /** Handle drill down by hiding this panels list and controls and showing the sub-panel */
	        _expandDrilldownPanel: function (drilldown) {
	            this.panelStack.push(drilldown);
	            // hide this panel's controls and list, set the name for back navigation, and attach to the $el
	            this.$controls().add(this.$list()).hide();
	            drilldown.parentName = this.model.get('name');
	            drilldown.delegateEvents().render().$el.appendTo(this.$el);
	        },
	
	        /** Handle drilldown close by freeing the panel and re-rendering this panel */
	        _collapseDrilldownPanel: function (drilldown) {
	            this.panelStack.pop();
	            //TODO: MEM: free the panel
	            this.$controls().add(this.$list()).show();
	        },
	
	        // ........................................................................ panel events
	        /** event map */
	        events: _.extend(_.clone(_super.prototype.events), {
	            // the two links in the empty message
	            'click .uploader-link': function (ev) {
	                Galaxy.upload.show(ev);
	            },
	            'click .get-data-link': function (ev) {
	                var $toolMenu = $('.toolMenuContainer');
	                $toolMenu.parent().scrollTop(0);
	                $toolMenu.find('span:contains("Get Data")').click();
	            }
	        }),
	
	        // ........................................................................ external objects/MVC
	        listenToGalaxy: function (galaxy) {
	            this.listenTo(galaxy, {
	                // when the galaxy_main iframe is loaded with a new page,
	                // compare the url to the following list and if there's a match
	                // pull the id from url and indicate in the history view that
	                // the dataset with that id is the 'current'ly active dataset
	                'center-frame:load': function (data) {
	                    var pathToMatch = data.fullpath;
	                    var hdaId = null;
	                    var useToURLRegexMap = {
	                        'display': /datasets\/([a-f0-9]+)\/display/,
	                        'edit': /datasets\/([a-f0-9]+)\/edit/,
	                        'report_error': /dataset\/errors\?id=([a-f0-9]+)/,
	                        'rerun': /tool_runner\/rerun\?id=([a-f0-9]+)/,
	                        'show_params': /datasets\/([a-f0-9]+)\/show_params/
	                        // no great way to do this here? (leave it in the dataset event handlers above?)
	                        // 'visualization' : 'visualization',
	                    };
	                    _.find(useToURLRegexMap, function (regex, use) {
	                        // grab the more specific match result (1), save, and use it as the find flag
	                        hdaId = _.result(pathToMatch.match(regex), 1);
	                        return hdaId;
	                    });
	                    // need to type mangle to go from web route to history contents
	                    this._setCurrentContentById(hdaId ? 'dataset-' + hdaId : null);
	                },
	                // when the center panel is given a new view, clear the current indicator
	                'center-panel:load': function (view) {
	                    this._setCurrentContentById();
	                }
	            });
	        },
	
	        //TODO: remove quota meter from panel and remove this
	        /** add listeners to an external quota meter (mvc/user/user-quotameter.js) */
	        connectToQuotaMeter: function (quotaMeter) {
	            if (!quotaMeter) {
	                return this;
	            }
	            // show/hide the 'over quota message' in the history when the meter tells it to
	            this.listenTo(quotaMeter, 'quota:over', this.showQuotaMessage);
	            this.listenTo(quotaMeter, 'quota:under', this.hideQuotaMessage);
	
	            // having to add this to handle re-render of hview while overquota (the above do not fire)
	            this.on('rendered rendered:initial', function () {
	                if (quotaMeter && quotaMeter.isOverQuota()) {
	                    this.showQuotaMessage();
	                }
	            });
	            return this;
	        },
	
	        /** Override to preserve the quota message */
	        clearMessages: function (ev) {
	            var $target = !_.isUndefined(ev) ? $(ev.currentTarget) : this.$messages().children('[class$="message"]');
	            $target = $target.not('.quota-message');
	            $target.fadeOut(this.fxSpeed, function () {
	                $(this).remove();
	            });
	            return this;
	        },
	
	        /** Show the over quota message (which happens to be in the history panel).
	         */
	        showQuotaMessage: function () {
	            var $msg = this.$('.quota-message');
	            if ($msg.is(':hidden')) {
	                $msg.slideDown(this.fxSpeed);
	            }
	        },
	
	        /** Hide the over quota message (which happens to be in the history panel).
	         */
	        hideQuotaMessage: function () {
	            var $msg = this.$('.quota-message');
	            if (!$msg.is(':hidden')) {
	                $msg.slideUp(this.fxSpeed);
	            }
	        },
	
	        // ........................................................................ options menu
	        //TODO: remove to batch
	        /** unhide any hidden datasets */
	        unhideHidden: function () {
	            var self = this;
	            if (confirm(_l('Really unhide all hidden datasets?'))) {
	                // get all hidden, regardless of deleted/purged
	                return self.model.contents._filterAndUpdate({ visible: false, deleted: '', purged: '' }, { visible: true }).done(function () {
	                    // TODO: would be better to render these as they're unhidden instead of all at once
	                    if (!self.model.contents.includeHidden) {
	                        self.renderItems();
	                    }
	                });
	            }
	            return jQuery.when();
	        },
	
	        /** delete any hidden datasets */
	        deleteHidden: function () {
	            var self = this;
	            if (confirm(_l('Really delete all hidden datasets?'))) {
	                return self.model.contents._filterAndUpdate(
	                // get all hidden, regardless of deleted/purged
	                { visible: false, deleted: '', purged: '' },
	                // both delete *and* unhide them
	                { deleted: true, visible: true });
	            }
	            return jQuery.when();
	        },
	
	        /** Return a string rep of the history */
	        toString: function () {
	            return 'CurrentHistoryView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //------------------------------------------------------------------------------ TEMPLATES
	    CurrentHistoryView.prototype.templates = function () {
	
	        var quotaMsgTemplate = BASE_MVC.wrapTemplate(['<div class="quota-message errormessage">', _l('You are over your disk quota'), '. ', _l('Tool execution is on hold until your disk usage drops below your allocated quota'), '.', '</div>'], 'history');
	        return _.extend(_.clone(_super.prototype.templates), {
	            quotaMsg: quotaMsgTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        CurrentHistoryView: CurrentHistoryView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(134), __webpack_require__(64), __webpack_require__(17), __webpack_require__(88), __webpack_require__(129), __webpack_require__(130), __webpack_require__(45), __webpack_require__(80), __webpack_require__(60), __webpack_require__(125), __webpack_require__(124), __webpack_require__(26), __webpack_require__(18), __webpack_require__(7), __webpack_require__(6), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HISTORY_VIEW, HISTORY_CONTENTS, STATES, HDA_MODEL, HDA_LI_EDIT, HDCA_LI_EDIT, TAGS, ANNOTATIONS, LIST_COLLECTION_CREATOR, PAIR_COLLECTION_CREATOR, LIST_OF_PAIRS_COLLECTION_CREATOR, faIconButton, PopupMenu, BASE_MVC, _l) {
	
	    'use strict';
	
	    /* =============================================================================
	    TODO:
	    
	    ============================================================================= */
	
	    var _super = HISTORY_VIEW.HistoryView;
	    // base class for history-view-edit-current and used as-is in history/view.mako
	    /** @class Editable View/Controller for the history model.
	     *
	     *  Allows:
	     *      (everything HistoryView allows)
	     *      changing the name
	     *      displaying and editing tags and annotations
	     *      multi-selection and operations on mulitple content items
	     */
	    var HistoryViewEdit = _super.extend(
	    /** @lends HistoryViewEdit.prototype */{
	
	        /** class to use for constructing the HistoryDatasetAssociation views */
	        HDAViewClass: HDA_LI_EDIT.HDAListItemEdit,
	        /** class to use for constructing the HistoryDatasetCollectionAssociation views */
	        HDCAViewClass: HDCA_LI_EDIT.HDCAListItemEdit,
	
	        // ......................................................................... SET UP
	        /** Set up the view, set up storage, bind listeners to HistoryContents events
	         *  @param {Object} attributes
	         */
	        initialize: function (attributes) {
	            attributes = attributes || {};
	            _super.prototype.initialize.call(this, attributes);
	
	            // ---- set up instance vars
	            /** editor for tags - sub-view */
	            this.tagsEditor = null;
	
	            /** enable drag and drop - sub-view */
	            this.dragItems = true;
	
	            /** editor for annotations - sub-view */
	            this.annotationEditor = null;
	
	            /** allow user purge of dataset files? */
	            this.purgeAllowed = attributes.purgeAllowed || false;
	
	            // states/modes the panel can be in
	            /** is the panel currently showing the dataset selection controls? */
	            this.annotationEditorShown = attributes.annotationEditorShown || false;
	            this.tagsEditorShown = attributes.tagsEditorShown || false;
	        },
	
	        /** Override to handle history as drag-drop target */
	        _setUpListeners: function () {
	            _super.prototype._setUpListeners.call(this);
	            return this.on({
	                'droptarget:drop': function (ev, data) {
	                    // process whatever was dropped and re-hide the drop target
	                    this.dataDropped(data);
	                    this.dropTargetOff();
	                },
	                'view:attached view:removed': function () {
	                    this._renderCounts();
	                },
	                'search:loading-progress': this._renderSearchProgress,
	                'search:searching': this._renderSearchFindings
	            });
	        },
	
	        // ------------------------------------------------------------------------ listeners
	        /** listening for history and HDA events */
	        _setUpModelListeners: function () {
	            _super.prototype._setUpModelListeners.call(this);
	            this.listenTo(this.model, 'change:size', this.updateHistoryDiskSize);
	            return this;
	        },
	
	        /** listening for collection events */
	        _setUpCollectionListeners: function () {
	            _super.prototype._setUpCollectionListeners.call(this);
	            this.listenTo(this.collection, {
	                'change:deleted': this._handleItemDeletedChange,
	                'change:visible': this._handleItemVisibleChange,
	                'change:purged': function (model) {
	                    // hafta get the new nice-size w/o the purged model
	                    this.model.fetch();
	                },
	                // loading indicators for deleted/hidden
	                'fetching-deleted': function (collection) {
	                    this.$('> .controls .deleted-count').html('<i>' + _l('loading...') + '</i>');
	                },
	                'fetching-hidden': function (collection) {
	                    this.$('> .controls .hidden-count').html('<i>' + _l('loading...') + '</i>');
	                },
	                'fetching-deleted-done fetching-hidden-done': this._renderCounts
	            });
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ panel rendering
	        /** In this override, add tag and annotation editors and a btn to toggle the selectors */
	        _buildNewRender: function () {
	            // create a new render using a skeleton template, render title buttons, render body, and set up events, etc.
	            var $newRender = _super.prototype._buildNewRender.call(this);
	            if (!this.model) {
	                return $newRender;
	            }
	
	            if (Galaxy && Galaxy.user && Galaxy.user.id && Galaxy.user.id === this.model.get('user_id')) {
	                this._renderTags($newRender);
	                this._renderAnnotation($newRender);
	            }
	            return $newRender;
	        },
	
	        /** Update the history size display (curr. upper right of panel). */
	        updateHistoryDiskSize: function () {
	            this.$('.history-size').text(this.model.get('nice_size'));
	        },
	
	        /** override to render counts when the items are rendered */
	        renderItems: function ($whereTo) {
	            var views = _super.prototype.renderItems.call(this, $whereTo);
	            if (!this.searchFor) {
	                this._renderCounts($whereTo);
	            } else {
	                this._renderSearchFindings($whereTo);
	            }
	            return views;
	        },
	
	        /** override to show counts, what's deleted/hidden, and links to toggle those */
	        _renderCounts: function ($whereTo) {
	            $whereTo = $whereTo instanceof jQuery ? $whereTo : this.$el;
	            var html = this.templates.counts(this.model.toJSON(), this);
	            return $whereTo.find('> .controls .subtitle').html(html);
	        },
	
	        /** render the tags sub-view controller */
	        _renderTags: function ($where) {
	            var panel = this;
	            this.tagsEditor = new TAGS.TagsEditor({
	                model: this.model,
	                el: $where.find('.controls .tags-display'),
	                onshowFirstTime: function () {
	                    this.render();
	                },
	                // show hide sub-view tag editors when this is shown/hidden
	                onshow: function () {
	                    panel.toggleHDATagEditors(true, panel.fxSpeed);
	                },
	                onhide: function () {
	                    panel.toggleHDATagEditors(false, panel.fxSpeed);
	                },
	                $activator: faIconButton({
	                    title: _l('Edit history tags'),
	                    classes: 'history-tag-btn',
	                    faIcon: 'fa-tags'
	                }).appendTo($where.find('.controls .actions'))
	            });
	        },
	        /** render the annotation sub-view controller */
	        _renderAnnotation: function ($where) {
	            var panel = this;
	            this.annotationEditor = new ANNOTATIONS.AnnotationEditor({
	                model: this.model,
	                el: $where.find('.controls .annotation-display'),
	                onshowFirstTime: function () {
	                    this.render();
	                },
	                // show hide sub-view view annotation editors when this is shown/hidden
	                onshow: function () {
	                    panel.toggleHDAAnnotationEditors(true, panel.fxSpeed);
	                },
	                onhide: function () {
	                    panel.toggleHDAAnnotationEditors(false, panel.fxSpeed);
	                },
	                $activator: faIconButton({
	                    title: _l('Edit history annotation'),
	                    classes: 'history-annotate-btn',
	                    faIcon: 'fa-comment'
	                }).appendTo($where.find('.controls .actions'))
	            });
	        },
	
	        /** Set up HistoryViewEdit js/widget behaviours
	         *  In this override, make the name editable
	         */
	        _setUpBehaviors: function ($where) {
	            $where = $where || this.$el;
	            _super.prototype._setUpBehaviors.call(this, $where);
	            if (!this.model) {
	                return;
	            }
	
	            // anon users shouldn't have access to any of the following
	            if (!Galaxy.user || Galaxy.user.isAnonymous() || Galaxy.user.id !== this.model.get('user_id')) {
	                return;
	            }
	
	            var panel = this,
	                nameSelector = '> .controls .name';
	            $where.find(nameSelector).attr('title', _l('Click to rename history')).tooltip({ placement: 'bottom' }).make_text_editable({
	                on_finish: function (newName) {
	                    var previousName = panel.model.get('name');
	                    if (newName && newName !== previousName) {
	                        panel.$el.find(nameSelector).text(newName);
	                        panel.model.save({ name: newName }).fail(function () {
	                            panel.$el.find(nameSelector).text(panel.model.previous('name'));
	                        });
	                    } else {
	                        panel.$el.find(nameSelector).text(previousName);
	                    }
	                }
	            });
	        },
	
	        /** return a new popup menu for choosing a multi selection action
	         *  ajax calls made for multiple datasets are queued
	         */
	        multiselectActions: function () {
	            var panel = this,
	                actions = [{ html: _l('Hide datasets'), func: function () {
	                    var action = HDA_MODEL.HistoryDatasetAssociation.prototype.hide;
	                    panel.getSelectedModels().ajaxQueue(action);
	                }
	            }, { html: _l('Unhide datasets'), func: function () {
	                    var action = HDA_MODEL.HistoryDatasetAssociation.prototype.unhide;
	                    panel.getSelectedModels().ajaxQueue(action);
	                }
	            }, { html: _l('Delete datasets'), func: function () {
	                    var action = HDA_MODEL.HistoryDatasetAssociation.prototype['delete'];
	                    panel.getSelectedModels().ajaxQueue(action);
	                }
	            }, { html: _l('Undelete datasets'), func: function () {
	                    var action = HDA_MODEL.HistoryDatasetAssociation.prototype.undelete;
	                    panel.getSelectedModels().ajaxQueue(action);
	                }
	            }];
	            if (panel.purgeAllowed) {
	                actions.push({
	                    html: _l('Permanently delete datasets'), func: function () {
	                        if (confirm(_l('This will permanently remove the data in your datasets. Are you sure?'))) {
	                            var action = HDA_MODEL.HistoryDatasetAssociation.prototype.purge;
	                            panel.getSelectedModels().ajaxQueue(action);
	                        }
	                    }
	                });
	            }
	            actions = actions.concat(panel._collectionActions());
	            return actions;
	        },
	
	        /**   */
	        _collectionActions: function () {
	            var panel = this;
	            return [{ html: _l('Build Dataset List'), func: function () {
	                    panel.buildCollection("list");
	                }
	            },
	            // TODO: Only show quick pair if two things selected.
	            { html: _l('Build Dataset Pair'), func: function () {
	                    panel.buildCollection("paired");
	                }
	            }, { html: _l('Build List of Dataset Pairs'), func: function () {
	                    panel.buildCollection("list:paired");
	                }
	            }];
	        },
	
	        buildCollection: function (collectionType, selection, hideSourceItems) {
	            var panel = this;
	            var selection = selection || panel.getSelectedModels();
	            var hideSourceItems = hideSourceItems || false;
	            var createFunc;
	            if (collectionType == "list") {
	                createFunc = LIST_COLLECTION_CREATOR.createListCollection;
	            } else if (collectionType == "paired") {
	                createFunc = PAIR_COLLECTION_CREATOR.createPairCollection;
	            } else if (collectionType == "list:paired") {
	                createFunc = LIST_OF_PAIRS_COLLECTION_CREATOR.createListOfPairsCollection;
	            } else {
	                console.warn("Unknown collectionType encountered " + collectionType);
	            }
	            createFunc(selection, hideSourceItems).done(function () {
	                panel.model.refresh();
	            });
	        },
	
	        // ------------------------------------------------------------------------ sub-views
	        /** In this override, add purgeAllowed and whether tags/annotation editors should be shown */
	        _getItemViewOptions: function (model) {
	            var options = _super.prototype._getItemViewOptions.call(this, model);
	            _.extend(options, {
	                purgeAllowed: this.purgeAllowed,
	                tagsEditorShown: this.tagsEditor && !this.tagsEditor.hidden,
	                annotationEditorShown: this.annotationEditor && !this.annotationEditor.hidden
	            });
	            return options;
	        },
	
	        /** If this item is deleted and we're not showing deleted items, remove the view
	         *  @param {Model} the item model to check
	         */
	        _handleItemDeletedChange: function (itemModel) {
	            if (itemModel.get('deleted')) {
	                this._handleItemDeletion(itemModel);
	            } else {
	                this._handleItemUndeletion(itemModel);
	            }
	            this._renderCounts();
	        },
	
	        _handleItemDeletion: function (itemModel) {
	            var contentsShown = this.model.get('contents_active');
	            contentsShown.deleted += 1;
	            contentsShown.active -= 1;
	            if (!this.model.contents.includeDeleted) {
	                this.removeItemView(itemModel);
	            }
	            this.model.set('contents_active', contentsShown);
	        },
	
	        _handleItemUndeletion: function (itemModel) {
	            var contentsShown = this.model.get('contents_active');
	            contentsShown.deleted -= 1;
	            if (!this.model.contents.includeDeleted) {
	                contentsShown.active -= 1;
	            }
	            this.model.set('contents_active', contentsShown);
	        },
	
	        /** If this item is hidden and we're not showing hidden items, remove the view
	         *  @param {Model} the item model to check
	         */
	        _handleItemVisibleChange: function (itemModel) {
	            if (itemModel.hidden()) {
	                this._handleItemHidden(itemModel);
	            } else {
	                this._handleItemUnhidden(itemModel);
	            }
	            this._renderCounts();
	        },
	
	        _handleItemHidden: function (itemModel) {
	            var contentsShown = this.model.get('contents_active');
	            contentsShown.hidden += 1;
	            contentsShown.active -= 1;
	            if (!this.model.contents.includeHidden) {
	                this.removeItemView(itemModel);
	            }
	            this.model.set('contents_active', contentsShown);
	        },
	
	        _handleItemUnhidden: function (itemModel) {
	            var contentsShown = this.model.get('contents_active');
	            contentsShown.hidden -= 1;
	            if (!this.model.contents.includeHidden) {
	                contentsShown.active -= 1;
	            }
	            this.model.set('contents_active', contentsShown);
	        },
	
	        /** toggle the visibility of each content's tagsEditor applying all the args sent to this function */
	        toggleHDATagEditors: function (showOrHide, speed) {
	            _.each(this.views, function (view) {
	                if (view.tagsEditor) {
	                    view.tagsEditor.toggle(showOrHide, speed);
	                }
	            });
	        },
	
	        /** toggle the visibility of each content's annotationEditor applying all the args sent to this function */
	        toggleHDAAnnotationEditors: function (showOrHide, speed) {
	            _.each(this.views, function (view) {
	                if (view.annotationEditor) {
	                    view.annotationEditor.toggle(showOrHide, speed);
	                }
	            });
	        },
	
	        // ------------------------------------------------------------------------ panel events
	        /** event map */
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .show-selectors-btn': 'toggleSelectors',
	            'click .toggle-deleted-link': function (ev) {
	                this.toggleShowDeleted();
	            },
	            'click .toggle-hidden-link': function (ev) {
	                this.toggleShowHidden();
	            }
	        }),
	
	        // ------------------------------------------------------------------------ search
	        _renderSearchProgress: function (limit, offset) {
	            var stop = limit + offset;
	            return this.$('> .controls .subtitle').html(['<i>', _l('Searching '), stop, '/', this.model.contentsShown(), '</i>'].join(''));
	        },
	
	        /** override to display number found in subtitle */
	        _renderSearchFindings: function ($whereTo) {
	            $whereTo = $whereTo instanceof jQuery ? $whereTo : this.$el;
	            var html = this.templates.found(this.model.toJSON(), this);
	            $whereTo.find('> .controls .subtitle').html(html);
	            return this;
	        },
	
	        // ------------------------------------------------------------------------ as drop target
	        /** turn all the drag and drop handlers on and add some help text above the drop area */
	        dropTargetOn: function () {
	            if (this.dropTarget) {
	                return this;
	            }
	            this.dropTarget = true;
	
	            //TODO: to init
	            var dropHandlers = {
	                'dragenter': _.bind(this.dragenter, this),
	                'dragover': _.bind(this.dragover, this),
	                'dragleave': _.bind(this.dragleave, this),
	                'drop': _.bind(this.drop, this)
	            };
	
	            var $dropTarget = this._renderDropTarget();
	            this.$list().before([this._renderDropTargetHelp(), $dropTarget]);
	            for (var evName in dropHandlers) {
	                if (dropHandlers.hasOwnProperty(evName)) {
	                    //console.debug( evName, dropHandlers[ evName ] );
	                    $dropTarget.on(evName, dropHandlers[evName]);
	                }
	            }
	            return this;
	        },
	
	        /** render a box to serve as a 'drop here' area on the history */
	        _renderDropTarget: function () {
	            this.$('.history-drop-target').remove();
	            return $('<div/>').addClass('history-drop-target');
	        },
	
	        /** tell the user how it works  */
	        _renderDropTargetHelp: function () {
	            this.$('.history-drop-target-help').remove();
	            return $('<div/>').addClass('history-drop-target-help').text(_l('Drag datasets here to copy them to the current history'));
	        },
	
	        /** shut down drag and drop event handlers and remove drop target */
	        dropTargetOff: function () {
	            if (!this.dropTarget) {
	                return this;
	            }
	            //this.log( 'dropTargetOff' );
	            this.dropTarget = false;
	            var dropTarget = this.$('.history-drop-target').get(0);
	            for (var evName in this._dropHandlers) {
	                if (this._dropHandlers.hasOwnProperty(evName)) {
	                    dropTarget.off(evName, this._dropHandlers[evName]);
	                }
	            }
	            this.$('.history-drop-target').remove();
	            this.$('.history-drop-target-help').remove();
	            return this;
	        },
	        /** toggle the target on/off */
	        dropTargetToggle: function () {
	            if (this.dropTarget) {
	                this.dropTargetOff();
	            } else {
	                this.dropTargetOn();
	            }
	            return this;
	        },
	
	        dragenter: function (ev) {
	            //console.debug( 'dragenter:', this, ev );
	            ev.preventDefault();
	            ev.stopPropagation();
	            this.$('.history-drop-target').css('border', '2px solid black');
	        },
	        dragover: function (ev) {
	            ev.preventDefault();
	            ev.stopPropagation();
	        },
	        dragleave: function (ev) {
	            //console.debug( 'dragleave:', this, ev );
	            ev.preventDefault();
	            ev.stopPropagation();
	            this.$('.history-drop-target').css('border', '1px dashed black');
	        },
	        /** when (text) is dropped try to parse as json and trigger an event */
	        drop: function (ev) {
	            ev.preventDefault();
	            //ev.stopPropagation();
	
	            var self = this;
	            var dataTransfer = ev.originalEvent.dataTransfer;
	            var data = dataTransfer.getData("text");
	
	            dataTransfer.dropEffect = 'move';
	            try {
	                data = JSON.parse(data);
	            } catch (err) {
	                self.warn('error parsing JSON from drop:', data);
	            }
	
	            self.trigger('droptarget:drop', ev, data, self);
	            return false;
	        },
	
	        /** handler that copies data into the contents */
	        dataDropped: function (data) {
	            var self = this;
	            // HDA: dropping will copy it to the history
	            if (_.isObject(data) && data.model_class === 'HistoryDatasetAssociation' && data.id) {
	                if (self.contents.currentPage !== 0) {
	                    return self.contents.fetchPage(0).then(function () {
	                        return self.model.contents.copy(data.id);
	                    });
	                }
	                return self.model.contents.copy(data.id);
	            }
	            return jQuery.when();
	        },
	
	        // ........................................................................ misc
	        /** Return a string rep of the history */
	        toString: function () {
	            return 'HistoryViewEdit(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //------------------------------------------------------------------------------ TEMPLATES
	    HistoryViewEdit.prototype.templates = function () {
	
	        var countsTemplate = BASE_MVC.wrapTemplate(['<% var shown = Math.max( view.views.length, history.contents_active.active ) %>', '<% if( shown ){ %>', '<span class="shown-count">', '<%- shown %> ', _l('shown'), '</span>', '<% } %>', '<% if( history.contents_active.deleted ){ %>', '<span class="deleted-count">', '<% if( view.model.contents.includeDeleted ){ %>', '<a class="toggle-deleted-link" href="javascript:void(0);">', _l('hide deleted'), '</a>', '<% } else { %>', '<%- history.contents_active.deleted %> ', '<a class="toggle-deleted-link" href="javascript:void(0);">', _l('deleted'), '</a>', '<% } %>', '</span>', '<% } %>', '<% if( history.contents_active.hidden ){ %>', '<span class="hidden-count">', '<% if( view.model.contents.includeHidden ){ %>', '<a class="toggle-hidden-link" href="javascript:void(0);">', _l('hide hidden'), '</a>', '<% } else { %>', '<%- history.contents_active.hidden %> ', '<a class="toggle-hidden-link" href="javascript:void(0);">', _l('hidden'), '</a>', '<% } %>', '</span>', '<% } %>'], 'history');
	
	        var foundTemplate = BASE_MVC.wrapTemplate([_l('Found'), ' <%- view.views.length %>, ', '<% if( history.contents_active.deleted ){ %>', '<% if( view.model.contents.includeDeleted ){ %>', '<a class="toggle-deleted-link" href="javascript:void(0);">', _l('hide deleted'), '</a>, ', '<% } else { %>', '<a class="toggle-deleted-link" href="javascript:void(0);">', _l('show deleted'), '</a>, ', '<% } %>', '<% } %>', '<% if( history.contents_active.hidden ){ %>', '<% if( view.model.contents.includeHidden ){ %>', '<a class="toggle-hidden-link" href="javascript:void(0);">', _l('hide hidden'), '</a>', '<% } else { %>', '<a class="toggle-hidden-link" href="javascript:void(0);">', _l('show hidden'), '</a>', '<% } %>', '<% } %>'], 'history');
	
	        return _.extend(_.clone(_super.prototype.templates), {
	            counts: countsTemplate,
	            found: foundTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        HistoryViewEdit: HistoryViewEdit
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(91), __webpack_require__(65), __webpack_require__(64), __webpack_require__(66), __webpack_require__(87), __webpack_require__(89), __webpack_require__(95), __webpack_require__(94), __webpack_require__(26), __webpack_require__(7), __webpack_require__(6), __webpack_require__(98)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LIST_VIEW, HISTORY_MODEL, HISTORY_CONTENTS, HISTORY_PREFS, HDA_LI, HDCA_LI, USER, ERROR_MODAL, faIconButton, BASE_MVC, _l) {
	    'use strict';
	
	    /* =============================================================================
	    TODO:
	    
	    ============================================================================= */
	    /** @class  non-editable, read-only View/Controller for a history model.
	     *  Allows:
	     *      changing the loaded history
	     *      displaying data, info, and download
	     *      tracking history attrs: size, tags, annotations, name, etc.
	     *  Does not allow:
	     *      changing the name
	     */
	
	    var _super = LIST_VIEW.ModelListPanel;
	    var HistoryView = _super.extend(
	    /** @lends HistoryView.prototype */{
	        _logNamespace: 'history',
	
	        /** class to use for constructing the HDA views */
	        HDAViewClass: HDA_LI.HDAListItemView,
	        /** class to use for constructing the HDCA views */
	        HDCAViewClass: HDCA_LI.HDCAListItemView,
	        /** class to used for constructing collection of sub-view models */
	        collectionClass: HISTORY_CONTENTS.HistoryContents,
	        /** key of attribute in model to assign to this.collection */
	        modelCollectionKey: 'contents',
	
	        tagName: 'div',
	        className: _super.prototype.className + ' history-panel',
	
	        /** string to display when the collection is empty */
	        emptyMsg: _l('This history is empty'),
	        /** displayed when no items match the search terms */
	        noneFoundMsg: _l('No matching datasets found'),
	        /** string used for search placeholder */
	        searchPlaceholder: _l('search datasets'),
	
	        /** @type {Number} ms to wait after history load to fetch/decorate hdcas with element_count */
	        FETCH_COLLECTION_COUNTS_DELAY: 2000,
	
	        // ......................................................................... SET UP
	        /** Set up the view, bind listeners.
	         *  @param {Object} attributes optional settings for the panel
	         */
	        initialize: function (attributes) {
	            _super.prototype.initialize.call(this, attributes);
	            // ---- instance vars
	            // control contents/behavior based on where (and in what context) the panel is being used
	            /** where should pages from links be displayed? (default to new tab/window) */
	            this.linkTarget = attributes.linkTarget || '_blank';
	        },
	
	        /** create and return a collection for when none is initially passed */
	        _createDefaultCollection: function () {
	            // override
	            return new this.collectionClass([], { history: this.model });
	        },
	
	        /** In this override, clear the update timer on the model */
	        freeModel: function () {
	            _super.prototype.freeModel.call(this);
	            if (this.model) {
	                this.model.clearUpdateTimeout();
	            }
	            return this;
	        },
	
	        /** create any event listeners for the panel
	         *  @fires: rendered:initial    on the first render
	         *  @fires: empty-history       when switching to a history with no contents or creating a new history
	         */
	        _setUpListeners: function () {
	            _super.prototype._setUpListeners.call(this);
	            this.on({
	                error: function (model, xhr, options, msg, details) {
	                    this.errorHandler(model, xhr, options, msg, details);
	                },
	                'loading-done': function () {
	                    var self = this;
	                    // after the initial load, decorate with more time consuming fields (like HDCA element_counts)
	                    _.delay(function () {
	                        self.model.contents.fetchCollectionCounts();
	                    }, self.FETCH_COLLECTION_COUNTS_DELAY);
	                },
	                'views:ready view:attached view:removed': function (view) {
	                    this._renderSelectButton();
	                },
	                'view:attached': function (view) {
	                    this.scrollTo(0);
	                }
	            });
	            // this.on( 'all', function(){ console.debug( arguments ); });
	        },
	
	        // ------------------------------------------------------------------------ loading history/hda models
	        /** load the history with the given id then it's contents, sending ajax options to both */
	        loadHistory: function (historyId, options, contentsOptions) {
	            contentsOptions = _.extend(contentsOptions || { silent: true });
	            this.info('loadHistory:', historyId, options, contentsOptions);
	            var self = this;
	            self.setModel(new HISTORY_MODEL.History({ id: historyId }));
	
	            contentsOptions.silent = true;
	            self.trigger('loading');
	            return self.model.fetchWithContents(options, contentsOptions).always(function () {
	                self.render();
	                self.trigger('loading-done');
	            });
	        },
	
	        /** convenience alias to the model. Updates the item list only (not the history) */
	        refreshContents: function (options) {
	            if (this.model) {
	                return this.model.refresh(options);
	            }
	            // may have callbacks - so return an empty promise
	            return $.when();
	        },
	
	        /** Override to reset web storage when the id changes (since it needs the id) */
	        _setUpCollectionListeners: function () {
	            _super.prototype._setUpCollectionListeners.call(this);
	            return this.listenTo(this.collection, {
	                // 'all' : function(){ console.log( this.collection + ':', arguments ); },
	                'fetching-more': function () {
	                    this._toggleContentsLoadingIndicator(true);
	                    this.$emptyMessage().hide();
	                },
	                'fetching-more-done': function () {
	                    this._toggleContentsLoadingIndicator(false);
	                }
	            });
	        },
	
	        // ------------------------------------------------------------------------ panel rendering
	        /** hide the $el and display a loading indicator (in the $el's parent) when loading new data */
	        _showLoadingIndicator: function (msg, speed, callback) {
	            var $indicator = $('<div class="loading-indicator"/>');
	            this.$el.html($indicator.text(msg).slideDown(!_.isUndefined(speed) ? speed : this.fxSpeed));
	        },
	
	        /** hide the loading indicator */
	        _hideLoadingIndicator: function (speed) {
	            // make speed a bit slower to compensate for slow rendering of up to 500 contents
	            this.$('.loading-indicator').slideUp(!_.isUndefined(speed) ? speed : this.fxSpeed + 200, function () {
	                $(this).remove();
	            });
	        },
	
	        /** In this override, add a btn to toggle the selectors */
	        _buildNewRender: function () {
	            var $newRender = _super.prototype._buildNewRender.call(this);
	            this._renderSelectButton($newRender);
	            return $newRender;
	        },
	
	        /** button for starting select mode */
	        _renderSelectButton: function ($where) {
	            $where = $where || this.$el;
	            // do not render selector option if no actions
	            if (!this.multiselectActions().length) {
	                return null;
	            }
	            // do not render (and remove even) if nothing to select
	            if (!this.views.length) {
	                this.hideSelectors();
	                $where.find('.controls .actions .show-selectors-btn').remove();
	                return null;
	            }
	            // don't bother rendering if there's one already
	            var $existing = $where.find('.controls .actions .show-selectors-btn');
	            if ($existing.length) {
	                return $existing;
	            }
	
	            return faIconButton({
	                title: _l('Operations on multiple datasets'),
	                classes: 'show-selectors-btn',
	                faIcon: 'fa-check-square-o'
	            }).prependTo($where.find('.controls .actions'));
	        },
	
	        /** override to avoid showing intial empty message using contents_active */
	        _renderEmptyMessage: function ($whereTo) {
	            var self = this;
	            var $emptyMsg = self.$emptyMessage($whereTo);
	
	            var empty = self.model.get('contents_active').active <= 0;
	            if (empty) {
	                return $emptyMsg.empty().append(self.emptyMsg).show();
	            } else if (self.searchFor && self.model.contents.haveSearchDetails() && !self.views.length) {
	                return $emptyMsg.empty().append(self.noneFoundMsg).show();
	            }
	            $emptyMsg.hide();
	            return $();
	        },
	
	        /** the scroll container for this panel - can be $el, $el.parent(), or grandparent depending on context */
	        $scrollContainer: function ($where) {
	            // override or set via attributes.$scrollContainer
	            return this.$list($where);
	        },
	
	        // ------------------------------------------------------------------------ subviews
	        _toggleContentsLoadingIndicator: function (show) {
	            if (!show) {
	                this.$list().find('.contents-loading-indicator').remove();
	            } else {
	                this.$list().html('<div class="contents-loading-indicator">' + '<span class="fa fa-2x fa-spinner fa-spin"/></div>');
	            }
	        },
	
	        /** override to render pagination also */
	        renderItems: function ($whereTo) {
	            // console.log( this + '.renderItems-----------------', new Date() );
	            $whereTo = $whereTo || this.$el;
	            var self = this;
	            var $list = self.$list($whereTo);
	
	            // TODO: bootstrap hack to remove orphaned tooltips
	            $('.tooltip').remove();
	
	            $list.empty();
	            self.views = [];
	
	            var models = self._filterCollection();
	            if (models.length) {
	                self._renderPagination($whereTo);
	                self.views = self._renderSomeItems(models, $list);
	            } else {
	                // TODO: consolidate with _renderPagination above by (???) passing in models/length?
	                $whereTo.find('> .controls .list-pagination').empty();
	            }
	            self._renderEmptyMessage($whereTo).toggle(!models.length);
	
	            self.trigger('views:ready', self.views);
	            return self.views;
	        },
	
	        /** render pagination controls if not searching and contents says we're paginating */
	        _renderPagination: function ($whereTo) {
	            var $paginationControls = $whereTo.find('> .controls .list-pagination');
	            if (this.searchFor || !this.model.contents.shouldPaginate()) return $paginationControls.empty();
	
	            $paginationControls.html(this.templates.pagination({
	                // pagination is 1-based for the user
	                current: this.model.contents.currentPage + 1,
	                last: this.model.contents.getLastPage() + 1
	            }, this));
	            $paginationControls.find('select.pages').tooltip();
	            return $paginationControls;
	        },
	
	        /** render a subset of the entire collection (client-side pagination) */
	        _renderSomeItems: function (models, $list) {
	            var self = this;
	            var views = [];
	            $list.append(models.map(function (m) {
	                var view = self._createItemView(m);
	                views.push(view);
	                return self._renderItemView$el(view);
	            }));
	            return views;
	        },
	
	        // ------------------------------------------------------------------------ sub-views
	        /** in this override, check if the contents would also display based on includeDeleted/hidden */
	        _filterItem: function (model) {
	            var self = this;
	            var contents = self.model.contents;
	            return (contents.includeHidden || !model.hidden()) && (contents.includeDeleted || !model.isDeletedOrPurged()) && _super.prototype._filterItem.call(self, model);
	        },
	
	        /** In this override, since history contents are mixed,
	         *      get the appropo view class based on history_content_type
	         */
	        _getItemViewClass: function (model) {
	            var contentType = model.get("history_content_type");
	            switch (contentType) {
	                case 'dataset':
	                    return this.HDAViewClass;
	                case 'dataset_collection':
	                    return this.HDCAViewClass;
	            }
	            throw new TypeError('Unknown history_content_type: ' + contentType);
	        },
	
	        /** in this override, add a linktarget, and expand if id is in web storage */
	        _getItemViewOptions: function (model) {
	            var options = _super.prototype._getItemViewOptions.call(this, model);
	            return _.extend(options, {
	                linkTarget: this.linkTarget,
	                expanded: this.model.contents.storage.isExpanded(model.id),
	                hasUser: this.model.ownedByCurrUser()
	            });
	        },
	
	        /** In this override, add/remove expanded/collapsed model ids to/from web storage */
	        _setUpItemViewListeners: function (view) {
	            var panel = this;
	            _super.prototype._setUpItemViewListeners.call(panel, view);
	            //TODO: send from content view: this.model.collection.storage.addExpanded
	            // maintain a list of items whose bodies are expanded
	            return panel.listenTo(view, {
	                'expanded': function (v) {
	                    panel.model.contents.storage.addExpanded(v.model);
	                },
	                'collapsed': function (v) {
	                    panel.model.contents.storage.removeExpanded(v.model);
	                }
	            });
	        },
	
	        /** override to remove expandedIds from webstorage */
	        collapseAll: function () {
	            this.model.contents.storage.clearExpanded();
	            _super.prototype.collapseAll.call(this);
	        },
	
	        // ------------------------------------------------------------------------ selection
	        /** Override to correctly set the historyId of the new collection */
	        getSelectedModels: function () {
	            var collection = _super.prototype.getSelectedModels.call(this);
	            collection.historyId = this.collection.historyId;
	            return collection;
	        },
	
	        // ------------------------------------------------------------------------ panel events
	        /** event map */
	        events: _.extend(_.clone(_super.prototype.events), {
	            'click .show-selectors-btn': 'toggleSelectors',
	            'click > .controls .prev': '_clickPrevPage',
	            'click > .controls .next': '_clickNextPage',
	            'change > .controls .pages': '_changePageSelect',
	            // allow (error) messages to be clicked away
	            'click .messages [class$=message]': 'clearMessages'
	        }),
	
	        _clickPrevPage: function (ev) {
	            this.model.clearUpdateTimeout();
	            this.model.contents.fetchPrevPage();
	        },
	
	        _clickNextPage: function (ev) {
	            this.model.clearUpdateTimeout();
	            this.model.contents.fetchNextPage();
	        },
	
	        _changePageSelect: function (ev) {
	            this.model.clearUpdateTimeout();
	            var page = $(ev.currentTarget).val();
	            this.model.contents.fetchPage(page);
	        },
	
	        /** Toggle and store the deleted visibility and re-render items
	         * @returns {Boolean} new setting
	         */
	        toggleShowDeleted: function (show, options) {
	            show = show !== undefined ? show : !this.model.contents.includeDeleted;
	            var self = this;
	            var contents = self.model.contents;
	            contents.setIncludeDeleted(show, options);
	            self.trigger('show-deleted', show);
	
	            contents.fetchCurrentPage({ renderAll: true });
	            return show;
	        },
	
	        /** Toggle and store whether to render explicity hidden contents
	         * @returns {Boolean} new setting
	         */
	        toggleShowHidden: function (show, store, options) {
	            // console.log( 'toggleShowHidden', show, store );
	            show = show !== undefined ? show : !this.model.contents.includeHidden;
	            var self = this;
	            var contents = self.model.contents;
	            contents.setIncludeHidden(show, options);
	            self.trigger('show-hidden', show);
	
	            contents.fetchCurrentPage({ renderAll: true });
	            return show;
	        },
	
	        /** On the first search, if there are no details - load them, then search */
	        _firstSearch: function (searchFor) {
	            var self = this;
	            var inputSelector = '> .controls .search-input';
	            this.log('onFirstSearch', searchFor);
	
	            // if the contents already have enough details to search, search and return now
	            if (self.model.contents.haveSearchDetails()) {
	                self.searchItems(searchFor);
	                return;
	            }
	
	            // otherwise, load the details progressively here
	            self.$(inputSelector).searchInput('toggle-loading');
	            // set this now so that only results will show during progress
	            self.searchFor = searchFor;
	            var xhr = self.model.contents.progressivelyFetchDetails({ silent: true }).progress(function (response, limit, offset) {
	                self.renderItems();
	                self.trigger('search:loading-progress', limit, offset);
	            }).always(function () {
	                self.$el.find(inputSelector).searchInput('toggle-loading');
	            }).done(function () {
	                self.searchItems(searchFor, 'force');
	            });
	        },
	
	        /** clear the search filters and show all views that are normally shown */
	        clearSearch: function (searchFor) {
	            var self = this;
	            if (!self.searchFor) return self;
	            //self.log( 'onSearchClear', self );
	            self.searchFor = '';
	            self.trigger('search:clear', self);
	            self.$('> .controls .search-query').val('');
	            // NOTE: silent + render prevents collection update event with merge only
	            // - which causes an empty page due to event handler above
	            self.model.contents.fetchCurrentPage({ silent: true }).done(function () {
	                self.renderItems();
	            });
	            return self;
	        },
	
	        // ........................................................................ error handling
	        /** Event handler for errors (from the panel, the history, or the history's contents)
	         *  Alternately use two strings for model and xhr to use custom message and title (respectively)
	         *  @param {Model or View} model    the (Backbone) source of the error
	         *  @param {XMLHTTPRequest} xhr     any ajax obj. assoc. with the error
	         *  @param {Object} options         the options map commonly used with bbone ajax
	         */
	        errorHandler: function (model, xhr, options) {
	            //TODO: to mixin or base model
	            // interrupted ajax or no connection
	            if (xhr && xhr.status === 0 && xhr.readyState === 0) {
	                // return ERROR_MODAL.offlineErrorModal();
	                // fail silently
	                return;
	            }
	            // otherwise, leave something to report in the console
	            this.error(model, xhr, options);
	            // and feedback to a modal
	            // if sent two strings (and possibly details as 'options'), use those as message and title
	            if (_.isString(model) && _.isString(xhr)) {
	                var message = model;
	                var title = xhr;
	                return ERROR_MODAL.errorModal(message, title, options);
	            }
	            // bad gateway
	            // TODO: possibly to global handler
	            if (xhr && xhr.status === 502) {
	                return ERROR_MODAL.badGatewayErrorModal();
	            }
	            return ERROR_MODAL.ajaxErrorModal(model, xhr, options);
	        },
	
	        /** Remove all messages from the panel. */
	        clearMessages: function (ev) {
	            var $target = !_.isUndefined(ev) ? $(ev.currentTarget) : this.$messages().children('[class$="message"]');
	            $target.fadeOut(this.fxSpeed, function () {
	                $(this).remove();
	            });
	            return this;
	        },
	
	        // ........................................................................ scrolling
	        /** Scrolls the panel to show the content sub-view with the given hid.
	         *  @param {Integer} hid    the hid of item to scroll into view
	         *  @returns {HistoryView} the panel
	         */
	        scrollToHid: function (hid) {
	            return this.scrollToItem(_.first(this.viewsWhereModel({ hid: hid })));
	        },
	
	        // ........................................................................ misc
	        /** utility for adding -st, -nd, -rd, -th to numbers */
	        ordinalIndicator: function (number) {
	            var numStr = number + '';
	            switch (numStr.charAt(numStr.length - 1)) {
	                case '1':
	                    return numStr + 'st';
	                case '2':
	                    return numStr + 'nd';
	                case '3':
	                    return numStr + 'rd';
	                default:
	                    return numStr + 'th';
	            }
	        },
	
	        /** Return a string rep of the history */
	        toString: function () {
	            return 'HistoryView(' + (this.model ? this.model.get('name') : '') + ')';
	        }
	    });
	
	    //------------------------------------------------------------------------------ TEMPLATES
	    HistoryView.prototype.templates = function () {
	
	        var mainTemplate = BASE_MVC.wrapTemplate([
	        // temp container
	        '<div>', '<div class="controls"></div>', '<ul class="list-items"></ul>', '<div class="empty-message infomessagesmall"></div>', '</div>']);
	
	        var controlsTemplate = BASE_MVC.wrapTemplate(['<div class="controls">', '<div class="title">', '<div class="name"><%- history.name %></div>', '</div>', '<div class="subtitle"></div>', '<div class="history-size"><%- history.nice_size %></div>', '<div class="actions"></div>', '<div class="messages">', '<% if( history.deleted && history.purged ){ %>', '<div class="deleted-msg warningmessagesmall">', _l('This history has been purged and deleted'), '</div>', '<% } else if( history.deleted ){ %>', '<div class="deleted-msg warningmessagesmall">', _l('This history has been deleted'), '</div>', '<% } else if( history.purged ){ %>', '<div class="deleted-msg warningmessagesmall">', _l('This history has been purged'), '</div>', '<% } %>', '<% if( history.message ){ %>',
	        // should already be localized
	        '<div class="<%= history.message.level || "info" %>messagesmall">', '<%= history.message.text %>', '</div>', '<% } %>', '</div>',
	
	        // add tags and annotations
	        '<div class="tags-display"></div>', '<div class="annotation-display"></div>', '<div class="search">', '<div class="search-input"></div>', '</div>', '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-default"', 'data-mode="select">', _l('All'), '</button>', '<button class="deselect-all btn btn-default"', 'data-mode="select">', _l('None'), '</button>', '</div>', '<div class="list-action-menu btn-group">', '</div>', '</div>', '<div class="list-pagination form-inline"></div>', '</div>'], 'history');
	
	        var paginationTemplate = BASE_MVC.wrapTemplate(['<button class="prev" <%- pages.current === 1 ? "disabled" : "" %>>previous</button>', '<select class="pages form-control" ', 'title="', _l('Click to open and select a page. Begin typing a page number to select it'), '">', '<% _.range( 1, pages.last + 1 ).forEach( function( i ){ %>', '<option value="<%- i - 1 %>" <%- i === pages.current ? "selected" : "" %>>', '<%- view.ordinalIndicator( i ) %> of <%- pages.last %> pages', '</option>', '<% }); %>', '</select>', '<button class="next" <%- pages.current === pages.last ? "disabled" : "" %>>next</button>'], 'pages');
	
	        return _.extend(_.clone(_super.prototype.templates), {
	            el: mainTemplate,
	            controls: controlsTemplate,
	            pagination: paginationTemplate
	        });
	    }();
	
	    //==============================================================================
	    return {
	        HistoryView: HistoryView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18), __webpack_require__(86), __webpack_require__(7), __webpack_require__(6), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PopupMenu, historyCopyDialog, BASE_MVC, _l, Webhooks) {
	
	    'use strict';
	
	    // ============================================================================
	
	    var menu = [{
	        html: _l('History Lists'),
	        header: true
	    }, {
	        html: _l('Saved Histories'),
	        href: 'histories/list',
	        target: '_top'
	
	    }, {
	        html: _l('Histories Shared with Me'),
	        href: 'histories/list_shared',
	        target: '_top'
	    }, {
	        html: _l('Current History'),
	        header: true,
	        anon: true
	    }, {
	        html: _l('Create New'),
	        func: function () {
	            if (Galaxy && Galaxy.currHistoryPanel) {
	                Galaxy.currHistoryPanel.createNewHistory();
	            }
	        }
	    }, {
	        html: _l('Copy History'),
	        func: function () {
	            historyCopyDialog(Galaxy.currHistoryPanel.model).done(function () {
	                Galaxy.currHistoryPanel.loadCurrentHistory();
	            });
	        }
	    }, {
	        html: _l('Share or Publish'),
	        href: 'history/sharing'
	    }, {
	        html: _l('Show Structure'),
	        href: 'history/display_structured',
	        anon: true
	    }, {
	        html: _l('Extract Workflow'),
	        href: 'workflow/build_from_current_history'
	    }, {
	        html: _l('Delete'),
	        anon: true,
	        func: function () {
	            if (Galaxy && Galaxy.currHistoryPanel && confirm(_l('Really delete the current history?'))) {
	                Galaxy.currHistoryPanel.model._delete().done(function () {
	                    Galaxy.currHistoryPanel.loadCurrentHistory();
	                });
	            }
	        }
	    }, {
	        html: _l('Delete Permanently'),
	        purge: true,
	        anon: true,
	        func: function () {
	            if (Galaxy && Galaxy.currHistoryPanel && confirm(_l('Really delete the current history permanently? This cannot be undone.'))) {
	                Galaxy.currHistoryPanel.model.purge().done(function () {
	                    Galaxy.currHistoryPanel.loadCurrentHistory();
	                });
	            }
	        }
	    }, {
	        html: _l('Dataset Actions'),
	        header: true,
	        anon: true
	    }, {
	        html: _l('Copy Datasets'),
	        href: 'dataset/copy_datasets'
	    }, {
	        html: _l('Dataset Security'),
	        href: 'root/history_set_default_permissions'
	    }, {
	        html: _l('Resume Paused Jobs'),
	        href: 'history/resume_paused_jobs?current=True',
	        anon: true
	    }, {
	        html: _l('Collapse Expanded Datasets'),
	        func: function () {
	            if (Galaxy && Galaxy.currHistoryPanel) {
	                Galaxy.currHistoryPanel.collapseAll();
	            }
	        }
	    }, {
	        html: _l('Unhide Hidden Datasets'),
	        anon: true,
	        func: function () {
	            // TODO: Deprecate this functionality and replace with group dataset selector and action combination
	            if (Galaxy && Galaxy.currHistoryPanel && confirm(_l('Really unhide all hidden datasets?'))) {
	                $.post(Galaxy.root + "history/adjust_hidden", { 'user_action': 'unhide' }, function () {
	                    Galaxy.currHistoryPanel.loadCurrentHistory();
	                });
	            }
	        }
	    }, {
	        html: _l('Delete Hidden Datasets'),
	        anon: true,
	        func: function () {
	            // TODO: Deprecate this functionality and replace with group dataset selector and action combination
	            if (Galaxy && Galaxy.currHistoryPanel && confirm(_l('Really delete all hidden datasets?'))) {
	                $.post(Galaxy.root + "history/adjust_hidden", { 'user_action': 'delete' }, function () {
	                    Galaxy.currHistoryPanel.loadCurrentHistory();
	                });
	            }
	        }
	    }, {
	        html: _l('Purge Deleted Datasets'),
	        confirm: _l('Really delete all deleted datasets permanently? This cannot be undone.'),
	        href: 'history/purge_deleted_datasets',
	        purge: true,
	        anon: true
	    }, {
	        html: _l('Downloads'),
	        header: true
	    }, {
	        html: _l('Export Tool Citations'),
	        href: 'history/citations',
	        anon: true
	    }, {
	        html: _l('Export History to File'),
	        href: 'history/export_archive?preview=True',
	        anon: true
	    }, {
	        html: _l('Other Actions'),
	        header: true
	    }, {
	        html: _l('Import from File'),
	        href: 'history/import_archive'
	    }];
	
	    // Webhooks
	    Webhooks.add({
	        url: 'api/webhooks/history-menu/all',
	        async: false, // (hypothetically) slows down the performance
	        callback: function (webhooks) {
	            var webhooks_menu = [];
	
	            $.each(webhooks.models, function (index, model) {
	                var webhook = model.toJSON();
	                if (webhook.activate) {
	                    webhooks_menu.push({
	                        html: _l(webhook.config.title),
	                        // func: function() {},
	                        anon: true
	                    });
	                }
	            });
	
	            if (webhooks_menu.length > 0) {
	                webhooks_menu.unshift({
	                    html: _l('Webhooks'),
	                    header: true
	                });
	                $.merge(menu, webhooks_menu);
	            }
	        }
	    });
	
	    function buildMenu(isAnon, purgeAllowed, urlRoot) {
	        return _.clone(menu).filter(function (menuOption) {
	            if (isAnon && !menuOption.anon) {
	                return false;
	            }
	            if (!purgeAllowed && menuOption.purge) {
	                return false;
	            }
	
	            //TODO:?? hard-coded galaxy_main
	            if (menuOption.href) {
	                menuOption.href = urlRoot + menuOption.href;
	                menuOption.target = menuOption.target || 'galaxy_main';
	            }
	
	            if (menuOption.confirm) {
	                menuOption.func = function () {
	                    if (confirm(menuOption.confirm)) {
	                        galaxy_main.location = menuOption.href;
	                    }
	                };
	            }
	            return true;
	        });
	    }
	
	    var create = function ($button, options) {
	        options = options || {};
	        var isAnon = options.anonymous === undefined ? true : options.anonymous,
	            purgeAllowed = options.purgeAllowed || false,
	            menu = buildMenu(isAnon, purgeAllowed, Galaxy.root);
	        //console.debug( 'menu:', menu );
	        return new PopupMenu($button, menu);
	    };
	
	    // ============================================================================
	    return create;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** Renders the collection uploader rows */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(43), __webpack_require__(70), __webpack_require__(22), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadModel, UploadSettings, Popover, Select) {
	    return Backbone.View.extend({
	        /** Dictionary of upload states and associated icons */
	        status_classes: {
	            init: 'upload-icon-button fa fa-trash-o',
	            queued: 'upload-icon fa fa-spinner fa-spin',
	            running: 'upload-icon fa fa-spinner fa-spin',
	            success: 'upload-icon-button fa fa-check',
	            error: 'upload-icon-button fa fa-exclamation-triangle'
	        },
	
	        initialize: function (app, options) {
	            var self = this;
	            this.app = app;
	            this.model = options.model;
	            this.setElement(this._template(options.model));
	            this.$mode = this.$('.upload-mode');
	            this.$title = this.$('.upload-title-extended');
	            this.$text = this.$('.upload-text');
	            this.$size = this.$('.upload-size');
	            this.$info_text = this.$('.upload-info-text');
	            this.$info_progress = this.$('.upload-info-progress');
	            this.$text_content = this.$('.upload-text-content');
	            this.$symbol = this.$('.upload-symbol');
	            this.$progress_bar = this.$('.upload-progress-bar');
	            this.$percentage = this.$('.upload-percentage');
	
	            // append popup to settings icon
	            this.settings = new Popover.View({
	                title: 'Upload configuration',
	                container: this.$('.upload-settings'),
	                placement: 'bottom'
	            });
	
	            // identify default genome and extension values
	            var default_genome = this.app.select_genome.value();
	            var default_extension = this.app.select_extension.value();
	
	            // handle click event
	            this.$symbol.on('click', function () {
	                self._removeRow();
	            });
	
	            // handle text editing event
	            this.$text_content.on('change input', function (e) {
	                self.model.set({ 'url_paste': $(e.target).val(),
	                    'file_size': $(e.target).val().length });
	            });
	
	            // model events
	            this.listenTo(this.model, 'change:percentage', function () {
	                self._refreshPercentage();
	            });
	            this.listenTo(this.model, 'change:status', function () {
	                self._refreshStatus();
	            });
	            this.listenTo(this.model, 'change:info', function () {
	                self._refreshInfo();
	            });
	            this.listenTo(this.model, 'change:file_size', function () {
	                self._refreshFileSize();
	            });
	            this.listenTo(this.model, 'remove', function () {
	                self.remove();
	            });
	            this.app.collection.on('reset', function () {
	                self.remove();
	            });
	        },
	
	        render: function () {
	            var options = this.model.attributes;
	            this.$title.html(_.escape(options.file_name));
	            this.$size.html(Utils.bytesToString(options.file_size));
	            this.$mode.removeClass().addClass('upload-mode').addClass('text-primary');
	            if (options.file_mode == 'new') {
	                this.$text.css({ 'width': this.$el.width() - 16 + 'px', 'top': this.$el.height() - 8 + 'px' }).show();
	                this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
	                this.$mode.addClass('fa fa-edit');
	            } else if (options.file_mode == 'local') {
	                this.$mode.addClass('fa fa-laptop');
	            } else if (options.file_mode == 'ftp') {
	                this.$mode.addClass('fa fa-folder-open-o');
	            }
	        },
	
	        /** Refresh info text */
	        _refreshInfo: function () {
	            var info = this.model.get('info');
	            if (info) {
	                this.$info_text.html('<strong>Failed: </strong>' + info).show();
	            } else {
	                this.$info_text.hide();
	            }
	        },
	
	        /** Refresh percentage status */
	        _refreshPercentage: function () {
	            var percentage = parseInt(this.model.get('percentage'));
	            this.$progress_bar.css({ width: percentage + '%' });
	            this.$percentage.html(percentage != 100 ? percentage + '%' : 'Adding to history...');
	        },
	
	        /** Refresh status */
	        _refreshStatus: function () {
	            var status = this.model.get('status');
	            this.$symbol.removeClass().addClass('upload-symbol').addClass(this.status_classes[status]);
	            this.model.set('enabled', status == 'init');
	            var enabled = this.model.get('enabled');
	            this.$text_content.attr('disabled', !enabled);
	            if (status == 'success') {
	                this.$el.addClass('success');
	                this.$percentage.html('100%');
	            }
	            if (status == 'error') {
	                this.$el.addClass('danger');
	                this.$info_progress.hide();
	            }
	        },
	
	        /** Refresh file size */
	        _refreshFileSize: function () {
	            this.$size.html(Utils.bytesToString(this.model.get('file_size')));
	        },
	
	        /** Remove row */
	        _removeRow: function () {
	            if (['init', 'success', 'error'].indexOf(this.model.get('status')) !== -1) {
	                this.app.collection.remove(this.model);
	            }
	        },
	
	        /** Attach file info popup */
	        _showSettings: function () {
	            if (!this.settings.visible) {
	                this.settings.empty();
	                this.settings.append(new UploadSettings(this).$el);
	                this.settings.show();
	            } else {
	                this.settings.hide();
	            }
	        },
	
	        /** View template */
	        _template: function (options) {
	            return '<tr id="upload-row-' + options.id + '" class="upload-row">' + '<td>' + '<div class="upload-text-column">' + '<div class="upload-mode"/>' + '<div class="upload-title-extended"/>' + '<div class="upload-text">' + '<div class="upload-text-info">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div>' + '<textarea class="upload-text-content form-control"/>' + '</div>' + '</div>' + '</td>' + '<td>' + '<div class="upload-size"/>' + '</td>' + '<td>' + '<div class="upload-info">' + '<div class="upload-info-text"/>' + '<div class="upload-info-progress progress">' + '<div class="upload-progress-bar progress-bar progress-bar-success"/>' + '<div class="upload-percentage">0%</div>' + '</div>' + '</div>' + '</td>' + '<td>' + '<div class="upload-symbol ' + this.status_classes.init + '"/>' + '</td>' + '</tr>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/** Renders contents of the collection uploader */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(43), __webpack_require__(136), __webpack_require__(69), __webpack_require__(22), __webpack_require__(23), __webpack_require__(5), __webpack_require__(60), __webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadModel, UploadRow, UploadFtp, Popover, Select, Ui, LIST_COLLECTION_CREATOR) {
	    return Backbone.View.extend({
	        // current upload size in bytes
	        upload_size: 0,
	
	        // contains upload row models
	        collection: new UploadModel.Collection(),
	
	        // keeps track of the current uploader state
	        counter: {
	            announce: 0,
	            success: 0,
	            error: 0,
	            running: 0,
	            reset: function () {
	                this.announce = this.success = this.error = this.running = 0;
	            }
	        },
	
	        initialize: function (app) {
	            var self = this;
	            this.app = app;
	            this.options = app.options;
	            this.list_extensions = app.list_extensions;
	            this.list_genomes = app.list_genomes;
	            this.ui_button = app.ui_button;
	            this.ftp_upload_site = app.currentFtp();
	            this.setElement(this._template());
	
	            // append buttons to dom
	            this.btnLocal = new Ui.Button({ id: 'btn-local', title: 'Choose local files', onclick: function () {
	                    self.uploadbox.select();
	                }, icon: 'fa fa-laptop' });
	            this.btnFtp = new Ui.Button({ id: 'btn-ftp', title: 'Choose FTP files', onclick: function () {
	                    self._eventFtp();
	                }, icon: 'fa fa-folder-open-o' });
	            this.btnCreate = new Ui.Button({ id: 'btn-new', title: 'Paste/Fetch data', onclick: function () {
	                    self._eventCreate();
	                }, icon: 'fa fa-edit' });
	            this.btnStart = new Ui.Button({ id: 'btn-start', title: 'Start', onclick: function () {
	                    self._eventStart();
	                } });
	            this.btnBuild = new Ui.Button({ id: 'btn-build', title: 'Build', onclick: function () {
	                    self._eventBuild();
	                } });
	            this.btnStop = new Ui.Button({ id: 'btn-stop', title: 'Pause', onclick: function () {
	                    self._eventStop();
	                } });
	            this.btnReset = new Ui.Button({ id: 'btn-reset', title: 'Reset', onclick: function () {
	                    self._eventReset();
	                } });
	            this.btnClose = new Ui.Button({ id: 'btn-close', title: 'Close', onclick: function () {
	                    self.app.modal.hide();
	                } });
	            _.each([this.btnLocal, this.btnFtp, this.btnCreate, this.btnStop, this.btnReset, this.btnStart, this.btnBuild, this.btnClose], function (button) {
	                self.$('.upload-buttons').prepend(button.$el);
	            });
	
	            // file upload
	            this.uploadbox = this.$('.upload-box').uploadbox({
	                url: this.app.options.nginx_upload_path,
	                announce: function (index, file) {
	                    self._eventAnnounce(index, file);
	                },
	                initialize: function (index) {
	                    return self.app.toData([self.collection.get(index)], self.history_id);
	                },
	                progress: function (index, percentage) {
	                    self._eventProgress(index, percentage);
	                },
	                success: function (index, message) {
	                    self._eventSuccess(index, message);
	                },
	                error: function (index, message) {
	                    self._eventError(index, message);
	                },
	                complete: function () {
	                    self._eventComplete();
	                },
	                ondragover: function () {
	                    self.$('.upload-box').addClass('highlight');
	                },
	                ondragleave: function () {
	                    self.$('.upload-box').removeClass('highlight');
	                }
	            });
	
	            console.log(this.list_extensions);
	
	            // add ftp file viewer
	            this.ftp = new Popover.View({ title: 'FTP files', container: this.btnFtp.$el });
	
	            // select extension
	            this.select_extension = new Select.View({
	                css: 'upload-footer-selection-compressed',
	                container: this.$('.upload-footer-extension'),
	                data: _.filter(this.list_extensions, function (ext) {
	                    return !ext.composite_files;
	                }),
	                value: this.options.default_extension,
	                onchange: function (extension) {
	                    self.updateExtension(extension);
	                }
	            });
	
	            this.collectionType = "list";
	            this.select_collection = new Select.View({
	                css: 'upload-footer-selection-compressed',
	                container: this.$('.upload-footer-collection-type'),
	                data: [{ "id": "list", "text": "List" }, { "id": "paired", "text": "Paired" }, { "id": "list:paired", "text": "List of Pairs" }],
	                value: "list",
	                onchange: function (collectionType) {
	                    self.updateCollectionType(collectionType);
	                }
	            });
	
	            // handle extension info popover
	            this.$('.upload-footer-extension-info').on('click', function (e) {
	                self.showExtensionInfo({
	                    $el: $(e.target),
	                    title: self.select_extension.text(),
	                    extension: self.select_extension.value(),
	                    placement: 'top'
	                });
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // genome extension
	            this.select_genome = new Select.View({
	                css: 'upload-footer-selection',
	                container: this.$('.upload-footer-genome'),
	                data: this.list_genomes,
	                value: this.options.default_genome,
	                onchange: function (genome) {
	                    self.updateGenome(genome);
	                }
	            });
	
	            // events
	            this.collection.on('remove', function (model) {
	                self._eventRemove(model);
	            });
	            this._updateScreen();
	        },
	
	        /** A new file has been dropped/selected through the uploadbox plugin */
	        _eventAnnounce: function (index, file) {
	            this.counter.announce++;
	            var new_model = new UploadModel.Model({
	                id: index,
	                file_name: file.name,
	                file_size: file.size,
	                file_mode: file.mode || 'local',
	                file_path: file.path,
	                file_data: file,
	                extension: this.select_extension.value(),
	                genome: this.select_genome.value()
	            });
	            this.collection.add(new_model);
	            var upload_row = new UploadRow(this, { model: new_model });
	            this.$('.upload-table > tbody:first').append(upload_row.$el);
	            this._updateScreen();
	            upload_row.render();
	        },
	
	        /** Progress */
	        _eventProgress: function (index, percentage) {
	            var it = this.collection.get(index);
	            it.set('percentage', percentage);
	            this.ui_button.model.set('percentage', this._uploadPercentage(percentage, it.get('file_size')));
	        },
	
	        /** Success */
	        _eventSuccess: function (index, message) {
	            // var hdaId = message["outputs"][0]["id"];
	            var hids = _.pluck(message["outputs"], "hid");
	            var it = this.collection.get(index);
	            it.set({ 'percentage': 100, 'status': 'success', 'hids': hids });
	            this.ui_button.model.set('percentage', this._uploadPercentage(100, it.get('file_size')));
	            this.upload_completed += it.get('file_size') * 100;
	            this.counter.announce--;
	            this.counter.success++;
	            this._updateScreen();
	            Galaxy.currHistoryPanel.refreshContents();
	        },
	
	        /** Error */
	        _eventError: function (index, message) {
	            var it = this.collection.get(index);
	            it.set({ 'percentage': 100, 'status': 'error', 'info': message });
	            this.ui_button.model.set({ 'percentage': this._uploadPercentage(100, it.get('file_size')), 'status': 'danger' });
	            this.upload_completed += it.get('file_size') * 100;
	            this.counter.announce--;
	            this.counter.error++;
	            this._updateScreen();
	        },
	
	        /** Queue is done */
	        _eventComplete: function () {
	            this.collection.each(function (model) {
	                model.get('status') == 'queued' && model.set('status', 'init');
	            });
	            this.counter.running = 0;
	            this._updateScreen();
	        },
	
	        _eventBuild: function () {
	            var allHids = [];
	            _.forEach(this.collection.models, function (upload) {
	                allHids.push.apply(allHids, upload.get('hids'));
	            });
	            var models = _.map(allHids, function (hid) {
	                return Galaxy.currHistoryPanel.collection.getByHid(hid);
	            });
	            var selection = new Galaxy.currHistoryPanel.collection.constructor(models);
	            // I'm building the selection wrong because I need to set this historyId directly.
	            selection.historyId = Galaxy.currHistoryPanel.collection.historyId;
	            Galaxy.currHistoryPanel.buildCollection(this.collectionType, selection, true);
	            this.counter.running = 0;
	            this._updateScreen();
	            this._eventReset();
	            this.app.modal.hide();
	        },
	
	        /** Remove model from upload list */
	        _eventRemove: function (model) {
	            var status = model.get('status');
	            if (status == 'success') {
	                this.counter.success--;
	            } else if (status == 'error') {
	                this.counter.error--;
	            } else {
	                this.counter.announce--;
	            }
	            this.uploadbox.remove(model.id);
	            this._updateScreen();
	        },
	
	        //
	        // events triggered by this view
	        //
	
	        /** [public] display extension info popup */
	        showExtensionInfo: function (options) {
	            var self = this;
	            var $el = options.$el;
	            var extension = options.extension;
	            var title = options.title;
	            var description = _.findWhere(self.list_extensions, { 'id': extension });
	            this.extension_popup && this.extension_popup.remove();
	            this.extension_popup = new Popover.View({ placement: options.placement || 'bottom', container: $el });
	            this.extension_popup.title(title);
	            this.extension_popup.empty();
	            this.extension_popup.append(this._templateDescription(description));
	            this.extension_popup.show();
	        },
	
	        /** Show/hide ftp popup */
	        _eventFtp: function () {
	            if (!this.ftp.visible) {
	                this.ftp.empty();
	                var self = this;
	                this.ftp.append(new UploadFtp({
	                    collection: this.collection,
	                    ftp_upload_site: this.ftp_upload_site,
	                    onadd: function (ftp_file) {
	                        self.uploadbox.add([{
	                            mode: 'ftp',
	                            name: ftp_file.path,
	                            size: ftp_file.size,
	                            path: ftp_file.path
	                        }]);
	                    },
	                    onremove: function (model_index) {
	                        self.collection.remove(model_index);
	                    }
	                }).$el);
	                this.ftp.show();
	            } else {
	                this.ftp.hide();
	            }
	        },
	
	        /** Create a new file */
	        _eventCreate: function () {
	            this.uploadbox.add([{ name: 'New File', size: 0, mode: 'new' }]);
	        },
	
	        /** Start upload process */
	        _eventStart: function () {
	            if (this.counter.announce == 0 || this.counter.running > 0) {
	                return;
	            }
	            var self = this;
	            this.upload_size = 0;
	            this.upload_completed = 0;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init') {
	                    model.set('status', 'queued');
	                    self.upload_size += model.get('file_size');
	                }
	            });
	            this.ui_button.model.set({ 'percentage': 0, 'status': 'success' });
	            this.counter.running = this.counter.announce;
	            this.history_id = this.app.currentHistory();
	            this.uploadbox.start();
	            this._updateScreen();
	        },
	
	        /** Pause upload process */
	        _eventStop: function () {
	            if (this.counter.running > 0) {
	                this.ui_button.model.set('status', 'info');
	                $('.upload-top-info').html('Queue will pause after completing the current file...');
	                this.uploadbox.stop();
	            }
	        },
	
	        /** Remove all */
	        _eventReset: function () {
	            if (this.counter.running == 0) {
	                this.collection.reset();
	                this.counter.reset();
	                this.uploadbox.reset();
	                this.select_extension.value(this.options.default_extension);
	                this.select_genome.value(this.options.default_genome);
	                this.ui_button.model.set('percentage', 0);
	                this._updateScreen();
	            }
	        },
	
	        /** Update extension for all models */
	        updateExtension: function (extension, defaults_only) {
	            var self = this;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init' && (model.get('extension') == self.options.default_extension || !defaults_only)) {
	                    model.set('extension', extension);
	                }
	            });
	        },
	
	        /** Update collection type */
	        updateCollectionType: function (collectionType) {
	            var self = this;
	            this.collectionType = collectionType;
	        },
	
	        /** Update genome for all models */
	        updateGenome: function (genome, defaults_only) {
	            var self = this;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init' && (model.get('genome') == self.options.default_genome || !defaults_only)) {
	                    model.set('genome', genome);
	                }
	            });
	        },
	
	        /** Set screen */
	        _updateScreen: function () {
	            var message = '';
	            if (this.counter.announce == 0) {
	                if (this.uploadbox.compatible()) {
	                    message = '&nbsp;';
	                } else {
	                    message = 'Browser does not support Drag & Drop. Try Firefox 4+, Chrome 7+, IE 10+, Opera 12+ or Safari 6+.';
	                }
	            } else {
	                if (this.counter.running == 0) {
	                    message = 'You added ' + this.counter.announce + ' file(s) to the queue. Add more files or click \'Start\' to proceed.';
	                } else {
	                    message = 'Please wait...' + this.counter.announce + ' out of ' + this.counter.running + ' remaining.';
	                }
	            }
	            this.$('.upload-top-info').html(message);
	            var enable_reset = this.counter.running == 0 && this.counter.announce + this.counter.success + this.counter.error > 0;
	            var enable_start = this.counter.running == 0 && this.counter.announce > 0;
	            var enable_build = this.counter.running == 0 && this.counter.announce == 0 && this.counter.success > 0 && this.counter.error == 0;
	            var enable_sources = this.counter.running == 0;
	            var show_table = this.counter.announce + this.counter.success + this.counter.error > 0;
	            this.btnReset[enable_reset ? 'enable' : 'disable']();
	            this.btnStart[enable_start ? 'enable' : 'disable']();
	            this.btnStart.$el[enable_start ? 'addClass' : 'removeClass']('btn-primary');
	            this.btnBuild[enable_build ? 'enable' : 'disable']();
	            this.btnBuild.$el[enable_build ? 'addClass' : 'removeClass']('btn-primary');
	            this.btnStop[this.counter.running > 0 ? 'enable' : 'disable']();
	            this.btnLocal[enable_sources ? 'enable' : 'disable']();
	            this.btnFtp[enable_sources ? 'enable' : 'disable']();
	            this.btnCreate[enable_sources ? 'enable' : 'disable']();
	            this.btnFtp.$el[this.ftp_upload_site ? 'show' : 'hide']();
	            this.$('.upload-table')[show_table ? 'show' : 'hide']();
	            this.$('.upload-helper')[show_table ? 'hide' : 'show']();
	        },
	
	        /** Calculate percentage of all queued uploads */
	        _uploadPercentage: function (percentage, size) {
	            return (this.upload_completed + percentage * size) / this.upload_size;
	        },
	
	        /** Template for extensions description */
	        _templateDescription: function (options) {
	            if (options.description) {
	                var tmpl = options.description;
	                if (options.description_url) {
	                    tmpl += '&nbsp;(<a href="' + options.description_url + '" target="_blank">read more</a>)';
	                }
	                return tmpl;
	            } else {
	                return 'There is no description available for this file extension.';
	            }
	        },
	
	        /** Template */
	        _template: function () {
	            return '<div class="upload-view-default">' + '<div class="upload-top">' + '<h6 class="upload-top-info"/>' + '</div>' + '<div class="upload-box">' + '<div class="upload-helper"><i class="fa fa-files-o"/>Drop files here</div>' + '<table class="upload-table ui-table-striped" style="display: none;">' + '<thead>' + '<tr>' + '<th>Name</th>' + '<th>Size</th>' + '<th>Status</th>' + '<th/>' + '</tr>' + '</thead>' + '<tbody/>' + '</table>' + '</div>' + '<div class="upload-footer">' + '<span class="upload-footer-title-compressed">Collection Type:</span>' + '<span class="upload-footer-collection-type"/>' + '<span class="upload-footer-title-compressed">File Type:</span>' + '<span class="upload-footer-extension"/>' + '<span class="upload-footer-extension-info upload-icon-button fa fa-search"/> ' + '<span class="upload-footer-title-compressed">Genome (set all):</span>' + '<span class="upload-footer-genome"/>' + '</div>' + '<div class="upload-buttons"/>' + '</div>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** Renders the composite upload row view */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(70), __webpack_require__(69), __webpack_require__(22), __webpack_require__(5), __webpack_require__(23), __webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadSettings, UploadFtp, Popover, Ui, Select) {
	    return Backbone.View.extend({
	        /** Dictionary of upload states and associated icons */
	        status_classes: {
	            init: 'upload-mode fa fa-exclamation text-primary',
	            ready: 'upload-mode fa fa-check text-success',
	            running: 'upload-mode fa fa-spinner fa-spin',
	            success: 'upload-mode fa fa-check',
	            error: 'upload-mode fa fa-exclamation-triangle'
	        },
	
	        initialize: function (app, options) {
	            var self = this;
	            this.app = app;
	            this.model = options.model;
	            this.setElement(this._template());
	            this.$source = this.$('.upload-source');
	            this.$settings = this.$('.upload-settings');
	            this.$status = this.$('.upload-status');
	            this.$text = this.$('.upload-text');
	            this.$text_content = this.$('.upload-text-content');
	            this.$info_text = this.$('.upload-info-text');
	            this.$info_progress = this.$('.upload-info-progress');
	            this.$file_name = this.$('.upload-file-name');
	            this.$file_desc = this.$('.upload-file-desc');
	            this.$file_size = this.$('.upload-file-size');
	            this.$progress_bar = this.$('.upload-progress-bar');
	            this.$percentage = this.$('.upload-percentage');
	
	            // build upload functions
	            this.uploadinput = this.$el.uploadinput({
	                ondragover: function () {
	                    self.model.get('enabled') && self.$el.addClass('warning');
	                },
	                ondragleave: function () {
	                    self.$el.removeClass('warning');
	                },
	                onchange: function (files) {
	                    if (self.model.get('status') != 'running' && files && files.length > 0) {
	                        self.model.reset({
	                            'file_data': files[0],
	                            'file_name': files[0].name,
	                            'file_size': files[0].size,
	                            'file_mode': files[0].mode || 'local'
	                        });
	                        self._refreshReady();
	                    }
	                }
	            });
	
	            // source selection popup
	            this.button_menu = new Ui.ButtonMenu({
	                icon: 'fa-caret-down',
	                title: 'Select',
	                pull: 'left'
	            });
	            this.$source.append(this.button_menu.$el);
	            this.button_menu.addMenu({
	                icon: 'fa-laptop',
	                title: 'Choose local file',
	                onclick: function () {
	                    self.uploadinput.dialog();
	                }
	            });
	            if (this.app.ftp_upload_site) {
	                this.button_menu.addMenu({
	                    icon: 'fa-folder-open-o',
	                    title: 'Choose FTP file',
	                    onclick: function () {
	                        self._showFtp();
	                    }
	                });
	            }
	            this.button_menu.addMenu({
	                icon: 'fa-edit',
	                title: 'Paste/Fetch data',
	                onclick: function () {
	                    self.model.reset({ 'file_mode': 'new', 'file_name': 'New File' });
	                }
	            });
	
	            // add ftp file viewer
	            this.ftp = new Popover.View({
	                title: 'Choose FTP file:',
	                container: this.$source.find('.ui-button-menu'),
	                placement: 'right'
	            });
	
	            // append popup to settings icon
	            this.settings = new Popover.View({
	                title: 'Upload configuration',
	                container: this.$settings,
	                placement: 'bottom'
	            });
	
	            // handle text editing event
	            this.$text_content.on('change input', function (e) {
	                self.model.set({ 'url_paste': $(e.target).val(),
	                    'file_size': $(e.target).val().length });
	                self._refreshReady();
	            });
	
	            // handle settings popover
	            this.$settings.on('click', function (e) {
	                self._showSettings();
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // model events
	            this.listenTo(this.model, 'change:percentage', function () {
	                self._refreshPercentage();
	            });
	            this.listenTo(this.model, 'change:status', function () {
	                self._refreshStatus();
	            });
	            this.listenTo(this.model, 'change:info', function () {
	                self._refreshInfo();
	            });
	            this.listenTo(this.model, 'change:file_name', function () {
	                self._refreshFileName();
	            });
	            this.listenTo(this.model, 'change:file_mode', function () {
	                self._refreshMode();
	            });
	            this.listenTo(this.model, 'change:file_size', function () {
	                self._refreshFileSize();
	            });
	            this.listenTo(this.model, 'remove', function () {
	                self.remove();
	            });
	            this.app.collection.on('reset', function () {
	                self.remove();
	            });
	        },
	
	        render: function () {
	            this.$el.attr('id', 'upload-row-' + this.model.id);
	            this.$file_name.html(_.escape(this.model.get('file_name') || '-'));
	            this.$file_desc.html(this.model.get('file_desc') || 'Unavailable');
	            this.$file_size.html(Utils.bytesToString(this.model.get('file_size')));
	            this.$status.removeClass().addClass(this.status_classes.init);
	        },
	
	        /** Remove view */
	        remove: function () {
	            // call the base class remove method
	            Backbone.View.prototype.remove.apply(this);
	        },
	
	        //
	        // handle model events
	        //
	
	        /** Refresh ready or not states */
	        _refreshReady: function () {
	            this.app.collection.each(function (model) {
	                model.set('status', model.get('file_size') > 0 && 'ready' || 'init');
	            });
	        },
	
	        /** Refresh mode and e.g. show/hide textarea field */
	        _refreshMode: function () {
	            var file_mode = this.model.get('file_mode');
	            if (file_mode == 'new') {
	                this.height = this.$el.height();
	                this.$text.css({ 'width': this.$el.width() - 16 + 'px',
	                    'top': this.$el.height() - 8 + 'px' }).show();
	                this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
	                this.$text_content.val('').trigger('keyup');
	            } else {
	                this.$el.height(this.height);
	                this.$text.hide();
	            }
	        },
	
	        /** Refresh information */
	        _refreshInfo: function () {
	            var info = this.model.get('info');
	            if (info) {
	                this.$info_text.html('<strong>Failed: </strong>' + info).show();
	            } else {
	                this.$info_text.hide();
	            }
	        },
	
	        /** Refresh percentage */
	        _refreshPercentage: function () {
	            var percentage = parseInt(this.model.get('percentage'));
	            if (percentage != 0) {
	                this.$progress_bar.css({ width: percentage + '%' });
	            } else {
	                this.$progress_bar.addClass('no-transition');
	                this.$progress_bar.css({ width: '0%' });
	                this.$progress_bar[0].offsetHeight;
	                this.$progress_bar.removeClass('no-transition');
	            }
	            this.$percentage.html(percentage != 100 ? percentage + '%' : 'Adding to history...');
	        },
	
	        /** Refresh status */
	        _refreshStatus: function () {
	            var status = this.model.get('status');
	            this.$status.removeClass().addClass(this.status_classes[status]);
	            this.model.set('enabled', status != 'running');
	            this.$text_content.attr('disabled', !this.model.get('enabled'));
	            this.$el.removeClass('success danger warning');
	            if (status == 'running' || status == 'ready') {
	                this.model.set('percentage', 0);
	            }
	            this.$source.find('.button')[status == 'running' ? 'addClass' : 'removeClass']('disabled');
	            if (status == 'success') {
	                this.$el.addClass('success');
	                this.model.set('percentage', 100);
	                this.$percentage.html('100%');
	            }
	            if (status == 'error') {
	                this.$el.addClass('danger');
	                this.model.set('percentage', 0);
	                this.$info_progress.hide();
	                this.$info_text.show();
	            } else {
	                this.$info_progress.show();
	                this.$info_text.hide();
	            }
	        },
	
	        /** File name */
	        _refreshFileName: function () {
	            this.$file_name.html(this.model.get('file_name') || '-');
	        },
	
	        /** File size */
	        _refreshFileSize: function () {
	            this.$file_size.html(Utils.bytesToString(this.model.get('file_size')));
	        },
	
	        /** Show/hide ftp popup */
	        _showFtp: function () {
	            if (!this.ftp.visible) {
	                var self = this;
	                this.ftp.empty();
	                this.ftp.append(new UploadFtp({
	                    ftp_upload_site: this.app.ftp_upload_site,
	                    onchange: function (ftp_file) {
	                        self.ftp.hide();
	                        if (self.model.get('status') != 'running' && ftp_file) {
	                            self.model.reset({
	                                'file_mode': 'ftp',
	                                'file_name': ftp_file.path,
	                                'file_size': ftp_file.size,
	                                'file_path': ftp_file.path
	                            });
	                            self._refreshReady();
	                        }
	                    }
	                }).$el);
	                this.ftp.show();
	            } else {
	                this.ftp.hide();
	            }
	        },
	
	        /** Show/hide settings popup */
	        _showSettings: function () {
	            if (!this.settings.visible) {
	                this.settings.empty();
	                this.settings.append(new UploadSettings(this).$el);
	                this.settings.show();
	            } else {
	                this.settings.hide();
	            }
	        },
	
	        /** Template */
	        _template: function () {
	            return '<tr class="upload-row">' + '<td>' + '<div class="upload-source"/>' + '<div class="upload-text-column">' + '<div class="upload-text">' + '<div class="upload-text-info">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div>' + '<textarea class="upload-text-content form-control"/>' + '</div>' + '</div>' + '</td>' + '<td>' + '<div class="upload-status"/>' + '</td>' + '<td>' + '<div class="upload-file-desc upload-title"/>' + '</td>' + '<td>' + '<div class="upload-file-name upload-title"/>' + '</td>' + '<td>' + '<div class="upload-file-size upload-size"/>' + '</td>' + '<td><div class="upload-settings upload-icon-button fa fa-gear"/></td>' + '<td>' + '<div class="upload-info">' + '<div class="upload-info-text"/>' + '<div class="upload-info-progress progress">' + '<div class="upload-progress-bar progress-bar progress-bar-success"/>' + '<div class="upload-percentage">0%</div>' + '</div>' + '</div>' + '</td>' + '</tr>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/** Renders contents of the composite uploader */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(43), __webpack_require__(138), __webpack_require__(22), __webpack_require__(23), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadModel, UploadRow, Popover, Select, Ui) {
	    return Backbone.View.extend({
	        collection: new UploadModel.Collection(),
	        initialize: function (app) {
	            var self = this;
	            this.app = app;
	            this.options = app.options;
	            this.list_extensions = app.list_extensions;
	            this.list_genomes = app.list_genomes;
	            this.ftp_upload_site = app.currentFtp();
	            this.setElement(this._template());
	
	            // create button section
	            this.btnStart = new Ui.Button({ title: 'Start', onclick: function () {
	                    self._eventStart();
	                } });
	            this.btnClose = new Ui.Button({ title: 'Close', onclick: function () {
	                    self.app.modal.hide();
	                } });
	
	            // append buttons to dom
	            _.each([this.btnStart, this.btnClose], function (button) {
	                self.$('.upload-buttons').prepend(button.$el);
	            });
	
	            // select extension
	            this.select_extension = new Select.View({
	                css: 'upload-footer-selection',
	                container: this.$('.upload-footer-extension'),
	                data: _.filter(this.list_extensions, function (ext) {
	                    return ext.composite_files;
	                }),
	                onchange: function (extension) {
	                    self.collection.reset();
	                    var details = _.findWhere(self.list_extensions, { id: extension });
	                    if (details && details.composite_files) {
	                        _.each(details.composite_files, function (item) {
	                            self.collection.add({ id: self.collection.size(),
	                                file_desc: item.description || item.name });
	                        });
	                    }
	                }
	            });
	
	            // handle extension info popover
	            this.$('.upload-footer-extension-info').on('click', function (e) {
	                self._showExtensionInfo({
	                    $el: $(e.target),
	                    title: self.select_extension.text(),
	                    extension: self.select_extension.value(),
	                    placement: 'top'
	                });
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // genome extension
	            this.select_genome = new Select.View({
	                css: 'upload-footer-selection',
	                container: this.$('.upload-footer-genome'),
	                data: this.list_genomes,
	                value: this.options.default_genome
	            });
	
	            // listener for collection triggers on change in composite datatype and extension selection
	            this.listenTo(this.collection, 'add', function (model) {
	                self._eventAnnounce(model);
	            });
	            this.listenTo(this.collection, 'change add', function () {
	                self.render();
	            });
	            this.select_extension.options.onchange(this.select_extension.value());
	            this.render();
	        },
	
	        render: function () {
	            var model = this.collection.first();
	            if (model && model.get('status') == 'running') {
	                this.select_genome.disable();
	                this.select_extension.disable();
	            } else {
	                this.select_genome.enable();
	                this.select_extension.enable();
	            }
	            if (this.collection.where({ status: 'ready' }).length == this.collection.length && this.collection.length > 0) {
	                this.btnStart.enable();
	                this.btnStart.$el.addClass('btn-primary');
	            } else {
	                this.btnStart.disable();
	                this.btnStart.$el.removeClass('btn-primary');
	            }
	            this.$('.upload-table')[this.collection.length > 0 ? 'show' : 'hide']();
	        },
	
	        //
	        // upload events / process pipeline
	        //
	
	        /** Builds the basic ui with placeholder rows for each composite data type file */
	        _eventAnnounce: function (model) {
	            var upload_row = new UploadRow(this, { model: model });
	            this.$('.upload-table > tbody:first').append(upload_row.$el);
	            this.$('.upload-table')[this.collection.length > 0 ? 'show' : 'hide']();
	            upload_row.render();
	        },
	
	        /** Start upload process */
	        _eventStart: function () {
	            var self = this;
	            this.collection.each(function (model) {
	                model.set({ 'genome': self.select_genome.value(),
	                    'extension': self.select_extension.value() });
	            });
	            $.uploadpost({
	                url: this.app.options.nginx_upload_path,
	                data: this.app.toData(this.collection.filter()),
	                success: function (message) {
	                    self._eventSuccess(message);
	                },
	                error: function (message) {
	                    self._eventError(message);
	                },
	                progress: function (percentage) {
	                    self._eventProgress(percentage);
	                }
	            });
	        },
	
	        /** Refresh progress state */
	        _eventProgress: function (percentage) {
	            this.collection.each(function (it) {
	                it.set('percentage', percentage);
	            });
	        },
	
	        /** Refresh success state */
	        _eventSuccess: function (message) {
	            this.collection.each(function (it) {
	                it.set('status', 'success');
	            });
	            Galaxy.currHistoryPanel.refreshContents();
	        },
	
	        /** Refresh error state */
	        _eventError: function (message) {
	            this.collection.each(function (it) {
	                it.set({ 'status': 'error', 'info': message });
	            });
	        },
	
	        /** Display extension info popup */
	        _showExtensionInfo: function (options) {
	            var self = this;
	            var $el = options.$el;
	            var extension = options.extension;
	            var title = options.title;
	            var description = _.findWhere(this.list_extensions, { id: extension });
	            this.extension_popup && this.extension_popup.remove();
	            this.extension_popup = new Popover.View({
	                placement: options.placement || 'bottom',
	                container: $el,
	                destroy: true
	            });
	            this.extension_popup.title(title);
	            this.extension_popup.empty();
	            this.extension_popup.append(this._templateDescription(description));
	            this.extension_popup.show();
	        },
	
	        /* Template for extensions description */
	        _templateDescription: function (options) {
	            if (options.description) {
	                var tmpl = options.description;
	                if (options.description_url) {
	                    tmpl += '&nbsp;(<a href="' + options.description_url + '" target="_blank">read more</a>)';
	                }
	                return tmpl;
	            } else {
	                return 'There is no description available for this file extension.';
	            }
	        },
	
	        /** Load html template */
	        _template: function () {
	            return '<div class="upload-view-composite">' + '<div class="upload-footer">' + '<span class="upload-footer-title">Composite Type:</span>' + '<span class="upload-footer-extension"/>' + '<span class="upload-footer-extension-info upload-icon-button fa fa-search"/> ' + '<span class="upload-footer-title">Genome/Build:</span>' + '<span class="upload-footer-genome"/>' + '</div>' + '<div class="upload-box">' + '<table class="upload-table ui-table-striped" style="display: none;">' + '<thead>' + '<tr>' + '<th/>' + '<th/>' + '<th>Description</th>' + '<th>Name</th>' + '<th>Size</th>' + '<th>Settings</th>' + '<th>Status</th>' + '</tr>' + '</thead>' + '<tbody/>' + '</table>' + '</div>' + '<div class="upload-buttons"/>' + '</div>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** Renders the default uploader rows */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(43), __webpack_require__(70), __webpack_require__(22), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadModel, UploadSettings, Popover, Select) {
	    return Backbone.View.extend({
	        /** Dictionary of upload states and associated icons */
	        status_classes: {
	            init: 'upload-icon-button fa fa-trash-o',
	            queued: 'upload-icon fa fa-spinner fa-spin',
	            running: 'upload-icon fa fa-spinner fa-spin',
	            success: 'upload-icon-button fa fa-check',
	            error: 'upload-icon-button fa fa-exclamation-triangle'
	        },
	
	        initialize: function (app, options) {
	            var self = this;
	            this.app = app;
	            this.model = options.model;
	            this.setElement(this._template(options.model));
	            this.$mode = this.$('.upload-mode');
	            this.$title = this.$('.upload-title');
	            this.$text = this.$('.upload-text');
	            this.$size = this.$('.upload-size');
	            this.$info_text = this.$('.upload-info-text');
	            this.$info_progress = this.$('.upload-info-progress');
	            this.$text_content = this.$('.upload-text-content');
	            this.$settings = this.$('.upload-settings');
	            this.$symbol = this.$('.upload-symbol');
	            this.$progress_bar = this.$('.upload-progress-bar');
	            this.$percentage = this.$('.upload-percentage');
	
	            // append popup to settings icon
	            this.settings = new Popover.View({
	                title: 'Upload configuration',
	                container: this.$('.upload-settings'),
	                placement: 'bottom'
	            });
	
	            // identify default genome and extension values
	            var default_genome = this.app.select_genome.value();
	            var default_extension = this.app.select_extension.value();
	
	            // create select genomes
	            this.select_genome = new Select.View({
	                css: 'upload-genome',
	                data: self.app.list_genomes,
	                container: this.$('.upload-genome'),
	                value: default_genome,
	                onchange: function (genome) {
	                    self.model.set('genome', genome);
	                }
	            });
	
	            // create select extension
	            this.select_extension = new Select.View({
	                css: 'upload-extension',
	                data: self.app.list_extensions,
	                container: this.$('.upload-extension'),
	                value: default_extension,
	                onchange: function (extension) {
	                    self.model.set('extension', extension);
	                }
	            });
	
	            // initialize genome and extension values
	            this.model.set({ 'genome': default_genome, 'extension': default_extension });
	
	            // handle click event
	            this.$symbol.on('click', function () {
	                self._removeRow();
	            });
	
	            // handle extension info popover
	            this.$('.upload-extension-info').on('click', function (e) {
	                self.app.showExtensionInfo({
	                    $el: $(e.target),
	                    title: self.select_extension.text(),
	                    extension: self.select_extension.value()
	                });
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // handle settings popover
	            this.$settings.on('click', function (e) {
	                self._showSettings();
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // handle text editing event
	            this.$text_content.on('change input', function (e) {
	                self.model.set({ 'url_paste': $(e.target).val(),
	                    'file_size': $(e.target).val().length });
	            });
	
	            // model events
	            this.listenTo(this.model, 'change:percentage', function () {
	                self._refreshPercentage();
	            });
	            this.listenTo(this.model, 'change:status', function () {
	                self._refreshStatus();
	            });
	            this.listenTo(this.model, 'change:info', function () {
	                self._refreshInfo();
	            });
	            this.listenTo(this.model, 'change:genome', function () {
	                self._refreshGenome();
	            });
	            this.listenTo(this.model, 'change:extension', function () {
	                self._refreshExtension();
	            });
	            this.listenTo(this.model, 'change:file_size', function () {
	                self._refreshFileSize();
	            });
	            this.listenTo(this.model, 'remove', function () {
	                self.remove();
	            });
	            this.app.collection.on('reset', function () {
	                self.remove();
	            });
	        },
	
	        render: function () {
	            var options = this.model.attributes;
	            this.$title.html(_.escape(options.file_name));
	            this.$size.html(Utils.bytesToString(options.file_size));
	            this.$mode.removeClass().addClass('upload-mode').addClass('text-primary');
	            if (options.file_mode == 'new') {
	                this.$text.css({ 'width': this.$el.width() - 16 + 'px', 'top': this.$el.height() - 8 + 'px' }).show();
	                this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
	                this.$mode.addClass('fa fa-edit');
	            } else if (options.file_mode == 'local') {
	                this.$mode.addClass('fa fa-laptop');
	            } else if (options.file_mode == 'ftp') {
	                this.$mode.addClass('fa fa-folder-open-o');
	            }
	        },
	
	        /** Remove view */
	        remove: function () {
	            this.select_genome.remove();
	            this.select_extension.remove();
	            Backbone.View.prototype.remove.apply(this);
	        },
	
	        /** Update extension */
	        _refreshExtension: function () {
	            this.select_extension.value(this.model.get('extension'));
	        },
	
	        /** Update genome */
	        _refreshGenome: function () {
	            this.select_genome.value(this.model.get('genome'));
	        },
	
	        /** Refresh info text */
	        _refreshInfo: function () {
	            var info = this.model.get('info');
	            if (info) {
	                this.$info_text.html('<strong>Failed: </strong>' + info).show();
	            } else {
	                this.$info_text.hide();
	            }
	        },
	
	        /** Refresh percentage status */
	        _refreshPercentage: function () {
	            var percentage = parseInt(this.model.get('percentage'));
	            this.$progress_bar.css({ width: percentage + '%' });
	            this.$percentage.html(percentage != 100 ? percentage + '%' : 'Adding to history...');
	        },
	
	        /** Refresh status */
	        _refreshStatus: function () {
	            var status = this.model.get('status');
	            this.$symbol.removeClass().addClass('upload-symbol').addClass(this.status_classes[status]);
	            this.model.set('enabled', status == 'init');
	            var enabled = this.model.get('enabled');
	            this.$text_content.attr('disabled', !enabled);
	            if (enabled) {
	                this.select_genome.enable();
	                this.select_extension.enable();
	            } else {
	                this.select_genome.disable();
	                this.select_extension.disable();
	            }
	            if (status == 'success') {
	                this.$el.addClass('success');
	                this.$percentage.html('100%');
	            }
	            if (status == 'error') {
	                this.$el.addClass('danger');
	                this.$info_progress.hide();
	            }
	        },
	
	        /** Refresh file size */
	        _refreshFileSize: function () {
	            this.$size.html(Utils.bytesToString(this.model.get('file_size')));
	        },
	
	        /** Remove row */
	        _removeRow: function () {
	            if (['init', 'success', 'error'].indexOf(this.model.get('status')) !== -1) {
	                this.app.collection.remove(this.model);
	            }
	        },
	
	        /** Attach file info popup */
	        _showSettings: function () {
	            if (!this.settings.visible) {
	                this.settings.empty();
	                this.settings.append(new UploadSettings(this).$el);
	                this.settings.show();
	            } else {
	                this.settings.hide();
	            }
	        },
	
	        /** View template */
	        _template: function (options) {
	            return '<tr id="upload-row-' + options.id + '" class="upload-row">' + '<td>' + '<div class="upload-text-column">' + '<div class="upload-mode"/>' + '<div class="upload-title"/>' + '<div class="upload-text">' + '<div class="upload-text-info">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div>' + '<textarea class="upload-text-content form-control"/>' + '</div>' + '</div>' + '</td>' + '<td>' + '<div class="upload-size"/>' + '</td>' + '<td>' + '<div class="upload-extension" style="float: left;"/>&nbsp;&nbsp' + '<div class="upload-extension-info upload-icon-button fa fa-search"/>' + '</td>' + '<td>' + '<div class="upload-genome"/>' + '</td>' + '<td><div class="upload-settings upload-icon-button fa fa-gear"/></td>' + '<td>' + '<div class="upload-info">' + '<div class="upload-info-text"/>' + '<div class="upload-info-progress progress">' + '<div class="upload-progress-bar progress-bar progress-bar-success"/>' + '<div class="upload-percentage">0%</div>' + '</div>' + '</div>' + '</td>' + '<td>' + '<div class="upload-symbol ' + this.status_classes.init + '"/>' + '</td>' + '</tr>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/** Renders contents of the default uploader */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(43), __webpack_require__(140), __webpack_require__(69), __webpack_require__(22), __webpack_require__(23), __webpack_require__(5), __webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, UploadModel, UploadRow, UploadFtp, Popover, Select, Ui) {
	    return Backbone.View.extend({
	        // current upload size in bytes
	        upload_size: 0,
	
	        // contains upload row models
	        collection: new UploadModel.Collection(),
	
	        // keeps track of the current uploader state
	        counter: {
	            announce: 0,
	            success: 0,
	            error: 0,
	            running: 0,
	            reset: function () {
	                this.announce = this.success = this.error = this.running = 0;
	            }
	        },
	
	        initialize: function (app) {
	            var self = this;
	            this.app = app;
	            this.options = app.options;
	            this.list_extensions = app.list_extensions;
	            this.list_genomes = app.list_genomes;
	            this.ui_button = app.ui_button;
	            this.ftp_upload_site = app.currentFtp();
	            this.setElement(this._template());
	
	            // append buttons to dom
	            this.btnLocal = new Ui.Button({ id: 'btn-local', title: 'Choose local file', onclick: function () {
	                    self.uploadbox.select();
	                }, icon: 'fa fa-laptop' });
	            this.btnFtp = new Ui.Button({ id: 'btn-ftp', title: 'Choose FTP file', onclick: function () {
	                    self._eventFtp();
	                }, icon: 'fa fa-folder-open-o' });
	            this.btnCreate = new Ui.Button({ id: 'btn-new', title: 'Paste/Fetch data', onclick: function () {
	                    self._eventCreate();
	                }, icon: 'fa fa-edit' });
	            this.btnStart = new Ui.Button({ id: 'btn-start', title: 'Start', onclick: function () {
	                    self._eventStart();
	                } });
	            this.btnStop = new Ui.Button({ id: 'btn-stop', title: 'Pause', onclick: function () {
	                    self._eventStop();
	                } });
	            this.btnReset = new Ui.Button({ id: 'btn-reset', title: 'Reset', onclick: function () {
	                    self._eventReset();
	                } });
	            this.btnClose = new Ui.Button({ id: 'btn-close', title: 'Close', onclick: function () {
	                    self.app.modal.hide();
	                } });
	            _.each([this.btnLocal, this.btnFtp, this.btnCreate, this.btnStop, this.btnReset, this.btnStart, this.btnClose], function (button) {
	                self.$('.upload-buttons').prepend(button.$el);
	            });
	
	            // file upload
	            this.uploadbox = this.$('.upload-box').uploadbox({
	                url: this.app.options.nginx_upload_path,
	                announce: function (index, file) {
	                    self._eventAnnounce(index, file);
	                },
	                initialize: function (index) {
	                    return self.app.toData([self.collection.get(index)], self.history_id);
	                },
	                progress: function (index, percentage) {
	                    self._eventProgress(index, percentage);
	                },
	                success: function (index, message) {
	                    self._eventSuccess(index, message);
	                },
	                error: function (index, message) {
	                    self._eventError(index, message);
	                },
	                complete: function () {
	                    self._eventComplete();
	                },
	                ondragover: function () {
	                    self.$('.upload-box').addClass('highlight');
	                },
	                ondragleave: function () {
	                    self.$('.upload-box').removeClass('highlight');
	                }
	            });
	
	            // add ftp file viewer
	            this.ftp = new Popover.View({ title: 'FTP files', container: this.btnFtp.$el });
	
	            // select extension
	            this.select_extension = new Select.View({
	                css: 'upload-footer-selection',
	                container: this.$('.upload-footer-extension'),
	                data: _.filter(this.list_extensions, function (ext) {
	                    return !ext.composite_files;
	                }),
	                value: this.options.default_extension,
	                onchange: function (extension) {
	                    self.updateExtension(extension);
	                }
	            });
	
	            // handle extension info popover
	            this.$('.upload-footer-extension-info').on('click', function (e) {
	                self.showExtensionInfo({
	                    $el: $(e.target),
	                    title: self.select_extension.text(),
	                    extension: self.select_extension.value(),
	                    placement: 'top'
	                });
	            }).on('mousedown', function (e) {
	                e.preventDefault();
	            });
	
	            // genome extension
	            this.select_genome = new Select.View({
	                css: 'upload-footer-selection',
	                container: this.$('.upload-footer-genome'),
	                data: this.list_genomes,
	                value: this.options.default_genome,
	                onchange: function (genome) {
	                    self.updateGenome(genome);
	                }
	            });
	
	            // events
	            this.collection.on('remove', function (model) {
	                self._eventRemove(model);
	            });
	            this._updateScreen();
	        },
	
	        /** A new file has been dropped/selected through the uploadbox plugin */
	        _eventAnnounce: function (index, file) {
	            this.counter.announce++;
	            var new_model = new UploadModel.Model({
	                id: index,
	                file_name: file.name,
	                file_size: file.size,
	                file_mode: file.mode || 'local',
	                file_path: file.path,
	                file_data: file
	            });
	            this.collection.add(new_model);
	            var upload_row = new UploadRow(this, { model: new_model });
	            this.$('.upload-table > tbody:first').append(upload_row.$el);
	            this._updateScreen();
	            upload_row.render();
	        },
	
	        /** Progress */
	        _eventProgress: function (index, percentage) {
	            var it = this.collection.get(index);
	            it.set('percentage', percentage);
	            this.ui_button.model.set('percentage', this._uploadPercentage(percentage, it.get('file_size')));
	        },
	
	        /** Success */
	        _eventSuccess: function (index, message) {
	            var it = this.collection.get(index);
	            it.set({ 'percentage': 100, 'status': 'success' });
	            this.ui_button.model.set('percentage', this._uploadPercentage(100, it.get('file_size')));
	            this.upload_completed += it.get('file_size') * 100;
	            this.counter.announce--;
	            this.counter.success++;
	            this._updateScreen();
	            Galaxy.currHistoryPanel.refreshContents();
	        },
	
	        /** Error */
	        _eventError: function (index, message) {
	            var it = this.collection.get(index);
	            it.set({ 'percentage': 100, 'status': 'error', 'info': message });
	            this.ui_button.model.set({ 'percentage': this._uploadPercentage(100, it.get('file_size')), 'status': 'danger' });
	            this.upload_completed += it.get('file_size') * 100;
	            this.counter.announce--;
	            this.counter.error++;
	            this._updateScreen();
	        },
	
	        /** Queue is done */
	        _eventComplete: function () {
	            this.collection.each(function (model) {
	                model.get('status') == 'queued' && model.set('status', 'init');
	            });
	            this.counter.running = 0;
	            this._updateScreen();
	        },
	
	        /** Remove model from upload list */
	        _eventRemove: function (model) {
	            var status = model.get('status');
	            if (status == 'success') {
	                this.counter.success--;
	            } else if (status == 'error') {
	                this.counter.error--;
	            } else {
	                this.counter.announce--;
	            }
	            this.uploadbox.remove(model.id);
	            this._updateScreen();
	        },
	
	        //
	        // events triggered by this view
	        //
	
	        /** [public] display extension info popup */
	        showExtensionInfo: function (options) {
	            var self = this;
	            var $el = options.$el;
	            var extension = options.extension;
	            var title = options.title;
	            var description = _.findWhere(self.list_extensions, { 'id': extension });
	            this.extension_popup && this.extension_popup.remove();
	            this.extension_popup = new Popover.View({ placement: options.placement || 'bottom', container: $el });
	            this.extension_popup.title(title);
	            this.extension_popup.empty();
	            this.extension_popup.append(this._templateDescription(description));
	            this.extension_popup.show();
	        },
	
	        /** Show/hide ftp popup */
	        _eventFtp: function () {
	            if (!this.ftp.visible) {
	                this.ftp.empty();
	                var self = this;
	                this.ftp.append(new UploadFtp({
	                    collection: this.collection,
	                    ftp_upload_site: this.ftp_upload_site,
	                    onadd: function (ftp_file) {
	                        self.uploadbox.add([{
	                            mode: 'ftp',
	                            name: ftp_file.path,
	                            size: ftp_file.size,
	                            path: ftp_file.path
	                        }]);
	                    },
	                    onremove: function (model_index) {
	                        self.collection.remove(model_index);
	                    }
	                }).$el);
	                this.ftp.show();
	            } else {
	                this.ftp.hide();
	            }
	        },
	
	        /** Create a new file */
	        _eventCreate: function () {
	            this.uploadbox.add([{ name: 'New File', size: 0, mode: 'new' }]);
	        },
	
	        /** Start upload process */
	        _eventStart: function () {
	            if (this.counter.announce == 0 || this.counter.running > 0) {
	                return;
	            }
	            var self = this;
	            this.upload_size = 0;
	            this.upload_completed = 0;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init') {
	                    model.set('status', 'queued');
	                    self.upload_size += model.get('file_size');
	                }
	            });
	            this.ui_button.model.set({ 'percentage': 0, 'status': 'success' });
	            this.counter.running = this.counter.announce;
	            this.history_id = this.app.currentHistory();
	            this.uploadbox.start();
	            this._updateScreen();
	        },
	
	        /** Pause upload process */
	        _eventStop: function () {
	            if (this.counter.running > 0) {
	                this.ui_button.model.set('status', 'info');
	                $('.upload-top-info').html('Queue will pause after completing the current file...');
	                this.uploadbox.stop();
	            }
	        },
	
	        /** Remove all */
	        _eventReset: function () {
	            if (this.counter.running == 0) {
	                this.collection.reset();
	                this.counter.reset();
	                this.uploadbox.reset();
	                this.select_extension.value(this.options.default_extension);
	                this.select_genome.value(this.options.default_genome);
	                this.ui_button.model.set('percentage', 0);
	                this._updateScreen();
	            }
	        },
	
	        /** Update extension for all models */
	        updateExtension: function (extension, defaults_only) {
	            var self = this;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init' && (model.get('extension') == self.options.default_extension || !defaults_only)) {
	                    model.set('extension', extension);
	                }
	            });
	        },
	
	        /** Update genome for all models */
	        updateGenome: function (genome, defaults_only) {
	            var self = this;
	            this.collection.each(function (model) {
	                if (model.get('status') == 'init' && (model.get('genome') == self.options.default_genome || !defaults_only)) {
	                    model.set('genome', genome);
	                }
	            });
	        },
	
	        /** Set screen */
	        _updateScreen: function () {
	            var message = '';
	            if (this.counter.announce == 0) {
	                if (this.uploadbox.compatible()) {
	                    message = '&nbsp;';
	                } else {
	                    message = 'Browser does not support Drag & Drop. Try Firefox 4+, Chrome 7+, IE 10+, Opera 12+ or Safari 6+.';
	                }
	            } else {
	                if (this.counter.running == 0) {
	                    message = 'You added ' + this.counter.announce + ' file(s) to the queue. Add more files or click \'Start\' to proceed.';
	                } else {
	                    message = 'Please wait...' + this.counter.announce + ' out of ' + this.counter.running + ' remaining.';
	                }
	            }
	            this.$('.upload-top-info').html(message);
	            var enable_reset = this.counter.running == 0 && this.counter.announce + this.counter.success + this.counter.error > 0;
	            var enable_start = this.counter.running == 0 && this.counter.announce > 0;
	            var enable_sources = this.counter.running == 0;
	            var show_table = this.counter.announce + this.counter.success + this.counter.error > 0;
	            this.btnReset[enable_reset ? 'enable' : 'disable']();
	            this.btnStart[enable_start ? 'enable' : 'disable']();
	            this.btnStart.$el[enable_start ? 'addClass' : 'removeClass']('btn-primary');
	            this.btnStop[this.counter.running > 0 ? 'enable' : 'disable']();
	            this.btnLocal[enable_sources ? 'enable' : 'disable']();
	            this.btnFtp[enable_sources ? 'enable' : 'disable']();
	            this.btnCreate[enable_sources ? 'enable' : 'disable']();
	            this.btnFtp.$el[this.ftp_upload_site ? 'show' : 'hide']();
	            this.$('.upload-table')[show_table ? 'show' : 'hide']();
	            this.$('.upload-helper')[show_table ? 'hide' : 'show']();
	        },
	
	        /** Calculate percentage of all queued uploads */
	        _uploadPercentage: function (percentage, size) {
	            return (this.upload_completed + percentage * size) / this.upload_size;
	        },
	
	        /** Template for extensions description */
	        _templateDescription: function (options) {
	            if (options.description) {
	                var tmpl = options.description;
	                if (options.description_url) {
	                    tmpl += '&nbsp;(<a href="' + options.description_url + '" target="_blank">read more</a>)';
	                }
	                return tmpl;
	            } else {
	                return 'There is no description available for this file extension.';
	            }
	        },
	
	        /** Template */
	        _template: function () {
	            return '<div class="upload-view-default">' + '<div class="upload-top">' + '<h6 class="upload-top-info"/>' + '</div>' + '<div class="upload-box">' + '<div class="upload-helper"><i class="fa fa-files-o"/>Drop files here</div>' + '<table class="upload-table ui-table-striped" style="display: none;">' + '<thead>' + '<tr>' + '<th>Name</th>' + '<th>Size</th>' + '<th>Type</th>' + '<th>Genome</th>' + '<th>Settings</th>' + '<th>Status</th>' + '<th/>' + '</tr>' + '</thead>' + '<tbody/>' + '</table>' + '</div>' + '<div class="upload-footer">' + '<span class="upload-footer-title">Type (set all):</span>' + '<span class="upload-footer-extension"/>' + '<span class="upload-footer-extension-info upload-icon-button fa fa-search"/> ' + '<span class="upload-footer-title">Genome (set all):</span>' + '<span class="upload-footer-genome"/>' + '</div>' + '<div class="upload-buttons"/>' + '</div>';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** View for upload/progress bar button */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model({
	                icon: 'fa-upload',
	                tooltip: 'Download from URL or upload files from disk',
	                label: 'Load Data',
	                percentage: 0,
	                status: '',
	                onunload: function () {},
	                onclick: function () {}
	            }).set(options);
	            this.setElement(this._template());
	            this.$progress = this.$('.progress-bar');
	            this.listenTo(this.model, 'change', this.render, this);
	            this.render();
	            $(window).on('beforeunload', function () {
	                return self.model.get('onunload')();
	            });
	        },
	
	        render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.$el.off('click').on('click', function (e) {
	                options.onclick(e);
	            }).tooltip({ title: this.model.get('tooltip'), placement: 'bottom' });
	            this.$progress.removeClass().addClass('progress-bar').addClass('progress-bar-notransition').addClass(options.status != '' && 'progress-bar-' + options.status).css({ width: options.percentage + '%' });
	        },
	
	        /** Template */
	        _template: function () {
	            return '<div class="upload-button">' + '<div class="progress">' + '<div class="progress-bar"/>' + '<a class="panel-header-button" href="javascript:void(0)" id="tool-panel-upload-button">' + '<span class="fa fa-upload"/>' + '</a>' + '</div>' + '</div>';
	        }
	    });
	    return { View: View };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {/** Upload app contains the upload progress button and upload modal, compiles model data for API request **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(8), __webpack_require__(49), __webpack_require__(142), __webpack_require__(141), __webpack_require__(139), __webpack_require__(137)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Modal, Tabs, UploadButton, UploadViewDefault, UploadViewComposite, UploadViewCollection) {
	    return Backbone.View.extend({
	        options: {
	            nginx_upload_path: '',
	            ftp_upload_site: 'n/a',
	            default_genome: '?',
	            default_extension: 'auto',
	            height: 500,
	            width: 900,
	            auto: {
	                id: 'auto',
	                text: 'Auto-detect',
	                description: 'This system will try to detect the file type automatically. If your file is not detected properly as one of the known formats, it most likely means that it has some format problems (e.g., different number of columns on different rows). You can still coerce the system to set your data to the format you think it should be.  You can also upload compressed files, which will automatically be decompressed.'
	            }
	        },
	
	        // contains all available dataset extensions/types
	        list_extensions: [],
	
	        // contains all available genomes
	        list_genomes: [],
	
	        initialize: function (options) {
	            var self = this;
	            this.options = Utils.merge(options, this.options);
	
	            // create view for upload/progress button
	            this.ui_button = new UploadButton.View({
	                onclick: function (e) {
	                    e.preventDefault();
	                    self.show();
	                },
	                onunload: function () {
	                    var percentage = self.ui_button.model.get('percentage', 0);
	                    if (percentage > 0 && percentage < 100) {
	                        return 'Several uploads are queued.';
	                    }
	                }
	            });
	
	            // set element to button view
	            this.setElement(this.ui_button.$el);
	
	            // load extensions
	            var self = this;
	            Utils.get({
	                url: Galaxy.root + 'api/datatypes?extension_only=False',
	                success: function (datatypes) {
	                    for (var key in datatypes) {
	                        self.list_extensions.push({
	                            id: datatypes[key].extension,
	                            text: datatypes[key].extension,
	                            description: datatypes[key].description,
	                            description_url: datatypes[key].description_url,
	                            composite_files: datatypes[key].composite_files
	                        });
	                    }
	                    self.list_extensions.sort(function (a, b) {
	                        var a_text = a.text && a.text.toLowerCase();
	                        var b_text = b.text && b.text.toLowerCase();
	                        return a_text > b_text ? 1 : a_text < b_text ? -1 : 0;
	                    });
	                    if (!self.options.datatypes_disable_auto) {
	                        self.list_extensions.unshift(self.options.auto);
	                    }
	                }
	            });
	
	            // load genomes
	            Utils.get({
	                url: Galaxy.root + 'api/genomes',
	                success: function (genomes) {
	                    for (var key in genomes) {
	                        self.list_genomes.push({
	                            id: genomes[key][1],
	                            text: genomes[key][0]
	                        });
	                    }
	                    self.list_genomes.sort(function (a, b) {
	                        if (a.id == self.options.default_genome) {
	                            return -1;
	                        }
	                        if (b.id == self.options.default_genome) {
	                            return 1;
	                        }
	                        return a.text > b.text ? 1 : a.text < b.text ? -1 : 0;
	                    });
	                }
	            });
	        },
	
	        /** Show/hide upload dialog */
	        show: function () {
	            var self = this;
	            if (!Galaxy.currHistoryPanel || !Galaxy.currHistoryPanel.model) {
	                window.setTimeout(function () {
	                    self.show();
	                }, 500);
	                return;
	            }
	            this.current_user = Galaxy.user.id;
	            if (!this.modal) {
	                this.tabs = new Tabs.View();
	                this.default_view = new UploadViewDefault(this);
	                this.tabs.add({
	                    id: 'regular',
	                    title: 'Regular',
	                    $el: this.default_view.$el
	                });
	                this.composite_view = new UploadViewComposite(this);
	                this.tabs.add({
	                    id: 'composite',
	                    title: 'Composite',
	                    $el: this.composite_view.$el
	                });
	                this.collection_view = new UploadViewCollection(this);
	                this.tabs.add({
	                    id: 'collection',
	                    title: 'Collection',
	                    $el: this.collection_view.$el
	                });
	                this.modal = new Modal.View({
	                    title: 'Download from web or upload from disk',
	                    body: this.tabs.$el,
	                    height: this.options.height,
	                    width: this.options.width,
	                    closing_events: true,
	                    title_separator: false
	                });
	            }
	            this.modal.show();
	        },
	
	        /** Refresh user and current history */
	        currentHistory: function () {
	            return this.current_user && Galaxy.currHistoryPanel.model.get('id');
	        },
	
	        /** Get ftp configuration */
	        currentFtp: function () {
	            return this.current_user && this.options.ftp_upload_site;
	        },
	
	        /**
	          * Package API data from array of models
	          * @param{Array} items - Upload items/rows filtered from a collection
	        */
	        toData: function (items, history_id) {
	            // create dictionary for data submission
	            var data = {
	                payload: {
	                    'tool_id': 'upload1',
	                    'history_id': history_id || this.currentHistory(),
	                    'inputs': {}
	                },
	                files: [],
	                error_message: null
	                // add upload tools input data
	            };if (items && items.length > 0) {
	                var inputs = {};
	                inputs['dbkey'] = items[0].get('genome', null);
	                inputs['file_type'] = items[0].get('extension', null);
	                for (var index in items) {
	                    var it = items[index];
	                    it.set('status', 'running');
	                    if (it.get('file_size') > 0) {
	                        var prefix = 'files_' + index + '|';
	                        inputs[prefix + 'type'] = 'upload_dataset';
	                        inputs[prefix + 'space_to_tab'] = it.get('space_to_tab') && 'Yes' || null;
	                        inputs[prefix + 'to_posix_lines'] = it.get('to_posix_lines') && 'Yes' || null;
	                        switch (it.get('file_mode')) {
	                            case 'new':
	                                inputs[prefix + 'url_paste'] = it.get('url_paste');
	                                break;
	                            case 'ftp':
	                                inputs[prefix + 'ftp_files'] = it.get('file_path');
	                                break;
	                            case 'local':
	                                data.files.push({ name: prefix + 'file_data', file: it.get('file_data') });
	                        }
	                    } else {
	                        data.error_message = 'Upload content incomplete.';
	                        it.set('status', 'error');
	                        it.set('info', data.error_message);
	                        break;
	                    }
	                }
	                data.payload.inputs = JSON.stringify(inputs);
	            }
	            return data;
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** This class renders the chart configuration form. */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(10), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Ui, Form, Table) {
	    var Collection = Backbone.Collection.extend({
	        comparator: function (a, b) {
	            a = a.get('name');
	            b = b.get('name');
	            return a > b ? 1 : a < b ? -1 : 0;
	        }
	    });
	
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            var history_id = Galaxy.currHistoryPanel && Galaxy.currHistoryPanel.model.id;
	            this.model = new Backbone.Model();
	            this.model.url = Galaxy.root + 'api/histories/' + history_id + '/custom_builds_metadata';
	            this.collection = new Collection();
	            this.collection.url = Galaxy.root + 'api/users/' + Galaxy.user.id + '/custom_builds';
	            this.message = new Ui.Message({});
	            this.installed_builds = new Ui.Select.View({
	                optional: true,
	                onchange: function () {
	                    self.installed_builds.value(null);
	                },
	                empty_text: 'List of available builds:',
	                error_text: 'No system installed builds available.'
	            });
	            this.table = new Table.View({ cls: 'grid', selectable: false });
	            this.table.addHeader('Name');
	            this.table.addHeader('Key');
	            this.table.addHeader('Number of chroms/contigs');
	            this.table.addHeader('');
	            this.table.appendHeader();
	            this.setElement($('<div/>').append($('<h4/>').text('Current Custom Builds')).append(this.table.$el).append(this.$installed = $('<div/>').append($('<h4/>').text('System Installed Builds').addClass('ui-margin-top')).append(this.installed_builds.$el)).append($('<h4/>').text('Add a Custom Build').addClass('ui-margin-top')).append($('<span/>').addClass('ui-column').append($('<div/>').addClass('ui-column-left').append(this.message.$el).append(this.$form = $('<div/>').addClass('ui-margin-top'))).append(this.$help = $('<div/>').addClass('ui-column-right'))));
	            this.listenTo(this.collection, 'add remove reset', function () {
	                self._renderTable();
	            });
	            this.listenTo(this.model, 'change', function () {
	                self._renderForm();
	            });
	            this.collection.fetch();
	            this.model.fetch();
	        },
	
	        render: function () {
	            this._renderTable();
	            this._renderForm();
	        },
	
	        _renderTable: function () {
	            var self = this;
	            this.table.delAll();
	            this.collection.sort();
	            this.collection.each(function (model) {
	                self.table.add(model.get('name'));
	                self.table.add(model.id);
	                self.table.add(model.get('count') !== undefined ? model.get('count') : 'Processing...');
	                self.table.add(new Ui.ButtonIcon({
	                    icon: 'fa-trash-o',
	                    cls: 'ui-button-icon-plain',
	                    tooltip: 'Delete custom build.',
	                    onclick: function () {
	                        model.destroy();
	                    }
	                }).$el);
	                self.table.append(model.id);
	            });
	        },
	
	        _renderForm: function () {
	            var self = this;
	            var initial_type = 'fasta';
	            var form = new Form({
	                inputs: [{
	                    type: 'text',
	                    name: 'name',
	                    label: 'Name',
	                    help: 'Specify a build name e.g. Hamster.'
	                }, {
	                    type: 'text',
	                    name: 'id',
	                    label: 'Key',
	                    help: 'Specify a build key e.g. hamster_v1.'
	                }, {
	                    name: 'len',
	                    type: 'conditional',
	                    test_param: {
	                        name: 'type',
	                        label: 'Definition',
	                        help: 'Provide the data source.',
	                        type: 'select',
	                        value: initial_type,
	                        data: [{ value: 'fasta', label: 'FASTA-file from history' }, { value: 'file', label: 'Len-file from disk' }, { value: 'text', label: 'Len-file by copy/paste' }]
	                    },
	                    cases: [{
	                        value: 'fasta',
	                        inputs: [{
	                            type: 'select',
	                            name: 'value',
	                            label: 'FASTA-file',
	                            data: this.model.get('fasta_hdas')
	                        }]
	                    }, {
	                        value: 'file',
	                        inputs: [{
	                            type: 'upload',
	                            name: 'value',
	                            label: 'Len-file',
	                            data: this.model.get('len_hdas')
	                        }]
	                    }, {
	                        value: 'text',
	                        inputs: [{
	                            type: 'text',
	                            area: true,
	                            name: 'value',
	                            label: 'Edit/Paste'
	                        }]
	                    }]
	                }],
	                buttons: {
	                    save: new Ui.Button({
	                        icon: 'fa-save',
	                        tooltip: 'Create new Build',
	                        title: 'Save',
	                        cls: 'btn btn-primary ui-clear-float',
	                        onclick: function () {
	                            var data = form.data.create();
	                            if (!data.id || !data.name) {
	                                self.message.update({ message: 'All inputs are required.', status: 'danger' });
	                            } else {
	                                self.collection.create(data, {
	                                    wait: true,
	                                    success: function (response) {
	                                        if (response.get('message')) {
	                                            self.message.update({ message: response.get('message'), status: 'warning' });
	                                        } else {
	                                            self.message.update({ message: 'Successfully added a new custom build.', status: 'success' });
	                                        }
	                                    },
	                                    error: function (response, err) {
	                                        var message = err && err.responseJSON && err.responseJSON.err_msg;
	                                        self.message.update({ message: message || 'Failed to create custom build.', status: 'danger' });
	                                    }
	                                });
	                            }
	                        }
	                    })
	                },
	                onchange: function () {
	                    var input_id = form.data.match('len|type');
	                    if (input_id) {
	                        var input_field = form.field_list[input_id];
	                        self._renderHelp(input_field.value());
	                    }
	                }
	            });
	            this.$form.empty().append(form.$el);
	            var installed_builds = this.model.get('installed_builds');
	            if (installed_builds && installed_builds.length) {
	                this.$installed.show();
	                this.installed_builds.update(this.model.get('installed_builds'));
	            } else {
	                this.$installed.hide();
	            }
	            this._renderHelp(initial_type);
	        },
	
	        _renderHelp: function (len_type) {
	            this.$help.empty().addClass('alert alert-info').html(len_type == 'fasta' ? this._templateFasta() : this._templateLen());
	        },
	
	        _templateLen: function () {
	            return '<h4>Length Format</h4>' + '<p>' + 'The length format is two-column, separated by whitespace, of the form:' + '<pre>chrom/contig   length of chrom/contig</pre>' + '</p>' + '<p>' + 'For example, the first few entries of <em>mm9.len</em> are as follows:' + '<pre>' + 'chr1    197195432\n' + 'chr2    181748087\n' + 'chr3    159599783\n' + 'chr4    155630120\n' + 'chr5    152537259' + '</pre>' + '</p>' + '<p>Trackster uses this information to populate the select box for chrom/contig, and' + 'to set the maximum basepair of the track browser. You may either upload a .len file' + 'of this format (Len File option), or directly enter the information into the box ' + '(Len Entry option).</p>';
	        },
	
	        _templateFasta: function () {
	            return '<h4>FASTA format</h4>' + '<p>' + 'This is a multi-fasta file from your current history that provides the genome' + 'sequences for each chromosome/contig in your build.' + '</p>' + '<p>' + 'Here is a snippet from an example multi-fasta file:' + '<pre>' + '>chr1\n' + 'ATTATATATAAGACCACAGAGAGAATATTTTGCCCGG...\n\n' + '>chr2\n' + 'GGCGGCCGCGGCGATATAGAACTACTCATTATATATA...\n\n' + '...' + '</pre>' + '</p>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {/** User Preferences view */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(5), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Form, Ui, QueryStringParsing) {
	
	    /** Contains descriptive dictionaries describing user forms */
	    var Model = Backbone.Model.extend({
	        initialize: function (options) {
	            options = options || {};
	            options.user_id = options.user_id || Galaxy.user.id;
	            this.set({
	                'user_id': options.user_id,
	                'information': {
	                    title: 'Manage information',
	                    description: 'Edit your email, addresses and custom parameters or change your username.',
	                    url: 'api/users/' + options.user_id + '/information/inputs',
	                    icon: 'fa-user',
	                    redirect: 'user'
	                },
	                'password': {
	                    title: 'Change password',
	                    description: 'Allows you to change your login credentials.',
	                    icon: 'fa-unlock-alt',
	                    url: 'api/users/' + options.user_id + '/password/inputs',
	                    submit_title: 'Save password',
	                    redirect: 'user'
	                },
	                'communication': {
	                    title: 'Change communication settings',
	                    description: 'Enable or disable the communication feature to chat with other users.',
	                    url: 'api/users/' + options.user_id + '/communication/inputs',
	                    icon: 'fa-comments-o',
	                    redirect: 'user'
	                },
	                'permissions': {
	                    title: 'Set dataset permissions for new histories',
	                    description: 'Grant others default access to newly created histories. Changes made here will only affect histories created after these settings have been stored.',
	                    url: 'api/users/' + options.user_id + '/permissions/inputs',
	                    icon: 'fa-users',
	                    submit_title: 'Save permissions',
	                    redirect: 'user'
	                },
	                'api_key': {
	                    title: 'Manage API key',
	                    description: 'Access your current API key or create a new one.',
	                    url: 'api/users/' + options.user_id + '/api_key/inputs',
	                    icon: 'fa-key',
	                    submit_title: 'Create a new key',
	                    submit_icon: 'fa-check'
	                },
	                'toolbox_filters': {
	                    title: 'Manage Toolbox filters',
	                    description: 'Customize your Toolbox by displaying or omitting sets of Tools.',
	                    url: 'api/users/' + options.user_id + '/toolbox_filters/inputs',
	                    icon: 'fa-filter',
	                    submit_title: 'Save filters',
	                    redirect: 'user'
	                },
	                'openids': {
	                    title: 'Manage OpenIDs',
	                    description: 'Associate OpenIDs with your account.',
	                    icon: 'fa-openid',
	                    onclick: function () {
	                        window.location.href = Galaxy.root + 'user/openid_manage?cntrller=user&use_panels=True';
	                    }
	                },
	                'custom_builds': {
	                    title: 'Manage custom builds',
	                    description: 'Add or remove custom builds using history datasets.',
	                    icon: 'fa-cubes',
	                    onclick: function () {
	                        window.location.href = Galaxy.root + 'custom_builds';
	                    }
	                },
	                'logout': {
	                    title: 'Sign out',
	                    description: 'Click here to sign out of all sessions.',
	                    icon: 'fa-sign-out',
	                    onclick: function () {
	                        Galaxy.modal.show({
	                            title: 'Sign out',
	                            body: 'Do you want to continue and sign out of all active sessions?',
	                            buttons: {
	                                'Cancel': function () {
	                                    Galaxy.modal.hide();
	                                },
	                                'Sign out': function () {
	                                    window.location.href = Galaxy.root + 'user/logout?session_csrf_token=' + Galaxy.session_csrf_token;
	                                }
	                            }
	                        });
	                    }
	                }
	            });
	        }
	    });
	
	    /** View of the main user preference panel with links to individual user forms */
	    var View = Backbone.View.extend({
	        title: "User Preferences",
	        initialize: function () {
	            this.model = new Model();
	            this.setElement('<div/>');
	            this.render();
	        },
	
	        render: function () {
	            var self = this;
	            var config = Galaxy.config;
	            $.getJSON(Galaxy.root + 'api/users/' + Galaxy.user.id, function (data) {
	                self.$preferences = $('<div/>').addClass('ui-panel').append($('<h2/>').append('User preferences')).append($('<p/>').append('You are logged in as <strong>' + _.escape(data.email) + '</strong>.')).append(self.$table = $('<table/>').addClass('ui-panel-table'));
	                var message = QueryStringParsing.get('message');
	                var status = QueryStringParsing.get('status');
	                if (message && status) {
	                    self.$preferences.prepend(new Ui.Message({ message: message, status: status }).$el);
	                }
	                if (!config.use_remote_user) {
	                    self._addLink('information');
	                    self._addLink('password');
	                }
	                if (config.enable_communication_server) {
	                    self._addLink('communication');
	                }
	                self._addLink('custom_builds');
	                self._addLink('permissions');
	                self._addLink('api_key');
	                if (config.has_user_tool_filters) {
	                    self._addLink('toolbox_filters');
	                }
	                if (config.enable_openid && !config.use_remote_user) {
	                    self._addLink('openids');
	                }
	                if (Galaxy.session_csrf_token) {
	                    self._addLink('logout');
	                }
	                self.$preferences.append(self._templateFooter(data));
	                self.$el.empty().append(self.$preferences);
	            });
	        },
	
	        _addLink: function (action) {
	            var options = this.model.get(action);
	            var $row = $(this._templateLink(options));
	            var $a = $row.find('a');
	            if (options.onclick) {
	                $a.on('click', function () {
	                    options.onclick();
	                });
	            } else {
	                $a.attr('href', Galaxy.root + 'user/' + action);
	            }
	            this.$table.append($row);
	        },
	
	        _templateLink: function (options) {
	            return '<tr>' + '<td>' + '<div class="ui-panel-icon fa ' + options.icon + '">' + '</td>' + '<td>' + '<a class="ui-panel-anchor" href="javascript:void(0)">' + options.title + '</a>' + '<div class="ui-form-info">' + options.description + '</div>' + '</td>' + '</tr>';
	        },
	
	        _templateFooter: function (options) {
	            return '<p class="ui-panel-footer">' + 'You are using <strong>' + options.nice_total_disk_usage + '</strong> of disk space in this Galaxy instance. ' + (Galaxy.config.enable_quotas ? 'Your disk quota is: <strong>' + options.quota + '</strong>. ' : '') + 'Is your usage more than expected? See the <a href="https://galaxyproject.org/learn/managing-datasets/" target="_blank">documentation</a> for tips on how to find all of the data in your account.' + '</p>';
	        }
	    });
	
	    return {
	        View: View,
	        Model: Model
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        'tool': 'fa-wrench',
	        'data_input': 'fa-file-o',
	        'data_collection_input': 'fa-folder-o',
	        'subworkflow': 'fa-sitemap fa-rotate-270',
	        'pause': 'fa-pause'
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (baseMVC) {
	    /* global Backbone */
	    // workflow model
	
	    var logNamespace = 'workflow';
	    //==============================================================================
	    /** @class model for a single workflow.
	     *  @name WorkflowItem
	     *  @augments Backbone.Model
	     */
	    var WorkflowItem = Backbone.Model.extend(baseMVC.LoggableMixin).extend({
	        _logNamespace: logNamespace,
	
	        urlRoot: Galaxy.root + 'api/workflows',
	
	        toJSON: function () {
	            // need to overwrite this as endpoint expects the 'workflow' key in payload
	            return { workflow: this.attributes };
	        }
	
	    });
	
	    //==============================================================================
	    /** @class collection for workflows.
	     *  @name WorkflowCollection
	     *  @augments Backbone.Collection
	     */
	    var WorkflowCollection = Backbone.Collection.extend({
	        model: WorkflowItem,
	        url: Galaxy.root + 'api/workflows'
	
	    });
	
	    //==============================================================================
	
	    return {
	        WorkflowItem: WorkflowItem,
	        WorkflowCollection: WorkflowCollection
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/** Workflow view */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(121), __webpack_require__(45), __webpack_require__(148), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (mod_toastr, TAGS, WORKFLOWS, QueryStringParsing) {
	
	    /** View of the individual workflows */
	    var WorkflowItemView = Backbone.View.extend({
	        tagName: 'tr', // name of (orphan) root tag in this.el
	        initialize: function () {
	            _.bindAll(this, 'render', '_rowTemplate', 'renderTagEditor', '_templateActions', 'removeWorkflow', 'copyWorkflow'); // every function that uses 'this' as the current object should be in here
	            mod_toastr.options.timeOut = 1500;
	        },
	
	        events: {
	            'click #show-in-tool-panel': 'showInToolPanel',
	            'click #delete-workflow': 'removeWorkflow',
	            'click #rename-workflow': 'renameWorkflow',
	            'click #copy-workflow': 'copyWorkflow'
	        },
	
	        render: function () {
	            $(this.el).html(this._rowTemplate());
	            return this;
	        },
	
	        showInToolPanel: function () {
	            this.model.set('show_in_tool_panel', !this.model.get('show_in_tool_panel'));
	            this.model.save();
	            // This reloads the whole page, so that the workflow appears in the tool panel.
	            // Ideally we would notify only the tool panel of a change
	            window.location = Galaxy.root + 'workflow';
	        },
	
	        removeWorkflow: function () {
	            var wfName = this.model.get('name');
	            if (window.confirm("Are you sure you want to delete workflow '" + wfName + "'?")) {
	                this.model.destroy({
	                    success: function () {
	                        mod_toastr.success("Successfully deleted workflow '" + wfName + "'");
	                    }
	                });
	                this.remove();
	            }
	        },
	
	        renameWorkflow: function () {
	            var oldName = this.model.get('name');
	            var newName = window.prompt("Enter a new Name for workflow '" + oldName + "'", oldName);
	            if (newName) {
	                this.model.save({ 'name': newName }, { success: function () {
	                        mod_toastr.success("Successfully renamed workflow '" + oldName + "' to '" + newName + "'");
	                    }
	                });
	                this.render();
	            }
	        },
	
	        copyWorkflow: function () {
	            var self = this;
	            var oldName = this.model.get('name');
	            $.getJSON(this.model.urlRoot + '/' + this.model.id + '/download', function (wfJson) {
	                var newName = 'Copy of ' + oldName;
	                var currentOwner = self.model.get('owner');
	                if (currentOwner != Galaxy.user.attributes.username) {
	                    newName += ' shared by user ' + currentOwner;
	                }
	                wfJson.name = newName;
	                self.collection.create(wfJson, { at: 0,
	                    wait: true,
	                    success: function () {
	                        mod_toastr.success("Successfully copied workflow '" + oldName + "' to '" + newName + "'");
	                    },
	                    error: function (model, resp, options) {
	                        // signature seems to have changed over the course of backbone dev
	                        // see https://github.com/jashkenas/backbone/issues/2606#issuecomment-19289483
	                        mod_toastr.error(options.errorThrown);
	                    }
	                });
	            }).error(function (jqXHR, textStatus, errorThrown) {
	                mod_toastr.error(jqXHR.responseJSON.err_msg);
	            });
	        },
	
	        _rowTemplate: function () {
	            var show = this.model.get("show_in_tool_panel");
	            var wfId = this.model.id;
	            var checkboxHtml = '<input id="show-in-tool-panel" type="checkbox" class="show-in-tool-panel" ' + (show ? 'checked="' + show + '"' : "") + ' value="' + wfId + '">';
	            var trHtml = '<td>' + '<div class="dropdown">' + '<button class="menubutton" type="button" data-toggle="dropdown">' + _.escape(this.model.get("name")) + '<span class="caret"></span>' + '</button>' + this._templateActions() + '</div>' + '</td>' + '<td><span>' + '<div class="' + wfId + ' tags-display"></div>' + '</td>' + '<td>' + (this.model.get('owner') === Galaxy.user.attributes.username ? "You" : this.model.get('owner')) + '</span></td>' + '<td>' + this.model.get("number_of_steps") + '</td>' + '<td>' + (this.model.get("published") ? "Yes" : "No") + '</td>' + '<td>' + checkboxHtml + '</td>';
	            return trHtml;
	        },
	
	        renderTagEditor: function () {
	            var TagEditor = new TAGS.TagsEditor({
	                model: this.model,
	                el: $.find('.' + this.model.id + '.tags-display'),
	                workflow_mode: true });
	            TagEditor.toggle(true);
	            TagEditor.render();
	        },
	
	        /** Template for user actions for workflows */
	        _templateActions: function () {
	            if (this.model.get("owner") === Galaxy.user.attributes.username) {
	                return '<ul class="dropdown-menu action-dpd">' + '<li><a href="' + Galaxy.root + 'workflow/editor?id=' + this.model.id + '">Edit</a></li>' + '<li><a href="' + Galaxy.root + 'workflow/run?id=' + this.model.id + '">Run</a></li>' + '<li><a href="' + Galaxy.root + 'workflow/sharing?id=' + this.model.id + '">Share</a></li>' + '<li><a href="' + Galaxy.root + 'api/workflows/' + this.model.id + '/download?format=json-download">Download</a></li>' + '<li><a id="copy-workflow" style="cursor: pointer;">Copy</a></li>' + '<li><a id="rename-workflow" style="cursor: pointer;">Rename</a></li>' + '<li><a href="' + Galaxy.root + 'workflow/display_by_id?id=' + this.model.id + '">View</a></li>' + '<li><a id="delete-workflow" style="cursor: pointer;">Delete</a></li>' + '</ul>';
	            } else {
	                return '<ul class="dropdown-menu action-dpd">' + '<li><a href="' + Galaxy.root + 'workflow/display_by_username_and_slug?username=' + this.model.get("owner") + '&slug=' + this.model.get("slug") + '">View</a></li>' + '<li><a href="' + Galaxy.root + 'workflow/run?id=' + this.model.id + '">Run</a></li>' + '<li><a id="copy-workflow" style="cursor: pointer;">Copy</a></li>' + '<li><a class="link-confirm-shared-' + this.model.id + '" href="' + Galaxy.root + 'workflow/sharing?unshare_me=True&id=' + this.model.id + '">Remove</a></li>' + '</ul>';
	            }
	        }
	    });
	
	    /** View of the main workflow list page */
	    var WorkflowListView = Backbone.View.extend({
	        title: "Workflows",
	        initialize: function () {
	            this.setElement('<div/>');
	            _.bindAll(this, 'adjustActiondropdown');
	            this.collection = new WORKFLOWS.WorkflowCollection();
	            this.collection.fetch().done(this.render());
	            this.collection.bind('add', this.appendItem);
	            this.collection.on('sync', this.render, this);
	        },
	
	        events: {
	            'dragleave': 'unhighlightDropZone',
	            'drop': 'drop',
	            'dragover': function (ev) {
	                $('.hidden_description_layer').addClass('dragover');
	                $('.menubutton').addClass('background-none');
	                ev.preventDefault();
	            }
	        },
	
	        unhighlightDropZone: function () {
	            $('.hidden_description_layer').removeClass('dragover');
	            $('.menubutton').removeClass('background-none');
	        },
	
	        drop: function (e) {
	            // TODO: check that file is valid galaxy workflow
	            this.unhighlightDropZone();
	            e.preventDefault();
	            var files = e.dataTransfer.files;
	            var self = this;
	            for (var i = 0, f; f = files[i]; i++) {
	                self.readWorkflowFiles(f);
	            }
	        },
	
	        readWorkflowFiles: function (f) {
	            var self = this;
	            var reader = new FileReader();
	            reader.onload = function (theFile) {
	                var wf_json;
	                try {
	                    wf_json = JSON.parse(reader.result);
	                } catch (e) {
	                    mod_toastr.error("Could not read file '" + f.name + "'. Verify it is a valid Galaxy workflow");
	                    wf_json = null;
	                }
	                if (wf_json) {
	                    self.collection.create(wf_json, {
	                        at: 0,
	                        wait: true,
	                        success: function () {
	                            mod_toastr.success("Successfully imported workflow '" + wf_json.name + "'");
	                        },
	                        error: function (model, resp, options) {
	                            mod_toastr.error(options.errorThrown);
	                        }
	                    });
	                }
	            };
	            reader.readAsText(f, 'utf-8');
	        },
	
	        _showArgErrors: _.once(function () {
	            // Parse args out of params, display if there's a message.
	            var msg_text = QueryStringParsing.get('message');
	            var msg_status = QueryStringParsing.get('status');
	            if (msg_status === "error") {
	                mod_toastr.error(_.escape(msg_text || "Unknown Error, please report this to an administrator."));
	            } else if (msg_text) {
	                mod_toastr.info(_.escape(msg_text));
	            }
	        }),
	
	        render: function () {
	            // Add workflow header
	            var header = this._templateHeader();
	            // Add the actions buttons
	            var templateActions = this._templateActionButtons();
	            var tableTemplate = this._templateWorkflowTable();
	            this.$el.html(header + templateActions + tableTemplate);
	            var self = this;
	            _(this.collection.models).each(function (item) {
	                // in case collection is not empty
	                self.appendItem(item);
	                self.confirmDelete(item);
	            }, this);
	            var minQueryLength = 3;
	            this.searchWorkflow(this.$('.search-wf'), this.$('.workflow-search tr'), minQueryLength);
	            this.adjustActiondropdown();
	            this._showArgErrors();
	            return this;
	        },
	
	        appendItem: function (item) {
	            var workflowItemView = new WorkflowItemView({
	                model: item,
	                collection: this.collection
	            });
	            $('.workflow-search').append(workflowItemView.render().el);
	            workflowItemView.renderTagEditor();
	        },
	
	        /** Add confirm box before removing/unsharing workflow */
	        confirmDelete: function (workflow) {
	            var $el_shared_wf_link = this.$('.link-confirm-shared-' + workflow.id);
	            $el_shared_wf_link.click(function () {
	                return window.confirm("Are you sure you want to remove the shared workflow '" + workflow.attributes.name + "'?");
	            });
	        },
	
	        /** Implement client side workflow search/filtering */
	        searchWorkflow: function ($el_searchinput, $el_tabletr, min_querylen) {
	            $el_searchinput.on('keyup', function () {
	                var query = $(this).val();
	                // Filter when query is at least 3 characters
	                // otherwise show all rows
	                if (query.length >= min_querylen) {
	                    // Ignore the query's case using 'i'
	                    var regular_expression = new RegExp(query, 'i');
	                    $el_tabletr.hide();
	                    $el_tabletr.filter(function () {
	                        // Apply regular expression on each row's text
	                        // and show when there is a match
	                        return regular_expression.test($(this).text());
	                    }).show();
	                } else {
	                    $el_tabletr.show();
	                }
	            });
	        },
	
	        /** Ajust the position of dropdown with respect to table */
	        adjustActiondropdown: function () {
	            $(this.el).on('show.bs.dropdown', function () {
	                $(this.el).css("overflow", "inherit");
	            });
	            $(this.el).on('hide.bs.dropdown', function () {
	                $(this.el).css("overflow", "auto");
	            });
	        },
	
	        /** Template for no workflow */
	        _templateNoWorkflow: function () {
	            return '<div class="wf-nodata"> You have no workflows. </div>';
	        },
	
	        /** Template for actions buttons */
	        _templateActionButtons: function () {
	            return '<ul class="manage-table-actions">' + '<li>' + '<input class="search-wf form-control" type="text" autocomplete="off" placeholder="search for workflow...">' + '</li>' + '<li>' + '<a class="action-button fa fa-plus wf-action" id="new-workflow" title="Create new workflow" href="' + Galaxy.root + 'workflow/create">' + '</a>' + '</li>' + '<li>' + '<a class="action-button fa fa-upload wf-action" id="import-workflow" title="Upload or import workflow" href="' + Galaxy.root + 'workflow/import_workflow">' + '</a>' + '</li>' + '</ul>';
	        },
	
	        /** Template for workflow table */
	        _templateWorkflowTable: function () {
	            var tableHtml = '<table class="table colored"><thead>' + '<tr class="header">' + '<th>Name</th>' + '<th>Tags</th>' + '<th>Owner</th>' + '<th># of Steps</th>' + '<th>Published</th>' + '<th>Show in tools panel</th>' + '</tr></thead>';
	            return tableHtml + '<tbody class="workflow-search "><div class="hidden_description_layer"><p>Drop workflow files here to import</p>' + '</tbody></table></div>';
	        },
	
	        /** Main template */
	        _templateHeader: function () {
	            return '<div class="page-container">' + '<div class="user-workflows wf">' + '<div class="response-message"></div>' + '<h2>Your workflows</h2>' + '</div>' + '</div>';
	        }
	    });
	
	    var ImportWorkflowView = Backbone.View.extend({
	
	        initialize: function () {
	            this.setElement('<div/>');
	            this.render();
	        },
	
	        /** Open page to import workflow */
	        render: function () {
	            var self = this;
	            $.getJSON(Galaxy.root + 'workflow/upload_import_workflow', function (options) {
	                self.$el.empty().append(self._mainTemplate(options));
	            });
	        },
	
	        /** Template for the import workflow page */
	        _mainTemplate: function (options) {
	            return "<div class='toolForm'>" + "<div class='toolFormTitle'>Import Galaxy workflow</div>" + "<div class='toolFormBody'>" + "<form name='import_workflow' id='import_workflow' action='" + Galaxy.root + 'workflow/upload_import_workflow' + "' enctype='multipart/form-data' method='POST'>" + "<div class='form-row'>" + "<label>Galaxy workflow URL:</label>" + "<input type='text' name='url' class='input-url' value='" + options.url + "' size='40'>" + "<div class='toolParamHelp' style='clear: both;'>" + "If the workflow is accessible via a URL, enter the URL above and click <b>Import</b>." + "</div>" + "<div style='clear: both'></div>" + "</div>" + "<div class='form-row'>" + "<label>Galaxy workflow file:</label>" + "<div class='form-row-input'>" + "<input type='file' name='file_data' class='input-file'/>" + "</div>" + "<div class='toolParamHelp' style='clear: both;'>" + "If the workflow is in a file on your computer, choose it and then click <b>Import</b>." + "</div>" + "<div style='clear: both'></div>" + "</div>" + "<div class='form-row'>" + "<input type='submit' class='primary-button wf-import' name='import_button' value='Import'>" + "</div>" + "</form>" + "<hr/>" + "<div class='form-row'>" + "<label>Import a Galaxy workflow from myExperiment:</label>" + "<div class='form-row-input'>" + "<a href='" + options.myexperiment_target_url + "'> Visit myExperiment</a>" + "</div>" + "<div class='toolParamHelp' style='clear: both;'>" + "Click the link above to visit myExperiment and browse for Galaxy workflows." + "</div>" + "<div style='clear: both'></div>" + "</div>" + "</div>" + "</div>";
	        }
	    });
	
	    return {
	        View: WorkflowListView,
	        ImportWorkflowView: ImportWorkflowView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery, $) {(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals
	        root.LoadingIndicator = factory();
	    }
	
	    //============================================================================
	})(this, function () {
	    //TODO: too specific to history panel
	    function LoadingIndicator($where, options) {
	
	        var self = this;
	        // defaults
	        options = jQuery.extend({
	            cover: false
	        }, options || {});
	
	        function render() {
	            var html = ['<div class="loading-indicator">', '<div class="loading-indicator-text">', '<span class="fa fa-spinner fa-spin fa-lg"></span>', '<span class="loading-indicator-message">loading...</span>', '</div>', '</div>'].join('\n');
	
	            var $indicator = $(html).hide().css(options.css || {
	                position: 'fixed'
	            }),
	                $text = $indicator.children('.loading-indicator-text');
	
	            if (options.cover) {
	                $indicator.css({
	                    'z-index': 2,
	                    top: $where.css('top'),
	                    bottom: $where.css('bottom'),
	                    left: $where.css('left'),
	                    right: $where.css('right'),
	                    opacity: 0.5,
	                    'background-color': 'white',
	                    'text-align': 'center'
	                });
	                $text = $indicator.children('.loading-indicator-text').css({
	                    'margin-top': '20px'
	                });
	            } else {
	                $text = $indicator.children('.loading-indicator-text').css({
	                    margin: '12px 0px 0px 10px',
	                    opacity: '0.85',
	                    color: 'grey'
	                });
	                $text.children('.loading-indicator-message').css({
	                    margin: '0px 8px 0px 0px',
	                    'font-style': 'italic'
	                });
	            }
	            return $indicator;
	        }
	
	        self.show = function (msg, speed, callback) {
	            msg = msg || 'loading...';
	            speed = speed || 'fast';
	            // remove previous
	            $where.parent().find('.loading-indicator').remove();
	            // since position is fixed - we insert as sibling
	            self.$indicator = render().insertBefore($where);
	            self.message(msg);
	            self.$indicator.fadeIn(speed, callback);
	            return self;
	        };
	
	        self.message = function (msg) {
	            self.$indicator.find('i').text(msg);
	        };
	
	        self.hide = function (speed, callback) {
	            speed = speed || 'fast';
	            if (self.$indicator && self.$indicator.length) {
	                self.$indicator.fadeOut(speed, function () {
	                    self.$indicator.remove();
	                    if (callback) {
	                        callback();
	                    }
	                });
	            } else {
	                if (callback) {
	                    callback();
	                }
	            }
	            return self;
	        };
	        return self;
	    }
	
	    //============================================================================
	    return LoadingIndicator;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    //ASSUMES: jquery
	    //=============================================================================
	    /** @class AjaxQueue
	     *  Class that allows queueing functions that return jQuery promises (such
	     *  as ajax calls). Each function waits for the previous to complete before
	     *  being called
	     *
	     *  @constructor accepts a list of functions and automatically begins
	     *      processing them
	     */
	    function AjaxQueue(initialFunctions) {
	        //TODO: possibly rename to DeferredQueue
	        var self = this;
	        /** the main deferred for the entire queue - note: also sends notifications of progress */
	        self.deferred = jQuery.Deferred();
	        /** the queue array of functions */
	        self.queue = [];
	        /** cache the response from each deferred call - error or success */
	        self.responses = [];
	        /** total number of fn's to process */
	        self.numToProcess = 0;
	        /** is the queue processing/waiting for any calls to return? */
	        self.running = false;
	
	        self.init(initialFunctions || []);
	        self.start();
	
	        return self;
	    }
	
	    /** add all fns in initialFunctions (if any) to the queue */
	    AjaxQueue.prototype.init = function init(initialFunctions) {
	        var self = this;
	        initialFunctions.forEach(function (fn) {
	            self.add(fn);
	        });
	    };
	
	    /** add a fn to the queue */
	    AjaxQueue.prototype.add = function add(fn) {
	        //console.debug( 'AjaxQueue.prototype.add:', fn );
	        var self = this,
	            index = this.queue.length;
	        this.numToProcess += 1;
	
	        this.queue.push(function () {
	            var fnIndex = index,
	                xhr = fn();
	            // if successful, notify using the deferred to allow tracking progress
	            xhr.done(function (response) {
	                self.deferred.notify({ curr: fnIndex, total: self.numToProcess, response: response });
	            });
	            // (regardless of previous error or success) if not last ajax call, shift and call the next
	            //  if last fn, resolve deferred
	            xhr.always(function (response) {
	                self.responses.push(response);
	                if (self.queue.length) {
	                    self.queue.shift()();
	                } else {
	                    self.stop();
	                }
	            });
	        });
	        return this;
	    };
	
	    /** start processing the queue */
	    AjaxQueue.prototype.start = function start() {
	        if (this.queue.length) {
	            this.running = true;
	            this.queue.shift()();
	        }
	        return this;
	    };
	
	    /** stop the queue
	     *  @param {boolean} causeFail  cause an error/fail on the main deferred
	     *  @param {String} msg         message to send when rejecting the main deferred
	     */
	    AjaxQueue.prototype.stop = function stop(causeFail, msg) {
	        //TODO: doesn't abort current call
	        this.running = false;
	        this.queue = [];
	        if (causeFail) {
	            //TODO: spliced args instead
	            this.deferred.reject(msg);
	        } else {
	            this.deferred.resolve(this.responses);
	        }
	        this.numToProcess = 0;
	        this.deferred = jQuery.Deferred();
	        return this;
	    };
	
	    // only a handful of the deferred interface for now - possible YAGNI
	    /** implement done from the jq deferred interface */
	    AjaxQueue.prototype.done = function done(fn) {
	        return this.deferred.done(fn);
	    };
	    /** implement fail from the jq deferred interface */
	    AjaxQueue.prototype.fail = function fail(fn) {
	        return this.deferred.fail(fn);
	    };
	    /** implement always from the jq deferred interface */
	    AjaxQueue.prototype.always = function always(fn) {
	        return this.deferred.always(fn);
	    };
	    /** implement progress from the jq deferred interface */
	    AjaxQueue.prototype.progress = function progress(fn) {
	        return this.deferred.progress(fn);
	    };
	
	    /** shortcut constructor / fire and forget
	     *  @returns {Deferred} the queue's main deferred
	     */
	    AjaxQueue.create = function create(initialFunctions) {
	        return new AjaxQueue(initialFunctions).deferred;
	    };
	
	    //=============================================================================
	    /** @class NamedAjaxQueue
	     *  @augments AjaxQueue
	     *  Allows associating a name with a deferring fn and prevents adding deferring
	     *  fns if the name has already been used. Useful to prevent build up of duplicate
	     *  async calls.
	     *  Both the array initialFunctions sent to constructor and any added later with
	     *  add() should be objects (NOT functions) of the form:
	     *  { name: some unique id,
	     *    fn:   the deferring fn or ajax call }
	     */
	    function NamedAjaxQueue(initialFunctions) {
	        var self = this;
	        self.names = {};
	        AjaxQueue.call(this, initialFunctions);
	        return self;
	    }
	    NamedAjaxQueue.prototype = new AjaxQueue();
	    NamedAjaxQueue.prototype.constructor = NamedAjaxQueue;
	
	    /** add the obj.fn to the queue if obj.name hasn't been used before */
	    NamedAjaxQueue.prototype.add = function add(obj) {
	        //console.debug( 'NamedAjaxQueue.adding:', obj )
	        //console.debug( 'NamedAjaxQueue.prototype.add:', obj );
	        if (!(obj.hasOwnProperty('name') && obj.hasOwnProperty('fn'))) {
	            throw new Error('NamedAjaxQueue.add requires an object with both "name" and "fn": ' + JSON.stringify(obj));
	        }
	        if (this.names.hasOwnProperty(obj.name)) {
	            //console.warn( 'name has been used:', obj.name );
	            return;
	        }
	        this.names[obj.name] = true;
	        //console.debug( '\t names: ', this.names )
	        return AjaxQueue.prototype.add.call(this, obj.fn);
	        //console.debug( '\t queue: ', this.queue.length );
	    };
	
	    /** override to remove names */
	    NamedAjaxQueue.prototype.clear = function clear() {
	        this.names = {};
	        return this;
	    };
	
	    /** shortcut constructor / fire and forget
	     *  @returns {Deferred} the queue's main deferred
	     */
	    NamedAjaxQueue.create = function create(initialFunctions) {
	        return new NamedAjaxQueue(initialFunctions).deferred;
	    };
	
	    //=============================================================================
	    return {
	        AjaxQueue: AjaxQueue,
	        NamedAjaxQueue: NamedAjaxQueue
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  //=============================================================================
	  /**
	  (Imported for edit distance algorith. From: https://gist.github.com/andrei-m/982927)
	  Copyright (c) 2011 Andrei Mackenzie
	  
	  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
	  documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
	  rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	  persons to whom the Software is furnished to do so, subject to the following conditions:
	  
	  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
	  Software.
	  
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
	  WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	  */
	  // Compute the edit distance between the two given strings
	  //exports.getEditDistance = function(a, b){
	  function levenshteinDistance(a, b) {
	    if (a.length === 0) {
	      return b.length;
	    }
	    if (b.length === 0) {
	      return a.length;
	    }
	
	    var matrix = [];
	
	    // increment along the first column of each row
	    var i;
	    for (i = 0; i <= b.length; i++) {
	      matrix[i] = [i];
	    }
	
	    // increment each column in the first row
	    var j;
	    for (j = 0; j <= a.length; j++) {
	      matrix[0][j] = j;
	    }
	
	    // Fill in the rest of the matrix
	    for (i = 1; i <= b.length; i++) {
	      for (j = 1; j <= a.length; j++) {
	        if (b.charAt(i - 1) === a.charAt(j - 1)) {
	          matrix[i][j] = matrix[i - 1][j - 1];
	        } else {
	          matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
	          Math.min(matrix[i][j - 1] + 1, // insertion
	          matrix[i - 1][j] + 1)); // deletion
	        }
	      }
	    }
	
	    //console.debug( '\t\t levenshteinDistance', a, b, matrix[b.length][a.length] );
	    return matrix[b.length][a.length];
	  }
	
	  //=============================================================================
	  return levenshteinDistance;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ })
]);


// WEBPACK FOOTER //
// analysis.bundled.js